/* v19 - firebase */
/* eslint-disable */
// VDumplingHQ build 2026-04-22 15:05
import { LOGO_NAV, LOGO_WHITE } from "./logos";
import { useState, useRef, useCallback, useEffect, useMemo } from "react";
import * as XLSX from "xlsx";
import { db, storage } from "./firebase";
import { doc, getDoc, setDoc, onSnapshot, writeBatch, collection, deleteField } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";

const FONT = `@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=IBM+Plex+Sans:wght@300;400;500;600&display=swap');`;

// ── Auth Config ───────────────────────────────────────────────────────────────
// Change these passwords! Site password + one per branch
const INIT_USERS = [
  { id: 0, name: "Prep", username: "prep", pin: "0000", role: "prep", branchId: null, branchIds: [] },
  { id: 1, name: "Admin",        username: "admin",        pin: "admin2024",       role: "admin",   branchId: null,  branchIds: [] },
  { id: 2, name: "Williamsburg", username: "williamsburg", pin: "williamsburg123", role: "manager", branchId: 1,     branchIds: [1] },
  { id: 3, name: "Adam",         username: "adam",         pin: "0224",            role: "admin",   branchId: null,  branchIds: [] },
];

// ── Login Screen ──────────────────────────────────────────────────────────────
function LoginScreen({ onLogin, users }) {
  const [username, setUsername] = useState("");
  const [pin, setPin]           = useState("");
  const [error, setError]       = useState("");
  const [shake, setShake]       = useState(false);
  const [showPin, setShowPin]   = useState(false);

  const doShake = () => { setShake(true); setTimeout(()=>setShake(false), 500); };

  const handleLogin = () => {
    const trimUser = username.trim().toLowerCase();
    const trimPin = pin.trim();
    const user = users.find(u => u.username.toLowerCase() === trimUser && u.pin.trim() === trimPin);
    if (user) {
      onLogin({ role: user.role, branchId: user.branchId, branchIds: user.branchIds||(user.branchId?[user.branchId]:[]), userId: user.id, name: user.name, productionItems: user.productionItems||[], departments: user.departments||[] });
    } else {
      setError("Incorrect username or password");
      setPin("");
      doShake();
    }
  };

  return (
    <div style={{minHeight:"100vh", background:"#F2F0EC", display:"flex",
      flexDirection:"column", alignItems:"center", justifyContent:"center", padding:20}}>
      <style>{`
        @keyframes shake { 0%,100%{transform:translateX(0)} 20%{transform:translateX(-8px)} 40%{transform:translateX(8px)} 60%{transform:translateX(-5px)} 80%{transform:translateX(5px)} }
        @keyframes fadeIn { from{opacity:0;transform:translateY(12px)} to{opacity:1;transform:translateY(0)} }
      `}</style>
      <div style={{background:"#fff", borderRadius:20, padding:"44px 40px", width:"100%", maxWidth:400,
        boxShadow:"0 24px 80px rgba(0,0,0,0.12)",
        animation: shake ? "shake 0.4s ease" : "fadeIn 0.3s ease"}}>
        <div style={{textAlign:"center", marginBottom:36}}>
          <img src={LOGO_NAV} alt="Vanessa's Dumpling House"
            style={{height:60,width:"auto",objectFit:"contain",maxWidth:280,marginBottom:8}}/>
          <p style={{color:"#aaa", fontSize:12, margin:0, letterSpacing:.3}}>Internal Operations</p>
        </div>
        <div style={{marginBottom:14}}>
          <label style={{display:"block", fontSize:11, fontWeight:700, color:"#888",
            textTransform:"uppercase", letterSpacing:.5, marginBottom:6}}>Username</label>
          <input
            id="kl-username"
            name="username"
            autoComplete="username"
            value={username} onChange={e=>{ setUsername(e.target.value); setError(""); }}
            onKeyDown={e=>e.key==="Enter"&&handleLogin()}
            placeholder="Enter your username" autoCapitalize="none" autoCorrect="off"
            style={{width:"100%", border:"1.5px solid #e5e5e5", borderRadius:10, padding:"12px 14px",
              fontSize:15, outline:"none", boxSizing:"border-box",
              fontFamily:"'IBM Plex Sans',sans-serif", background:"#fafafa"}} />
        </div>
        <div style={{marginBottom:22}}>
          <label style={{display:"block", fontSize:11, fontWeight:700, color:"#888",
            textTransform:"uppercase", letterSpacing:.5, marginBottom:6}}>Password</label>
          <div style={{position:"relative"}}>
            <input
              id="kl-password"
              name="password"
              type="password"
              autoComplete="current-password"
              value={pin}
              onChange={e=>{ setPin(e.target.value); setError(""); }}
              onKeyDown={e=>e.key==="Enter"&&handleLogin()}
              placeholder="Enter your password"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck="false"
              style={{display:showPin?"none":"block", width:"100%", border:"1.5px solid #e5e5e5",
                borderRadius:10, padding:"12px 44px 12px 14px", fontSize:15, outline:"none",
                boxSizing:"border-box", fontFamily:"'IBM Plex Sans',sans-serif", background:"#fafafa"}} />
            <input
              type="text"
              autoComplete="off"
              value={pin}
              onChange={e=>{ setPin(e.target.value); setError(""); }}
              onKeyDown={e=>e.key==="Enter"&&handleLogin()}
              placeholder="Enter your password"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck="false"
              style={{display:showPin?"block":"none", width:"100%", border:"1.5px solid #e5e5e5",
                borderRadius:10, padding:"12px 44px 12px 14px", fontSize:15, outline:"none",
                boxSizing:"border-box", fontFamily:"'IBM Plex Sans',sans-serif", background:"#fafafa"}} />
            <button onClick={()=>setShowPin(s=>!s)}
              style={{position:"absolute", right:12, top:"50%", transform:"translateY(-50%)",
                background:"none", border:"none", cursor:"pointer", color:"#aaa", fontSize:16, padding:4}}>
              {showPin ? "🙈" : "👁"}
            </button>
          </div>
        </div>
        {error && (
          <div style={{background:"#FEE2E2", color:"#C0392B", borderRadius:8, padding:"9px 13px",
            fontSize:13, fontWeight:600, marginBottom:16, textAlign:"center"}}>{error}</div>
        )}
        <button onClick={handleLogin}
          style={{width:"100%", background:"#1a1a1a", color:"#fff", border:"none", borderRadius:10,
            padding:"14px", fontSize:15, fontWeight:700, cursor:"pointer",
            fontFamily:"'IBM Plex Sans',sans-serif"}}>
          Sign In
        </button>
        <p style={{textAlign:"center", color:"#ccc", fontSize:11, marginTop:24, marginBottom:0}}>
          VDumplingHQ . {"Vanessa's Dumpling House"}
        </p>
      </div>
    </div>
  );
}


// ── Data ─────────────────────────────────────────────────────────────────────
const INIT_RESTAURANTS = [
  { id:1, name:"Williamsburg", color:"#C0392B", deliveryDays:["Monday","Thursday"],  managerName:"Manager",   managerEmail:"orders@vanessas.com" },
  { id:2, name:"Upper West Side",  color:"#2471A3", deliveryDays:["Tuesday","Friday"],   managerName:"Manager",  managerEmail:"orders@vanessas.com" },
  { id:3, name:"Upper East Side",  color:"#1E8449", deliveryDays:["Tuesday","Friday"],   managerName:"Manager",      managerEmail:"orders@vanessas.com" },
];

const FACTORY_EMAIL = "carmen@vanessas.com";
const BETA_EMAIL = "adam@vanessas.com";

// EmailJS config
const EJS_SERVICE  = "service_wiqk0dr";
const EJS_TEMPLATE = "template_wr1xgyi";
const EJS_KEY      = "GDdXmOxRgA-6Ifzbo";

// price: null = "Market Price" (quoted at delivery)
const INIT_PRODUCTS = [
  // Buns
  { id:1,  name:"Pork Buns",                          nameZh:"猪肉包",            category:"Buns",             unit:"8 pc Bag",       price:10.0  },
  { id:2,  name:"Vegetable Buns",                     nameZh:"素菜包",            category:"Buns",             unit:"8 pc Bag",       price:12.0  },
  { id:3,  name:"Red Bean Buns",                      nameZh:"红豆包",            category:"Buns",             unit:"8 pc Bag",       price:10.0  },
  // Doughs
  { id:4,  name:"Noodles",                            nameZh:"面条",              category:"Doughs",           unit:"Case",           price:1.21  },
  { id:5,  name:"Pancake Dough",                      nameZh:"大饼面",            category:"Doughs",           unit:"Bag",            price:6.5   },
  // Frozen Dumplings
  { id:6,  name:"Pork & Chive",                       nameZh:"速冻韭菜猪肉饺子",  category:"Frozen Dumplings", unit:"100 pc Bags",    price:30.0  },
  { id:7,  name:"Pork & Cabbage",                     nameZh:"速冻白菜饺子",      category:"Frozen Dumplings", unit:"100 pc Bags",    price:28.0  },
  { id:8,  name:"Chicken & Basil",                    nameZh:"速冻鸡肉饺子",      category:"Frozen Dumplings", unit:"100 pc Bags",    price:29.0  },
  { id:9,  name:"Vegetable",                          nameZh:"速冻素菜饺子",      category:"Frozen Dumplings", unit:"100 pc Bags",    price:38.0  },
  { id:10, name:"Shrimp",                             nameZh:"速冻鲜虾饺子",      category:"Frozen Dumplings", unit:"100 pc Bags",    price:34.0  },
  { id:11, name:"Spicy Beef",                         nameZh:"速冻辣牛肉饺子",    category:"Frozen Dumplings", unit:"100 pc Bags",    price:32.0  },
  { id:12, name:"Vegan Spicy Beef",                   nameZh:"速冻素辣牛饺子",    category:"Frozen Dumplings", unit:"100 pc Bags",    price:41.0  },
  { id:13, name:"Frozen Wontons",                     nameZh:"速冻鸡肉鲜虾云吞",  category:"Frozen Dumplings", unit:"100 pc Bags",    price:39.0  },
  { id:14, name:"Frozen Veg Wontons",                 nameZh:"速冻素菜云吞",      category:"Frozen Dumplings", unit:"100 pc Bags",    price:39.5  },
  { id:15, name:"Pork Fried Buns",                    nameZh:"生煎包",            category:"Frozen Dumplings", unit:"100 pc Bags",    price:45.0  },
  // Meats
  { id:16, name:"Roast Pork",                         nameZh:"夹饼猪肉",          category:"Meats",            unit:"Case",           price:55.0  },
  { id:17, name:"Roast Chicken",                      nameZh:"夹饼鸡肉",          category:"Meats",            unit:"Case",           price:70.0  },
  { id:18, name:"Peking Duck",                        nameZh:"夹饼鸭肉",          category:"Meats",            unit:"Case",           price:60.0  },
  { id:19, name:"Sliced Beef",                        nameZh:"夹饼牛肉片",        category:"Meats",            unit:"Case",           price:40.0  },
  { id:20, name:"Beef Chunk",                         nameZh:"汤面牛肉块",        category:"Meats",            unit:"Case",           price:112.0 },
  // Paper Goods
  { id:21, name:"Forks",                              nameZh:"叉子",              category:"Paper Goods",      unit:"Case",           price:null  },
  { id:22, name:"Spoons",                             nameZh:"勺子",              category:"Paper Goods",      unit:"Case",           price:null  },
  { id:23, name:"Chopsticks",                         nameZh:"筷子",              category:"Paper Goods",      unit:"Case",           price:null  },
  { id:24, name:"1oz Cups & Lids (2 box)",            nameZh:"1盎司酱料杯",       category:"Paper Goods",      unit:"Case",           price:null  },
  { id:25, name:"1lb Aluminum Trays & Lids Set",      nameZh:"1磅锅贴锡纸盒",     category:"Paper Goods",      unit:"Case",           price:null  },
  { id:26, name:"RO 40 Noodle Soup Bowl",             nameZh:"深汤面碗",          category:"Paper Goods",      unit:"Case",           price:null  },
  { id:27, name:"RO 32 Dry Noodle Bowl",              nameZh:"浅拌面碗",          category:"Paper Goods",      unit:"Case",           price:null  },
  { id:28, name:"12oz Side Dishes",                   nameZh:"12盎司小菜碟",      category:"Paper Goods",      unit:"Case",           price:null  },
  { id:29, name:"8oz Side Dishes",                    nameZh:"8盎司小菜碟",       category:"Paper Goods",      unit:"Case",           price:null  },
  { id:30, name:"Frozen Bags & Labels",               nameZh:"冷冻包装袋+贴纸",   category:"Paper Goods",      unit:"Case",           price:null  },
  { id:31, name:"2oz Side Sauce Container",           nameZh:"2oz 小油盒子",      category:"Paper Goods",      unit:"Case",           price:null  },
  { id:32, name:"16oz Small Soup Containers",         nameZh:"小汤罐",            category:"Paper Goods",      unit:"Case",           price:null  },
  { id:33, name:"32oz Large Soup Containers",         nameZh:"大汤罐",            category:"Paper Goods",      unit:"Case",           price:null  },
  { id:34, name:"Single Piece Bun Containers",        nameZh:"透明单粒包子盒",    category:"Paper Goods",      unit:"Case",           price:null  },
  // Sauces
  { id:35, name:"Dan Dan Mein Sauce",                 nameZh:"担担面酱",          category:"Sauces",           unit:"Quart",          price:11.0  },
  { id:36, name:"Dan Dan Mein Beef",                  nameZh:"担担牛肉",          category:"Sauces",           unit:"Quart",          price:17.6  },
  { id:37, name:"Dan Dan Mein Tofu",                  nameZh:"担担豆腐",          category:"Sauces",           unit:"Quart",          price:19.0  },
  { id:38, name:"Sesame Noodle Sauce (Set)",          nameZh:"芝麻酱(套)",        category:"Sauces",           unit:"Quart",          price:14.0  },
  { id:39, name:"Sesame Noodle Sauce Brown Only",     nameZh:"芝麻酱(棕)",        category:"Sauces",           unit:"Quart",          price:10.0  },
  { id:40, name:"Sesame Noodle Sauce Black Only",     nameZh:"芝麻酱(黑)",        category:"Sauces",           unit:"Quart",          price:4.0   },
  { id:41, name:"Hot Chili Oil (Bucket)",             nameZh:"辣椒油 (桶)",       category:"Sauces",           unit:"5 Gallon Bucket", price:130.0 },
  { id:42, name:"Wonton Soy Sauce",                   nameZh:"云吞酱油",          category:"Sauces",           unit:"Quart",          price:10.0  },
  { id:43, name:"Dumpling Soy Sauce",                 nameZh:"饺子酱汁",          category:"Sauces",           unit:"Bottle",         price:10.0  },
  { id:44, name:"Dumpling Hot Sauce (box)",           nameZh:"饺子辣汁（盒）",    category:"Sauces",           unit:"Case",           price:null  },
  { id:45, name:"Dumpling Hot Sauce (Gallon)",        nameZh:"饺子辣汁 (加仑)",   category:"Sauces",           unit:"Bottle",         price:26.0  },
  { id:46, name:"Case of Sweet Bean Sauce",           nameZh:"甜面酱",            category:"Sauces",           unit:"Case",           price:null  },
  // Sides
  { id:47, name:"Kimchi",                             nameZh:"辣白菜",            category:"Sides",            unit:"Case",           price:19.5  },
  { id:48, name:"Spicy Cucumbers + Sauce",            nameZh:"辣黄瓜+辣汁",       category:"Sides",            unit:"Case",           price:38.5  },
  { id:49, name:"Spicy Cucumbers Sauce Only",         nameZh:"辣汁",              category:"Sides",            unit:"Case",           price:null  },
  // Soup
  { id:50, name:"Hot and Sour Soup Filling",          nameZh:"酸辣汤料",          category:"Soup",             unit:"Case",           price:40.0  },
  { id:51, name:"Beef Broth",                         nameZh:"牛肉汁",            category:"Soup",             unit:"Bottle",         price:6.0   },
  { id:52, name:"Soft Tofu",                          nameZh:"大豆腐",            category:"Soup",             unit:"Case",           price:null  },
  { id:53, name:"Chicken Bone",                       nameZh:"鸡骨头",            category:"Soup",             unit:"Bag",            price:1.5   },
  { id:54, name:"Pork Bone",                          nameZh:"猪骨头",            category:"Soup",             unit:"Bag",            price:3.0   },
  { id:55, name:"Duck Bone",                          nameZh:"鸭骨头",            category:"Soup",             unit:"Bag",            price:0.0   },
  // Vegetables
  { id:56, name:"Sliced Pickled Carrots",             nameZh:"夹饼胡萝卜丝",      category:"Vegetables",       unit:"Case",           price:16.2  },
  { id:57, name:"Sliced Cucumbers",                   nameZh:"夹饼黄瓜丝",        category:"Vegetables",       unit:"Case",           price:30.0  },
  { id:58, name:"Bag of Cilantro (3 lbs)",            nameZh:"香菜 (3 磅)",       category:"Vegetables",       unit:"Bag",            price:13.53 },
  { id:59, name:"Chopped Scallion",                   nameZh:"碎葱",              category:"Vegetables",       unit:"Case",           price:22.0  },
  { id:60, name:"Baby Bok Choy",                      nameZh:"上海菜苗",          category:"Vegetables",       unit:"Case",           price:null  },
  { id:61, name:"Vegetable for Sauteed Noodle",       nameZh:"炒面菜",            category:"Vegetables",       unit:"Case",           price:15.0  },
  { id:62, name:"Bottle of Garlic",                   nameZh:"去皮蒜",            category:"Vegetables",       unit:"Jar",            price:null  },
  { id:63, name:"Edamame",                            nameZh:"毛豆",              category:"Vegetables",       unit:"Case",           price:null  },
  { id:64, name:"Seaweed Salad",                      nameZh:"海带丝",            category:"Vegetables",       unit:"Case",           price:null  },
  { id:65, name:"Roasted Peanuts",                    nameZh:"花生碎",            category:"Vegetables",       unit:"Can",            price:null  },
];

// i18n labels — add any UI string here
const I18N = {
  en: {
    stockCheck:"Stock Check", catering:"Catering Mode", orders:"Orders",
    restaurant:"Restaurant", kitchen:"Factory", settings:"Settings",
    addProduct:"+ Add Product", importExcel:"📊 Import Excel",
    addBranch:"+ Add Branch", reviewOrder:"Review & Place Order →",
    allAbovePar:"[OK] All stock above par — no order needed!",
    belowPar:"item(s) below par — pre-filled:",
    marketPrice:"Market Price", perUnit:"/",
    par:"Par", order:"Order", stock:"Stock",
    approveInvoice:"Approve & Generate Invoice →",
    sendFactory:"📧 Resend Email",
    orderHistory:"Order History", noOrders:"No orders yet.",
    factoryDash:"Factory Dashboard", ordersReceived:"Orders received from restaurant branches",
    newOrdersAlert:"new order(s) received — awaiting confirmation",
    invoice:"Invoice", send:"Send", close:"Close",
    low:"LOW", readyToSend:"ready to send", atFactory:"at factory",
    editParLevels:"⚙ Edit Par Levels", saveParLevels:"✓ Save Par Levels",
    reviewCombined:"Review Combined Order →",
    products:"📦 Products", branches:"🏪 Branches",
    searchProducts:"🔍 Search products...",
    deliverBy:"DELIVER BY", orderToday:"ORDER TODAY",
    todayOrderDay:"Today is an order day!", nextOrder:"Next order:",
    orderDays:"Delivery days:", nextDelivery:"Next delivery:",
    cateringSummary:"🍽 Catering Summary", selectDishes:"Select dishes above",
    regularStock:"📦 Regular Stock Order", allStockAbovePar:"✓ All stock above par",
    estimatedGuests:"Estimated guests:",
    extraIngredients:"Extra Ingredients Needed",
    selectCateringDishes:"Select Catering Dishes",
    orderNote:"ORDER NOTE",
    itemsTotal:(n,u)=>`${n} item${n!==1?"s":""} . ${u} total units`,
    inclTax:"",
    cancelBtn:"Cancel", doneBtn:"Done",
    cats:{"Buns":"Buns","Doughs":"Doughs","Frozen Dumplings":"Frozen Dumplings","Meats":"Meats","Paper Goods":"Paper Goods","Sauces":"Sauces","Sides":"Sides","Soup":"Soup","Vegetables":"Vegetables"},
  },
  zh: {
    stockCheck:"库存检查", catering:"外卖模式", orders:"订单",
    restaurant:"餐厅", kitchen:"厨房", settings:"设置",
    addProduct:"+ 添加产品", importExcel:"📊 导入Excel",
    addBranch:"+ 添加分店", reviewOrder:"审核并下单 →",
    allAbovePar:"[OK] 所有库存充足 — 无需下单！",
    belowPar:"件低于标准 — 已预填:",
    marketPrice:"市场价", perUnit:"/",
    par:"标准", order:"订购", stock:"库存",
    approveInvoice:"批准并生成发票 →",
    sendFactory:"📧 重新发送",
    orderHistory:"订单历史", noOrders:"暂无订单。",
    factoryDash:"工厂仪表盘", ordersReceived:"来自各餐厅分店的订单",
    newOrdersAlert:"条新订单 — 待确认",
    invoice:"发票", send:"发送", close:"关闭",
    low:"低", readyToSend:"待发送", atFactory:"在工厂",
    editParLevels:"⚙ 编辑标准量", saveParLevels:"✓ 保存标准量",
    reviewCombined:"审核综合订单 →",
    products:"📦 产品", branches:"🏪 分店",
    searchProducts:"🔍 搜索产品...",
    deliverBy:"送达日期", orderToday:"今日下单",
    todayOrderDay:"今天是下单日！", nextOrder:"下次下单:",
    orderDays:"送货日:", nextDelivery:"下次送货:",
    cateringSummary:"🍽 外卖摘要", selectDishes:"请在上方选择菜品",
    regularStock:"📦 常规库存订单", allStockAbovePar:"✓ 所有库存充足",
    estimatedGuests:"预计用餐人数:",
    extraIngredients:"所需额外食材",
    selectCateringDishes:"选择外卖菜品",
    orderNote:"订单备注",
    itemsTotal:(n,u)=>`${n} 件商品 . 共 ${u} 单位`,
    inclTax:"",
    cancelBtn:"取消", doneBtn:"完成",
    cats:{"Buns":"包子","Doughs":"面团","Frozen Dumplings":"冷冻饺子","Meats":"肉类","Paper Goods":"纸品","Sauces":"酱料","Sides":"配菜","Soup":"汤","Vegetables":"蔬菜"},
  }
};

const INIT_CATERING_DISHES = [];

const INIT_PREP_TASKS = [{"id": 1000, "nameEn": "Peel and cut X Bags of Carrots", "nameZh": "削皮并切X袋胡萝卜", "nameEs": "Pelar y cortar X bolsas de zanahorias", "category": "Vegetable Prep", "subcategory": "Carrots", "hasQuantity": true, "estimatedMins": null}, {"id": 1001, "nameEn": "Slice X Pounds of Carrots for Filling (2 times)", "nameZh": "将X磅胡萝卜切片用于馅料（2次）", "nameEs": "Rebanar X libras de zanahorias para relleno (2 veces)", "category": "Vegetable Prep", "subcategory": "Carrots", "hasQuantity": true, "estimatedMins": null}, {"id": 1002, "nameEn": "Shred X Pounds of Carrots", "nameZh": "将X磅胡萝卜切丝", "nameEs": "Rallar X libras de zanahorias", "category": "Vegetable Prep", "subcategory": "Carrots", "hasQuantity": true, "estimatedMins": null}, {"id": 1003, "nameEn": "Cut and Wash X Boxes of Taiwan Cabbage", "nameZh": "切洗X箱台湾卷心菜", "nameEs": "Cortar y lavar X cajas de repollo taiwanés", "category": "Vegetable Prep", "subcategory": "Taiwan Cabbage", "hasQuantity": true, "estimatedMins": null}, {"id": 1004, "nameEn": "Dice Taiwan Cabbage", "nameZh": "将台湾卷心菜切丁", "nameEs": "Picar el repollo taiwanés", "category": "Vegetable Prep", "subcategory": "Taiwan Cabbage", "hasQuantity": false, "estimatedMins": null}, {"id": 1005, "nameEn": "Blanch and put Taiwan Cabbage in Ice Water", "nameZh": "焯台湾卷心菜并放入冰水", "nameEs": "Escaldar el repollo taiwanés y poner en agua con hielo", "category": "Vegetable Prep", "subcategory": "Taiwan Cabbage", "hasQuantity": false, "estimatedMins": null}, {"id": 1006, "nameEn": "Spin Dry Taiwan Cabbage", "nameZh": "甩干台湾卷心菜", "nameEs": "Centrifugar el repollo taiwanés", "category": "Vegetable Prep", "subcategory": "Taiwan Cabbage", "hasQuantity": false, "estimatedMins": null}, {"id": 1007, "nameEn": "Portion Taiwan Cabbage into 15 pound boxes", "nameZh": "将台湾卷心菜分装入15磅箱", "nameEs": "Porcionar el repollo taiwanés en cajas de 15 libras", "category": "Vegetable Prep", "subcategory": "Taiwan Cabbage", "hasQuantity": false, "estimatedMins": null}, {"id": 1008, "nameEn": "Wash X Cases of Baby Bok Choy", "nameZh": "清洗X箱小白菜", "nameEs": "Lavar X cajas de bok choy baby", "category": "Vegetable Prep", "subcategory": "Baby Bok Choy", "hasQuantity": true, "estimatedMins": null}, {"id": 1009, "nameEn": "Cut and Wash X Boxes of Shanghai Bok Choy", "nameZh": "切洗X箱上海青", "nameEs": "Cortar y lavar X cajas de bok choy Shanghai", "category": "Vegetable Prep", "subcategory": "Baby Bok Choy", "hasQuantity": true, "estimatedMins": null}, {"id": 1010, "nameEn": "Dice Shanghai Bok Choy", "nameZh": "将上海青切丁", "nameEs": "Picar el bok choy Shanghai", "category": "Vegetable Prep", "subcategory": "Baby Bok Choy", "hasQuantity": false, "estimatedMins": null}, {"id": 1011, "nameEn": "Blanch and put Shanghai Bok Choy in Ice Water", "nameZh": "焯上海青并放入冰水", "nameEs": "Escaldar el bok choy Shanghai y poner en agua con hielo", "category": "Vegetable Prep", "subcategory": "Baby Bok Choy", "hasQuantity": false, "estimatedMins": null}, {"id": 1012, "nameEn": "Spin Dry Shanghai Boy Choy Twice", "nameZh": "将上海青甩干两次", "nameEs": "Centrifugar el bok choy Shanghai dos veces", "category": "Vegetable Prep", "subcategory": "Baby Bok Choy", "hasQuantity": false, "estimatedMins": null}, {"id": 1013, "nameEn": "Portion Shanghai Bok Choy into 9 pound boxes", "nameZh": "将上海青分装入9磅箱", "nameEs": "Porcionar el bok choy Shanghai en cajas de 9 libras", "category": "Vegetable Prep", "subcategory": "Baby Bok Choy", "hasQuantity": false, "estimatedMins": null}, {"id": 1014, "nameEn": "Wash X Boxes of Chives", "nameZh": "清洗X箱韭菜", "nameEs": "Lavar X cajas de cebollín", "category": "Vegetable Prep", "subcategory": "Chives", "hasQuantity": true, "estimatedMins": null}, {"id": 1015, "nameEn": "Slice Chives to 1/4 Inch", "nameZh": "将韭菜切成1/4英寸", "nameEs": "Rebanar el cebollín a 1/4 de pulgada", "category": "Vegetable Prep", "subcategory": "Chives", "hasQuantity": false, "estimatedMins": null}, {"id": 1016, "nameEn": "Portion Chives into 22lb boxes", "nameZh": "将韭菜分装入22磅箱", "nameEs": "Porcionar el cebollín en cajas de 22 libras", "category": "Vegetable Prep", "subcategory": "Chives", "hasQuantity": false, "estimatedMins": null}, {"id": 1017, "nameEn": "Wash X Boxes of Scallions", "nameZh": "清洗X箱大葱", "nameEs": "Lavar X cajas de cebolleta", "category": "Vegetable Prep", "subcategory": "Scallion", "hasQuantity": true, "estimatedMins": null}, {"id": 1018, "nameEn": "Slice Scallions to 1/8 Inch", "nameZh": "将大葱切成1/8英寸", "nameEs": "Rebanar la cebolleta a 1/8 de pulgada", "category": "Vegetable Prep", "subcategory": "Scallion", "hasQuantity": false, "estimatedMins": null}, {"id": 1019, "nameEn": "Portion Scallions into 4lb boxes", "nameZh": "将大葱分装入4磅箱", "nameEs": "Porcionar la cebolleta en cajas de 4 libras", "category": "Vegetable Prep", "subcategory": "Scallion", "hasQuantity": false, "estimatedMins": null}, {"id": 1020, "nameEn": "Wash X Pounds of Cucumber", "nameZh": "清洗X磅黄瓜", "nameEs": "Lavar X libras de pepino", "category": "Vegetable Prep", "subcategory": "Cucumber", "hasQuantity": true, "estimatedMins": null}, {"id": 1021, "nameEn": "Peel X Pounds of Cucumber", "nameZh": "削X磅黄瓜皮", "nameEs": "Pelar X libras de pepino", "category": "Vegetable Prep", "subcategory": "Cucumber", "hasQuantity": true, "estimatedMins": null}, {"id": 1022, "nameEn": "Cut Cucumber for X 12lb Boxes", "nameZh": "将黄瓜切好装入X个12磅箱", "nameEs": "Cortar pepino para X cajas de 12 libras", "category": "Vegetable Prep", "subcategory": "Cucumber", "hasQuantity": true, "estimatedMins": null}, {"id": 1023, "nameEn": "Cut X pound of Cucumber in half", "nameZh": "将X磅黄瓜对半切", "nameEs": "Cortar X libras de pepino por la mitad", "category": "Vegetable Prep", "subcategory": "Cucumber", "hasQuantity": true, "estimatedMins": null}, {"id": 1024, "nameEn": "Shred X Pound of Cucumber", "nameZh": "将X磅黄瓜切丝", "nameEs": "Rallar X libras de pepino", "category": "Vegetable Prep", "subcategory": "Cucumber", "hasQuantity": true, "estimatedMins": null}, {"id": 1025, "nameEn": "Portion Shredded Cucumber into X 12 pound boxes", "nameZh": "将黄瓜丝分装入X个12磅箱", "nameEs": "Porcionar el pepino rallado en X cajas de 12 libras", "category": "Vegetable Prep", "subcategory": "Cucumber", "hasQuantity": true, "estimatedMins": null}, {"id": 1026, "nameEn": "Cut and Wash X Boxes of Napa Cabbage", "nameZh": "切洗X箱大白菜", "nameEs": "Cortar y lavar X cajas de col china", "category": "Vegetable Prep", "subcategory": "Napa Cabbage", "hasQuantity": true, "estimatedMins": null}, {"id": 1027, "nameEn": "Dice Napa Cabbage", "nameZh": "将大白菜切丁", "nameEs": "Picar la col china", "category": "Vegetable Prep", "subcategory": "Napa Cabbage", "hasQuantity": false, "estimatedMins": null}, {"id": 1028, "nameEn": "Spin Dry Napa Cabbage", "nameZh": "甩干大白菜", "nameEs": "Centrifugar la col china", "category": "Vegetable Prep", "subcategory": "Napa Cabbage", "hasQuantity": false, "estimatedMins": null}, {"id": 1029, "nameEn": "Portion Napa Cabbage into 7 pound boxes", "nameZh": "将大白菜分装入7磅箱", "nameEs": "Porcionar la col china en cajas de 7 libras", "category": "Vegetable Prep", "subcategory": "Napa Cabbage", "hasQuantity": false, "estimatedMins": null}, {"id": 1030, "nameEn": "Portion Napa Cabbage into 8 pound boxes", "nameZh": "将大白菜分装入8磅箱", "nameEs": "Porcionar la col china en cajas de 8 libras", "category": "Vegetable Prep", "subcategory": "Napa Cabbage", "hasQuantity": false, "estimatedMins": null}, {"id": 1031, "nameEn": "Weigh X Pound of Celery", "nameZh": "称X磅芹菜", "nameEs": "Pesar X libras de apio", "category": "Vegetable Prep", "subcategory": "Celery", "hasQuantity": true, "estimatedMins": null}, {"id": 1032, "nameEn": "Wash X Pounds of Celery", "nameZh": "清洗X磅芹菜", "nameEs": "Lavar X libras de apio", "category": "Vegetable Prep", "subcategory": "Celery", "hasQuantity": true, "estimatedMins": null}, {"id": 1033, "nameEn": "Dice Celery", "nameZh": "将芹菜切丁", "nameEs": "Picar el apio", "category": "Vegetable Prep", "subcategory": "Celery", "hasQuantity": false, "estimatedMins": null}, {"id": 1034, "nameEn": "Put X Bag of Mushroom into Water (in fridge)", "nameZh": "将X袋蘑菇放入水中（冰箱内）", "nameEs": "Poner X bolsas de hongos en agua (en el refrigerador)", "category": "Vegetable Prep", "subcategory": "Mushroom", "hasQuantity": true, "estimatedMins": null}, {"id": 1035, "nameEn": "Drain, Wash and Clean Mushroom", "nameZh": "沥干、清洗蘑菇", "nameEs": "Escurrir, lavar y limpiar los hongos", "category": "Vegetable Prep", "subcategory": "Mushroom", "hasQuantity": false, "estimatedMins": null}, {"id": 1036, "nameEn": "Spin Dry Mushroom", "nameZh": "甩干蘑菇", "nameEs": "Centrifugar los hongos", "category": "Vegetable Prep", "subcategory": "Mushroom", "hasQuantity": false, "estimatedMins": null}, {"id": 1037, "nameEn": "Grind Mushroom at X Size", "nameZh": "将蘑菇研磨至X大小", "nameEs": "Moler los hongos a tamaño X", "category": "Vegetable Prep", "subcategory": "Mushroom", "hasQuantity": true, "estimatedMins": null}, {"id": 1038, "nameEn": "Saute Mushroom", "nameZh": "炒蘑菇", "nameEs": "Saltear los hongos", "category": "Vegetable Prep", "subcategory": "Mushroom", "hasQuantity": false, "estimatedMins": null}, {"id": 1039, "nameEn": "Weigh X Pounds of Onion", "nameZh": "称X磅洋葱", "nameEs": "Pesar X libras de cebolla", "category": "Vegetable Prep", "subcategory": "Onion", "hasQuantity": true, "estimatedMins": null}, {"id": 1040, "nameEn": "Remove Onion Skin", "nameZh": "去洋葱皮", "nameEs": "Quitar la piel de la cebolla", "category": "Vegetable Prep", "subcategory": "Onion", "hasQuantity": false, "estimatedMins": null}, {"id": 1041, "nameEn": "Slice Onion (3 times)", "nameZh": "将洋葱切片（3次）", "nameEs": "Rebanar la cebolla (3 veces)", "category": "Vegetable Prep", "subcategory": "Onion", "hasQuantity": false, "estimatedMins": null}, {"id": 1042, "nameEn": "Weigh X Pound of Hot Pepper", "nameZh": "称X磅辣椒", "nameEs": "Pesar X libras de chile largo", "category": "Vegetable Prep", "subcategory": "Long Hot Pepper", "hasQuantity": true, "estimatedMins": null}, {"id": 1043, "nameEn": "Remove Top of Hot Pepper", "nameZh": "去辣椒蒂", "nameEs": "Quitar el tallo del chile", "category": "Vegetable Prep", "subcategory": "Long Hot Pepper", "hasQuantity": false, "estimatedMins": null}, {"id": 1044, "nameEn": "Wash Hot Peppers", "nameZh": "清洗辣椒", "nameEs": "Lavar los chiles", "category": "Vegetable Prep", "subcategory": "Long Hot Pepper", "hasQuantity": false, "estimatedMins": null}, {"id": 1045, "nameEn": "Slice Hot Peppers (3 times)", "nameZh": "将辣椒切片（3次）", "nameEs": "Rebanar los chiles (3 veces)", "category": "Vegetable Prep", "subcategory": "Long Hot Pepper", "hasQuantity": false, "estimatedMins": null}, {"id": 1046, "nameEn": "Take out X Pounds of Basil", "nameZh": "取出X磅罗勒", "nameEs": "Sacar X libras de albahaca", "category": "Vegetable Prep", "subcategory": "Basil", "hasQuantity": true, "estimatedMins": null}, {"id": 1047, "nameEn": "Cut Ends of Basil", "nameZh": "剪去罗勒根部", "nameEs": "Cortar los extremos de la albahaca", "category": "Vegetable Prep", "subcategory": "Basil", "hasQuantity": false, "estimatedMins": null}, {"id": 1048, "nameEn": "Slice Basil 1/8 Inch", "nameZh": "将罗勒切成1/8英寸", "nameEs": "Rebanar la albahaca a 1/8 de pulgada", "category": "Vegetable Prep", "subcategory": "Basil", "hasQuantity": false, "estimatedMins": null}, {"id": 1049, "nameEn": "Take out X Bags of Tofu", "nameZh": "取出X袋豆腐", "nameEs": "Sacar X bolsas de tofu", "category": "Vegetable Prep", "subcategory": "Smoked Tofu", "hasQuantity": true, "estimatedMins": null}, {"id": 1050, "nameEn": "Run Smoke Tofu Through Dicing Machine", "nameZh": "将熏豆腐过丁机", "nameEs": "Pasar el tofu ahumado por la máquina de cortar", "category": "Vegetable Prep", "subcategory": "Smoked Tofu", "hasQuantity": false, "estimatedMins": null}, {"id": 1051, "nameEn": "Take Out X Bag of Shephed's Purse & Thaw Overnight", "nameZh": "取出X袋荠菜并隔夜解冻", "nameEs": "Sacar X bolsas de bolsa de pastor y descongelar de noche", "category": "Vegetable Prep", "subcategory": "Sherpherd's Purse", "hasQuantity": true, "estimatedMins": null}, {"id": 1052, "nameEn": "Wash Shepherd's Purse", "nameZh": "清洗荠菜", "nameEs": "Lavar la bolsa de pastor", "category": "Vegetable Prep", "subcategory": "Sherpherd's Purse", "hasQuantity": false, "estimatedMins": null}, {"id": 1053, "nameEn": "Spin Dry Shepherd's Purse", "nameZh": "甩干荠菜", "nameEs": "Centrifugar la bolsa de pastor", "category": "Vegetable Prep", "subcategory": "Sherpherd's Purse", "hasQuantity": false, "estimatedMins": null}, {"id": 1054, "nameEn": "Slice Shepherd's Purse", "nameZh": "将荠菜切碎", "nameEs": "Picar la bolsa de pastor", "category": "Vegetable Prep", "subcategory": "Sherpherd's Purse", "hasQuantity": false, "estimatedMins": null}, {"id": 1055, "nameEn": "Take Out 2 Cases of Spinach & Thaw Overnight", "nameZh": "取出2箱菠菜并隔夜解冻", "nameEs": "Sacar 2 cajas de espinaca y descongelar de noche", "category": "Vegetable Prep", "subcategory": "Spinach", "hasQuantity": false, "estimatedMins": null}, {"id": 1056, "nameEn": "Blanch Spinach & Put in Ice Water", "nameZh": "焯菠菜并放入冰水", "nameEs": "Escaldar la espinaca y poner en agua con hielo", "category": "Vegetable Prep", "subcategory": "Spinach", "hasQuantity": false, "estimatedMins": null}, {"id": 1057, "nameEn": "Spin Dry Spinach", "nameZh": "甩干菠菜", "nameEs": "Centrifugar la espinaca", "category": "Vegetable Prep", "subcategory": "Spinach", "hasQuantity": false, "estimatedMins": null}, {"nameEn": "Take out 40lb of Shrimp to Thaw", "nameZh": "取出40磅虾解冻", "nameEs": "Sacar 40lb de camarón para descongelar", "subcategory": "Shrimp & Chicken Wonton Filling", "hasQuantity": false, "recordOutput": false, "id": 2000, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Take out 13 bag of Frozen Shepherd's Purse to Thaw", "nameZh": "取出13袋冷冻荠菜解冻", "nameEs": "Sacar 13 bolsas de bolsa de pastor congelada para descongelar", "subcategory": "Shrimp & Chicken Wonton Filling", "hasQuantity": false, "recordOutput": false, "id": 2001, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Wash Shrimp", "nameZh": "清洗虾", "nameEs": "Lavar el camarón", "subcategory": "Shrimp & Chicken Wonton Filling", "hasQuantity": false, "recordOutput": false, "id": 2002, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Grind Shrimp", "nameZh": "研磨虾", "nameEs": "Moler el camarón", "subcategory": "Shrimp & Chicken Wonton Filling", "hasQuantity": false, "recordOutput": false, "id": 2003, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Wash Shepherd's Purse", "nameZh": "清洗荠菜", "nameEs": "Lavar la bolsa de pastor", "subcategory": "Shrimp & Chicken Wonton Filling", "hasQuantity": false, "recordOutput": false, "id": 2004, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Spin dry Shepherd's Purse", "nameZh": "甩干荠菜", "nameEs": "Centrifugar la bolsa de pastor", "subcategory": "Shrimp & Chicken Wonton Filling", "hasQuantity": false, "recordOutput": false, "id": 2005, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Slice Shepherd's Purse at 1/8\"", "nameZh": "将荠菜切成1/8英寸", "nameEs": "Rebanar la bolsa de pastor a 1/8 de pulgada", "subcategory": "Shrimp & Chicken Wonton Filling", "hasQuantity": false, "recordOutput": false, "id": 2006, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Weigh 20lb of Ground Chicken", "nameZh": "称20磅鸡肉碎", "nameEs": "Pesar 20lb de pollo molido", "subcategory": "Shrimp & Chicken Wonton Filling", "hasQuantity": false, "recordOutput": false, "id": 2007, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Mix Shrimp & Chicken Filling", "nameZh": "混合虾仁鸡肉馅", "nameEs": "Mezclar el relleno de camarón y pollo", "subcategory": "Shrimp & Chicken Wonton Filling", "hasQuantity": false, "recordOutput": false, "id": 2008, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Take out 2 cases of Frozen Spinach to Thaw", "nameZh": "取出2箱冷冻菠菜解冻", "nameEs": "Sacar 2 cajas de espinaca congelada para descongelar", "subcategory": "Spinach & Mushroom Wonton Filling", "hasQuantity": false, "recordOutput": false, "id": 2009, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Blanch Frozen Spinach", "nameZh": "焯冷冻菠菜", "nameEs": "Escaldar la espinaca congelada", "subcategory": "Spinach & Mushroom Wonton Filling", "hasQuantity": false, "recordOutput": false, "id": 2010, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Spin dry Frozen Spinach", "nameZh": "甩干冷冻菠菜", "nameEs": "Centrifugar la espinaca congelada", "subcategory": "Spinach & Mushroom Wonton Filling", "hasQuantity": false, "recordOutput": false, "id": 2011, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Mix Spinach & Wonton Filling", "nameZh": "混合菠菜馄饨馅", "nameEs": "Mezclar el relleno de espinaca y wonton", "subcategory": "Spinach & Mushroom Wonton Filling", "hasQuantity": false, "recordOutput": false, "id": 2012, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Marinate X lb Ground Pork with Sauce", "nameZh": "用酱料腌制X磅猪肉碎", "nameEs": "Marinar X lb de cerdo molido con salsa", "subcategory": "Chive & Pork Filling", "hasQuantity": true, "recordOutput": false, "id": 2013, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Weight 22lb of Chive X times to make X boxes", "nameZh": "称22磅韭菜X次制作X箱", "nameEs": "Pesar 22lb de cebollín X veces para hacer X cajas", "subcategory": "Chive & Pork Filling", "hasQuantity": true, "recordOutput": false, "id": 2014, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Prepare Seasoning and Oils for Chive & Pork Filling", "nameZh": "准备韭菜猪肉馅的调料和油", "nameEs": "Preparar condimentos y aceites para el relleno de cebollín y cerdo", "subcategory": "Chive & Pork Filling", "hasQuantity": false, "recordOutput": false, "id": 2015, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Mix Chive & Pork Filling", "nameZh": "混合韭菜猪肉馅", "nameEs": "Mezclar el relleno de cebollín y cerdo", "subcategory": "Chive & Pork Filling", "hasQuantity": false, "recordOutput": false, "id": 2016, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Marinate X lb Ground Chicken with Sauce", "nameZh": "用酱料腌制X磅鸡肉碎", "nameEs": "Marinar X lb de pollo molido con salsa", "subcategory": "Basil & Chicken Filling", "hasQuantity": true, "recordOutput": false, "id": 2017, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Weight Y pound of Carrots X times to make X boxes", "nameZh": "称Y磅胡萝卜X次制作X箱", "nameEs": "Pesar Y libras de zanahoria X veces para hacer X cajas", "subcategory": "Basil & Chicken Filling", "hasQuantity": true, "recordOutput": false, "id": 2018, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Weight Y pound of Onion X times to make X boxes", "nameZh": "称Y磅洋葱X次制作X箱", "nameEs": "Pesar Y libras de cebolla X veces para hacer X cajas", "subcategory": "Basil & Chicken Filling", "hasQuantity": true, "recordOutput": false, "id": 2019, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Weight Y pound of Basil X times to make X boxes", "nameZh": "称Y磅罗勒X次制作X箱", "nameEs": "Pesar Y libras de albahaca X veces para hacer X cajas", "subcategory": "Basil & Chicken Filling", "hasQuantity": true, "recordOutput": false, "id": 2020, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Prepare Seasoning and Oils for Basil & Chicken Filling", "nameZh": "准备罗勒鸡肉馅的调料和油", "nameEs": "Preparar condimentos y aceites para el relleno de albahaca y pollo", "subcategory": "Basil & Chicken Filling", "hasQuantity": false, "recordOutput": false, "id": 2021, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Mix Basil & Chicken Filling", "nameZh": "混合罗勒鸡肉馅", "nameEs": "Mezclar el relleno de albahaca y pollo", "subcategory": "Basil & Chicken Filling", "hasQuantity": false, "recordOutput": false, "id": 2022, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Marinate X lb Ground Pork with Sauce", "nameZh": "用酱料腌制X磅猪肉碎", "nameEs": "Marinar X lb de cerdo molido con salsa", "subcategory": "Cabbage & Pork Filling", "hasQuantity": true, "recordOutput": false, "id": 2023, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Prepare Seasoning and Oils for Cabbage & Pork Filling", "nameZh": "准备白菜猪肉馅的调料和油", "nameEs": "Preparar condimentos y aceites para el relleno de repollo y cerdo", "subcategory": "Cabbage & Pork Filling", "hasQuantity": false, "recordOutput": false, "id": 2024, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Mix Cabbage & Pork Fillings", "nameZh": "混合白菜猪肉馅", "nameEs": "Mezclar el relleno de repollo y cerdo", "subcategory": "Cabbage & Pork Filling", "hasQuantity": false, "recordOutput": false, "id": 2025, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Weight the X pound of Eye Round of Beef", "nameZh": "称X磅牛眼肉", "nameEs": "Pesar X libras de redondo de res", "subcategory": "Spicy Beef Filling", "hasQuantity": true, "recordOutput": false, "id": 2026, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Weight the X pound of Beef Navel Plate", "nameZh": "称X磅牛腩", "nameEs": "Pesar X libras de falda de res", "subcategory": "Spicy Beef Filling", "hasQuantity": true, "recordOutput": false, "id": 2027, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Grind the X pound of Eye Round of Beef", "nameZh": "研磨X磅牛眼肉", "nameEs": "Moler X libras de redondo de res", "subcategory": "Spicy Beef Filling", "hasQuantity": true, "recordOutput": false, "id": 2028, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Grind the X pound of Beef Navel Plate", "nameZh": "研磨X磅牛腩", "nameEs": "Moler X libras de falda de res", "subcategory": "Spicy Beef Filling", "hasQuantity": true, "recordOutput": false, "id": 2029, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Marinate X lb Ground Beef with Sauce", "nameZh": "用酱料腌制X磅牛肉碎", "nameEs": "Marinar X lb de res molida con salsa", "subcategory": "Spicy Beef Filling", "hasQuantity": true, "recordOutput": false, "id": 2030, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Weight 11lb of Pepper X times to make X boxes", "nameZh": "称11磅辣椒X次制作X箱", "nameEs": "Pesar 11lb de pimienta X veces para hacer X cajas", "subcategory": "Spicy Beef Filling", "hasQuantity": true, "recordOutput": false, "id": 2031, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Weight X lb of Onion", "nameZh": "称X磅洋葱", "nameEs": "Pesar X libras de cebolla", "subcategory": "Spicy Beef Filling", "hasQuantity": true, "recordOutput": false, "id": 2032, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Mix Spicy Beef Fillings", "nameZh": "混合香辣牛肉馅", "nameEs": "Mezclar el relleno de res picante", "subcategory": "Spicy Beef Filling", "hasQuantity": false, "recordOutput": false, "id": 2033, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Weight the X pound of Vegan Teriyaki Beef", "nameZh": "称X磅素食照烧牛肉", "nameEs": "Pesar X libras de res vegana teriyaki", "subcategory": "Spicy Vegan Beef Filling", "hasQuantity": true, "recordOutput": false, "id": 2034, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Weight the X pound of Impossible Meat", "nameZh": "称X磅植物肉", "nameEs": "Pesar X libras de carne imposible", "subcategory": "Spicy Vegan Beef Filling", "hasQuantity": true, "recordOutput": false, "id": 2035, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Grind the X pound of Vegan Teriyaki Beef", "nameZh": "研磨X磅素食照烧牛肉", "nameEs": "Moler X libras de res vegana teriyaki", "subcategory": "Spicy Vegan Beef Filling", "hasQuantity": true, "recordOutput": false, "id": 2036, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Marinate X lb Ground Vegan Beef with Sauce", "nameZh": "用酱料腌制X磅素食牛肉碎", "nameEs": "Marinar X lb de res vegana molida con salsa", "subcategory": "Spicy Vegan Beef Filling", "hasQuantity": true, "recordOutput": false, "id": 2037, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Weight 10lb of Pepper X times to make X boxes", "nameZh": "称10磅辣椒X次制作X箱", "nameEs": "Pesar 10lb de pimienta X veces para hacer X cajas", "subcategory": "Spicy Vegan Beef Filling", "hasQuantity": true, "recordOutput": false, "id": 2038, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Weight X lb of Onion", "nameZh": "称X磅洋葱", "nameEs": "Pesar X libras de cebolla", "subcategory": "Spicy Vegan Beef Filling", "hasQuantity": true, "recordOutput": false, "id": 2039, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Mix Spicy Vegan Beef Fillings", "nameZh": "混合香辣素食牛肉馅", "nameEs": "Mezclar el relleno vegano de res picante", "subcategory": "Spicy Vegan Beef Filling", "hasQuantity": false, "recordOutput": false, "id": 2040, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Take out X cases of 40lb Shrimp to Thaw", "nameZh": "取出X箱40磅虾解冻", "nameEs": "Sacar X cajas de 40lb de camarón para descongelar", "subcategory": "Shrimp Filling", "hasQuantity": true, "recordOutput": false, "id": 2041, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Take out X bags of Corn to Thaw", "nameZh": "取出X袋玉米解冻", "nameEs": "Sacar X bolsas de maíz para descongelar", "subcategory": "Shrimp Filling", "hasQuantity": false, "recordOutput": false, "id": 2042, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Wash X cases of 40lb Shrimp", "nameZh": "清洗X箱40磅虾", "nameEs": "Lavar X cajas de 40lb de camarón", "subcategory": "Shrimp Filling", "hasQuantity": true, "recordOutput": false, "id": 2043, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Grind X cases of 40lb Shrimp", "nameZh": "研磨X箱40磅虾", "nameEs": "Moler X cajas de 40lb de camarón", "subcategory": "Shrimp Filling", "hasQuantity": true, "recordOutput": false, "id": 2044, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Weight X lb of Carrots", "nameZh": "称X磅胡萝卜", "nameEs": "Pesar X libras de zanahoria", "subcategory": "Shrimp Filling", "hasQuantity": true, "recordOutput": false, "id": 2045, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Weight X lb of Celery", "nameZh": "称X磅芹菜", "nameEs": "Pesar X libras de apio", "subcategory": "Shrimp Filling", "hasQuantity": true, "recordOutput": false, "id": 2046, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Mix Shrimp Fillings", "nameZh": "混合虾馅", "nameEs": "Mezclar el relleno de camarón", "subcategory": "Shrimp Filling", "hasQuantity": false, "recordOutput": false, "id": 2047, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Weight 5.4 lb of the Sauteed Mushroom X boxes", "nameZh": "称5.4磅炒蘑菇X箱", "nameEs": "Pesar 5.4lb de hongos salteados X cajas", "subcategory": "Vegetable Filling", "hasQuantity": true, "recordOutput": false, "id": 2048, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Weight 2.83 lb of the Carrots X boxes", "nameZh": "称2.83磅胡萝卜X箱", "nameEs": "Pesar 2.83lb de zanahoria X cajas", "subcategory": "Vegetable Filling", "hasQuantity": true, "recordOutput": false, "id": 2049, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Weight 9.33 lb of the Smoked Tofu X boxes", "nameZh": "称9.33磅熏豆腐X箱", "nameEs": "Pesar 9.33lb de tofu ahumado X cajas", "subcategory": "Vegetable Filling", "hasQuantity": true, "recordOutput": false, "id": 2050, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Weight 4.5 lb of the Korean Noodles X boxes", "nameZh": "称4.5磅韩式面条X箱", "nameEs": "Pesar 4.5lb de fideos coreanos X cajas", "subcategory": "Vegetable Filling", "hasQuantity": true, "recordOutput": false, "id": 2051, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Weight 3 lb of the Salted Radish X boxes", "nameZh": "称3磅咸萝卜X箱", "nameEs": "Pesar 3lb de rábano salado X cajas", "subcategory": "Vegetable Filling", "hasQuantity": true, "recordOutput": false, "id": 2052, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Mix Vegetable Fillings", "nameZh": "混合蔬菜馅", "nameEs": "Mezclar el relleno de verduras", "subcategory": "Vegetable Filling", "hasQuantity": false, "recordOutput": false, "id": 2053, "category": "Filling Prep", "estimatedMins": null}, {"nameEn": "Cut X Box of Chicken Breast", "nameZh": "切X箱鸡胸肉", "nameEs": "Cortar X caja de pechuga de pollo", "subcategory": "Chicken Breast", "hasQuantity": true, "recordOutput": false, "id": 2054, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Take out X box of Chicken Breast to Thaw", "nameZh": "取出X箱鸡胸肉解冻", "nameEs": "Sacar X caja de pechuga de pollo para descongelar", "subcategory": "Chicken Breast", "hasQuantity": true, "recordOutput": false, "id": 2055, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Cut X Box of Pork Picnic", "nameZh": "切X箱猪前腿肉", "nameEs": "Cortar X caja de paleta de cerdo", "subcategory": "Pork Picnic", "hasQuantity": true, "recordOutput": false, "id": 2056, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Take out X box of Pork Picnic to Thaw", "nameZh": "取出X箱猪前腿肉解冻", "nameEs": "Sacar X caja de paleta de cerdo para descongelar", "subcategory": "Pork Picnic", "hasQuantity": true, "recordOutput": false, "id": 2057, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Take out X box of Beef Heel to Thaw", "nameZh": "取出X箱牛蹄筋解冻", "nameEs": "Sacar X caja de talón de res para descongelar", "subcategory": "Beef Heel (Sliced)", "hasQuantity": true, "recordOutput": false, "id": 2058, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Sliced X boxes of Cooked Beef Heel", "nameZh": "切X箱熟牛蹄筋", "nameEs": "Rebanar X cajas de talón de res cocido", "subcategory": "Beef Heel (Sliced)", "hasQuantity": true, "recordOutput": false, "id": 2059, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Weigh Sliced Beef into 2lb Bags", "nameZh": "将切片牛肉称重装入2磅袋", "nameEs": "Pesar la res rebanada en bolsas de 2lb", "subcategory": "Beef Heel (Sliced)", "hasQuantity": false, "recordOutput": false, "id": 2060, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Record how many Bags of Beef", "nameZh": "记录牛肉袋数", "nameEs": "Registrar cuántas bolsas de res", "subcategory": "Beef Heel (Sliced)", "hasQuantity": false, "recordOutput": true, "recordPromptEn": "How many total bags of Sliced Beef were made?", "recordPromptZh": "共制作了多少袋切片牛肉？", "recordPromptEs": "¿Cuántas bolsas totales de res rebanada se hicieron?", "id": 2061, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Take out X box of Beef Heel to Thaw", "nameZh": "取出X箱牛蹄筋解冻", "nameEs": "Sacar X caja de talón de res para descongelar", "subcategory": "Beef Heel (Stewed)", "hasQuantity": false, "recordOutput": false, "id": 2062, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Cut X Box of Beef Heel into Cubes", "nameZh": "将X箱牛蹄筋切成小块", "nameEs": "Cortar X caja de talón de res en cubos", "subcategory": "Beef Heel (Stewed)", "hasQuantity": true, "recordOutput": false, "id": 2063, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Debone X Ducks", "nameZh": "给X只鸭子去骨", "nameEs": "Deshuesar X patos", "subcategory": "Duck", "hasQuantity": true, "recordOutput": false, "id": 2064, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Cut X Ducks into Slices", "nameZh": "将X只鸭子切片", "nameEs": "Cortar X patos en rebanadas", "subcategory": "Duck", "hasQuantity": true, "recordOutput": false, "id": 2065, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Weigh Sliced Duck into 2lb Bags", "nameZh": "将切片鸭肉称重装入2磅袋", "nameEs": "Pesar el pato rebanado en bolsas de 2lb", "subcategory": "Duck", "hasQuantity": false, "recordOutput": false, "id": 2066, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Record how many Bags of Duck", "nameZh": "记录鸭肉袋数", "nameEs": "Registrar cuántas bolsas de pato", "subcategory": "Duck", "hasQuantity": false, "recordOutput": true, "recordPromptEn": "How many total bags of Sliced Duck were made?", "recordPromptZh": "共制作了多少袋切片鸭肉？", "recordPromptEs": "¿Cuántas bolsas totales de pato rebanado se hicieron?", "id": 2067, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Take out 2 bag of Eye Round of Beef", "nameZh": "取出2袋牛眼肉", "nameEs": "Sacar 2 bolsas de redondo de res", "subcategory": "Eye Round of Beef", "hasQuantity": false, "recordOutput": false, "id": 2068, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Grind 2 bag of Eye Round of Beef", "nameZh": "研磨2袋牛眼肉", "nameEs": "Moler 2 bolsas de redondo de res", "subcategory": "Eye Round of Beef", "hasQuantity": false, "recordOutput": false, "id": 2069, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Weigh Eye Round of Beef and label with weight", "nameZh": "称量牛眼肉并贴上重量标签", "nameEs": "Pesar el redondo de res y etiquetar con el peso", "subcategory": "Eye Round of Beef", "hasQuantity": false, "recordOutput": false, "id": 2070, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Take 10lb of Impossible Meat to Thaw", "nameZh": "取出10磅植物肉解冻", "nameEs": "Sacar 10lb de carne imposible para descongelar", "subcategory": "Impossible Meat", "hasQuantity": false, "recordOutput": false, "id": 2071, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Portion out 4lb of Chicken Carcass into Bags", "nameZh": "将鸡骨架分装入4磅袋", "nameEs": "Porcionar 4lb de carcasa de pollo en bolsas", "subcategory": "Chicken Carcass", "hasQuantity": false, "recordOutput": false, "id": 2072, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Record how many Bags of Chicken Carcass", "nameZh": "记录鸡骨架袋数", "nameEs": "Registrar cuántas bolsas de carcasa de pollo", "subcategory": "Chicken Carcass", "hasQuantity": false, "recordOutput": true, "recordPromptEn": "How many total bags of Chicken Carcass were portioned?", "recordPromptZh": "共分装了多少袋鸡骨架？", "recordPromptEs": "¿Cuántas bolsas totales de carcasa de pollo se porcionaron?", "id": 2073, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Put all Chicken Carcass into Freezer", "nameZh": "将所有鸡骨架放入冷冻库", "nameEs": "Poner toda la carcasa de pollo en el congelador", "subcategory": "Chicken Carcass", "hasQuantity": false, "recordOutput": false, "id": 2074, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Portion out 10lb of Chicken Thigh into Bags", "nameZh": "将鸡腿肉分装入10磅袋", "nameEs": "Porcionar 10lb de muslo de pollo en bolsas", "subcategory": "Chicken Thigh", "hasQuantity": false, "recordOutput": false, "id": 2075, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Record how many Bags of Chicken Thighs", "nameZh": "记录鸡腿肉袋数", "nameEs": "Registrar cuántas bolsas de muslo de pollo", "subcategory": "Chicken Thigh", "hasQuantity": false, "recordOutput": true, "recordPromptEn": "How many total bags of Chicken Thighs were portioned?", "recordPromptZh": "共分装了多少袋鸡腿肉？", "recordPromptEs": "¿Cuántas bolsas totales de muslo de pollo se porcionaron?", "id": 2076, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Put all Chicken Thighs into Freezer", "nameZh": "将所有鸡腿肉放入冷冻库", "nameEs": "Poner todos los muslos de pollo en el congelador", "subcategory": "Chicken Thigh", "hasQuantity": false, "recordOutput": false, "id": 2077, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Portion out 10lb of Pork Ribs into Bags", "nameZh": "将猪排骨分装入10磅袋", "nameEs": "Porcionar 10lb de costillas de cerdo en bolsas", "subcategory": "Pork Ribs", "hasQuantity": false, "recordOutput": false, "id": 2078, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Record how many Bags of Pork Ribs", "nameZh": "记录猪排骨袋数", "nameEs": "Registrar cuántas bolsas de costillas de cerdo", "subcategory": "Pork Ribs", "hasQuantity": false, "recordOutput": true, "recordPromptEn": "How many total bags of Pork Ribs were portioned?", "recordPromptZh": "共分装了多少袋猪排骨？", "recordPromptEs": "¿Cuántas bolsas totales de costillas de cerdo se porcionaron?", "id": 2079, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Put all Pork Ribs into Freezer", "nameZh": "将所有猪排骨放入冷冻库", "nameEs": "Poner todas las costillas de cerdo en el congelador", "subcategory": "Pork Ribs", "hasQuantity": false, "recordOutput": false, "id": 2080, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Portion out 10lb of Pork Belly into Bags", "nameZh": "将五花肉分装入10磅袋", "nameEs": "Porcionar 10lb de panceta de cerdo en bolsas", "subcategory": "Pork Belly", "hasQuantity": false, "recordOutput": false, "id": 2081, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Record how many Bags of Pork Belly", "nameZh": "记录五花肉袋数", "nameEs": "Registrar cuántas bolsas de panceta de cerdo", "subcategory": "Pork Belly", "hasQuantity": false, "recordOutput": true, "recordPromptEn": "How many total bags of Pork Belly were portioned?", "recordPromptZh": "共分装了多少袋五花肉？", "recordPromptEs": "¿Cuántas bolsas totales de panceta de cerdo se porcionaron?", "id": 2082, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Put all Pork Belly into Freezer", "nameZh": "将所有五花肉放入冷冻库", "nameEs": "Poner toda la panceta de cerdo en el congelador", "subcategory": "Pork Belly", "hasQuantity": false, "recordOutput": false, "id": 2083, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Portion out 10lb of Pork Loin into Bags", "nameZh": "将猪里脊分装入10磅袋", "nameEs": "Porcionar 10lb de lomo de cerdo en bolsas", "subcategory": "Pork Loin", "hasQuantity": false, "recordOutput": false, "id": 2084, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Record how many Bags of Pork Loin", "nameZh": "记录猪里脊袋数", "nameEs": "Registrar cuántas bolsas de lomo de cerdo", "subcategory": "Pork Loin", "hasQuantity": false, "recordOutput": true, "recordPromptEn": "How many total bags of Pork Loin were portioned?", "recordPromptZh": "共分装了多少袋猪里脊？", "recordPromptEs": "¿Cuántas bolsas totales de lomo de cerdo se porcionaron?", "id": 2085, "category": "Meat Prep", "estimatedMins": null}, {"nameEn": "Put all Pork Loin into Freezer", "nameZh": "将所有猪里脊放入冷冻库", "nameEs": "Poner todo el lomo de cerdo en el congelador", "subcategory": "Pork Loin", "hasQuantity": false, "recordOutput": false, "id": 2086, "category": "Meat Prep", "estimatedMins": null}];

const WILLIAMSBURG_PARS = {
  "Pork Buns": 7,
  "Vegetable Buns": 5,
  "Red Bean Buns": 4,
  "Noodles": 5,
  "Pancake Dough": 35,
  "Pork & Chive": 35,
  "Pork & Cabbage": 9,
  "Chicken & Basil": 16,
  "Vegetable": 14,
  "Shrimp": 10,
  "Spicy Beef": 6,
  "Vegan Spicy Beef": 6,
  "Frozen Wontons": 15,
  "Frozen Veg Wontons": 7,
  "Pork Fried Buns": 3,
  "Roast Pork": 3,
  "Roast Chicken": 3,
  "Peking Duck": 3,
  "Sliced Beef": 2,
  "Beef Chunk": 3,
  "Forks": 2,
  "Spoons": 1,
  "Chopsticks": 1,
  "1oz Cups & Lids (2 box)": 2,
  "1lb Aluminum Trays & Lids Set": 2,
  "RO 40 Noodle Soup Bowl": 2,
  "RO 32 Dry Noodle Bowl": 2,
  "12oz Side Dishes": 2,
  "8oz Side Dishes": 1,
  "Frozen Bags & Labels": 1,
  "2oz Side Sauce Container": 2,
  "16oz Small Soup Containers": 2,
  "32oz Large Soup Containers": 2,
  "Single Piece Bun Containers": 2,
  "Dan Dan Mein Sauce": 10,
  "Dan Dan Mein Beef": 7,
  "Dan Dan Mein Tofu": 4,
  "Sesame Noodle Sauce (Set)": 5,
  "Hot Chili Oil (Bucket)": 2,
  "Wonton Soy Sauce": 12,
  "Dumpling Soy Sauce": 6,
  "Dumpling Hot Sauce (box)": 4,
  "Dumpling Hot Sauce (Gallon)": 3,
  "Case of Sweet Bean Sauce": 1,
  "Kimchi": 2,
  "Spicy Cucumbers + Sauce": 4,
  "Hot and Sour Soup Filling": 2,
  "Beef Broth": 1,
  "Soft Tofu": 2,
  "Chicken Bone": 5,
  "Pork Bone": 5,
  "Duck Bone": 5,
  "Sliced Pickled Carrots": 3,
  "Sliced Cucumbers": 3,
  "Bag of Cilantro (3 lbs)": 2,
  "Chopped Scallion": 5,
  "Baby Bok Choy": 4,
  "Vegetable for Sauteed Noodle": 2,
  "Bottle of Garlic": 1,
  "Edamame": 2,
  "Seaweed Salad": 2,
  "Roasted Peanuts": 1
};

const buildInitPar = (restaurants, products) => {
  const result = {};
  restaurants.forEach(r => {
    result[r.id] = {};
    products.forEach(p => {
      // Use real Williamsburg pars for branch 1, defaults for others
      const wPar = r.id === 1 ? (WILLIAMSBURG_PARS[p.name] ?? 5) : 5;
      result[r.id][p.id] = { par: wPar, orderQty: wPar };
    });
  });
  return result;
};

// Flat version for dynamic imports (no hardcoded overrides)
const buildInitParFlat = (restaurants, products) => {
  const result = {};
  restaurants.forEach(r => {
    result[r.id] = {};
    products.forEach(p => { result[r.id][p.id] = { par: 10, orderQty: 15 }; });
  });
  return result;
};

const DAYS = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
const TODAY = DAYS[new Date().getDay()];
const PRESET_COLORS = ["#C0392B","#2471A3","#1E8449","#8E44AD","#E67E22","#16A085","#2C3E50","#D35400","#6C3483","#117A65"];
const CATEGORIES = ["Buns","Doughs","Frozen Dumplings","Meats","Paper Goods","Sauces","Sides","Soup","Vegetables","Other"];
const UNITS = ["Bag","Bottle","Can","Case","Jar","Quart","100 pc Bags","8 pc Bag","5 Gallon Bucket","pcs","kg","liter","bunch","Other"];

let _prodId = 100;
const newProdId = () => ++_prodId;
let _restId = 10;
const newRestId = () => ++_restId;
let _oid = 200;
const newOid = () => ++_oid;

const genInventory = (restaurants, products, parLevels={}) => {
  const inv = {};
  restaurants.forEach(r => {
    inv[r.id] = {};
    products.forEach(p => {
      // Default to par level so nothing gets ordered unless manager counts lower
      const par = parLevels[r.id]?.[p.id]?.par ?? 5;
      inv[r.id][p.id] = par;
    });
  });
  return inv;
};

const nextDelivInfo = (deliveryDays) => {
  const now = new Date();
  const todayIdx = now.getDay();
  const opts = deliveryDays.map(d => {
    const dIdx = DAYS.indexOf(d);
    const oIdx = (dIdx - 1 + 7) % 7;
    let diff = oIdx - todayIdx;
    if (diff <= 0) diff += 7;
    const orderDate = new Date(now); orderDate.setDate(now.getDate() + diff);
    const delivDate = new Date(orderDate); delivDate.setDate(orderDate.getDate() + 1);
    return { orderDay: DAYS[oIdx], delivDate, diff };
  });
  opts.sort((a,b) => a.diff - b.diff);
  return opts[0];
};

const isOrderDay = (rest) => rest.deliveryDays.some(d => DAYS[(DAYS.indexOf(d)-1+7)%7] === TODAY);
const fmt = d => d.toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric"});
const fmtMoney = n => `$${n.toFixed(2)}`;
const round2 = n => Math.round(n * 100) / 100;

const STATUS_META = {
  "pending":           { color:"#E67E22", label:"Pending" },
  "sent":              { color:"#2471A3", label:"Sent" },
  "confirmed":         { color:"#27AE60", label:"Confirmed" },
  "preparing":         { color:"#2471A3", label:"Preparing" },
  "dispatched":        { color:"#E74C3C", label:"Dispatched" },
  "delivered":         { color:"#1A5276", label:"Delivered ✓" },
  "to_be_delivered":   { color:"#27AE60", label:"Confirmed" },
  "cancel_requested":  { color:"#8E44AD", label:"Cancel Requested" },
  "cancelled":         { color:"#95a5a6", label:"Cancelled" },
  // Legacy Title Case (older orders in Firebase)
  "Sent":              { color:"#2471A3", label:"Sent" },
  "Confirmed":         { color:"#27AE60", label:"Confirmed" },
  "Preparing":         { color:"#2471A3", label:"Preparing" },
  "Dispatched":        { color:"#E74C3C", label:"Dispatched" },
  "Delivered":         { color:"#1A5276", label:"Delivered ✓" },
  "To Be Delivered":   { color:"#27AE60", label:"Confirmed" },
};

// ── Atoms ────────────────────────────────────────────────────────────────────
const Badge = ({status}) => {
  const m = STATUS_META[status]||{color:"#999"};
  const label = m.label || status;
  return <span style={{background:m.color+"22",color:m.color,border:`1px solid ${m.color}44`,
    borderRadius:20,padding:"2px 10px",fontSize:11,fontWeight:700,whiteSpace:"nowrap"}}>{label}</span>;
};

const Card = ({children,style={},...rest}) => (
  <div style={{background:"#fff",borderRadius:14,boxShadow:"0 2px 14px rgba(0,0,0,0.06)",padding:22,...style}} {...rest}>
    {children}
  </div>
);

const Btn = ({children,onClick,color="#1a1a1a",outline=false,small=false,disabled=false,full=false,danger=false,style={}}) => {
  const c = danger ? "#E74C3C" : color;
  return (
    <button onClick={onClick} disabled={disabled} style={{
      background:disabled?"#e5e5e5":outline?"transparent":c,
      color:disabled?"#bbb":outline?c:"#fff",
      border:`2px solid ${disabled?"#e5e5e5":c}`,
      borderRadius:9,padding:small?"5px 13px":"10px 18px",
      fontFamily:"'IBM Plex Sans',sans-serif",fontWeight:600,
      fontSize:small?12:14,cursor:disabled?"not-allowed":"pointer",
      transition:"all .15s",width:full?"100%":"auto",...style,
    }}>{children}</button>
  );
};

const NumInput = ({value, onChange, min=0}) => (
  <div style={{display:"flex",border:"1px solid #e5e5e5",borderRadius:8,overflow:"hidden",width:110}}>
    <button onClick={()=>onChange(Math.max(min, value-1))}
      style={{background:"#f5f5f5",border:"none",padding:"6px 9px",fontWeight:700,fontSize:14,cursor:"pointer"}}>−</button>
    <input type="number" value={value}
      onChange={e=>onChange(Math.max(min,+e.target.value))}
      style={{flex:1,border:"none",textAlign:"center",fontWeight:700,fontSize:14,padding:"5px 0",outline:"none"}}/>
    <button onClick={()=>onChange(value+1)}
      style={{background:"#f5f5f5",border:"none",padding:"6px 9px",fontWeight:700,fontSize:14,cursor:"pointer"}}>+</button>
  </div>
);

const FormField = ({label, children, error}) => (
  <div style={{marginBottom:14}}>
    <label style={{fontSize:11,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:.5,display:"block",marginBottom:5}}>{label}</label>
    {children}
    {error && <div style={{fontSize:11,color:"#E74C3C",marginTop:3}}>{error}</div>}
  </div>
);

const inputStyle = {
  width:"100%", border:"1px solid #e5e5e5", borderRadius:9, padding:"10px 13px",
  fontSize:14, outline:"none", fontFamily:"'IBM Plex Sans',sans-serif", transition:"border .15s"
};

// ── Product Editor Modal ──────────────────────────────────────────────────────
function ProductEditorModal({ product, onSave, onClose, onDelete, customCats }) {
  const isNew = !product;
  const [form, setForm] = useState(product ? {...product} : { name:"", unit:"kg", category:"Other", price:"" });
  const [errors, setErrors] = useState({});

  const set = (k,v) => setForm(f=>({...f,[k]:v}));

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Name is required";
    if (!form.internal && (!form.price || isNaN(+form.price) || +form.price <= 0)) e.price = "Valid price required (or mark as Internal)";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSave = () => {
    if (!validate()) return;
    onSave({ ...form, id: product?.id || newProdId(),
      price: form.internal ? null : +form.price,
      internal: !!form.internal });
  };

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:2000,
      display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={onClose}>
      <div style={{background:"#fff",borderRadius:18,width:"100%",maxWidth:480,
        maxHeight:"90vh",overflowY:"auto",WebkitOverflowScrolling:"touch",
        boxShadow:"0 30px 80px rgba(0,0,0,0.3)"}} onClick={e=>e.stopPropagation()}>

        <div style={{background:"#1a1a1a",color:"#fff",padding:"22px 28px",
          display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{fontSize:10,color:"#666",letterSpacing:3,textTransform:"uppercase",marginBottom:3}}>
              {isNew ? "Add Product" : "Edit Product"}
            </div>
            <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:22}}>
              {isNew ? "New Product" : form.name || "Edit Product"}
            </h2>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",color:"#666",fontSize:22,cursor:"pointer",lineHeight:1}}>×</button>
        </div>

        <div style={{padding:"24px 28px"}}>
          <FormField label="Product Name" error={errors.name}>
            <input value={form.name} onChange={e=>set("name",e.target.value)} placeholder="e.g. San Marzano Tomatoes"
              style={{...inputStyle, borderColor: errors.name?"#E74C3C":"#e5e5e5"}}/>
          </FormField>

          {/* Order Mode Toggle */}
          <div style={{marginBottom:20}}>
            <div style={{fontSize:11,fontWeight:700,color:"#888",letterSpacing:1,textTransform:"uppercase",marginBottom:10}}>Ordering Modes</div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {[["par","📦 Par Order","Counts inventory and calculates what's needed to hit par levels"],
                ["custom","📋 Custom Order","Manager enters quantities directly without par context"]].map(([mode,label,desc])=>{
                const enabled = (form.orderModes||["par"]).includes(mode);
                return (
                  <div key={mode} onClick={()=>{
                    const cur = form.orderModes||["par"];
                    const next = enabled ? cur.filter(m=>m!==mode) : [...cur,mode];
                    if (next.length > 0) set("orderModes", next);
                  }} style={{display:"flex",alignItems:"center",gap:14,padding:"12px 14px",
                    borderRadius:10,border:`1px solid ${enabled?"#1a1a1a":"#e5e5e5"}`,
                    background:enabled?"#1a1a1a":"#fff",cursor:"pointer",transition:"all .15s"}}>
                    <div style={{width:20,height:20,borderRadius:6,border:`2px solid ${enabled?"#fff":"#ccc"}`,
                      background:enabled?"#fff":"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                      {enabled && <div style={{width:10,height:10,borderRadius:3,background:"#1a1a1a"}}/>}
                    </div>
                    <div>
                      <div style={{fontWeight:700,fontSize:14,color:enabled?"#fff":"#1a1a1a"}}>{label}</div>
                      <div style={{fontSize:12,color:enabled?"rgba(255,255,255,0.65)":"#888",marginTop:1}}>{desc}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>


          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
            <FormField label="Category">
              <select value={form.category} onChange={e=>set("category",e.target.value)} style={inputStyle}>
                {[...new Set([...CATEGORIES, ...(customCats||[])])].sort().map(c=><option key={c}>{c}</option>)}
              </select>
            </FormField>
            <FormField label="Unit">
              <select value={form.unit} onChange={e=>set("unit",e.target.value)} style={inputStyle}>
                {UNITS.map(u=><option key={u}>{u}</option>)}
              </select>
            </FormField>
          </div>

          {/* Internal item toggle */}
          <div style={{marginBottom:14}}>
            <label onClick={()=>{set("internal",!form.internal); if(!form.internal)set("price","");}}
              style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",
                borderRadius:10,border:`2px solid ${form.internal?"#8E44AD":"#e5e5e5"}`,
                background:form.internal?"#faf5ff":"#fff",cursor:"pointer",userSelect:"none"}}>
              <div style={{width:20,height:20,borderRadius:5,border:`2px solid ${form.internal?"#8E44AD":"#ccc"}`,
                background:form.internal?"#8E44AD":"transparent",display:"flex",
                alignItems:"center",justifyContent:"center",flexShrink:0}}>
                {form.internal&&<span style={{color:"#fff",fontSize:12,fontWeight:900}}>✓</span>}
              </div>
              <div>
                <div style={{fontWeight:700,fontSize:13,color:form.internal?"#8E44AD":"#555"}}>
                  Internal / Non-deliverable item
                </div>
                <div style={{fontSize:11,color:"#aaa",marginTop:1}}>
                  Track production only — won't appear in restaurant orders
                </div>
              </div>
            </label>
          </div>

          {!form.internal && <FormField label="Price per unit ($)" error={errors.price}>
            <input type="number" value={form.price} onChange={e=>set("price",e.target.value)}
              placeholder="0.00" step="0.01" min="0"
              style={{...inputStyle, borderColor: errors.price?"#E74C3C":"#e5e5e5"}}/>
          </FormField>}

          <FormField label="Weight per unit (lbs)" >
            <input type="number" value={form.weightLbs||""} onChange={e=>set("weightLbs", e.target.value ? parseFloat(e.target.value) : "")}
              placeholder="e.g. 1.5" step="0.01" min="0"
              style={inputStyle}/>
            <div style={{fontSize:11,color:"#aaa",marginTop:4}}>Used for factory poundage reports. Leave blank if not a factory-produced item.</div>
          </FormField>

          {/* Preview */}
          {form.name && form.price && (
            <div style={{background:"#f8f8f8",borderRadius:10,padding:"10px 14px",marginBottom:16,
              display:"flex",justifyContent:"space-between",alignItems:"center",fontSize:13}}>
              <div>
                <span style={{background:"#e5e5e5",borderRadius:5,padding:"2px 7px",fontSize:10,fontWeight:700,marginRight:8}}>{form.category}</span>
                <strong>{form.name}</strong>
              </div>
              <span style={{color:"#666",fontWeight:700}}>{fmtMoney(+form.price||0)}/{form.unit}</span>
            </div>
          )}

          <div style={{display:"flex",gap:10,justifyContent:"space-between",alignItems:"center",borderTop:"1px solid #f0f0f0",paddingTop:16}}>
            <div>
              {!isNew && onDelete && (
                <Btn small danger outline onClick={()=>onDelete(product.id)}>🗑 Delete</Btn>
              )}
            </div>
            <div style={{display:"flex",gap:8}}>
              <Btn outline color="#888" onClick={onClose}>Cancel</Btn>
              <Btn color="#1a1a1a" onClick={handleSave}>{isNew ? "Add Product" : "Save Changes"}</Btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Restaurant Editor Modal ───────────────────────────────────────────────────
function RestaurantEditorModal({ restaurant, onSave, onClose, onDelete }) {
  const isNew = !restaurant;
  const [form, setForm] = useState(restaurant ? {...restaurant} : {
    name:"", color:PRESET_COLORS[0], deliveryDays:[], managerName:"", managerEmail:"", orderModes:["par"]
  });
  const [errors, setErrors] = useState({});

  const set = (k,v) => setForm(f=>({...f,[k]:v}));

  const toggleDay = (day) => {
    set("deliveryDays", form.deliveryDays.includes(day)
      ? form.deliveryDays.filter(d=>d!==day)
      : [...form.deliveryDays, day]);
  };

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Branch name is required";
    if (form.deliveryDays.length === 0) e.days = "Select at least one delivery day";
    if (!form.managerName.trim()) e.managerName = "Manager name is required";
    if (!form.managerEmail.trim()) e.managerEmail = "Manager email is required";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSave = () => {
    if (!validate()) return;
    onSave({ ...form, id: restaurant?.id || newRestId() });
  };

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:2000,
      display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={onClose}>
      <div style={{background:"#fff",borderRadius:18,width:"100%",maxWidth:500,maxHeight:"90vh",
        overflowY:"auto",boxShadow:"0 30px 80px rgba(0,0,0,0.3)"}} onClick={e=>e.stopPropagation()}>

        <div style={{background:"#1a1a1a",color:"#fff",padding:"22px 28px",
          display:"flex",justifyContent:"space-between",alignItems:"center",
          borderRadius:"18px 18px 0 0",position:"sticky",top:0,zIndex:10}}>
          <div>
            <div style={{fontSize:10,color:"#666",letterSpacing:3,textTransform:"uppercase",marginBottom:3}}>
              {isNew ? "Add Branch" : "Edit Branch"}
            </div>
            <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:22}}>
              {isNew ? "New Restaurant" : form.name}
            </h2>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",color:"#666",fontSize:22,cursor:"pointer"}}>×</button>
        </div>

        <div style={{padding:"24px 28px"}}>
          <FormField label="Branch Name" error={errors.name}>
            <input value={form.name} onChange={e=>set("name",e.target.value)} placeholder="e.g. East Village"
              style={{...inputStyle, borderColor: errors.name?"#E74C3C":"#e5e5e5"}}/>
          </FormField>

          <FormField label="Brand Color">
            <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
              {PRESET_COLORS.map(c=>(
                <button key={c} onClick={()=>set("color",c)} style={{
                  width:30,height:30,borderRadius:8,background:c,border:"none",cursor:"pointer",
                  outline: form.color===c ? `3px solid ${c}` : "2px solid transparent",
                  outlineOffset:2,transition:"all .15s",transform:form.color===c?"scale(1.15)":"scale(1)"
                }}/>
              ))}
              <input type="color" value={form.color} onChange={e=>set("color",e.target.value)}
                title="Custom color" style={{width:30,height:30,borderRadius:8,border:"1px solid #e5e5e5",
                padding:2,cursor:"pointer",background:"none"}}/>
            </div>
            <div style={{marginTop:8,display:"flex",alignItems:"center",gap:8,fontSize:12}}>
              <div style={{width:12,height:12,borderRadius:3,background:form.color}}/>
              <span style={{color:"#888"}}>{form.name || "Branch name"} preview</span>
              <span style={{background:form.color+"22",color:form.color,borderRadius:20,
                padding:"2px 10px",fontSize:11,fontWeight:700,border:`1px solid ${form.color}44`}}>
                {form.name || "Branch"}
              </span>
            </div>
          </FormField>

          <FormField label="Delivery Days" error={errors.days}>
            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
              {["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"].map(day=>{
                const on = form.deliveryDays.includes(day);
                return (
                  <button key={day} onClick={()=>toggleDay(day)} style={{
                    border:`2px solid ${on?form.color:"#e5e5e5"}`,
                    background:on?form.color+"15":"#fff",
                    color:on?form.color:"#888",
                    borderRadius:9,padding:"5px 11px",fontSize:12,fontWeight:600,cursor:"pointer",transition:"all .15s"
                  }}>{day.slice(0,3)}</button>
                );
              })}
            </div>
            {form.deliveryDays.length > 0 && (
              <div style={{fontSize:11,color:"#888",marginTop:5}}>
                Orders due day before: <strong style={{color:"#555"}}>
                  {form.deliveryDays.map(d=>DAYS[(DAYS.indexOf(d)-1+7)%7]).join(", ")}
                </strong>
              </div>
            )}
          </FormField>

          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
            <FormField label="Manager Name" error={errors.managerName}>
              <input value={form.managerName} onChange={e=>set("managerName",e.target.value)}
                placeholder="Full name" style={{...inputStyle,borderColor:errors.managerName?"#E74C3C":"#e5e5e5"}}/>
            </FormField>
            <FormField label="Manager Email" error={errors.managerEmail}>
              <input value={form.managerEmail} onChange={e=>set("managerEmail",e.target.value)}
                placeholder="email@branch.com" style={{...inputStyle,borderColor:errors.managerEmail?"#E74C3C":"#e5e5e5"}}/>
            </FormField>
          </div>


          <div style={{display:"flex",gap:10,justifyContent:"space-between",borderTop:"1px solid #f0f0f0",paddingTop:16}}>
            <div>
              {!isNew && onDelete && (
                <Btn small danger outline onClick={()=>onDelete(restaurant.id)}>🗑 Remove Branch</Btn>
              )}
            </div>
            <div style={{display:"flex",gap:8}}>
              <Btn outline color="#888" onClick={onClose}>Cancel</Btn>
              <Btn color={form.color||"#1a1a1a"} onClick={handleSave}>{isNew ? "Add Branch" : "Save Changes"}</Btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Excel Import Modal ────────────────────────────────────────────────────────
const COL_ALIASES = {
  name:     ["name","product","item","product name","item name","description"],
  category: ["category","cat","type","group","section"],
  unit:     ["unit","uom","measure","unit of measure","sold by"],
  price:    ["price","cost","rate","unit price","price per unit","amount"],
};

function detectColumns(headers) {
  const map = {};
  headers.forEach((h, i) => {
    const norm = h.toString().toLowerCase().trim();
    Object.entries(COL_ALIASES).forEach(([field, aliases]) => {
      if (!map[field] && aliases.includes(norm)) map[field] = i;
    });
  });
  return map;
}

function ExcelImportModal({ onImport, onClose }) {
  const [stage, setStage]       = useState("upload"); // upload | preview | done
  const [dragging, setDragging] = useState(false);
  const [fileName, setFileName] = useState("");
  const [preview, setPreview]   = useState([]); // valid rows
  const [errors, setErrors]     = useState([]);  // {row, msg}
  const [colMap, setColMap]     = useState({});
  const [rawHeaders, setRawHeaders] = useState([]);
  const fileRef = useRef();

  const processFile = (file) => {
    if (!file) return;
    setFileName(file.name);
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const wb = XLSX.read(e.target.result, { type: "array" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(ws, { header: 1, defval: "" });
        if (rows.length < 2) { setErrors([{row:"-", msg:"Sheet appears empty or has only a header row"}]); return; }

        const headers = rows[0].map(h => String(h));
        const detected = detectColumns(headers);
        setRawHeaders(headers);
        setColMap(detected);

        const valid = [], errs = [];
        rows.slice(1).forEach((row, i) => {
          const rowNum = i + 2;
          if (row.every(c => c === "" || c === null || c === undefined)) return; // skip blank rows
          const name     = detected.name     !== undefined ? String(row[detected.name]||"").trim()     : "";
          const category = detected.category !== undefined ? String(row[detected.category]||"").trim() : "Other";
          const unit     = detected.unit     !== undefined ? String(row[detected.unit]||"").trim()     : "pcs";
          const priceRaw = detected.price    !== undefined ? row[detected.price] : "";
          const price    = parseFloat(String(priceRaw).replace(/[^0-9.]/g, ""));

          if (!name)            { errs.push({row:rowNum, msg:`Row ${rowNum}: Missing product name`}); return; }
          if (isNaN(price) || price <= 0) { errs.push({row:rowNum, msg:`Row ${rowNum}: "${name}" — invalid price "${priceRaw}"`}); return; }
          valid.push({ name, category: category||"Other", unit: unit||"pcs", price });
        });

        setPreview(valid);
        setErrors(errs);
        if (valid.length > 0) setStage("preview");
        else setStage("upload");
      } catch(err) {
        setErrors([{row:"-", msg:"Could not read file. Make sure it's an .xlsx or .xls file."}]);
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const handleDrop = useCallback((e) => {
    e.preventDefault(); setDragging(false);
    processFile(e.dataTransfer.files[0]);
  }, []);

  const handleConfirm = () => {
    onImport(preview.map((p, i) => ({ ...p, id: 200 + i + 1, price: +p.price })));
    setStage("done");
  };

  const missingCols = Object.keys(COL_ALIASES).filter(k => colMap[k] === undefined);

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.65)",zIndex:3000,
      display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={onClose}>
      <div style={{background:"#fff",borderRadius:18,width:"100%",maxWidth:620,maxHeight:"90vh",
        overflowY:"auto",boxShadow:"0 30px 80px rgba(0,0,0,0.35)"}} onClick={e=>e.stopPropagation()}>

        {/* Header */}
        <div style={{background:"#1a1a1a",color:"#fff",padding:"20px 26px",borderRadius:"18px 18px 0 0",
          display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{fontSize:10,color:"#666",letterSpacing:3,textTransform:"uppercase",marginBottom:3}}>Products</div>
            <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:22}}>Import from Excel</h2>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",color:"#666",fontSize:22,cursor:"pointer"}}>×</button>
        </div>

        <div style={{padding:"24px 26px"}}>

          {/* ── Stage: Upload ── */}
          {stage === "upload" && (
            <div>
              {/* Format guide */}
              <div style={{background:"#F8F9FA",borderRadius:12,padding:"14px 16px",marginBottom:20,border:"1px solid #e8e8e8"}}>
                <div style={{fontSize:11,fontWeight:700,color:"#aaa",letterSpacing:.5,textTransform:"uppercase",marginBottom:10}}>
                  Expected columns (column order doesn't matter)
                </div>
                <div style={{overflowX:"auto"}}>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                    <thead>
                      <tr>
                        {["Name ✱","Category","Unit","Price ✱"].map(h=>(
                          <th key={h} style={{padding:"6px 10px",background:"#1a1a1a",color:"#fff",
                            textAlign:"left",fontWeight:700,fontSize:11}}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ["Tomato Sauce","Sauces","liter","4.50"],
                        ["Mozzarella","Dairy","kg","12.00"],
                        ["Pizza Dough Balls","Bakery","pcs","1.20"],
                      ].map((row,i)=>(
                        <tr key={i} style={{background:i%2?"#f8f8f8":"#fff"}}>
                          {row.map((cell,j)=>(
                            <td key={j} style={{padding:"5px 10px",borderBottom:"1px solid #f0f0f0",color:"#555"}}>{cell}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div style={{fontSize:11,color:"#aaa",marginTop:8}}>✱ Required &nbsp;.&nbsp; Accepts .xlsx and .xls</div>
              </div>

              {/* Drop zone */}
              <div
                onDragOver={e=>{e.preventDefault();setDragging(true);}}
                onDragLeave={()=>setDragging(false)}
                onDrop={handleDrop}
                onClick={()=>fileRef.current.click()}
                style={{
                  border:`2px dashed ${dragging?"#1a1a1a":"#d0d0d0"}`,
                  background:dragging?"#f5f5f5":"#fafafa",
                  borderRadius:14,padding:"40px 20px",textAlign:"center",
                  cursor:"pointer",transition:"all .2s",marginBottom:errors.length?16:0
                }}>
                <div style={{fontSize:40,marginBottom:10}}>📊</div>
                <div style={{fontWeight:700,fontSize:15,marginBottom:4}}>
                  {dragging ? "Drop it!" : "Drag & drop your Excel file here"}
                </div>
                <div style={{fontSize:12,color:"#aaa",marginBottom:14}}>or click to browse</div>
                <Btn small color="#1a1a1a" onClick={e=>{e.stopPropagation();fileRef.current.click();}}>
                  Choose File
                </Btn>
                <input ref={fileRef} type="file" accept=".xlsx,.xls"
                  style={{display:"none"}} onChange={e=>processFile(e.target.files[0])}/>
              </div>

              {/* Errors */}
              {errors.length > 0 && (
                <div style={{marginTop:14,background:"#FEF2F2",border:"1px solid #FCA5A5",borderRadius:10,padding:"12px 16px"}}>
                  <div style={{fontWeight:700,fontSize:12,color:"#DC2626",marginBottom:6}}>⚠ Issues found</div>
                  {errors.map((e,i)=>(
                    <div key={i} style={{fontSize:12,color:"#7F1D1D",padding:"2px 0"}}>{e.msg}</div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* ── Stage: Preview ── */}
          {stage === "preview" && (
            <div>
              {/* Summary banner */}
              <div style={{background:"#ECFDF5",border:"1px solid #6EE7B7",borderRadius:10,
                padding:"12px 16px",marginBottom:16,display:"flex",gap:12,alignItems:"center",flexWrap:"wrap"}}>
                <span style={{fontSize:24}}>[OK]</span>
                <div>
                  <div style={{fontWeight:700,fontSize:14,color:"#065F46"}}>
                    {preview.length} product{preview.length!==1?"s":""} ready to import from <em>{fileName}</em>
                  </div>
                  <div style={{fontSize:12,color:"#047857",marginTop:2}}>
                    This will <strong>replace all existing products</strong>. Review below before confirming.
                  </div>
                </div>
              </div>

              {/* Column mapping info */}
              {missingCols.length > 0 && (
                <div style={{background:"#FFFBEB",border:"1px solid #FCD34D",borderRadius:10,
                  padding:"10px 14px",marginBottom:14,fontSize:12,color:"#92400E"}}>
                  ⚠ Columns not detected: <strong>{missingCols.join(", ")}</strong> — defaults used (category: "Other", unit: "pcs")
                </div>
              )}

              {/* Detected column mapping */}
              <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:14}}>
                {Object.entries(colMap).map(([field, idx])=>(
                  <div key={field} style={{background:"#f0f0f0",borderRadius:7,padding:"4px 10px",fontSize:11}}>
                    <span style={{color:"#aaa",fontWeight:600,textTransform:"uppercase"}}>{field}</span>
                    <span style={{color:"#555",marginLeft:5}}>→ "{rawHeaders[idx]}"</span>
                  </div>
                ))}
              </div>

              {/* Error rows */}
              {errors.length > 0 && (
                <div style={{background:"#FEF2F2",border:"1px solid #FCA5A5",borderRadius:10,
                  padding:"10px 14px",marginBottom:14}}>
                  <div style={{fontWeight:700,fontSize:12,color:"#DC2626",marginBottom:4}}>
                    {errors.length} row{errors.length!==1?"s":""} skipped due to errors
                  </div>
                  {errors.map((e,i)=>(
                    <div key={i} style={{fontSize:11,color:"#7F1D1D",padding:"1px 0"}}>{e.msg}</div>
                  ))}
                </div>
              )}

              {/* Preview table */}
              <div style={{overflowX:"auto",borderRadius:10,border:"1px solid #e8e8e8",marginBottom:20}}>
                <table style={{width:"100%",borderCollapse:"collapse",fontSize:13,minWidth:380}}>
                  <thead>
                    <tr style={{background:"#1a1a1a",color:"#fff"}}>
                      {["#","Name","Category","Unit","Price"].map(h=>(
                        <th key={h} style={{padding:"8px 12px",textAlign:h==="Price"?"right":"left",
                          fontWeight:700,fontSize:11,letterSpacing:.3}}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {preview.map((p,i)=>(
                      <tr key={i} style={{background:i%2?"#fafafa":"#fff",borderBottom:"1px solid #f0f0f0"}}>
                        <td style={{padding:"7px 12px",color:"#ccc",fontSize:11}}>{i+1}</td>
                        <td style={{padding:"7px 12px",fontWeight:600}}>{p.name}</td>
                        <td style={{padding:"7px 12px",color:"#888"}}>{p.category}</td>
                        <td style={{padding:"7px 12px",color:"#888"}}>{p.unit}</td>
                        <td style={{padding:"7px 12px",textAlign:"right",fontWeight:700}}>{fmtMoney(p.price)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div style={{display:"flex",gap:10,justifyContent:"space-between",flexWrap:"wrap"}}>
                <Btn outline color="#888" onClick={()=>{setStage("upload");setPreview([]);setErrors([]);}}>
                  ← Upload Different File
                </Btn>
                <Btn color="#1E8449" onClick={handleConfirm}>
                  ✓ Import {preview.length} Products
                </Btn>
              </div>
            </div>
          )}

          {/* ── Stage: Done ── */}
          {stage === "done" && (
            <div style={{textAlign:"center",padding:"30px 0"}}>
              <div style={{fontSize:56,marginBottom:14}}>🎉</div>
              <h3 style={{fontFamily:"'Playfair Display',serif",fontSize:22,marginBottom:8}}>Import Complete!</h3>
              <p style={{color:"#666",fontSize:13,marginBottom:6}}>
                <strong>{preview.length} products</strong> have replaced the previous catalog.
              </p>
              <p style={{color:"#aaa",fontSize:12,marginBottom:24}}>
                Par levels for all branches have been reset to defaults (par: 10, order qty: 15). Update them in Stock Check.
              </p>
              <Btn color="#1a1a1a" onClick={onClose}>Done</Btn>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ── Settings Tab (Manage Products & Restaurants) ──────────────────────────────
// ── WeightsSection ───────────────────────────────────────────────────────────
function WeightsSection({ products, saveProducts, showToast }) {
  const FACTORY_CATS = ["Frozen Dumplings","Meats","Sauces","Pancakes","Vegetables","Sides and Soups"];
  const [weightEdits, setWeightEdits] = useState({});
  const [factoryUnsetOpen, setFactoryUnsetOpen] = useState(false);
  const [otherUnsetOpen, setOtherUnsetOpen] = useState(false);
  const hasEdits = Object.keys(weightEdits).length > 0;

  const hasWeight = p => {
    if (weightEdits[p.id] !== undefined) return weightEdits[p.id] !== "";
    return p.weightLbs != null && p.weightLbs !== "";
  };

  const sort = arr => [...arr].sort((a,b)=>a.category.localeCompare(b.category)||a.name.localeCompare(b.name));

  const factoryProds = sort(products.filter(p => FACTORY_CATS.includes(p.category)));
  const otherProds   = sort(products.filter(p => !FACTORY_CATS.includes(p.category)));

  const handleSave = () => {
    const updated = products.map(p =>
      weightEdits[p.id] !== undefined
        ? { ...p, weightLbs: weightEdits[p.id] === "" ? undefined : parseFloat(weightEdits[p.id]) }
        : p
    );
    saveProducts(updated);
    setWeightEdits({});
    if (showToast) showToast("Weights saved ✓");
  };

  const WeightRow = ({ p }) => {
    const val = weightEdits[p.id] !== undefined ? weightEdits[p.id] : (p.weightLbs ?? "");
    return (
      <tr style={{borderBottom:"1px solid #f0f0f0"}}>
        <td style={{padding:"8px 12px",fontSize:13,fontWeight:600}}>{p.name}</td>
        <td style={{padding:"8px 12px",fontSize:12,color:"#888"}}>{p.category}</td>
        <td style={{padding:"8px 12px",fontSize:12,color:"#aaa"}}>{p.unit}</td>
        <td style={{padding:"8px 12px"}}>
          <input
            type="number" min="0" step="0.01" placeholder="—"
            value={val}
            onChange={e => setWeightEdits(prev => ({...prev, [p.id]: e.target.value}))}
            style={{width:80,border:"1px solid #e5e5e5",borderRadius:7,padding:"5px 8px",
              fontSize:13,fontFamily:"'IBM Plex Sans',sans-serif",
              background: weightEdits[p.id] !== undefined ? "#fffbea" : "#fff"}}
          />
        </td>
      </tr>
    );
  };

  const colHeaders = (
    <tr style={{background:"#f8f8f8",borderBottom:"2px solid #eee"}}>
      {["Product","Category","Unit","Lbs / Unit"].map(h => (
        <th key={h} style={{padding:"9px 12px",textAlign:"left",fontSize:11,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:.5}}>{h}</th>
      ))}
    </tr>
  );

  const ProductTable = ({ prods, headerBg, headerLabel, unsetOpen, setUnsetOpen }) => {
    const set   = prods.filter(p => hasWeight(p));
    const unset = prods.filter(p => !hasWeight(p));
    return (
      <div style={{background:"#fff",borderRadius:14,border:"1px solid #eee",overflow:"hidden",marginBottom:24}}>
        <div style={{background:headerBg,color:"#fff",padding:"12px 16px",
          display:"flex",alignItems:"center",gap:8,fontSize:13,fontWeight:700}}>
          {headerLabel}
          <span style={{background:"rgba(255,255,255,0.15)",borderRadius:20,padding:"2px 10px",fontSize:11}}>
            {set.length}/{prods.length} set
          </span>
        </div>
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead>{colHeaders}</thead>
          <tbody>
            {set.map(p => <WeightRow key={p.id} p={p}/>)}
            {set.length === 0 && unset.length > 0 && (
              <tr><td colSpan={4} style={{padding:"12px 16px",fontSize:13,color:"#bbb",fontStyle:"italic"}}>No weights set yet</td></tr>
            )}
          </tbody>
        </table>
        {unset.length > 0 && (
          <>
            <button onClick={() => setUnsetOpen(o => !o)}
              style={{width:"100%",textAlign:"left",padding:"10px 16px",fontSize:12,fontWeight:600,
                color:"#999",background:"#f8f8f8",border:"none",borderTop:"1px solid #eee",
                cursor:"pointer",display:"flex",alignItems:"center",gap:6}}>
              <span style={{fontSize:10,display:"inline-block",transform:unsetOpen?"rotate(90deg)":"rotate(0deg)",transition:"transform .15s"}}>▶</span>
              {unset.length} not set
            </button>
            {unsetOpen && (
              <table style={{width:"100%",borderCollapse:"collapse"}}>
                <tbody>
                  {unset.map(p => <WeightRow key={p.id} p={p}/>)}
                </tbody>
              </table>
            )}
          </>
        )}
      </div>
    );
  };

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:20,flexWrap:"wrap",gap:12}}>
        <div>
          <h3 style={{fontFamily:"'Playfair Display',serif",fontSize:20,marginBottom:4}}>⚖️ Product Weights</h3>
          <div style={{fontSize:13,color:"#888"}}>
            Set lbs-per-unit for each product. Used to calculate monthly poundage produced/sold for overhead allocation.
          </div>
        </div>
        {hasEdits && (
          <button onClick={handleSave}
            style={{background:"#27AE60",color:"#fff",border:"none",borderRadius:9,
              padding:"10px 20px",fontSize:13,fontWeight:700,cursor:"pointer"}}>
            💾 Save Weights
          </button>
        )}
      </div>

      <ProductTable prods={factoryProds} headerBg="#1a1a1a"
        headerLabel="🏭 Factory-Produced Items"
        unsetOpen={factoryUnsetOpen} setUnsetOpen={setFactoryUnsetOpen}/>

      <ProductTable prods={otherProds} headerBg="#555"
        headerLabel="🛒 Other / Resell Items"
        unsetOpen={otherUnsetOpen} setUnsetOpen={setOtherUnsetOpen}/>

      {hasEdits && (
        <div style={{marginTop:4,display:"flex",justifyContent:"flex-end"}}>
          <button onClick={handleSave}
            style={{background:"#27AE60",color:"#fff",border:"none",borderRadius:9,
              padding:"10px 24px",fontSize:14,fontWeight:700,cursor:"pointer"}}>
            💾 Save Weights
          </button>
        </div>
      )}
    </div>
  );
}

// ── BackupPanel ──────────────────────────────────────────────────────────────
function BackupPanel({ users, products, restaurants, parLevels, orders=[],
  closingReports=[], factoryInventory={}, factoryLogs=[], prepStaff=[], prepTasks=[],
  prepTemplates={}, prepDailyAssignments={}, prepTimestamps=[], productionHidden={},
  hiddenItems={}, customCats=[], catVisibility={}, showToast }) {

  const [lastExport, setLastExport] = useState(null);
  const [importText, setImportText] = useState("");
  const [importError, setImportError] = useState("");
  const [confirmRestore, setConfirmRestore] = useState(false);

  const restoreFromFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      try {
        const backup = JSON.parse(ev.target.result);
        const d = backup.data || backup;
        if (!d.users || !d.products) {
          showToastProp("❌ Invalid backup file");
          return;
        }
        if (!window.confirm(`Restore backup from ${backup.exportedAt ? new Date(backup.exportedAt).toLocaleString() : "unknown date"}?\n\nThis will overwrite ALL current data.`)) return;
        // Restore each field
        const fields = ['users','products','restaurants','parLevels','customCats',
          'hiddenItems','inventory','orders','factoryInventory','factoryLogs',
          'prepStaff','prepTasks','prepTemplates','prepDailyAssignments','prepTimestamps',
          'closingReports','catVisibility','productionHidden'];
        fields.forEach(field => {
          if (d[field] !== undefined) {
            const [col, docId] = "kitchenlink/data".split("/");
            import("firebase/firestore").then(({doc, setDoc, getFirestore}) => {
              const db = getFirestore();
              setDoc(doc(db, col, docId), { [field]: d[field] }, { merge: true });
            });
          }
        });
        showToastProp("✓ Restore initiated — reload in 5 seconds");
        setTimeout(() => window.location.reload(), 5000);
      } catch(err) {
        showToastProp("❌ Failed to parse backup: " + err.message);
      }
    };
    reader.readAsText(file);
  };

  const exportData = () => {
    const snapshot = {
      exportedAt: new Date().toISOString(),
      exportedBy: "Admin",
      version: "VDumplingHQ-v6",
      data: {
        users, products, restaurants, parLevels,
        orders, closingReports,
        factoryInventory, factoryLogs,
        prepStaff, prepTasks, prepTemplates,
        prepDailyAssignments, prepTimestamps,
        productionHidden, hiddenItems, customCats, catVisibility,
      }
    };
    const json = JSON.stringify(snapshot, null, 2);
    const blob = new Blob([json], {type: "application/json"});
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    const date = new Date().toISOString().slice(0,10);
    a.href = url;
    a.download = `VDumplingHQ_Backup_${date}.json`;
    a.click();
    URL.revokeObjectURL(url);
    setLastExport(new Date().toLocaleString());
    showToast("✓ Backup downloaded");
  };

  const exportCSV = (key, data) => {
    if (!data || !data.length) { showToast("No data to export"); return; }
    const keys = Object.keys(data[0]);
    const rows = [keys.join(","), ...data.map(row =>
      keys.map(k => {
        const v = row[k];
        if (v === null || v === undefined) return "";
        const s = String(v).replace(/"/g, '""');
        return (s.includes(",") || s.includes('"')) ? ('"' + s + '"') : s;
      }).join(",")
    )];
    const blob = new Blob([rows.join("\n")], {type: "text/csv"});
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `VDumplingHQ_${key}_${new Date().toISOString().slice(0,10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
    showToast(`✓ ${key} CSV downloaded`);
  };

  const stats = [
    ["👤", "Users", users?.length||0],
    ["🏪", "Locations", restaurants?.length||0],
    ["🥟", "Products", products?.length||0],
    ["📦", "Orders", orders?.length||0],
    ["🧾", "Closing Reports", closingReports?.length||0],
    ["🏭", "Production Logs", factoryLogs?.length||0],
    ["📋", "Prep Tasks", prepTasks?.length||0],
  ];

  return (
    <div style={{maxWidth:600}}>
      <div style={{background:"#FFF9F0",border:"1px solid #F39C12",borderRadius:12,
        padding:"14px 18px",marginBottom:24,fontSize:13,color:"#92400E"}}>
        ⚠️ Always export a backup before making major changes. Backups include all users,
        locations, products, orders, par levels, and production data.
      </div>

      {/* Fresh install only */}
      <details style={{marginBottom:20}}>
        <summary style={{fontSize:12,color:"#aaa",cursor:"pointer",userSelect:"none"}}>
          🔧 Fresh install / Initialize empty database
        </summary>
        <div style={{background:"#fff0f0",border:"1px solid #E74C3C",borderRadius:10,
          padding:"14px 16px",marginTop:8}}>
          <div style={{fontSize:13,fontWeight:700,color:"#E74C3C",marginBottom:6}}>
            ⚠️ Only use this on a brand new empty database
          </div>
          <div style={{fontSize:12,color:"#666",marginBottom:12}}>
            This seeds default products, categories, and settings. It will NOT overwrite
            existing orders or users — but do not use it if you have real data.
          </div>
          <button onClick={()=>{
            if (!window.confirm("Are you sure? Only use this on a fresh empty database.")) return;
            const fields = {
              users: [], products: [], restaurants: [],
              parLevels: {}, customCats: [], hiddenItems: {}, inventory: {},
              orders: [], factoryInventory: {}, factoryLogs: [],
              prepStaff: [], prepTemplates: {}, prepDailyAssignments: {}, prepTimestamps: [],
            };
            Object.entries(fields).forEach(([k,v]) => saveField(k, v));
            showToast("Database initialized");
          }}
            style={{background:"#E74C3C",color:"#fff",border:"none",borderRadius:8,
              padding:"10px 20px",fontSize:13,fontWeight:700,cursor:"pointer"}}>
            Initialize Empty Database
          </button>
        </div>
      </details>

      {/* Current data stats */}
      <div style={{marginBottom:24}}>
        <div style={{fontSize:11,fontWeight:800,color:"#aaa",letterSpacing:1,marginBottom:12}}>
          CURRENT DATA SNAPSHOT
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8}}>
          {stats.map(([icon,label,count])=>(
            <div key={label} style={{background:"#fff",borderRadius:10,padding:"12px 14px",
              border:"1px solid #eee",textAlign:"center"}}>
              <div style={{fontSize:20}}>{icon}</div>
              <div style={{fontWeight:800,fontSize:20,color:"#1a1a1a"}}>{count}</div>
              <div style={{fontSize:11,color:"#aaa",marginTop:2}}>{label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Full backup */}
      <div style={{marginBottom:20}}>
        <div style={{fontSize:11,fontWeight:800,color:"#aaa",letterSpacing:1,marginBottom:10}}>
          FULL BACKUP (JSON)
        </div>
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px"}}>
          <div style={{fontWeight:700,fontSize:15,marginBottom:4}}>💾 Export All Data</div>
          <div style={{fontSize:12,color:"#888",marginBottom:14}}>
            Downloads a complete snapshot of all your data as a JSON file.
            Keep this somewhere safe — it can be used to restore if anything is lost.
          </div>
          {lastExport && (
            <div style={{fontSize:11,color:"#27AE60",fontWeight:600,marginBottom:10}}>
              ✓ Last export: {lastExport}
            </div>
          )}
          <button onClick={exportData}
            style={{background:"#1a1a1a",color:"#fff",border:"none",borderRadius:10,
              padding:"12px 24px",fontSize:14,fontWeight:700,cursor:"pointer",
              display:"flex",alignItems:"center",gap:8}}>
            💾 Download Full Backup
          </button>
        </div>
      </div>

      {/* Restore from backup */}
      <div style={{marginBottom:20}}>
        <div style={{fontSize:11,fontWeight:800,color:"#aaa",letterSpacing:1,marginBottom:10}}>
          RESTORE FROM BACKUP
        </div>
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",padding:"16px 18px"}}>
          <div style={{fontWeight:700,fontSize:15,marginBottom:4}}>🔄 Restore Data</div>
          <div style={{fontSize:12,color:"#888",marginBottom:14}}>
            Upload a previously downloaded backup JSON file to restore all data.
            This will overwrite current data — use with caution.
          </div>
          <label style={{display:"inline-block",background:"#E74C3C",color:"#fff",
            borderRadius:10,padding:"10px 20px",fontSize:13,fontWeight:700,cursor:"pointer"}}>
            📂 Upload Backup File
            <input type="file" accept=".json" onChange={restoreFromFile}
              style={{display:"none"}}/>
          </label>
        </div>
      </div>

      {/* CSV exports */}
      <div style={{marginBottom:20}}>
        <div style={{fontSize:11,fontWeight:800,color:"#aaa",letterSpacing:1,marginBottom:10}}>
          CSV EXPORTS
        </div>
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #eee",
          padding:"16px 18px",display:"flex",flexDirection:"column",gap:8}}>
          {[
            ["Orders", orders],
            ["Products", products],
            ["Users", users?.map(u=>({...u,password:undefined}))],
            ["Restaurants", restaurants],
            ["Production Logs", factoryLogs],
          ].map(([label, data])=>(
            <button key={label} onClick={()=>exportCSV(label, data)}
              style={{background:"#f5f5f5",border:"1px solid #e5e5e5",borderRadius:8,
                padding:"10px 14px",fontSize:13,fontWeight:600,cursor:"pointer",
                textAlign:"left",color:"#1a1a1a"}}>
              📊 Export {label} as CSV
            </button>
          ))}
        </div>
      </div>

      {/* Safety info */}
      <div style={{background:"#f0f8ff",border:"1px solid #2471A3",borderRadius:12,
        padding:"14px 18px",fontSize:12,color:"#1A5276"}}>
        <div style={{fontWeight:800,marginBottom:8}}>💡 Backup Best Practices</div>
        <div style={{display:"flex",flexDirection:"column",gap:4}}>
          <div>• Export a full backup weekly, or before any major changes</div>
          <div>• Save backups to Google Drive or email them to yourself</div>
          <div>• Orders and production logs grow over time — export monthly CSVs for accounting</div>
          <div>• If data ever disappears, contact your developer with the backup file to restore</div>
        </div>
      </div>
    </div>
  );
}

// ── ProductionAssignPanel ──────────────────────────────────────────────────────
function ProductionAssignPanel({ users, products, saveUsers }) {
  const [expandedUser, setExpandedUser] = useState(null);
  const allDepts = [
    {id:"dumplings",label:"Dumpling Production",icon:"🥟",cats:["Frozen Dumplings","Buns","Doughs"]},
    {id:"vegetables",label:"Vegetable Production",icon:"🥬",cats:["Vegetables","Sides"]},
    {id:"sauces",label:"Sauce Production",icon:"🫙",cats:["Sauces"]},
    {id:"meats",label:"Meat Production",icon:"🥩",cats:["Meats","Soup"]},
    {id:"other",label:"Other Goods",icon:"📦",cats:["Paper Goods"]},
  ];
  const productionUsers = (users||[]).filter(u=>u.role==="production"||u.role==="kitchen");

  return (
    <div>
      <div style={{fontSize:12,color:"#aaa",marginBottom:16}}>
        Select items each production staff member is responsible for recording daily.
        Leave all unchecked and they see everything in their assigned departments.
      </div>
      {productionUsers.length===0 && (
        <div style={{color:"#aaa",textAlign:"center",padding:40,fontSize:13}}>
          No production users yet. Add users with Factory or Production role in the Users tab.
        </div>
      )}
      <div style={{display:"flex",flexDirection:"column",gap:10}}>
        {productionUsers.map(u=>{
          const isExpanded = expandedUser===u.id;
          const assignedCount = (u.productionItems||[]).length;
          const userDepts = allDepts.filter(d=>
            !(u.departments||[]).length || (u.departments||[]).includes(d.id)
          );
          return (
            <div key={u.id} style={{background:"#fff",borderRadius:12,
              border:"1px solid #eee",overflow:"hidden"}}>
              <button onClick={()=>setExpandedUser(isExpanded?null:u.id)}
                style={{width:"100%",border:"none",cursor:"pointer",background:"#fff",
                  padding:"14px 16px",display:"flex",alignItems:"center",gap:12,textAlign:"left"}}>
                <div style={{width:36,height:36,borderRadius:"50%",flexShrink:0,
                  background:"#1a1a1a",display:"flex",alignItems:"center",
                  justifyContent:"center",color:"#fff",fontWeight:700,fontSize:16}}>
                  {u.name.charAt(0).toUpperCase()}
                </div>
                <div style={{flex:1}}>
                  <div style={{fontWeight:700,fontSize:15}}>{u.name}</div>
                  <div style={{fontSize:12,color:"#888",marginTop:2}}>
                    {u.role==="kitchen"?"🏭 Factory":"🥟 Production"}
                    {(u.departments||[]).length>0&&` . ${(u.departments||[]).map(d=>allDepts.find(x=>x.id===d)?.icon||"").join(" ")}`}
                  </div>
                </div>
                <div style={{fontSize:12,fontWeight:700,
                  color:assignedCount>0?"#27AE60":"#aaa",marginRight:8}}>
                  {assignedCount>0?`${assignedCount} items assigned`:"All items"}
                </div>
                <span style={{color:"#bbb",fontSize:16,
                  transform:isExpanded?"rotate(90deg)":"none",transition:"transform .2s"}}>›</span>
              </button>

              {isExpanded && (
                <div style={{borderTop:"1px solid #f0f0f0",padding:16}}>
                  <div style={{fontSize:12,color:"#888",marginBottom:12}}>
                    Check items this person records each day.
                  </div>
                  {userDepts.map(dept=>{
                    const deptProds = (products||[]).filter(p=>dept.cats.includes(p.category));
                    if (!deptProds.length) return null;
                    return (
                      <div key={dept.id} style={{marginBottom:14}}>
                        <div style={{fontSize:11,fontWeight:800,color:"#555",
                          letterSpacing:1,marginBottom:6,display:"flex",alignItems:"center",gap:5}}>
                          <span>{dept.icon}</span>
                          <span>{dept.label.toUpperCase()}</span>
                        </div>
                        <div style={{display:"flex",flexDirection:"column",gap:3}}>
                          {deptProds.map(p=>{
                            const assigned=(u.productionItems||[]).includes(p.id);
                            return (
                              <label key={p.id}
                                onClick={()=>{
                                  const curr=u.productionItems||[];
                                  const next=assigned?curr.filter(id=>id!==p.id):[...curr,p.id];
                                  saveUsers(users.map(x=>x.id===u.id?{...x,productionItems:next}:x));
                                }}
                                style={{display:"flex",alignItems:"center",gap:8,
                                  padding:"7px 10px",borderRadius:8,cursor:"pointer",
                                  background:assigned?"#f0faf4":"#fafafa",
                                  border:`1px solid ${assigned?"#27AE60":"#eee"}`}}>
                                <div style={{width:16,height:16,borderRadius:4,flexShrink:0,
                                  border:`2px solid ${assigned?"#27AE60":"#ccc"}`,
                                  background:assigned?"#27AE60":"transparent",
                                  display:"flex",alignItems:"center",justifyContent:"center"}}>
                                  {assigned&&<span style={{color:"#fff",fontSize:10,fontWeight:900}}>✓</span>}
                                </div>
                                <span style={{fontSize:13,fontWeight:500,flex:1}}>{p.name}</span>
                                <span style={{fontSize:11,color:"#aaa"}}>{p.unit}</span>
                                {p.internal&&<span style={{fontSize:9,color:"#8E44AD",fontWeight:700,
                                  background:"#f5f0ff",borderRadius:3,padding:"1px 4px"}}>INT</span>}
                              </label>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                  <button onClick={()=>{
                    saveUsers(users.map(x=>x.id===u.id?{...x,productionItems:[]}:x));
                  }} style={{fontSize:11,color:"#E74C3C",background:"none",border:"none",
                    cursor:"pointer",marginTop:4,fontWeight:600}}>
                    Clear all assignments
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function SettingsTab({ products, setProducts, restaurants, setRestaurants, parLevels, setParLevels, customCats, setCustomCats, hiddenItems, saveHiddenItems, catVisibility, saveCatVisibility, catOrder=[], saveCatOrder, saveField, users, setUsers, t, pName, orders=[], saveOrders, closingReports=[], factoryInventory={}, factoryLogs=[], prepStaff=[], prepTasks=[], prepTemplates={}, prepDailyAssignments={}, prepTimestamps=[], productionHidden={}, inventoryAddOns=[], saveInventoryAddOns, showToast: showToastProp }) {
  const [section, setSection]       = useState("items");
  const [itemSubTab, setItemSubTab] = useState("products"); // products | categories | pars
  const [search, setSearch]         = useState("");
  const [editProduct, setEditProduct] = useState(null);
  const [editBranch, setEditBranch]   = useState(null);
  const [parBranch, setParBranch]     = useState(restaurants[0]?.id || 1);
  const [toast, setToast]             = useState("");

  const [editCatName, setEditCatName] = useState("");
  const [editCatOld,  setEditCatOld]  = useState(null);
  const [expandedCat, setExpandedCat] = useState(null);
  const [editUser,    setEditUser]    = useState(null); // null = new, string = editing existing

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(""), 2500); };

  // Build CATS: respect saved order, append any new cats alphabetically at end
  const ALL_CATS_SET = [...new Set([...products.map(p => p.category), ...customCats])];
  const CATS = [
    ...catOrder.filter(c => ALL_CATS_SET.includes(c)),
    ...ALL_CATS_SET.filter(c => !catOrder.includes(c)).sort(),
  ];

  const [dragCat,     setDragCat]     = useState(null); // cat name being dragged
  const [dragOverCat, setDragOverCat] = useState(null); // cat name hovered over

  // ── Save helpers (write to Firebase via props) ──
  const saveProducts   = (p) => { setProducts(p);    saveField("products", p); };
  const saveCategories = (c) => { setCustomCats(c);  saveField("customCats", c); };
  const saveUsers      = (u) => {
    // Guard: never save fewer users than currently in Firebase (prevents accidental wipe)
    if (u.length === 0) { console.warn("VDumplingHQ: Blocked empty users save"); return; }
    setUsers(u);
    saveField("users", u);
  };
  const toggleHidden   = (restId, prodId) => {
    const current = hiddenItems[restId] || [];
    const updated = current.includes(prodId)
      ? { ...hiddenItems, [restId]: current.filter(id => id !== prodId) }
      : { ...hiddenItems, [restId]: [...current, prodId] };
    saveHiddenItems(updated);
  };
  const isHidden = (restId, prodId) => (hiddenItems[restId] || []).includes(prodId);
  const saveRestaurants= (r) => { setRestaurants(r);  saveField("restaurants", r); };
  const savePars       = (pl) => { setParLevels(pl);  saveField("parLevels", pl); };

  // ── Item handlers ──
  const handleSaveProduct = (prod) => {
    // Resolve __new__ category
    const finalCat = prod.category === "__new__" ? (prod.newCategory||"").trim() : prod.category;
    if (!finalCat) { alert("Please enter a category name"); return; }
    const cleanProd = {...prod, category: finalCat};
    delete cleanProd.newCategory;
    // If it's a brand new category name, save it to customCats too
    if (!CATS.includes(finalCat) && !customCats.includes(finalCat)) {
      saveCategories([...customCats, finalCat]);
    }
    const updated = cleanProd.id
      ? products.map(p => p.id === cleanProd.id ? cleanProd : p)
      : [...products, { ...cleanProd, id: Date.now() }];
    saveProducts(updated);
    setEditProduct(null);
    showToast(cleanProd.id ? "Item updated ✓" : "Item added ✓");
  };
  const handleDeleteProduct = (id) => {
    if (!window.confirm("Remove this item?")) return;
    saveProducts(products.filter(p => p.id !== id));
    showToast("Item removed");
  };

  // ── Branch handlers ──
  const handleSaveBranch = (branch) => {
    const updated = branch.id
      ? restaurants.map(r => r.id === branch.id ? branch : r)
      : [...restaurants, { ...branch, id: Date.now() }];
    saveRestaurants(updated);
    setEditBranch(null);
    showToast(branch.id ? "Location updated ✓" : "Location added ✓");
  };
  const handleDeleteBranch = (id) => {
    if (!window.confirm("Remove this location? This cannot be undone.")) return;
    saveRestaurants(restaurants.filter(r => r.id !== id));
    showToast("Location removed");
  };

  // ── Category handlers ──
  const handleAddCategory = () => {
    const name = editCatName.trim();
    if (!name) return;
    if (CATS.includes(name)) { alert("Category already exists"); return; }
    saveCategories([...customCats, name]);
    setEditCatName("");
    showToast("Category added ✓");
  };
  const handleRenameCategory = () => {
    const newName = editCatName.trim();
    if (!newName || !editCatOld) return;
    // Rename in all products
    const updatedProducts = products.map(p =>
      p.category === editCatOld ? {...p, category: newName} : p
    );
    saveProducts(updatedProducts);
    saveCategories(customCats.map(c => c === editCatOld ? newName : c));
    setEditCatOld(null);
    setEditCatName("");
    showToast("Category renamed ✓");
  };
  const handleDeleteCategory = (cat) => {
    const count = products.filter(p => p.category === cat).length;
    if (count > 0) { alert(`Cannot delete — ${count} item(s) are in this category. Reassign them first.`); return; }
    if (!window.confirm(`Delete category "${cat}"?`)) return;
    saveCategories(customCats.filter(c => c !== cat));
    showToast("Category deleted");
  };

  // ── User handlers ──
  const handleSaveUser = (user) => {
    if (!user.name.trim())     { alert("Name is required"); return; }
    if (!user.username.trim()) { alert("Username is required"); return; }
    const isNew = !user.id;
    if (isNew && !user.pin.trim()) { alert("Password is required"); return; }
    if (user.role === "manager" && (!user.branchIds || user.branchIds.length === 0)) { alert("Please assign at least one location"); return; }
    const dup = users.find(u => u.username.toLowerCase() === user.username.toLowerCase() && u.id !== user.id);
    if (dup) { alert("That username is already taken"); return; }
    const saved = (!isNew && !user.pin.trim()) ? {...user, username: user.username.trim().toLowerCase(), pin: users.find(u=>u.id===user.id)?.pin||""} : {...user, username: user.username.trim().toLowerCase(), pin: user.pin.trim()};
    // keep branchId for backwards compat (first location)
    const withBranch = {...saved, branchId: (saved.branchIds||[])[0]||null};
    const updated = isNew ? [...users, {...withBranch, id: Date.now()}] : users.map(u => u.id === withBranch.id ? withBranch : u);
    saveUsers(updated);
    setEditUser(null);
    showToast(isNew ? "User added ✓" : "User updated ✓");
  };
  const handleDeleteUser = (id) => {
    if (users.length <= 1) { showToast("Cannot delete the last user"); return; }
    if (!window.confirm("Remove this user?")) return;
    saveUsers(users.filter(u => u.id !== id));
    showToast("User removed");
  };

  // ── Par level handler ──
  const handleParChange = (branchId, productId, value) => {
    const updated = {
      ...parLevels,
      [String(branchId)]: {
        ...(parLevels[String(branchId)] || parLevels[branchId] || {}),
        [String(productId)]: { par: Math.max(0, parseInt(value) || 0) }
      }
    };
    savePars(updated);
  };

  const filtered = products.filter(p =>
    p.name.toLowerCase().includes(search.toLowerCase()) ||
    (p.nameZh||"").includes(search) ||
    p.category.toLowerCase().includes(search.toLowerCase())
  );
  const grouped = CATS.reduce((acc, cat) => {
    const items = filtered.filter(p => p.category === cat);
    acc[cat] = items; // show all categories, even empty ones
    return acc;
  }, {});

  const NAV = [
    { key:"items",      icon:"🏷",  label:"Items" },
    { key:"locations",  icon:"📍", label:"Locations" },
    { key:"users",      icon:"👤", label:"Users" },
    { key:"ordering",   icon:"🛒", label:"Ordering" },
    { key:"production", icon:"🥟", label:"Production" },
    { key:"weights",    icon:"⚖️",  label:"Weights" },
    { key:"backup",     icon:"💾", label:"Backup" },
  ];

  const sectionBtnStyle = (key) => ({
    flex:1, border:"none", borderRadius:10, padding:"11px 6px",
    fontWeight:700, fontSize:13, cursor:"pointer",
    fontFamily:"'IBM Plex Sans',sans-serif",
    background: section===key ? "#1a1a1a" : "#f0f0f0",
    color: section===key ? "#fff" : "#555",
    transition:"all .15s",
  });

  return (
    <div>
      {/* Toast */}
      {toast && (
        <div style={{position:"fixed",top:20,right:20,background:"#1a1a1a",color:"#fff",
          padding:"10px 18px",borderRadius:10,fontSize:13,fontWeight:700,zIndex:9999,
          boxShadow:"0 4px 20px rgba(0,0,0,.3)"}}>
          {toast}
        </div>
      )}

      {/* Section nav — Sidebar + Content wrapper */}
      <div style={{display:"flex",gap:16,alignItems:"flex-start"}}>
        <div style={{width:150,flexShrink:0,display:"flex",flexDirection:"column",gap:3,
          background:"#fff",borderRadius:14,padding:"8px",
          border:"1px solid #eee",boxShadow:"0 2px 8px rgba(0,0,0,0.04)",
          position:"sticky",top:68,alignSelf:"flex-start"}}>
          {NAV.map(n => (
            <button key={n.key} onClick={() => setSection(n.key)}
              style={{display:"flex",alignItems:"center",gap:8,padding:"9px 10px",
                borderRadius:9,border:"none",cursor:"pointer",textAlign:"left",width:"100%",
                background:section===n.key?"#1a1a1a":"transparent",
                color:section===n.key?"#fff":"#555",
                fontWeight:section===n.key?700:500,fontSize:13,
                fontFamily:"'IBM Plex Sans',sans-serif",transition:"all .15s"}}>
              <span>{n.icon}</span>
              <span>{n.label}</span>
            </button>
          ))}
        </div>
        <div style={{flex:1,minWidth:0}}>

      {/* ══ ITEMS & PRICES ══ */}
      {section === "items" && (
        <div style={{display:"flex",gap:4,marginBottom:16,background:"#f0f0f0",
          borderRadius:10,padding:3,width:"fit-content"}}>
          {[["products","🏷 Items & Prices"],["categories","🗂 Categories"],["pars","📊 Par Levels"]].map(([k,l])=>(
            <button key={k} onClick={()=>setItemSubTab(k)}
              style={{border:"none",borderRadius:8,padding:"7px 14px",fontSize:12,fontWeight:700,
                cursor:"pointer",background:itemSubTab===k?"#1a1a1a":"transparent",
                color:itemSubTab===k?"#fff":"#666"}}>
              {l}
            </button>
          ))}
        </div>
      )}
      {section === "items" && itemSubTab === "products" && (
        <div>
          <div style={{display:"flex",gap:10,marginBottom:16,flexWrap:"wrap"}}>
            <input value={search} onChange={e=>setSearch(e.target.value)}
              placeholder="Search items..." style={{flex:1,minWidth:180,
              border:"1px solid #e5e5e5",borderRadius:9,padding:"9px 13px",
              fontSize:14,fontFamily:"'IBM Plex Sans',sans-serif",outline:"none"}} />
            <button onClick={()=>setEditProduct({name:"",nameZh:"",category:CATS[0]||"",unit:"",price:null})}
              style={{background:"#1a1a1a",color:"#fff",border:"none",borderRadius:9,
              padding:"9px 16px",fontWeight:700,fontSize:13,cursor:"pointer",
              fontFamily:"'IBM Plex Sans',sans-serif",whiteSpace:"nowrap"}}>
              + Add Item
            </button>
            {!products.some(p=>p.category==="Drinks") && (
              <button onClick={()=>{
                const DRINKS = [
                  {name:"Taro Tea Powder",        nameZh:"芋頭茶粉",        unit:"bag",        price:14.50},
                  {name:"Thai Tea Powder",         nameZh:"泰式茶粉",        unit:"bag",        price:14.50},
                  {name:"Milk Tea Powder",         nameZh:"奶茶粉",          unit:"bag",        price:14.00},
                  {name:"Almond Tea Powder",       nameZh:"杏仁茶粉",        unit:"bag",        price:14.50},
                  {name:"Coconut Tea Powder",      nameZh:"椰子茶粉",        unit:"bag",        price:14.50},
                  {name:"Honeydew Tea Powder",     nameZh:"蜜瓜茶粉",        unit:"bag",        price:14.50},
                  {name:"Matcha Powder",           nameZh:"抹茶粉",          unit:"bag",        price:13.50},
                  {name:"Mocha Tea Powder",        nameZh:"摩卡茶粉",        unit:"bag",        price:14.50},
                  {name:"Non Dairy Creamer",       nameZh:"植脂末",          unit:"bag",        price:7.50},
                  {name:"Green Tea",               nameZh:"綠茶",            unit:"bag",        price:14.50},
                  {name:"Black Tea",               nameZh:"紅茶",            unit:"bag",        price:11.50},
                  {name:"Fructose",                nameZh:"果糖",            unit:"jug",        price:15.50},
                  {name:"Juice Box",               nameZh:"果汁盒",          unit:"case",       price:14.50},
                  {name:"Passionfruit Syrup",      nameZh:"百香果糖漿",      unit:"bottle",     price:32.00},
                  {name:"Peach Syrup",             nameZh:"桃子糖漿",        unit:"bottle",     price:32.00},
                  {name:"Mango Syrup",             nameZh:"芒果糖漿",        unit:"bottle",     price:32.00},
                  {name:"Lychee Syrup",            nameZh:"荔枝糖漿",        unit:"bottle",     price:32.00},
                  {name:"Strawberry Syrup",        nameZh:"草莓糖漿",        unit:"bottle",     price:32.00},
                  {name:"Mango Pop Boba",          nameZh:"芒果爆爆珠",      unit:"bag",        price:19.50},
                  {name:"Lychee Pop Boba",         nameZh:"荔枝爆爆珠",      unit:"bag",        price:19.50},
                  {name:"Strawberry Pop Boba",     nameZh:"草莓爆爆珠",      unit:"bag",        price:19.50},
                  {name:"Honey",                   nameZh:"蜂蜜",            unit:"bottle",     price:19.00},
                  {name:"Ginger Honey",            nameZh:"薑蜜",            unit:"jar",        price:10.00},
                  {name:"Citron Honey",            nameZh:"柚子蜜",          unit:"jar",        price:10.00},
                  {name:"Bubble (6 bags/Case)",    nameZh:"珍珠粉圓（6袋/箱）",unit:"case",    price:10.00},
                  {name:"Clear Cup 22oz (50 ct)",  nameZh:"透明杯22oz（50個）",unit:"pack",     price:5.00},
                  {name:"Cold Cup 16oz",           nameZh:"冷飲杯16oz",      unit:"pack",       price:6.50},
                  {name:"Hot Cup 12oz (20 ct)",    nameZh:"熱飲杯12oz（20個）",unit:"pack",     price:5.00},
                  {name:"Hot Cup Dome Lids (20 ct)",nameZh:"熱飲蓋（20個）", unit:"pack",       price:3.00},
                  {name:"BBT Straws (50 ct)",      nameZh:"珍珠奶茶吸管（50根）",unit:"pack",   price:2.00},
                  {name:"Clear Straws (24 ct)",    nameZh:"透明吸管（24根）",unit:"pack",       price:3.00},
                  {name:"Plastic Sealing Roll",    nameZh:"封口膜",          unit:"roll",       price:47.00},
                  {name:"Hot Coffee Cup 16oz",     nameZh:"熱咖啡杯16oz",    unit:"pack",       price:4.50},
                  {name:"Cold Cup Lid 16/22oz (40 ct)",nameZh:"冷飲蓋（40個）",unit:"pack",     price:2.00},
                  {name:"Poland Spring Water (40 ct)",nameZh:"Poland Spring水（40瓶）",unit:"case",price:9.00},
                  {name:"Seltzer Water (24 ct)",   nameZh:"氣泡水（24瓶）",  unit:"case",       price:15.50},
                  {name:"Lemonade (2-pack)",       nameZh:"檸檬水（2入）",   unit:"set",        price:8.00},
                  {name:"Root Beer (24 ct)",       nameZh:"根汁汽水（24瓶）",unit:"case",       price:15.50},
                  {name:"Soda (24 ct)",            nameZh:"汽水（24瓶）",    unit:"case",       price:19.00},
                  {name:"Ginger Ale (24 ct)",      nameZh:"薑汁汽水（24瓶）",unit:"case",       price:16.00},
                  {name:"Clear Cup Costco",        nameZh:"透明杯（Costco）",unit:"pack",       price:16.00},
                  {name:"Sapporo",                 nameZh:"札幌啤酒",        unit:"case",       price:33.00},
                  {name:"Coke / Diet Coke (35 ct)",nameZh:"可口可樂（35瓶）",unit:"case",       price:27.50},
                  {name:"Polar Seltzer (24 ct)",   nameZh:"Polar氣泡水（24瓶）",unit:"case",    price:13.00},
                  {name:"Jasmine Tea (case)",      nameZh:"茉莉花茶（箱）",  unit:"case",       price:22.50},
                  {name:"Apple Juice Costco (case)",nameZh:"蘋果汁（箱）",   unit:"case",       price:14.50},
                  {name:"Snapple Peach/Lemon/Kiwi (24 ct)",nameZh:"Snapple茶飲（24瓶）",unit:"case",price:25.00},
                  {name:"Snapple Mango/Orangeade (24 ct)",nameZh:"Snapple芒果柳橙（24瓶）",unit:"case",price:28.50},
                  {name:"Dr Pepper (35 ct)",       nameZh:"胡椒博士（35瓶）",unit:"case",       price:25.00},
                ];
                const now = Date.now();
                const newProds = DRINKS.map((d,i)=>({...d, id:now+i, category:"Drinks"}));
                saveProducts([...products, ...newProds]);
                showToast(`${newProds.length} drink items added ✓`);
              }} style={{background:"#2471A3",color:"#fff",border:"none",borderRadius:9,
                padding:"9px 16px",fontWeight:700,fontSize:13,cursor:"pointer",
                fontFamily:"'IBM Plex Sans',sans-serif",whiteSpace:"nowrap"}}>
                🥤 Add Drinks Catalog
              </button>
            )}
          </div>

          {Object.entries(grouped).map(([cat, items]) => (
            <div key={cat} style={{marginBottom:18}}>
              <div style={{fontSize:11,fontWeight:700,color:"#aaa",textTransform:"uppercase",
                letterSpacing:.8,marginBottom:8,paddingLeft:2}}>
                {cat} . {items.length} items
              </div>
              <div style={{background:"#fff",border:"1px solid #e5e5e5",borderRadius:12,overflow:"hidden"}}>
                {items.length === 0 && (
                  <div style={{padding:"14px 16px",color:"#bbb",fontSize:13,fontStyle:"italic",
                    display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                    No items yet
                    <button onClick={()=>setEditProduct({name:"",nameZh:"",category:cat,unit:"",price:null})}
                      style={{background:"#f0f0f0",border:"none",borderRadius:7,padding:"5px 12px",
                      fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"'IBM Plex Sans',sans-serif",color:"#555"}}>
                      + Add Item
                    </button>
                  </div>
                )}
                {items.map((p, i) => (
                  <div key={p.id} style={{display:"flex",alignItems:"center",gap:12,
                    padding:"11px 14px",
                    borderBottom: i<items.length-1 ? "1px solid #f0f0f0" : "none",
                    background: i%2===0?"#fff":"#fafafa"}}>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontWeight:700,fontSize:13,color:"#1a1a1a"}}>{p.name}</div>
                      <div style={{fontSize:11,color:"#bbb",marginTop:1}}>
                        {p.nameZh && <span style={{marginRight:8}}>{p.nameZh}</span>}
                        {p.unit}
                        {p.price != null
                          ? <span style={{marginLeft:8,color:"#555"}}>${p.price.toFixed(2)}</span>
                          : <span style={{marginLeft:8,color:"#F39C12",fontStyle:"italic"}}>Market Price</span>}
                      </div>
                    </div>
                    <button onClick={()=>setEditProduct({...p})}
                      style={{background:"#f0f0f0",border:"none",borderRadius:7,padding:"6px 12px",
                      fontSize:12,fontWeight:700,cursor:"pointer",color:"#555",
                      fontFamily:"'IBM Plex Sans',sans-serif"}}>Edit</button>
                    <button onClick={()=>handleDeleteProduct(p.id)}
                      style={{background:"#FEE2E2",border:"none",borderRadius:7,padding:"6px 10px",
                      fontSize:12,fontWeight:700,cursor:"pointer",color:"#C0392B",
                      fontFamily:"'IBM Plex Sans',sans-serif"}}>✕</button>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ══ CATEGORIES ══ */}
      {section === "items" && itemSubTab === "categories" && (() => {
        const toggleCatLocation = (cat, restId) => {
          const hidden = catVisibility[restId] || [];
          const next = hidden.includes(cat)
            ? hidden.filter(c => c !== cat)
            : [...hidden, cat];
          saveCatVisibility({...catVisibility, [restId]: next});
        };
        return (
        <div>
          <div style={{marginBottom:20}}>
            <div style={{fontSize:12,color:"#aaa",marginBottom:14}}>
              Add or rename categories. Click a category to choose which locations it appears in.
            </div>

            {/* Add / Edit form */}
            <div style={{background:"#f8f8f8",borderRadius:12,padding:"16px 18px",marginBottom:20}}>
              <div style={{fontSize:11,fontWeight:700,color:"#888",textTransform:"uppercase",
                letterSpacing:.5,marginBottom:10}}>
                {editCatOld ? `Renaming: "${editCatOld}"` : "Add New Category"}
              </div>
              <div style={{display:"flex",gap:8}}>
                <input
                  value={editCatName}
                  onChange={e=>setEditCatName(e.target.value)}
                  onKeyDown={e=>e.key==="Enter"&&(editCatOld?handleRenameCategory():handleAddCategory())}
                  placeholder="Category name..."
                  style={{flex:1,border:"1px solid #e5e5e5",borderRadius:9,padding:"10px 13px",
                    fontSize:14,fontFamily:"'IBM Plex Sans',sans-serif",outline:"none"}}
                />
                {editCatOld && (
                  <button onClick={()=>{setEditCatOld(null);setEditCatName("");}}
                    style={{background:"#f0f0f0",border:"none",borderRadius:9,padding:"10px 14px",
                    fontWeight:700,fontSize:13,cursor:"pointer",color:"#888",
                    fontFamily:"'IBM Plex Sans',sans-serif"}}>Cancel</button>
                )}
                <button onClick={editCatOld ? handleRenameCategory : handleAddCategory}
                  style={{background:"#1a1a1a",color:"#fff",border:"none",borderRadius:9,
                  padding:"10px 16px",fontWeight:700,fontSize:13,cursor:"pointer",
                  fontFamily:"'IBM Plex Sans',sans-serif",whiteSpace:"nowrap"}}>
                  {editCatOld ? "Save Rename" : "+ Add"}
                </button>
              </div>
            </div>

            {/* Category list */}
            <div style={{background:"#fff",border:"1px solid #e5e5e5",borderRadius:12,overflow:"hidden"}}>
              {CATS.map((cat, i) => {
                const count = products.filter(p=>p.category===cat).length;
                const isExpanded = expandedCat === cat;
                const visibleAt = restaurants.filter(r => !(catVisibility[r.id]||[]).includes(cat));
                const hiddenAt  = restaurants.filter(r =>  (catVisibility[r.id]||[]).includes(cat));
                const isDragging = dragCat === cat;
                const isDragOver = dragOverCat === cat;
                return (
                  <div key={cat}
                    draggable
                    onDragStart={()=>{ setDragCat(cat); }}
                    onDragEnd={()=>{ setDragCat(null); setDragOverCat(null); }}
                    onDragOver={e=>{ e.preventDefault(); if(cat!==dragCat) setDragOverCat(cat); }}
                    onDragLeave={()=>{ if(dragOverCat===cat) setDragOverCat(null); }}
                    onDrop={e=>{ e.preventDefault();
                      if (!dragCat || dragCat===cat) return;
                      const newOrder = [...CATS];
                      const from = newOrder.indexOf(dragCat);
                      const to   = newOrder.indexOf(cat);
                      newOrder.splice(from, 1);
                      newOrder.splice(to, 0, dragCat);
                      saveCatOrder(newOrder);
                      setDragCat(null); setDragOverCat(null);
                    }}
                    style={{borderBottom:i<CATS.length-1?"1px solid #f0f0f0":"none",
                      opacity:isDragging?0.4:1,
                      background:isDragOver?"#f0f7ff":"transparent",
                      transition:"background .1s"}}>
                    {/* Main row */}
                    <div style={{display:"flex",alignItems:"center",gap:12,
                      padding:"12px 16px", background:isDragOver?"transparent":i%2===0?"#fff":"#fafafa",
                      cursor:"pointer"}}
                      onClick={()=>setExpandedCat(isExpanded ? null : cat)}>
                      {/* Drag handle */}
                      <div onMouseDown={e=>e.stopPropagation()}
                        style={{cursor:"grab",color:"#ccc",fontSize:14,
                          display:"flex",flexDirection:"column",gap:2,padding:"2px 0",flexShrink:0}}
                        title="Drag to reorder">
                        <div style={{width:14,height:2,background:"#ccc",borderRadius:1}}/>
                        <div style={{width:14,height:2,background:"#ccc",borderRadius:1}}/>
                        <div style={{width:14,height:2,background:"#ccc",borderRadius:1}}/>
                      </div>
                      <div style={{flex:1}}>
                        <div style={{fontWeight:700,fontSize:14,color:"#1a1a1a"}}>{cat}</div>
                        <div style={{fontSize:11,color:"#bbb",marginTop:1}}>
                          {count} item{count!==1?"s":""} .{" "}
                          {hiddenAt.length === 0
                            ? <span style={{color:"#22C55E"}}>All locations</span>
                            : hiddenAt.length === restaurants.length
                              ? <span style={{color:"#E74C3C"}}>Hidden everywhere</span>
                              : <span style={{color:"#F59E0B"}}>{visibleAt.length} of {restaurants.length} locations</span>
                          }
                        </div>
                      </div>
                      <div style={{display:"flex",gap:6,alignItems:"center"}}>
                        <button onClick={e=>{e.stopPropagation();setEditCatOld(cat);setEditCatName(cat);}}
                          style={{background:"#f0f0f0",border:"none",borderRadius:7,padding:"6px 12px",
                          fontSize:12,fontWeight:700,cursor:"pointer",color:"#555",
                          fontFamily:"'IBM Plex Sans',sans-serif"}}>Rename</button>
                        <button onClick={e=>{e.stopPropagation();handleDeleteCategory(cat);}}
                          style={{background:"#FEE2E2",border:"none",borderRadius:7,padding:"6px 10px",
                          fontSize:12,fontWeight:700,cursor:"pointer",color:"#C0392B",
                          fontFamily:"'IBM Plex Sans',sans-serif"}}>✕</button>
                        <span style={{color:"#ccc",fontSize:14,transition:"transform .2s",
                          display:"inline-block",transform:isExpanded?"rotate(90deg)":"rotate(0deg)"}}>›</span>
                      </div>
                    </div>
                    {/* Expanded: location toggles */}
                    {isExpanded && (
                      <div style={{background:"#f8f8f8",padding:"12px 16px 14px",
                        borderTop:"1px solid #f0f0f0"}}>
                        <div style={{fontSize:11,fontWeight:700,color:"#888",
                          textTransform:"uppercase",letterSpacing:.5,marginBottom:10}}>
                          Show in locations
                        </div>
                        <div style={{display:"flex",flexDirection:"column",gap:8}}>
                          {restaurants.map(r => {
                            const isVisible = !(catVisibility[r.id]||[]).includes(cat);
                            return (
                              <div key={r.id}
                                onClick={()=>toggleCatLocation(cat, r.id)}
                                style={{display:"flex",alignItems:"center",justifyContent:"space-between",
                                  background:"#fff",border:`1.5px solid ${isVisible ? r.color : "#e5e5e5"}`,
                                  borderRadius:10,padding:"10px 14px",cursor:"pointer",
                                  transition:"all .15s"}}>
                                <div style={{display:"flex",alignItems:"center",gap:10}}>
                                  <div style={{width:10,height:10,borderRadius:"50%",
                                    background:r.color,flexShrink:0}}/>
                                  <span style={{fontWeight:600,fontSize:13,color:"#1a1a1a"}}>{r.name}</span>
                                </div>
                                <div style={{
                                  width:20,height:20,borderRadius:6,border:`2px solid ${isVisible ? r.color : "#ccc"}`,
                                  background:isVisible ? r.color : "#fff",
                                  display:"flex",alignItems:"center",justifyContent:"center",
                                  flexShrink:0,transition:"all .15s"
                                }}>
                                  {isVisible && <span style={{color:"#fff",fontSize:12,fontWeight:800}}>✓</span>}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        );
      })()}

      {/* ══ PAR LEVELS ══ */}
      {section === "items" && itemSubTab === "pars" && (
        <div>
          {/* Branch picker */}
          <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap"}}>
            {restaurants.map(r => (
              <button key={r.id} onClick={()=>setParBranch(r.id)} style={{
                border:`2px solid ${parBranch===r.id ? r.color : "#e5e5e5"}`,
                background: parBranch===r.id ? r.color+"15" : "#fff",
                color: parBranch===r.id ? r.color : "#555",
                borderRadius:9,padding:"8px 16px",fontWeight:700,fontSize:13,
                cursor:"pointer",fontFamily:"'IBM Plex Sans',sans-serif",transition:"all .15s"
              }}>{r.name}</button>
            ))}
          </div>

          <div style={{fontSize:12,color:"#aaa",marginBottom:12}}>
            Tap any par number to edit it. Changes save instantly.
          </div>

          {CATS.map(cat => {
            const items = products.filter(p => p.category === cat);
            if (!items.length) return null;
            return (
              <div key={cat} style={{marginBottom:18}}>
                <div style={{fontSize:11,fontWeight:700,color:"#aaa",
                  textTransform:"uppercase",letterSpacing:.8,marginBottom:8,paddingLeft:2}}>
                  {cat}
                </div>
                <div style={{background:"#fff",border:"1px solid #e5e5e5",borderRadius:12,overflow:"hidden"}}>
                  {items.map((p,i) => {
                    const par = parLevels[parBranch]?.[p.id]?.par ?? 0;
                    return (
                      <div key={p.id} style={{display:"flex",alignItems:"center",gap:12,
                        padding:"10px 14px",
                        borderBottom: i<items.length-1?"1px solid #f0f0f0":"none",
                        background: i%2===0?"#fff":"#fafafa"}}>
                        <div style={{flex:1}}>
                          <div style={{fontWeight:600,fontSize:13}}>{p.name}</div>
                          <div style={{fontSize:11,color:"#bbb"}}>{p.unit}</div>
                        </div>
                        <div style={{display:"flex",alignItems:"center",gap:6}}>
                          <span style={{fontSize:11,color:"#aaa",fontWeight:600}}>Par:</span>
                          <button onClick={()=>handleParChange(parBranch,p.id,par-1)}
                            style={{width:26,height:26,borderRadius:6,border:"1px solid #ddd",
                            background:"#f5f5f5",fontWeight:700,fontSize:14,cursor:"pointer",color:"#555"}}>−</button>
                          <input type="number" min="0" value={par}
                            onChange={e=>handleParChange(parBranch,p.id,e.target.value)}
                            style={{width:52,textAlign:"center",border:"1.5px solid #ddd",
                            borderRadius:7,padding:"5px 2px",fontSize:15,fontWeight:700,
                            fontFamily:"'IBM Plex Sans',sans-serif",outline:"none"}} />
                          <button onClick={()=>handleParChange(parBranch,p.id,par+1)}
                            style={{width:26,height:26,borderRadius:6,border:"1px solid #ddd",
                            background:"#f5f5f5",fontWeight:700,fontSize:14,cursor:"pointer",color:"#555"}}>+</button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* ══ LOCATIONS ══ */}
      {section === "locations" && (
        <div>
          <div style={{display:"flex",justifyContent:"flex-end",marginBottom:16}}>
            <button onClick={()=>setEditBranch({name:"",color:"#C0392B",
              deliveryDays:["Monday","Thursday"],managerName:"",managerEmail:""})}
              style={{background:"#1a1a1a",color:"#fff",border:"none",borderRadius:9,
              padding:"9px 16px",fontWeight:700,fontSize:13,cursor:"pointer",
              fontFamily:"'IBM Plex Sans',sans-serif"}}>
              + Add Location
            </button>
          </div>

          <div style={{display:"flex",flexDirection:"column",gap:12}}>
            {restaurants.map(r => (
              <div key={r.id} style={{background:"#fff",border:`2px solid ${r.color}22`,
                borderRadius:14,padding:"16px 18px",display:"flex",
                alignItems:"center",gap:14,flexWrap:"wrap"}}>
                <div style={{width:12,height:12,borderRadius:"50%",background:r.color,flexShrink:0}}/>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontWeight:700,fontSize:15,color:"#1a1a1a"}}>{r.name}</div>
                  <div style={{fontSize:12,color:"#aaa",marginTop:2}}>
                    {r.managerName} . {r.deliveryDays.join(", ")}
                  </div>
                  <div style={{fontSize:11,color:"#bbb"}}>{r.managerEmail}</div>
                </div>
                <div style={{display:"flex",gap:8}}>
                  <button onClick={()=>setEditBranch({...r})}
                    style={{background:"#f0f0f0",border:"none",borderRadius:7,padding:"7px 14px",
                    fontSize:12,fontWeight:700,cursor:"pointer",color:"#555",
                    fontFamily:"'IBM Plex Sans',sans-serif"}}>Edit</button>
                  <button onClick={()=>handleDeleteBranch(r.id)}
                    style={{background:"#FEE2E2",border:"none",borderRadius:7,padding:"7px 10px",
                    fontSize:12,fontWeight:700,cursor:"pointer",color:"#C0392B",
                    fontFamily:"'IBM Plex Sans',sans-serif"}}>✕</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ══ EDIT PRODUCT MODAL ══ */}
      {editProduct && (
        <ProductEditModal
          product={editProduct}
          categories={CATS}
          onSave={handleSaveProduct}
          onClose={()=>setEditProduct(null)}
          restaurants={restaurants}
          hiddenItems={hiddenItems}
          toggleHidden={toggleHidden}
        />
      )}

      {/* ══ USERS ══ */}
      {section === "users" && (
        <div>
          <div style={{marginBottom:12,fontSize:12,color:"#aaa"}}>
            Managers see Inventory, History and Catering for their assigned location. Admins see everything including Settings.
          </div>
          <div style={{display:"flex",justifyContent:"flex-end",marginBottom:16}}>
            <button onClick={()=>setEditUser({name:"",username:"",pin:"",role:"manager",branchId:restaurants[0]?.id||null,canSettings:false})}
              style={{background:"#1a1a1a",color:"#fff",border:"none",borderRadius:9,
              padding:"9px 16px",fontWeight:700,fontSize:13,cursor:"pointer",
              fontFamily:"'IBM Plex Sans',sans-serif"}}>+ Add User</button>
          </div>
          <div style={{background:"#fff",border:"1px solid #e5e5e5",borderRadius:12,overflow:"hidden"}}>
            {users.map((user,i) => {
              const branch = restaurants.find(r=>r.id===user.branchId);
              return (
                <div key={user.id} style={{display:"flex",alignItems:"center",gap:12,
                  padding:"13px 16px",borderBottom:i<users.length-1?"1px solid #f0f0f0":"none",
                  background:i%2===0?"#fff":"#fafafa"}}>
                  <div style={{width:36,height:36,borderRadius:"50%",flexShrink:0,
                    background:user.role==="admin"?"#1a1a1a":(branch?.color||"#ccc"),
                    display:"flex",alignItems:"center",justifyContent:"center",
                    color:"#fff",fontWeight:700,fontSize:15}}>
                    {user.name.charAt(0).toUpperCase()}
                  </div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontWeight:700,fontSize:14}}>{user.name}
                      <span style={{marginLeft:8,fontSize:11,color:"#aaa",fontWeight:400}}>@{user.username}</span>
                    </div>
                    <div style={{fontSize:12,color:"#aaa",marginTop:2}}>
                      {user.role==="admin"
                        ? <span style={{color:"#1a1a1a",fontWeight:700}}>👑 Admin — all locations</span>
                        : <span style={{color:branch?.color||"#888"}}>
                            {(user.branchIds||[user.branchId]).filter(Boolean).map(id=>restaurants.find(r=>r.id===id)?.name).filter(Boolean).join(", ")||"No location assigned"}
                          </span>
                      }
                    </div>
                  </div>
                  <button onClick={()=>setEditUser({...user})}
                    style={{background:"#f0f0f0",border:"none",borderRadius:7,padding:"6px 12px",
                    fontSize:12,fontWeight:700,cursor:"pointer",color:"#555",
                    fontFamily:"'IBM Plex Sans',sans-serif"}}>Edit</button>
                  <button onClick={()=>handleDeleteUser(user.id)}
                    style={{background:"#FEE2E2",border:"none",borderRadius:7,padding:"6px 10px",
                    fontSize:12,fontWeight:700,cursor:"pointer",color:"#C0392B",
                    fontFamily:"'IBM Plex Sans',sans-serif"}}>✕</button>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {section === "ordering" && (
        <div>
          <div style={{fontWeight:800, fontSize:17, marginBottom:4}}>🛒 Ordering Add-Ons</div>
          <div style={{fontSize:13, color:"#888", marginBottom:20}}>
            Items checked here will appear in the <strong>"Anything else to add?"</strong> prompt at the end of every inventory order. Useful for things like paper goods that aren't tracked by par level.
          </div>
          <div style={{display:"flex", flexDirection:"column", gap:8}}>
            {[...products].sort((a,b) => a.category.localeCompare(b.category) || a.name.localeCompare(b.name)).map(p => {
              const checked = (inventoryAddOns||[]).includes(p.id);
              return (
                <div key={p.id}
                  onClick={() => {
                    const next = checked
                      ? (inventoryAddOns||[]).filter(id => id !== p.id)
                      : [...(inventoryAddOns||[]), p.id];
                    saveInventoryAddOns(next);
                  }}
                  style={{display:"flex", alignItems:"center", gap:12, padding:"10px 14px",
                    borderRadius:10, border:`1.5px solid ${checked ? "#1a1a1a" : "#e5e5e5"}`,
                    background: checked ? "#f8f8f8" : "#fff", cursor:"pointer",
                    transition:"all .15s"}}>
                  <div style={{width:20, height:20, borderRadius:5, flexShrink:0,
                    border:`2px solid ${checked ? "#1a1a1a" : "#ccc"}`,
                    background: checked ? "#1a1a1a" : "#fff",
                    display:"flex", alignItems:"center", justifyContent:"center"}}>
                    {checked && <span style={{color:"#fff", fontSize:13, fontWeight:800}}>✓</span>}
                  </div>
                  <div style={{flex:1}}>
                    <div style={{fontWeight:600, fontSize:14}}>{p.name}</div>
                    <div style={{fontSize:11, color:"#aaa"}}>{p.category} · {p.unit}</div>
                  </div>
                </div>
              );
            })}
          </div>
          {(inventoryAddOns||[]).length > 0 && (
            <div style={{marginTop:16, padding:"10px 14px", background:"#f0faf4",
              borderRadius:10, border:"1px solid #86EFAC", fontSize:13, color:"#15803D", fontWeight:600}}>
              ✓ {inventoryAddOns.length} item{inventoryAddOns.length !== 1 ? "s" : ""} will appear in the add-ons prompt
            </div>
          )}
        </div>
      )}

      {section === "production" && (
        <ProductionAssignPanel
          users={users}
          products={products}
          saveUsers={saveUsers}
        />
      )}


      {section === "weights" && (
        <WeightsSection products={products} saveProducts={saveProducts} showToast={showToastProp}/>
      )}

      {section === "backup" && (
        <div>
          <BackupPanel
            users={users} products={products} restaurants={restaurants}
            parLevels={parLevels} orders={orders} closingReports={closingReports}
            factoryInventory={factoryInventory} factoryLogs={factoryLogs}
            prepStaff={prepStaff} prepTasks={prepTasks} prepTemplates={prepTemplates}
            prepDailyAssignments={prepDailyAssignments} prepTimestamps={prepTimestamps}
            productionHidden={productionHidden} hiddenItems={hiddenItems}
            customCats={customCats} catVisibility={catVisibility}
            showToast={showToastProp}
          />
          {/* ── One-time legacy status migration ── */}
          {(() => {
            const LEGACY = ["[ok] confirmed","to be delivered","ok confirmed","confirmed"];
            const affected = orders.filter(o => LEGACY.includes(o.status?.toLowerCase()) && o.status?.toLowerCase() !== "to_be_delivered");
            if (!affected.length) return (
              <div style={{marginTop:24, padding:"12px 16px", background:"#f0faf4", border:"1px solid #86EFAC", borderRadius:10, fontSize:13, color:"#15803D", fontWeight:600}}>
                ✓ No legacy order statuses found — all clean
              </div>
            );
            return (
              <div style={{marginTop:24, padding:"16px 20px", background:"#FFF8F0", border:"2px solid #F39C12", borderRadius:12}}>
                <div style={{fontWeight:800, fontSize:14, color:"#E67E22", marginBottom:6}}>
                  ⚠️ {affected.length} order{affected.length!==1?"s":""} with legacy status found
                </div>
                <div style={{fontSize:13, color:"#888", marginBottom:14}}>
                  These orders have status values like "[OK] Confirmed" that should be "to_be_delivered". Click below to fix them all permanently.
                </div>
                <button onClick={() => {
                    if (!window.confirm(`Fix ${affected.length} order${affected.length!==1?"s":""}? This will set their status to "to_be_delivered".`)) return;
                    const fixed = orders.map(o =>
                      LEGACY.includes(o.status?.toLowerCase()) && o.status?.toLowerCase() !== "to_be_delivered"
                        ? {...o, status: "to_be_delivered"}
                        : o
                    );
                    saveOrders(fixed);
                    showToastProp(`✓ Fixed ${affected.length} order${affected.length!==1?"s":""}`);
                  }}
                  style={{background:"#E67E22", color:"#fff", border:"none", borderRadius:9, padding:"10px 20px",
                    fontSize:13, fontWeight:700, cursor:"pointer"}}>
                  Fix {affected.length} Order{affected.length!==1?"s":""} Now
                </button>
              </div>
            );
          })()}
        </div>
      )}

      {editUser && (
        <UserEditModal user={editUser} restaurants={restaurants} products={products} onSave={handleSaveUser} onClose={()=>setEditUser(null)} />
      )}

      {/* ══ EDIT BRANCH MODAL ══ */}
      {editBranch && (
        <BranchEditModal
          branch={editBranch}
          onSave={handleSaveBranch}
          onClose={()=>setEditBranch(null)}
        />
      )}
        </div>
      </div>
    </div>
  );
}

function ProductEditModal({ product, categories, onSave, onClose, restaurants, hiddenItems, toggleHidden }) {
  const [form, setForm] = useState({...product});
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const isNew = !product.id;

  const inputStyle = {width:"100%",border:"1px solid #e5e5e5",borderRadius:9,
    padding:"10px 13px",fontSize:14,fontFamily:"'IBM Plex Sans',sans-serif",
    outline:"none",boxSizing:"border-box"};
  const labelStyle = {fontSize:11,fontWeight:700,color:"#888",textTransform:"uppercase",
    letterSpacing:.5,display:"block",marginBottom:5};

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:2000,
      display:"flex",alignItems:"center",justifyContent:"center",padding:16}}
      onClick={onClose}>
      <div style={{background:"#fff",borderRadius:18,maxWidth:460,width:"100%",
        maxHeight:"90vh",overflow:"auto",boxShadow:"0 24px 80px rgba(0,0,0,.2)"}}
        onClick={e=>e.stopPropagation()}>
        <div style={{background:"#1a1a1a",color:"#fff",padding:"20px 24px",
          borderRadius:"18px 18px 0 0",fontFamily:"'Playfair Display',serif",fontSize:20}}>
          {isNew ? "Add New Item" : "Edit Item"}
        </div>
        <div style={{padding:"22px 24px",display:"flex",flexDirection:"column",gap:14}}>
          <div>
            <label style={labelStyle}>Product Name (English)</label>
            <input value={form.name||""} onChange={e=>set("name",e.target.value)}
              placeholder="e.g. Pork Buns" style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Product Name (中文)</label>
            <input value={form.nameZh||""} onChange={e=>set("nameZh",e.target.value)}
              placeholder="e.g. 猪肉包" style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Category</label>
            <select value={form.category||""} onChange={e=>set("category",e.target.value)}
              style={{...inputStyle,background:"#fff"}}>
              {categories.map(c=><option key={c} value={c}>{c}</option>)}
              <option value="__new__">+ New category...</option>
            </select>
            {form.category==="__new__" && (
              <input value={form.newCategory||""} onChange={e=>set("newCategory",e.target.value)}
                placeholder="Category name" style={{...inputStyle,marginTop:8}} />
            )}
          </div>
          <div>
            <label style={labelStyle}>Unit</label>
            <input value={form.unit||""} onChange={e=>set("unit",e.target.value)}
              placeholder="e.g. 8 pc Bag, Case, Quart" style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Unit Price (leave blank for Market Price)</label>
            <input type="number" min="0" step="0.01"
              value={form.price != null ? form.price : ""}
              onChange={e=>set("price", e.target.value==="" ? null : parseFloat(e.target.value)||null)}
              placeholder="Market Price" style={inputStyle} />
          </div>
          {restaurants && restaurants.length > 0 && !isNew && (
            <div style={{borderTop:"1px solid #f0f0f0",paddingTop:16}}>
              <div style={{fontSize:11,fontWeight:700,color:"#888",textTransform:"uppercase",
                letterSpacing:.5,marginBottom:10}}>Visibility by Location</div>
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
                {restaurants.map(r => {
                  const hidden = (hiddenItems[r.id]||[]).includes(form.id);
                  return (
                    <div key={r.id} style={{display:"flex",alignItems:"center",
                      justifyContent:"space-between", padding:"10px 14px", borderRadius:10,
                      background:hidden?"#FEF2F2":"#F0FDF4",
                      border:`1.5px solid ${hidden?"#FECACA":"#BBF7D0"}`}}>
                      <div style={{display:"flex",alignItems:"center",gap:10}}>
                        <div style={{width:10,height:10,borderRadius:"50%",flexShrink:0,background:r.color}}/>
                        <span style={{fontSize:14,fontWeight:600,color:"#1a1a1a"}}>{r.name}</span>
                      </div>
                      <button onClick={()=>toggleHidden(r.id, form.id)}
                        style={{background:"none",border:`1.5px solid ${hidden?"#F87171":"#4ADE80"}`,
                        borderRadius:7,padding:"5px 14px",fontSize:12,fontWeight:700,
                        cursor:"pointer",color:hidden?"#C0392B":"#16A34A",
                        fontFamily:"'IBM Plex Sans',sans-serif"}}>
                        {hidden ? "Hidden" : "Visible"}
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          <div style={{display:"flex",gap:10,marginTop:6,borderTop:"1px solid #f0f0f0",paddingTop:16}}>
            <button onClick={onClose}
              style={{flex:1,background:"#f0f0f0",border:"none",borderRadius:9,padding:13,
              fontWeight:700,fontSize:14,cursor:"pointer",fontFamily:"'IBM Plex Sans',sans-serif",color:"#555"}}>
              Cancel
            </button>
            <button onClick={()=>{
              if(!form.name.trim()){alert("Product name is required");return;}
              const cat = form.category==="__new__" ? (form.newCategory||"Other") : form.category;
              onSave({...form,category:cat});
            }} style={{flex:2,background:"#1a1a1a",border:"none",borderRadius:9,padding:13,
              fontWeight:700,fontSize:14,cursor:"pointer",color:"#fff",
              fontFamily:"'IBM Plex Sans',sans-serif"}}>
              {isNew ? "Add Item" : "Save Changes"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function UserEditModal({ user, restaurants, products=[], onSave, onClose }) {
  // branchIds is now an array for multi-location managers
  const initForm = () => ({
    ...user,
    role: (user.role||"manager").toLowerCase(), // normalize legacy capitalized roles
    branchIds: user.branchIds || (user.branchId ? [user.branchId] : []),
    productionItems: user.productionItems || [],
    departments: user.departments || [],
  });
  const [form, setForm] = useState(initForm);
  const [showPin, setShowPin] = useState(false);
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const isNew = !user.id;

  const toggleLocation = (id) => {
    const ids = form.branchIds || [];
    set('branchIds', ids.includes(id) ? ids.filter(x=>x!==id) : [...ids, id]);
  };

  const inp = {width:"100%",border:"1px solid #e5e5e5",borderRadius:9,padding:"10px 13px",
    fontSize:14,fontFamily:"'IBM Plex Sans',sans-serif",outline:"none",
    boxSizing:"border-box",background:"#fafafa"};
  const lbl = {fontSize:11,fontWeight:700,color:"#888",textTransform:"uppercase",
    letterSpacing:.5,display:"block",marginBottom:5};

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:2000,
      display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={onClose}>
      <div style={{background:"#fff",borderRadius:18,maxWidth:480,width:"100%",
        maxHeight:"90vh",overflowY:"auto",overflowX:"hidden",
        WebkitOverflowScrolling:"touch",boxShadow:"0 24px 80px rgba(0,0,0,.2)"}}
        onClick={e=>e.stopPropagation()}>
        <div style={{background:"#1a1a1a",color:"#fff",padding:"20px 24px",
          borderRadius:"18px 18px 0 0",fontFamily:"'Playfair Display',serif",fontSize:20}}>
          {isNew ? "Add User" : `Edit — ${user.name}`}
        </div>
        <div style={{padding:"22px 24px",display:"flex",flexDirection:"column",gap:14}}>

          <div style={{display:"flex",gap:12}}>
            <div style={{flex:1}}>
              <label style={lbl}>Full Name</label>
              <input value={form.name||""} onChange={e=>set("name",e.target.value)}
                placeholder="e.g. Sarah Chen" style={inp} />
            </div>
            <div style={{flex:1}}>
              <label style={lbl}>Username</label>
              <input value={form.username||""} onChange={e=>set("username",e.target.value.toLowerCase().split(" ").join(""))}
                placeholder="e.g. sarah" autoCapitalize="none" style={inp} />
            </div>
          </div>

          <div>
            <label style={lbl}>Password</label>
            <div style={{position:"relative"}}>
              <input type={showPin?"text":"password"} value={form.pin||""}
                onChange={e=>set("pin",e.target.value)}
                placeholder={isNew?"Set a password":"Leave blank to keep current"}
                style={{...inp,paddingRight:44}} />
              <button onClick={()=>setShowPin(s=>!s)}
                style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",
                background:"none",border:"none",cursor:"pointer",color:"#aaa",fontSize:15}}>
                {showPin?"🙈":"👁"}
              </button>
            </div>
          </div>

          <div>
            <label style={lbl}>Role</label>
            <select
              value={form.role||"manager"}
              onChange={e=>{
                const r=e.target.value;
                set("role",r);
                if(["admin","kitchen","prep","production","driver"].includes(r)) set("branchIds",[]);
                if(!["kitchen","production"].includes(r)) set("departments",[]);
              }}
              style={{width:"100%",border:"2px solid #e5e5e5",borderRadius:9,padding:"11px 14px",
                fontSize:14,fontWeight:600,cursor:"pointer",background:"#fff",
                fontFamily:"'IBM Plex Sans',sans-serif",outline:"none"}}>
              <option value="manager">👤 Manager</option>
              <option value="cashier">💵 Cashier</option>
              <option value="kitchen">🏭 Factory — Full Access</option>
              <option value="production">🥟 Production — Report Only</option>
              <option value="driver">🚚 Driver</option>
              <option value="admin">👑 Admin</option>
              <option value="owner">💼 Owner — View Only</option>
              <option value="prep">📋 Prep Display</option>
            </select>
          </div>

          {(!["admin","kitchen","production","driver","prep","owner"].includes(form.role?.toLowerCase())) && (
            <div>
              <label style={lbl}>Assigned Locations</label>
              <div style={{display:"flex",flexDirection:"column",gap:6}}>
                {(!restaurants||restaurants.length===0) && (
                <div style={{fontSize:12,color:"#aaa",padding:8}}>
                  No locations found. Add locations in Settings → Locations first.
                </div>
              )}
              {(restaurants||[]).map(r => {
                  const checked = (form.branchIds||[]).includes(r.id);
                  return (
                    <label key={r.id} onClick={()=>toggleLocation(r.id)}
                      style={{display:"flex",alignItems:"center",gap:10,padding:"9px 12px",
                      borderRadius:9,border:`2px solid ${checked?r.color:"#e5e5e5"}`,
                      background:checked?"#fafafa":"#fff",cursor:"pointer",userSelect:"none"}}>
                      <div style={{width:18,height:18,borderRadius:4,flexShrink:0,
                        background:checked?r.color:"#fff",border:`2px solid ${checked?r.color:"#ccc"}`,
                        display:"flex",alignItems:"center",justifyContent:"center"}}>
                        {checked && <span style={{color:"#fff",fontSize:11,fontWeight:900}}>✓</span>}
                      </div>
                      <span style={{fontWeight:600,fontSize:14,color:"#1a1a1a"}}>{r.name}</span>
                      <div style={{width:10,height:10,borderRadius:"50%",background:r.color,marginLeft:"auto"}}/>
                    </label>
                  );
                })}
              </div>
              {(form.branchIds||[]).length === 0 && (
                <div style={{fontSize:12,color:"#E74C3C",marginTop:4}}>Please select at least one location</div>
              )}
            </div>
          )}

          {form.role==="admin" && (
            <div style={{background:"#f5f5f5",borderRadius:9,padding:"10px 14px",fontSize:12,color:"#777"}}>
              👑 Admins have access to all locations and the Settings panel.
            </div>
          )}
          {form.role==="owner" && (
            <div style={{background:"#f5f5f5",borderRadius:9,padding:"10px 14px",fontSize:12,color:"#777"}}>
              💼 Owners can view all invoices and reports (read-only) and use chat. No editing access.
            </div>
          )}

          {(form.role==="kitchen"||form.role==="production") && (
            <div>
              <label style={lbl}>Departments</label>
              <div style={{fontSize:11,color:"#aaa",marginBottom:8}}>
                Select all departments this person oversees. They can submit production reports for each.
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:6}}>
                {[
                  {id:"dumplings", label:"Dumpling Production", icon:"🥟"},
                  {id:"vegetables",label:"Vegetable Production",icon:"🥬"},
                  {id:"sauces",    label:"Sauce Production",    icon:"🫙"},
                  {id:"meats",     label:"Meat Production",     icon:"🥩"},
                  {id:"other",     label:"Other Goods",         icon:"📦"},
                ].map(dept => {
                  const checked = (form.departments||[]).includes(dept.id);
                  return (
                    <label key={dept.id}
                      onClick={()=>set("departments", checked
                        ? (form.departments||[]).filter(d=>d!==dept.id)
                        : [...(form.departments||[]), dept.id])}
                      style={{display:"flex",alignItems:"center",gap:10,padding:"10px 12px",
                        borderRadius:9,border:`2px solid ${checked?"#1a1a1a":"#e5e5e5"}`,
                        background:checked?"#f8f8f8":"#fff",cursor:"pointer",userSelect:"none"}}>
                      <div style={{width:18,height:18,borderRadius:4,flexShrink:0,
                        background:checked?"#1a1a1a":"#fff",border:`2px solid ${checked?"#1a1a1a":"#ccc"}`,
                        display:"flex",alignItems:"center",justifyContent:"center"}}>
                        {checked&&<span style={{color:"#fff",fontSize:11,fontWeight:900}}>✓</span>}
                      </div>
                      <span style={{fontSize:16}}>{dept.icon}</span>
                      <span style={{fontWeight:600,fontSize:14,color:"#1a1a1a"}}>{dept.label}</span>
                    </label>
                  );
                })}
              </div>
              {(form.departments||[]).length===0&&(
                <div style={{fontSize:12,color:"#888",marginTop:6}}>
                  No departments selected — they'll see all departments when recording production.
                </div>
              )}
            </div>
          )}

          {(form.role==="kitchen"||form.role==="production") && (
            <div>
              <label style={lbl}>Production Items</label>
              <div style={{fontSize:11,color:"#aaa",marginBottom:10}}>
                Select the specific items this person records. Leave empty to show all items in their departments.
              </div>
              {/* Group by department */}
              {[
                {id:"dumplings",label:"Dumpling Production",icon:"🥟",categories:["Frozen Dumplings","Buns","Doughs"]},
                {id:"vegetables",label:"Vegetable Production",icon:"🥬",categories:["Vegetables","Sides"]},
                {id:"sauces",label:"Sauce Production",icon:"🫙",categories:["Sauces"]},
                {id:"meats",label:"Meat Production",icon:"🥩",categories:["Meats","Soup"]},
                {id:"other",label:"Other Goods",icon:"📦",categories:["Paper Goods"]},
              ].filter(dept=>
                // Only show depts this user is assigned to (or all if none assigned)
                !(form.departments||[]).length || (form.departments||[]).includes(dept.id)
              ).map(dept => {
                const deptProds = (restaurants||[]) ? [] : []; // placeholder
                // Get products for this dept from the products prop
                return null; // rendered below via products
              })}
              {/* Flat product list grouped by dept */}
              {[
                {id:"dumplings",label:"Dumpling Production",icon:"🥟",cats:["Frozen Dumplings","Buns","Doughs"]},
                {id:"vegetables",label:"Vegetable Production",icon:"🥬",cats:["Vegetables","Sides"]},
                {id:"sauces",label:"Sauce Production",icon:"🫙",cats:["Sauces"]},
                {id:"meats",label:"Meat Production",icon:"🥩",cats:["Meats","Soup"]},
                {id:"other",label:"Other Goods",icon:"📦",cats:["Paper Goods"]},
              ].filter(dept=>
                !(form.departments||[]).length || (form.departments||[]).includes(dept.id)
              ).map(dept => {
                const deptProds = products.filter(p=>dept.cats.includes(p.category));
                if (!deptProds.length) return null;
                const assignedItems = form.productionItems||[];
                const deptAssigned = deptProds.filter(p=>assignedItems.includes(p.id)).length;
                return (
                  <div key={dept.id} style={{marginBottom:12}}>
                    <div style={{fontSize:11,fontWeight:800,color:"#555",letterSpacing:1,
                      marginBottom:6,display:"flex",alignItems:"center",gap:6}}>
                      <span>{dept.icon}</span>
                      <span>{dept.label.toUpperCase()}</span>
                      {deptAssigned>0&&<span style={{fontWeight:400,color:"#27AE60",fontSize:10}}>
                        {deptAssigned} assigned
                      </span>}
                    </div>
                    <div style={{display:"flex",flexDirection:"column",gap:3}}>
                      {deptProds.map(p=>{
                        const assigned = (form.productionItems||[]).includes(p.id);
                        return (
                          <label key={p.id}
                            onClick={()=>{
                              const curr = form.productionItems||[];
                              set("productionItems", assigned
                                ? curr.filter(id=>id!==p.id)
                                : [...curr, p.id]);
                            }}
                            style={{display:"flex",alignItems:"center",gap:8,
                              padding:"7px 10px",borderRadius:8,cursor:"pointer",
                              background:assigned?"#f0faf4":"#fff",
                              border:`1px solid ${assigned?"#27AE60":"#eee"}`}}>
                            <div style={{width:16,height:16,borderRadius:4,flexShrink:0,
                              border:`2px solid ${assigned?"#27AE60":"#ccc"}`,
                              background:assigned?"#27AE60":"transparent",
                              display:"flex",alignItems:"center",justifyContent:"center"}}>
                              {assigned&&<span style={{color:"#fff",fontSize:10,fontWeight:900}}>✓</span>}
                            </div>
                            <span style={{fontSize:13,fontWeight:500,flex:1}}>{p.name}</span>
                            <span style={{fontSize:11,color:"#aaa"}}>{p.unit}</span>
                            {p.internal&&<span style={{fontSize:9,color:"#8E44AD",fontWeight:700,
                              background:"#f5f0ff",borderRadius:3,padding:"1px 4px"}}>INT</span>}
                          </label>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
              {(form.productionItems||[]).length>0&&(
                <div style={{fontSize:11,color:"#27AE60",marginTop:6,fontWeight:600}}>
                  ✓ {(form.productionItems||[]).length} items assigned
                </div>
              )}
            </div>
          )}

          <div style={{background:"#f5f5f5",borderRadius:9,padding:"12px 14px"}}>
            <div style={{fontSize:11,fontWeight:700,color:"#888",textTransform:"uppercase",
              letterSpacing:.5,marginBottom:8}}>Access Summary</div>
            <div style={{fontSize:12,color:"#555",lineHeight:1.8}}>
              {form.role==="admin" ? (
                <div>[OK] All locations &nbsp;.&nbsp; [OK] Inventory &nbsp;.&nbsp; [OK] History &nbsp;.&nbsp; [OK] Catering &nbsp;.&nbsp; [OK] Settings</div>
              ) : (
                <div>
                  [OK] {(form.branchIds||[]).length === 0 ? "No locations selected" :
                    (form.branchIds||[]).map(id=>restaurants.find(r=>r.id===id)?.name).filter(Boolean).join(", ")}
                  <br/>[OK] Inventory &nbsp;.&nbsp; [OK] History &nbsp;.&nbsp; [OK] Catering &nbsp;.&nbsp; <span style={{color:"#C0392B"}}>✗ Settings</span>
                </div>
              )}
            </div>
          </div>

          <div style={{display:"flex",gap:10,marginTop:4}}>
            <button onClick={onClose}
              style={{flex:1,background:"#f0f0f0",border:"none",borderRadius:9,padding:13,
              fontWeight:700,fontSize:14,cursor:"pointer",fontFamily:"'IBM Plex Sans',sans-serif",color:"#555"}}>
              Cancel
            </button>
            <button onClick={()=>onSave(form)}
              style={{flex:2,background:"#1a1a1a",border:"none",borderRadius:9,padding:13,
              fontWeight:700,fontSize:14,cursor:"pointer",color:"#fff",
              fontFamily:"'IBM Plex Sans',sans-serif"}}>
              {isNew?"Add User":"Save Changes"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


// ── Staff Editor (reusable) ───────────────────────────────────────────────────
function StaffEditor({ staff, onChange }) {
  const [newName, setNewName] = useState("");
  const add = () => {
    const n = newName.trim();
    if (!n || staff.includes(n)) return;
    onChange([...staff, n]);
    setNewName("");
  };
  const remove = (name) => onChange(staff.filter(s=>s!==name));
  return (
    <div>
      <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:8}}>
        {staff.map(name=>(
          <div key={name} style={{display:"flex",alignItems:"center",gap:5,background:"#f0f0f0",
            borderRadius:20,padding:"4px 10px 4px 12px",fontSize:13}}>
            <span>{name}</span>
            <button onClick={()=>remove(name)}
              style={{background:"none",border:"none",cursor:"pointer",color:"#aaa",fontSize:14,lineHeight:1,padding:0}}>×</button>
          </div>
        ))}
        {staff.length===0 && <span style={{fontSize:13,color:"#ccc"}}>No staff added yet</span>}
      </div>
      <div style={{display:"flex",gap:7}}>
        <input value={newName} onChange={e=>setNewName(e.target.value)}
          onKeyDown={e=>e.key==="Enter"&&add()}
          placeholder="Employee name..."
          style={{flex:1,border:"1px solid #e5e5e5",borderRadius:8,padding:"7px 10px",fontSize:13}}/>
        <button onClick={add}
          style={{background:"#1a1a1a",color:"#fff",border:"none",borderRadius:8,
            padding:"7px 14px",fontSize:13,fontWeight:700,cursor:"pointer"}}>Add</button>
      </div>
    </div>
  );
}


function BranchEditModal({ branch, onSave, onClose }) {
  const [form, setForm] = useState({...branch,
    deliveryDays: branch.deliveryDays || []});
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const isNew = !branch.id;
  const DAYS = ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"];
  const COLORS = ["#C0392B","#2471A3","#1E8449","#7D3C98","#D35400","#117A65","#1A5276"];

  const inputStyle = {width:"100%",border:"1px solid #e5e5e5",borderRadius:9,
    padding:"10px 13px",fontSize:14,fontFamily:"'IBM Plex Sans',sans-serif",
    outline:"none",boxSizing:"border-box"};
  const labelStyle = {fontSize:11,fontWeight:700,color:"#888",textTransform:"uppercase",
    letterSpacing:.5,display:"block",marginBottom:5};

  const toggleDay = (day) => {
    const days = form.deliveryDays.includes(day)
      ? form.deliveryDays.filter(d=>d!==day)
      : [...form.deliveryDays, day];
    set("deliveryDays", days);
  };

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:2000,
      display:"flex",alignItems:"center",justifyContent:"center",padding:16}}
      onClick={onClose}>
      <div style={{background:"#fff",borderRadius:18,maxWidth:460,width:"100%",
        maxHeight:"90vh",overflow:"auto",boxShadow:"0 24px 80px rgba(0,0,0,.2)"}}
        onClick={e=>e.stopPropagation()}>
        <div style={{background:"#1a1a1a",color:"#fff",padding:"20px 24px",
          borderRadius:"18px 18px 0 0",fontFamily:"'Playfair Display',serif",fontSize:20}}>
          {isNew ? "Add Location" : `Edit — ${branch.name}`}
        </div>
        <div style={{padding:"22px 24px",display:"flex",flexDirection:"column",gap:14}}>
          <div>
            <label style={labelStyle}>Location Name</label>
            <input value={form.name||""} onChange={e=>set("name",e.target.value)}
              placeholder="e.g. Upper West Side" style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Delivery Address</label>
            <input value={form.address||""} onChange={e=>set("address",e.target.value)}
              placeholder="e.g. 123 Bedford Ave, Brooklyn, NY 11211" style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Manager Name</label>
            <input value={form.managerName||""} onChange={e=>set("managerName",e.target.value)}
              placeholder="Full name" style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Manager Email</label>
            <input value={form.managerEmail||""} onChange={e=>set("managerEmail",e.target.value)}
              placeholder="manager@vanessas.com" style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Delivery Days</label>
            <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
              {DAYS.map(day=>(
                <button key={day} onClick={()=>toggleDay(day)} style={{
                  border:`2px solid ${form.deliveryDays.includes(day)?form.color:"#e5e5e5"}`,
                  background: form.deliveryDays.includes(day)?form.color+"15":"#fff",
                  color: form.deliveryDays.includes(day)?form.color:"#888",
                  borderRadius:7,padding:"5px 10px",fontSize:12,fontWeight:700,
                  cursor:"pointer",fontFamily:"'IBM Plex Sans',sans-serif"}}>
                  {day.slice(0,3)}
                </button>
              ))}
            </div>
          </div>
          <div>
            <label style={labelStyle}>Ordering Modes</label>
            <div style={{display:"flex",flexDirection:"column",gap:7}}>
              {[["par","📦 Par Order","Count inventory, system calculates vs par levels"],
                ["custom","📋 Custom Order","Enter quantities directly without par context"]].map(([mode,label,desc])=>{
                const modes = form.orderModes || ["par"];
                const enabled = modes.includes(mode);
                return (
                  <div key={mode} onClick={()=>{
                    const next = enabled ? modes.filter(m=>m!==mode) : [...modes,mode];
                    if (next.length > 0) set("orderModes", next);
                  }} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 12px",
                    borderRadius:9,border:`1px solid ${enabled?"#1a1a1a":"#e5e5e5"}`,
                    background:enabled?"#1a1a1a":"#fff",cursor:"pointer",transition:"all .15s"}}>
                    <div style={{width:18,height:18,borderRadius:5,flexShrink:0,
                      border:`2px solid ${enabled?"#fff":"#ccc"}`,
                      background:enabled?"#fff":"transparent",
                      display:"flex",alignItems:"center",justifyContent:"center"}}>
                      {enabled && <div style={{width:9,height:9,borderRadius:2,background:"#1a1a1a"}}/>}
                    </div>
                    <div>
                      <div style={{fontWeight:700,fontSize:13,color:enabled?"#fff":"#1a1a1a"}}>{label}</div>
                      <div style={{fontSize:11,color:enabled?"rgba(255,255,255,0.6)":"#999",marginTop:1}}>{desc}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div>
            <label style={labelStyle}>Color</label>
            <div style={{display:"flex",gap:8}}>
              {COLORS.map(c=>(
                <button key={c} onClick={()=>set("color",c)} style={{
                  width:30,height:30,borderRadius:"50%",background:c,border:"none",
                  cursor:"pointer",outline: form.color===c?"3px solid #1a1a1a":"3px solid transparent",
                  outlineOffset:2,transition:"all .12s"}}/>
              ))}
            </div>
          </div>
          <div>
            <label style={labelStyle}>Staff / Tip-Split Employees</label>
            <StaffEditor staff={form.staff||[]} onChange={s=>set("staff",s)}/>
          </div>
          <div style={{borderTop:"1px solid #f0f0f0",paddingTop:14}}>
            <label style={labelStyle}>Statement Language</label>
            <div onClick={()=>set("showChinese",!form.showChinese)} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 12px",
              borderRadius:9,border:`1px solid ${form.showChinese?"#1a1a1a":"#e5e5e5"}`,
              background:form.showChinese?"#1a1a1a":"#fff",cursor:"pointer",transition:"all .15s"}}>
              <div style={{width:18,height:18,borderRadius:5,flexShrink:0,
                border:`2px solid ${form.showChinese?"#fff":"#ccc"}`,
                background:form.showChinese?"#fff":"transparent",
                display:"flex",alignItems:"center",justifyContent:"center"}}>
                {form.showChinese && <div style={{width:9,height:9,borderRadius:2,background:"#1a1a1a"}}/>}
              </div>
              <div>
                <div style={{fontWeight:700,fontSize:13,color:form.showChinese?"#fff":"#1a1a1a"}}>🇨🇳 Show Chinese on Statements</div>
                <div style={{fontSize:11,color:form.showChinese?"rgba(255,255,255,0.6)":"#999",marginTop:1}}>Item names will show Chinese below English on invoices sent to this location</div>
              </div>
            </div>
          </div>
          <div style={{display:"flex",gap:10,marginTop:6}}>
            <button onClick={onClose}
              style={{flex:1,background:"#f0f0f0",border:"none",borderRadius:9,padding:13,
              fontWeight:700,fontSize:14,cursor:"pointer",fontFamily:"'IBM Plex Sans',sans-serif",color:"#555"}}>
              Cancel
            </button>
            <button onClick={()=>{
              if(!form.name.trim()){alert("Location name is required");return;}
              onSave(form);
            }} style={{flex:2,background:"#1a1a1a",border:"none",borderRadius:9,padding:13,
              fontWeight:700,fontSize:14,cursor:"pointer",color:"#fff",
              fontFamily:"'IBM Plex Sans',sans-serif"}}>
              {isNew ? "Add Location" : "Save Changes"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


function OrderReviewModal({baseItems, cateringBreakdown, rest, delivDate, initialNote, onConfirm, onClose, products, t, pName, fmtPrice, hidePrice=false}) {
  const [submitting, setSubmitting] = useState(false);
  const init = {};
  products.forEach(p => { init[p.id] = 0; });
  baseItems.forEach(i => { init[i.productId] = (init[i.productId]||0) + i.qty; });
  if (cateringBreakdown) {
    Object.entries(cateringBreakdown.extras).forEach(([pid, qty]) => {
      init[+pid] = (init[+pid]||0) + qty;
    });
  }

  const [qtys, setQtys] = useState(init);
  const [note, setNote] = useState(cateringBreakdown ? `Includes catering: ${cateringBreakdown.summary}` : (initialNote||""));
  const [showAll, setShowAll] = useState(false);

  const activeItems = products.filter(p => qtys[p.id] > 0);
  const allItems = products.filter(p => init[p.id] > 0 || qtys[p.id] > 0);
  const displayItems = showAll ? allItems : activeItems;

  const pricedItems = activeItems.filter(p => p.price !== null && p.price !== undefined);
  const subtotal = pricedItems.reduce((s,p) => s + p.price * qtys[p.id], 0);
  const hasMarketPrice = activeItems.some(p => p.price === null || p.price === undefined);

  const parItems   = new Set(baseItems.map(i=>i.productId));
  const caterItems = cateringBreakdown ? new Set(Object.keys(cateringBreakdown.extras).map(Number)) : new Set();

  // Group display items by category
  const cats = [...new Set(displayItems.map(p=>p.category))];

  const tagStyle = (type) => {
    const styles = {
      par:    { background:"#FEE2E2", color:"#C0392B" },
      cater:  { background:"#EDE7F6", color:"#7B1FA2" },
      manual: { background:"#E3F2FD", color:"#1565C0" },
    };
    const s = styles[type] || styles.manual;
    return { ...s, borderRadius:4, padding:"1px 6px", fontSize:10, fontWeight:700 };
  };

  const getTag = (p) => {
    if (parItems.has(p.id) && caterItems.has(p.id)) return "cater";
    if (parItems.has(p.id)) return "par";
    if (caterItems.has(p.id)) return "cater";
    return "manual";
  };

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:1000,
      display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={onClose}>
      <div style={{background:"#fff",borderRadius:18,maxWidth:680,width:"100%",
        maxHeight:"92vh",display:"flex",flexDirection:"column",
        boxShadow:"0 30px 80px rgba(0,0,0,0.3)"}}
        onClick={e=>e.stopPropagation()}>

        {/* Header */}
        <div style={{background:"#1a1a1a",color:"#fff",padding:"20px 26px",
          borderRadius:"18px 18px 0 0",display:"flex",justifyContent:"space-between",
          alignItems:"center",flexWrap:"wrap",gap:10,flexShrink:0}}>
          <div>
            <div style={{fontSize:10,letterSpacing:3,color:"#666",
              textTransform:"uppercase",marginBottom:3}}>Review Order</div>
            <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:22,margin:0}}>{rest.name}</h2>
          </div>
          <div style={{textAlign:"right"}}>
            <div style={{fontSize:10,color:"#666",marginBottom:2}}>EST. DELIVERY</div>
            <div style={{fontSize:18,fontWeight:700,color:"#F39C12"}}>{fmt(delivDate)}</div>
            <div style={{fontSize:9,color:"#aaa",marginTop:2}}>Confirmed by factory</div>
          </div>
        </div>

        {/* Summary bar */}
        <div style={{background:"#f8f8f8",borderBottom:"1px solid #eee",
          padding:"10px 26px",display:"flex",alignItems:"center",
          justifyContent:"space-between",flexShrink:0,flexWrap:"wrap",gap:8}}>
          <div style={{fontSize:13,color:"#555"}}>
            <strong style={{color:"#1a1a1a"}}>{activeItems.length} items</strong> in this order
            {activeItems.length !== allItems.length && (
              <button onClick={()=>setShowAll(s=>!s)}
                style={{marginLeft:10,background:"none",border:"none",color:"#2471A3",
                fontSize:12,cursor:"pointer",fontWeight:600,fontFamily:"'IBM Plex Sans',sans-serif"}}>
                {showAll ? "Hide zero-qty items" : `Show all ${allItems.length} items`}
              </button>
            )}
          </div>
          <div style={{fontSize:13,fontWeight:700,color:"#1a1a1a"}}>
            {!hidePrice && (subtotal > 0 ? `Est. $${subtotal.toFixed(2)}${hasMarketPrice?" + market items":""}` : "Market price items only")}
          </div>
        </div>

        {/* Item list - scrollable */}
        <div style={{flex:1,overflowY:"auto",padding:"12px 26px"}}>
          {cats.map(cat => (
            <div key={cat} style={{marginBottom:16}}>
              <div style={{fontSize:10,fontWeight:700,color:"#aaa",textTransform:"uppercase",
                letterSpacing:.8,marginBottom:6,paddingBottom:4,
                borderBottom:"1px solid #f0f0f0"}}>
                {cat}
              </div>
              {displayItems.filter(p=>p.category===cat).map((p,i,arr) => {
                const qty = qtys[p.id] ?? 0;
                const tag = getTag(p);
                const isZero = qty === 0;
                return (
                  <div key={p.id} style={{
                    display:"flex", alignItems:"center", gap:12,
                    padding:"8px 10px",
                    borderRadius:8,
                    background: isZero ? "#fafafa" : "#fff",
                    border: `1px solid ${isZero ? "#f0f0f0" : "#e8e8e8"}`,
                    marginBottom: i<arr.length-1 ? 4 : 0,
                    opacity: isZero ? 0.5 : 1,
                    transition:"all .12s",
                  }}>
                    {/* Tag */}
                    <span style={tagStyle(tag)}>
                      {tag==="par"?"par-level":tag==="cater"?"catering":"manual"}
                    </span>

                    {/* Name + price */}
                    <div style={{flex:1,minWidth:0}}>
                      <span style={{fontWeight:700,fontSize:13,color:"#1a1a1a"}}>{pName(p)}</span>
                      <span style={{fontSize:11,color:"#bbb",marginLeft:8}}>{p.unit}</span>
                    </div>

                    {/* Price per unit */}
                    <div style={{fontSize:12,color:"#888",minWidth:80,textAlign:"right"}}>
                      {!hidePrice && (p.price != null
                        ? `$${(p.price*qty).toFixed(2)}`
                        : <span style={{color:"#F39C12",fontStyle:"italic"}}>mkt price</span>)}
                    </div>

                    {/* Qty controls */}
                    <div style={{display:"flex",alignItems:"center",gap:4,flexShrink:0}}>
                      <button onClick={()=>setQtys(q=>({...q,[p.id]:Math.max(0,(q[p.id]||0)-1)}))}
                        style={{width:24,height:24,borderRadius:5,border:"1px solid #ddd",
                        background:"#f5f5f5",fontWeight:700,fontSize:13,cursor:"pointer",
                        color:"#555",lineHeight:1}}>−</button>
                      <input type="number" min="0" step="0.5" value={qty}
                        onChange={e=>setQtys(q=>({...q,[p.id]:Math.max(0,parseFloat(e.target.value)||0)}))}
                        onFocus={e=>e.target.select()}
                        style={{width:52,textAlign:"center",border:"1px solid #ddd",borderRadius:6,
                        padding:"3px 4px",fontSize:13,fontWeight:700,
                        fontFamily:"'IBM Plex Sans',sans-serif",outline:"none"}} />
                      <button onClick={()=>setQtys(q=>({...q,[p.id]:(q[p.id]||0)+1}))}
                        style={{width:24,height:24,borderRadius:5,border:"1px solid #ddd",
                        background:"#f5f5f5",fontWeight:700,fontSize:13,cursor:"pointer",
                        color:"#555",lineHeight:1}}>+</button>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>

        {/* Note + footer */}
        <div style={{borderTop:"1px solid #eee",padding:"14px 26px",flexShrink:0,background:"#fafafa",
          borderRadius:"0 0 18px 18px"}}>
          <textarea value={note} onChange={e=>setNote(e.target.value)}
            placeholder="Add a note to this order (optional)..."
            rows={2}
            style={{width:"100%",border:"1px solid #e5e5e5",borderRadius:8,padding:"8px 12px",
            fontSize:12,fontFamily:"'IBM Plex Sans',sans-serif",outline:"none",
            resize:"none",boxSizing:"border-box",background:"#fff",marginBottom:12}} />
          <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
            <button onClick={onClose}
              style={{background:"#f0f0f0",border:"none",borderRadius:9,padding:"11px 20px",
              fontWeight:700,fontSize:13,cursor:"pointer",color:"#555",
              fontFamily:"'IBM Plex Sans',sans-serif"}}>
              Cancel
            </button>
            <button
              disabled={activeItems.length===0||submitting}
              onClick={()=>{ if(submitting) return; setSubmitting(true); onConfirm(activeItems.map(p=>({productId:p.id,qty:qtys[p.id],customPrice:p.price??null})),note); }}
              style={{background:activeItems.length>0&&!submitting?rest.color:"#ccc",border:"none",
              borderRadius:9,padding:"11px 24px",fontWeight:700,fontSize:13,
              cursor:activeItems.length>0&&!submitting?"pointer":"not-allowed",color:"#fff",
              fontFamily:"'IBM Plex Sans',sans-serif"}}>
              {submitting?"Submitting...":"Approve & Generate Invoice →"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


// ── Note with Translate button ────────────────────────────────────────────────
function NoteWithTranslate({ note, style={} }) {
  const translateUrl = `https://translate.google.com/?sl=auto&tl=en&text=${encodeURIComponent(note)}&op=translate`;
  return (
    <div style={{background:"#FFFBF0", border:"1px solid #F39C12", borderRadius:8,
      padding:"8px 12px", marginBottom:14, fontSize:13, color:"#856404", ...style}}>
      <div style={{display:"flex", alignItems:"flex-start", justifyContent:"space-between", gap:8}}>
        <div style={{flex:1}}><strong>Note:</strong> {note}</div>
        <a href={translateUrl} target="_blank" rel="noreferrer"
          style={{flexShrink:0, border:"1px solid #F39C12", borderRadius:6, background:"#fff",
            color:"#856404", fontSize:11, fontWeight:700, padding:"3px 8px",
            textDecoration:"none", whiteSpace:"nowrap"}}>
          🌐 Translate
        </a>
      </div>
    </div>
  );
}

function InvoiceModal({order, rest, onClose, onSend, products, t, pName, fmtPrice, hidePrice=false}) {
  const items = order.items.map(i => { const p=products.find(x=>x.id===i.productId); return p?{...p,qty:i.qty,total:p.price!=null?p.price*i.qty:null}:null; }).filter(Boolean);
  const sub = items.reduce((s,i)=>s+(i.total||0),0);

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:1100,
      display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={onClose}>
      <div style={{background:"#fff",borderRadius:18,maxWidth:660,width:"100%",
        maxHeight:"90vh",overflow:"auto",boxShadow:"0 30px 80px rgba(0,0,0,0.3)"}}
        onClick={e=>e.stopPropagation()}>

        <div style={{background:"#1a1a1a",color:"#fff",padding:"24px 30px",borderRadius:"18px 18px 0 0"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:10}}>
            <div>
              <div style={{fontSize:10,letterSpacing:3,color:"#666",textTransform:"uppercase",marginBottom:4}}>Purchase Order</div>
              <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:24,marginBottom:5}}>Order #{order.id}</h2>
              <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
                <Badge status={order.status}/>
                {order.hasCatering && <span style={{background:"#8E44AD33",color:"#C39BD3",borderRadius:20,padding:"2px 10px",fontSize:11,fontWeight:700}}>🍽 Includes Catering</span>}
              </div>
            </div>
            <div style={{textAlign:"right"}}>
              <div style={{fontSize:10,color:"#666",marginBottom:2}}>DELIVER BY</div>
              <div style={{fontSize:20,fontWeight:700,color:"#F39C12"}}>{order.deliveryDate ? fmt(new Date(order.deliveryDate)) : "TBD"}</div>
            </div>
          </div>
        </div>

        <div style={{padding:"24px 30px"}}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:22}}>
            {[["FROM",rest.name,"",""],["TO","Central Factory","",FACTORY_EMAIL]].map(([label,name,contact,email])=>(
              <div key={label} style={{background:"#f8f8f8",borderRadius:10,padding:14}}>
                <div style={{fontSize:10,color:"#aaa",fontWeight:700,letterSpacing:1,marginBottom:5}}>{label}</div>
                <div style={{fontWeight:700}}>{name}</div>
                {contact && <div style={{fontSize:12,color:"#777",marginTop:1}}>{contact}</div>}
                <div style={{fontSize:12,color:"#aaa"}}>{email}</div>
              </div>
            ))}
          </div>

          <div style={{overflowX:"auto",marginBottom:14}}>
            <table style={{width:"100%",borderCollapse:"collapse",minWidth:400}}>
              <thead>
                <tr style={{borderBottom:"2px solid #1a1a1a"}}>
                  {(hidePrice ? ["Qty","Item","Category"] : ["Qty","Item","Category","Price","Total"]).map(h=>(
                    <th key={h} style={{textAlign:["Qty","Price","Total"].includes(h)?"right":"left",
                      padding:"7px 8px",fontSize:10,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:.5}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {items.map((item,i)=>(
                  <tr key={item.id} style={{background:i%2?"#fafafa":"#fff",borderBottom:"1px solid #f0f0f0"}}>
                    <td style={{padding:"9px 8px",textAlign:"center",fontWeight:900,fontSize:20,color:"#1a1a1a",minWidth:48}}>{item.qty}</td>
                    <td style={{padding:"9px 8px",fontWeight:600}}>{pName(item)} <span style={{fontSize:11,color:"#aaa",fontWeight:400}}>{item.unit}</span></td>
                    <td style={{padding:"9px 8px",fontSize:12,color:"#999"}}>{item.category}</td>
                    <td style={{padding:"9px 8px",textAlign:"right",color:"#666"}}>{!hidePrice && fmtPrice(item)}</td>
                    <td style={{padding:"9px 8px",textAlign:"right",fontWeight:700}}>
                      {!hidePrice && (item.price!=null ? fmtMoney(item.total) : <span style={{color:"#E67E22",fontSize:11}}>{t.marketPrice}</span>)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={{display:"flex",justifyContent:"flex-end",marginBottom:18}}>
            {!hidePrice && <div style={{minWidth:200}}>
              {[["Subtotal",fmtMoney(sub)]].map(([l,v])=>(
                <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"5px 0",
                  borderBottom:"1px solid #f0f0f0",fontSize:13,color:"#666"}}>
                  <span>{l}</span><span>{v}</span>
                </div>
              ))}
              <div style={{display:"flex",justifyContent:"space-between",padding:"9px 0",
                fontSize:18,fontWeight:700,borderTop:"2px solid #1a1a1a",marginTop:2}}>
                <span>Total</span><span>{fmtMoney(sub)}</span>
              </div>
            </div>}
          </div>

          {order.note && <NoteWithTranslate note={order.note} />}

          {order.approvedAt && (
            <div style={{background:"#EAFAF1",border:"1px solid #27AE6033",borderRadius:10,
              padding:"10px 14px",marginBottom:10,display:"flex",alignItems:"center",gap:10}}>
              <span style={{fontSize:18}}>[OK]</span>
              <div>
                <div style={{fontWeight:700,fontSize:13}}>Approved by {rest.managerName}</div>
                <div style={{fontSize:11,color:"#888"}}>{new Date(order.approvedAt).toLocaleString()}</div>
              </div>
            </div>
          )}
          {order.sentAt && (
            <div style={{background:"#EBF5FB",border:"1px solid #2471A333",borderRadius:10,
              padding:"10px 14px",marginBottom:10,display:"flex",alignItems:"center",gap:10}}>
              <span>📧</span>
              <div>
                <div style={{fontWeight:700,fontSize:13}}>Emailed to {FACTORY_EMAIL}</div>
                <div style={{fontSize:11,color:"#888"}}>{new Date(order.sentAt).toLocaleString()}</div>
              </div>
            </div>
          )}

          <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:10,flexWrap:"wrap"}}>
            <Btn outline color="#888" onClick={onClose}>{t.close||"Close"}</Btn>
            {!["sent","Sent"].includes(order.status) && <Btn color="#C0392B" onClick={()=>onSend(order)}>{t.sendFactory}</Btn>}
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Email Sent Modal ──────────────────────────────────────────────────────────
function EmailSentModal({order, rest, onClose, t}) {
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:2000,
      display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={onClose}>
      <div style={{background:"#fff",borderRadius:18,maxWidth:400,width:"100%",padding:38,
        textAlign:"center",boxShadow:"0 24px 70px rgba(0,0,0,0.25)"}} onClick={e=>e.stopPropagation()}>
        <div style={{fontSize:56,marginBottom:12}}>📧</div>
        <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:22,marginBottom:8}}>Order Sent!</h2>
        <p style={{color:"#666",fontSize:13,marginBottom:14,lineHeight:1.6}}>
          <strong>Order #{order.id}</strong> from <strong>{rest.name}</strong> emailed to:
        </p>
        <div style={{background:"#EBF5FB",borderRadius:10,padding:"10px 16px",marginBottom:6,fontWeight:700,color:"#2471A3",fontSize:13}}>{FACTORY_EMAIL}</div>
        <div style={{background:"#EBF5FB",borderRadius:10,padding:"10px 16px",marginBottom:12,fontWeight:700,color:"#2471A3",fontSize:13}}>{BETA_EMAIL}</div>
        <div style={{background:"#EAFAF1",borderRadius:10,padding:10,marginBottom:22,fontSize:12,color:"#1E8449"}}>
          🚚 Delivery: <strong>{order.deliveryDate ? fmt(new Date(order.deliveryDate)) : "To be confirmed"}</strong>
        </div>
        <button onClick={onClose}
          style={{width:"100%",padding:"13px",borderRadius:12,border:"none",
            background:"#1a1a1a",color:"#fff",fontSize:15,fontWeight:700,
            cursor:"pointer",fontFamily:"'IBM Plex Sans',sans-serif"}}>
          Done
        </button>
      </div>
    </div>
  );
}

// ── Inventory Tab ─────────────────────────────────────────────────────────────


// ── Closing Report Tab ────────────────────────────────────────────────────────
function ClosingReportTab({ rest, auth, lang="en", closingReports, saveClosingReports, allReports, showToast, isCashier, allRestaurants, saveRestaurants }) {
  const LEAVE_IN_REGISTER = 200;
  const cr = {
    en: {
      newReport:"New Report", history:"History", general:"General", sales:"Sales",
      tips:"Tips", review:"Review", next:"Next →", submit:"Submit Report",
      employeeName:"EMPLOYEE NAME", date:"DATE", shift:"SHIFT",
      lunch:"🌤 Lunch", dinner:"🌙 Dinner", fullDay:"☀️ Full Day",
      registerStart:"REGISTER START", cashSales:"CASH SALES", creditSales:"CREDIT SALES",
      thirdParty:"3RD PARTY SALES", kiosk:"KIOSK SALES", actualCash:"ACTUAL CASH COUNTED",
      creditTips:"CREDIT CARD TIPS", kioskTips:"KIOSK TIPS", thirdPartyTips:"3RD PARTY TIPS",
      workingStaff:"WORKING STAFF", addStaff:"+ Add Staff Member", enterName:"Enter name",
      expectedCash:"Expected Cash", lunchDeposit:"Lunch Deposit", deposit:"Deposit (Actual − $200 float)",
      discrepancy:"Discrepancy", totalSales:"Total Sales", totalTips:"Total Tips",
      submitConfirm:"Submit closing report?", noReports:"No reports yet.",
      shortBy:"Short by", overBy:"Over by", balanced:"Balanced ✓",
    },
    zh: {
      newReport:"新报告", history:"历史记录", general:"基本信息", sales:"销售额",
      tips:"小费", review:"审核", next:"下一步 →", submit:"提交报告",
      employeeName:"员工姓名", date:"日期", shift:"班次",
      lunch:"🌤 午班", dinner:"🌙 晚班", fullDay:"☀️ 全天",
      registerStart:"收银机起始金额", cashSales:"现金销售", creditSales:"刷卡销售",
      thirdParty:"第三方销售", kiosk:"自助机销售", actualCash:"实际现金清点",
      creditTips:"信用卡小费", kioskTips:"自助机小费", thirdPartyTips:"第三方小费",
      workingStaff:"工作人员", addStaff:"+ 添加员工", enterName:"输入姓名",
      expectedCash:"预期现金", lunchDeposit:"午餐存款", deposit:"存款（实际 − $200 备用金）",
      discrepancy:"差异", totalSales:"总销售额", totalTips:"总小费",
      submitConfirm:"确认提交结班报告？", noReports:"暂无报告。",
      shortBy:"短缺", overBy:"超出", balanced:"平衡 ✓",
    },
  }[lang] || {};
  const [view, setView] = useState("form");
  const [step, setStep] = useState(0);
  const today = new Date().toISOString().slice(0,10);

  const blankForm = () => ({
    restaurantId: rest?.id,
    restaurantName: rest?.name || "",
    employeeName: auth?.name || auth?.username || "",
    date: today,
    shift: "dinner",
    registerStart: "", cashSales: "", creditSales: "",
    thirdPartySales: "", kioskSales: "", actualCash: "",
    creditTips: "", kioskTips: "", thirdPartyTips: "",
    workingStaff: [], submittedAt: null, id: null,
  });

  const [form, setForm] = useState(blankForm);
  const set = (k, v) => setForm(f => ({...f, [k]: v}));

  const cashSalesN       = parseFloat(form.cashSales)       || 0;
  const creditSalesN     = parseFloat(form.creditSales)     || 0;
  const thirdPartySalesN = parseFloat(form.thirdPartySales) || 0;
  const kioskSalesN      = parseFloat(form.kioskSales)      || 0;
  const registerStartN   = parseFloat(form.registerStart)   || 0;
  const actualCashN      = parseFloat(form.actualCash)      || 0;
  // Auto-find lunch report for same date/location (for dinner shift deduction)
  const lunchReport = form.shift === "dinner"
    ? (allReports||[]).find(r =>
        r.date === form.date &&
        r.restaurantId === (rest?.id) &&
        r.shift === "lunch")
    : null;

  const lunchDepositN    = (form.shift === "dinner")
    ? (parseFloat(form.lunchDeposit) || lunchReport?.computedCashDeposit || 0)
    : 0;
  const lunchCashSales      = lunchReport ? (parseFloat(lunchReport.cashSales)       || 0) : 0;
  const lunchCreditSales    = lunchReport ? (parseFloat(lunchReport.creditSales)     || 0) : 0;
  const lunchThirdParty     = lunchReport ? (parseFloat(lunchReport.thirdPartySales) || 0) : 0;
  const lunchKiosk          = lunchReport ? (parseFloat(lunchReport.kioskSales)      || 0) : 0;
  const lunchTotalSales     = lunchCashSales + lunchCreditSales + lunchThirdParty + lunchKiosk;
  // Dinner net = dinner total minus lunch (since Square dinner = full day)
  const dinnerNetCash       = lunchReport ? Math.max(0, cashSalesN - lunchCashSales) : cashSalesN;
  const dinnerNetCredit     = lunchReport ? Math.max(0, creditSalesN - lunchCreditSales) : creditSalesN;
  const dinnerNetThirdParty = lunchReport ? Math.max(0, thirdPartySalesN - lunchThirdParty) : thirdPartySalesN;
  const dinnerNetKiosk      = lunchReport ? Math.max(0, kioskSalesN - lunchKiosk) : kioskSalesN;

  const expectedCash     = registerStartN + cashSalesN - lunchDepositN;
  const discrepancy      = actualCashN - expectedCash;
  const cashDeposit      = actualCashN - LEAVE_IN_REGISTER;
  const totalSales       = cashSalesN + creditSalesN + thirdPartySalesN + kioskSalesN;
  const creditTipsN      = parseFloat(form.creditTips)      || 0;
  const kioskTipsN       = parseFloat(form.kioskTips)       || 0;
  const thirdPartyTipsN  = parseFloat(form.thirdPartyTips)  || 0;
  const totalTips        = creditTipsN + kioskTipsN + thirdPartyTipsN;
  // Net tips for dinner: subtract lunch tips to avoid double-counting
  const lunchCreditTips     = lunchReport ? (parseFloat(lunchReport.creditTips)      || 0) : 0;
  const lunchKioskTips      = lunchReport ? (parseFloat(lunchReport.kioskTips)       || 0) : 0;
  const lunchThirdPartyTips = lunchReport ? (parseFloat(lunchReport.thirdPartyTips)  || 0) : 0;
  const lunchTotalTips      = lunchCreditTips + lunchKioskTips + lunchThirdPartyTips;
  const isDinnerWithLunch   = form.shift === "dinner" && !!lunchReport;
  const netCreditTips       = isDinnerWithLunch ? Math.max(0, creditTipsN    - lunchCreditTips)     : creditTipsN;
  const netKioskTips        = isDinnerWithLunch ? Math.max(0, kioskTipsN     - lunchKioskTips)      : kioskTipsN;
  const netThirdPartyTips   = isDinnerWithLunch ? Math.max(0, thirdPartyTipsN- lunchThirdPartyTips) : thirdPartyTipsN;
  const netTotalTips        = isDinnerWithLunch ? Math.max(0, totalTips - lunchTotalTips) : totalTips;
  // Net sales for dinner shift (Square total minus lunch already captured)
  const netCashSalesDisp    = isDinnerWithLunch ? dinnerNetCash       : cashSalesN;
  const netCreditSalesDisp  = isDinnerWithLunch ? dinnerNetCredit     : creditSalesN;
  const netThirdPartyDisp   = isDinnerWithLunch ? dinnerNetThirdParty : thirdPartySalesN;
  const netKioskDisp        = isDinnerWithLunch ? dinnerNetKiosk      : kioskSalesN;
  const netTotalSales       = netCashSalesDisp + netCreditSalesDisp + netThirdPartyDisp + netKioskDisp;
  const tipPerEmployee   = form.workingStaff.length > 0 ? netTotalTips / form.workingStaff.length : 0;

  const staff = rest?.staff || [];
  const [showAddStaff, setShowAddStaff] = useState(false);
  const [newStaffName, setNewStaffName] = useState("");
  const fmt = (n) => `$${Math.abs(n).toFixed(2)}`;

  const addStaffMember = () => {
    const name = newStaffName.trim();
    if (!name || staff.includes(name)) return;
    const updatedRest = {...rest, staff: [...staff, name]};
    const updatedAll = (allRestaurants||[]).map(r => r.id===rest.id ? updatedRest : r);
    saveRestaurants(updatedAll);
    setNewStaffName("");
    setShowAddStaff(false);
  };

  const removeStaffMember = (name) => {
    const updatedRest = {...rest, staff: staff.filter(s=>s!==name)};
    const updatedAll = (allRestaurants||[]).map(r => r.id===rest.id ? updatedRest : r);
    saveRestaurants(updatedAll);
    set("workingStaff", form.workingStaff.filter(n=>n!==name));
  };
  const STEPS = [cr.general, cr.sales, cr.tips, cr.review];

  const toggleStaff = (name) => {
    const cur = form.workingStaff;
    set("workingStaff", cur.includes(name) ? cur.filter(n=>n!==name) : [...cur, name]);
  };

  const handleSubmit = async () => {
    if (!form.employeeName.trim()) { showToast("Employee name required"); return; }
    if (!form.date) { showToast("Date required"); return; }
    const newReport = {
      ...form, id: Date.now(), submittedAt: new Date().toISOString(),
      restaurantId: rest?.id,
      computedExpectedCash: expectedCash, computedDiscrepancy: discrepancy,
      computedCashDeposit: cashDeposit, computedTotalSales: netTotalSales,
      computedTotalTips: totalTips, computedTipPerEmployee: tipPerEmployee,
      netTotalTips: netTotalTips,
      netCreditTips: netCreditTips,
      netKioskTips: netKioskTips,
      netThirdPartyTips: netThirdPartyTips,
      netTipPerEmployee: form.workingStaff?.length ? netTotalTips / form.workingStaff.length : 0,
      // For dinner: store net sales (dinner - lunch) for accurate reporting
      netCashSales:      form.shift==="dinner" && lunchReport ? dinnerNetCash      : cashSalesN,
      netCreditSales:    form.shift==="dinner" && lunchReport ? dinnerNetCredit    : creditSalesN,
      netThirdParty:     form.shift==="dinner" && lunchReport ? dinnerNetThirdParty: thirdPartySalesN,
      netKiosk:          form.shift==="dinner" && lunchReport ? dinnerNetKiosk     : kioskSalesN,
      netTotalSales:     form.shift==="dinner" && lunchReport
        ? (dinnerNetCash + dinnerNetCredit + dinnerNetThirdParty + dinnerNetKiosk)
        : totalSales,
      lunchReportId:     lunchReport?.id || null,
    };
    const updated = [...allReports, newReport];
    saveClosingReports(updated);
    try {
      await fetch("/api/closing-report", {
        method: "POST", headers: {"Content-Type":"application/json"},
        body: JSON.stringify({ report: newReport, allReports: updated }),
      });
    } catch(e) { console.error("Email failed:", e); }
    showToast(lang==="zh"?"报告已提交 ✓":"Report submitted ✓");
    setForm(blankForm());
    setStep(0);
    setView("history");
  };

  const inp = {
    width:"100%", border:"1px solid #e5e5e5", borderRadius:9,
    padding:"10px 13px", fontSize:14, boxSizing:"border-box", outline:"none",
  };
  const inpDollar = {...inp, paddingLeft:26};
  const lbl = { fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:.5, display:"block", marginBottom:5 };
  const dollarWrap = { position:"relative" };
  const dollarSign = { position:"absolute", left:12, top:"50%", transform:"translateY(-50%)", color:"#aaa", pointerEvents:"none" };

  // History view
  if (view === "history") {
    const sorted = [...closingReports].sort((a,b) => b.id - a.id);
    return (
      <div>
        <div style={{display:"flex", gap:4, marginBottom:16, background:"#f0f0f0", borderRadius:10, padding:3, width:"fit-content"}}>
          {[["form",`Note: ${cr.newReport}`],["history",`📋 ${cr.history}`]].map(([v,l]) => (
            <button key={v} onClick={()=>setView(v)}
              style={{border:"none", borderRadius:7, padding:"7px 16px", fontSize:13, fontWeight:700, cursor:"pointer",
                background:view===v?"#1a1a1a":"transparent", color:view===v?"#fff":"#666"}}>{l}</button>
          ))}
        </div>
        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14}}>
          <h3 style={{margin:0, fontSize:16, fontWeight:700}}>Past Reports — {rest?.name}</h3>
        </div>
        {sorted.length === 0
          ? <div style={{textAlign:"center", padding:40, color:"#ccc", fontSize:14}}>No reports yet</div>
          : sorted.map(r => (
            <div key={r.id} style={{background:"#fff", borderRadius:12, padding:"14px 18px", marginBottom:8,
              border:"1px solid #e8e8e8", boxShadow:"0 1px 4px rgba(0,0,0,0.05)"}}>
              <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:8}}>
                <div>
                  <div style={{fontWeight:700, fontSize:14}}>{r.date} — <span style={{textTransform:"capitalize"}}>{r.shift}</span></div>
                  <div style={{fontSize:12, color:"#888", marginTop:2}}>by {r.employeeName} . {new Date(r.submittedAt).toLocaleTimeString("en-US",{hour:"numeric",minute:"2-digit"})}</div>
                </div>
                <div style={{display:"flex", gap:8, fontSize:13}}>
                  <div style={{textAlign:"right"}}>
                    <div style={{fontSize:11, color:"#888"}}>Sales</div>
                    <div style={{fontWeight:700}}>${(r.computedTotalSales||0).toFixed(2)}</div>
                  </div>
                  <div style={{textAlign:"right", padding:"4px 10px", borderRadius:8,
                    background:r.computedDiscrepancy>=0?"#f0faf4":"#fff5f5",
                    border:`1px solid ${r.computedDiscrepancy>=0?"#27AE60":"#E74C3C"}`}}>
                    <div style={{fontSize:11, color:"#888"}}>{cr.discrepancy}</div>
                    <div style={{fontWeight:700, color:r.computedDiscrepancy>=0?"#27AE60":"#E74C3C"}}>
                      {r.computedDiscrepancy>=0?"+":""}{(r.computedDiscrepancy||0).toFixed(2)}
                    </div>
                  </div>
                  <div style={{textAlign:"right", padding:"4px 10px", borderRadius:8, background:"#f0f8ff", border:"1px solid #2471A3"}}>
                    <div style={{fontSize:11, color:"#888"}}>Deposit</div>
                    <div style={{fontWeight:700, color:"#2471A3"}}>${Math.max(0,r.computedCashDeposit||0).toFixed(2)}</div>
                  </div>
                </div>
              </div>
            </div>
          ))
        }
      </div>
    );
  }

  return (
    <div style={{maxWidth:560}}>
      {/* View toggle */}
      <div style={{display:"flex", gap:4, marginBottom:20, background:"#f0f0f0", borderRadius:10, padding:3, width:"fit-content"}}>
        {[["form",`Note: ${cr.newReport}`],["history",`📋 ${cr.history}`]].map(([v,l]) => (
          <button key={v} onClick={()=>setView(v)}
            style={{border:"none", borderRadius:7, padding:"7px 16px", fontSize:13, fontWeight:700, cursor:"pointer",
              background:view===v?"#1a1a1a":"transparent", color:view===v?"#fff":"#666"}}>{l}</button>
        ))}
      </div>

      {/* Step indicator */}
      <div style={{display:"flex", marginBottom:24, borderRadius:10, overflow:"hidden", border:"1px solid #e5e5e5"}}>
        {STEPS.map((s,i) => (
          <div key={s} onClick={()=>i<step&&setStep(i)}
            style={{flex:1, padding:"9px 4px", textAlign:"center", fontSize:12, fontWeight:700,
              background:step===i?"#1a1a1a":step>i?"#f0f0f0":"#fff",
              color:step===i?"#fff":step>i?"#555":"#bbb",
              cursor:i<step?"pointer":"default", borderRight:i<3?"1px solid #e5e5e5":"none"}}>
            {step>i?"✓ ":""}{s}
          </div>
        ))}
      </div>

      {/* ── Step 0: General ── */}
      {step === 0 && (
        <div>
          <div style={{marginBottom:14}}>
            <label style={lbl}>{cr.employeeName}</label>
            <input value={form.employeeName} onChange={e=>set("employeeName",e.target.value)}
              placeholder={lang==="zh"?"您的姓名":"Your name"} style={inp}/>
          </div>
          <div style={{marginBottom:14}}>
            <label style={lbl}>{cr.date}</label>
            <input type="date" value={form.date} onChange={e=>set("date",e.target.value)} style={inp}/>
          </div>
          <div style={{marginBottom:14}}>
            <label style={lbl}>{cr.shift}</label>
            <div style={{display:"flex", gap:8}}>
              {[["lunch",cr.lunch],["dinner",cr.dinner],["fullday",cr.fullDay]].map(([v,l]) => (
                <button key={v} onClick={()=>set("shift",v)}
                  style={{flex:1, border:`2px solid ${form.shift===v?"#1a1a1a":"#e5e5e5"}`,
                    background:form.shift===v?"#1a1a1a":"#fff", color:form.shift===v?"#fff":"#555",
                    borderRadius:9, padding:"10px 6px", fontSize:13, fontWeight:700, cursor:"pointer"}}>
                  {l}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* ── Step 1: Sales ── */}
      {step === 1 && (
        <div>
          <div style={{marginBottom:14}}>
            <label style={lbl}>{cr.registerStart}</label>
            <div style={dollarWrap}>
              <span style={dollarSign}>$</span>
              <input type="number" step="0.01" min="0" value={form.registerStart}
                onChange={e=>set("registerStart",e.target.value)} placeholder="0.00" style={inpDollar}/>
            </div>
          </div>

            {/* Lunch report found banner — dinner shift */}
            {form.shift === "dinner" && lunchReport && (
              <div style={{background:"#f0faf4",border:"1px solid #27AE60",borderRadius:10,
                padding:"10px 14px",marginBottom:10,fontSize:12}}>
                <div style={{fontWeight:700,color:"#27AE60",marginBottom:3}}>
                  ✓ Lunch report found for {form.date}
                </div>
                <div style={{color:"#555"}}>
                  Lunch sales: ${lunchTotalSales.toFixed(2)} by {lunchReport.employeeName}
                </div>
                <div style={{color:"#888",marginTop:2}}>
                  Dinner net sales will be calculated as: Dinner total − Lunch total
                </div>
              </div>
            )}
            {form.shift === "dinner" && !lunchReport && form.date && (
              <div style={{background:"#f5f5f5",borderRadius:10,
                padding:"8px 12px",marginBottom:10,fontSize:11,color:"#aaa"}}>
                No lunch report found for {form.date} — dinner will be treated as full day
              </div>
            )}

            {/* Lunch Deposit — only for dinner shift */}
            {form.shift === "dinner" && (
              <div style={{marginTop:10,padding:"10px 12px",background:"#FFF9F0",
                border:"1px solid #F39C12",borderRadius:10}}>
                <label style={{...lbl, color:"#92400E"}}>{cr.lunchDeposit || "Lunch Deposit"}</label>
                <div style={{fontSize:11,color:"#92400E",marginBottom:6}}>
                  Amount already removed by lunch shift — will be subtracted from expected cash
                </div>
                <div style={{display:"flex",alignItems:"center",border:"1px solid #e5e5e5",
                  borderRadius:9,background:"#fff",overflow:"hidden"}}>
                  <span style={{padding:"10px 8px 10px 12px",color:"#aaa",fontSize:16,fontWeight:600}}>$</span>
                  <input type="number" step="0.01" min="0"
                    value={form.lunchDeposit !== undefined && form.lunchDeposit !== ""
                      ? form.lunchDeposit
                      : (lunchReport?.computedCashDeposit ?? "")}
                    onChange={e=>set("lunchDeposit", e.target.value)}
                    placeholder={lunchReport ? lunchReport.computedCashDeposit?.toFixed(2)||"0.00" : "0.00"}
                    style={{flex:1,border:"none",outline:"none",fontSize:16,
                      fontWeight:700,padding:"10px 8px",background:"transparent",
                      fontFamily:"'IBM Plex Sans',sans-serif"}}/>
                </div>
              </div>
            )}
          {[["cashSales",lang==="zh"?"现金销售（上报）":"Cash Sales (reported)"],["creditSales",lang==="zh"?"刷卡销售":"Credit Card Sales"],
            ["thirdPartySales",lang==="zh"?"第三方外卖销售":"3rd Party Delivery Sales"],["kioskSales",lang==="zh"?"自助机销售":"Kiosk Sales"]].map(([k,label]) => (
            <div key={k} style={{marginBottom:14}}>
              <label style={lbl}>{label}</label>
              <div style={dollarWrap}>
                <span style={dollarSign}>$</span>
                <input type="number" step="0.01" min="0" value={form[k]}
                  onChange={e=>set(k,e.target.value)} placeholder="0.00" style={inpDollar}/>
              </div>
            </div>
          ))}
          <div style={{background:"#f8f8f8", borderRadius:10, padding:"14px 16px", marginBottom:14}}>
            <div style={{fontSize:12, fontWeight:700, color:"#888", marginBottom:8, textTransform:"uppercase"}}>Summary</div>
            <div style={{display:"flex", flexDirection:"column", gap:5, fontSize:13}}>
              <div style={{display:"flex", justifyContent:"space-between"}}>
                <span style={{color:"#555"}}>{cr.totalSales}</span>
                <span style={{fontWeight:700}}>${netTotalSales.toFixed(2)}</span>
                {isDinnerWithLunch && (
                  <span style={{fontSize:11,color:"#F39C12",marginLeft:6}}>
                    (full day ${totalSales.toFixed(2)} − lunch ${lunchTotalSales.toFixed(2)})
                  </span>
                )}
              </div>
              <div style={{display:"flex", justifyContent:"space-between"}}>
                <span style={{color:"#555"}}>{cr.expectedCash}</span>
                <span style={{fontWeight:700}}>${expectedCash.toFixed(2)}</span>
                {lunchDepositN > 0 && (
                  <span style={{fontSize:11,color:"#F39C12",marginLeft:6}}>
                    (−${lunchDepositN.toFixed(2)} lunch deposit)
                  </span>
                )}
              </div>
            </div>
          </div>
          <div style={{marginBottom:14}}>
            <label style={lbl}>{cr.actualCash}</label>
            <div style={dollarWrap}>
              <span style={dollarSign}>$</span>
              <input type="number" step="0.01" min="0" value={form.actualCash}
                onChange={e=>set("actualCash",e.target.value)} placeholder="0.00" style={inpDollar}/>
            </div>
          </div>
          {form.actualCash !== "" && (
            <div style={{display:"flex", gap:10}}>
              <div style={{flex:1, background:discrepancy>=0?"#f0faf4":"#fff5f5",
                border:`1px solid ${discrepancy>=0?"#27AE60":"#E74C3C"}`, borderRadius:10, padding:"12px 14px", textAlign:"center"}}>
                <div style={{fontSize:11, fontWeight:700, color:"#888", marginBottom:4}}>{cr.discrepancy}</div>
                <div style={{fontSize:18, fontWeight:800, color:discrepancy>=0?"#27AE60":"#E74C3C"}}>
                  {discrepancy>=0?"+":"-"}{fmt(discrepancy)}
                </div>
              </div>
              <div style={{flex:1, background:"#f0f8ff", border:"1px solid #2471A3", borderRadius:10, padding:"12px 14px", textAlign:"center"}}>
                <div style={{fontSize:11, fontWeight:700, color:"#888", marginBottom:4}}>{cr.deposit}</div>
                <div style={{fontSize:18, fontWeight:800, color:"#2471A3"}}>{fmt(Math.max(0,cashDeposit))}</div>
                <div style={{fontSize:10, color:"#aaa", marginTop:2}}>{cr.deposit}</div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* ── Step 2: Tips ── */}
      {step === 2 && (
        <div>
          {[["creditTips",lang==="zh"?"💳 信用卡小费":"💳 Credit Card Tips"],["kioskTips",lang==="zh"?"🖥 自助机小费":"🖥 Kiosk Tips"],["thirdPartyTips",lang==="zh"?"🛵 第三方小费":"🛵 3rd Party Tips"]].map(([k,label]) => (
            <div key={k} style={{marginBottom:14}}>
              <label style={lbl}>{label}</label>
              <div style={dollarWrap}>
                <span style={dollarSign}>$</span>
                <input type="number" step="0.01" min="0" value={form[k]}
                  onChange={e=>set(k,e.target.value)} placeholder="0.00" style={inpDollar}/>
              </div>
            </div>
          ))}
          <div style={{marginBottom:14}}>
            <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8}}>
              <label style={{...lbl, marginBottom:0}}>Working Staff</label>
              {!isCashier && (
                <button onClick={()=>setShowAddStaff(v=>!v)}
                  style={{background:"none", border:"1px solid #e5e5e5", borderRadius:7, padding:"4px 10px",
                    fontSize:12, fontWeight:600, cursor:"pointer", color:"#555"}}>
                  {showAddStaff ? "✕" : cr.addStaff}
                </button>
              )}
            </div>

            {/* Add staff inline form - manager only */}
            {showAddStaff && !isCashier && (
              <div style={{display:"flex", gap:7, marginBottom:10}}>
                <input value={newStaffName} onChange={e=>setNewStaffName(e.target.value)}
                  onKeyDown={e=>e.key===lang==="zh"?"输入":"Enter"&&addStaffMember()}
                  placeholder={lang==="zh"?"新员工姓名...":"New employee name..."}
                  style={{flex:1, border:"1px solid #e5e5e5", borderRadius:8, padding:"7px 10px", fontSize:13}}/>
                <button onClick={addStaffMember}
                  style={{background:"#1a1a1a", color:"#fff", border:"none", borderRadius:8,
                    padding:"7px 14px", fontSize:13, fontWeight:700, cursor:"pointer"}}>Add</button>
              </div>
            )}

            {/* Staff list */}
            {staff.length === 0
              ? <div style={{fontSize:13, color:"#aaa", padding:"8px 0"}}>
                  {isCashier ? lang==="zh"?"暂无员工，请联系管理员添加":"No staff added yet" : lang==="zh"?"暂无员工，请上方添加":"No staff yet"}
                </div>
              : <div style={{display:"flex", flexWrap:"wrap", gap:7}}>
                  {staff.map(name => {
                    const on = form.workingStaff.includes(name);
                    return (
                      <div key={name} style={{display:"flex", alignItems:"center", gap:0,
                        border:`2px solid ${on?"#1a1a1a":"#e5e5e5"}`,
                        background:on?"#1a1a1a":"#fff", borderRadius:20, overflow:"hidden"}}>
                        <button onClick={()=>toggleStaff(name)}
                          style={{background:"none", border:"none", padding:"6px 12px",
                            color:on?"#fff":"#555", fontSize:13, fontWeight:600, cursor:"pointer"}}>
                          {name}
                        </button>
                        {!isCashier && (
                          <button onClick={()=>removeStaffMember(name)}
                            style={{background:"none", border:"none", borderLeft:`1px solid ${on?"rgba(255,255,255,0.3)":"#e5e5e5"}`,
                              padding:"6px 8px", color:on?"rgba(255,255,255,0.7)":"#ccc",
                              fontSize:12, cursor:"pointer", lineHeight:1}}>×</button>
                        )}
                      </div>
                    );
                  })}
                </div>
            }
          </div>
          {totalTips > 0 && form.workingStaff.length > 0 && (
            <div style={{background:"#f8f8f8", borderRadius:10, padding:"14px 16px"}}>
              <div style={{fontSize:12, fontWeight:700, color:"#888", marginBottom:8, textTransform:"uppercase"}}>Tip Breakdown</div>
              <div style={{display:"flex", justifyContent:"space-between", marginBottom:4, fontSize:13}}>
                <span style={{color:"#555"}}>{cr.totalTips}</span>
                <span style={{fontWeight:700}}>${netTotalTips.toFixed(2)}</span>
                {form.shift==="dinner" && lunchReport && lunchTotalTips>0 && (
                  <span style={{fontSize:11,color:"#F39C12",marginLeft:6}}>
                    (−${lunchTotalTips.toFixed(2)} lunch)
                  </span>
                )}
              </div>
              <div style={{display:"flex", justifyContent:"space-between", marginBottom:10, fontSize:13}}>
                <span style={{color:"#555"}}>{form.workingStaff.length} employee{form.workingStaff.length!==1?"s":""}</span>
                <span style={{fontWeight:800, color:"#27AE60", fontSize:15}}>${tipPerEmployee.toFixed(2)} each</span>
              </div>
              <div style={{display:"flex", flexWrap:"wrap", gap:6}}>
                {form.workingStaff.map(name => (
                  <div key={name} style={{background:"#fff", border:"1px solid #e5e5e5", borderRadius:8, padding:"5px 10px", fontSize:12}}>
                    {name} <span style={{fontWeight:700, color:"#27AE60"}}>${tipPerEmployee.toFixed(2)}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      {/* ── Step 3: Review ── */}
      {step === 3 && (
        <div style={{display:"flex", flexDirection:"column", gap:14}}>
          <div style={{background:"#f8f8f8", borderRadius:10, padding:"14px 16px"}}>
            <div style={{fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", marginBottom:8}}>General</div>
            <div style={{fontSize:13, display:"flex", flexDirection:"column", gap:4}}>
              <div><span style={{color:"#888"}}>Employee: </span><strong>{form.employeeName}</strong></div>
              <div><span style={{color:"#888"}}>Date: </span><strong>{form.date}</strong></div>
              <div><span style={{color:"#888"}}>Shift: </span><strong style={{textTransform:"capitalize"}}>{form.shift}</strong></div>
              <div><span style={{color:"#888"}}>Location: </span><strong>{rest?.name}</strong></div>
            </div>
          </div>
          <div style={{background:"#f8f8f8", borderRadius:10, padding:"14px 16px"}}>
            <div style={{fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", marginBottom:8}}>Sales</div>
            <div style={{fontSize:13, display:"flex", flexDirection:"column", gap:4}}>
              {[[lang==="zh"?"现金销售":"Cash Sales",form.cashSales],[lang==="zh"?"刷卡销售":"Credit Card Sales",form.creditSales],
                ["3rd Party Sales",form.thirdPartySales],[lang==="zh"?"自助机销售":"Kiosk Sales",form.kioskSales]].map(([l,v]) => (
                <div key={l} style={{display:"flex", justifyContent:"space-between"}}>
                  <span style={{color:"#888"}}>{l}</span><span>${parseFloat(v||0).toFixed(2)}</span>
                </div>
              ))}
              <div style={{display:"flex", justifyContent:"space-between", borderTop:"1px solid #e5e5e5", paddingTop:6, marginTop:2}}>
                <span style={{fontWeight:700}}>{cr.totalSales}</span><span style={{fontWeight:700}}>${totalSales.toFixed(2)}</span>
              </div>
            </div>
            <div style={{display:"flex", gap:8, marginTop:10}}>
              <div style={{flex:1, padding:"10px 12px", borderRadius:8,
                background:discrepancy>=0?"#f0faf4":"#fff5f5", border:`1px solid ${discrepancy>=0?"#27AE60":"#E74C3C"}`}}>
                <div style={{fontSize:10, fontWeight:700, color:"#888"}}>{cr.discrepancy}</div>
                <div style={{fontSize:16, fontWeight:800, color:discrepancy>=0?"#27AE60":"#E74C3C"}}>
                  {discrepancy>=0?"+":"-"}{fmt(discrepancy)}
                </div>
              </div>
              <div style={{flex:1, padding:"10px 12px", borderRadius:8, background:"#f0f8ff", border:"1px solid #2471A3"}}>
                <div style={{fontSize:10, fontWeight:700, color:"#888"}}>{cr.deposit}</div>
                <div style={{fontSize:16, fontWeight:800, color:"#2471A3"}}>{fmt(Math.max(0,cashDeposit))}</div>
              </div>
            </div>
          </div>
          <div style={{background:"#f8f8f8", borderRadius:10, padding:"14px 16px"}}>
            <div style={{fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", marginBottom:8}}>Tips</div>
            <div style={{fontSize:13, display:"flex", flexDirection:"column", gap:4}}>
              {[[lang==="zh"?"信用卡":lang==="zh"?"💳 信用卡":"💳 Credit Card",form.creditTips],[lang==="zh"?"自助机":"Kiosk",form.kioskTips],["3rd Party",form.thirdPartyTips]].map(([l,v]) => (
                <div key={l} style={{display:"flex", justifyContent:"space-between"}}>
                  <span style={{color:"#888"}}>{l} Tips</span><span>${parseFloat(v||0).toFixed(2)}</span>
                </div>
              ))}
              <div style={{display:"flex", justifyContent:"space-between", borderTop:"1px solid #e5e5e5", paddingTop:6, marginTop:2}}>
                <span style={{fontWeight:700}}>{cr.totalTips}</span><span style={{fontWeight:700}}>${totalTips.toFixed(2)}</span>
              </div>
              {form.workingStaff.length > 0 && (
                <div style={{display:"flex", justifyContent:"space-between", marginTop:2}}>
                  <span style={{color:"#888"}}>Per Employee ({form.workingStaff.length})</span>
                  <span style={{fontWeight:800, color:"#27AE60"}}>${tipPerEmployee.toFixed(2)}</span>
                </div>
              )}
            </div>
            {form.workingStaff.length > 0 && (
              <div style={{marginTop:8, fontSize:12, color:"#888"}}>Staff: {form.workingStaff.join(", ")}</div>
            )}
          </div>
        </div>
      )}

      {/* Navigation */}
      <div style={{display:"flex", gap:10, marginTop:20}}>
        {step > 0 && (
          <button onClick={()=>setStep(s=>s-1)}
            style={{flex:1, background:"#f0f0f0", border:"none", borderRadius:10, padding:13,
              fontWeight:700, fontSize:14, cursor:"pointer", color:"#555"}}>
            {lang==="zh"?"← 返回":"← Back"}
          </button>
        )}
        {step < 3 ? (
          <button onClick={()=>setStep(s=>s+1)}
            style={{flex:2, background:"#1a1a1a", border:"none", borderRadius:10, padding:13,
              fontWeight:700, fontSize:14, cursor:"pointer", color:"#fff"}}>
            Next →
          </button>
        ) : (
          <button onClick={handleSubmit}
            style={{flex:2, background:"#27AE60", border:"none", borderRadius:10, padding:13,
              fontWeight:700, fontSize:15, cursor:"pointer", color:"#fff",
              boxShadow:"0 4px 14px rgba(39,174,96,0.3)"}}>
            {cr.submit}
          </button>
        )}
      </div>
    </div>
  );
}


// ── Custom Order Tab ──────────────────────────────────────────────────────────
function CustomOrderTab({ rest, onReview, showToast, products, allCategories, catOrder=[], t, pName, fmtPrice, lang, hidePrice=false, parLevels={}, activeRestId=null }) {
  // Par lookup helper
  const _restId2 = activeRestId ?? rest?.id;
  const _parSlice2 = parLevels?.[_restId2] ?? parLevels?.[String(_restId2)] ?? parLevels?.[Number(_restId2)] ?? {};
  const _parNorm2 = Object.fromEntries(Object.entries(_parSlice2).map(([k,v])=>[String(k),v]));
  const getParCustom = (pid) => _parNorm2?.[String(pid)]?.par ?? _parNorm2?.[pid]?.par ?? 0;

  const _allCatsSet = [...new Set([
    ...products.map(p => p.category).filter(Boolean),
    ...(allCategories||[])
  ])];
  const cats = [
    ...(catOrder||[]).filter(c => _allCatsSet.includes(c)),
    ..._allCatsSet.filter(c => !(catOrder||[]).includes(c)).sort(),
  ];
  const [activeCategory, setActiveCategory] = useState(null);
  const DRAFT_KEY = `custom_draft_${rest?.id}`;
  const DIRTY_KEY  = `custom_dirty_${rest?.id}`;

  // Load draft on mount
  const loadDraft = () => {
    try {
      const d = localStorage.getItem(DRAFT_KEY);
      return d ? JSON.parse(d) : null;
    } catch(e) { return null; }
  };
  const draft = loadDraft();

  const [activeSection, setActiveSection] = useState("items");
  const [qtys, setQtys] = useState(draft?.qtys || {});
  const [note, setNote] = useState(draft?.note || "");
  const [specialRequest, setSpecialRequest] = useState(draft?.specialRequest || "");
  const [draftSaved, setDraftSaved] = useState(false);
  const [pickerProduct, setPickerProduct] = useState(null);
  const [pickerInput, setPickerInput] = useState("");

  const markDirty = (overrideQtys) => {
    try {
      sessionStorage.setItem(DIRTY_KEY, "1");
      // Auto-save to localStorage on every change
      localStorage.setItem(DRAFT_KEY, JSON.stringify({
        qtys: overrideQtys ?? qtys,
        note,
        specialRequest
      }));
    } catch(e) {}
  };
  const saveDraft = () => {
    try {
      localStorage.setItem(DRAFT_KEY, JSON.stringify({ qtys, note, specialRequest }));
      sessionStorage.removeItem(DIRTY_KEY);
      setDraftSaved(true);
      showToast("Progress saved — come back anytime");
      setTimeout(() => setDraftSaved(false), 3000);
    } catch(e) { showToast("Could not save draft"); }
  };
  const clearDraft = () => {
    try {
      localStorage.removeItem(DRAFT_KEY);
      sessionStorage.removeItem(DIRTY_KEY);
    } catch(e) {}
  };

  const visibleProducts = products.filter(p =>
    !activeCategory || p.category === activeCategory
  );

  const setQty = (id, val) => {
    const n = parseFloat(val) || 0;
    setQtys(q => {
      const next = n > 0 ? {...q, [id]: n} : Object.fromEntries(Object.entries(q).filter(([k])=>k!==id));
      markDirty(next);
      return next;
    });
  };

  const [pickerFresh, setPickerFresh] = useState(true); // true = next digit replaces instead of appends

  const openPicker = (p) => {
    setPickerProduct(p);
    setPickerInput(String(qtys[p.id] || ""));
    setPickerFresh(true); // first keypress will replace the pre-filled value
  };

  const closePicker = () => {
    setPickerProduct(null);
    setPickerInput("");
    setPickerFresh(true);
  };

  const pickerDone = () => {
    if (pickerProduct) setQty(pickerProduct.id, pickerInput === "" ? 0 : pickerInput);
    closePicker();
  };

  const pickerKey = (k) => {
    if (k === "⌫") {
      setPickerFresh(false);
      setPickerInput(p => p.slice(0, -1));
    } else if (k === "✓") {
      pickerDone();
      return;
    } else if (k === "½") {
      pickerDone();
      return;
    } else if (k === ".") {
      setPickerFresh(false);
      setPickerInput(p => {
        const cur = pickerFresh ? "" : p;
        if (cur.includes(".")) return cur; // already has decimal
        if (cur === "" || cur === "0") return "0.";
        return cur + ".";
      });
    } else {
      if (pickerFresh) {
        setPickerInput(k === "0" ? "" : k);
        setPickerFresh(false);
      } else if (pickerInput.length < 6) {
        setPickerInput(p => p + k);
      }
    }
  };

  const orderCount = Object.values(qtys).filter(v=>v>0).length;

  const handleReview = () => {
    const items = Object.entries(qtys)
      .filter(([,qty]) => qty > 0)
      .map(([productId, qty]) => {
        const p = products.find(x => x.id === parseInt(productId) || x.id === productId);
        return { productId: p?.id, name: p?.name || "Unknown", unit: p?.unit || "", qty };
      });
    const combinedNote = [note, specialRequest ? `Special requests: ${specialRequest}` : ""].filter(Boolean).join(" | ");
    if (items.length === 0 && !specialRequest.trim()) { showToast("Add items or a special request"); return; }
    clearDraft();
    onReview(items, combinedNote);
  };

  const KEYS = ["1","2","3","4","5","6","7","8","9","⌫","0",".","½"];

  return (
    <div style={{paddingBottom: orderCount>0 ? 80 : 0}}>

      {/* Category filter + Notes pill */}
      <div style={{display:"flex", gap:6, flexWrap:"wrap", marginBottom:16}}>
        <button onClick={()=>{setActiveSection("items");setActiveCategory(null);}}
          style={{border:"none", borderRadius:20, padding:"5px 14px", fontSize:12, fontWeight:600, cursor:"pointer",
            background: activeSection==="items" && !activeCategory ? "#1a1a1a" : "#f0f0f0",
            color: activeSection==="items" && !activeCategory ? "#fff" : "#555"}}>
          {lang==="zh" ? "全部" : "All"}
        </button>
        {cats.map(c => (
          <button key={c} onClick={()=>{setActiveSection("items");setActiveCategory(c===activeCategory?null:c);}}
            style={{border:"none", borderRadius:20, padding:"5px 14px", fontSize:12, fontWeight:600, cursor:"pointer",
              background: activeSection==="items" && activeCategory===c ? "#1a1a1a" : "#f0f0f0",
              color: activeSection==="items" && activeCategory===c ? "#fff" : "#555"}}>
            {t.cats?.[c]||c}
          </button>
        ))}
        {/* Notes pill — last in the row */}
        <button onClick={()=>setActiveSection("notes")}
          style={{border:"none", borderRadius:20, padding:"5px 14px", fontSize:12, fontWeight:600,
            cursor:"pointer", position:"relative",
            background: activeSection==="notes" ? "#F39C12" : "#f0f0f0",
            color: activeSection==="notes" ? "#fff" : "#555"}}>
          {lang==="zh" ? "Note: 其他" : "Note: Notes"}
          {specialRequest.trim() && activeSection!=="notes" && (
            <span style={{position:"absolute", top:2, right:2, width:7, height:7,
              borderRadius:"50%", background:"#F39C12", border:"2px solid #fff"}}/>
          )}
        </button>
      </div>

      {/* ── Items section ── */}
      {activeSection === "items" && (<>

      {/* Product list */}
      <div style={{display:"flex", flexDirection:"column", gap:2, marginBottom:16}}>
        {visibleProducts.map(p => {
          const qty = qtys[p.id] || 0;
          const active = qty > 0;
          return (
            <div key={p.id}
              onClick={()=>openPicker(p)}
              style={{display:"flex", alignItems:"center", gap:12, padding:"13px 16px",
                background: active ? "#f0faf4" : "#fff", borderRadius:12,
                border: `1px solid ${active ? "#27AE60" : "#eee"}`,
                transition:"all .12s", cursor:"pointer", userSelect:"none"}}>
              {/* Left: name + unit */}
              <div style={{flex:1, minWidth:0}}>
                <div style={{fontWeight:600, fontSize:15, color:"#1a1a1a"}}>{pName(p)}</div>
                <div style={{fontSize:12, color:"#aaa", marginTop:2}}>
                  {p.unit}
                  {getParCustom(p.id) > 0 && <span style={{marginLeft:5,color:"#2471A3",fontWeight:700,fontSize:11}}>Par: {getParCustom(p.id)}</span>}
                  {!hidePrice && p.price != null ? ` · ${fmtPrice(p)}` : ""}
                </div>
              </div>
              {/* Right: qty badge or add prompt */}
              <div style={{flexShrink:0}}>
                {active ? (
                  <div style={{
                    background:"#27AE60", color:"#fff", borderRadius:10,
                    padding:"6px 16px", fontWeight:800, fontSize:16, minWidth:44, textAlign:"center"
                  }}>{qty}</div>
                ) : (
                  <div style={{
                    background:"#f0f0f0", color:"#aaa", borderRadius:10,
                    padding:"6px 14px", fontWeight:600, fontSize:13
                  }}>+ Add</div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Order note inside items tab */}
      <div style={{fontSize:11,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:.8,marginBottom:6}}>Note: {lang==="zh"?"订单备注":"Order Note"}</div>
      <textarea value={note} onChange={e=>{setNote(e.target.value); markDirty();}}
        placeholder={lang==="zh" ? "添加工厂备注（可选）..." : "Add a note for the factory (optional)..."}
        style={{width:"100%", border:`1.5px solid ${note?"#F39C12":"#ccc"}`, borderRadius:10, padding:"10px 14px",
          fontSize:13, color:"#333", resize:"vertical", minHeight:60, marginBottom:14,
          boxSizing:"border-box",
          background: note ? "#FFFBEB" : "#fff", transition:"all .2s"}}/>

      </>)}

      {/* ── Notes / Other section ── */}
      {activeSection === "notes" && (
        <div>
          <div style={{marginBottom:20}}>
            <div style={{fontWeight:700, fontSize:15, color:"#1a1a1a", marginBottom:4}}>
              {lang==="zh" ? "特殊请求" : "Special Requests"}
            </div>
            <div style={{fontSize:13, color:"#aaa", marginBottom:12}}>
              {lang==="zh" ? "请求未列出的商品或添加任何其他备注" : "Request items not on the list, or add any other notes for the factory"}
            </div>
            <textarea
              value={specialRequest}
              onChange={e=>{setSpecialRequest(e.target.value); markDirty();}}
              placeholder={lang==="zh" ? "例如：需要额外的酱料、特殊包装要求..." : "e.g. Need extra sauces, special packaging requests, low stock alerts..."}
              rows={6}
              style={{width:"100%", border:`1.5px solid ${specialRequest?"#F39C12":"#e5e5e5"}`,
                borderRadius:12, padding:"14px 16px", fontSize:14, color:"#333",
                resize:"vertical", boxSizing:"border-box", outline:"none",
                background: specialRequest ? "#FFFBEB" : "#fff",
                fontFamily:"'IBM Plex Sans',sans-serif", lineHeight:1.6,
                transition:"all .2s"}}
            />
            {specialRequest.trim() && (
              <div style={{marginTop:8, fontSize:12, color:"#F39C12", fontWeight:600}}>
                ✓ {lang==="zh" ? "备注已添加，将随订单发送" : "Note added — will be sent with your order"}
              </div>
            )}
          </div>
          {/* Submit from notes tab too */}
          <div style={{display:"flex", gap:8, marginBottom:8}}>
            <button onClick={saveDraft}
              style={{flex:1, padding:"11px", borderRadius:10, border:"1px solid #e5e5e5",
                background: draftSaved ? "#f0faf4" : "#fff",
                color: draftSaved ? "#27AE60" : "#888",
                fontSize:13, fontWeight:700, cursor:"pointer", transition:"all .2s"}}>
              {draftSaved ? (lang==="zh"?"✓ 已保存!":"✓ Saved!") : (lang==="zh"?"💾 稍后完成":"💾 Finish Later")}
            </button>
          </div>
          <button onClick={handleReview}
            disabled={orderCount===0 && !specialRequest.trim()}
            style={{width:"100%", padding:"14px", borderRadius:12, border:"none",
              background: (orderCount>0||specialRequest.trim()) ? "#1a1a1a" : "#f0f0f0",
              color: (orderCount>0||specialRequest.trim()) ? "#fff" : "#aaa",
              fontSize:15, fontWeight:700,
              cursor: (orderCount>0||specialRequest.trim()) ? "pointer" : "not-allowed"}}>
            {orderCount > 0
              ? `${lang==="zh"?"提交订单":"Submit Order"} (${orderCount} ${lang==="zh"?"件":"item"}${orderCount!==1&&lang!=="zh"?"s":""}${specialRequest.trim()?" + note":""})`
              : lang==="zh" ? "提交备注" : "Submit Note Only"}
          </button>
        </div>
      )}

      {/* Sticky cart bar */}
      {orderCount > 0 && (
        <div style={{position:"fixed", bottom:0, left:0, right:0, zIndex:200,
          padding:"12px 16px", background:"#fff", borderTop:"1px solid #e8e8e8",
          boxShadow:"0 -4px 20px rgba(0,0,0,0.08)"}}>
          <div style={{display:"flex", gap:8, marginBottom:8}}>
            <button onClick={saveDraft}
              style={{flex:1, padding:"10px", borderRadius:10, border:"1px solid #e5e5e5",
                background: draftSaved ? "#f0faf4" : "#fff",
                color: draftSaved ? "#27AE60" : "#888",
                fontSize:13, fontWeight:700, cursor:"pointer", transition:"all .2s"}}>
              {draftSaved ? (lang==="zh"?"✓ 已保存!":"✓ Saved!") : (lang==="zh"?"💾 稍后完成":"💾 Finish Later")}
            </button>
          </div>
          <button onClick={handleReview}
            style={{width:"100%", padding:"15px", borderRadius:12, border:"none",
              background:"#1a1a1a", color:"#fff", fontSize:16, fontWeight:700, cursor:"pointer",
              display:"flex", alignItems:"center", justifyContent:"center", gap:10}}>
            <span style={{background:"#fff", color:"#1a1a1a", borderRadius:20,
              padding:"2px 10px", fontSize:13, fontWeight:800}}>{orderCount}</span>
            {lang==="zh"?"审核订单 →":"Review Order →"}
          </button>
        </div>
      )}

      {/* Qty picker modal */}
      {pickerProduct && (
        <div style={{position:"fixed", inset:0, zIndex:400, display:"flex", flexDirection:"column", justifyContent:"flex-end"}}
          onClick={closePicker}>
          <div style={{background:"#fff", borderRadius:"20px 20px 0 0", padding:"20px 16px 32px",
            boxShadow:"0 -8px 40px rgba(0,0,0,0.18)"}}
            onClick={e=>e.stopPropagation()}>

            {/* Product name + current input display */}
            <div style={{marginBottom:16, textAlign:"center"}}>
              <div style={{fontWeight:700, fontSize:17, color:"#1a1a1a"}}>{pName(pickerProduct)}</div>
              <div style={{fontSize:12, color:"#aaa", marginTop:2}}>
                {pickerProduct.unit}{!hidePrice && pickerProduct.price != null ? ` . ${fmtPrice(pickerProduct)}` : ""}
              </div>
              <div style={{
                fontSize:48, fontWeight:800,
                color: pickerInput === "" ? "#ddd" : pickerInput === "0" ? "#E74C3C" : "#1a1a1a",
                letterSpacing:4, marginTop:12, minHeight:60, lineHeight:1
              }}>
                {pickerInput === "" ? "0" : pickerInput}
              </div>
              {pickerInput === "0" && (
                <div style={{fontSize:12, color:"#E74C3C", fontWeight:600, marginTop:4}}>
                  Will remove from order
                </div>
              )}
            </div>

            {/* Numpad grid */}
            <div style={{display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:10, maxWidth:320, margin:"0 auto"}}>
              {KEYS.map(k => (
                <button key={k} onClick={()=>pickerKey(k)}
                  style={{
                    height:64, borderRadius:14, border:"none", cursor:"pointer",
                    fontSize: k==="½" ? 18 : k==="⌫" ? 20 : 24,
                    fontWeight:700,
                    gridColumn: k==="½" ? "1 / -1" : "auto",
                    background: k==="½" ? "#1a1a1a" : k==="⌫" ? "#f5f5f5" : "#f0f0f0",
                    color: k==="½" ? "#fff" : k==="⌫" ? "#888" : "#1a1a1a",
                    transition:"background .1s"
                  }}>
                  {k==="½" ? "✓  Submit" : k}
                </button>
              ))}
            </div>

            {/* Remove button if qty already set */}
            {(qtys[pickerProduct.id]||0) > 0 && (
              <button onClick={(e)=>{
                  e.stopPropagation();
                  const id = pickerProduct.id;
                  setQtys(q => {
                    const next = {...q};
                    delete next[id];
                    markDirty(next);
                    return next;
                  });
                  closePicker();
                }}
                style={{width:"100%", marginTop:12, padding:"12px", borderRadius:12, border:"none",
                  background:"#fff5f5", color:"#E74C3C", fontSize:14, fontWeight:700, cursor:"pointer",
                  maxWidth:320, display:"block", marginLeft:"auto", marginRight:"auto"}}>
                Remove from order
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}


function InventoryTab({rest,inventory,parLevels,activeRestId,setParLevels,setInventory,onReview,showToast,products,allCategories,catOrder=[],t,pName,fmtPrice,savePars,catVisibility,lang="en",hidePrice=false,inventoryAddOns=[]}) {
  const [showPaperModal, setShowPaperModal] = useState(false);
  const [paperQtys, setPaperQtys] = useState({});
  const [pendingOrder, setPendingOrder] = useState(null);
  // TEMP DEBUG
  const _debugPar = JSON.stringify(parLevels).slice(0, 200);
  const isMobile = typeof window !== "undefined" && window.innerWidth < 600;

  // ── Inventory numpad picker state ──
  // ── Inventory numpad — ref-based so keystrokes never cause re-renders ──
  const [invPickerProduct, setInvPickerProduct] = useState(null);
  const invPickerProductRef = useRef(null);  // mirror for use inside event handlers
  const invBufRef   = useRef("");            // raw string buffer
  const invFreshRef = useRef(true);          // true = next digit replaces pre-fill
  const invHasPrevRef = useRef(false);       // was this product already counted?
  const invDisplayRef = useRef(null);        // <div> showing the number
  const invClearBtnRef = useRef(null);       // "Clear" button, shown/hidden via style
  const INV_KEYS = ["1","2","3","4","5","6","7","8","9","⌫","0",".","✓"];

  const _invSetDisplay = (val) => {
    if (invDisplayRef.current) {
      invDisplayRef.current.textContent = val === "" ? "—" : val;
      invDisplayRef.current.style.color  = val === "" ? "#ccc" : "#1a1a1a";
    }
  };

  const openInvPicker = (p) => {
    const cur = stock[p.id];
    const curStr = (cur !== null && cur !== undefined) ? String(cur) : "";
    invBufRef.current   = curStr;
    invFreshRef.current = true;
    invHasPrevRef.current = cur !== null && cur !== undefined;
    invPickerProductRef.current = p;
    setInvPickerProduct(p);   // single setState just to mount the modal
    // display will be set after mount via the ref
    setTimeout(() => _invSetDisplay(curStr), 0);
    if (invClearBtnRef.current) invClearBtnRef.current.style.display = invHasPrevRef.current ? "block" : "none";
  };

  const closeInvPicker = () => {
    invBufRef.current = "";
    invFreshRef.current = true;
    invPickerProductRef.current = null;
    setInvPickerProduct(null);
  };

  const commitInvPicker = () => {
    const p = invPickerProductRef.current;
    if (p) {
      const val = invBufRef.current === "" ? null : parseFloat(invBufRef.current);
      if (val === null || isNaN(val)) {
        setStockDirty(s2 => { const n={...s2}; delete n[p.id]; return n; });
      } else {
        setStockDirty(s2 => ({...s2, [p.id]: val}));
      }
    }
    closeInvPicker();
  };

  const invPickerKey = (k) => {
    if (k === "✓") { commitInvPicker(); return; }
    let buf = invBufRef.current;
    const fresh = invFreshRef.current;
    if (k === "⌫") {
      buf = fresh ? "" : buf.slice(0, -1);
      invFreshRef.current = false;
    } else if (k === ".") {
      if (fresh) { buf = "0."; invFreshRef.current = false; }
      else if (!buf.includes(".") && buf.length < 6) buf = (buf === "" || buf === "0" ? "0." : buf + ".");
    } else {
      if (fresh) { buf = k === "0" ? "0" : k; invFreshRef.current = false; }
      else if (buf.length < 6) buf = buf + k;
    }
    invBufRef.current = buf;
    _invSetDisplay(buf);
  };
  const DRAFT_KEY = `inv_draft_${rest?.id}`;
  const DIRTY_KEY  = `inv_dirty_${rest?.id}`;
  const [activeCategory, setActiveCategory] = useState(null);
  const [stock, setStock] = useState(() => {
    // Load saved draft first, otherwise start completely blank
    try {
      const draft = localStorage.getItem(DRAFT_KEY);
      if (draft) return JSON.parse(draft);
    } catch(e) {}
    return {};
  });
  // Normalize parLevels - always read live from prop so updates are instant
  // Get the restaurant slice from full parLevels using all possible key formats
  const _restId = activeRestId ?? rest?.id;
  const _parSlice = parLevels?.[_restId] 
    ?? parLevels?.[String(_restId)] 
    ?? parLevels?.[Number(_restId)] 
    ?? {};
  // Normalize product keys to strings
  const _parNorm = Object.fromEntries(Object.entries(_parSlice).map(([k,v])=>[String(k),v]));
  
  const getPar = (productId) => {
    const asStr = String(productId);
    const asNum = Number(productId);
    return _parNorm?.[asStr]?.par ?? _parNorm?.[asNum]?.par ?? _parNorm?.[productId]?.par ?? 0;
  };
  // localPar only used for editable par inputs in the par-setting UI
  const [localPar, setLocalPar] = useState({});
  useEffect(() => {
    if (parLevels && Object.keys(parLevels).length > 0) {
      const out = {};
      Object.entries(parLevels).forEach(([k,v]) => { out[String(k)] = v; });
      setLocalPar(out);
    }
  }, [parLevels]);
    const [orderNote, setOrderNote] = useState("");
  const [draftSaved, setDraftSaved] = useState(false);

  // Mark dirty in sessionStorage whenever stock changes
  const setStockDirty = (updater) => {
    setStock(prev => {
      const next = typeof updater === "function" ? updater(prev) : updater;
      try {
        sessionStorage.setItem(DIRTY_KEY, "1");
        // Auto-save to localStorage on every change
        localStorage.setItem(DRAFT_KEY, JSON.stringify(next));
      } catch(e) {}
      return next;
    });
  };

  const saveDraft = () => {
    try {
      localStorage.setItem(DRAFT_KEY, JSON.stringify(stock));
      sessionStorage.removeItem(DIRTY_KEY);
      setDraftSaved(true);
      showToast("Progress saved — come back anytime");
      setTimeout(() => setDraftSaved(false), 3000);
    } catch(e) { showToast("Could not save draft"); }
  };

  const clearDraft = () => {
    try {
      localStorage.removeItem(DRAFT_KEY);
      sessionStorage.removeItem(DIRTY_KEY);
    } catch(e) {}
  };

  const _invCatSet = [...new Set([...products.map(p => p.category), ...(allCategories||[])])]
    .filter(cat => !(catVisibility?.[rest?.id]||[]).includes(cat));
  const categories = [
    ...(catOrder||[]).filter(c => _invCatSet.includes(c)),
    ..._invCatSet.filter(c => !(catOrder||[]).includes(c)).sort(),
  ];

  const getOrderQty = (p) => {
    const par = getPar(p.id);
    const s = stock[p.id] ?? stock[String(p.id)] ?? null;
    if (s === null || s === undefined) return 0;
    return Math.max(0, Math.ceil(par - s));
  };

  const orderItems = products.filter(p => {
    const s = stock[p.id];
    return s !== null && s !== undefined && getOrderQty(p) > 0;
  });

  const getCatStats = (cat) => {
    const prods = products.filter(p => p.category === cat);
    const counted = prods.filter(p => stock[p.id] !== null && stock[p.id] !== undefined).length;
    const needOrder = prods.filter(p => {
      const s = stock[p.id];
      return (s !== null && s !== undefined) && getOrderQty(p) > 0;
    }).length;
    return { total: prods.length, counted, needOrder };
  };

  const CATEGORY_ICONS = {
    "Buns":"🥟","Doughs":"🌾","Frozen Dumplings":"❄️",
    "Meats":"🥩","Paper Goods":"📦","Sauces":"🫙",
    "Sides":"🥗","Soup":"🍜","Vegetables":"🥬",
  };


  const displayCat = activeCategory || categories[0];
  const displayProducts = products.filter(p => p.category === displayCat);
  const parProducts = products.filter(p => !(inventoryAddOns||[]).includes(p.id));
  const totalCounted = parProducts.filter(p => stock[p.id] !== null && stock[p.id] !== undefined).length;

  const ItemCard = ({p, mobile}) => {
    const s = stock[p.id];
    const counted = s !== null && s !== undefined;
    const par = getPar(p.id);
    const orderQty = counted ? getOrderQty(p) : null;
    const isLow  = counted && orderQty > 0;
    const isGood = counted && orderQty === 0;
    return (
      <div
        onClick={() => openInvPicker(p)}
        style={{
          background: isLow ? "#FFF8F8" : isGood ? "#F0FDF4" : "#FAFAFA",
          border:`1.5px solid ${isLow ? "#FCA5A5" : isGood ? "#86EFAC" : "#ebebeb"}`,
          borderRadius:10, padding: mobile ? "12px 14px" : "10px 12px",
          display:"flex", alignItems:"center", gap:10,
          cursor:"pointer", transition:"border .15s, background .15s",
          userSelect:"none",
        }}>
        {/* Item info */}
        <div style={{flex:1, minWidth:0}}>
          <div style={{fontWeight:700, fontSize: mobile ? 15 : 14, color:"#1a1a1a"}}>{pName(p)}</div>
          <div style={{fontSize: mobile ? 12 : 11, color:"#bbb", marginTop:2}}>
            {p.unit} · Par: <strong style={{color:"#777"}}>{par}</strong>
          </div>
        </div>
        {/* Tap-to-count chip */}
        <div style={{
          flexShrink:0, minWidth:64, textAlign:"center",
          background: counted ? (isLow ? "#FEE2E2" : "#DCFCE7") : "#f0f0f0",
          border:`1.5px solid ${counted ? (isLow ? "#FCA5A5" : "#86EFAC") : "#e0e0e0"}`,
          borderRadius:10, padding:"5px 12px",
        }}>
          <div style={{fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:.4,
            color: counted ? (isLow ? "#B91C1C" : "#15803D") : "#aaa"}}>
            {counted ? (lang==="zh" ? "库存" : "Have") : (lang==="zh" ? "点击" : "Tap")}
          </div>
          <div style={{fontSize: mobile ? 22 : 19, fontWeight:800, lineHeight:1.1,
            color: counted ? (isLow ? "#DC2626" : "#16A34A") : "#ccc"}}>
            {counted ? s : "—"}
          </div>
        </div>
        {/* Order qty badge */}
        {counted && isLow && (
          <div style={{flexShrink:0, textAlign:"center", minWidth:40}}>
            <div style={{fontSize:9, color:"#C0392B", fontWeight:700, textTransform:"uppercase"}}>Order</div>
            <div style={{fontSize: mobile ? 22 : 19, fontWeight:800, color:"#C0392B", lineHeight:1}}>{orderQty}</div>
          </div>
        )}
        {counted && isGood && (
          <div style={{fontSize: mobile ? 18 : 15, color:"#22C55E", fontWeight:700, flexShrink:0}}>✓</div>
        )}
      </div>
    );
  };

  return (
    <>
    {/* Hidden save trigger for parent modal */}
    <button data-save-inventory={rest?.id} onClick={saveDraft} style={{display:"none"}} aria-hidden="true"/>
    {/* ── Desktop layout ── */}
    {!isMobile && (
    <div style={{display:"flex", flexDirection:"row", gap:0, minHeight:"70vh", background:"#fff",
      borderRadius:16, border:"1px solid #e5e5e5", overflow:"hidden",
      boxShadow:"0 2px 12px rgba(0,0,0,.06)"}}>
      <div style={{width:155, flexShrink:0, background:"#F7F7F5",
        borderRight:"1px solid #e5e5e5", display:"flex", flexDirection:"column"}}>
        <div style={{padding:"14px 12px 10px", borderBottom:"1px solid #e5e5e5"}}>
          <div style={{fontSize:10,fontWeight:700,color:"#aaa",textTransform:"uppercase",letterSpacing:.8}}>Categories</div>
        </div>
        <div style={{overflowY:"auto", flex:1}}>
          {categories.map(cat => {
            const stats = getCatStats(cat);
            const hasOrders = stats.needOrder > 0;
            const allCounted = stats.counted === stats.total;
            return (
              <button key={cat} onClick={() => setActiveCategory(cat)}
                style={{width:"100%", background: displayCat===cat ? "#fff" : "transparent",
                  border:"none", borderLeft: displayCat===cat ? "3px solid #C0392B" : "3px solid transparent",
                  padding:"9px 12px", cursor:"pointer", textAlign:"left",
                  borderBottom:"1px solid #f0f0f0", display:"flex",
                  alignItems:"center", justifyContent:"space-between"}}>
                <div style={{minWidth:0}}>
                  <div style={{fontWeight: displayCat===cat ? 700 : 500, fontSize:13,
                    color: displayCat===cat ? "#C0392B" : "#333",
                    whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis"}}>
                    <span style={{marginRight:5}}>{CATEGORY_ICONS[cat]||"📦"}</span>{t.cats?.[cat]||cat}
                  </div>
                  <div style={{fontSize:10,color:"#bbb",marginTop:1}}>{stats.counted}/{stats.total}</div>
                </div>
                {hasOrders && <div style={{background:"#C0392B",color:"#fff",borderRadius:10,padding:"1px 6px",fontSize:10,fontWeight:700,flexShrink:0}}>{stats.needOrder}</div>}
                {allCounted && !hasOrders && <span style={{color:"#22C55E",fontSize:12}}>✓</span>}
              </button>
            );
          })}
        </div>
        <div style={{padding:"10px 12px", borderTop:"1px solid #e5e5e5", background:"#fafafa"}}>
          <div style={{fontSize:10,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:.8,marginBottom:6}}>Note: Order Note</div>
          <textarea value={orderNote} onChange={e=>setOrderNote(e.target.value)}
            placeholder="Add a note for the factory..." rows={4}
            style={{width:"100%",border:`1.5px solid ${orderNote ? "#F39C12" : "#ccc"}`,borderRadius:8,
              padding:"10px 12px",fontSize:13,fontFamily:"'IBM Plex Sans',sans-serif",
              outline:"none",resize:"none",boxSizing:"border-box",
              background: orderNote ? "#FFFBEB" : "#fff",
              color:"#333",lineHeight:1.4,transition:"background .2s"}}/>
        </div>
        <div style={{padding:"10px 12px", borderTop:"1px solid #e5e5e5",
          background: orderItems.length > 0 ? "#FEF3C7" : "#F7F7F5"}}>
          <div style={{fontSize:10,color:orderItems.length>0?"#92400E":"#aaa",fontWeight:700,marginBottom:6}}>
            {orderItems.length > 0 ? `${orderItems.length} items to order` : "Nothing to order yet"}
          </div>
          {totalCounted < parProducts.length && (
            <div style={{fontSize:10, color:"#C0392B", fontWeight:700, marginBottom:6, padding:"5px 8px",
              background:"#FEF2F2", borderRadius:6, border:"1px solid #FCA5A5"}}>
              ⚠️ {parProducts.length - totalCounted} item{parProducts.length-totalCounted!==1?"s":""} not counted yet
            </div>
          )}
          <button onClick={saveDraft}
            style={{width:"100%",border:"1px solid #e5e5e5",borderRadius:8,padding:"7px 6px",fontSize:11,fontWeight:700,
              cursor:"pointer", background: draftSaved ? "#f0faf4" : "#fff",
              color: draftSaved ? "#27AE60" : "#888",
              fontFamily:"'IBM Plex Sans',sans-serif",transition:"all .2s", marginBottom:6}}>
            {draftSaved ? (lang==="zh"?"✓ 已保存！":"✓ Saved!") : (lang==="zh"?"💾 暂存草稿":"💾 Save for Later")}
          </button>
          <button disabled={orderItems.length===0 || totalCounted < parProducts.length}
            onClick={() => {
                clearDraft(); setInventory(stock);
                const baseItems = orderItems.map(p=>({productId:p.id,qty:getOrderQty(p)}));
                if ((inventoryAddOns||[]).length === 0) {
                  onReview(baseItems, orderNote);
                } else {
                  setPendingOrder({baseItems, note:orderNote});
                  setPaperQtys({});
                  setShowPaperModal(true);
                }
              }}
              style={{width:"100%",border:"none",borderRadius:8,padding:"9px 6px",fontSize:12,fontWeight:700,
              cursor:(orderItems.length>0 && totalCounted>=parProducts.length)?"pointer":"not-allowed",
              background:(orderItems.length>0 && totalCounted>=parProducts.length)?rest.color:"#e0e0e0",
              color:(orderItems.length>0 && totalCounted>=parProducts.length)?"#fff":"#bbb",
              fontFamily:"'IBM Plex Sans',sans-serif",transition:"all .15s"}}>
            {lang==="zh"?"审核订单 →":"Review Order →"}
          </button>
        </div>
      </div>
      <div style={{flex:1, display:"flex", flexDirection:"column", minWidth:0}}>
        <div style={{padding:"14px 20px 12px", borderBottom:"1px solid #f0f0f0",
          display:"flex", alignItems:"center", justifyContent:"space-between",
          background:"#fff", flexWrap:"wrap", gap:8}}>
          <div style={{display:"flex", alignItems:"center", gap:10}}>
            <span style={{fontSize:22}}>{CATEGORY_ICONS[displayCat]||"📦"}</span>
            <div>
              <h2 style={{fontSize:18, margin:0, color:"#1a1a1a"}}>{t.cats?.[displayCat]||displayCat}</h2>
              <p style={{fontSize:11, color:"#aaa", margin:0}}>{lang==="zh"?"输入当前库存 → 自动计算订购数量":"Enter current stock → order qty auto-fills"}</p>
            </div>
          </div>
          <div style={{fontSize:11,color:"#bbb"}}>{totalCounted} / {parProducts.length} items counted</div>
        </div>
        <div style={{padding:"12px 16px", display:"flex", flexDirection:"column", gap:8, overflowY:"auto"}}>
          {displayProducts.map(p => <ItemCard key={p.id} p={p} mobile={false} />)}
        </div>
      </div>
    </div>
    )}

    {/* ── Mobile layout ── */}
    {isMobile && (
    <div style={{background:"#fff", borderRadius:16, border:"1px solid #e5e5e5",
      boxShadow:"0 2px 12px rgba(0,0,0,.06)", overflow:"hidden"}}>
      <div style={{display:"flex", overflowX:"auto", gap:8, padding:"12px",
        borderBottom:"1px solid #f0f0f0", scrollbarWidth:"none"}}>
        {categories.map(cat => {
          const stats = getCatStats(cat);
          const active = displayCat === cat;
          return (
            <button key={cat} onClick={() => setActiveCategory(cat)}
              style={{flexShrink:0, border: active ? "2px solid #C0392B" : "1.5px solid #e0e0e0",
                borderRadius:20, padding:"6px 14px", fontSize:13, fontWeight: active ? 700 : 500,
                background: active ? "#FFF0EE" : "#fff", color: active ? "#C0392B" : "#555",
                cursor:"pointer", display:"flex", alignItems:"center", gap:5}}>
              {CATEGORY_ICONS[cat]||"📦"} {t.cats?.[cat]||cat}
              {stats.needOrder > 0 && (
                <span style={{background:"#C0392B",color:"#fff",borderRadius:10,padding:"0 5px",fontSize:10,fontWeight:700}}>{stats.needOrder}</span>
              )}
            </button>
          );
        })}
      </div>
      <div style={{padding:"6px 14px", fontSize:11, color:"#aaa", borderBottom:"1px solid #f5f5f5"}}>
        {totalCounted} / {parProducts.length} items counted
      </div>
      <div style={{padding:"10px 12px", display:"flex", flexDirection:"column", gap:8}}>
        {displayProducts.map(p => <ItemCard key={p.id} p={p} mobile={true} />)}
      </div>
      <div style={{padding:"10px 12px", borderTop:"1px solid #e5e5e5"}}>
        <div style={{fontSize:11,fontWeight:700,color:"#555",textTransform:"uppercase",letterSpacing:.8,marginBottom:6}}>Note: Order Note</div>
        <textarea value={orderNote} onChange={e=>setOrderNote(e.target.value)}
          placeholder="Add a note for the factory..."
          rows={3}
          style={{width:"100%",border:`1.5px solid ${orderNote ? "#F39C12" : "#ccc"}`,borderRadius:8,
            padding:"11px 13px",fontSize:14,fontFamily:"'IBM Plex Sans',sans-serif",
            outline:"none",resize:"none",boxSizing:"border-box",
            background: orderNote ? "#FFFBEB" : "#fff",
            color:"#333",lineHeight:1.4,transition:"background .2s"}}/>
      </div>
      <div style={{padding:"10px 12px 14px", background:orderItems.length>0?"#FEF3C7":"#f7f7f7"}}>
        <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:8}}>
          <div style={{fontSize:13,color:orderItems.length>0?"#92400E":"#aaa",fontWeight:600}}>
            {orderItems.length>0 ? `${orderItems.length} items to order` : "Nothing to order yet"}
          </div>
          <button onClick={saveDraft}
            style={{border:"1px solid #e5e5e5", borderRadius:10, padding:"8px 14px", fontSize:13,
              fontWeight:700, cursor:"pointer",
              background: draftSaved ? "#f0faf4" : "#fff",
              color: draftSaved ? "#27AE60" : "#888", transition:"all .2s"}}>
            {draftSaved ? (lang==="zh"?"✓ 已保存!":"✓ Saved!") : (lang==="zh"?"💾 稍后完成":"💾 Finish Later")}
          </button>
        </div>
        {totalCounted < parProducts.length && (
          <div style={{fontSize:11, color:"#C0392B", fontWeight:700, marginBottom:8, padding:"5px 8px",
            background:"#FEF2F2", borderRadius:6, border:"1px solid #FCA5A5"}}>
            ⚠️ {parProducts.length - totalCounted} item{parProducts.length-totalCounted!==1?"s":""} not counted yet
          </div>
        )}
        <button disabled={orderItems.length===0 || totalCounted < parProducts.length}
          onClick={() => {
                clearDraft(); setInventory(stock);
                const baseItems = orderItems.map(p=>({productId:p.id,qty:getOrderQty(p)}));
                if ((inventoryAddOns||[]).length === 0) {
                  onReview(baseItems, orderNote);
                } else {
                  setPendingOrder({baseItems, note:orderNote});
                  setPaperQtys({});
                  setShowPaperModal(true);
                }
              }}
          style={{width:"100%",border:"none",borderRadius:10,padding:"12px",fontSize:14,fontWeight:700,
            cursor:(orderItems.length>0 && totalCounted>=parProducts.length)?"pointer":"not-allowed",
            background:(orderItems.length>0 && totalCounted>=parProducts.length)?rest.color:"#e0e0e0",
            color:(orderItems.length>0 && totalCounted>=parProducts.length)?"#fff":"#bbb",
            fontFamily:"'IBM Plex Sans',sans-serif"}}>
          Review Order →
        </button>
      </div>
    </div>
    )}

    {/* ── Inventory numpad picker ── */}
    {invPickerProduct && (
      <div style={{position:"fixed", inset:0, zIndex:3100, display:"flex", flexDirection:"column", justifyContent:"flex-end"}}
        onClick={commitInvPicker}>
        <div style={{background:"rgba(0,0,0,0.45)", position:"absolute", inset:0}} />
        <div style={{position:"relative", background:"#fff", borderRadius:"20px 20px 0 0",
          padding:"20px 16px 36px", boxShadow:"0 -8px 40px rgba(0,0,0,0.22)"}}
          onClick={e => e.stopPropagation()}>
          {/* Product header */}
          <div style={{textAlign:"center", marginBottom:16}}>
            <div style={{fontWeight:700, fontSize:18, color:"#1a1a1a"}}>{pName(invPickerProduct)}</div>
            <div style={{fontSize:12, color:"#aaa", marginTop:2}}>
              {invPickerProduct.unit} · Par: {getPar(invPickerProduct.id) || "—"}
            </div>
            {/* Display — updated directly via DOM ref, zero re-renders */}
            <div ref={invDisplayRef} style={{
              fontSize:56, fontWeight:800, letterSpacing:4, marginTop:14, minHeight:68, lineHeight:1,
              color:"#ccc",
            }}>—</div>
            <div style={{fontSize:11, color:"#aaa", marginTop:4}}>
              {lang==="zh" ? "输入当前库存数量" : "Enter current stock on hand"}
            </div>
          </div>
          {/* Numpad — plain onPointerDown so mobile fires instantly without waiting for click delay */}
          <div style={{display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:10, maxWidth:320, margin:"0 auto"}}>
            {INV_KEYS.map(k => (
              <button key={k}
                onPointerDown={e => { e.preventDefault(); invPickerKey(k); }}
                style={{
                  height:64, borderRadius:14, border:"none", cursor:"pointer",
                  fontSize: k === "✓" ? 16 : k === "⌫" ? 20 : 24,
                  fontWeight:700,
                  gridColumn: k === "✓" ? "1 / -1" : "auto",
                  background: k === "✓" ? "#1a1a1a" : k === "⌫" ? "#f5f5f5" : "#f0f0f0",
                  color: k === "✓" ? "#fff" : k === "⌫" ? "#888" : "#1a1a1a",
                  WebkitTapHighlightColor: "transparent",
                  touchAction: "manipulation",
                  fontFamily:"'IBM Plex Sans',sans-serif",
                }}>
                {k === "✓" ? "✓  Done" : k}
              </button>
            ))}
          </div>
          {/* Clear button — visibility toggled via ref, no re-render */}
          <button ref={invClearBtnRef}
            onPointerDown={e => {
              e.preventDefault();
              const p = invPickerProductRef.current;
              if (p) setStockDirty(s2 => { const n={...s2}; delete n[p.id]; return n; });
              closeInvPicker();
            }}
            style={{display: invHasPrevRef.current ? "block" : "none",
              margin:"12px auto 0", padding:"11px 24px",
              borderRadius:12, border:"none", background:"#fff5f5",
              color:"#E74C3C", fontSize:14, fontWeight:700, cursor:"pointer",
              maxWidth:320, width:"100%", WebkitTapHighlightColor:"transparent",
              touchAction:"manipulation"}}>
            Clear this item
          </button>
        </div>
      </div>
    )}

    {/* Add-Ons Popup */}
    {showPaperModal && (
      <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:3000,
        display:"flex",alignItems:"center",justifyContent:"center",padding:16}}
        onClick={()=>setShowPaperModal(false)}>
        <div style={{background:"#fff",borderRadius:18,width:"100%",maxWidth:480,
          maxHeight:"85vh",overflowY:"auto",boxShadow:"0 24px 60px rgba(0,0,0,0.3)"}}
          onClick={e=>e.stopPropagation()}>
          <div style={{background:"#1a1a1a",borderRadius:"18px 18px 0 0",padding:"18px 20px"}}>
            <div style={{color:"#fff",fontWeight:800,fontSize:18}}>Anything else to add?</div>
            <div style={{color:"rgba(255,255,255,0.6)",fontSize:13,marginTop:4}}>
              Add any extras to include with this order
            </div>
          </div>
          <div style={{padding:"0 20px"}}>
            {products.filter(p=>(inventoryAddOns||[]).includes(p.id)).map(p=>(
              <div key={p.id} style={{display:"flex",justifyContent:"space-between",
                alignItems:"center",padding:"12px 0",borderBottom:"1px solid #f0f0f0"}}>
                <div>
                  <div style={{fontWeight:600,fontSize:14}}>{p.name}</div>
                  {p.nameZh&&<div style={{fontSize:11,color:"#aaa"}}>{p.nameZh}</div>}
                  <div style={{fontSize:11,color:"#bbb"}}>{p.unit}</div>
                </div>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <button onClick={()=>setPaperQtys(q=>({...q,[p.id]:Math.max(0,(q[p.id]||0)-1)}))}
                    style={{width:36,height:36,borderRadius:18,border:"1px solid #e5e5e5",
                      background:"#f5f5f5",fontSize:20,cursor:"pointer",lineHeight:1}}>&#x2212;</button>
                  <span style={{minWidth:28,textAlign:"center",fontWeight:700,fontSize:16}}>
                    {paperQtys[p.id]||0}
                  </span>
                  <button onClick={()=>setPaperQtys(q=>({...q,[p.id]:(q[p.id]||0)+1}))}
                    style={{width:36,height:36,borderRadius:18,border:"none",
                      background:"#1a1a1a",color:"#fff",fontSize:20,cursor:"pointer",lineHeight:1}}>+</button>
                </div>
              </div>
            ))}
          </div>
          <div style={{padding:"16px 20px",borderTop:"1px solid #eee",display:"flex",gap:10}}>
            <button onClick={()=>{setShowPaperModal(false);onReview(pendingOrder.baseItems,pendingOrder.note);}}
              style={{flex:1,padding:"12px",borderRadius:10,border:"1px solid #e5e5e5",
                background:"#f5f5f5",fontSize:14,fontWeight:600,cursor:"pointer"}}>
              Skip
            </button>
            <button onClick={()=>{
                setShowPaperModal(false);
                const addOnItems = products.filter(p=>(inventoryAddOns||[]).includes(p.id)&&(paperQtys[p.id]||0)>0)
                  .map(p=>({productId:p.id,qty:paperQtys[p.id]}));
                onReview([...pendingOrder.baseItems,...addOnItems],pendingOrder.note);
              }}
              style={{flex:1,padding:"12px",borderRadius:10,border:"none",
                background:"#1a1a1a",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer"}}>
              Add & Review Order
            </button>
          </div>
        </div>
      </div>
    )}
    </>
  );
}


function CateringTab({rest, inventory, parLevels, setInventory, onReview, products}) {
  const [dishQtys, setDishQtys] = useState({});
  const [levels, setLevels] = useState({...inventory});

  const cateringExtras = {};
  INIT_CATERING_DISHES.forEach(dish => {
    const qty = dishQtys[dish.id]||0;
    if(qty > 0) {
      Object.entries(dish.ingredients).forEach(([pid, perUnit]) => {
        cateringExtras[+pid] = round2((cateringExtras[+pid]||0) + perUnit * qty);
      });
    }
  });

  const low = products.filter(p=>(levels[p.id]??0)<(parLevels[p.id]?.par??0));
  const parItems = low.map(p=>({productId:p.id, qty:parLevels[p.id]?.orderQty||10}));
  const hasDishes = Object.values(dishQtys).some(q=>q>0);
  const totalGuests = INIT_CATERING_DISHES.reduce((s,d)=>s+(dishQtys[d.id]||0)*d.serves, 0);
  const cateringSummary = INIT_CATERING_DISHES.filter(d=>(dishQtys[d.id]||0)>0).map(d=>`${dishQtys[d.id]}× ${d.name}`).join(", ");
  const affectedProducts = products.filter(p=>cateringExtras[p.id]);

  return (
    <div>
      <div style={{marginBottom:18}}>
        <h2 style={{fontSize:24,marginBottom:3}}>🍽 Catering Mode</h2>
        <p style={{color:"#888",fontSize:12}}>Select catering dishes — extra ingredients are calculated and added to your stock order.</p>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr",gap:18}}>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(230px,1fr))",gap:10}}>
          {INIT_CATERING_DISHES.map(dish=>{
            const qty = dishQtys[dish.id]||0;
            return (
              <Card key={dish.id} style={{border:`2px solid ${qty>0?rest.color+"55":"#f0f0f0"}`,background:qty>0?rest.color+"07":"#fff"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
                  <div>
                    <span style={{fontSize:22,marginRight:6}}>{dish.emoji}</span>
                    <span style={{fontWeight:700,fontSize:14}}>{dish.name}</span>
                    <div style={{fontSize:11,color:"#aaa",marginTop:2}}>1 {dish.unit} serves ~{dish.serves} guests</div>
                  </div>
                  {qty>0 && <span style={{background:rest.color+"22",color:rest.color,borderRadius:20,padding:"2px 8px",fontSize:10,fontWeight:700}}>×{qty}</span>}
                </div>
                <div style={{display:"flex",flexWrap:"wrap",gap:4,marginBottom:10}}>
                  {Object.entries(dish.ingredients).map(([pid,amt])=>{
                    const p=products.find(x=>x.id===+pid);
                    return p ? <span key={pid} style={{background:"#f0f0f0",borderRadius:5,padding:"2px 7px",fontSize:10,color:"#666"}}>{p.name} {amt}{p.unit}</span> : null;
                  })}
                </div>
                <NumInput value={qty} onChange={v=>setDishQtys(d=>({...d,[dish.id]:v}))}/>
              </Card>
            );
          })}
        </div>

        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:14}}>
          <Card style={{border:`2px solid ${hasDishes?rest.color+"44":"#f0f0f0"}`}}>
            <div style={{fontWeight:700,fontSize:15,marginBottom:12,color:rest.color}}>🍽 Catering Summary</div>
            {!hasDishes
              ? <p style={{color:"#ccc",fontSize:13,textAlign:"center",padding:"14px 0"}}>Select dishes above</p>
              : <>
                  <div style={{fontSize:12,color:"#888",marginBottom:10}}>Estimated guests: <strong style={{color:"#1a1a1a"}}>{totalGuests}</strong></div>
                  {INIT_CATERING_DISHES.filter(d=>(dishQtys[d.id]||0)>0).map(d=>(
                    <div key={d.id} style={{display:"flex",justifyContent:"space-between",padding:"5px 0",borderBottom:"1px solid #f5f5f5",fontSize:13}}>
                      <span>{d.emoji} {d.name}</span>
                      <span style={{fontWeight:700,color:rest.color}}>{dishQtys[d.id]} {d.unit}{dishQtys[d.id]>1?"s":""}</span>
                    </div>
                  ))}
                  {affectedProducts.length > 0 && (
                    <div style={{marginTop:12,paddingTop:10,borderTop:"1px solid #f0f0f0"}}>
                      <div style={{fontSize:11,fontWeight:700,color:"#aaa",letterSpacing:.5,textTransform:"uppercase",marginBottom:8}}>Extra Ingredients Needed</div>
                      {affectedProducts.map(p=>(
                        <div key={p.id} style={{display:"flex",justifyContent:"space-between",padding:"4px 0",fontSize:12}}>
                          <span style={{color:"#555"}}>{p.name}</span>
                          <span style={{fontWeight:700,color:"#8E44AD"}}>+{cateringExtras[p.id]} {p.unit}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </>
            }
          </Card>

          <Card style={{border:"1px solid #f0f0f0"}}>
            <div style={{fontWeight:700,fontSize:14,marginBottom:8,color:"#555"}}>📦 Regular Stock Order</div>
            {low.length===0
              ? <p style={{color:"#aaa",fontSize:12}}>✓ All stock above par</p>
              : low.map(p=>(
                  <div key={p.id} style={{display:"flex",justifyContent:"space-between",padding:"4px 0",borderBottom:"1px solid #f5f5f5",fontSize:12}}>
                    <span style={{color:"#555"}}>{p.name}</span>
                    <span style={{fontWeight:700,color:"#C0392B"}}>+{parLevels[p.id]?.orderQty||10} {p.unit}</span>
                  </div>
                ))
            }
          </Card>
        </div>

        <Btn color={rest.color} full disabled={!hasDishes && low.length===0}
          onClick={()=>{
            setInventory(levels);
            const breakdown = hasDishes ? { extras: cateringExtras, summary: cateringSummary } : null;
            onReview(parItems, breakdown);
          }}>
          Review Combined Order →
        </Btn>
      </div>
    </div>
  );
}

// ── PREP MODULE ────────────────────────────────────────────────────────────────

const TODAY_KEY = () => new Date().toISOString().slice(0,10); // "2024-01-15"

const PREP_LANGS = {
  en: {
    myTasks:"My Tasks", noTasks:"No tasks assigned today", tapStart:"Tap to start",
    inProgress:"In progress", done:"Done", urgent:"URGENT",
    addNote:"Add a note...", finish:"Mark Complete", start:"Start Task",
    from:"From yesterday", allDone:"All done for today! 🎉",
    shift:"Shift", am:"Morning", pm:"Afternoon", all:"All Day",
  },
  zh: {
    myTasks:"我的任务", noTasks:"今天没有分配任务", tapStart:"点击开始",
    inProgress:"进行中", done:"完成", urgent:"紧急",
    addNote:"添加备注...", finish:"标记完成", start:"开始任务",
    from:"来自昨天", allDone:"今天全部完成！🎉",
    shift:"班次", am:"上午", pm:"下午", all:"全天",
  },
  es: {
    myTasks:"Mis tareas", noTasks:"No hay tareas asignadas hoy", tapStart:"Toca para comenzar",
    inProgress:"En progreso", done:"Hecho", urgent:"URGENTE",
    addNote:"Añadir una nota...", finish:"Marcar completo", start:"Iniciar tarea",
    from:"De ayer", allDone:"¡Todo listo por hoy! 🎉",
    shift:"Turno", am:"Mañana", pm:"Tarde", all:"Todo el día",
  },
};

// ── PrepStaffBoard — the shared kiosk screen (prep role) ──
function PrepStaffBoard({ prepStaff, prepTasks, prepDailyAssignments, savePrepTimestamps, prepTimestamps }) {
  const [selectedStaff, setSelectedStaff] = useState(null);
  const today = TODAY_KEY();
  // Show today's assignments, or fall back to most recent date that has assignments
  const activeDate = today;
  const todayAssignments = prepDailyAssignments?.[activeDate] || [];

  if (selectedStaff) {
    return <PrepTaskView
      staff={selectedStaff}
      tasks={prepTasks}
      assignments={todayAssignments.filter(a => a.assignedTo?.includes(selectedStaff.id))}
      timestamps={prepTimestamps}
      savePrepTimestamps={savePrepTimestamps}
      onBack={()=>setSelectedStaff(null)}
      activeDate={activeDate}
    />;
  }

  return (
    <div style={{minHeight:"100vh", background:"#f2f0ec", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:24}}>
      <div style={{marginBottom:32, textAlign:"center"}}>
        <img src="/logo-nav.png" alt="Vanessa's" style={{height:44, width:"auto", marginBottom:12}}/>
        <div style={{fontSize:14, color:"#888"}}>{new Date().toLocaleDateString("en-US",{weekday:"long",month:"long",day:"numeric"})}</div>
      </div>

      <div style={{display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))", gap:12, width:"100%", maxWidth:640}}>
        {(prepStaff||[]).map(s => {
          const myAssignments = todayAssignments.filter(a => a.assignedTo?.includes(s.id));
          const myTimestamps = prepTimestamps.filter(ts => ts.staffId===s.id && ts.date===today);
          const completed = myTimestamps.filter(ts => ts.finishedAt).length;
          const total = myAssignments.length;
          const pct = total > 0 ? Math.round(completed/total*100) : 0;
          return (
            <button key={s.id} onClick={()=>setSelectedStaff(s)}
              style={{background:"#fff", border:"2px solid #e8e8e8", borderRadius:16,
                padding:"20px 16px", cursor:"pointer", textAlign:"center",
                boxShadow:"0 2px 12px rgba(0,0,0,0.06)", transition:"all .15s"}}
              onMouseEnter={e=>{e.currentTarget.style.borderColor="#1a1a1a";e.currentTarget.style.boxShadow="0 4px 20px rgba(0,0,0,0.12)";}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor="#e8e8e8";e.currentTarget.style.boxShadow="0 2px 12px rgba(0,0,0,0.06)";}}>
              <div style={{fontSize:32, marginBottom:8}}>👤</div>
              <div style={{fontWeight:800, fontSize:16, color:"#1a1a1a", marginBottom:6}}>{s.name}</div>
              {total > 0 ? (
                <>
                  <div style={{background:"#f0f0f0", borderRadius:99, height:6, marginBottom:4, overflow:"hidden"}}>
                    <div style={{height:"100%", borderRadius:99, width:`${pct}%`,
                      background: pct===100 ? "#27AE60" : "#1a1a1a", transition:"width .3s"}}/>
                  </div>
                  <div style={{fontSize:11, color: pct===100?"#27AE60":"#888"}}>
                    {pct===100
                    ? (s.primaryLang==="zh"?"✓ 全部完成！":s.primaryLang==="es"?"✓ ¡Todo listo!":"✓ All done!")
                    : `${completed}/${total} ${s.primaryLang==="zh"?"项":s.primaryLang==="es"?"tareas":"tasks"}`}
                  </div>
                </>
              ) : (
                <div style={{fontSize:11, color:"#bbb"}}>
                  {s.primaryLang==="zh"?"今天没有任务":s.primaryLang==="es"?"Sin tareas hoy":"No tasks today"}
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}

// ── PrepTaskView — individual staff task list ──
function PrepTaskView({ staff, tasks, assignments, timestamps, savePrepTimestamps, onBack, adminView=false, activeDate }) {
  const tl = PREP_LANGS[staff.primaryLang] || PREP_LANGS.en;
  const today = activeDate || TODAY_KEY(); // use the date assignments were made
  const [detailsPopup, setDetailsPopup] = useState(null);
  const [recordPopup, setRecordPopup] = useState(null);
  const [expandedSubcats, setExpandedSubcats] = useState({}); // subcategory -> bool

  const getTs = (taskId) => (timestamps||[]).find(ts => ts.staffId===staff.id && ts.taskId===taskId && ts.date===today);

  const startTask = (taskId) => {
    const existing = getTs(taskId);
    if (existing) return;
    savePrepTimestamps([...(timestamps||[]), {
      staffId: staff.id, taskId, date: today,
      startedAt: new Date().toISOString(), finishedAt: null, note: ""
    }]);
  };

  const finishTask = (taskId, outputQty) => {
    const task = tasks.find(t=>t.id===taskId);
    if (task?.recordOutput && outputQty===undefined) {
      setRecordPopup({task, value:""});
      return;
    }
    const updated = (timestamps||[]).map(ts =>
      ts.staffId===staff.id && ts.taskId===taskId && ts.date===today
        ? {...ts, finishedAt: new Date().toISOString(), outputQty: outputQty||null}
        : ts
    );
    savePrepTimestamps(updated);
    if (task?.recordOutput && outputQty) {
      // Fire and forget — send email to Yuzhen
      fetch("/api/send-output-record", {
        method:"POST", headers:{"Content-Type":"application/json"},
        body:JSON.stringify({taskName:task.nameEn, staffName:staff.name, qty:outputQty, date:today, toEmail:"yuzhen@vanessas.com"})
      }).catch(e=>console.error("Output record email failed:", e));
    }
    setRecordPopup(null);
  };

  const sorted = [...(assignments||[])].sort((a,b) => {
    const aDone = !!getTs(a.taskId)?.finishedAt;
    const bDone = !!getTs(b.taskId)?.finishedAt;
    if (aDone !== bDone) return aDone ? 1 : -1;
    if (a.urgent !== b.urgent) return a.urgent ? -1 : 1;
    return (a.order||0) - (b.order||0);
  });

  // Group by subcategory
  const subcats = [...new Set(sorted.map(a => {
    const t = tasks.find(x=>x.id===a.taskId);
    return t?.subcategory || t?.category || "Other";
  }))];

  const completed = sorted.filter(a => getTs(a.taskId)?.finishedAt).length;
  const pct = sorted.length > 0 ? Math.round(completed/sorted.length*100) : 0;
  // Check if there's a next day with assignments for this staff
  const nextDayDate = null; // simplified — back button handles navigation

  const toggleSubcat = (sub) => setExpandedSubcats(p => ({...p, [sub]: !p[sub]}));

  // Get subcategory progress
  const subcatProgress = (sub) => {
    const subTasks = sorted.filter(a => {const t=tasks.find(x=>x.id===a.taskId); return (t?.subcategory||t?.category||"Other")===sub;});
    const done = subTasks.filter(a=>getTs(a.taskId)?.finishedAt).length;
    return {done, total:subTasks.length};
  };

  const hasUrgentInSubcat = (sub) =>
    sorted.some(a => {
      const t=tasks.find(x=>x.id===a.taskId);
      return (t?.subcategory||t?.category||"Other")===sub && a.urgent && !getTs(a.taskId)?.finishedAt;
    });

  return (
    <div style={{minHeight:"100vh", background:"#f2f0ec", padding:20}}>
      {/* Admin view banner */}
      {adminView && (
        <div style={{background:"#FFF9F0",border:"1px solid #F39C12",borderRadius:10,
          padding:"8px 14px",marginBottom:12,fontSize:12,color:"#92400E",fontWeight:600}}>
          👁 Admin view — read only
        </div>
      )}

      {/* Header */}
      <div style={{display:"flex", alignItems:"center", gap:14, marginBottom:20}}>
        <button onClick={onBack} style={{background:"#1a1a1a", color:"#fff", border:"none",
          borderRadius:10, padding:"8px 16px", cursor:"pointer", fontWeight:700, fontSize:14}}>
          ← Back
        </button>
        <div>
          <div style={{fontWeight:800, fontSize:20, color:"#1a1a1a"}}>{staff.name}</div>
          <div style={{fontSize:12, color:"#888"}}>{new Date().toLocaleDateString("en-US",{weekday:"long",month:"short",day:"numeric"})}</div>
        </div>
      </div>

      {/* Progress bar */}
      <div style={{background:"#fff", borderRadius:14, padding:"14px 18px", marginBottom:16,
        boxShadow:"0 2px 10px rgba(0,0,0,0.06)"}}>
        <div style={{display:"flex", justifyContent:"space-between", marginBottom:8}}>
          <div style={{fontWeight:700, fontSize:14}}>{tl.myTasks}</div>
          <div style={{fontWeight:800, fontSize:14, color: pct===100?"#27AE60":"#1a1a1a"}}>
            {pct===100 ? tl.allDone : `${completed}/${sorted.length}`}
          </div>
        </div>
        <div style={{background:"#f0f0f0", borderRadius:99, height:8, overflow:"hidden"}}>
          <div style={{height:"100%", borderRadius:99, width:`${pct}%`,
            background: pct===100?"#27AE60":"#1a1a1a", transition:"width .4s"}}/>
        </div>
      </div>

      {/* Record output popup */}
      {recordPopup && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:500,
          display:"flex",alignItems:"center",justifyContent:"center",padding:20}}
          onClick={()=>setRecordPopup(null)}>
          <div style={{background:"#fff",borderRadius:20,padding:"24px 20px",width:"100%",maxWidth:340}}
            onClick={e=>e.stopPropagation()}>
            <div style={{fontSize:13,fontWeight:800,color:"#8E44AD",marginBottom:6}}>
              📊 {staff.primaryLang==="zh"?"记录产量":staff.primaryLang==="es"?"Registrar producción":"Record Output"}
            </div>
            <div style={{fontWeight:800,fontSize:16,marginBottom:4,color:"#1a1a1a"}}>
              {staff.primaryLang==="zh"&&recordPopup.task.nameZh ? recordPopup.task.nameZh :
               staff.primaryLang==="es"&&recordPopup.task.nameEs ? recordPopup.task.nameEs :
               recordPopup.task.nameEn}
            </div>
            <div style={{fontSize:13,color:"#888",marginBottom:16,lineHeight:1.5}}>
              {staff.primaryLang==="zh" ? (recordPopup.task.recordPromptZh||recordPopup.task.recordPromptEn) :
               staff.primaryLang==="es" ? (recordPopup.task.recordPromptEs||recordPopup.task.recordPromptEn) :
               recordPopup.task.recordPromptEn}
            </div>
            <input autoFocus type="number" inputMode="numeric"
              value={recordPopup.value}
              onChange={e=>setRecordPopup(p=>({...p,value:e.target.value}))}
              placeholder="0"
              onKeyDown={e=>e.key==="Enter"&&recordPopup.value.trim()&&finishTask(recordPopup.task.id,recordPopup.value.trim())}
              style={{width:"100%",border:"2px solid #8E44AD",borderRadius:12,
                padding:"14px",fontSize:36,fontWeight:800,textAlign:"center",
                boxSizing:"border-box",marginBottom:14,outline:"none"}}/>
            <div style={{display:"flex",gap:8}}>
              <button onClick={()=>setRecordPopup(null)}
                style={{flex:1,padding:"12px",borderRadius:10,border:"1px solid #e5e5e5",
                  background:"#fff",cursor:"pointer",fontSize:13,fontWeight:600}}>
                {staff.primaryLang==="zh"?"取消":staff.primaryLang==="es"?"Cancelar":"Cancel"}
              </button>
              <button onClick={()=>recordPopup.value.trim()&&finishTask(recordPopup.task.id,recordPopup.value.trim())}
                disabled={!recordPopup.value.trim()}
                style={{flex:2,padding:"12px",borderRadius:10,border:"none",
                  background:recordPopup.value.trim()?"#8E44AD":"#f0f0f0",
                  color:recordPopup.value.trim()?"#fff":"#aaa",
                  fontSize:13,fontWeight:700,cursor:recordPopup.value.trim()?"pointer":"default"}}>
                {staff.primaryLang==="zh"?"确认提交":staff.primaryLang==="es"?"Confirmar":"Submit & Complete"}
              </button>
            </div>
            <div style={{fontSize:11,color:"#aaa",textAlign:"center",marginTop:10}}>
              {staff.primaryLang==="zh"?"此记录将发送至管理员":
               staff.primaryLang==="es"?"Este registro será enviado al administrador":
               "This record will be emailed to management"}
            </div>
          </div>
        </div>
      )}

      {/* Task details popup */}
      {detailsPopup && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:500,
          display:"flex",alignItems:"flex-end",justifyContent:"center"}}
          onClick={()=>setDetailsPopup(null)}>
          <div style={{background:"#fff",borderRadius:"20px 20px 0 0",width:"100%",maxWidth:560,
            maxHeight:"70vh",overflowY:"auto",padding:"24px 20px 32px",
            boxShadow:"0 -8px 40px rgba(0,0,0,0.2)"}}
            onClick={e=>e.stopPropagation()}>
            <div style={{fontWeight:800,fontSize:18,color:"#1a1a1a",marginBottom:4}}>
              {detailsPopup.nameEn}
            </div>
            {detailsPopup.estimatedMins&&(
              <div style={{fontSize:12,color:"#aaa",marginBottom:14}}>⏱ ~{detailsPopup.estimatedMins} min</div>
            )}
            <div style={{fontSize:15,color:"#333",lineHeight:1.7,whiteSpace:"pre-wrap"}}>
              {detailsPopup.details}
            </div>
            <button onClick={()=>setDetailsPopup(null)}
              style={{marginTop:20,width:"100%",padding:"13px",borderRadius:12,border:"none",
                background:"#1a1a1a",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer"}}>
              Close
            </button>
          </div>
        </div>
      )}

      {/* Tasks grouped by subcategory — collapsible */}
      {sorted.length === 0 ? (
        <div style={{textAlign:"center", color:"#aaa", marginTop:60, fontSize:15}}>{tl.noTasks}</div>
      ) : (
        <div style={{display:"flex", flexDirection:"column", gap:8}}>
          {subcats.map(sub => {
            const subTasks = sorted.filter(a => {
              const t=tasks.find(x=>x.id===a.taskId);
              return (t?.subcategory||t?.category||"Other")===sub;
            });
            const {done, total} = subcatProgress(sub);
            const isExpanded = expandedSubcats[sub] !== false; // default expanded
            const hasUrgent = hasUrgentInSubcat(sub);
            const subPct = total > 0 ? Math.round(done/total*100) : 0;

            return (
              <div key={sub} style={{background:"#fff",borderRadius:14,
                overflow:"hidden",boxShadow:"0 2px 8px rgba(0,0,0,0.05)"}}>
                {/* Subcategory header — tap to expand/collapse */}
                <button onClick={()=>toggleSubcat(sub)}
                  style={{width:"100%",border:"none",cursor:"pointer",
                    background: hasUrgent&&subPct<100 ? "#FFF5F5" : subPct===100 ? "#F0FFF4" : "#fff",
                    padding:"14px 16px",textAlign:"left",
                    display:"flex",alignItems:"center",gap:10}}>
                  {hasUrgent&&subPct<100&&(
                    <span style={{background:"#E74C3C",color:"#fff",fontSize:9,
                      fontWeight:800,borderRadius:4,padding:"2px 6px",flexShrink:0}}>
                      {tl.urgent}
                    </span>
                  )}
                  <div style={{flex:1}}>
                    <div style={{fontWeight:800,fontSize:15,color:subPct===100?"#27AE60":"#1a1a1a"}}>
                      {sub}
                    </div>
                    <div style={{fontSize:11,color:"#aaa",marginTop:2}}>{done}/{total} tasks</div>
                  </div>
                  {/* Mini progress bar */}
                  <div style={{width:60,height:4,background:"#f0f0f0",borderRadius:99,overflow:"hidden",flexShrink:0}}>
                    <div style={{height:"100%",borderRadius:99,width:`${subPct}%`,
                      background:subPct===100?"#27AE60":"#1a1a1a",transition:"width .3s"}}/>
                  </div>
                  <span style={{fontSize:16,color:"#bbb",flexShrink:0,
                    transform:isExpanded?"rotate(90deg)":"none",transition:"transform .2s"}}>›</span>
                </button>

                {/* Tasks inside subcategory */}
                {isExpanded && (
                  <div style={{padding:"0 12px 12px"}}>
                    {subTasks.map((a,i) => {
                      const task = tasks.find(t => t.id===a.taskId);
                      if (!task) return null;
                      const ts = getTs(a.taskId);
                      const isStarted = !!ts?.startedAt;
                      const isDone = !!ts?.finishedAt;
                      const isUrgent = a.urgent;
                      const isRecord = task.recordOutput;

                      const baseName = staff.primaryLang==="zh" && task.nameZh ? task.nameZh :
                                       staff.primaryLang==="es" && task.nameEs ? task.nameEs : task.nameEn;
                      const assignedQty = a.qty;
                      const taskName = assignedQty ? baseName.split(' X ').join(' '+assignedQty+' ').split('X ').join(assignedQty+' ').split(' X').join(' '+assignedQty) : baseName;
                      const taskNameEn = (staff.primaryLang!=="en" && baseName !== task.nameEn)
                        ? (assignedQty ? task.nameEn.split(' X ').join(' '+assignedQty+' ').split('X ').join(assignedQty+' ').split(' X').join(' '+assignedQty) : task.nameEn) : null;

                      return (
                        <div key={a.taskId} style={{
                          background: isDone ? "#f0faf4" : isRecord ? "#FAF5FF" : "#fff",
                          border:`2px solid ${isDone?"#27AE60":isStarted?"#F39C12":isUrgent?"#E74C3C":isRecord?"#8E44AD33":"#f0f0f0"}`,
                          borderRadius:12, padding:"12px 14px", marginTop:8,
                          opacity: isDone ? 0.85 : 1
                        }}>
                          <div style={{display:"flex", alignItems:"flex-start", gap:10}}>
                            {/* Step number */}
                            <div style={{
                              width:26, height:26, borderRadius:"50%", flexShrink:0,
                              background: isDone?"#27AE60":isStarted?"#F39C12":isUrgent?"#E74C3C":isRecord?"#8E44AD":"#1a1a1a",
                              color:"#fff", display:"flex", alignItems:"center", justifyContent:"center",
                              fontSize:12, fontWeight:800
                            }}>
                              {isDone ? "✓" : i+1}
                            </div>
                            <div style={{flex:1}}>
                              <div style={{display:"flex", alignItems:"center", gap:6, flexWrap:"wrap"}}>
                                {isUrgent && !isDone && (
                                  <span style={{background:"#E74C3C",color:"#fff",fontSize:10,
                                    fontWeight:800,borderRadius:5,padding:"2px 7px"}}>{tl.urgent}</span>
                                )}
                                {isRecord && (
                                  <span style={{background:"#8E44AD",color:"#fff",fontSize:10,
                                    fontWeight:800,borderRadius:5,padding:"2px 7px"}}>📊 Record</span>
                                )}
                                <div style={{fontWeight:700, fontSize:14, color: isDone?"#27AE60":"#1a1a1a"}}>
                                  {taskName}
                                </div>
                                {task.details && (
                                  <button onClick={e=>{e.stopPropagation();setDetailsPopup(task);}}
                                    style={{background:"#f0f0f0",border:"none",borderRadius:20,
                                      padding:"2px 9px",fontSize:11,fontWeight:700,cursor:"pointer",color:"#555"}}>
                                    ℹ️ How-to
                                  </button>
                                )}
                              </div>
                              {taskNameEn && (
                                <div style={{fontSize:12,color:"#aaa",marginTop:2}}>{taskNameEn}</div>
                              )}
                              {isStarted && !isDone && ts.startedAt && (
                                <div style={{fontSize:11,color:"#F39C12",marginTop:4,fontWeight:600}}>
                                  {tl.inProgress} . started {new Date(ts.startedAt).toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"})}
                                  {ts.qty?<span style={{color:"#555",fontWeight:500}}> . Qty: {ts.qty}</span>:null}
                                </div>
                              )}
                              {isDone && ts.finishedAt && (
                                <div style={{fontSize:11,color:"#27AE60",marginTop:4,fontWeight:600}}>
                                  ✓ {tl.done} . {new Date(ts.finishedAt).toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"})}
                                  {ts.outputQty?<span style={{color:"#8E44AD",fontWeight:700}}> . {ts.outputQty} bags</span>:null}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Action buttons */}
                          {!isDone && !adminView && (
                            <div style={{marginTop:10,display:"flex",gap:8}}>
                              {!isStarted ? (
                                <button onClick={()=>startTask(a.taskId)}
                                  style={{flex:1,padding:"10px",borderRadius:10,border:"none",
                                    background:"#1a1a1a",color:"#fff",fontWeight:700,fontSize:14,cursor:"pointer"}}>
                                  {tl.start}
                                </button>
                              ) : (
                                <button onClick={()=>finishTask(a.taskId)}
                                  style={{flex:1,padding:"10px",borderRadius:10,border:"none",
                                    background:isRecord?"#8E44AD":"#27AE60",
                                    color:"#fff",fontWeight:700,fontSize:14,cursor:"pointer"}}>
                                  {isRecord
                                    ? (staff.primaryLang==="zh"?"完成并记录":staff.primaryLang==="es"?"Completar y registrar":"Complete & Record")
                                    : tl.finish}
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}


function PrepAdminView({ prepStaff, savePrepStaff, prepTasks, savePrepTasks,
  prepTemplates, savePrepTemplates, prepDailyAssignments, savePrepDailyAssignments,
  prepTimestamps, showToast }) {

  const [section, setSection] = useState("board");
  const [viewingStaff, setViewingStaff] = useState(null);
  const [boardView, setBoardView] = useState("staff");
  const [boardDate, setBoardDate] = useState(null); // null = use activeDate
  const [boardDragId, setBoardDragId] = useState(null);
  const [boardDragOverId, setBoardDragOverId] = useState(null);
  const [boardDragY, setBoardDragY] = useState(0);
  const [boardDragLabel, setBoardDragLabel] = useState("");
  const [subcatDragId, setSubcatDragId] = useState(null);
  const [subcatDragOverId, setSubcatDragOverId] = useState(null);
  const today = TODAY_KEY();
  const activeDate = today;
  const boardViewDate = boardDate || activeDate;
  const todayAssignments = prepDailyAssignments?.[boardViewDate] || [];

  // Admin can tap a staff card to see their task list (read-only view)
  if (viewingStaff) {
    return (
      <>
        <PrepTaskView
          staff={viewingStaff}
          tasks={prepTasks}
          assignments={todayAssignments.filter(a=>a.assignedTo?.includes(viewingStaff.id))}
          timestamps={prepTimestamps}
          savePrepTimestamps={(v)=>{}} // no-op for admin view — read only
          onBack={()=>setViewingStaff(null)}
          adminView={true}
        />
      </>
    );
  }

  // ── Board drag handlers ──
  const boardPointerDown = (e, taskId, label, staffId) => {
    e.preventDefault();
    setBoardDragId(`${staffId}::${taskId}`);
    setBoardDragY(e.clientY);
    setBoardDragLabel(label);
    const move = (ev) => setBoardDragY(ev.clientY);
    const up = (ev) => {
      document.removeEventListener("pointermove", move);
      document.removeEventListener("pointerup", up);
      const el = document.elementFromPoint(ev.clientX, ev.clientY);
      const targetKey = el?.closest("[data-boardtask]")?.dataset.boardtask;
      if (targetKey && targetKey !== `${staffId}::${taskId}`) {
        const targetTaskId = parseInt(targetKey.split("::")[1]);
        // Reorder within the todayAssignments for this staff
        const myAssignments = (todayAssignments||[]).filter(a=>a.assignedTo?.includes(staffId));
        const others = (todayAssignments||[]).filter(a=>!a.assignedTo?.includes(staffId));
        const from = myAssignments.findIndex(a=>a.taskId===taskId);
        const to = myAssignments.findIndex(a=>a.taskId===targetTaskId);
        if (from>=0 && to>=0) {
          const next = [...myAssignments];
          const [moved] = next.splice(from, 1);
          next.splice(to, 0, moved);
          next.forEach((a,i)=>a.order=i);
          savePrepDailyAssignments({...prepDailyAssignments, [TODAY_KEY()]: [...others, ...next]});
        }
      }
      setBoardDragId(null); setBoardDragOverId(null); setBoardDragY(0); setBoardDragLabel("");
    };
    document.addEventListener("pointermove", move);
    document.addEventListener("pointerup", up);
  };

  const subcatPointerDown = (e, staffId, subcat, allSubcats, myAssignments) => {
    e.preventDefault();
    setSubcatDragId(`${staffId}::${subcat}`);
    const move = () => {};
    const up = (ev) => {
      document.removeEventListener("pointermove", move);
      document.removeEventListener("pointerup", up);
      const el = document.elementFromPoint(ev.clientX, ev.clientY);
      const targetKey = el?.closest("[data-subcatdrag]")?.dataset.subcatdrag;
      if (targetKey && targetKey !== `${staffId}::${subcat}`) {
        const targetSubcat = targetKey.split("::").slice(1).join("::");
        const fromIdx = allSubcats.indexOf(subcat);
        const toIdx = allSubcats.indexOf(targetSubcat);
        if (fromIdx>=0 && toIdx>=0) {
          // Reorder all tasks: move all subcat tasks to target position
          const others = myAssignments.filter(a=>{
            const t=(prepTasks||[]).find(x=>x.id===a.taskId);
            return (t?.subcategory||"Other")!==subcat;
          });
          const subcatTasks = myAssignments.filter(a=>{
            const t=(prepTasks||[]).find(x=>x.id===a.taskId);
            return (t?.subcategory||"Other")===subcat;
          });
          // Insert subcatTasks at the target subcategory position
          const targetTasks = myAssignments.filter(a=>{
            const t=(prepTasks||[]).find(x=>x.id===a.taskId);
            return (t?.subcategory||"Other")===targetSubcat;
          });
          const targetFirstOrder = Math.min(...targetTasks.map(a=>a.order||0));
          const remaining = myAssignments.filter(a=>{
            const t=(prepTasks||[]).find(x=>x.id===a.taskId);
            const s=t?.subcategory||"Other";
            return s!==subcat && s!==targetSubcat;
          });
          // Re-sort: place subcat before/after target
          const insertBefore = fromIdx > toIdx;
          let reordered;
          if (insertBefore) {
            reordered = [...subcatTasks, ...targetTasks, ...remaining];
          } else {
            reordered = [...targetTasks, ...subcatTasks, ...remaining];
          }
          const allOthers = (todayAssignments||[]).filter(a=>!a.assignedTo?.includes(staffId));
          reordered.forEach((a,i)=>a.order=i);
          savePrepDailyAssignments({...prepDailyAssignments, [TODAY_KEY()]: [...allOthers, ...reordered]});
        }
      }
      setSubcatDragId(null); setSubcatDragOverId(null);
    };
    document.addEventListener("pointermove", move);
    document.addEventListener("pointerup", up);
  };

  // ── Board (live view) ──
  if (section === "board") {
    return (
      <div>
        <div style={{display:"flex", gap:6, marginBottom:20, flexWrap:"wrap"}}>
          {[["board","📋 Live Board"],["assign","Note: Assign Tasks"],["tasks","🗂 Task Library"],["staff","👥 Staff"],["analytics","📊 Analytics"]].map(([k,l])=>(
            <button key={k} onClick={()=>setSection(k)}
              style={{border:"none", borderRadius:20, padding:"7px 16px", fontSize:13, fontWeight:700,
                cursor:"pointer", background:section===k?"#1a1a1a":"#f0f0f0", color:section===k?"#fff":"#555"}}>
              {l}
            </button>
          ))}
        </div>
        {/* Board date selector + view toggle */}
        <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap",alignItems:"center"}}>
          <div style={{background:"#f0f0f0",borderRadius:10,padding:3,display:"flex",gap:4}}>
            {[["staff","👥 By Employee"],["all","📋 All Tasks"]].map(([v,l])=>(
              <button key={v} onClick={()=>setBoardView(v)}
                style={{border:"none",borderRadius:8,padding:"7px 16px",fontSize:13,
                  fontWeight:700,cursor:"pointer",
                  background:boardView===v?"#1a1a1a":"transparent",
                  color:boardView===v?"#fff":"#666"}}>
                {l}
              </button>
            ))}
          </div>
          {/* Date picker for viewing assigned days */}
          <select
            value={boardDate||today}
            onChange={e=>setBoardDate(e.target.value)}
            style={{border:"1px solid #e5e5e5",borderRadius:9,padding:"7px 12px",
              fontSize:13,fontWeight:600,cursor:"pointer",background:"#fff",
              color:"#1a1a1a"}}>
            {(() => {
              const opts = [];
              const seen = new Set(Object.keys(prepDailyAssignments||{}));
              // Always show next 7 weekdays
              let d = new Date(); let count = 0;
              while (count < 7) {
                const day = d.getDay();
                if (day!==0&&day!==6) {
                  const s = d.toISOString().slice(0,10);
                  seen.add(s);
                  count++;
                }
                d = new Date(d.getTime()+86400000);
              }
              return [...seen].sort().map(date => {
                const isToday = date===today;
                const label = new Date(date+'T12:00:00').toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric"});
                const hasAssignments = (prepDailyAssignments?.[date]?.length||0) > 0;
                return <option key={date} value={date}>
                  {isToday?"Today":""}  {label} {hasAssignments?"●":""}
                </option>;
              });
            })()}
          </select>
        </div>

                {/* All Tasks view — grouped by employee, subcategory within */}
        {boardView==="all" && (() => {
          const staffWithTasks = (prepStaff||[]).filter(s=>
            (todayAssignments||[]).some(a=>a.assignedTo?.includes(s.id))
          );
          const unassigned = (todayAssignments||[]).filter(a=>!a.assignedTo?.length);
          return (
            <div style={{display:"flex",flexDirection:"column",gap:24}}>
              {staffWithTasks.map(s => {
                const myAssignments = (todayAssignments||[])
                  .filter(a=>a.assignedTo?.includes(s.id))
                  .sort((a,b)=>b.urgent-a.urgent);
                const myTs = (prepTimestamps||[]).filter(ts=>ts.staffId===s.id&&ts.date===boardViewDate);
                const done = myTs.filter(ts=>ts.finishedAt).length;
                const pct = myAssignments.length>0?Math.round(done/myAssignments.length*100):0;

                // Group by subcategory
                const subcats = [...new Set(myAssignments.map(a=>{
                  const t=(prepTasks||[]).find(x=>x.id===a.taskId);
                  return t?.subcategory||"Other";
                }))];

                return (
                  <div key={s.id} style={{background:"#fff",borderRadius:14,
                    boxShadow:"0 2px 10px rgba(0,0,0,0.06)",overflow:"hidden"}}>
                    {/* Employee header */}
                    <div style={{padding:"12px 16px",background:"#1a1a1a",
                      display:"flex",alignItems:"center",gap:12}}>
                      <div style={{flex:1}}>
                        <div style={{fontWeight:800,fontSize:15,color:"#fff"}}>{s.name}</div>
                        <div style={{fontSize:11,color:"#aaa",marginTop:2}}>
                          {s.primaryLang==="zh"?"中文":s.primaryLang==="es"?"Español":"English"}
                          {" . "}{done}/{myAssignments.length} tasks done
                        </div>
                      </div>
                      {/* Mini progress bar */}
                      <div style={{width:80,height:6,background:"#444",borderRadius:99,overflow:"hidden"}}>
                        <div style={{height:"100%",borderRadius:99,width:`${pct}%`,
                          background:pct===100?"#27AE60":"#F39C12",transition:"width .3s"}}/>
                      </div>
                      <div style={{color:pct===100?"#27AE60":"#aaa",fontSize:12,fontWeight:700,minWidth:32}}>
                        {pct}%
                      </div>
                    </div>

                    {/* Tasks grouped by subcategory */}
                    <div style={{padding:"8px 0"}}>
                      {subcats.map(sub => {
                        const subTasks = myAssignments.filter(a=>{
                          const t=(prepTasks||[]).find(x=>x.id===a.taskId);
                          return (t?.subcategory||"Other")===sub;
                        });
                        return (
                          <div key={sub}>
                            {subcats.length>1&&(
                              <div
                                data-subcatdrag={`${s.id}::${sub}`}
                                onPointerEnter={()=>subcatDragId&&setSubcatDragOverId(`${s.id}::${sub}`)}
                                style={{fontSize:10,fontWeight:800,
                                  color:subcatDragOverId===`${s.id}::${sub}`?"#1a1a1a":"#bbb",
                                  letterSpacing:1,padding:"8px 16px 4px",
                                  textTransform:"uppercase",display:"flex",alignItems:"center",gap:6,
                                  background:subcatDragOverId===`${s.id}::${sub}`?"#f5f5f5":"transparent",
                                  transition:"background .1s"}}>
                                <span
                                  onPointerDown={e=>subcatPointerDown(e, s.id, sub, subcats, myAssignments)}
                                  style={{color:"#ccc",fontSize:14,cursor:"grab",touchAction:"none",userSelect:"none"}}
                                  onClick={e=>e.stopPropagation()}>⠿</span>
                                {sub}
                              </div>
                            )}
                            {subTasks.map(a=>{
                              const task=(prepTasks||[]).find(t=>t.id===a.taskId);
                              if(!task) return null;
                              const ts=myTs.find(ts=>ts.taskId==a.taskId);
                              const isDone=!!ts?.finishedAt;
                              const isStarted=!!ts?.startedAt&&!isDone;
                              return (
                                <div key={a.taskId}
                              data-boardtask={`${s.id}::${a.taskId}`}
                              onPointerEnter={()=>boardDragId&&setBoardDragOverId(`${s.id}::${a.taskId}`)}
                              style={{
                                  padding:"10px 16px",
                                  borderLeft:`3px solid ${a.urgent?"#E74C3C":isDone?"#27AE60":isStarted?"#F39C12":"transparent"}`,
                                  background:boardDragOverId===`${s.id}::${a.taskId}`&&boardDragId!==`${s.id}::${a.taskId}`?"#f0f0f0":isDone?"#fafffe":isStarted?"#FFFDF7":"#fff",
                                  borderBottom:"1px solid #f0f0f0",
                                  display:"flex",alignItems:"center",gap:10,
                                  opacity:boardDragId===`${s.id}::${a.taskId}`?0.35:1,
                                  transform:boardDragOverId===`${s.id}::${a.taskId}`&&boardDragId!==`${s.id}::${a.taskId}`?"translateY(-2px)":"none",
                                  transition:"transform .1s,background .1s"
                                }}>
                                <span
                                  onPointerDown={e=>boardPointerDown(e, a.taskId, task?.nameEn||"", s.id)}
                                  style={{color:"#ddd",fontSize:16,cursor:"grab",flexShrink:0,
                                    padding:"0 4px",touchAction:"none",userSelect:"none"}}
                                  onClick={e=>e.stopPropagation()}>⠿</span>
                                  <div style={{flex:1}}>
                                    <div style={{fontSize:13,fontWeight:isDone?500:600,
                                      color:isDone?"#aaa":"#1a1a1a",
                                      textDecoration:isDone?"line-through":"none",
                                      display:"flex",alignItems:"center",gap:6}}>
                                      {a.urgent&&!isDone&&(
                                        <span style={{background:"#E74C3C",color:"#fff",
                                          fontSize:9,fontWeight:800,borderRadius:4,
                                          padding:"1px 5px",flexShrink:0}}>URGENT</span>
                                      )}
                                      {task.nameEn}
                                      {a.qty&&<span style={{fontSize:11,color:"#888",fontWeight:400}}>× {a.qty}</span>}
                                    </div>
                                  </div>
                                  <div style={{fontSize:11,fontWeight:700,flexShrink:0,
                                    color:isDone?"#27AE60":isStarted?"#F39C12":"#ccc"}}>
                                    {isDone?"✓ Done":isStarted?"● In progress":"○ Not started"}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}

              {/* Unassigned tasks */}
              {unassigned.length>0&&(
                <div style={{background:"#fff",borderRadius:14,boxShadow:"0 2px 10px rgba(0,0,0,0.06)",overflow:"hidden"}}>
                  <div style={{padding:"12px 16px",background:"#f0f0f0"}}>
                    <div style={{fontWeight:800,fontSize:15,color:"#888"}}>⚠ Unassigned</div>
                  </div>
                  {unassigned.map(a=>{
                    const task=(prepTasks||[]).find(t=>t.id===a.taskId);
                    return task?(
                      <div key={a.taskId} style={{padding:"10px 16px",borderBottom:"1px solid #f0f0f0",
                        fontSize:13,color:"#aaa"}}>
                        {task.nameEn}
                      </div>
                    ):null;
                  })}
                </div>
              )}

              {staffWithTasks.length===0&&unassigned.length===0&&(
                <div style={{color:"#aaa",textAlign:"center",padding:40,fontSize:13}}>
                  No tasks assigned today. Go to Note: Assign Tasks.
                </div>
              )}
            </div>
          );
        })()}

        {/* Floating board drag indicator */}
        {boardDragId && boardDragY > 0 && (
          <div style={{position:"fixed",left:"50%",top:boardDragY-20,transform:"translateX(-50%)",
            background:"#1a1a1a",color:"#fff",borderRadius:10,padding:"8px 18px",
            fontSize:13,fontWeight:700,pointerEvents:"none",zIndex:9999,
            boxShadow:"0 8px 24px rgba(0,0,0,0.3)",whiteSpace:"nowrap",maxWidth:"80vw",
            overflow:"hidden",textOverflow:"ellipsis"}}>
            ⠿ {boardDragLabel}
          </div>
        )}

{/* By Employee view */}
        {boardView==="staff" && <div style={{display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))", gap:12}}>
          {(prepStaff||[]).map(s => {
            const myA = todayAssignments.filter(a=>a.assignedTo?.includes(s.id));
            const myTs = (prepTimestamps||[]).filter(ts=>ts.staffId===s.id&&ts.date===boardViewDate);
            const done = myTs.filter(ts=>ts.finishedAt).length;
            const inProg = myTs.filter(ts=>ts.startedAt&&!ts.finishedAt).length;
            const pct = myA.length>0?Math.round(done/myA.length*100):0;
            const current = myTs.find(ts=>ts.startedAt&&!ts.finishedAt);
            const currentTask = current ? prepTasks.find(t=>t.id===current.taskId) : null;
            return (
              <div key={s.id}
                onClick={()=>setViewingStaff(s)}
                style={{background:"#fff",borderRadius:14,padding:16,
                  boxShadow:"0 2px 10px rgba(0,0,0,0.06)",cursor:"pointer",
                  transition:"box-shadow .15s"}}
                onMouseEnter={e=>e.currentTarget.style.boxShadow="0 4px 20px rgba(0,0,0,0.12)"}
                onMouseLeave={e=>e.currentTarget.style.boxShadow="0 2px 10px rgba(0,0,0,0.06)"}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                  <div style={{fontWeight:800,fontSize:15}}>{s.name}</div>
                  <div style={{fontSize:11,color:"#aaa",background:"#f5f5f5",borderRadius:6,padding:"2px 8px"}}>
                    {s.primaryLang==="zh"?"中文":s.primaryLang==="es"?"ES":"EN"}
                  </div>
                </div>
                <div style={{background:"#f0f0f0",borderRadius:99,height:6,marginBottom:6,overflow:"hidden"}}>
                  <div style={{height:"100%",borderRadius:99,width:`${pct}%`,
                    background:pct===100?"#27AE60":"#1a1a1a",transition:"width .3s"}}/>
                </div>
                <div style={{fontSize:12,color:"#888",marginBottom:8}}>
                  {done}/{myA.length} done {inProg>0?`. ${inProg} in progress`:""}
                </div>
                {currentTask && (
                  <div style={{background:"#FFF9F0",border:"1px solid #F39C12",borderRadius:8,
                    padding:"6px 10px",fontSize:12,color:"#D35400",fontWeight:600}}>
                    🟡 {currentTask.nameEn}
                  </div>
                )}
                {pct===100 && (
                  <div style={{background:"#f0faf4",border:"1px solid #27AE60",borderRadius:8,
                    padding:"6px 10px",fontSize:12,color:"#27AE60",fontWeight:600}}>
                    ✓ All done!
                  </div>
                )}
              </div>
            );
          })}
        </div>}
      </div>
    );
  }

  // ── Assign Tasks ──
  if (section === "assign") {
    return <PrepAssignView
      prepStaff={prepStaff} prepTasks={prepTasks}
      prepTemplates={prepTemplates} savePrepTemplates={savePrepTemplates}
      prepDailyAssignments={prepDailyAssignments} savePrepDailyAssignments={savePrepDailyAssignments}
      showToast={showToast} onBack={()=>setSection("board")} />;
  }

  // ── Task Library ──
  if (section === "tasks") {
    return <PrepTaskLibrary prepTasks={prepTasks} savePrepTasks={savePrepTasks}
      showToast={showToast} onBack={()=>setSection("board")} />;
  }

  // ── Staff ──
  if (section === "staff") {
    return <PrepStaffManager prepStaff={prepStaff} savePrepStaff={savePrepStaff}
      showToast={showToast} onBack={()=>setSection("board")} />;
  }

  // ── Analytics ──
  if (section === "analytics") {
    return <PrepAnalytics prepTimestamps={prepTimestamps} prepTasks={prepTasks}
      prepStaff={prepStaff} prepDailyAssignments={prepDailyAssignments} onBack={()=>setSection("board")} />;
  }

  return null;
}

const btnSm = {background:"#f5f5f5",border:"none",borderRadius:6,padding:"4px 8px",cursor:"pointer",color:"#555",fontSize:12};

// ── PrepAssignView — assign tasks for today / manage templates ──
// Flow: Pick Date → Pick Staff → Pick Category → Pick Tasks (with qty popup for X tasks)
function PrepAssignView({ prepStaff, prepTasks, prepTemplates, savePrepTemplates,
  prepDailyAssignments, savePrepDailyAssignments, showToast, onBack }) {
  const [dragTaskId, setDragTaskId] = useState(null);
  const [dragOverId, setDragOverId] = useState(null);
  const [dragY, setDragY] = useState(0);
  const [dragLabel, setDragLabel] = useState("");
  const dragRef = useRef(null);

  const todayStr = new Date().toISOString().slice(0,10);
  const tomorrowStr = new Date(Date.now()+86400000).toISOString().slice(0,10);
  const fmtDate = (s) => new Date(s+'T12:00:00').toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric"});

  // Step state: "date" | "staff" | "category" | "tasks"
  const [step, setStep] = useState("date");
  const [selectedDate, setSelectedDate] = useState(todayStr);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [selectedCat, setSelectedCat] = useState(null);
  const [qtyPopup, setQtyPopup] = useState(null); // {task, value}

  // Load existing assignments for selected date
  const [assignments, setAssignments] = useState(() => prepDailyAssignments?.[todayStr] || []);

  // Update assignments when date changes
  const loadDate = (date) => {
    setSelectedDate(date);
    setAssignments(prepDailyAssignments?.[date] || []);
    setStep("staff");
  };

  const saveDay = (assgns) => {
    savePrepDailyAssignments({...prepDailyAssignments, [selectedDate]: assgns});
  };

  const saveTemplate = () => {
    savePrepTemplates({...prepTemplates, default: assignments});
    showToast("Saved as default template");
  };

  // Get categories from tasks
  // Top-level categories (e.g. "Vegetable Prep", "Filling Prep")
  const MAIN_CATEGORIES = ["Vegetable Prep", "Filling Prep", "Meat Prep"];
  const categories = MAIN_CATEGORIES;

  // Subcategories within a main category (e.g. "Carrots", "Taiwan Cabbage")
  const subcatsInCategory = (mainCat) =>
    [...new Set((prepTasks||[]).filter(t=>t.category===mainCat).map(t=>t.subcategory).filter(Boolean))];

  const tasksInSubcat = (mainCat, subcat) =>
    (prepTasks||[]).filter(t=>t.category===mainCat && t.subcategory===subcat);

  const SUBCAT_META = {
  "Chicken Breast":   ["🍗","#FFF5F5","#C0392B"],
  "Pork Picnic":      ["🥩","#FFF5F5","#922B21"],
  "Beef Heel (Sliced)": ["🥩","#FEF9E7","#784212"],
  "Beef Heel (Stewed)": ["🍲","#FEF9E7","#784212"],
  "Duck":             ["🦆","#F8F9FA","#2C3E50"],
  "Eye Round of Beef":["🥩","#FEF9E7","#784212"],
  "Impossible Meat":  ["🌱","#F0FFF4","#1A5276"],
  "Chicken Carcass":  ["🍗","#FFF5F5","#C0392B"],
  "Chicken Thigh":    ["🍗","#FFF5F5","#C0392B"],
  "Pork Ribs":        ["🥩","#FFF5F5","#922B21"],
  "Pork Belly":       ["🥩","#FFF5F5","#922B21"],
  "Pork Loin":        ["🥩","#FFF5F5","#922B21"],
  // Filling subcategories
  "Shrimp & Chicken Wonton Filling": ["🦐","#EBF5FB","#1A5276"],
  "Spinach & Mushroom Wonton Filling": ["🥬","#EAFAF1","#1E8449"],
  "Chive & Pork Filling":   ["🌿","#F0FFF4","#276749"],
  "Basil & Chicken Filling":["🌿","#F0FFF4","#1E8449"],
  "Cabbage & Pork Filling": ["🥬","#F0FFF4","#276749"],
  "Spicy Beef Filling":     ["🌶️","#FFEBEE","#B71C1C"],
  "Spicy Vegan Beef Filling":["🌱","#F0FFF4","#1A5276"],
  "Shrimp Filling":         ["🦐","#EBF5FB","#1A5276"],
  "Vegetable Filling":      ["🥦","#F0FFF4","#276749"],
'Carrots': ('🥕', '#FFF3E0', '#E65100'), 'Taiwan Cabbage': ('🥬', '#E8F5E9', '#2E7D32'), 'Baby Bok Choy': ('🥬', '#E0F2F1', '#00695C'), 'Chives': ('🌿', '#F1F8E9', '#558B2F'), 'Scallion': ('🌱', '#E8F5E9', '#388E3C'), 'Cucumber': ('🥒', '#E0F7FA', '#006064'), 'Napa Cabbage': ('🥬', '#F3E5F5', '#6A1B9A'), 'Celery': ('🌿', '#FAFDE7', '#827717'), 'Mushroom': ('🍄', '#FBE9E7', '#BF360C'), 'Onion': ('🧅', '#FFF8E1', '#F57F17'), 'Long Hot Pepper': ('🌶️', '#FFEBEE', '#B71C1C'), 'Basil': ('🌿', '#E8F5E9', '#1B5E20'), 'Smoked Tofu': ('🟤', '#FBE9E7', '#4E342E'), "Sherpherd's Purse": ('🌿', '#F0FFF4', '#276749'), 'Spinach': ('🥬', '#ECFDF5', '#065F46')};

  const tasksInCat = (cat) => (prepTasks||[]).filter(t=>t.category===cat);

  const isAssigned = (taskId, staffId) =>
    assignments.some(a=>a.taskId===taskId && a.assignedTo?.includes(staffId));

  const toggleTask = (task, staffId, qty) => {
    const existing = assignments.find(a=>a.taskId==task.id && a.assignedTo?.includes(staffId));
    let next;
    if (existing && qty) {
      // Updating qty on already-assigned task — just update qty, don't remove
      next = assignments.map(a=>a.taskId==task.id ? {...a, qty} : a);
    } else if (existing) {
      // Remove this staff from task
      const updatedAssignees = existing.assignedTo.filter(id=>id!==staffId);
      if (updatedAssignees.length === 0) {
        next = assignments.filter(a=>a.taskId!=task.id);
      } else {
        next = assignments.map(a=>a.taskId==task.id ? {...a, assignedTo:updatedAssignees} : a);
      }
    } else {
      // Add task — if hasQuantity and no qty provided, show popup
      if (task.hasQuantity && !qty) {
        setQtyPopup({task, staffId, value:""});
        return;
      }
      const existingTask = assignments.find(a=>a.taskId==task.id);
      if (existingTask) {
        next = assignments.map(a=>a.taskId==task.id
          ? {...a, assignedTo:[...(a.assignedTo||[]), staffId], qty: qty||a.qty}
          : a);
      } else {
        next = [...assignments, {
          taskId:task.id, assignedTo:[staffId],
          order:assignments.length, urgent:false, qty: qty||null
        }];
      }
    }
    setAssignments(next);
    saveDay(next);
  };

  const toggleUrgent = (taskId) => {
    const next = assignments.map(a=>a.taskId===taskId?{...a,urgent:!a.urgent}:a);
    setAssignments(next);
    saveDay(next);
  };

  const confirmQty = () => {
    if (!qtyPopup?.value?.trim()) return;
    const {task, staffId, value} = qtyPopup;
    setQtyPopup(null);
    toggleTask({...task, hasQuantity:false}, staffId, value.trim());
  };

  // ── Pointer-based drag to reorder (shows live movement) ──
  const pointerDown = (e, taskId, label) => {
    e.preventDefault();
    setDragTaskId(taskId);
    setDragY(e.clientY);
    setDragLabel(label);
    const move = (ev) => setDragY(ev.clientY);
    const up = (ev) => {
      document.removeEventListener("pointermove", move);
      document.removeEventListener("pointerup", up);
      // Find what we're hovering over
      const el = document.elementFromPoint(ev.clientX, ev.clientY);
      const targetId = el?.closest("[data-taskid]")?.dataset.taskid;
      if (targetId && targetId !== String(taskId)) {
        const from = assignments.findIndex(a=>a.taskId===taskId);
        const to   = assignments.findIndex(a=>String(a.taskId)===targetId);
        if (from>=0 && to>=0) {
          const next = [...assignments];
          const [moved] = next.splice(from, 1);
          next.splice(to, 0, moved);
          next.forEach((a,i)=>a.order=i);
          setAssignments(next);
          saveDay(next);
        }
      }
      setDragTaskId(null); setDragOverId(null); setDragY(0); setDragLabel("");
    };
    document.addEventListener("pointermove", move);
    document.addEventListener("pointerup", up);
  };
  const onDragOver = (taskId) => setDragOverId(taskId);

  // Count assigned tasks for a staff member
  const staffTaskCount = (staffId) =>
    assignments.filter(a=>a.assignedTo?.includes(staffId)).length;

  const assignedInCat = (cat, staffId) =>
    assignments.filter(a=>{
      const t=(prepTasks||[]).find(x=>x.id===a.taskId);
      return t && t.category===cat && a.assignedTo?.includes(staffId);
    }).length;

  // Breadcrumb component for assign flow
  const Breadcrumb = () => (
    <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:16,flexWrap:"wrap"}}>
      <button onClick={onBack}
        style={{background:"#1a1a1a",color:"#fff",border:"none",borderRadius:8,
          padding:"5px 12px",fontSize:12,fontWeight:700,cursor:"pointer"}}>
        ⌂ Prep Home
      </button>
      {step!=="date"&&<><span style={{color:"#ccc"}}>›</span>
      <button onClick={()=>setStep("date")}
        style={{background:"none",border:"none",color:step==="date"?"#1a1a1a":"#888",
          fontSize:12,fontWeight:600,cursor:"pointer",padding:"4px 8px",
          borderRadius:6,background:step==="date"?"#f0f0f0":"none"}}>
        {fmtDate(selectedDate)}
      </button></>}
      {(step==="category"||step==="tasks")&&<><span style={{color:"#ccc"}}>›</span>
      <button onClick={()=>setStep("staff")}
        style={{background:"none",border:"none",color:step==="staff"?"#1a1a1a":"#888",
          fontSize:12,fontWeight:600,cursor:"pointer",padding:"4px 8px"}}>
        {selectedStaff?.name}
      </button></>}
      {step==="tasks"&&<><span style={{color:"#ccc"}}>›</span>
      <button onClick={()=>setStep("category")}
        style={{background:"none",border:"none",color:"#888",
          fontSize:12,fontWeight:600,cursor:"pointer",padding:"4px 8px"}}>
        {selectedCat}
      </button></>}
    </div>
  );

  // ── STEP: Date ──
  if (step==="date") {
    // Only show weekdays (Mon-Fri), get next 5
    const dates = [];
    let d = new Date();
    while (dates.length < 5) {
      const day = d.getDay();
      if (day !== 0 && day !== 6) dates.push(d.toISOString().slice(0,10));
      d = new Date(d.getTime() + 86400000);
    }
    return (
      <div>
        <Breadcrumb/>
        <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:20}}>
          <h2 style={{margin:0,fontSize:20,fontWeight:800}}>📅 Choose a Date</h2>
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:8,maxWidth:360}}>
          {dates.map((d,i)=>(
            <button key={d} onClick={()=>loadDate(d)}
              style={{padding:"14px 18px",borderRadius:12,border:`2px solid ${d===tomorrowStr?"#1a1a1a":"#e8e8e8"}`,
                background:d===tomorrowStr?"#1a1a1a":"#fff",
                color:d===tomorrowStr?"#fff":"#1a1a1a",
                fontSize:15,fontWeight:700,cursor:"pointer",textAlign:"left",
                display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span>{fmtDate(d)}</span>
              <span style={{fontSize:12,fontWeight:500,opacity:0.6}}>
                {i===0?"Today (default)":i===1?"Tomorrow":""}
                {(prepDailyAssignments?.[d]?.length||0)>0 ? ` . ${prepDailyAssignments[d].length} tasks` : ""}
              </span>
            </button>
          ))}
        </div>
      </div>
    );
  }

  // ── STEP: Staff ──
  if (step==="staff") {
    return (
      <div>
        <Breadcrumb/>
        <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
          <h2 style={{margin:0,fontSize:20,fontWeight:800}}>👤 Who are you assigning to?</h2>
        </div>
        <div style={{fontSize:13,color:"#aaa",marginBottom:20}}>{fmtDate(selectedDate)}</div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"flex-end",gap:8,marginBottom:14}}>
          <button onClick={saveTemplate}
            style={{border:"1px solid #e5e5e5",borderRadius:9,padding:"7px 14px",
              background:"#fff",color:"#555",fontSize:12,fontWeight:700,cursor:"pointer"}}>
            💾 Save as Template
          </button>
          <button onClick={()=>showToast("Tasks auto-saved as you go!")}
            style={{border:"none",borderRadius:9,padding:"7px 14px",
              background:"#1a1a1a",color:"#fff",fontSize:12,fontWeight:700,cursor:"pointer"}}>
            ✓ Published
          </button>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))",gap:10}}>
          {(prepStaff||[]).map(s=>(
            <button key={s.id} onClick={()=>{setSelectedStaff(s);setStep("category");}}
              style={{background:"#fff",border:`2px solid ${selectedStaff?.id===s.id?"#1a1a1a":"#e8e8e8"}`,
                borderRadius:14,padding:"16px 14px",cursor:"pointer",textAlign:"left",
                boxShadow:"0 2px 8px rgba(0,0,0,0.05)"}}>
              <div style={{fontSize:24,marginBottom:6}}>👤</div>
              <div style={{fontWeight:800,fontSize:15,marginBottom:4}}>{s.name}</div>
              <div style={{fontSize:12,color:"#aaa"}}>
                {s.primaryLang==="zh"?"中文":s.primaryLang==="es"?"ES":"EN"} . {s.shift==="am"?"Morning":s.shift==="pm"?"Afternoon":"All Day"}
              </div>
              {staffTaskCount(s.id)>0&&(
                <div style={{marginTop:8,background:"#f0f0f0",borderRadius:8,padding:"4px 8px",
                  fontSize:11,fontWeight:700,color:"#555",display:"inline-block"}}>
                  {staffTaskCount(s.id)} tasks
                </div>
              )}
            </button>
          ))}
        </div>
        {(prepStaff||[]).length===0&&(
          <div style={{color:"#aaa",textAlign:"center",padding:40,fontSize:13}}>
            No prep staff added yet. Go to 👥 Staff to add team members.
          </div>
        )}
      </div>
    );
  }

  // ── STEP: Category ──
  if (step==="category") {
    return (
      <div>
        <Breadcrumb/>
        <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
          <h2 style={{margin:0,fontSize:20,fontWeight:800}}>📂 Pick a Category</h2>
        </div>
        <div style={{fontSize:13,color:"#aaa",marginBottom:20}}>
          Assigning to <strong style={{color:"#1a1a1a"}}>{selectedStaff?.name}</strong> . {fmtDate(selectedDate)}
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {categories.map(cat=>{
            const CAT_META = {
              "Vegetable Prep": ["🥬","#F0FFF4","#276749"],
              "Filling Prep":   ["🥟","#FFF8E1","#B7791F"],
            };
            const [emoji, bg, color] = CAT_META[cat] || ["📋","#f5f5f5","#555"];
            const total = tasksInCat(cat).length;
            const assigned = assignedInCat(cat, selectedStaff?.id);
            return (
              <button key={cat} onClick={()=>{setSelectedCat(cat);setStep("tasks");}}
                style={{background:bg,border:`1.5px solid ${color}33`,borderRadius:12,
                  padding:"14px 16px",cursor:"pointer",textAlign:"left",
                  display:"flex",alignItems:"center",gap:12}}>
                <span style={{fontSize:28}}>{emoji}</span>
                <div style={{flex:1}}>
                  <div style={{fontWeight:700,fontSize:15,color:"#1a1a1a"}}>{cat}</div>
                  <div style={{fontSize:12,color:"#888",marginTop:2}}>{total} tasks available</div>
                </div>
                {assigned>0&&(
                  <div style={{background:color,color:"#fff",borderRadius:20,
                    padding:"4px 12px",fontSize:12,fontWeight:700,flexShrink:0}}>
                    {assigned}/{total} assigned
                  </div>
                )}
                <span style={{color:"#bbb",fontSize:18}}>›</span>
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  // ── STEP: Tasks ──
  if (step==="tasks") {
    const CAT_META = {
      "Vegetable Prep": ["🥬","#F0FFF4","#276749"],
      "Filling Prep":   ["🥟","#FFF8E1","#B7791F"],
      "Meat Prep":      ["🥩","#FFF0F0","#C0392B"],
    };
    const [catEmoji, catBg, catColor] = CAT_META[selectedCat] || ["📋","#f5f5f5","#555"];
    const subcats = subcatsInCategory(selectedCat);

    return (
      <div>
        {/* Floating drag indicator */}
        {dragTaskId && dragY > 0 && (
          <div style={{position:"fixed",left:"50%",top:dragY-20,transform:"translateX(-50%)",
            background:"#1a1a1a",color:"#fff",borderRadius:10,padding:"8px 18px",
            fontSize:13,fontWeight:700,pointerEvents:"none",zIndex:9999,
            boxShadow:"0 8px 24px rgba(0,0,0,0.3)",whiteSpace:"nowrap",maxWidth:"80vw",
            overflow:"hidden",textOverflow:"ellipsis"}}>
            ⠿ {dragLabel}
          </div>
        )}

        {/* Qty popup */}
        {qtyPopup && (
          <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:500,
            display:"flex",alignItems:"center",justifyContent:"center",padding:20}}
            onClick={()=>setQtyPopup(null)}>
            <div style={{background:"#fff",borderRadius:20,padding:"24px 20px",width:"100%",maxWidth:320}}
              onClick={e=>e.stopPropagation()}>
              <div style={{fontWeight:800,fontSize:16,marginBottom:4}}>{qtyPopup.task.nameEn}</div>
              <div style={{fontSize:13,color:"#888",marginBottom:14}}>How many?</div>
              <input autoFocus type="number" inputMode="numeric"
                value={qtyPopup.value}
                onChange={e=>setQtyPopup(p=>({...p,value:e.target.value}))}
                placeholder="0"
                onKeyDown={e=>e.key==="Enter"&&confirmQty()}
                style={{width:"100%",border:"2px solid #1a1a1a",borderRadius:12,
                  padding:"14px",fontSize:36,fontWeight:800,textAlign:"center",
                  boxSizing:"border-box",marginBottom:14,outline:"none"}}/>
              <div style={{display:"flex",gap:8}}>
                <button onClick={()=>setQtyPopup(null)}
                  style={{flex:1,padding:"12px",borderRadius:10,border:"1px solid #e5e5e5",
                    background:"#fff",cursor:"pointer",fontSize:13,fontWeight:600}}>Cancel</button>
                <button onClick={confirmQty} disabled={!qtyPopup.value?.trim()}
                  style={{flex:2,padding:"12px",borderRadius:10,border:"none",
                    background:qtyPopup.value?.trim()?"#1a1a1a":"#f0f0f0",
                    color:qtyPopup.value?.trim()?"#fff":"#aaa",
                    fontSize:13,fontWeight:700,
                    cursor:qtyPopup.value?.trim()?"pointer":"default"}}>
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Header */}
        <Breadcrumb/>
        <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
          <span style={{fontSize:22}}>{catEmoji}</span>
          <h2 style={{margin:0,fontSize:20,fontWeight:800}}>{selectedCat}</h2>
        </div>
        <div style={{fontSize:13,color:"#aaa",marginBottom:20}}>
          Assigning to <strong style={{color:"#1a1a1a"}}>{selectedStaff?.name}</strong> . {fmtDate(selectedDate)}
        </div>

        {/* Task count summary */}
        {(() => {
          const total = tasksInCat(selectedCat).length;
          const assigned = assignedInCat(selectedCat, selectedStaff?.id);
          return assigned > 0 ? (
            <div style={{background:catBg, border:`1.5px solid ${catColor}44`,
              borderRadius:10, padding:"8px 14px", marginBottom:14,
              fontSize:13, fontWeight:600, color:catColor}}>
              {assigned} of {total} tasks assigned to {selectedStaff?.name}
            </div>
          ) : null;
        })()}

        {/* Subcategory sections */}
        {subcats.length > 0 ? subcats.map(subcat => {
          const meta = SUBCAT_META[subcat] || ["📋","#fafafa","#555"];
          const [emoji, bg, color] = Array.isArray(meta) ? meta : [meta[0],meta[1],meta[2]];
          const subcatTasks = tasksInSubcat(selectedCat, subcat);
          const anyAssigned = subcatTasks.some(t=>isAssigned(t.id, selectedStaff?.id));
          return (
            <div key={subcat} style={{marginBottom:20}}>
              {/* Subcat header */}
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8,
                padding:"8px 12px",background:bg,borderRadius:10,
                borderLeft:`4px solid ${color}`}}>
                <span style={{fontSize:20}}>{emoji}</span>
                <span style={{fontWeight:800,fontSize:14,color:"#1a1a1a"}}>{subcat}</span>
                {anyAssigned && (
                  <span style={{marginLeft:"auto",fontSize:11,fontWeight:700,
                    color:color,background:"#fff",borderRadius:20,padding:"2px 8px",
                    border:`1px solid ${color}66`}}>
                    {subcatTasks.filter(t=>isAssigned(t.id,selectedStaff?.id)).length} assigned
                  </span>
                )}
              </div>

              {/* Task buttons — full width, each its own button */}
              <div style={{display:"flex",flexDirection:"column",gap:4,paddingLeft:4}}>
                {subcatTasks.map(task => {
                  const assigned = isAssigned(task.id, selectedStaff?.id);
                  const taskAssignment = assignments.find(a=>a.taskId==task.id);
                  const qty = taskAssignment?.qty;
                  return (
                    <div key={task.id}
                      data-taskid={task.id}
                      onPointerEnter={()=>dragTaskId&&onDragOver(task.id)}
                      onClick={()=>{
                        if (dragTaskId) return;
                        // X tasks already assigned: toggle off (uncheck), don't open qty popup
                        // qty popup only opens via the badge click
                        toggleTask({...task, hasQuantity: assigned ? false : task.hasQuantity}, selectedStaff?.id);
                      }}
                      style={{
                        width:"100%", textAlign:"left",
                        padding:"12px 16px",
                        borderRadius:10,
                        border:`1.5px solid ${dragOverId===task.id?"#1a1a1a":assigned?color+"88":"#e8e8e8"}`,
                        background: dragOverId===task.id?"#e8e8e8":assigned?bg:"#fff",
                        cursor: assigned?"grab":"pointer",
                        display:"flex", alignItems:"center", gap:10,
                        transition:"border .1s, background .1s",
                        opacity: dragTaskId===task.id ? 0.35 : 1,
                        transform: dragOverId===task.id&&dragTaskId!==task.id?"translateY(-2px)":"none",
                        boxShadow: dragOverId===task.id?"0 4px 12px rgba(0,0,0,0.1)":"none"
                      }}>
                      {assigned&&(
                        <span
                          onPointerDown={e=>pointerDown(e, task.id, task.nameEn)}
                          style={{color:"#bbb",fontSize:18,flexShrink:0,cursor:"grab",
                            padding:"0 4px",touchAction:"none",userSelect:"none"}}
                          onClick={e=>e.stopPropagation()}>
                          ⠿
                        </span>
                      )}
                      {/* Checkbox indicator */}
                      <div style={{
                        width:22, height:22, borderRadius:6, flexShrink:0,
                        border:`2px solid ${assigned ? "#1a1a1a" : "#ccc"}`,
                        background: assigned ? "#1a1a1a" : "transparent",
                        display:"flex", alignItems:"center", justifyContent:"center"
                      }}>
                        {assigned && <span style={{color:"#fff",fontSize:13,fontWeight:800}}>✓</span>}
                      </div>

                      {/* Task name */}
                      <div style={{flex:1, minWidth:0}}>
                        <div style={{fontWeight: assigned?700:500, fontSize:14,
                          color: assigned?"#1a1a1a":"#444"}}>
                          {qty ? task.nameEn.split(' X ').join(' '+qty+' ').trim() : task.nameEn}
                        </div>
                        {task.nameZh && (
                          <div style={{fontSize:11,color:"#aaa",marginTop:1}}>
                            {qty ? task.nameZh.split('X').join(qty) : task.nameZh}
                          </div>
                        )}
                      </div>

                      {/* Qty badge + unassign button */}
                      {assigned && qty && (
                        <span
                          onClick={e=>{e.stopPropagation();setQtyPopup({task,staffId:selectedStaff?.id,value:qty||""}); }}
                          style={{background:"#1a1a1a",color:"#fff",borderRadius:6,
                            padding:"2px 10px",fontSize:12,fontWeight:700,flexShrink:0,cursor:"pointer"}}>
                          ×{qty} ✎
                        </span>
                      )}


                      {/* Qty required indicator */}
                      {task.hasQuantity && !qty && !assigned && (
                        <span style={{fontSize:11,color:"#F39C12",flexShrink:0}}>
                          # qty
                        </span>
                      )}

                      {/* Urgent toggle — only when assigned */}
                      {assigned && taskAssignment && (
                        <button
                          onClick={e=>{e.stopPropagation();toggleUrgent(task.id);}}
                          style={{borderRadius:6,border:"none",padding:"3px 7px",fontSize:10,
                            fontWeight:800,cursor:"pointer",flexShrink:0,
                            background:taskAssignment.urgent?"#E74C3C":"#f0f0f0",
                            color:taskAssignment.urgent?"#fff":"#bbb"}}>
                          {taskAssignment.urgent?"🔴":"urgent"}
                        </button>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        }) : (
          <div style={{color:"#aaa",textAlign:"center",padding:40,fontSize:13}}>
            No tasks yet for {selectedCat}. Add them in 🗂 Task Library.
          </div>
        )}
      </div>
    );
  }
  return null;
}


// ── PrepTaskLibrary ──
function PrepTaskLibrary({ prepTasks, savePrepTasks, showToast, onBack }) {
  const MAIN_CATEGORIES = ["Vegetable Prep", "Filling Prep", "Meat Prep"];
  const [selectedCat, setSelectedCat] = useState(null); // null = show category cards
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({nameEn:"",nameZh:"",nameEs:"",category:"",subcategory:"",estimatedMins:"",details:""});
  const [newCatName, setNewCatName] = useState("");
  const [showAddCat, setShowAddCat] = useState(false);

  // All categories (built-in + custom)
  const allCategories = [...new Set([...MAIN_CATEGORIES, ...(prepTasks||[]).map(t=>t.category).filter(Boolean)])];

  const openNew = () => {
    setForm({nameEn:"",nameZh:"",nameEs:"",category:selectedCat||"",subcategory:"",estimatedMins:"",details:""});
    setEditing("new");
  };
  const openEdit = (t) => { setForm({...t,details:t.details||""}); setEditing(t.id); };

  const save = () => {
    if(!form.nameEn.trim()){showToast("Task name required");return;}
    if(editing==="new"){
      savePrepTasks([...prepTasks,{...form,id:Date.now(),estimatedMins:parseInt(form.estimatedMins)||null,hasQuantity:/\bX\b/.test(form.nameEn)}]);
    } else {
      savePrepTasks((prepTasks||[]).map(t=>t.id===editing?{...t,...form,estimatedMins:parseInt(form.estimatedMins)||null,hasQuantity:/\bX\b/.test(form.nameEn)}:t));
    }
    setEditing(null);
    showToast("Task saved");
  };

  const del = (id) => {
    if(!window.confirm("Delete this task?")) return;
    savePrepTasks((prepTasks||[]).filter(t=>t.id!==id));
  };

  const addCategory = () => {
    if(!newCatName.trim()) return;
    setShowAddCat(false);
    setNewCatName("");
    setSelectedCat(newCatName.trim());
    showToast(`Category "${newCatName.trim()}" created`);
  };

  const CAT_META = {
    "Vegetable Prep": ["🥬","#F0FFF4","#276749"],
    "Filling Prep":   ["🥟","#FFF8E1","#B7791F"],
    "Meat Prep":      ["🥩","#FFF0F0","#C0392B"],
  };

  // ── Category picker screen ──
  if (!selectedCat && !editing) {
    return (
      <div>
        <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:20}}>
          <button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",
            color:"#666",fontSize:13,fontWeight:600,padding:0}}>← Back</button>
          <h2 style={{margin:0,fontSize:20,fontWeight:800}}>🗂 Task Library</h2>
          <button onClick={()=>setShowAddCat(true)} style={{marginLeft:"auto",border:"1px dashed #ccc",
            borderRadius:9,padding:"7px 14px",background:"#fff",color:"#555",
            fontSize:12,fontWeight:700,cursor:"pointer"}}>
            + New Category
          </button>
        </div>

        {showAddCat && (
          <div style={{background:"#f8f8f8",borderRadius:12,padding:14,marginBottom:16,
            border:"1px solid #e5e5e5",display:"flex",gap:8,alignItems:"center"}}>
            <input autoFocus value={newCatName} onChange={e=>setNewCatName(e.target.value)}
              placeholder="Category name (e.g. Filling Prep, Sauce Prep...)"
              onKeyDown={e=>e.key==="Enter"&&addCategory()}
              style={{flex:1,border:"1px solid #e5e5e5",borderRadius:8,padding:"8px 12px",fontSize:13}}/>
            <button onClick={()=>setShowAddCat(false)}
              style={{...btnSm,padding:"8px 14px"}}>Cancel</button>
            <button onClick={addCategory}
              style={{border:"none",borderRadius:8,padding:"8px 16px",background:"#1a1a1a",
                color:"#fff",fontSize:13,fontWeight:700,cursor:"pointer"}}>
              Create
            </button>
          </div>
        )}

        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {allCategories.map(cat => {
            const [emoji,bg,color] = CAT_META[cat] || ["📋","#f5f5f5","#555"];
            const count = (prepTasks||[]).filter(t=>t.category===cat).length;
            return (
              <button key={cat} onClick={()=>setSelectedCat(cat)}
                style={{background:bg,border:`1.5px solid ${color}33`,borderRadius:14,
                  padding:"16px 18px",cursor:"pointer",textAlign:"left",
                  display:"flex",alignItems:"center",gap:14}}>
                <span style={{fontSize:28}}>{emoji}</span>
                <div style={{flex:1}}>
                  <div style={{fontWeight:800,fontSize:15,color:"#1a1a1a"}}>{cat}</div>
                  <div style={{fontSize:12,color:"#888",marginTop:2}}>{count} tasks</div>
                </div>
                <span style={{color:"#bbb",fontSize:18}}>›</span>
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  // ── Task edit form ──
  if (editing) {
    return (
      <div>
        <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:20}}>
          <button onClick={()=>setEditing(null)} style={{background:"none",border:"none",
            cursor:"pointer",color:"#666",fontSize:13,fontWeight:600,padding:0}}>← Back</button>
          <h2 style={{margin:0,fontSize:20,fontWeight:800}}>
            {editing==="new"?"New Task":"Edit Task"}
          </h2>
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          {/* Names */}
          <div style={{background:"#fff",borderRadius:12,padding:16,border:"1px solid #eee"}}>
            <div style={{fontSize:11,fontWeight:800,color:"#aaa",letterSpacing:1,marginBottom:12}}>TASK NAMES</div>
            {[["nameEn","English","🇺🇸"],["nameZh","Chinese (中文)","🇨🇳"],["nameEs","Spanish (Español)","🇲🇽"]].map(([k,l,flag])=>(
              <div key={k} style={{marginBottom:10}}>
                <label style={{fontSize:12,fontWeight:700,color:"#555",display:"block",marginBottom:4}}>
                  {flag} {l} {k==="nameEn"&&<span style={{color:"#E74C3C"}}>*</span>}
                </label>
                <input value={form[k]||""} onChange={e=>setForm(f=>({...f,[k]:e.target.value}))}
                  placeholder={k==="nameEn"?"Task name (use X for variable quantities)":l}
                  style={{width:"100%",border:"1px solid #e5e5e5",borderRadius:8,
                    padding:"9px 12px",fontSize:13,boxSizing:"border-box"}}/>
              </div>
            ))}
          </div>

          {/* Details */}
          <div style={{background:"#fff",borderRadius:12,padding:16,border:"1px solid #eee"}}>
            <div style={{fontSize:11,fontWeight:800,color:"#aaa",letterSpacing:1,marginBottom:12}}>TASK DETAILS</div>
            <div style={{fontSize:12,color:"#888",marginBottom:8}}>
              Instructions that staff can view on the prep screen if they need a refresher.
            </div>
            <textarea value={form.details||""} onChange={e=>setForm(f=>({...f,details:e.target.value}))}
              placeholder="Step-by-step instructions, tips, safety notes, equipment needed..."
              rows={5}
              style={{width:"100%",border:"1px solid #e5e5e5",borderRadius:8,
                padding:"10px 12px",fontSize:13,resize:"vertical",boxSizing:"border-box",
                fontFamily:"'IBM Plex Sans',sans-serif"}}/>
          </div>

          {/* Category & meta */}
          <div style={{background:"#fff",borderRadius:12,padding:16,border:"1px solid #eee"}}>
            <div style={{fontSize:11,fontWeight:800,color:"#aaa",letterSpacing:1,marginBottom:12}}>CATEGORY & DETAILS</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10}}>
              {[["category","Category"],["subcategory","Subcategory (e.g. Carrots)"],["estimatedMins","Est. Minutes"]].map(([k,l])=>(
                <div key={k}>
                  <label style={{fontSize:12,fontWeight:700,color:"#555",display:"block",marginBottom:4}}>{l}</label>
                  {k==="category" ? (
                    <select value={form[k]||""} onChange={e=>setForm(f=>({...f,[k]:e.target.value}))}
                      style={{width:"100%",border:"1px solid #e5e5e5",borderRadius:8,
                        padding:"9px 10px",fontSize:13,boxSizing:"border-box"}}>
                      <option value="">Select...</option>
                      {allCategories.map(c=><option key={c} value={c}>{c}</option>)}
                    </select>
                  ) : (
                    <input value={form[k]||""} onChange={e=>setForm(f=>({...f,[k]:e.target.value}))}
                      type={k==="estimatedMins"?"number":"text"}
                      style={{width:"100%",border:"1px solid #e5e5e5",borderRadius:8,
                        padding:"9px 10px",fontSize:13,boxSizing:"border-box"}}/>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div style={{display:"flex",gap:8}}>
            <button onClick={()=>setEditing(null)}
              style={{...btnSm,padding:"11px 20px",fontSize:13}}>Cancel</button>
            <button onClick={save}
              style={{flex:1,border:"none",borderRadius:10,padding:"12px",
                background:"#1a1a1a",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer"}}>
              Save Task
            </button>
          </div>
        </div>
      </div>
    );
  }

  // ── Task list for selected category ──
  const catTasks = (prepTasks||[]).filter(t=>t.category===selectedCat);
  const [emoji,bg,color] = CAT_META[selectedCat] || ["📋","#f5f5f5","#555"];
  const subcats = [...new Set(catTasks.map(t=>t.subcategory).filter(Boolean))];
  const uncat = catTasks.filter(t=>!t.subcategory);

  return (
    <div>
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:20}}>
        <button onClick={()=>setSelectedCat(null)} style={{background:"none",border:"none",
          cursor:"pointer",color:"#666",fontSize:13,fontWeight:600,padding:0}}>← Back</button>
        <span style={{fontSize:22}}>{emoji}</span>
        <h2 style={{margin:0,fontSize:20,fontWeight:800}}>{selectedCat}</h2>
        <button onClick={openNew} style={{marginLeft:"auto",border:"none",borderRadius:9,
          padding:"8px 16px",background:"#1a1a1a",color:"#fff",fontSize:13,fontWeight:700,cursor:"pointer"}}>
          + New Task
        </button>
      </div>

      {/* Tasks grouped by subcategory */}
      {subcats.map(sub => (
        <div key={sub} style={{marginBottom:20}}>
          <div style={{fontSize:11,fontWeight:800,color:color,letterSpacing:1,
            marginBottom:8,padding:"6px 12px",background:bg,borderRadius:8,
            borderLeft:`4px solid ${color}`,display:"inline-block"}}>
            {sub.toUpperCase()}
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:4}}>
            {catTasks.filter(t=>t.subcategory===sub).map(t=>(
              <div key={t.id} style={{background:"#fff",borderRadius:10,padding:"12px 14px",
                display:"flex",alignItems:"center",gap:10,border:"1px solid #eee"}}>
                <div style={{flex:1}}>
                  <div style={{fontWeight:600,fontSize:14}}>{t.nameEn}</div>
                  <div style={{fontSize:11,color:"#aaa",marginTop:2}}>
                    {t.nameZh&&`中: ${t.nameZh}`}
                    {t.nameZh&&t.nameEs?" . ":""}
                    {t.nameEs&&`ES: ${t.nameEs}`}
                    {t.estimatedMins?` . ${t.estimatedMins} min`:""}
                    {t.details?<span style={{color:"#27AE60"}}> . Has details</span>:""}
                  </div>
                </div>
                <button onClick={()=>openEdit(t)} style={{...btnSm}}>Edit</button>
                <button onClick={()=>del(t.id)} style={{...btnSm,color:"#E74C3C"}}>✕</button>
              </div>
            ))}
          </div>
        </div>
      ))}
      {uncat.length>0&&(
        <div>
          {subcats.length>0&&<div style={{fontSize:11,fontWeight:800,color:"#aaa",letterSpacing:1,marginBottom:8}}>UNCATEGORIZED</div>}
          <div style={{display:"flex",flexDirection:"column",gap:4}}>
            {uncat.map(t=>(
              <div key={t.id} style={{background:"#fff",borderRadius:10,padding:"12px 14px",
                display:"flex",alignItems:"center",gap:10,border:"1px solid #eee"}}>
                <div style={{flex:1}}>
                  <div style={{fontWeight:600,fontSize:14}}>{t.nameEn}</div>
                  <div style={{fontSize:11,color:"#aaa",marginTop:2}}>
                    {t.estimatedMins?`${t.estimatedMins} min`:""}
                    {t.details?<span style={{color:"#27AE60"}}> . Has details</span>:""}
                  </div>
                </div>
                <button onClick={()=>openEdit(t)} style={{...btnSm}}>Edit</button>
                <button onClick={()=>del(t.id)} style={{...btnSm,color:"#E74C3C"}}>✕</button>
              </div>
            ))}
          </div>
        </div>
      )}
      {catTasks.length===0&&(
        <div style={{color:"#aaa",textAlign:"center",padding:40,fontSize:13}}>
          No tasks yet. Tap + New Task to add one.
        </div>
      )}
    </div>
  );
}


// ── PrepStaffManager ──
function PrepStaffManager({ prepStaff, savePrepStaff, showToast, onBack }) {
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({name:"",primaryLang:"en",shift:"all"});

  const openNew = () => { setForm({name:"",primaryLang:"en",shift:"all"}); setEditing("new"); };
  const openEdit = (s) => { setForm({...s}); setEditing(s.id); };

  const save = () => {
    if(!form.name.trim()){showToast("Name required");return;}
    if(editing==="new"){
      savePrepStaff([...prepStaff,{...form,id:Date.now()}]);
    } else {
      savePrepStaff(prepStaff.map(s=>s.id===editing?{...s,...form}:s));
    }
    setEditing(null);
    showToast("Staff saved");
  };

  const del = (id) => {
    if(!window.confirm("Remove this staff member?")) return;
    savePrepStaff(prepStaff.filter(s=>s.id!==id));
  };

  return (
    <div>
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16}}>
        <button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",color:"#666",fontSize:13,fontWeight:600,padding:0}}>← Back</button>
        <h2 style={{margin:0,fontSize:20,fontWeight:800}}>👥 Prep Staff</h2>
        <button onClick={openNew} style={{marginLeft:"auto",border:"none",borderRadius:9,
          padding:"8px 16px",background:"#1a1a1a",color:"#fff",fontSize:13,fontWeight:700,cursor:"pointer"}}>
          + Add Staff
        </button>
      </div>

      {editing&&(
        <div style={{background:"#f8f8f8",borderRadius:12,padding:16,marginBottom:16,border:"1px solid #e5e5e5"}}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:10}}>
            <div>
              <label style={{fontSize:11,fontWeight:700,color:"#888",display:"block",marginBottom:4}}>Name</label>
              <input value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))}
                style={{width:"100%",border:"1px solid #e5e5e5",borderRadius:8,padding:"8px 10px",fontSize:13,boxSizing:"border-box"}}/>
            </div>
            <div>
              <label style={{fontSize:11,fontWeight:700,color:"#888",display:"block",marginBottom:4}}>Primary Language</label>
              <select value={form.primaryLang} onChange={e=>setForm(f=>({...f,primaryLang:e.target.value}))}
                style={{width:"100%",border:"1px solid #e5e5e5",borderRadius:8,padding:"8px 10px",fontSize:13,boxSizing:"border-box"}}>
                <option value="en">English</option>
                <option value="zh">中文 (Chinese)</option>
                <option value="es">Español (Spanish)</option>
              </select>
            </div>
            <div>
              <label style={{fontSize:11,fontWeight:700,color:"#888",display:"block",marginBottom:4}}>Shift</label>
              <select value={form.shift} onChange={e=>setForm(f=>({...f,shift:e.target.value}))}
                style={{width:"100%",border:"1px solid #e5e5e5",borderRadius:8,padding:"8px 10px",fontSize:13,boxSizing:"border-box"}}>
                <option value="all">All Day</option>
                <option value="am">Morning (AM)</option>
                <option value="pm">Afternoon (PM)</option>
              </select>
            </div>
          </div>
          <div style={{display:"flex",gap:8}}>
            <button onClick={()=>setEditing(null)} style={{...btnSm,padding:"8px 16px"}}>Cancel</button>
            <button onClick={save} style={{border:"none",borderRadius:8,padding:"8px 20px",
              background:"#1a1a1a",color:"#fff",fontSize:13,fontWeight:700,cursor:"pointer"}}>
              Save
            </button>
          </div>
        </div>
      )}

      <div style={{display:"flex",flexDirection:"column",gap:6}}>
        {(prepStaff||[]).map(s=>(
          <div key={s.id} style={{background:"#fff",borderRadius:10,padding:"12px 14px",
            display:"flex",alignItems:"center",gap:10,border:"1px solid #eee"}}>
            <div style={{fontSize:24}}>👤</div>
            <div style={{flex:1}}>
              <div style={{fontWeight:700,fontSize:15}}>{s.name}</div>
              <div style={{fontSize:11,color:"#aaa"}}>
                {s.primaryLang==="zh"?"中文":s.primaryLang==="es"?"Español":"English"}
                {" . "}{s.shift==="am"?"Morning":s.shift==="pm"?"Afternoon":"All Day"}
              </div>
            </div>
            <button onClick={()=>openEdit(s)} style={{...btnSm}}>Edit</button>
            <button onClick={()=>del(s.id)} style={{...btnSm,color:"#E74C3C"}}>Remove</button>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── PrepAnalytics ──
function PrepAnalytics({ prepTimestamps, prepTasks, prepStaff, prepDailyAssignments, onBack }) {
  const [days, setDays] = useState(14);
  const [tab, setTab] = useState("tasks"); // "tasks" | "employees" | "headtohead" | "dailylog"
  const [selectedTask, setSelectedTask] = useState(null); // for head-to-head

  const cutoff = new Date(); cutoff.setDate(cutoff.getDate()-days);
  const recent = (prepTimestamps||[]).filter(ts => {
    if (!ts.finishedAt || !ts.startedAt) return false;
    const mins = (new Date(ts.finishedAt)-new Date(ts.startedAt))/60000;
    return mins > 0 && mins < 480 && new Date(ts.date) >= cutoff;
  });

  const getMins = ts => (new Date(ts.finishedAt)-new Date(ts.startedAt))/60000;

  // ── Task stats (slowest tasks) ──
  const taskStats = {};
  recent.forEach(ts => {
    const m = getMins(ts);
    if (!taskStats[ts.taskId]) taskStats[ts.taskId] = {total:0,count:0,entries:[]};
    taskStats[ts.taskId].total += m;
    taskStats[ts.taskId].count++;
    taskStats[ts.taskId].entries.push({staffId:ts.staffId,mins:m});
  });

  // ── Employee stats (per-employee, per-task breakdown) ──
  const empStats = {};
  recent.forEach(ts => {
    const sid = ts.staffId;
    if (!empStats[sid]) empStats[sid] = {total:0,count:0,tasks:{}};
    const m = getMins(ts);
    empStats[sid].total += m;
    empStats[sid].count++;
    if (!empStats[sid].tasks[ts.taskId]) empStats[sid].tasks[ts.taskId] = {total:0,count:0};
    empStats[sid].tasks[ts.taskId].total += m;
    empStats[sid].tasks[ts.taskId].count++;
  });

  // Tasks where multiple employees have data (for head-to-head)
  const sharedTasks = Object.entries(taskStats)
    .filter(([,s]) => new Set(s.entries.map(e=>e.staffId)).size > 1)
    .map(([id]) => id);

  const SectionHeader = ({label}) => (
    <div style={{fontSize:11,fontWeight:800,color:"#aaa",letterSpacing:1,marginBottom:10,marginTop:4}}>
      {label}
    </div>
  );

  const NoData = () => (
    <div style={{color:"#aaa",textAlign:"center",padding:32,fontSize:13}}>
      No data yet for this period
    </div>
  );

  const tabBtn = (key, label) => (
    <button key={key} onClick={()=>setTab(key)}
      style={{border:"none",borderRadius:8,padding:"7px 14px",fontSize:12,fontWeight:700,
        cursor:"pointer",whiteSpace:"nowrap",
        background:tab===key?"#1a1a1a":"#f0f0f0",color:tab===key?"#fff":"#555"}}>
      {label}
    </button>
  );

  // Daily log — snapshot of all assignments per date
  const allDates = [...new Set([
    ...Object.keys(prepDailyAssignments||{}),
    ...(prepTimestamps||[]).map(ts=>ts.date)
  ])].filter(d=>new Date(d)>=cutoff)
    .sort((a,b)=>b.localeCompare(a))
    .filter(d=>{ const day=new Date(d+'T12:00:00').getDay(); return day!==0&&day!==6; });

  return (
    <div>
      {/* Header */}
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16,flexWrap:"wrap"}}>
        <button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",
          color:"#666",fontSize:13,fontWeight:600,padding:0}}>← Back</button>
        <h2 style={{margin:0,fontSize:20,fontWeight:800}}>📊 Prep Analytics</h2>
        <div style={{marginLeft:"auto",display:"flex",gap:4}}>
          {[7,14,30].map(d=>(
            <button key={d} onClick={()=>setDays(d)}
              style={{border:"none",borderRadius:8,padding:"5px 12px",fontSize:12,fontWeight:700,
                cursor:"pointer",background:days===d?"#1a1a1a":"#f0f0f0",color:days===d?"#fff":"#555"}}>
              {d}d
            </button>
          ))}
        </div>
      </div>

      {/* Tabs */}
      <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:20}}>
        {tabBtn("tasks","⏱ Slowest Tasks")}
        {tabBtn("employees","👤 By Employee")}
        {tabBtn("headtohead","⚔️ Head-to-Head")}
        {tabBtn("dailylog","📅 Daily Log")}
        {tabBtn("production","📊 Production")}
      </div>

      {/* ── Tab: Slowest Tasks ── */}
      {tab==="tasks" && (
        <div>
          <SectionHeader label="TASKS RANKED BY AVG COMPLETION TIME (SLOWEST FIRST)"/>
          <div style={{display:"flex",flexDirection:"column",gap:6}}>
            {Object.entries(taskStats)
              .sort((a,b)=>(b[1].total/b[1].count)-(a[1].total/a[1].count))
              .map(([taskId,stat],rank)=>{
                const task=(prepTasks||[]).find(t=>t.id==taskId);
                const avg=Math.round(stat.total/stat.count);
                const est=task?.estimatedMins;
                const over=est&&avg>est*1.2;
                const under=est&&avg<est*0.8;
                const pct=est?Math.round((avg/est)*100):null;
                return (
                  <div key={taskId} style={{background:"#fff",borderRadius:12,padding:"14px 16px",
                    border:`1.5px solid ${over?"#E74C3C33":under?"#27AE6033":"#eee"}`,
                    display:"flex",alignItems:"center",gap:12}}>
                    <div style={{width:28,height:28,borderRadius:"50%",flexShrink:0,
                      background:over?"#E74C3C":under?"#27AE60":"#f0f0f0",
                      color:over||under?"#fff":"#aaa",
                      display:"flex",alignItems:"center",justifyContent:"center",
                      fontWeight:800,fontSize:12}}>
                      {rank+1}
                    </div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontWeight:700,fontSize:14,color:"#1a1a1a",
                        overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                        {task?.nameEn||"Unknown task"}
                      </div>
                      <div style={{fontSize:11,color:"#aaa",marginTop:2}}>
                        {stat.count} completion{stat.count!==1?"s":""}
                        {" . "}{new Set(stat.entries.map(e=>e.staffId)).size} staff
                      </div>
                    </div>
                    <div style={{textAlign:"right",flexShrink:0}}>
                      <div style={{fontWeight:800,fontSize:16,
                        color:over?"#E74C3C":under?"#27AE60":"#1a1a1a"}}>
                        {avg} min
                      </div>
                      {est&&(
                        <div style={{fontSize:11,color:"#aaa"}}>
                          est. {est} min
                          <span style={{marginLeft:4,color:over?"#E74C3C":under?"#27AE60":"#aaa",fontWeight:700}}>
                            ({pct>100?"+":""}{pct-100}%)
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            {Object.keys(taskStats).length===0&&<NoData/>}
          </div>
        </div>
      )}

      {/* ── Tab: By Employee ── */}
      {tab==="employees" && (
        <div>
          {(prepStaff||[]).map(s=>{
            const stats=empStats[s.id];
            if(!stats) return (
              <div key={s.id} style={{background:"#fff",borderRadius:12,padding:"14px 16px",
                marginBottom:10,border:"1px solid #eee",color:"#aaa",fontSize:13}}>
                <strong style={{color:"#1a1a1a"}}>{s.name}</strong> — no data in this period
              </div>
            );
            const avgOverall=Math.round(stats.total/stats.count);
            const taskBreakdown=Object.entries(stats.tasks)
              .map(([tid,ts])=>({task:(prepTasks||[]).find(t=>t.id==tid),avg:Math.round(ts.total/ts.count),count:ts.count}))
              .filter(x=>x.task)
              .sort((a,b)=>b.avg-a.avg);
            return (
              <div key={s.id} style={{background:"#fff",borderRadius:12,
                marginBottom:12,border:"1px solid #eee",overflow:"hidden"}}>
                {/* Employee header */}
                <div style={{padding:"12px 16px",background:"#1a1a1a",
                  display:"flex",alignItems:"center",gap:12}}>
                  <div style={{flex:1}}>
                    <div style={{fontWeight:800,fontSize:15,color:"#fff"}}>{s.name}</div>
                    <div style={{fontSize:11,color:"#aaa",marginTop:2}}>
                      {stats.count} task completions . avg {avgOverall} min per task
                    </div>
                  </div>
                </div>
                {/* Per-task breakdown */}
                <div>
                  {taskBreakdown.map(({task,avg,count})=>{
                    const est=task.estimatedMins;
                    const over=est&&avg>est*1.2;
                    const under=est&&avg<est*0.8;
                    return (
                      <div key={task.id} style={{padding:"10px 16px",
                        borderBottom:"1px solid #f5f5f5",
                        display:"flex",alignItems:"center",gap:10}}>
                        <div style={{flex:1,fontSize:13,fontWeight:500,color:"#333"}}>
                          {task.nameEn}
                          <span style={{fontSize:11,color:"#bbb",marginLeft:6}}>×{count}</span>
                        </div>
                        <div style={{fontWeight:800,fontSize:14,
                          color:over?"#E74C3C":under?"#27AE60":"#1a1a1a"}}>
                          {avg} min
                          {est&&<span style={{fontSize:11,fontWeight:400,color:"#aaa",marginLeft:4}}>
                            / est. {est}
                          </span>}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
          {Object.keys(empStats).length===0&&<NoData/>}
        </div>
      )}

      {/* ── Tab: Head-to-Head ── */}
      {tab==="headtohead" && (
        <div>
          <SectionHeader label="COMPARE EMPLOYEES ON THE SAME TASK"/>
          {sharedTasks.length===0 ? (
            <div style={{color:"#aaa",textAlign:"center",padding:32,fontSize:13}}>
              Not enough data yet — need at least 2 employees to have completed the same task
            </div>
          ) : (
            <>
              {/* Task selector */}
              <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:16}}>
                {sharedTasks.map(tid=>{
                  const task=(prepTasks||[]).find(t=>t.id==tid);
                  return (
                    <button key={tid} onClick={()=>setSelectedTask(tid)}
                      style={{border:"none",borderRadius:8,padding:"6px 12px",fontSize:12,
                        fontWeight:700,cursor:"pointer",
                        background:selectedTask===tid?"#1a1a1a":"#f0f0f0",
                        color:selectedTask===tid?"#fff":"#555"}}>
                      {task?.nameEn||"Unknown"}
                    </button>
                  );
                })}
              </div>

              {selectedTask && (() => {
                const stat=taskStats[selectedTask];
                const task=(prepTasks||[]).find(t=>t.id==selectedTask);
                const byStaff={};
                (stat?.entries||[]).forEach(e=>{
                  if(!byStaff[e.staffId]) byStaff[e.staffId]={total:0,count:0};
                  byStaff[e.staffId].total+=e.mins;
                  byStaff[e.staffId].count++;
                });
                const ranked=Object.entries(byStaff)
                  .map(([sid,s])=>({
                    staff:(prepStaff||[]).find(x=>x.id==sid),
                    avg:Math.round(s.total/s.count),
                    count:s.count
                  }))
                  .filter(x=>x.staff)
                  .sort((a,b)=>a.avg-b.avg); // fastest first
                const fastest=ranked[0]?.avg||1;
                const est=task?.estimatedMins;
                return (
                  <div>
                    <div style={{fontWeight:800,fontSize:16,marginBottom:4}}>{task?.nameEn}</div>
                    {est&&<div style={{fontSize:12,color:"#aaa",marginBottom:14}}>
                      Estimated time: {est} min
                    </div>}
                    <div style={{display:"flex",flexDirection:"column",gap:8}}>
                      {ranked.map(({staff,avg,count},i)=>{
                        const barW=Math.round((avg/Math.max(...ranked.map(r=>r.avg)))*100);
                        const isOver=est&&avg>est*1.2;
                        const isUnder=est&&avg<est*0.8;
                        const barColor=i===0?"#27AE60":isOver?"#E74C3C":"#1a1a1a";
                        return (
                          <div key={staff.id} style={{background:"#fff",borderRadius:12,
                            padding:"14px 16px",border:"1px solid #eee"}}>
                            <div style={{display:"flex",alignItems:"center",
                              justifyContent:"space-between",marginBottom:8}}>
                              <div>
                                <span style={{fontWeight:800,fontSize:14}}>{staff.name}</span>
                                {i===0&&<span style={{marginLeft:8,background:"#27AE60",color:"#fff",
                                  fontSize:10,fontWeight:800,borderRadius:4,padding:"2px 6px"}}>
                                  Fastest
                                </span>}
                                <div style={{fontSize:11,color:"#aaa",marginTop:2}}>
                                  {count} completion{count!==1?"s":""}
                                </div>
                              </div>
                              <div style={{fontWeight:800,fontSize:18,color:barColor}}>
                                {avg} min
                              </div>
                            </div>
                            <div style={{background:"#f0f0f0",borderRadius:99,height:8,overflow:"hidden"}}>
                              <div style={{height:"100%",borderRadius:99,width:`${barW}%`,
                                background:barColor,transition:"width .4s"}}/>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })()}
            </>
          )}
        </div>
      )}

      {/* ── Tab: Daily Log ── */}
      {tab==="dailylog" && (
        <div>
          <SectionHeader label="DAILY TASK ASSIGNMENT LOG"/>
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            {allDates.length===0&&<NoData/>}
            {allDates.map(date=>{
              const assignments=(prepDailyAssignments||{})[date]||[];
              const dayTs=(prepTimestamps||[]).filter(ts=>ts.date===date);
              const done=dayTs.filter(ts=>ts.finishedAt).length;
              const total=assignments.length;
              const dateLabel=new Date(date+'T12:00:00').toLocaleDateString("en-US",
                {weekday:"short",month:"short",day:"numeric"});
              return (
                <details key={date} style={{background:"#fff",borderRadius:12,
                  border:"1px solid #eee",overflow:"hidden"}}>
                  <summary style={{padding:"12px 16px",cursor:"pointer",
                    display:"flex",alignItems:"center",gap:10,listStyle:"none"}}>
                    <div style={{flex:1}}>
                      <div style={{fontWeight:700,fontSize:14}}>{dateLabel}</div>
                      <div style={{fontSize:11,color:"#aaa",marginTop:2}}>
                        {total} tasks assigned . {done} completed
                      </div>
                    </div>
                    <div style={{
                      background:total===0?"#f0f0f0":done===total?"#27AE60":"#1a1a1a",
                      color:"#fff",borderRadius:8,padding:"4px 10px",
                      fontSize:12,fontWeight:700}}>
                      {total===0?"Empty":done===total?"✓ Complete":`${done}/${total}`}
                    </div>
                  </summary>
                  {/* Expandable detail */}
                  <div style={{borderTop:"1px solid #f0f0f0"}}>
                    {assignments.length===0?(
                      <div style={{padding:"12px 16px",color:"#aaa",fontSize:13}}>No assignments recorded</div>
                    ):assignments.map(a=>{
                      const task=(prepTasks||[]).find(t=>t.id===a.taskId);
                      const assignedNames=(a.assignedTo||[]).map(id=>
                        (prepStaff||[]).find(s=>s.id===id)?.name).filter(Boolean);
                      const taskTs=dayTs.filter(ts=>ts.taskId==a.taskId);
                      return (
                        <div key={a.taskId} style={{padding:"8px 16px",
                          borderBottom:"1px solid #f9f9f9",
                          display:"flex",alignItems:"center",gap:10}}>
                          <div style={{flex:1}}>
                            <div style={{fontSize:13,fontWeight:600}}>
                              {a.urgent&&<span style={{background:"#E74C3C",color:"#fff",
                                fontSize:9,fontWeight:800,borderRadius:4,
                                padding:"1px 5px",marginRight:6}}>URGENT</span>}
                              {task?.nameEn||"Unknown"}
                              {a.qty&&<span style={{fontSize:11,color:"#888",marginLeft:4}}>× {a.qty}</span>}
                            </div>
                            <div style={{fontSize:11,color:"#aaa",marginTop:1}}>
                              {assignedNames.join(", ")||"Unassigned"}
                            </div>
                          </div>
                          <div style={{fontSize:11,fontWeight:700,flexShrink:0}}>
                            {taskTs.map(ts=>{
                              const done=!!ts.finishedAt;
                              const started=!!ts.startedAt;
                              const staff=(prepStaff||[]).find(s=>s.id===ts.staffId);
                              const mins=done?Math.round((new Date(ts.finishedAt)-new Date(ts.startedAt))/60000):null;
                              return (
                                <div key={ts.staffId} style={{
                                  color:done?"#27AE60":started?"#F39C12":"#aaa"}}>
                                  {staff?.name}: {done?`✓ ${mins}min`:started?"started":"—"}
                                  {ts.outputQty&&<span style={{marginLeft:6,fontWeight:700,color:"#8E44AD"}}>📊 {ts.outputQty}</span>}
                                </div>
                              );
                            })}
                            {taskTs.length===0&&<span style={{color:"#ccc"}}>Not started</span>}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </details>
              );
            })}
          </div>
        </div>
      )}
      {/* ── Tab: Production Records ── */}
      {tab==="production" && (
        <div>
          <SectionHeader label="PRODUCTION RECORDS BY DATE"/>
          {(() => {
            const recordTs = (prepTimestamps||[])
              .filter(ts=>ts.outputQty!=null)
              .sort((a,b)=>b.date.localeCompare(a.date));
            if (recordTs.length===0) return <NoData/>;
            const byDate = {};
            recordTs.forEach(ts=>{
              if (!byDate[ts.date]) byDate[ts.date]=[];
              byDate[ts.date].push(ts);
            });
            return Object.entries(byDate).map(([date, entries])=>{
              const label = new Date(date+'T12:00:00').toLocaleDateString("en-US",
                {weekday:"long",month:"long",day:"numeric",year:"numeric"});
              return (
                <div key={date} style={{marginBottom:20}}>
                  <div style={{fontWeight:800,fontSize:14,color:"#1a1a1a",
                    marginBottom:10,paddingBottom:6,borderBottom:"2px solid #f0f0f0"}}>
                    📅 {label}
                  </div>
                  <div style={{display:"flex",flexDirection:"column",gap:6}}>
                    {entries.map((ts,i)=>{
                      const task=(prepTasks||[]).find(t=>t.id==ts.taskId);
                      const staff=(prepStaff||[]).find(s=>s.id==ts.staffId);
                      const time=ts.finishedAt
                        ?new Date(ts.finishedAt).toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"}):"";
                      return (
                        <div key={i} style={{background:"#fff",borderRadius:10,
                          padding:"12px 16px",border:"1px solid #eee",
                          display:"flex",alignItems:"center",gap:12}}>
                          <div style={{flex:1}}>
                            <div style={{fontWeight:700,fontSize:14}}>
                              {task?.nameEn||"Unknown task"}
                            </div>
                            <div style={{fontSize:12,color:"#888",marginTop:2}}>
                              {staff?.name||"Unknown"}{time?` . ${time}`:""}
                            </div>
                          </div>
                          <div style={{background:"#8E44AD",color:"#fff",borderRadius:10,
                            padding:"6px 18px",fontWeight:800,fontSize:22,flexShrink:0}}>
                            {ts.outputQty}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            });
          })()}
        </div>
      )}
    </div>
  );
}



// ── ProductionStaffView — what production staff sees when they log in ──────────
function ProductionStaffView({ products, auth, factoryInventory, saveFactoryInventory,
  factoryLogs, saveFactoryLogs, showToast, onSignOut }) {

  const [lang, setLang] = useState("en");
  const [form, setForm] = useState({});
  const [note, setNote] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const today = new Date().toISOString().slice(0,10);
  const todayLabel = new Date().toLocaleDateString("en-US",
    {weekday:"long", month:"long", day:"numeric", year:"numeric"});

  const totalEntered = Object.values(form).reduce((s,v)=>s+(Number(v)||0),0);

  const submit = () => {
    const entries = Object.entries(form).filter(([,q])=>Number(q)>0);
    if (!entries.length) { showToast(lang==="zh"?"请输入数量":"Enter at least one quantity"); return; }

    // Add to factory inventory
    const newInv = {...factoryInventory};
    entries.forEach(([pid,qty])=>{
      newInv[pid] = (newInv[pid]||0) + Number(qty);
    });
    saveFactoryInventory(newInv);

    // Save log entry with today's date
    const logEntry = {
      id: Date.now(),
      date: today,
      submittedAt: new Date().toISOString(),
      submittedBy: auth?.name || auth?.username || "Unknown",
      staffId: auth?.userId,
      department: (auth?.departments||[])[0] || "production",
      departmentLabel: "Production Report",
      note,
      items: entries.map(([pid,qty])=>({productId:Number(pid), qty:Number(qty)})),
    };
    saveFactoryLogs([logEntry, ...(factoryLogs||[])]);
    setForm({});
    setNote("");
    setSubmitted(true);
    showToast(lang==="zh"?"✓ 报告已提交":"✓ Report submitted");
  };

  if (submitted) {
    return (
      <div style={{minHeight:"100vh",background:"#f2f0ec",display:"flex",
        alignItems:"center",justifyContent:"center",padding:20}}>
        <div style={{background:"#fff",borderRadius:20,padding:32,maxWidth:400,
          width:"100%",textAlign:"center",boxShadow:"0 4px 24px rgba(0,0,0,0.08)"}}>
          <div style={{fontSize:48,marginBottom:16}}>[OK]</div>
          <div style={{fontWeight:800,fontSize:22,marginBottom:8}}>
            {lang==="zh"?"报告已提交！":"Report Submitted!"}
          </div>
          <div style={{fontSize:13,color:"#888",marginBottom:24}}>
            {todayLabel}
          </div>
          <button onClick={()=>setSubmitted(false)}
            style={{width:"100%",padding:"13px",borderRadius:12,border:"none",
              background:"#1a1a1a",color:"#fff",fontSize:15,fontWeight:700,cursor:"pointer",
              marginBottom:10}}>
            {lang==="zh"?"再次提交":"Submit Another Report"}
          </button>
          <button onClick={onSignOut}
            style={{width:"100%",padding:"13px",borderRadius:12,border:"none",
              background:"#f0f0f0",color:"#555",fontSize:14,fontWeight:600,cursor:"pointer"}}>
            {lang==="zh"?"退出登录":"Sign Out"}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{minHeight:"100vh",background:"#f2f0ec"}}>
      {/* Header */}
      <div style={{background:"#1a1a1a",padding:"14px 20px",
        display:"flex",alignItems:"center",gap:12}}>
        <img src="/logo-nav.png" alt="Vanessa's" style={{height:28,width:"auto",filter:"brightness(0) invert(1)"}}/>
        <div style={{flex:1}}>
          <div style={{color:"#fff",fontWeight:800,fontSize:15}}>
            {lang==="zh"?"生产报告":"Production Report"}
          </div>
          <div style={{color:"#aaa",fontSize:11}}>{auth?.name}</div>
        </div>
        <button onClick={()=>setLang(l=>l==="en"?"zh":"en")}
          style={{border:"1px solid #444",borderRadius:8,padding:"4px 10px",
            fontSize:12,fontWeight:700,cursor:"pointer",background:"transparent",
            color:"#fff",marginRight:8}}>
          {lang==="en"?"中文":"EN"}
        </button>
        <button onClick={onSignOut}
          style={{border:"1px solid #444",borderRadius:8,padding:"4px 10px",
            fontSize:12,cursor:"pointer",background:"transparent",color:"#aaa"}}>
          {lang==="zh"?"退出":"Sign out"}
        </button>
      </div>

      <div style={{maxWidth:560,margin:"0 auto",padding:"20px 16px"}}>
        {/* Date */}
        <div style={{fontSize:12,color:"#888",marginBottom:16,fontWeight:600}}>
          📅 {todayLabel}
        </div>

        {/* Item list */}
        <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:16}}>
          {products.map(p=>{
            const val = form[p.id]||"";
            const currentStock = factoryInventory[p.id]||0;
            const filled = Number(val) > 0;
            return (
              <div key={p.id} style={{background:"#fff",borderRadius:14,
                padding:"14px 16px",border:`2px solid ${filled?"#1a1a1a":"#eee"}`,
                display:"flex",alignItems:"center",gap:12,
                transition:"border .15s"}}>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontWeight:700,fontSize:15,color:"#1a1a1a"}}>
                    {lang==="zh"&&p.nameZh ? p.nameZh : p.name}
                  </div>
                  {lang==="zh"&&p.nameZh&&(
                    <div style={{fontSize:11,color:"#aaa",marginTop:1}}>{p.name}</div>
                  )}
                  <div style={{fontSize:11,color:"#aaa",marginTop:2}}>
                    {lang==="zh"?"当前库存:":"In stock:"} {currentStock} {p.unit}
                  </div>
                </div>
                <div style={{display:"flex",alignItems:"center",gap:8,flexShrink:0}}>
                  <span style={{fontSize:12,color:"#aaa"}}>
                    {lang==="zh"?"+添加":"+"}
                  </span>
                  <input
                    type="number" inputMode="numeric" min="0"
                    value={val}
                    onChange={e=>setForm(f=>({...f,[p.id]:e.target.value}))}
                    placeholder="0"
                    style={{width:70,border:`2px solid ${filled?"#1a1a1a":"#e5e5e5"}`,
                      borderRadius:10,padding:"10px",fontSize:18,fontWeight:800,
                      textAlign:"center",outline:"none",
                      background:filled?"#f8f8f8":"#fff",
                      fontFamily:"'IBM Plex Sans',sans-serif"}}
                  />
                  <span style={{fontSize:11,color:"#aaa",minWidth:24}}>{p.unit}</span>
                </div>
              </div>
            );
          })}
        </div>

        {/* Note */}
        <textarea
          value={note}
          onChange={e=>setNote(e.target.value)}
          placeholder={lang==="zh"?"备注（可选）...":"Note (optional)..."}
          rows={2}
          style={{width:"100%",border:"1px solid #e5e5e5",borderRadius:10,
            padding:"10px 12px",fontSize:13,resize:"none",boxSizing:"border-box",
            fontFamily:"'IBM Plex Sans',sans-serif",marginBottom:14}}
        />

        {/* Submit */}
        <button onClick={submit} disabled={totalEntered===0}
          style={{width:"100%",padding:"16px",borderRadius:14,border:"none",
            background:totalEntered>0?"#1a1a1a":"#e5e5e5",
            color:totalEntered>0?"#fff":"#aaa",
            fontSize:16,fontWeight:800,cursor:totalEntered>0?"pointer":"not-allowed",
            fontFamily:"'IBM Plex Sans',sans-serif"}}>
          {totalEntered>0
            ? (lang==="zh"?`提交报告（+${totalEntered} 件）`:`Submit Report (+${totalEntered} units)`)
            : (lang==="zh"?"请输入数量":"Enter quantities above")}
        </button>
      </div>
    </div>
  );
}

// ── FACTORY INVENTORY ─────────────────────────────────────────────────────────

const DEPARTMENTS = [
  { id:"dumplings",  label:"Dumpling Production",   icon:"🥟", categories:["Frozen Dumplings","Buns","Doughs"] },
  { id:"vegetables", label:"Vegetable Production",  icon:"🥬", categories:["Vegetables","Sides"] },
  { id:"sauces",     label:"Sauce Production",      icon:"🫙", categories:["Sauces"] },
  { id:"meats",      label:"Meat Production",       icon:"🥩", categories:["Meats","Soup"] },
  { id:"other",      label:"Other Goods",           icon:"📦", categories:["Paper Goods"] },
];

function FactoryInventoryView({ products, factoryInventory, saveFactoryInventory,
  factoryLogs, saveFactoryLogs, productionHidden={}, saveProductionHidden, auth, orders, showToast, productionOnly=false }) {

  const [tab, setTab] = useState(productionOnly ? "report" : "dashboard");
  const [reportDept, setReportDept] = useState(null);
  const [reportForm, setReportForm] = useState({}); // { productId: qty }
  const [reportNote, setReportNote] = useState("");
  const [lang, setLang] = useState("en");
  const [showItemConfig, setShowItemConfig] = useState(false); // admin config panel // for production report bilingual

  const today = new Date().toISOString().slice(0,10);
  const fmtDate = (s) => new Date(s+'T12:00:00').toLocaleDateString("en-US",
    {weekday:"short",month:"short",day:"numeric"});

  // Low stock threshold — below par we flag red
  const isLow = (productId, qty) => {
    const product = products.find(p=>p.id===productId);
    return product?.price && qty < 5; // simple threshold for now
  };

  const submitReport = () => {
    const entries = Object.entries(reportForm).filter(([,q])=>q>0);
    if (!entries.length) { showToast("Enter at least one quantity"); return; }

    // Add to inventory
    const newInv = {...factoryInventory};
    entries.forEach(([productId, qty]) => {
      newInv[productId] = (newInv[productId]||0) + Number(qty);
    });
    saveFactoryInventory(newInv);

    // Log it
    const logEntry = {
      id: Date.now(),
      date: today,
      submittedAt: new Date().toISOString(),
      submittedBy: auth?.name || auth?.username || "Unknown",
      department: reportDept.id,
      departmentLabel: reportDept.label,
      note: reportNote,
      items: entries.map(([productId, qty])=>({productId:Number(productId), qty:Number(qty)})),
    };
    saveFactoryLogs([logEntry, ...(factoryLogs||[])]);
    setReportForm({});
    setReportNote("");
    setReportDept(null);
    setTab("dashboard");
    showToast(`✓ Production recorded — ${entries.length} item${entries.length!==1?"s":""} updated`);
  };

  const tabBtn = (key, label) => (
    <button key={key} onClick={()=>setTab(key)}
      style={{border:"none",borderRadius:20,padding:"7px 16px",fontSize:13,fontWeight:700,
        cursor:"pointer",background:tab===key?"#1a1a1a":"#f0f0f0",color:tab===key?"#fff":"#555"}}>
      {label}
    </button>
  );

  // ── DASHBOARD ──
  if (tab==="dashboard" || (tab==="report" && !reportDept)) {
    // Group products by category, show inventory qty
    const categories = [...new Set(products.map(p=>p.category))];
    const totalItems = products.filter(p=>p.price).length;
    const stockedItems = products.filter(p=>p.price&&(factoryInventory[p.id]||0)>0).length;
    const lowItems = products.filter(p=>p.price&&isLow(p.id,factoryInventory[p.id]||0)).length;

    return (
      <div>
        {/* Tabs */}
        <div style={{display:"flex",gap:6,marginBottom:20,flexWrap:"wrap"}}>
          {!productionOnly && tabBtn("dashboard","📦 Inventory")}
          {tabBtn("report","➕ Record Production")}
          {!productionOnly && tabBtn("logs","📋 Production Log")}
        </div>

        {tab==="report" && !reportDept ? (
          // Department selector
          <div>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
            <h3 style={{margin:0,fontSize:18,fontWeight:800}}>Select Department</h3>
            <button onClick={()=>setLang(l=>l==="en"?"zh":"en")}
              style={{border:"1px solid #e5e5e5",borderRadius:8,padding:"5px 12px",
                fontSize:12,fontWeight:700,cursor:"pointer",background:"#fff"}}>
              {lang==="en"?"中文":"EN"}
            </button>
          </div>
            {auth?.departments?.length > 0 && (
              <div style={{background:"#f0f0f0",borderRadius:9,padding:"8px 12px",
                fontSize:12,color:"#666",marginBottom:12}}>
                Showing your assigned departments. Contact admin to update.
              </div>
            )}
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {DEPARTMENTS.filter(dept=>
                !auth?.departments?.length || auth.departments.includes(dept.id)
              ).map(dept=>(
                <button key={dept.id} onClick={()=>{setReportDept(dept);setReportForm({});}}
                  style={{background:"#fff",border:"1.5px solid #e8e8e8",borderRadius:14,
                    padding:"16px 18px",cursor:"pointer",textAlign:"left",
                    display:"flex",alignItems:"center",gap:14,
                    boxShadow:"0 2px 8px rgba(0,0,0,0.05)"}}>
                  <span style={{fontSize:28}}>{dept.icon}</span>
                  <div style={{flex:1}}>
                    <div style={{fontWeight:800,fontSize:15}}>{dept.label}</div>
                    <div style={{fontSize:12,color:"#888",marginTop:2}}>{dept.categories.join(", ")}</div>
                  </div>
                  <span style={{color:"#bbb",fontSize:18}}>›</span>
                </button>
              ))}
            </div>
          </div>
        ) : (
          // Inventory dashboard
          <div>
            {/* Summary cards */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:20}}>
              {[
                ["📦","Total SKUs",totalItems,"#1a1a1a"],
                ["[OK]","In Stock",stockedItems,"#27AE60"],
                ["⚠️","Low / Empty",lowItems,"#E74C3C"],
              ].map(([icon,label,val,color])=>(
                <div key={label} style={{background:"#fff",borderRadius:12,padding:"14px 16px",
                  boxShadow:"0 2px 8px rgba(0,0,0,0.05)",textAlign:"center"}}>
                  <div style={{fontSize:22}}>{icon}</div>
                  <div style={{fontWeight:800,fontSize:22,color}}>{val}</div>
                  <div style={{fontSize:11,color:"#888",marginTop:2}}>{label}</div>
                </div>
              ))}
            </div>

            {/* Product list by category */}
            {categories.map(cat=>{
              const catProducts = products.filter(p=>p.category===cat&&p.price);
              if (!catProducts.length) return null;
              return (
                <div key={cat} style={{marginBottom:20}}>
                  <div style={{fontSize:11,fontWeight:800,color:"#aaa",letterSpacing:1,
                    marginBottom:8,textTransform:"uppercase"}}>{cat}</div>
                  <div style={{background:"#fff",borderRadius:12,overflow:"hidden",
                    border:"1px solid #eee"}}>
                    {catProducts.map((p,i)=>{
                      const qty = factoryInventory[p.id]||0;
                      const low = isLow(p.id, qty);
                      return (
                        <div key={p.id} style={{
                          display:"flex",alignItems:"center",gap:12,
                          padding:"11px 16px",
                          borderBottom:i<catProducts.length-1?"1px solid #f5f5f5":"none",
                          background:low&&qty===0?"#fff8f8":low?"#fffbf0":"#fff"
                        }}>
                          <div style={{flex:1}}>
                            <div style={{fontWeight:600,fontSize:14}}>{p.name}</div>
                            <div style={{fontSize:11,color:"#aaa"}}>{p.nameZh} . {p.unit}</div>
                          </div>
                          {low && qty===0 && (
                            <span style={{fontSize:10,fontWeight:800,color:"#E74C3C",
                              background:"#fef2f2",borderRadius:5,padding:"2px 7px"}}>EMPTY</span>
                          )}
                          {low && qty>0 && (
                            <span style={{fontSize:10,fontWeight:800,color:"#F39C12",
                              background:"#FFF9F0",borderRadius:5,padding:"2px 7px"}}>LOW</span>
                          )}
                          <div style={{
                            fontWeight:800,fontSize:18,minWidth:40,textAlign:"right",
                            color:qty===0?"#ccc":low?"#F39C12":"#1a1a1a"
                          }}>
                            {qty}
                          </div>
                          <div style={{fontSize:11,color:"#aaa",minWidth:30}}>{p.unit}</div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }

  // ── PRODUCTION REPORT FORM ──
  if (tab==="report" && reportDept) {
    // User-level item assignment (specific items this person records)
    const userItems = auth?.productionItems || [];
    // Dept-level assignment (admin configured for dept)
    const assignedForDept = productionHidden[reportDept.id] || [];
    const deptProducts = products.filter(p=>
      reportDept.categories.includes(p.category) &&
      // If user has specific items assigned, only show those
      // Otherwise fall back to dept-level assignment (or all)
      (userItems.length > 0
        ? userItems.includes(p.id)
        : assignedForDept.length === 0 || assignedForDept.includes(p.id))
    );
    const totalEntered = Object.values(reportForm).reduce((s,v)=>s+(Number(v)||0),0);

    return (
      <div>
        <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:20,flexWrap:"wrap"}}>
          <button onClick={()=>setReportDept(null)}
            style={{background:"none",border:"none",cursor:"pointer",color:"#666",fontSize:13,fontWeight:600,padding:0}}>
            ← Back
          </button>
          {!productionOnly && saveProductionHidden && (
            <button onClick={()=>setShowItemConfig(c=>!c)}
              style={{background:"#f0f0f0",border:"none",borderRadius:8,padding:"5px 10px",
                fontSize:11,fontWeight:700,cursor:"pointer",color:"#555"}}>
              ⚙️ {showItemConfig?"Done":"Configure Items"}
            </button>
          )}
          <div style={{flex:1}}>
            <div style={{fontWeight:800,fontSize:20}}>{reportDept.icon} {reportDept.label}</div>
            <div style={{fontSize:12,color:"#888"}}>{fmtDate(today)} — {lang==="zh"?"当日生产报告":"End of day production report"}</div>
          </div>
          <button onClick={()=>setLang(l=>l==="en"?"zh":"en")}
            style={{border:"1px solid #e5e5e5",borderRadius:8,padding:"5px 12px",
              fontSize:12,fontWeight:700,cursor:"pointer",background:"#fff",flexShrink:0}}>
            {lang==="en"?"中文":"EN"}
          </button>
        </div>

        {showItemConfig && (
          <div style={{background:"#FFF9F0",border:"1px solid #F39C12",borderRadius:12,
            padding:14,marginBottom:14}}>
            <div style={{fontWeight:700,fontSize:13,color:"#92400E",marginBottom:4}}>
              ⚙️ Assign items to this department
            </div>
            <div style={{fontSize:11,color:"#92400E",marginBottom:10}}>
              Check items this department should record. Leave all unchecked to show everything.
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:4}}>
              {products.filter(p=>reportDept.categories.includes(p.category)).map(p=>{
                const assigned = (productionHidden[reportDept.id]||[]).includes(p.id);
                return (
                  <label key={p.id}
                    onClick={()=>{
                      const curr = productionHidden[reportDept.id]||[];
                      const next = assigned ? curr.filter(id=>id!==p.id) : [...curr, p.id];
                      saveProductionHidden({...productionHidden, [reportDept.id]: next});
                    }}
                    style={{display:"flex",alignItems:"center",gap:10,padding:"8px 10px",
                      borderRadius:8,background:assigned?"#f0faf4":"#fff",cursor:"pointer",
                      border:`1px solid ${assigned?"#27AE60":"#eee"}`}}>
                    <div style={{width:18,height:18,borderRadius:4,
                      border:`2px solid ${assigned?"#27AE60":"#ccc"}`,
                      background:assigned?"#27AE60":"transparent",
                      display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                      {assigned&&<span style={{color:"#fff",fontSize:11,fontWeight:900}}>✓</span>}
                    </div>
                    <span style={{fontSize:13,fontWeight:500,flex:1,color:"#1a1a1a"}}>
                      {p.name}
                    </span>
                    {p.internal&&<span style={{fontSize:10,color:"#8E44AD",fontWeight:700,
                      background:"#f5f0ff",borderRadius:4,padding:"1px 6px"}}>Internal</span>}
                    {!p.price&&!p.internal&&<span style={{fontSize:10,color:"#aaa",fontWeight:700}}>No price</span>}
                  </label>
                );
              })}
            </div>
          </div>
        )}

        <div style={{display:"flex",flexDirection:"column",gap:6,marginBottom:16}}>
          {deptProducts.map(p=>{
            const currentStock = factoryInventory[p.id]||0;
            const val = reportForm[p.id]||"";
            return (
              <div key={p.id} style={{background:"#fff",borderRadius:12,padding:"12px 16px",
                border:"1px solid #eee",display:"flex",alignItems:"center",gap:12}}>
                <div style={{flex:1}}>
                  <div style={{fontWeight:600,fontSize:14}}>
                    {lang==="zh"&&p.nameZh ? p.nameZh : p.name}
                  </div>
                  {lang==="zh"&&p.nameZh&&<div style={{fontSize:11,color:"#aaa"}}>{p.name}</div>}
                  <div style={{fontSize:11,color:"#aaa"}}>
                    {lang==="zh"?"当前库存:":"Current stock:"} <strong style={{color:currentStock===0?"#E74C3C":"#1a1a1a"}}>{currentStock}</strong> {p.unit}
                  </div>
                </div>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <span style={{fontSize:12,color:"#aaa"}}>+ add</span>
                  <input
                    type="number" inputMode="numeric" min="0"
                    value={val}
                    onChange={e=>setReportForm(f=>({...f,[p.id]:e.target.value}))}
                    placeholder="0"
                    style={{width:72,border:`2px solid ${val>0?"#1a1a1a":"#e5e5e5"}`,
                      borderRadius:9,padding:"8px 10px",fontSize:16,fontWeight:700,
                      textAlign:"center",outline:"none",
                      background:val>0?"#f8f8f8":"#fff"}}
                  />
                  <span style={{fontSize:11,color:"#aaa",minWidth:30}}>{p.unit}</span>
                </div>
              </div>
            );
          })}
        </div>

        {/* Note */}
        <div style={{marginBottom:14}}>
          <label style={{fontSize:11,fontWeight:700,color:"#888",display:"block",marginBottom:6}}>
            NOTE (optional)
          </label>
          <textarea value={reportNote} onChange={e=>setReportNote(e.target.value)}
            placeholder="Any notes about today's production..."
            rows={2}
            style={{width:"100%",border:"1px solid #e5e5e5",borderRadius:10,
              padding:"10px 12px",fontSize:13,resize:"none",boxSizing:"border-box",
              fontFamily:"'IBM Plex Sans',sans-serif"}}/>
        </div>

        <button onClick={submitReport}
          disabled={totalEntered===0}
          style={{width:"100%",padding:"14px",borderRadius:12,border:"none",
            background:totalEntered>0?"#1a1a1a":"#f0f0f0",
            color:totalEntered>0?"#fff":"#aaa",
            fontSize:15,fontWeight:700,cursor:totalEntered>0?"pointer":"not-allowed"}}>
          {lang==="zh"
              ? (totalEntered>0?`提交报告（+${totalEntered} 件）`:"请输入数量")
              : (totalEntered>0?`Submit Report (+${totalEntered} total units)`:"Enter quantities above")}
        </button>
      </div>
    );
  }

  // ── PRODUCTION LOG ──
  if (tab==="logs") {
    const cutoff = new Date(); cutoff.setDate(cutoff.getDate()-30);
    const recentLogs = (factoryLogs||[]).filter(l=>new Date(l.date)>=cutoff);

    return (
      <div>
        <div style={{display:"flex",gap:6,marginBottom:20,flexWrap:"wrap"}}>
          {!productionOnly && tabBtn("dashboard","📦 Inventory")}
          {tabBtn("report","➕ Record Production")}
          {!productionOnly && tabBtn("logs","📋 Production Log")}
        </div>
        <h3 style={{margin:"0 0 16px",fontSize:18,fontWeight:800}}>Production Log (30 days)</h3>
        {recentLogs.length===0 ? (
          <div style={{color:"#aaa",textAlign:"center",padding:40,fontSize:13}}>
            No production records yet
          </div>
        ) : (
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {recentLogs.map(log=>(
              <details key={log.id} style={{background:"#fff",borderRadius:12,
                border:"1px solid #eee",overflow:"hidden"}}>
                <summary style={{padding:"14px 16px",cursor:"pointer",listStyle:"none",
                  display:"flex",alignItems:"center",gap:12}}>
                  <div style={{flex:1}}>
                    <div style={{fontWeight:700,fontSize:14}}>{log.departmentLabel}</div>
                    <div style={{fontSize:12,color:"#888",marginTop:2}}>
                      {fmtDate(log.date)} . by {log.submittedBy}
                      {log.note&&<span style={{color:"#aaa"}}> . {log.note}</span>}
                    </div>
                  </div>
                  <div style={{background:"#f0f0f0",borderRadius:8,padding:"3px 10px",
                    fontSize:12,fontWeight:700,color:"#555",flexShrink:0}}>
                    {log.items.length} item{log.items.length!==1?"s":""}
                  </div>
                </summary>
                <div style={{borderTop:"1px solid #f0f0f0",padding:"8px 16px 12px"}}>
                  {log.items.map((item,i)=>{
                    const p = products.find(x=>x.id===item.productId);
                    return (
                      <div key={i} style={{display:"flex",justifyContent:"space-between",
                        padding:"6px 0",borderBottom:i<log.items.length-1?"1px solid #f9f9f9":"none"}}>
                        <span style={{fontSize:13,color:"#555"}}>{p?.name||"Unknown"}</span>
                        <span style={{fontWeight:700,fontSize:13}}>+{item.qty} {p?.unit}</span>
                      </div>
                    );
                  })}
                </div>
              </details>
            ))}
          </div>
        )}
      </div>
    );
  }

  return null;
}



// ── DELIVERY HUB ─────────────────────────────────────────────────────────────

function DeliveryHubView({ auth, orders, saveOrders, restaurants, products, pName, fmtPrice, showToast, isAdmin, onOpenChat, factoryStock=[] }) {
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [sigMode, setSigMode] = useState(false);
  const [sigData, setSigData] = useState(null);
  const canvasRef = useRef(null);
  const [drawing, setDrawing] = useState(false);
  const today = new Date().toISOString().slice(0,10);

  const printOrderPackingSlip = (order) => {
    const rest = restaurants.find(r=>r.id===order.restaurantId);
    const date = new Date(order.timestamp).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"});
    const delivDate = order.deliveryDate ? new Date(order.deliveryDate).toLocaleDateString("en-US",{weekday:"long",month:"long",day:"numeric"}) : null;
    const w = window.open("","_blank","width=1100,height=800");
    const CAT_ORDER = ["Frozen Dumplings","Paper Goods","Sauces","Doughs","Buns","Meats","Sides","Vegetables","Soup","Other"];
    const grouped = {};
    (order.items||[]).forEach(it => {
      const prod = products.find(x=>String(x.id)===String(it.productId));
      const cat = prod?.category || "Other";
      if (!grouped[cat]) grouped[cat] = [];
      grouped[cat].push({...it, name: prod?.name||it.name||"?", zhName: prod?.nameZh||"", prod});
    });
    const cats = [...CAT_ORDER.filter(c=>grouped[c]), ...Object.keys(grouped).filter(c=>!CAT_ORDER.includes(c)&&grouped[c])];
    const HDR = "border-bottom:2px solid #1a1a1a;padding:2px 5px;font-size:9px;font-weight:900;letter-spacing:.8px;text-transform:uppercase;";
    const BLOCK = "margin-bottom:5px;border:1px solid #ccc;border-radius:2px;overflow:hidden;break-inside:avoid;";
    const catBlocks = cats.map(cat => {
      const rowsHtml = grouped[cat].map((it,i) => {
        const bg = i%2===0?"background:#fff;":"background:#f7f7f7;-webkit-print-color-adjust:exact;print-color-adjust:exact;";
        let lotStr = "";
        const assigns = it.lotAssignment || [];
        if (assigns.length > 0) {
          lotStr = assigns.map(l => {
            const d = l.date ? new Date(l.date+"T12:00:00").toLocaleDateString("en-US",{month:"short",day:"numeric"}) : "?";
            return `${l.qty} \u00d7 ${d}`;
          }).join("  \u00b7  ");
        } else if (it.productId && it.prod?.category === "Frozen Dumplings") {
          // Reconstruct FIFO preview from current stock for display
          const lots = factoryStock
            .filter(e => e.productId === it.productId && (e.qtyRemaining||0) > 0)
            .sort((a,b) => !a.date?1:!b.date?-1:a.date<b.date?-1:a.date>b.date?1:0);
          let rem = it.qty; const preview = [];
          for (const lot of lots) {
            if (rem <= 0) break;
            const take = Math.min(lot.qtyRemaining, rem);
            const d = lot.date ? new Date(lot.date+"T12:00:00").toLocaleDateString("en-US",{month:"short",day:"numeric"}) : "?";
            preview.push(`${take} \u00d7 ${d}`);
            rem -= take;
          }
          lotStr = preview.join("  \u00b7  ");
        }
        return `<div style="display:flex;align-items:center;gap:5px;padding:2px 5px;border-bottom:1px solid #eee;${bg}">
          <input type="checkbox" style="width:12px;height:12px;flex-shrink:0"/>
          <div style="flex:1">
            <div style="font-weight:700;font-size:10px">${it.name}${it.added?" +":""}</div>
            ${it.zhName?`<div style="font-size:9px;color:#888;margin-top:0px">${it.zhName}</div>`:""}
            ${lotStr?`<div style="font-size:8px;color:#2471A3;margin-top:1px">${lotStr}</div>`:""}
          </div>
          <input type="text" style="width:38px;border:1px solid #ccc;border-radius:3px;padding:1px;font-size:9px;flex-shrink:0"/>
          <div style="font-size:15px;font-weight:900;min-width:22px;text-align:right">${it.qty}</div></div>`;
      }).join("");
      return `<div style="${BLOCK}"><div style="${HDR}">${cat}</div>${rowsHtml}</div>`;
    });
    const noteBlock = order.note ? `<div style="${BLOCK}"><div style="${HDR}">Notes</div><div style="padding:4px 6px;font-size:10px;color:#856404;background:#FFFBF0;border-left:3px solid #F39C12">${order.note}</div></div>` : "";
    if (noteBlock) catBlocks.push(noteBlock);
    w.document.write(`<!DOCTYPE html><html><head><title>Packing Slip - ${rest?.name||""}</title>
      <style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:Arial,sans-serif;color:#1a1a1a;font-size:11px}@page{size:landscape;margin:6mm}@media print{.no-print{display:none!important}body{font-size:10px}}</style>
      </head><body>
      <div style="display:flex;align-items:center;justify-content:space-between;padding:5px 10px;border-bottom:2px solid #1a1a1a;margin-bottom:5px">
        <img src="${LOGO_NAV}" style="height:20px;width:auto;max-width:140px" alt="logo"/>
        <div style="text-align:center">
          <div style="font-size:20px;font-weight:900">${rest?.name||"Unknown"}</div>
          <div style="font-size:9px;font-weight:600;letter-spacing:2px;color:#555;text-transform:uppercase">Packing Slip · Order #${order.invoiceNumber||order.id}</div>
        </div>
        <div style="text-align:right;font-size:9px;color:#555">
          <div>Placed: ${date}</div>
          ${delivDate?`<div style="color:#27AE60;font-weight:700">📅 ${delivDate}</div>`:""}
        </div>
      </div>
      <div style="padding:0 10px 4px">
        <div style="column-count:3;column-gap:10px;column-fill:balance">${catBlocks.join("")}</div>
        <div style="margin-top:3px;font-size:8px;color:#aaa">${(order.items||[]).length} item types · ${(order.items||[]).reduce((s,it)=>s+it.qty,0)} units total</div>
      </div>
      <div style="margin:4px 10px 0;padding-top:5px;border-top:1px dashed #ccc;display:flex;gap:30px">
        <div style="flex:1"><div style="font-size:8px;color:#aaa;margin-bottom:12px">Packed by</div><div style="border-bottom:1px solid #999"></div></div>
        <div style="flex:1"><div style="font-size:8px;color:#aaa;margin-bottom:12px">Received by</div><div style="border-bottom:1px solid #999"></div></div>
        <div style="flex:1"><div style="font-size:8px;color:#aaa;margin-bottom:12px">Date</div><div style="border-bottom:1px solid #999"></div></div>
      </div>
      <div class="no-print" style="padding:12px;margin-top:12px;display:flex;gap:10px">
        <button onclick="window.print()" style="background:#1a1a1a;color:#fff;border:none;padding:10px 20px;border-radius:8px;font-size:14px;font-weight:700;cursor:pointer">Print</button>
        <button onclick="window.close()" style="background:#f0f0f0;border:none;padding:10px 20px;border-radius:8px;font-size:14px;cursor:pointer">Close</button>
      </div>
    </body></html>`);
    w.document.close();
  };

  // Driver sees only to_be_delivered orders; admin sees all non-pending
  const myOrders = (orders||[])
    .filter(o => {
      const s = o.status?.toLowerCase();
      if (isAdmin) return ["to_be_delivered","delivered"].includes(s);
      return s === "to_be_delivered";
    })
    .sort((a,b) => new Date(b.timestamp)-new Date(a.timestamp));

  const todayDeliveries = myOrders.filter(o => {
    const d = o.deliveryDate ? new Date(o.deliveryDate).toISOString().slice(0,10) : null;
    return d === today;
  });
  const otherDeliveries = myOrders.filter(o => {
    const d = o.deliveryDate ? new Date(o.deliveryDate).toISOString().slice(0,10) : null;
    return d !== today;
  });

  const getRestaurant = (o) => restaurants.find(r=>r.id===o.restaurantId);

  const openMaps = (address) => {
    const encoded = encodeURIComponent(address);
    // Try to open in native maps app, fall back to Google Maps
    window.open(`https://maps.google.com/?q=${encoded}`, '_blank');
  };
  const openWaze = (address) => {
    const encoded = encodeURIComponent(address);
    window.open(`https://waze.com/ul?q=${encoded}`, '_blank');
  };

  // ── Signature canvas ──
  const startDraw = (e) => {
    setDrawing(true);
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const ctx = canvas.getContext('2d');
    const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
    const y = (e.touches ? e.touches[0].clientY : e.clientY) - rect.top;
    ctx.beginPath();
    ctx.moveTo(x, y);
  };
  const draw = (e) => {
    if (!drawing) return;
    e.preventDefault();
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const ctx = canvas.getContext('2d');
    ctx.strokeStyle = '#1a1a1a';
    ctx.lineWidth = 2.5;
    ctx.lineCap = 'round';
    const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
    const y = (e.touches ? e.touches[0].clientY : e.clientY) - rect.top;
    ctx.lineTo(x, y);
    ctx.stroke();
  };
  const endDraw = () => {
    setDrawing(false);
    const canvas = canvasRef.current;
    setSigData(canvas.toDataURL());
  };
  const clearSig = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    setSigData(null);
  };

  const confirmDelivery = () => {
    if (!sigData) return;
    const updated = orders.map(o => o.id === selectedOrder.id ? {
      ...o,
      status: "delivered",
      deliveredAt: new Date().toISOString(),
      deliveredBy: auth?.name || "Driver",
      signature: sigData,
    } : o);
    saveOrders(updated);
    setSelectedOrder(null);
    setSigMode(false);
    setSigData(null);
    showToast("✓ Delivery confirmed and signed");
  };

  const DeliveryCard = ({o}) => {
    const rest = getRestaurant(o);
    const isDelivered = o.status?.toLowerCase() === "delivered";
    const delivDate = o.deliveryDate ? new Date(o.deliveryDate) : null;
    const total = (o.items||[]).reduce((s,i)=>{
      const p=products.find(x=>x.id===i.productId);
      return s+(p?p.price*i.qty:0);
    },0);

    return (
      <div onClick={()=>!isDelivered&&setSelectedOrder(o)}
        style={{background:"#fff",borderRadius:14,padding:"16px 18px",
          border:`2px solid ${isDelivered?"#27AE6033":"#e8e8e8"}`,
          cursor:isDelivered?"default":"pointer",
          boxShadow:"0 2px 10px rgba(0,0,0,0.05)",
          opacity:isDelivered?0.75:1}}>
        <div style={{display:"flex",alignItems:"flex-start",gap:12}}>
          <div style={{width:42,height:42,borderRadius:10,flexShrink:0,
            background:isDelivered?"#27AE60":"#1a1a1a",
            display:"flex",alignItems:"center",justifyContent:"center",
            fontSize:20}}>
            {isDelivered?"✓":"🚚"}
          </div>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontWeight:800,fontSize:16,color:"#1a1a1a"}}>
              {rest?.name || "Unknown"}
            </div>
            <div style={{fontSize:12,color:"#888",marginTop:2}}>
              {rest?.address || "No address on file"}
            </div>
            <div style={{fontSize:12,color:"#aaa",marginTop:4}}>
              {o.items.length} items . ${total.toFixed(2)}
              {delivDate&&<span style={{marginLeft:8,color:"#27AE60",fontWeight:600}}>
                📅 {delivDate.toLocaleDateString("en-US",{month:"short",day:"numeric"})}
              </span>}
            </div>
          </div>
          {!isDelivered && rest?.address && (
            <div style={{display:"flex",gap:6,flexShrink:0}}>
              <button onClick={e=>{e.stopPropagation();printOrderPackingSlip(o);}}
                style={{border:"1px solid #e5e5e5",borderRadius:8,padding:"6px 10px",
                  background:"#fff",color:"#555",fontSize:11,fontWeight:700,cursor:"pointer"}}>
                🖨
              </button>
              <button onClick={e=>{e.stopPropagation();openMaps(rest.address);}}
                style={{border:"none",borderRadius:8,padding:"6px 10px",
                  background:"#4285F4",color:"#fff",fontSize:11,fontWeight:700,cursor:"pointer"}}>
                Maps
              </button>
              <button onClick={e=>{e.stopPropagation();openWaze(rest.address);}}
                style={{border:"none",borderRadius:8,padding:"6px 10px",
                  background:"#33CCFF",color:"#1a1a1a",fontSize:11,fontWeight:700,cursor:"pointer"}}>
                Waze
              </button>
            </div>
          )}
          {isDelivered && (
            <div style={{fontSize:11,color:"#27AE60",fontWeight:700,textAlign:"right",flexShrink:0}}>
              ✓ Signed<br/>
              <span style={{fontSize:10,color:"#aaa",fontWeight:400}}>
                {new Date(o.deliveredAt).toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"})}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  // ── Order detail + signature modal ──
  if (selectedOrder) {
    const rest = getRestaurant(selectedOrder);
    const total = (selectedOrder.items||[]).reduce((s,i)=>{
      const p=products.find(x=>x.id===i.productId);
      return s+(p?p.price*i.qty:0);
    },0);

    return (
      <div style={{minHeight:"100vh",background:"#f2f0ec"}}>
        {/* Signature mode */}
        {sigMode && (
          <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.8)",zIndex:500,
            display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:20}}>
            <div style={{background:"#fff",borderRadius:20,padding:24,width:"100%",maxWidth:480}}>
              <div style={{fontWeight:800,fontSize:18,marginBottom:4}}>Restaurant Signature</div>
              <div style={{fontSize:13,color:"#888",marginBottom:16}}>
                Please sign below to confirm receipt of delivery from Vanessa's Dumpling House
              </div>
              <canvas ref={canvasRef} width={430} height={160}
                style={{border:"2px solid #1a1a1a",borderRadius:12,width:"100%",
                  height:160,touchAction:"none",cursor:"crosshair",background:"#fafafa"}}
                onMouseDown={startDraw} onMouseMove={draw} onMouseUp={endDraw}
                onTouchStart={startDraw} onTouchMove={draw} onTouchEnd={endDraw}/>
              <div style={{display:"flex",gap:8,marginTop:12}}>
                <button onClick={clearSig}
                  style={{flex:1,padding:"10px",borderRadius:10,border:"1px solid #e5e5e5",
                    background:"#fff",fontSize:13,fontWeight:600,cursor:"pointer"}}>
                  Clear
                </button>
                <button onClick={()=>{setSigMode(false);setSigData(null);}}
                  style={{flex:1,padding:"10px",borderRadius:10,border:"1px solid #e5e5e5",
                    background:"#fff",fontSize:13,fontWeight:600,cursor:"pointer"}}>
                  Cancel
                </button>
                <button onClick={confirmDelivery} disabled={!sigData}
                  style={{flex:2,padding:"10px",borderRadius:10,border:"none",
                    background:sigData?"#27AE60":"#f0f0f0",
                    color:sigData?"#fff":"#aaa",fontSize:13,fontWeight:700,
                    cursor:sigData?"pointer":"not-allowed"}}>
                  ✓ Confirm Delivery
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Header */}
        <div style={{background:"#1a1a1a",padding:"14px 20px",
          display:"flex",alignItems:"center",gap:12}}>
          <button onClick={()=>setSelectedOrder(null)}
            style={{color:"#fff",background:"none",border:"none",fontSize:20,cursor:"pointer"}}>←</button>
          <div style={{flex:1}}>
            <div style={{color:"#fff",fontWeight:800,fontSize:16}}>{rest?.name}</div>
            <div style={{color:"#aaa",fontSize:12}}>Order #{selectedOrder.id}</div>
          </div>
          {rest?.address && (
            <div style={{display:"flex",gap:6}}>
              <button onClick={()=>printOrderPackingSlip(selectedOrder)}
                style={{border:"none",borderRadius:8,padding:"7px 12px",
                  background:"#555",color:"#fff",fontSize:12,fontWeight:700,cursor:"pointer"}}>
                🖨 Print
              </button>
              <button onClick={()=>openMaps(rest.address)}
                style={{border:"none",borderRadius:8,padding:"7px 12px",
                  background:"#4285F4",color:"#fff",fontSize:12,fontWeight:700,cursor:"pointer"}}>
                📍 Maps
              </button>
              <button onClick={()=>openWaze(rest.address)}
                style={{border:"none",borderRadius:8,padding:"7px 12px",
                  background:"#33CCFF",color:"#1a1a1a",fontSize:12,fontWeight:700,cursor:"pointer"}}>
                Waze
              </button>
            </div>
          )}
        </div>

        <div style={{padding:"16px 20px",maxWidth:560,margin:"0 auto"}}>
          {/* Delivery info */}
          <div style={{background:"#fff",borderRadius:12,padding:"14px 16px",marginBottom:14,
            border:"1px solid #eee"}}>
            <div style={{fontSize:12,color:"#aaa",marginBottom:4}}>DELIVERY ADDRESS</div>
            <div style={{fontWeight:700,fontSize:15}}>{rest?.address || "No address on file"}</div>
            {selectedOrder.deliveryDate && (
              <div style={{fontSize:12,color:"#27AE60",fontWeight:600,marginTop:6}}>
                📅 {new Date(selectedOrder.deliveryDate).toLocaleDateString("en-US",
                  {weekday:"long",month:"long",day:"numeric"})}
              </div>
            )}
          </div>

          {/* Items */}
          <div style={{fontSize:11,fontWeight:800,color:"#aaa",letterSpacing:1,marginBottom:8}}>
            ITEMS ({selectedOrder.items.length})
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:6,marginBottom:14}}>
            {selectedOrder.items.map((item,i)=>{
              const p=products.find(x=>x.id===item.productId);
              return (
                <div key={i} style={{background:"#fff",borderRadius:10,padding:"10px 14px",
                  display:"flex",alignItems:"center",gap:10,border:"1px solid #eee"}}>
                  <div style={{flex:1,fontWeight:600,fontSize:14}}>{p?pName(p):item.name||"?"}</div>
                  <div style={{fontWeight:800,fontSize:14}}>×{item.qty}</div>
                  {p?.price&&<div style={{fontSize:13,color:"#888",minWidth:60,textAlign:"right"}}>
                    ${(p.price*item.qty).toFixed(2)}
                  </div>}
                </div>
              );
            })}
          </div>

          {/* Total */}
          <div style={{background:"#1a1a1a",borderRadius:10,padding:"12px 16px",
            display:"flex",justifyContent:"space-between",marginBottom:16}}>
            <span style={{color:"#aaa",fontSize:13}}>Total</span>
            <span style={{color:"#fff",fontWeight:800,fontSize:16}}>${total.toFixed(2)}</span>
          </div>

          {selectedOrder.note && <NoteWithTranslate note={selectedOrder.note} />}

          {/* Confirm delivery button */}
          <button onClick={()=>setSigMode(true)}
            style={{width:"100%",padding:"16px",borderRadius:14,border:"none",
              background:"#27AE60",color:"#fff",fontSize:16,fontWeight:800,
              cursor:"pointer",fontFamily:"'IBM Plex Sans',sans-serif"}}>
            ✍️ Get Signature & Confirm Delivery
          </button>
        </div>
      </div>
    );
  }

  // ── Main list ──
  return (
    <div style={{minHeight:"100vh",background:"#f2f0ec"}}>
      <div style={{background:"#1a1a1a",padding:"14px 20px",
        display:"flex",alignItems:"center",gap:12}}>
        <div style={{flex:1}}>
          <div style={{color:"#fff",fontWeight:800,fontSize:16}}>🚚 Delivery Hub</div>
          <div style={{color:"#aaa",fontSize:11}}>{auth?.name} . {new Date().toLocaleDateString("en-US",{weekday:"long",month:"short",day:"numeric"})}</div>
        </div>
        {onOpenChat && (
          <button onClick={onOpenChat}
            style={{background:"#333",border:"none",borderRadius:8,padding:"7px 12px",
              color:"#fff",fontSize:13,fontWeight:700,cursor:"pointer"}}>
            💬 Chat
          </button>
        )}
      </div>

      <div style={{maxWidth:560,margin:"0 auto",padding:"16px"}}>
        {myOrders.length===0 ? (
          <div style={{textAlign:"center",color:"#aaa",padding:60,fontSize:14}}>
            No deliveries assigned
          </div>
        ) : (
          <>
            {todayDeliveries.length>0 && (
              <div style={{marginBottom:20}}>
                <div style={{fontSize:11,fontWeight:800,color:"#aaa",letterSpacing:1,marginBottom:10}}>
                  TODAY — {new Date().toLocaleDateString("en-US",{month:"long",day:"numeric"})}
                </div>
                <div style={{display:"flex",flexDirection:"column",gap:8}}>
                  {todayDeliveries.map(o=><DeliveryCard key={o.id} o={o}/>)}
                </div>
              </div>
            )}
            {otherDeliveries.length>0 && (
              <div>
                <div style={{fontSize:11,fontWeight:800,color:"#aaa",letterSpacing:1,marginBottom:10}}>
                  UPCOMING / OTHER
                </div>
                <div style={{display:"flex",flexDirection:"column",gap:8}}>
                  {otherDeliveries.map(o=><DeliveryCard key={o.id} o={o}/>)}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}



// ── History Tab ───────────────────────────────────────────────────────────────
function HistoryTab({orders,rest,onView,onSend,products,t,pName,saveOrders,allOrders,showToast,onReorder,hidePrice=false}) {
  const [reqCancelOrder, setReqCancelOrder] = useState(null);
  const [reqCancelReason, setReqCancelReason] = useState("");
  const [filterCancelled, setFilterCancelled] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null); // order detail modal
  const [combineMode, setCombineMode] = useState(false);
  const [selectedForCombine, setSelectedForCombine] = useState([]);
  const [showCombinePreview, setShowCombinePreview] = useState(false);

  const submitCancelRequest = () => {
    if (!reqCancelReason.trim()) return;
    const updated = (allOrders||[]).map(o => o.id===reqCancelOrder.id
      ? {...o, status:"cancel_requested", cancelRequestReason:reqCancelReason.trim(), cancelRequestedAt:new Date().toISOString()}
      : o);
    saveOrders(updated);
    setReqCancelOrder(null);
    setReqCancelReason("");
    showToast("Cancellation request sent");
  };

  const visibleOrders = filterCancelled
    ? orders
    : orders.filter(o => o.status?.toLowerCase() !== "cancelled");

  // Combine eligible: sent or pending orders (not confirmed/cancelled)
  const combineEligible = (o) => ["pending","sent"].includes(o.status?.toLowerCase());

  const toggleCombineSelect = (id) => {
    setSelectedForCombine(prev =>
      prev.includes(id) ? prev.filter(x=>x!==id) : [...prev, id]
    );
  };

  const doCombine = () => {
    const toMerge = orders.filter(o => selectedForCombine.includes(o.id));
    if (toMerge.length < 2) return;
    // Merge items — combine quantities for same product
    const itemMap = {};
    toMerge.forEach(o => {
      o.items.forEach(item => {
        const key = item.productId || item.name;
        if (itemMap[key]) {
          itemMap[key].qty += item.qty;
        } else {
          itemMap[key] = {...item};
        }
      });
    });
    const mergedItems = Object.values(itemMap);
    const notes = toMerge.map(o=>o.note).filter(Boolean).join(" | ");
    const combinedOrder = {
      ...toMerge[0],
      id: Date.now() % 900000 + 100000,
      items: mergedItems,
      note: notes,
      timestamp: new Date().toISOString(),
      status: "pending",
      combinedFrom: toMerge.map(o=>o.id),
    };
    // Replace merged orders with combined one
    const remaining = (allOrders||[]).filter(o => !selectedForCombine.includes(o.id));
    saveOrders([combinedOrder, ...remaining]);
    setCombineMode(false);
    setSelectedForCombine([]);
    setShowCombinePreview(false);
    showToast(`✓ ${toMerge.length} orders combined into #${combinedOrder.id}`);
  };

  const combinePreviewItems = () => {
    const toMerge = orders.filter(o => selectedForCombine.includes(o.id));
    const itemMap = {};
    toMerge.forEach(o => {
      o.items.forEach(item => {
        const key = item.productId || item.name;
        if (itemMap[key]) itemMap[key].qty += item.qty;
        else itemMap[key] = {...item};
      });
    });
    return Object.values(itemMap);
  };

  if(!orders.length)
    return <Card><p style={{color:"#ccc",textAlign:"center",padding:36,fontSize:13}}>{t.noOrders}</p></Card>;

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:8}}>
        <h2 style={{fontSize:24,margin:0}}>{t.orderHistory}</h2>
        <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
          <label style={{display:"flex",alignItems:"center",gap:7,fontSize:13,color:"#888",cursor:"pointer"}}>
            <input type="checkbox" checked={filterCancelled} onChange={e=>setFilterCancelled(e.target.checked)}
              style={{width:15,height:15,cursor:"pointer"}}/>
            Show cancelled orders
          </label>

        </div>
      </div>
      <div style={{display:"flex",flexDirection:"column",gap:9}}>
        {visibleOrders.map(o=>{
          const isCancelled = o.status?.toLowerCase()==="cancelled";
          const isCancelReq = o.status?.toLowerCase()==="cancel_requested";
          const total=o.items.reduce((s,i)=>{const p=products.find(x=>x.id===i.productId);return s+(p?p.price*i.qty:0);},0);
          return (
            <Card key={o.id}
              onClick={()=>setSelectedOrder(o)}
              style={{display:"flex",gap:12,alignItems:"center",cursor:"pointer",
                borderLeft:`4px solid ${isCancelled?"#95a5a6":isCancelReq?"#8E44AD":rest.color}`,
                flexWrap:"wrap", opacity:isCancelled?0.65:1,
                transition:"box-shadow .15s"}}
              onMouseEnter={e=>e.currentTarget.style.boxShadow="0 4px 16px rgba(0,0,0,0.1)"}
              onMouseLeave={e=>e.currentTarget.style.boxShadow=""}>

              <div style={{minWidth:88}}>
                <div style={{fontSize:10,color:"#aaa",fontWeight:700}}>#{o.invoiceNumber||o.id}</div>
                <div style={{fontSize:10,color:"#aaa"}}>{o.timestamp ? new Date(o.timestamp).toLocaleDateString() : ""}</div>
                <div style={{marginTop:4}}><Badge status={o.status}/></div>
                {o.hasCatering && <div style={{marginTop:3,fontSize:9,color:"#8E44AD",fontWeight:700}}>🍽 CATERING</div>}
              </div>
              <div style={{flex:1,minWidth:160}}>
                <div style={{fontSize:10,color:"#aaa",marginBottom:4}}>Deliver: <strong>{o.deliveryDate ? fmt(new Date(o.deliveryDate)) : "TBD"}</strong></div>
                <div style={{display:"flex",flexWrap:"wrap",gap:4}}>
                  {o.items.slice(0,4).map(item=>{
                    const p=products.find(x=>x.id===item.productId);
                    return <span key={item.productId} style={{background:"#f5f5f5",borderRadius:5,padding:"2px 7px",fontSize:11}}>{p?pName(p):"?"} ×{item.qty}</span>;
                  })}
                  {o.items.length>4&&<span style={{background:"#f5f5f5",borderRadius:5,padding:"2px 7px",fontSize:11,color:"#aaa"}}>+{o.items.length-4} more</span>}
                </div>
                {isCancelled && o.cancelReason && (
                  <div style={{fontSize:11,color:"#95a5a6",marginTop:4}}>Reason: {o.cancelReason}</div>
                )}
                {isCancelReq && (
                  <div style={{fontSize:11,color:"#8E44AD",marginTop:4}}>⚠️ Awaiting factory approval</div>
                )}
              </div>
              <div style={{textAlign:"right",minWidth:75}}>
                {!hidePrice && <div style={{fontWeight:700,fontSize:14,marginBottom:6}}>{fmtMoney(total)}</div>}
                <div style={{fontSize:11,color:"#aaa"}}>Tap to view →</div>
              </div>
            </Card>
          );
        })}
      </div>

      {/* Cancel request modal */}
      {reqCancelOrder && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:400,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div style={{background:"#fff",borderRadius:16,padding:24,width:"100%",maxWidth:400}}>
            <h3 style={{margin:"0 0 8px"}}>Request Cancellation</h3>
            <p style={{fontSize:13,color:"#888",margin:"0 0 14px"}}>Order #{reqCancelOrder.id} — Please provide a reason:</p>
            <textarea value={reqCancelReason} onChange={e=>setReqCancelReason(e.target.value)}
              placeholder="Reason for cancellation..."
              style={{width:"100%",border:"1px solid #e5e5e5",borderRadius:8,padding:"10px 12px",
                fontSize:13,minHeight:80,resize:"vertical",boxSizing:"border-box",marginBottom:14}}/>
            <div style={{display:"flex",gap:8}}>
              <button onClick={()=>setReqCancelOrder(null)}
                style={{flex:1,padding:"10px",borderRadius:8,border:"1px solid #e5e5e5",background:"#fff",cursor:"pointer",fontSize:13}}>Cancel</button>
              <button onClick={submitCancelRequest} disabled={!reqCancelReason.trim()}
                style={{flex:2,padding:"10px",borderRadius:8,border:"none",
                  background:reqCancelReason.trim()?"#E74C3C":"#f0f0f0",
                  color:reqCancelReason.trim()?"#fff":"#aaa",cursor:"pointer",fontSize:13,fontWeight:700}}>
                Submit Request
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Order detail modal */}
      {selectedOrder && (()=>{
        const o = selectedOrder;
        const isCancelled = o.status?.toLowerCase()==="cancelled";
        const isCancelReq = o.status?.toLowerCase()==="cancel_requested";
        const total = o.items.reduce((s,i)=>{const p=products.find(x=>x.id===i.productId);return s+(p?p.price*i.qty:0);},0);
        return (
          <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:400,
            display:"flex",alignItems:"flex-end",justifyContent:"center"}}
            onClick={()=>setSelectedOrder(null)}>
            <div style={{background:"#fff",borderRadius:"20px 20px 0 0",width:"100%",maxWidth:560,
              maxHeight:"88vh",overflowY:"auto",boxShadow:"0 -8px 40px rgba(0,0,0,0.2)"}}
              onClick={e=>e.stopPropagation()}>

              {/* Header */}
              <div style={{background:"#1a1a1a",borderRadius:"20px 20px 0 0",padding:"18px 20px",
                display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <div>
                  <div style={{color:"#aaa",fontSize:11,fontWeight:700,letterSpacing:1}}>ORDER #{o.invoiceNumber||o.id}</div>
                  <div style={{color:"#fff",fontSize:15,fontWeight:700,marginTop:2}}>
                    {o.timestamp ? new Date(o.timestamp).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}) : ""}
                  </div>
                </div>
                <div style={{textAlign:"right"}}>
                  <Badge status={o.status}/>
                  {!hidePrice && <div style={{color:"#fff",fontWeight:800,fontSize:18,marginTop:4}}>{fmtMoney(total)}</div>}
                </div>
              </div>

              <div style={{padding:"16px 20px 24px"}}>

                {/* Delivery date */}
                <div style={{background:"#f8f8f8",borderRadius:10,padding:"10px 14px",marginBottom:16,
                  display:"flex",alignItems:"center",gap:8}}>
                  <span style={{fontSize:16}}>📦</span>
                  <div>
                    <div style={{fontSize:11,color:"#aaa",fontWeight:700}}>DELIVERY</div>
                    <div style={{fontWeight:700,fontSize:13}}>{o.deliveryDate ? fmt(new Date(o.deliveryDate)) : "TBD"}</div>
                  </div>
                </div>

                {/* Items list */}
                <div style={{fontSize:11,fontWeight:700,color:"#aaa",letterSpacing:1,marginBottom:8}}>
                  ITEMS ({o.items.length})
                </div>
                <div style={{display:"flex",flexDirection:"column",gap:6,marginBottom:16}}>
                  {o.items.map(item=>{
                    const p = products.find(x=>x.id===item.productId);
                    const lineTotal = p ? p.price * item.qty : 0;
                    return (
                      <div key={item.productId} style={{display:"flex",alignItems:"center",
                        padding:"10px 12px",background:"#fafafa",borderRadius:8,gap:10}}>
                        <div style={{flex:1}}>
                          <div style={{fontWeight:600,fontSize:14}}>{p ? pName(p) : item.name || "?"}</div>
                          <div style={{fontSize:12,color:"#aaa"}}>{p?.unit || ""}</div>
                        </div>
                        <div style={{fontSize:13,fontWeight:700,color:"#555",minWidth:30,textAlign:"center"}}>×{item.qty}</div>
                        {p?.price && !hidePrice && <div style={{fontSize:13,fontWeight:700,minWidth:60,textAlign:"right"}}>{fmtMoney(lineTotal)}</div>}
                      </div>
                    );
                  })}
                </div>

                {/* Total */}
                {!hidePrice && (
                <div style={{display:"flex",justifyContent:"space-between",padding:"10px 12px",
                  background:"#1a1a1a",borderRadius:8,marginBottom:14}}>
                  <div style={{color:"#aaa",fontSize:13}}>Total</div>
                  <div style={{color:"#fff",fontWeight:800,fontSize:15}}>{fmtMoney(total)}</div>
                </div>
                )}

                {/* Note */}
                {o.note && <NoteWithTranslate note={o.note} />}

                {/* Cancel reason */}
                {isCancelled && o.cancelReason && (
                  <div style={{background:"#fdf2f2",border:"1px solid #e8c0c0",borderRadius:8,
                    padding:"10px 14px",marginBottom:14,fontSize:13,color:"#95a5a6"}}>
                    🚫 Cancelled: {o.cancelReason}
                  </div>
                )}
                {isCancelReq && (
                  <div style={{background:"#f5f0fb",border:"1px solid #c8a8e8",borderRadius:8,
                    padding:"10px 14px",marginBottom:14,fontSize:13,color:"#8E44AD"}}>
                    ⚠️ Cancellation pending factory approval
                  </div>
                )}

                {/* Action buttons */}
                <div style={{display:"flex",flexDirection:"column",gap:8}}>
                  {/* Reorder button */}
                  <button onClick={()=>{ setSelectedOrder(null); onReorder(o); }}
                    style={{width:"100%",padding:"14px",borderRadius:12,border:"none",
                      background:rest.color||"#1a1a1a",color:"#fff",
                      fontSize:15,fontWeight:700,cursor:"pointer"}}>
                    🔄 Reorder — Use as Template
                  </button>

                  {/* View invoice */}
                  <button onClick={()=>{ setSelectedOrder(null); onView(o); }}
                    style={{width:"100%",padding:"12px",borderRadius:12,
                      border:"1px solid #e5e5e5",background:"#fff",
                      fontSize:14,fontWeight:600,cursor:"pointer",color:"#555"}}>
                    📄 View Invoice
                  </button>

                  {/* Request cancel */}
                  {(o.status?.toLowerCase()==="sent"||o.status?.toLowerCase()==="confirmed") && (
                    <button onClick={()=>{ setSelectedOrder(null); setReqCancelOrder(o); setReqCancelReason(""); }}
                      style={{width:"100%",padding:"12px",borderRadius:12,
                        border:"1px solid #fcc",background:"#fff",
                        fontSize:14,fontWeight:600,cursor:"pointer",color:"#E74C3C"}}>
                      Request Cancellation
                    </button>
                  )}

                  {/* Close */}
                  <button onClick={()=>setSelectedOrder(null)}
                    style={{width:"100%",padding:"11px",borderRadius:12,border:"none",
                      background:"#f5f5f5",color:"#888",fontSize:13,fontWeight:600,cursor:"pointer"}}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
}


function KitchenView({restaurants,orders,onAdvance,onView,products,t,pName,fmtPrice}) {
  const [filter,setFilter]=useState("All");
  const kitchenOrders=orders.filter(o=>["Sent","Confirmed","Preparing","Dispatched","Delivered"].includes(o.status));
  const filtered=filter==="All"?kitchenOrders:kitchenOrders.filter(o=>o.status===filter);
  const NEXT={"Sent":"Confirm","Confirmed":"Start Prep","Preparing":"Dispatch","Dispatched":"Delivered ✓"};

  return (
    <div>
      <div style={{marginBottom:18}}>
        <h2 style={{fontSize:28,marginBottom:2}}>{t.factoryDash}</h2>
        <p style={{color:"#888",fontSize:13}}>{t.ordersReceived}</p>
      </div>

      {orders.filter(o=>o.status==="Sent").length>0 && (
        <div style={{background:"#FEF3C7",border:"1px solid #F39C1244",borderRadius:10,
          padding:"11px 16px",marginBottom:16,display:"flex",alignItems:"center",gap:9}}>
          <span>📬</span>
          <span style={{fontWeight:700,color:"#92400E",fontSize:13}}>
            {orders.filter(o=>o.status==="Sent").length} new order{orders.filter(o=>o.status==="Sent").length>1?"s":""} received
          </span>
        </div>
      )}

      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(120px,1fr))",gap:10,marginBottom:18}}>
        {["Sent","Confirmed","Preparing","Dispatched"].map(s=>(
          <Card key={s} style={{textAlign:"center",padding:14}}>
            <div style={{fontSize:22,fontFamily:"'Playfair Display',serif",color:STATUS_META[s].color}}>
              {orders.filter(o=>o.status===s).length}
            </div>
            <div style={{fontSize:11,color:"#888",marginTop:1}}>{s}</div>
          </Card>
        ))}
      </div>

      <div style={{display:"flex",gap:5,marginBottom:14,flexWrap:"wrap"}}>
        {["All","Sent","Confirmed","Preparing","Dispatched","Delivered"].map(s=>(
          <button key={s} onClick={()=>setFilter(s)} style={{
            border:`1px solid ${filter===s?"#1a1a1a":"#ddd"}`,
            background:filter===s?"#1a1a1a":"#fff",
            color:filter===s?"#fff":"#666",
            borderRadius:20,padding:"4px 12px",fontSize:11,fontWeight:600,cursor:"pointer",
          }}>{s} ({s==="All"?kitchenOrders.length:kitchenOrders.filter(o=>o.status===s).length})</button>
        ))}
      </div>

      {filtered.length===0
        ? <Card><p style={{color:"#ccc",textAlign:"center",padding:36}}>No orders here.</p></Card>
        : (
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            {filtered.map(o=>{
              const rest=restaurants.find(r=>r.id===o.restaurantId);
              if(!rest) return null;
              const total=o.items.reduce((s,i)=>{const p=products.find(x=>x.id===i.productId);return s+(p?p.price*i.qty:0);},0);
              return (
                <Card key={o.id} style={{borderLeft:`4px solid ${rest.color}`}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:9,flexWrap:"wrap",gap:8}}>
                    <div>
                      <div style={{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap",marginBottom:2}}>
                        <span style={{fontWeight:700,fontSize:14}}>Order #{o.invoiceNumber||o.id}</span>
                        <Badge status={o.status}/>
                        <span style={{background:rest.color+"22",color:rest.color,borderRadius:20,padding:"2px 8px",fontSize:10,fontWeight:700}}>{rest.name}</span>
                        {o.hasCatering && <span style={{background:"#8E44AD22",color:"#8E44AD",borderRadius:20,padding:"2px 8px",fontSize:10,fontWeight:700}}>🍽 CATERING</span>}
                      </div>
                      <div style={{fontSize:11,color:"#aaa"}}>
                        Received: {new Date(o.sentAt||o.timestamp).toLocaleString()} . Deliver: <strong>{o.deliveryDate ? fmt(new Date(o.deliveryDate)) : "TBD"}</strong>
                      </div>
                    </div>
                    <div style={{display:"flex",gap:6,alignItems:"center",flexWrap:"wrap"}}>
                      <span style={{fontWeight:700,fontSize:14}}>{fmtMoney(total)}</span>
                      <Btn small outline color="#555" onClick={()=>onView(o)}>{t.invoice}</Btn>
                      {NEXT[o.status]&&<Btn small color="#1a1a1a" onClick={()=>onAdvance(o.id)}>{NEXT[o.status]} →</Btn>}
                    </div>
                  </div>
                  <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
                    {o.items.map(item=>{
                      const p=products.find(x=>x.id===item.productId);
                      return (
                        <div key={item.productId} style={{background:"#f5f5f5",borderRadius:6,padding:"3px 10px",fontSize:11}}>
                          <span style={{fontWeight:600}}>{p ? pName(p) : "Unknown"}</span>
                          <span style={{color:"#999",marginLeft:3}}>{item.qty} {p?.unit||""}</span>
                        </div>
                      );
                    })}
                  </div>
                </Card>
              );
            })}
          </div>
        )
      }
    </div>
  );
}

// ── Restaurant View ───────────────────────────────────────────────────────────
function RestaurantView({restaurants,activeRest,setActiveRest,inventory,setInventory,saveInventory,
  parLevels,setParLevels,savePars,orders,saveOrders,activeTab,setActiveTab,onOpenReview,onViewInvoice,onSend,showToast,products,hiddenItems,customCats,catOrder=[],t,pName,fmtPrice,lang,catVisibility,
  closingReports,saveClosingReports,auth,isCashier,allRestaurants,saveRestaurants,hidePrice=false,inventoryResetKey=0,inventoryAddOns=[]}) {

  const rest = restaurants.find(r=>r.id===activeRest) || restaurants[0];
  const [showUnsavedModal, setShowUnsavedModal] = useState(false);

  const handleReorder = (order) => {
    // Save order qtys as a draft for CustomOrderTab then navigate there
    const draftKey = `custom_draft_${activeRest}`;
    const qtys = {};
    order.items.forEach(item => { if (item.productId) qtys[item.productId] = item.qty; });
    try { localStorage.setItem(draftKey, JSON.stringify({ qtys, note: order.note || "", specialRequest: "" })); } catch(e) {}
    setActiveTab("customOrder");
    showToast("Previous order loaded — review and edit before submitting");
  };
  if (!rest) return <Card><p style={{textAlign:"center",color:"#ccc",padding:36}}>No branches yet. Add one in Settings.</p></Card>;

  const {delivDate} = nextDelivInfo((rest.deliveryDays||[]).length ? (rest.deliveryDays||[]) : ["Monday"]);
  const todayOrder = isOrderDay(rest);
  // orderModes kept for data compat but UI now uses home grid tabs
  const myOrders = orders.filter(o=>o.restaurantId===activeRest);
  const inv = inventory[activeRest] || inventory[String(activeRest)] || inventory[Number(activeRest)] || {};
  const _parRaw = parLevels[activeRest] || parLevels[String(activeRest)] || parLevels[Number(activeRest)] || {};
  // Normalize product keys to strings so getPar always finds them
  const par = Object.fromEntries(Object.entries(_parRaw).map(([k,v])=>[String(k),v]));
  return (
    <div style={{background: rest?.color ? rest.color+"06" : "transparent",
      borderRadius:16, padding:"0 0 16px", transition:"background .3s"}}>
      {/* Branch picker - scrollable on mobile */}
      <div style={{display:"flex",gap:6,marginBottom:16,overflowX:"auto",paddingBottom:0}}>
        {restaurants.map(r=>{
          const active = activeRest===r.id;
          return (
          <button key={r.id} onClick={()=>setActiveRest(r.id)} style={{
            border:`2px solid ${active ? r.color : "#e8e8e8"}`,
            background: active ? r.color+"18" : "#fafafa",
            borderRadius:12, padding:"9px 16px 8px", fontWeight:700,
            color: active ? r.color : "#aaa", fontSize:13, transition:"all .15s",
            display:"flex", flexDirection:"column", alignItems:"flex-start", gap:2,
            flexShrink:0, cursor:"pointer",
            boxShadow: active ? `0 2px 10px ${r.color}33` : "none",
          }}>
            <span>{r.name}</span>
            <span style={{fontSize:10,fontWeight:500,color:active?r.color+"bb":"#ccc"}}>
              {r.deliveryDays.join(" & ")}
            </span>
          </button>
          );
        })}
      </div>

      {/* Schedule banner */}
      <div style={{background:todayOrder?"#FEF9E7":"#F0F4F8",
        border:`1px solid ${todayOrder?"#F39C12":"#BDC3C7"}33`,
        borderRadius:11,padding:"12px 16px",marginBottom:16,
        display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8}}>
        <div style={{display:"flex",alignItems:"center",gap:9}}>
          <span style={{fontSize:18}}>{todayOrder?"🔔":"📅"}</span>
          <div>
            <div style={{fontWeight:700,fontSize:13,color:todayOrder?"#7D6608":"#444"}}>
              {todayOrder ? t.todayOrderDay : t.nextOrder}
            </div>
            <div style={{fontSize:11,color:"#888"}}>
              {t.orderDays} <strong>{rest.deliveryDays.join(", ")}</strong> . {t.nextDelivery} <strong>{fmt(delivDate)}</strong>
            </div>
          </div>
        </div>
        {todayOrder && <div style={{background:"#F39C12",color:"#fff",borderRadius:7,padding:"4px 11px",fontSize:11,fontWeight:700}}>{t.orderToday}</div>}
      </div>

      {/* ── Manager Home: 5 big action buttons ── */}
      {!activeTab && (
        <div>
        <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:18}}>
          {[
            {key:"inventory",   icon:"📦", label:t.homeOrderByInventory,  sub:t.homeOrderByInventorySub},
            {key:"customOrder", icon:"📋", label:t.homeOrderByItem,        sub:t.homeOrderByItemSub},
            {key:"catering",    icon:"🍽", label:t.homeCatering,           sub:t.homeCateringSub},
            {key:"history",     icon:"🗂", label:t.homeHistory,            sub:t.homeHistorySub},
            {key:"closing",     icon:"🧾", label:t.homeClosing,            sub:t.homeClosingSub},
          ].map(({key,icon,label,sub}) => (
            <button key={key}
              onClick={()=>{ if(key!=="catering") setActiveTab(key); }}
              style={{
                background:"#fff", border:"1.5px solid #e8e8e8", borderRadius:16,
                padding:"18px 14px", cursor:"pointer", textAlign:"left",
                boxShadow:"0 2px 8px rgba(0,0,0,0.05)", transition:"all .15s",
                gridColumn: key==="closing" ? "span 2" : "span 1",
                display:"flex", alignItems:"center", gap:14,
                opacity: key==="catering" ? 0.55 : 1,
                cursor: key==="catering" ? "not-allowed" : "pointer",
              }}
              onMouseEnter={e=>{if(key!=="catering"){e.currentTarget.style.borderColor="#1a1a1a";e.currentTarget.style.boxShadow="0 4px 16px rgba(0,0,0,0.1)";}}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor="#e8e8e8";e.currentTarget.style.boxShadow="0 2px 8px rgba(0,0,0,0.05)";}}
            >
              <div style={{fontSize:32, flexShrink:0}}>{icon}</div>
              <div>
                <div style={{fontWeight:800, fontSize:15, color:"#1a1a1a", lineHeight:1.25, whiteSpace:"pre-line"}}>{label}</div>
                <div style={{fontSize:11, color:"#aaa", marginTop:3}}>{sub}</div>
              </div>
              {key!=="catering" && <div style={{marginLeft:"auto", color:"#ccc", fontSize:18, flexShrink:0}}>›</div>}
            </button>
          ))}
        </div>
        </div>
      )}

      {/* Back button when inside a section */}
      {activeTab && (
        <button
          onClick={()=>{
            const invDirtyKey = `inv_dirty_${activeRest}`;
            const customDirtyKey = `custom_dirty_${activeRest}`;
            const isDirty = typeof sessionStorage !== "undefined" && (
              (activeTab==="inventory" && sessionStorage.getItem(invDirtyKey)) ||
              (activeTab==="customOrder" && sessionStorage.getItem(customDirtyKey))
            );
            if (isDirty) {
              setShowUnsavedModal(true);
            } else {
              setActiveTab(null);
            }
          }}
          style={{display:"inline-flex", alignItems:"center", gap:8,
            background: rest?.color || "#1a1a1a", color:"#fff",
            border:"none", borderRadius:12, cursor:"pointer",
            fontSize:15, fontWeight:700, marginBottom:18,
            padding:"11px 20px", boxShadow:`0 3px 10px ${(rest?.color||"#1a1a1a")}44`}}>
          ← {rest?.name || "Menu"}
        </button>
      )}

      {activeTab==="inventory" && (
        <InventoryTab key={activeRest+lang+inventoryResetKey} rest={rest} inventory={inv} parLevels={parLevels} activeRestId={activeRest} hidePrice={hidePrice}
          setParLevels={pl=>{ const next={...parLevels,[String(activeRest)]:pl}; setParLevels(next); savePars(next); }}
          setInventory={inv=>{ const next={...inventory,[activeRest]:inv}; setInventory(next); saveInventory(next); }}
          onReview={(baseItems, note)=>{ const {delivDate}=nextDelivInfo((rest.deliveryDays||[]).length?(rest.deliveryDays||[]):["Monday"]); onOpenReview({baseItems,cateringBreakdown:null,delivDate,note}); }}
          showToast={showToast} products={products.filter(p=>!(hiddenItems[rest.id]||[]).includes(p.id))}
          allCategories={customCats} catOrder={catOrder} t={t} pName={pName} fmtPrice={fmtPrice} savePars={savePars} lang={lang}
          catVisibility={catVisibility}
          inventoryAddOns={inventoryAddOns}
        />
      )}

      {activeTab==="customOrder" && (
        <CustomOrderTab key={activeRest} rest={rest} hidePrice={hidePrice}
          parLevels={parLevels} activeRestId={activeRest}
          onReview={(baseItems, note)=>{ const {delivDate}=nextDelivInfo((rest.deliveryDays||[]).length?(rest.deliveryDays||[]):["Monday"]); onOpenReview({baseItems,cateringBreakdown:null,delivDate,note,restId:rest.id}); }}
          showToast={showToast} products={products.filter(p=>!(hiddenItems[rest.id]||[]).includes(p.id))}
          allCategories={customCats} catOrder={catOrder} t={t} pName={pName} fmtPrice={fmtPrice} lang={lang}
        />
      )}

      {activeTab==="catering" && (
        <CateringTab rest={rest} inventory={inv} parLevels={par}
          setInventory={inv=>{ const next={...inventory,[activeRest]:inv}; setInventory(next); saveInventory(next); }}
          onReview={(baseItems,cateringBreakdown)=>{ const {delivDate}=nextDelivInfo((rest.deliveryDays||[]).length?(rest.deliveryDays||[]):["Monday"]); onOpenReview({baseItems,cateringBreakdown,delivDate}); }}
          products={products.filter(p=>!(hiddenItems[rest.id]||[]).includes(p.id))} t={t} pName={pName}
        />
      )}
      {activeTab==="history" && (
        <HistoryTab key={activeRest} orders={myOrders} rest={rest} onView={onViewInvoice} onSend={onSend} products={products} t={t} pName={pName} saveOrders={saveOrders} allOrders={orders} showToast={showToast} onReorder={handleReorder} hidePrice={hidePrice}/>
      )}
      {activeTab==="closing" && (
        <ClosingReportTab
          rest={rest}
          auth={auth}
          lang={lang}
          closingReports={(closingReports||[]).filter(r=>r.restaurantId===activeRest)}
          saveClosingReports={saveClosingReports}
          allReports={closingReports||[]}
          showToast={showToast}
          isCashier={isCashier}
          allRestaurants={allRestaurants}
          saveRestaurants={saveRestaurants}
        />
      )}

      {/* ── Unsaved Progress Modal ── */}
      {showUnsavedModal && (
        <div style={{position:"fixed",inset:0,zIndex:500,background:"rgba(0,0,0,0.5)",
          display:"flex",alignItems:"flex-end",justifyContent:"center"}}
          onClick={()=>setShowUnsavedModal(false)}>
          <div style={{background:"#fff",borderRadius:"20px 20px 0 0",padding:"24px 20px 32px",
            width:"100%",maxWidth:480,boxShadow:"0 -8px 40px rgba(0,0,0,0.2)"}}
            onClick={e=>e.stopPropagation()}>
            <div style={{fontWeight:800,fontSize:17,color:"#1a1a1a",marginBottom:6}}>
              You have unsaved progress
            </div>
            <div style={{fontSize:14,color:"#aaa",marginBottom:20}}>
              Your order hasn't been submitted yet.
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              <button
                onClick={()=>{
                  // Progress is already auto-saved on every change
                  try {
                    sessionStorage.removeItem(`inv_dirty_${activeRest}`);
                    sessionStorage.removeItem(`custom_dirty_${activeRest}`);
                  } catch(e) {}
                  setShowUnsavedModal(false);
                  showToast("Progress saved ✓");
                  setActiveTab(null);
                }}
                style={{width:"100%",padding:"15px",borderRadius:12,border:"none",
                  background:"#1a1a1a",color:"#fff",fontSize:15,fontWeight:700,cursor:"pointer"}}>
                💾 Save & Go Back
              </button>
              <button
                onClick={()=>{
                  try {
                    sessionStorage.removeItem(`inv_dirty_${activeRest}`);
                    sessionStorage.removeItem(`custom_dirty_${activeRest}`);
                  } catch(e) {}
                  setShowUnsavedModal(false);
                  setActiveTab(null);
                }}
                style={{width:"100%",padding:"15px",borderRadius:12,
                  border:"1px solid #f0f0f0",background:"#fff",
                  color:"#E74C3C",fontSize:15,fontWeight:700,cursor:"pointer"}}>
                Discard & Go Back
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Main App ──────────────────────────────────────────────────────────────────



// ── Admin Home Dashboard ─────────────────────────────────────────────────────
function AdminHomeView({ setAppView, auth }) {
  const pages = [
    { key:"restaurant",     icon:"🏪", label:"Restaurants",     desc:"View and manage location orders & inventory" },
    { key:"centralKitchen", icon:"🏭", label:"Central Factory",  desc:"Review and manage incoming orders" },
    { key:"prep",           icon:"📋", label:"Prep",             desc:"Task assignments, staff tracking & analytics" },
    { key:"reports",        icon:"📊", label:"Reports",          desc:"Sales, tips, closing & factory reports" },
    { key:"settings",       icon:"⚙️",  label:"Settings",         desc:"Manage products, users, and locations" },
  ];

  return (
    <div style={{maxWidth:560, margin:"0 auto", padding:"40px 20px"}}>
      <div style={{marginBottom:36}}>
        <h2 style={{fontSize:28, fontFamily:"'Playfair Display',serif", margin:"0 0 6px"}}>
          Good {new Date().getHours() < 12 ? "morning" : new Date().getHours() < 17 ? "afternoon" : "evening"}, {auth?.username ? auth.username.charAt(0).toUpperCase() + auth.username.slice(1) : "Admin"} 👋
        </h2>
        <p style={{color:"#888", fontSize:14, margin:0}}>Where would you like to go?</p>
      </div>

      <div style={{display:"flex", flexDirection:"column", gap:10}}>
        {pages.map(p => (
          <button key={p.key} onClick={() => setAppView(p.key)}
            style={{
              display:"flex", alignItems:"center", gap:16,
              background:"#fff", border:"1px solid #e8e8e8",
              borderRadius:12, padding:"16px 20px",
              cursor:"pointer", textAlign:"left", width:"100%",
              boxShadow:"0 1px 4px rgba(0,0,0,0.05)",
              transition:"all .15s",
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor="#1a1a1a"; e.currentTarget.style.boxShadow="0 2px 10px rgba(0,0,0,0.1)"; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor="#e8e8e8"; e.currentTarget.style.boxShadow="0 1px 4px rgba(0,0,0,0.05)"; }}
          >
            <span style={{fontSize:26, flexShrink:0}}>{p.icon}</span>
            <div style={{flex:1}}>
              <div style={{fontWeight:700, fontSize:16, color:"#1a1a1a", marginBottom:2}}>{p.label}</div>
              <div style={{fontSize:13, color:"#888"}}>{p.desc}</div>
            </div>
            <span style={{color:"#ccc", fontSize:18}}>›</span>
          </button>
        ))}
      </div>
    </div>
  );
}



function ClosingReportCard({ r }) {
  const fmt = (n) => `$${(parseFloat(n)||0).toFixed(2)}`;
  const disc = parseFloat(r.computedDiscrepancy)||0;
  const deposit = parseFloat(r.computedCashDeposit)||0;
  const totalSales = parseFloat(r.computedTotalSales)||0;
  const totalTips = parseFloat(r.computedTotalTips)||0;
  const tipPer = parseFloat(r.computedTipPerEmployee)||0;
  const flagged = Math.abs(disc) > 5;

  return (
    <div className="closing-report-card" style={{
      background:"#fff", border:"1px solid #e8e8e8", borderRadius:14,
      overflow:"hidden", boxShadow:"0 2px 12px rgba(0,0,0,0.06)"
    }}>
      {/* Header */}
      <div style={{background:"#1a1a1a", color:"#fff", padding:"14px 18px", display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:8}}>
        <div>
          <div style={{fontWeight:800, fontSize:16}}>{r.restaurantName || "—"}</div>
          <div style={{fontSize:12, color:"#aaa", marginTop:2, textTransform:"capitalize"}}>
            {r.shift ? r.shift.charAt(0).toUpperCase()+r.shift.slice(1) : ""} Shift · {r.date}
            {r.submittedAt && (
              <span style={{marginLeft:6,color:"#aaa",fontSize:11}}>
                {new Date(r.submittedAt).toLocaleTimeString("en-US",{hour:"2-digit",minute:"2-digit"})}
              </span>
            )}
          </div>
        </div>
        <div style={{textAlign:"right"}}>
          <div style={{fontSize:11, color:"#aaa"}}>Submitted by</div>
          <div style={{fontWeight:700, fontSize:14}}>{r.employeeName}</div>
        </div>
      </div>

      <div style={{padding:"16px 18px", display:"flex", flexDirection:"column", gap:14}}>

        {/* Sales section */}
        <div style={{background:"#f9f9f9", borderRadius:10, padding:"12px 14px"}}>
          <div style={{fontSize:10, fontWeight:700, color:"#aaa", textTransform:"uppercase", marginBottom:10, letterSpacing:1}}>Sales</div>
          <div style={{fontSize:13, display:"flex", flexDirection:"column", gap:5}}>
            {[["Cash", r.cashSales], ["Credit Card", r.creditSales], ["3rd Party", r.thirdPartySales], ["Kiosk", r.kioskSales]].map(([l,v])=>(
              <div key={l} style={{display:"flex", justifyContent:"space-between"}}>
                <span style={{color:"#888"}}>{l}</span>
                <span>{fmt(v)}</span>
              </div>
            ))}
            <div style={{display:"flex", justifyContent:"space-between", borderTop:"1px solid #e5e5e5", paddingTop:7, marginTop:3}}>
              <span style={{fontWeight:700}}>Total Sales</span>
              <span style={{fontWeight:800, fontSize:15}}>{fmt(totalSales)}</span>
            </div>
          </div>
          {/* Discrepancy + Deposit pills */}
          <div style={{display:"flex", gap:8, marginTop:12}}>
            <div style={{flex:1, padding:"10px 12px", borderRadius:8,
              background:flagged?"#fff0f0":disc>=0?"#f0faf4":"#fff5f5",
              border:`1px solid ${flagged?"#E74C3C":disc>=0?"#27AE60":"#E74C3C"}`}}>
              <div style={{fontSize:10, fontWeight:700, color:"#888", marginBottom:3}}>DISCREPANCY</div>
              <div style={{fontSize:16, fontWeight:800, color:flagged?"#E74C3C":disc>=0?"#27AE60":"#E74C3C"}}>
                {disc>=0?"+":""}{fmt(disc)} {flagged&&"⚠️"}
              </div>
            </div>
            <div style={{flex:1, padding:"10px 12px", borderRadius:8, background:"#f0f8ff", border:"1px solid #2471A3"}}>
              <div style={{fontSize:10, fontWeight:700, color:"#888", marginBottom:3}}>CASH DEPOSIT</div>
              <div style={{fontSize:16, fontWeight:800, color:"#2471A3"}}>{fmt(Math.max(0,deposit))}</div>
            </div>
          </div>
        </div>

        {/* Tips section */}
        <div style={{background:"#f9f9f9", borderRadius:10, padding:"12px 14px"}}>
          <div style={{fontSize:10, fontWeight:700, color:"#aaa", textTransform:"uppercase", marginBottom:10, letterSpacing:1}}>Tips</div>
          <div style={{fontSize:13, display:"flex", flexDirection:"column", gap:5}}>
            {[["Credit Card", r.creditTips], ["Kiosk", r.kioskTips], ["3rd Party", r.thirdPartyTips]].map(([l,v])=>(
              <div key={l} style={{display:"flex", justifyContent:"space-between"}}>
                <span style={{color:"#888"}}>{l} Tips</span>
                <span>{fmt(v)}</span>
              </div>
            ))}
            <div style={{display:"flex", justifyContent:"space-between", borderTop:"1px solid #e5e5e5", paddingTop:7, marginTop:3}}>
              <span style={{fontWeight:700}}>Total Tips</span>
              <span style={{fontWeight:800, fontSize:15, color:"#27AE60"}}>{fmt(totalTips)}</span>
            </div>
            {(r.workingStaff||[]).length > 0 && (
              <div style={{display:"flex", justifyContent:"space-between", marginTop:2}}>
                <span style={{color:"#888"}}>Per Employee ({(r.workingStaff||[]).length})</span>
                <span style={{fontWeight:700, color:"#27AE60"}}>{fmt(tipPer)}</span>
              </div>
            )}
          </div>
          {(r.workingStaff||[]).length > 0 && (
            <div style={{marginTop:8, display:"flex", flexWrap:"wrap", gap:5}}>
              {(r.workingStaff||[]).map(s=>(
                <span key={s} style={{background:"#e8f5e9", color:"#2E7D32", fontSize:11, fontWeight:600,
                  borderRadius:20, padding:"3px 10px"}}>{s}</span>
              ))}
            </div>
          )}
        </div>

      </div>
    </div>
  );
}


// ── Closing Reports View ──────────────────────────────────────────────────────
function ClosingReportsView({ closingReports, restaurants, showToast }) {
  const [tab, setTab] = useState("sales");
  const [locMode, setLocMode] = useState("single"); // single | compare
  const [selectedLoc, setSelectedLoc] = useState("all");
  const [period, setPeriod] = useState("month");
  const [customStart, setCustomStart] = useState("");
  const [customEnd, setCustomEnd] = useState("");

  const TABS = [
    ["sales",       "💰 Sales"],
    ["deposits",    "🏦 Deposits"],
    ["tips",        "💵 Tips"],
    ["discrepancy", "⚠️ Discrepancy"],
    ["shifts",      "📅 Shifts"],
    ["records",     "📋 Records"],
  ];

  // ── Period filter ──
  const now = new Date();
  const getDateRange = () => {
    if (period === "week") {
      const start = new Date(now); start.setDate(now.getDate() - now.getDay());
      start.setHours(0,0,0,0);
      return { start, end: new Date() };
    }
    if (period === "month") {
      return { start: new Date(now.getFullYear(), now.getMonth(), 1), end: new Date() };
    }
    if (period === "year") {
      return { start: new Date(now.getFullYear(), 0, 1), end: new Date() };
    }
    if (period === "custom" && customStart && customEnd) {
      return { start: new Date(customStart), end: new Date(customEnd + "T23:59:59") };
    }
    return { start: new Date(0), end: new Date() };
  };

  const { start: rangeStart, end: rangeEnd } = getDateRange();

  const inRange = (r) => {
    const d = new Date(r.date);
    return d >= rangeStart && d <= rangeEnd;
  };

  const filteredByPeriod = (closingReports || []).filter(inRange);

  const forLocation = (loc) => loc === "all"
    ? filteredByPeriod
    : filteredByPeriod.filter(r => r.restaurantId === loc);

  const reports = locMode === "single" ? forLocation(selectedLoc) : filteredByPeriod;

  const fmt = (n) => `$${(parseFloat(n)||0).toFixed(2)}`;
  const sum = (arr, key) => arr.reduce((s,r) => s + (parseFloat(r[key])||0), 0);

  const periodLabel = period === "week" ? "This Week" : period === "month" ? "This Month" : period === "year" ? "This Year" : "Custom Range";

  // ── Bar chart helper ──
  const BarChart = ({ data, color="#2471A3", height=160 }) => {
    if (!data.length) return <div style={{color:"#ccc",fontSize:13,textAlign:"center",padding:20}}>No data</div>;
    const max = Math.max(...data.map(d=>d.value), 0.01);
    return (
      <div style={{background:"#fafafa", borderRadius:12, padding:"20px 24px 12px", border:"1px solid #f0f0f0"}}>
        <div style={{display:"flex", alignItems:"flex-end", gap:20, height:height, justifyContent:"center"}}>
          {data.map((d,i) => (
            <div key={i} style={{display:"flex", flexDirection:"column", alignItems:"center", gap:6, width:64}}>
              <div style={{fontSize:11, fontWeight:700, color:"#555"}}>{fmt(d.value)}</div>
              <div style={{
                width:40, background:color, borderRadius:"6px 6px 0 0",
                height:`${Math.max(Math.round((d.value/max)*height*0.85), 4)}px`,
                transition:"height .4s ease", boxShadow:"0 2px 8px rgba(0,0,0,0.1)"
              }}/>
              <div style={{fontSize:11, color:"#888", textAlign:"center", whiteSpace:"nowrap"}}>{d.label}</div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // ── Multi-bar chart for comparison ──
  const MultiBarChart = ({ datasets, height=160 }) => {
    const allVals = datasets.flatMap(ds => ds.values.map(v=>v.value));
    const max = Math.max(...allVals, 0.01);
    const colors = ["#2471A3","#27AE60","#E67E22","#8E44AD","#C0392B"];
    const labels = datasets[0]?.values.map(v=>v.label) || [];
    return (
      <div style={{background:"#fafafa", borderRadius:12, padding:"20px 24px 12px", border:"1px solid #f0f0f0"}}>
        <div style={{display:"flex", gap:16, marginBottom:14, flexWrap:"wrap"}}>
          {datasets.map((ds,i)=>(
            <div key={i} style={{display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#555"}}>
              <div style={{width:10,height:10,borderRadius:3,background:colors[i%colors.length]}}/>
              <span style={{fontWeight:600}}>{ds.label}</span>
            </div>
          ))}
        </div>
        <div style={{display:"flex", alignItems:"flex-end", gap:16, height:height, justifyContent:"center"}}>
          {labels.map((label,li) => (
            <div key={li} style={{display:"flex", flexDirection:"column", alignItems:"center", gap:6}}>
              <div style={{display:"flex", alignItems:"flex-end", gap:4}}>
                {datasets.map((ds,di) => {
                  const val = ds.values[li]?.value || 0;
                  return (
                    <div key={di} title={`${ds.label}: ${fmt(val)}`} style={{
                      width:20, background:colors[di%colors.length],
                      borderRadius:"4px 4px 0 0",
                      height:`${Math.max(Math.round((val/max)*height*0.85),4)}px`,
                      transition:"height .4s ease", boxShadow:"0 2px 6px rgba(0,0,0,0.1)"
                    }}/>
                  );
                })}
              </div>
              <div style={{fontSize:11, color:"#888", textAlign:"center", whiteSpace:"nowrap"}}>{label}</div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // ── Export helpers ──
  const downloadCSV = (rows, filename) => {
    const csv = rows.map(r => r.map(c => `"${String(c).replace(/"/g,'""')}"`).join(",")).join("\n");
    const blob = new Blob([csv], {type:"text/csv"});
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob);
    a.download = filename; a.click();
  };

  const exportCurrentTab = () => {
    if (tab === "sales") {
      const rows = [["Date","Location","Shift","Employee","Cash","Credit","3rd Party","Kiosk","Total"]];
      reports.forEach(r => rows.push([r.date, r.restaurantName, r.shift, r.employeeName,
        r.cashSales||0, r.creditSales||0, r.thirdPartySales||0, r.kioskSales||0, r.computedTotalSales||0]));
      downloadCSV(rows, `sales-report-${period}.csv`);
    } else if (tab === "tips") {
      const rows = [["Date","Location","Shift","Employee","Credit Tips","Kiosk Tips","3rd Party Tips","Total Tips","Staff Count","Per Employee"]];
      reports.forEach(r => rows.push([r.date, r.restaurantName, r.shift, r.employeeName,
        r.creditTips||0, r.kioskTips||0, r.thirdPartyTips||0, r.computedTotalTips||0,
        (r.workingStaff||[]).length, r.computedTipPerEmployee||0]));
      downloadCSV(rows, `tips-report-${period}.csv`);
    } else if (tab === "discrepancy") {
      const rows = [["Date","Location","Shift","Employee","Expected Cash","Actual Cash","Discrepancy","Flagged"]];
      reports.forEach(r => rows.push([r.date, r.restaurantName, r.shift, r.employeeName,
        r.computedExpectedCash||0, r.actualCash||0, r.computedDiscrepancy||0,
        Math.abs(r.computedDiscrepancy||0) > 5 ? "YES" : ""]));
      downloadCSV(rows, `discrepancy-report-${period}.csv`);
    } else if (tab === "deposits") {
      const rows = [["Date","Location","Shift","Employee","Cash Sales","Deposit Amount"]];
      reports.forEach(r => rows.push([r.date, r.restaurantName, r.shift, r.employeeName,
        r.cashSales||0, r.computedCashDeposit||0]));
      downloadCSV(rows, `deposits-report-${period}.csv`);
    } else {
      const rows = [["Date","Location","Shift","Employee","Total Sales","Total Tips","Discrepancy","Deposit"]];
      reports.forEach(r => rows.push([r.date, r.restaurantName, r.shift, r.employeeName,
        r.computedTotalSales||0, r.computedTotalTips||0, r.computedDiscrepancy||0, r.computedCashDeposit||0]));
      downloadCSV(rows, `shifts-report-${period}.csv`);
    }
    showToast("CSV downloaded ✓");
  };

  const exportPackage = () => {
    // Build a multi-sheet CSV (as separate downloads since pure JS can't do multi-sheet without xlsx lib)
    const allSheets = [
      { name:"sales", rows:[["Date","Location","Shift","Employee","Cash","Credit","3rd Party","Kiosk","Total"],
          ...filteredByPeriod.map(r=>[r.date,r.restaurantName,r.shift,r.employeeName,
            r.cashSales||0,r.creditSales||0,r.thirdPartySales||0,r.kioskSales||0,r.computedTotalSales||0])] },
      { name:"tips", rows:[["Date","Location","Employee","Total Tips","Per Employee","Staff"],
          ...filteredByPeriod.map(r=>[r.date,r.restaurantName,r.employeeName,
            r.computedTotalTips||0,r.computedTipPerEmployee||0,(r.workingStaff||[]).join("; ")])] },
      { name:"discrepancy", rows:[["Date","Location","Employee","Discrepancy","Flagged"],
          ...filteredByPeriod.map(r=>[r.date,r.restaurantName,r.employeeName,
            r.computedDiscrepancy||0, Math.abs(r.computedDiscrepancy||0)>5?"YES":""])] },
      { name:"deposits", rows:[["Date","Location","Employee","Deposit"],
          ...filteredByPeriod.map(r=>[r.date,r.restaurantName,r.employeeName,r.computedCashDeposit||0])] },
    ];
    allSheets.forEach(s => {
      const csv = s.rows.map(r=>r.map(c=>`"${String(c).replace(/"/g,'""')}"`).join(",")).join("\n");
      const blob = new Blob([csv],{type:"text/csv"});
      const a = document.createElement("a"); a.href = URL.createObjectURL(blob);
      a.download = `${s.name}-${period}.csv`; a.click();
    });
    showToast("Package downloaded (4 files) ✓");
  };

  // ── Period selector ──
  const PeriodSelector = () => (
    <div style={{display:"flex", gap:8, flexWrap:"wrap", alignItems:"center"}}>
      {[["week","This Week"],["month","This Month"],["year","This Year"],["custom","Custom"]].map(([v,l])=>(
        <button key={v} onClick={()=>setPeriod(v)}
          style={{border:"none", borderRadius:8, padding:"6px 14px", fontSize:13, fontWeight:600, cursor:"pointer",
            background:period===v?"#1a1a1a":"#f0f0f0", color:period===v?"#fff":"#555"}}>
          {l}
        </button>
      ))}
      {period==="custom" && (
        <>
          <input type="date" value={customStart} onChange={e=>setCustomStart(e.target.value)}
            style={{border:"1px solid #ddd", borderRadius:8, padding:"5px 10px", fontSize:13}}/>
          <span style={{color:"#888", fontSize:13}}>to</span>
          <input type="date" value={customEnd} onChange={e=>setCustomEnd(e.target.value)}
            style={{border:"1px solid #ddd", borderRadius:8, padding:"5px 10px", fontSize:13}}/>
        </>
      )}
    </div>
  );

  // ── Location selector ──
  const LocationSelector = () => (
    <div style={{display:"flex", gap:8, alignItems:"center", flexWrap:"wrap"}}>
      <div style={{display:"flex", gap:4, background:"#f0f0f0", borderRadius:9, padding:3}}>
        {[["single","Single Location"],["compare","Compare Locations"]].map(([v,l])=>(
          <button key={v} onClick={()=>setLocMode(v)}
            style={{border:"none", borderRadius:7, padding:"6px 14px", fontSize:13, fontWeight:600, cursor:"pointer",
              background:locMode===v?"#1a1a1a":"transparent", color:locMode===v?"#fff":"#555"}}>
            {l}
          </button>
        ))}
      </div>
      {locMode==="single" && (
        <select value={selectedLoc} onChange={e=>setSelectedLoc(e.target.value==="all"?"all":parseInt(e.target.value))}
          style={{border:"1px solid #ddd", borderRadius:8, padding:"6px 12px", fontSize:13, background:"#fff"}}>
          <option value="all">All Locations</option>
          {restaurants.map(r=><option key={r.id} value={r.id}>{r.name}</option>)}
        </select>
      )}
    </div>
  );

  const StatCard = ({label, value, sub, color="#1a1a1a", flag}) => (
    <div style={{background:flag?"#fff5f5":"#fff", border:`1px solid ${flag?"#E74C3C":"#e8e8e8"}`,
      borderRadius:12, padding:"14px 16px", flex:1, minWidth:120}}>
      <div style={{fontSize:11, fontWeight:700, color:"#aaa", textTransform:"uppercase", marginBottom:6}}>{label}</div>
      <div style={{fontSize:22, fontWeight:800, color:flag?"#E74C3C":color}}>{value}</div>
      {sub && <div style={{fontSize:11, color:"#aaa", marginTop:3}}>{sub}</div>}
    </div>
  );

  // ── Tab: Sales ──
  const SalesTab = () => {
    const totalSales = sum(reports,"computedTotalSales");
    const cashTotal = sum(reports,"cashSales");
    const creditTotal = sum(reports,"creditSales");
    const thirdPartyTotal = sum(reports,"thirdPartySales");
    const kioskTotal = sum(reports,"kioskSales");

    const byType = [
      {label:"Cash", value:cashTotal},
      {label:"Credit", value:creditTotal},
      {label:"3rd Party", value:thirdPartyTotal},
      {label:"Kiosk", value:kioskTotal},
    ];

    const compareData = locMode==="compare" ? restaurants.map(r=>({
      label: r.name,
      values: [
        {label:"Cash",    value:sum(forLocation(r.id),"cashSales")},
        {label:"Credit",  value:sum(forLocation(r.id),"creditSales")},
        {label:"3rd Party",value:sum(forLocation(r.id),"thirdPartySales")},
        {label:"Kiosk",   value:sum(forLocation(r.id),"kioskSales")},
      ]
    })) : [];

    return (
      <div>
        <div style={{display:"flex", gap:10, flexWrap:"wrap", marginBottom:20}}>
          <StatCard label="Total Sales" value={fmt(totalSales)} sub={`${reports.length} reports`}/>
          <StatCard label="Cash" value={fmt(cashTotal)} sub={`${totalSales>0?Math.round(cashTotal/totalSales*100):0}% of total`}/>
          <StatCard label="Credit Card" value={fmt(creditTotal)}/>
          <StatCard label="3rd Party" value={fmt(thirdPartyTotal)}/>
          <StatCard label="Kiosk" value={fmt(kioskTotal)}/>
        </div>
        {locMode==="compare"
          ? <MultiBarChart datasets={compareData} height={140}/>
          : <BarChart data={byType} color="#2471A3" height={140}/>
        }
        {reports.length>0 && (
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:13,marginTop:20}}>
            <thead>
              <tr style={{background:"#f5f5f5"}}>
                {["Date","Location","Shift","Employee","Cash","Credit","3rd Party","Kiosk","Total"].map(h=>(
                  <th key={h} style={{padding:"8px 10px",textAlign:"left",fontWeight:700,color:"#888",fontSize:11,textTransform:"uppercase"}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {reports.map((r,i)=>(
                <tr key={r.id} style={{borderBottom:"1px solid #f0f0f0",background:i%2===0?"#fff":"#fafafa"}}>
                  <td style={{padding:"7px 10px"}}>{r.date}</td>
                  <td style={{padding:"7px 10px"}}>{r.restaurantName}</td>
                  <td style={{padding:"7px 10px",textTransform:"capitalize"}}>{r.shift}</td>
                  <td style={{padding:"7px 10px"}}>{r.employeeName}</td>
                  <td style={{padding:"7px 10px"}}>{fmt(r.cashSales)}</td>
                  <td style={{padding:"7px 10px"}}>{fmt(r.creditSales)}</td>
                  <td style={{padding:"7px 10px"}}>{fmt(r.thirdPartySales)}</td>
                  <td style={{padding:"7px 10px"}}>{fmt(r.kioskSales)}</td>
                  <td style={{padding:"7px 10px",fontWeight:700}}>{fmt(r.computedTotalSales)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    );
  };

  // ── Tab: Deposits ──
  const DepositsTab = () => {
    const totalDeposit = sum(reports,"computedCashDeposit");
    const totalCash = sum(reports,"cashSales");
    const byLoc = restaurants.map(r=>({
      label:r.name, value:sum(forLocation(r.id),"computedCashDeposit")
    }));
    return (
      <div>
        <div style={{display:"flex",gap:10,flexWrap:"wrap",marginBottom:20}}>
          <StatCard label="Total Cash Sales" value={fmt(totalCash)}/>
          <StatCard label="Total Deposited" value={fmt(totalDeposit)} color="#2471A3"/>
          <StatCard label="Left in Register" value={fmt(reports.length*200)} sub="$200 × reports"/>
        </div>
        {locMode==="compare"
          ? <MultiBarChart datasets={restaurants.map(r=>({
              label:r.name,
              values:[{label:"Deposit",value:sum(forLocation(r.id),"computedCashDeposit")}]
            }))} height={120}/>
          : <BarChart data={byLoc} color="#27AE60" height={120}/>
        }
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:13,marginTop:20}}>
          <thead><tr style={{background:"#f5f5f5"}}>
            {["Date","Location","Shift","Employee","Cash Sales","Deposit"].map(h=>(
              <th key={h} style={{padding:"8px 10px",textAlign:"left",fontWeight:700,color:"#888",fontSize:11,textTransform:"uppercase"}}>{h}</th>
            ))}
          </tr></thead>
          <tbody>
            {reports.map((r,i)=>(
              <tr key={r.id} style={{borderBottom:"1px solid #f0f0f0",background:i%2===0?"#fff":"#fafafa"}}>
                <td style={{padding:"7px 10px"}}>{r.date}</td>
                <td style={{padding:"7px 10px"}}>{r.restaurantName}</td>
                <td style={{padding:"7px 10px",textTransform:"capitalize"}}>{r.shift}</td>
                <td style={{padding:"7px 10px"}}>{r.employeeName}</td>
                <td style={{padding:"7px 10px"}}>{fmt(r.cashSales)}</td>
                <td style={{padding:"7px 10px",fontWeight:700,color:"#27AE60"}}>{fmt(r.computedCashDeposit)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  // ── Tab: Tips ──
  const TipsTab = () => {
    const totalTips = sum(reports,"computedTotalTips");
    // Aggregate per employee
    const byEmployee = {};
    reports.forEach(r => {
      const emp = r.employeeName || "Unknown";
      if (!byEmployee[emp]) byEmployee[emp] = {tips:0, shifts:0, staff:{}};
      byEmployee[emp].tips += parseFloat(r.computedTotalTips)||0;
      byEmployee[emp].shifts++;
      (r.workingStaff||[]).forEach(s => {
        byEmployee[emp].staff[s] = (byEmployee[emp].staff[s]||0) + (parseFloat(r.computedTipPerEmployee)||0);
      });
    });

    // Overall staff tip totals
    const staffTotals = {};
    reports.forEach(r => {
      (r.workingStaff||[]).forEach(s => {
        staffTotals[s] = (staffTotals[s]||0) + (parseFloat(r.computedTipPerEmployee)||0);
      });
    });
    const staffList = Object.entries(staffTotals).sort((a,b)=>b[1]-a[1]);

    const compareData = locMode==="compare" ? restaurants.map(r=>({
      label:r.name,
      values:[{label:"Total Tips",value:sum(forLocation(r.id),"computedTotalTips")}]
    })) : [];

    return (
      <div>
        <div style={{display:"flex",gap:10,flexWrap:"wrap",marginBottom:20}}>
          <StatCard label="Total Tips" value={fmt(totalTips)}/>
          <StatCard label="Avg Tips/Shift" value={fmt(reports.length?totalTips/reports.length:0)}/>
          <StatCard label="Employees Tipped" value={staffList.length}/>
        </div>
        {locMode==="compare"
          ? <MultiBarChart datasets={compareData} height={120}/>
          : <BarChart data={staffList.map(([n,v])=>({label:n,value:v}))} color="#27AE60" height={120}/>
        }
        {staffList.length>0 && (
          <div style={{marginTop:20}}>
            <div style={{fontSize:12,fontWeight:700,color:"#888",textTransform:"uppercase",marginBottom:10}}>Tips by Employee — {periodLabel}</div>
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
              <thead><tr style={{background:"#f5f5f5"}}>
                {["Employee","Total Tips Earned","Shifts Counted"].map(h=>(
                  <th key={h} style={{padding:"8px 10px",textAlign:"left",fontWeight:700,color:"#888",fontSize:11,textTransform:"uppercase"}}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {staffList.map(([name,total],i)=>{
                  const shifts = reports.filter(r=>(r.workingStaff||[]).includes(name)).length;
                  return (
                    <tr key={name} style={{borderBottom:"1px solid #f0f0f0",background:i%2===0?"#fff":"#fafafa"}}>
                      <td style={{padding:"8px 10px",fontWeight:600}}>{name}</td>
                      <td style={{padding:"8px 10px",fontWeight:700,color:"#27AE60"}}>{fmt(total)}</td>
                      <td style={{padding:"8px 10px",color:"#888"}}>{shifts}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  // ── Tab: Discrepancy ──
  const DiscrepancyTab = () => {
    const flagged = reports.filter(r=>Math.abs(parseFloat(r.computedDiscrepancy)||0)>5);
    const byEmployee = {};
    reports.forEach(r => {
      const emp = r.employeeName||"Unknown";
      if (!byEmployee[emp]) byEmployee[emp]={count:0,total:0,flagged:0};
      byEmployee[emp].count++;
      byEmployee[emp].total += parseFloat(r.computedDiscrepancy)||0;
      if (Math.abs(parseFloat(r.computedDiscrepancy)||0)>5) byEmployee[emp].flagged++;
    });
    const empList = Object.entries(byEmployee).sort((a,b)=>Math.abs(b[1].total)-Math.abs(a[1].total));

    const allDisc = sum(reports,"computedDiscrepancy");
    const avgDisc = reports.length ? allDisc/reports.length : 0;

    return (
      <div>
        <div style={{display:"flex",gap:10,flexWrap:"wrap",marginBottom:20}}>
          <StatCard label="Total Discrepancy" value={`${allDisc>=0?"+":""}${fmt(allDisc)}`}
            color={allDisc<0?"#E74C3C":"#27AE60"} flag={allDisc<-5}/>
          <StatCard label="Avg per Shift" value={`${avgDisc>=0?"+":""}${fmt(avgDisc)}`}
            flag={Math.abs(avgDisc)>5}/>
          <StatCard label="Flagged Shifts" value={flagged.length}
            sub={`of ${reports.length} total`} flag={flagged.length>0}/>
        </div>

        {flagged.length>0 && (
          <div style={{background:"#fff5f5",border:"1px solid #E74C3C",borderRadius:10,padding:"12px 16px",marginBottom:20}}>
            <div style={{fontWeight:700,color:"#C0392B",fontSize:14,marginBottom:8}}>⚠️ Flagged Shifts (discrepancy &gt; $5)</div>
            {flagged.sort((a,b)=>Math.abs(b.computedDiscrepancy)-Math.abs(a.computedDiscrepancy)).map(r=>(
              <div key={r.id} style={{display:"flex",justifyContent:"space-between",fontSize:13,padding:"5px 0",borderBottom:"1px solid #fcc"}}>
                <span>{r.date} . {r.restaurantName} . {r.employeeName}</span>
                <span style={{fontWeight:700,color:"#C0392B"}}>{parseFloat(r.computedDiscrepancy)>=0?"+":""}{fmt(r.computedDiscrepancy)}</span>
              </div>
            ))}
          </div>
        )}

        {empList.length>0 && (
          <div style={{marginBottom:20}}>
            <div style={{fontSize:12,fontWeight:700,color:"#888",textTransform:"uppercase",marginBottom:10}}>Pattern Analysis by Shift Leader</div>
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
              <thead><tr style={{background:"#f5f5f5"}}>
                {["Shift Leader","Shifts","Total Discrepancy","Avg per Shift","Flagged","Pattern"].map(h=>(
                  <th key={h} style={{padding:"8px 10px",textAlign:"left",fontWeight:700,color:"#888",fontSize:11,textTransform:"uppercase"}}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {empList.map(([name,data],i)=>{
                  const avg = data.count ? data.total/data.count : 0;
                  const pattern = Math.abs(avg)<=1 ? {label:"[OK] Clean",color:"#27AE60"}
                    : avg<-5 ? {label:"🔴 Consistently short",color:"#E74C3C"}
                    : avg<0  ? {label:"🟡 Slightly short",color:"#E67E22"}
                    : avg>5  ? {label:"🟡 Consistently over",color:"#2471A3"}
                    : {label:"⚪ Minor variance",color:"#888"};
                  return (
                    <tr key={name} style={{borderBottom:"1px solid #f0f0f0",background:i%2===0?"#fff":"#fafafa"}}>
                      <td style={{padding:"8px 10px",fontWeight:600}}>{name}</td>
                      <td style={{padding:"8px 10px",color:"#888"}}>{data.count}</td>
                      <td style={{padding:"8px 10px",fontWeight:700,color:data.total<0?"#E74C3C":"#27AE60"}}>
                        {data.total>=0?"+":""}{fmt(data.total)}
                      </td>
                      <td style={{padding:"8px 10px",color:Math.abs(avg)>5?"#E74C3C":"#555"}}>
                        {avg>=0?"+":""}{fmt(avg)}
                      </td>
                      <td style={{padding:"8px 10px",color:data.flagged>0?"#E74C3C":"#555"}}>{data.flagged}</td>
                      <td style={{padding:"8px 10px",color:pattern.color,fontWeight:600}}>{pattern.label}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        <div style={{marginTop:8}}>
          <div style={{fontSize:12,fontWeight:700,color:"#888",textTransform:"uppercase",marginBottom:10}}>All Shifts</div>
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
            <thead><tr style={{background:"#f5f5f5"}}>
              {["Date","Location","Shift","Employee","Expected","Actual","Discrepancy"].map(h=>(
                <th key={h} style={{padding:"8px 10px",textAlign:"left",fontWeight:700,color:"#888",fontSize:11,textTransform:"uppercase"}}>{h}</th>
              ))}
            </tr></thead>
            <tbody>
              {[...reports].sort((a,b)=>Math.abs(b.computedDiscrepancy||0)-Math.abs(a.computedDiscrepancy||0)).map((r,i)=>{
                const disc = parseFloat(r.computedDiscrepancy)||0;
                const flagged = Math.abs(disc)>5;
                return (
                  <tr key={r.id} style={{borderBottom:"1px solid #f0f0f0",background:flagged?"#fff8f8":i%2===0?"#fff":"#fafafa"}}>
                    <td style={{padding:"7px 10px"}}>{r.date}</td>
                    <td style={{padding:"7px 10px"}}>{r.restaurantName}</td>
                    <td style={{padding:"7px 10px",textTransform:"capitalize"}}>{r.shift}</td>
                    <td style={{padding:"7px 10px"}}>{r.employeeName}</td>
                    <td style={{padding:"7px 10px"}}>{fmt(r.computedExpectedCash)}</td>
                    <td style={{padding:"7px 10px"}}>{fmt(r.actualCash)}</td>
                    <td style={{padding:"7px 10px",fontWeight:700,color:disc<0?"#E74C3C":disc>0?"#27AE60":"#555"}}>
                      {disc>=0?"+":""}{fmt(disc)} {flagged&&"⚠️"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  // ── Tab: Shifts ──
  const ShiftsTab = () => {
    const lunchReports   = reports.filter(r=>r.shift==="lunch");
    const dinnerReports  = reports.filter(r=>r.shift==="dinner");
    const fulldayReports = reports.filter(r=>r.shift==="fullday");

    // Use netTotalSales if available (dinner after deducting lunch), else computedTotalSales
    const netSales = (r) => r.netTotalSales ?? r.computedTotalSales ?? 0;
    const sumNet   = (arr) => arr.reduce((s,r)=>s+netSales(r),0);
    const avgNet   = (arr) => arr.length ? sumNet(arr)/arr.length : 0;
    const avgTips  = (arr) => arr.length ? arr.reduce((s,r)=>s+(r.netTotalTips??r.computedTotalTips??0),0)/arr.length : 0;

    // Daily breakdown: for each day, show lunch % of dinner total
    const byDate = {};
    reports.forEach(r => {
      if (!byDate[r.date]) byDate[r.date] = {lunch:null,dinner:null,fullday:null};
      byDate[r.date][r.shift] = r;
    });

    const dailyBreakdowns = Object.entries(byDate)
      .filter(([,d])=>d.lunch||d.dinner)
      .sort(([a],[b])=>b.localeCompare(a))
      .slice(0,14) // last 14 days
      .map(([date, shifts]) => {
        const dinnerTotal = shifts.dinner ? (shifts.dinner.computedTotalSales||0) : 0;
        const lunchTotal  = shifts.lunch  ? (shifts.lunch.computedTotalSales||0)  : 0;
        const lunchPct    = dinnerTotal > 0 ? Math.round(lunchTotal/dinnerTotal*100) : null;
        const dinnerNet   = shifts.dinner ? netSales(shifts.dinner) : 0;
        return {date, lunchTotal, dinnerNet, dinnerTotal, lunchPct, shifts};
      });

    const shiftData = [
      {label:"🌤 Lunch",    reports:lunchReports,   color:"#F39C12"},
      {label:"🌙 Dinner",   reports:dinnerReports,  color:"#8E44AD"},
      {label:"☀️ Full Day", reports:fulldayReports, color:"#2471A3"},
    ].filter(s=>s.reports.length>0);

    return (
      <div>
        {/* Summary cards */}
        <div style={{display:"flex",gap:10,flexWrap:"wrap",marginBottom:20}}>
          {shiftData.map(s=>(
            <StatCard key={s.label} label={s.label}
              value={fmt(avgNet(s.reports))} sub={`avg net sales . ${s.reports.length} shifts`}/>
          ))}
        </div>

        {/* Daily lunch/dinner breakdown */}
        {dailyBreakdowns.length > 0 && (
          <div style={{marginBottom:24}}>
            <div style={{fontWeight:700,fontSize:14,marginBottom:12}}>
              📅 Daily Shift Breakdown
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {dailyBreakdowns.map(({date,lunchTotal,dinnerNet,dinnerTotal,lunchPct,shifts})=>(
                <div key={date} style={{background:"#fff",borderRadius:12,padding:"12px 16px",
                  border:"1px solid #eee"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                    <div style={{fontWeight:700,fontSize:14}}>
                      {new Date(date+"T12:00:00").toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric"})}
                    </div>
                    {lunchPct !== null && (
                      <div style={{fontSize:12,color:"#888"}}>
                        Total: <strong>{fmt(dinnerTotal)}</strong>
                      </div>
                    )}
                  </div>
                  {lunchPct !== null ? (
                    <div>
                      {/* Split bar */}
                      <div style={{display:"flex",height:8,borderRadius:99,overflow:"hidden",marginBottom:8}}>
                        <div style={{width:`${lunchPct}%`,background:"#F39C12"}}/>
                        <div style={{flex:1,background:"#8E44AD"}}/>
                      </div>
                      <div style={{display:"flex",justifyContent:"space-between",fontSize:12}}>
                        <span style={{color:"#F39C12",fontWeight:700}}>
                          🌤 Lunch {fmt(lunchTotal)} ({lunchPct}%)
                        </span>
                        <span style={{color:"#8E44AD",fontWeight:700}}>
                          🌙 Dinner {fmt(dinnerNet)} ({100-lunchPct}%)
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div style={{fontSize:12,color:"#aaa"}}>
                      {shifts.lunch ? `🌤 Lunch only: ${fmt(lunchTotal)}` :
                       shifts.dinner ? `🌙 Dinner only: ${fmt(dinnerTotal)}` :
                       `☀️ Full day: ${fmt(shifts.fullday?.computedTotalSales||0)}`}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Per-shift stats */}
        <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
          {shiftData.map(s=>(
            <div key={s.label} style={{flex:1,minWidth:160,background:"#f8f8f8",borderRadius:10,padding:"14px 16px"}}>
              <div style={{fontWeight:700,marginBottom:8,color:s.color}}>{s.label}</div>
              <div style={{fontSize:13,color:"#555",display:"flex",flexDirection:"column",gap:4}}>
                <div style={{display:"flex",justifyContent:"space-between"}}><span>Avg Net Sales</span><strong>{fmt(avgNet(s.reports))}</strong></div>
                <div style={{display:"flex",justifyContent:"space-between"}}><span>Avg Tips</span><strong>{fmt(avgTips(s.reports))}</strong></div>
                <div style={{display:"flex",justifyContent:"space-between"}}><span>Total Net Sales</span><strong>{fmt(sumNet(s.reports))}</strong></div>
                <div style={{display:"flex",justifyContent:"space-between"}}><span>Shifts</span><strong>{s.reports.length}</strong></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // ── Tab: Records ──
  const RecordsTab = () => {
    const [search, setSearch] = useState("");
    const [sortBy, setSortBy] = useState("date_desc");
    const [selected, setSelected] = useState(null);

    const sorted = [...reports]
      .filter(r => {
        const q = search.toLowerCase();
        return !q || r.employeeName?.toLowerCase().includes(q) ||
          r.restaurantName?.toLowerCase().includes(q) ||
          r.date?.includes(q) || r.shift?.toLowerCase().includes(q);
      })
      .sort((a,b) => {
        if (sortBy==="date_desc") return new Date(b.date)-new Date(a.date);
        if (sortBy==="date_asc")  return new Date(a.date)-new Date(b.date);
        if (sortBy==="sales_desc") return (b.computedTotalSales||0)-(a.computedTotalSales||0);
        if (sortBy==="disc_desc")  return Math.abs(b.computedDiscrepancy||0)-Math.abs(a.computedDiscrepancy||0);
        return 0;
      });

    const printCard = (r) => {
      const win = window.open("","_blank","width=600,height=800");
      const disc = parseFloat(r.computedDiscrepancy)||0;
      const deposit = Math.max(0, parseFloat(r.computedCashDeposit)||0);
      const flagged = Math.abs(disc)>5;
      win.document.write(`<!DOCTYPE html><html><head><title>Closing Report - ${r.restaurantName} ${r.date}</title>
      <style>
        body{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;margin:0;padding:24px;color:#1a1a1a;max-width:520px}
        .header{background:#1a1a1a;color:#fff;padding:16px 20px;border-radius:10px 10px 0 0;display:flex;justify-content:space-between}
        .section{background:#f9f9f9;border-radius:10px;padding:14px 16px;margin:12px 0}
        .section-title{font-size:10px;font-weight:700;color:#aaa;text-transform:uppercase;letter-spacing:1px;margin-bottom:10px}
        .row{display:flex;justify-content:space-between;font-size:13px;padding:3px 0}
        .row.total{border-top:1px solid #e5e5e5;padding-top:8px;margin-top:4px;font-weight:700}
        .pills{display:flex;gap:8px;margin-top:12px}
        .pill{flex:1;padding:10px 12px;border-radius:8px;text-align:left}
        .pill .label{font-size:10px;font-weight:700;color:#888;margin-bottom:3px}
        .pill .value{font-size:16px;font-weight:800}
        .staff-tag{display:inline-block;background:#e8f5e9;color:#2E7D32;font-size:11px;font-weight:600;border-radius:20px;padding:3px 10px;margin:2px}
        .flag{color:#E74C3C}
        @media print{body{padding:0}}
      </style></head><body>
      <div class="header">
        <div>
          <div style="font-weight:800;font-size:16px">${r.restaurantName||"—"}</div>
          <div style="font-size:12px;color:#aaa;margin-top:2px;text-transform:capitalize">${r.shift} Shift . ${r.date}</div>
        </div>
        <div style="text-align:right">
          <div style="font-size:11px;color:#aaa">Submitted by</div>
          <div style="font-weight:700;font-size:14px">${r.employeeName}</div>
        </div>
      </div>
      <div class="section">
        <div class="section-title">Sales</div>
        <div class="row"><span style="color:#888">Cash</span><span>$${(parseFloat(r.cashSales)||0).toFixed(2)}</span></div>
        <div class="row"><span style="color:#888">Credit Card</span><span>$${(parseFloat(r.creditSales)||0).toFixed(2)}</span></div>
        <div class="row"><span style="color:#888">3rd Party</span><span>$${(parseFloat(r.thirdPartySales)||0).toFixed(2)}</span></div>
        <div class="row"><span style="color:#888">Kiosk</span><span>$${(parseFloat(r.kioskSales)||0).toFixed(2)}</span></div>
        <div class="row total"><span>Total Sales</span><span>$${(parseFloat(r.computedTotalSales)||0).toFixed(2)}</span></div>
        <div class="pills">
          <div class="pill" style="background:${flagged?"#fff0f0":disc>=0?"#f0faf4":"#fff5f5"};border:1px solid ${flagged?"#E74C3C":disc>=0?"#27AE60":"#E74C3C"}">
            <div class="label">DISCREPANCY</div>
            <div class="value ${flagged?"flag":""}" style="color:${flagged?"#E74C3C":disc>=0?"#27AE60":"#E74C3C"}">${disc>=0?"+":""}$${Math.abs(disc).toFixed(2)} ${flagged?"⚠️":""}</div>
          </div>
          <div class="pill" style="background:#f0f8ff;border:1px solid #2471A3">
            <div class="label">CASH DEPOSIT</div>
            <div class="value" style="color:#2471A3">$${deposit.toFixed(2)}</div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="section-title">Tips</div>
        <div class="row"><span style="color:#888">Credit Card Tips</span><span>$${(parseFloat(r.creditTips)||0).toFixed(2)}</span></div>
        <div class="row"><span style="color:#888">Kiosk Tips</span><span>$${(parseFloat(r.kioskTips)||0).toFixed(2)}</span></div>
        <div class="row"><span style="color:#888">3rd Party Tips</span><span>$${(parseFloat(r.thirdPartyTips)||0).toFixed(2)}</span></div>
        <div class="row total"><span>Total Tips</span><span style="color:#27AE60">$${(parseFloat(r.computedTotalTips)||0).toFixed(2)}</span></div>
        ${(r.workingStaff||[]).length>0?`<div class="row"><span style="color:#888">Per Employee (${(r.workingStaff||[]).length})</span><span style="font-weight:700;color:#27AE60">$${(parseFloat(r.computedTipPerEmployee)||0).toFixed(2)}</span></div>`:""}
        ${(r.workingStaff||[]).length>0?`<div style="margin-top:8px">${(r.workingStaff||[]).map(s=>`<span class="staff-tag">${s}</span>`).join("")}</div>`:""}
      </div>
      <div style="font-size:11px;color:#aaa;text-align:center;margin-top:16px">VDumplingHQ . Vanessa's Dumpling House</div>
      <script>window.onload=()=>{window.print();}</script>
      </body></html>`);
      win.document.close();
    };

    const exportExcel = () => {
      const rows = [
        ["CLOSING REPORT"],
        ["Location","Date","Shift","Employee"],
        [],[],
        ["--- SALES ---"],
        ["Cash Sales","Credit Sales","3rd Party Sales","Kiosk Sales","Total Sales","Register Start","Actual Cash","Discrepancy","Cash Deposit"],
        ["--- TIPS ---"],
        ["Credit Tips","Kiosk Tips","3rd Party Tips","Total Tips","Per Employee","Working Staff"],
        [],
        ...sorted.map(r=>[
          r.restaurantName, r.date, r.shift, r.employeeName,
          "", // spacer
          r.cashSales||0, r.creditSales||0, r.thirdPartySales||0, r.kioskSales||0, r.computedTotalSales||0,
          r.registerStart||0, r.actualCash||0, r.computedDiscrepancy||0, r.computedCashDeposit||0,
          r.creditTips||0, r.kioskTips||0, r.thirdPartyTips||0, r.computedTotalTips||0,
          r.computedTipPerEmployee||0, (r.workingStaff||[]).join("; ")
        ])
      ];
      const header = ["Location","Date","Shift","Employee","","Cash Sales","Credit Sales","3rd Party","Kiosk","Total Sales","Reg Start","Actual Cash","Discrepancy","Deposit","Credit Tips","Kiosk Tips","3rd Party Tips","Total Tips","Tip/Employee","Staff"];
      const csv = [header, ...sorted.map(r=>[
        r.restaurantName, r.date, r.shift, r.employeeName,"",
        r.cashSales||0, r.creditSales||0, r.thirdPartySales||0, r.kioskSales||0, r.computedTotalSales||0,
        r.registerStart||0, r.actualCash||0, r.computedDiscrepancy||0, r.computedCashDeposit||0,
        r.creditTips||0, r.kioskTips||0, r.thirdPartyTips||0, r.computedTotalTips||0,
        r.computedTipPerEmployee||0, (r.workingStaff||[]).join("; ")
      ])].map(row=>row.map(c=>`"${String(c).replace(/"/g,'""')}"`).join(",")).join("\n");
      const blob = new Blob([csv],{type:"text/csv"});
      const a = document.createElement("a"); a.href=URL.createObjectURL(blob);
      a.download=`closing-records-${period}.csv`; a.click();
      showToast("Excel CSV downloaded ✓");
    };

    return (
      <div>
        {/* Toolbar */}
        <div style={{display:"flex", gap:10, flexWrap:"wrap", alignItems:"center", marginBottom:18}}>
          <input value={search} onChange={e=>setSearch(e.target.value)}
            placeholder="Search by employee, location, date..."
            style={{flex:1, minWidth:200, border:"1px solid #e5e5e5", borderRadius:9, padding:"8px 14px", fontSize:13}}/>
          <select value={sortBy} onChange={e=>setSortBy(e.target.value)}
            style={{border:"1px solid #e5e5e5", borderRadius:9, padding:"8px 12px", fontSize:13, background:"#fff"}}>
            <option value="date_desc">Newest First</option>
            <option value="date_asc">Oldest First</option>
            <option value="sales_desc">Highest Sales</option>
            <option value="disc_desc">Largest Discrepancy</option>
          </select>
          <button onClick={exportExcel}
            style={{background:"#fff", border:"1px solid #e5e5e5", borderRadius:9, padding:"8px 14px", fontSize:13, fontWeight:600, cursor:"pointer", color:"#555"}}>
            📊 Export Excel
          </button>
        </div>

        {sorted.length === 0 && (
          <div style={{textAlign:"center", padding:60, color:"#ccc", fontSize:14}}>No records match your search</div>
        )}

        {/* Grid of cards */}
        <div style={{display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(320px, 1fr))", gap:16}}>
          {sorted.map(r => (
            <div key={r.id} onClick={()=>setSelected(selected?.id===r.id?null:r)} style={{cursor:"pointer"}}>
              <ClosingReportCard r={r}/>
            </div>
          ))}
        </div>

        {/* Detail modal */}
        {selected && (
          <div style={{position:"fixed", inset:0, background:"rgba(0,0,0,0.6)", zIndex:500,
            display:"flex", alignItems:"center", justifyContent:"center", padding:16}}
            onClick={()=>setSelected(null)}>
            <div style={{background:"#fff", borderRadius:16, maxWidth:500, width:"100%",
              maxHeight:"90vh", overflowY:"auto", boxShadow:"0 20px 60px rgba(0,0,0,0.3)"}}
              onClick={e=>e.stopPropagation()}>
              <div style={{padding:"16px 18px", display:"flex", justifyContent:"space-between", alignItems:"center", borderBottom:"1px solid #f0f0f0"}}>
                <span style={{fontWeight:700, fontSize:15}}>Closing Report</span>
                <div style={{display:"flex", gap:8}}>
                  <button onClick={()=>printCard(selected)}
                    style={{background:"#f0f0f0", border:"none", borderRadius:8, padding:"7px 14px", fontSize:13, fontWeight:600, cursor:"pointer"}}>
                    Print
                  </button>
                  <button onClick={()=>setSelected(null)}
                    style={{background:"#f0f0f0", border:"none", borderRadius:8, padding:"7px 12px", fontSize:16, cursor:"pointer"}}>
                    ✕
                  </button>
                </div>
              </div>
              <div style={{padding:18}}>
                <ClosingReportCard r={selected}/>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:12,marginBottom:20}}>
        <h2 style={{fontSize:24,fontWeight:800,margin:0}}>🧾 Closing Reports</h2>
        <div style={{display:"flex",gap:8}}>
          <button onClick={exportCurrentTab}
            style={{background:"#fff",border:"1px solid #e5e5e5",borderRadius:9,padding:"8px 16px",fontSize:13,fontWeight:600,cursor:"pointer",color:"#555"}}>
            Download Export Tab
          </button>
          <button onClick={exportPackage}
            style={{background:"#1a1a1a",border:"none",borderRadius:9,padding:"8px 16px",fontSize:13,fontWeight:700,cursor:"pointer",color:"#fff"}}>
            📦 Export Package
          </button>
        </div>
      </div>

      {/* Period + Location selectors */}
      <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:20,background:"#f8f8f8",borderRadius:12,padding:"14px 16px"}}>
        <PeriodSelector/>
        <LocationSelector/>
        <div style={{fontSize:12,color:"#aaa"}}>{reports.length} report{reports.length!==1?"s":""} in range</div>
      </div>

      {/* Tabs */}
      <div style={{display:"flex",gap:2,marginBottom:20,overflowX:"auto",paddingBottom:4}}>
        {TABS.map(([k,l])=>(
          <button key={k} onClick={()=>setTab(k)}
            style={{border:"none",borderRadius:9,padding:"8px 16px",fontSize:13,fontWeight:700,cursor:"pointer",whiteSpace:"nowrap",
              background:tab===k?"#1a1a1a":"#f0f0f0",color:tab===k?"#fff":"#555"}}>
            {l}
          </button>
        ))}
      </div>

      {/* No data state */}
      {reports.length===0 && (
        <div style={{textAlign:"center",padding:60,color:"#ccc",fontSize:14}}>
          No closing reports found for this period
        </div>
      )}

      {reports.length>0 && (
        <div>
          {tab==="sales"       && <SalesTab/>}
          {tab==="deposits"    && <DepositsTab/>}
          {tab==="tips"        && <TipsTab/>}
          {tab==="discrepancy" && <DiscrepancyTab/>}
          {tab==="shifts"      && <ShiftsTab/>}
          {tab==="records"     && <RecordsTab/>}
        </div>
      )}
    </div>
  );
}


// ── Editable Invoice Modal ────────────────────────────────────────────────────
function EditableInvoiceModal({ order, restaurants, products, saveProducts, onClose, saveOrders, orders, showToast }) {
  const [editMode, setEditMode] = useState(false);
  const rest = restaurants.find(r => r.id === order.restaurantId);
  const initItems = () => order.items.map(it => {
    const p = products.find(x => x.id === it.productId);
    return {
      productId: it.productId || null,
      name:  it.name  || p?.name  || "Unknown",
      unit:  it.unit  || p?.unit  || "",
      qty:   it.qty,
      price: it.customPrice ?? p?.price ?? 0,
    };
  });

  const [editItems,   setEditItems]   = useState(initItems);
  const [editNote,    setEditNote]    = useState(order.note || "");
  const [approved,    setApproved]    = useState(!!order.invoiceApproval);
  const [approvedBy,  setApprovedBy]  = useState(order.invoiceApproval?.approvedBy || "");
  const [dueDate,     setDueDate]     = useState(order.invoiceDueDate || "");
  const [invoiceNum,  setInvoiceNum]  = useState(order.invoiceNumber || String(order.id));
  const [dirty,       setDirty]       = useState(false);
  const [saving,      setSaving]      = useState(false);

  const mark = () => setDirty(true);

  const subtotal = editItems.reduce((s, it) => s + (parseFloat(it.price)||0) * (parseFloat(it.qty)||0), 0);

  const updateItem = (i, field, val) => {
    setEditItems(prev => prev.map((it, idx) => idx===i ? {...it, [field]: val} : it));
    mark();
  };
  const removeItem = (i) => { setEditItems(prev => prev.filter((_,idx) => idx!==i)); mark(); };
  const addItem    = ()  => { setEditItems(prev => [...prev, {productId:null, name:"", unit:"", qty:1, price:0}]); mark(); };

  const handleSave = async () => {
    setSaving(true);
    const updatedOrder = {
      ...order,
      note: editNote,
      invoiceDueDate: dueDate,
      invoiceNumber: invoiceNum.trim() || String(order.id),
      items: editItems.map(it => ({
        productId: it.productId,
        qty: parseFloat(it.qty)||0,
        customPrice: parseFloat(it.price)||0,
        name: it.name,
        unit: it.unit,
      })),
      invoiceApproval: approved ? {
        approvedBy: approvedBy || "Admin",
        approvedAt: order.invoiceApproval?.approvedAt || new Date().toISOString(),
      } : null,
    };
    const updated = orders.map(o => o.id === order.id ? updatedOrder : o);
    saveOrders(updated);
    setDirty(false);
    setSaving(false);
    showToast("Invoice saved ✓");
  };

  const handlePrint = () => {
    const w = window.open("","_blank","width=900,height=1100");
    if (!w) return;
    const fmtDate = d => new Date(d).toLocaleDateString("en-US",{month:"long",day:"numeric",year:"numeric"});
    const rows = editItems.map((it,i) => `
      <tr style="background:${i%2===0?"#fff":"#f9f9f9"}">
        <td style="padding:10px 12px;font-weight:600">${it.name}</td>
        <td style="padding:10px 12px;color:#888;font-size:12px">${it.unit}</td>
        <td style="padding:10px 12px;text-align:center;font-weight:700">${it.qty}</td>
        <td style="padding:10px 12px;text-align:right">$${parseFloat(it.price).toFixed(2)}</td>
        <td style="padding:10px 12px;text-align:right;font-weight:700">$${(parseFloat(it.price)*parseFloat(it.qty)).toFixed(2)}</td>
      </tr>`).join("");
    w.document.write(`<!DOCTYPE html><html><head><title>Invoice #${order.invoiceNumber||order.id}</title>
      <style>
        *{box-sizing:border-box;margin:0;padding:0}
        body{font-family:Arial,sans-serif;color:#1a1a1a;padding:40px;font-size:13px}
        table{width:100%;border-collapse:collapse}
        th{background:#1a1a1a;color:#fff;padding:10px 12px;text-align:left;font-size:12px;text-transform:uppercase;letter-spacing:.5px}
        @media print{.no-print{display:none}body{padding:20px}}
      </style></head><body>
      <div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:32px">
        <div>
          <div style="font-size:26px;font-weight:800;color:#C0392B;margin-bottom:4px">INVOICE</div>
          <div style="font-size:13px;color:#888">Vanessa's Dumpling House / Central Kitchen</div>
        </div>
        <div style="text-align:right">
          <div style="font-size:18px;font-weight:700">#${order.invoiceNumber||order.id}</div>
          <div style="font-size:12px;color:#888;margin-top:4px">Date: ${fmtDate(order.timestamp)}</div>
          ${dueDate ? `<div style="font-size:12px;color:#C0392B;font-weight:700;margin-top:2px">Due: ${fmtDate(dueDate+"T12:00:00")}</div>` : `<div style="font-size:12px;color:#888;margin-top:2px">Due: Upon Receipt</div>`}
        </div>
      </div>
      <div style="display:flex;gap:40px;margin-bottom:28px">
        <div style="flex:1">
          <div style="font-size:10px;color:#aaa;font-weight:700;text-transform:uppercase;letter-spacing:1px;margin-bottom:6px">Bill To</div>
          <div style="font-weight:700;font-size:15px">${rest?.name || "Unknown"}</div>
          <div style="color:#888;font-size:12px;margin-top:2px">${rest?.managerName || ""}</div>
          <div style="color:#888;font-size:12px">${rest?.managerEmail || ""}</div>
        </div>
        <div style="flex:1">
          <div style="font-size:10px;color:#aaa;font-weight:700;text-transform:uppercase;letter-spacing:1px;margin-bottom:6px">From</div>
          <div style="font-weight:700;font-size:15px">Vanessa's Dumpling House</div>
          <div style="color:#888;font-size:12px;margin-top:2px">Central Kitchen</div>
          <div style="color:#888;font-size:12px">Delivery: ${order.deliveryDate ? fmtDate(order.deliveryDate) : "TBD"}</div>
        </div>
      </div>
      <table style="margin-bottom:20px">
        <thead><tr>
          <th>Item</th><th>Unit</th>
          <th style="text-align:center">Qty</th>
          <th style="text-align:right">Unit Price</th>
          <th style="text-align:right">Total</th>
        </tr></thead>
        <tbody>${rows}</tbody>
      </table>
      <div style="display:flex;justify-content:flex-end;margin-bottom:24px">
        <div style="min-width:220px">
          <div style="display:flex;justify-content:space-between;padding:8px 0;border-bottom:1px solid #eee;color:#888">
            <span>Subtotal</span><span>$${subtotal.toFixed(2)}</span>
          </div>
          <div style="display:flex;justify-content:space-between;padding:10px 0;font-size:17px;font-weight:800;border-top:2px solid #1a1a1a;margin-top:4px">
            <span>Total Due</span><span>$${subtotal.toFixed(2)}</span>
          </div>
        </div>
      </div>
      ${editNote ? `<div style="padding:10px 14px;background:#FFFBF0;border:1px solid #F39C12;border-radius:6px;font-size:12px;color:#856404;margin-bottom:20px">Note: ${editNote}</div>` : ""}
      ${approved ? `
        <div style="margin-top:24px;padding:14px 16px;background:#f0faf4;border:1px solid #27AE60;border-radius:8px">
          <div style="font-size:11px;color:#27AE60;font-weight:700;text-transform:uppercase;letter-spacing:.5px;margin-bottom:4px">✓ Approved</div>
          <div style="font-size:13px;font-weight:600">${approvedBy || "Admin"}</div>
          <div style="font-size:11px;color:#888">${order.invoiceApproval?.approvedAt ? fmtDate(order.invoiceApproval.approvedAt) : fmtDate(new Date())}</div>
        </div>` : `
        <div style="margin-top:32px;border-top:1px solid #ddd;padding-top:12px;display:flex;gap:60px">
          <div><div style="font-size:11px;color:#aaa;margin-bottom:24px">Authorized Signature</div><div style="border-top:1px solid #1a1a1a;width:200px;padding-top:4px;font-size:11px;color:#aaa">Name &amp; Title</div></div>
          <div><div style="font-size:11px;color:#aaa;margin-bottom:24px">Date</div><div style="border-top:1px solid #1a1a1a;width:120px"></div></div>
        </div>`}
      <div style="margin-top:32px;padding-top:12px;border-top:1px solid #eee;font-size:11px;color:#aaa;text-align:center">
        Vanessa's Dumpling House · Thank you for your business
      </div>
      <div class="no-print" style="text-align:center;margin-top:24px">
        <button onclick="window.print()" style="background:#1a1a1a;color:#fff;border:none;padding:12px 28px;border-radius:8px;font-size:14px;font-weight:700;cursor:pointer">🖨 Print / Save as PDF</button>
      </div>
      <script>window.onload=()=>{window.print();}<\/script>
      </body></html>`);
    w.document.close();
  };

  const statusColors = { confirmed:"#2471A3", preparing:"#F39C12", dispatched:"#8E44AD", to_be_delivered:"#27AE60", delivered:"#27AE60", sent:"#aaa", pending:"#aaa", cancelled:"#E74C3C" };
  const status = order.status || "unknown";
  const statusColor = statusColors[status.toLowerCase()] || "#aaa";

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:1000,
      display:"flex",alignItems:"center",justifyContent:"center",padding:16}}
      onClick={onClose}>
      <div style={{background:"#fff",borderRadius:16,width:"100%",maxWidth:720,
        maxHeight:"92vh",overflowY:"auto",display:"flex",flexDirection:"column"}}
        onClick={e=>e.stopPropagation()}>

        {/* Header */}
        <div style={{background:"#C0392B",borderRadius:"16px 16px 0 0",padding:"18px 24px",
          display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0}}>
          <div>
            {editMode ? (
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <span style={{color:"rgba(255,255,255,0.7)",fontSize:16,fontWeight:700}}>Invoice #</span>
                <input
                  value={invoiceNum}
                  onChange={e=>{setInvoiceNum(e.target.value);mark();}}
                  style={{background:"rgba(255,255,255,0.15)",border:"1px solid rgba(255,255,255,0.4)",
                    borderRadius:8,color:"#fff",fontSize:18,fontWeight:800,padding:"3px 10px",
                    fontFamily:"'IBM Plex Sans',sans-serif",width:140}}
                />
              </div>
            ) : (
              <div style={{color:"#fff",fontWeight:800,fontSize:20}}>Invoice #{order.invoiceNumber || order.id}</div>
            )}
            <div style={{color:"rgba(255,255,255,0.7)",fontSize:13,marginTop:2}}>
              {rest?.name} · {new Date(order.timestamp).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"})}
            </div>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <span style={{background:"rgba(255,255,255,0.15)",color:"#fff",borderRadius:20,
              padding:"3px 12px",fontSize:12,fontWeight:700,textTransform:"capitalize"}}>
              {status}
            </span>
            {!editMode && (
              <button onClick={()=>setEditMode(true)}
                style={{background:"rgba(255,255,255,0.2)",border:"1px solid rgba(255,255,255,0.4)",
                  borderRadius:8,color:"#fff",fontSize:12,fontWeight:700,cursor:"pointer",
                  padding:"5px 12px"}}>✏️ Edit</button>
            )}
            {editMode && (
              <button onClick={()=>setEditMode(false)}
                style={{background:"rgba(255,255,255,0.2)",border:"1px solid rgba(255,255,255,0.4)",
                  borderRadius:8,color:"#fff",fontSize:12,fontWeight:700,cursor:"pointer",
                  padding:"5px 12px"}}>👁 View</button>
            )}
            <button onClick={onClose}
              style={{background:"rgba(255,255,255,0.2)",border:"none",borderRadius:8,
                color:"#fff",fontSize:18,fontWeight:700,cursor:"pointer",padding:"4px 10px"}}>✕</button>
          </div>
        </div>

        <div style={{padding:"20px 24px",flex:1}}>

          {/* Due date — edit mode only */}
          {editMode && <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:18}}>
            <label style={{fontSize:12,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:.5,whiteSpace:"nowrap"}}>Due Date</label>
            <input type="date" value={dueDate} onChange={e=>{setDueDate(e.target.value);mark();}}
              style={{border:"1px solid #e5e5e5",borderRadius:8,padding:"6px 10px",fontSize:13,
                fontFamily:"'IBM Plex Sans',sans-serif",color:"#555"}}/>
            <span style={{fontSize:12,color:"#aaa"}}>Leave blank for "Due on Receipt"</span>
          </div>}

          {/* Items table */}
          <div style={{border:"1px solid #e8e8e8",borderRadius:10,overflow:"hidden",marginBottom:16}}>
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
              <thead>
                <tr style={{background:"#f5f5f5"}}>
                  <th style={{padding:"9px 12px",textAlign:"left",fontWeight:700,fontSize:11,color:"#888",textTransform:"uppercase",letterSpacing:.5}}>Item</th>
                  <th style={{padding:"9px 12px",textAlign:"left",fontWeight:700,fontSize:11,color:"#888",textTransform:"uppercase",letterSpacing:.5,width:70}}>Unit</th>
                  <th style={{padding:"9px 12px",textAlign:"center",fontWeight:700,fontSize:11,color:"#888",textTransform:"uppercase",letterSpacing:.5,width:70}}>Qty</th>
                  <th style={{padding:"9px 12px",textAlign:"right",fontWeight:700,fontSize:11,color:"#888",textTransform:"uppercase",letterSpacing:.5,width:100}}>Unit Price</th>
                  <th style={{padding:"9px 12px",textAlign:"right",fontWeight:700,fontSize:11,color:"#888",textTransform:"uppercase",letterSpacing:.5,width:90}}>Total</th>
                  <th style={{width:32}}></th>
                </tr>
              </thead>
              <tbody>
                {editItems.map((it, i) => (
                  <tr key={i} style={{borderTop:"1px solid #f0f0f0",background:i%2===0?"#fff":"#fafafa"}}>
                    <td style={{padding:"6px 8px"}}>
                      {editMode
                        ? <input value={it.name} onChange={e=>updateItem(i,"name",e.target.value)}
                            style={{width:"100%",border:"1px solid transparent",borderRadius:6,padding:"5px 8px",
                              fontSize:13,fontWeight:600,background:"transparent",outline:"none",
                              fontFamily:"'IBM Plex Sans',sans-serif"}}
                            onFocus={e=>e.target.style.borderColor="#2471A3"}
                            onBlur={e=>e.target.style.borderColor="transparent"}/>
                        : <span style={{fontSize:13,fontWeight:600,padding:"5px 8px",display:"block"}}>{it.name}</span>}
                    </td>
                    <td style={{padding:"6px 8px"}}>
                      {editMode
                        ? <input value={it.unit} onChange={e=>updateItem(i,"unit",e.target.value)}
                            style={{width:"100%",border:"1px solid transparent",borderRadius:6,padding:"5px 6px",
                              fontSize:12,color:"#888",background:"transparent",outline:"none",
                              fontFamily:"'IBM Plex Sans',sans-serif"}}
                            onFocus={e=>e.target.style.borderColor="#2471A3"}
                            onBlur={e=>e.target.style.borderColor="transparent"}/>
                        : <span style={{fontSize:12,color:"#888",padding:"5px 6px",display:"block"}}>{it.unit}</span>}
                    </td>
                    <td style={{padding:"6px 8px"}}>
                      {editMode
                        ? <input type="number" min="0" value={it.qty} onChange={e=>updateItem(i,"qty",e.target.value)}
                            style={{width:"100%",border:"1px solid #e5e5e5",borderRadius:6,padding:"5px 6px",
                              fontSize:13,fontWeight:700,textAlign:"center",outline:"none",
                              fontFamily:"'IBM Plex Sans',sans-serif"}}/>
                        : <span style={{display:"block",textAlign:"center",fontWeight:700,fontSize:13}}>{it.qty}</span>}
                    </td>
                    <td style={{padding:"6px 8px"}}>
                      {editMode
                        ? <div style={{display:"flex",alignItems:"center",gap:2}}>
                            <span style={{color:"#aaa",fontSize:12}}>$</span>
                            <input type="number" min="0" step="0.01" value={it.price} onChange={e=>updateItem(i,"price",e.target.value)}
                              style={{width:"100%",border:"1px solid #e5e5e5",borderRadius:6,padding:"5px 6px",
                                fontSize:13,textAlign:"right",outline:"none",
                                fontFamily:"'IBM Plex Sans',sans-serif"}}/>
                          </div>
                        : <span style={{display:"block",textAlign:"right",fontSize:13}}>${parseFloat(it.price).toFixed(2)}</span>}
                    </td>
                    <td style={{padding:"6px 8px",textAlign:"right",fontWeight:700,fontSize:13}}>
                      ${((parseFloat(it.price)||0)*(parseFloat(it.qty)||0)).toFixed(2)}
                    </td>
                    <td style={{padding:"6px 4px",textAlign:"center",minWidth:60}}>
                      {editMode && <div style={{display:"flex",alignItems:"center",gap:4,justifyContent:"center"}}>
                        {!it.productId && saveProducts && it.name.trim() && (
                          <button
                            title="Save to Misc catalog"
                            onClick={()=>{
                              if (products.some(p=>p.name.toLowerCase()===it.name.trim().toLowerCase()&&p.category==="Misc")) {
                                showToast("Already in Misc catalog");
                                return;
                              }
                              const newProduct = {
                                id: Date.now(),
                                name: it.name.trim(),
                                unit: it.unit||"",
                                price: parseFloat(it.price)||null,
                                category: "Misc",
                              };
                              saveProducts([...products, newProduct]);
                              // Also link this item to the new product so it's no longer "custom"
                              updateItem(i, "productId", newProduct.id);
                              showToast(`"${newProduct.name}" saved to Misc ✓`);
                            }}
                            style={{background:"none",border:"1px solid #e0d0ff",borderRadius:5,
                              color:"#8E44AD",fontSize:10,fontWeight:700,cursor:"pointer",
                              padding:"2px 5px",lineHeight:1.4,whiteSpace:"nowrap"}}
                            onMouseEnter={e=>e.currentTarget.style.background="#f5eeff"}
                            onMouseLeave={e=>e.currentTarget.style.background="none"}>
                            + Misc
                          </button>
                        )}
                        <button onClick={()=>removeItem(i)}
                          style={{background:"none",border:"none",color:"#ddd",fontSize:16,
                            cursor:"pointer",lineHeight:1,padding:"2px 4px"}}
                          onMouseEnter={e=>e.target.style.color="#E74C3C"}
                          onMouseLeave={e=>e.target.style.color="#ddd"}>×</button>
                      </div>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div style={{padding:"8px 12px",borderTop:"1px solid #f0f0f0"}}>
              {editMode && (() => {
                const usedIds = new Set(editItems.map(it=>it.productId).filter(Boolean));
                return (
                  <select
                    value=""
                    onChange={e => {
                      const val = e.target.value;
                      if (!val) return;
                      if (val === "custom") {
                        setEditItems(prev => [...prev, {productId:null, name:"", unit:"", qty:1, price:0}]);
                      } else {
                        const p = products.find(x => x.id === parseInt(val));
                        if (!p) return;
                        setEditItems(prev => [...prev, {
                          productId: p.id, name: p.name, unit: p.unit, qty: 1, price: p.price ?? 0
                        }]);
                      }
                      mark();
                    }}
                    style={{border:"1px dashed #ccc",borderRadius:8,padding:"6px 12px",
                      fontSize:12,color:"#555",cursor:"pointer",background:"#fff",
                      fontFamily:"'IBM Plex Sans',sans-serif",width:"100%"}}>
                    <option value="">+ Add item to invoice...</option>
                    {products
                      .filter(p => !usedIds.has(p.id))
                      .map(p => (
                        <option key={p.id} value={p.id}>
                          {p.name} — {p.unit}{p.price != null ? ` ($${p.price.toFixed(2)})` : " (Market)"}
                        </option>
                      ))
                    }
                    <option value="custom">✏️ Add custom line item...</option>
                  </select>
                );
              })()}
            </div>
          </div>

          {/* Subtotal */}
          <div style={{display:"flex",justifyContent:"flex-end",marginBottom:18}}>
            <div style={{minWidth:220}}>
              <div style={{display:"flex",justifyContent:"space-between",padding:"8px 0",
                borderBottom:"1px solid #eee",fontSize:13,color:"#888"}}>
                <span>Subtotal</span><span>${subtotal.toFixed(2)}</span>
              </div>
              <div style={{display:"flex",justifyContent:"space-between",padding:"10px 0",
                fontSize:17,fontWeight:800,borderTop:"2px solid #1a1a1a",marginTop:4}}>
                <span>Total Due</span><span>${subtotal.toFixed(2)}</span>
              </div>
            </div>
          </div>

          {/* Note */}
          <div style={{marginBottom:18}}>
            <label style={{display:"block",fontSize:11,fontWeight:700,color:"#888",
              textTransform:"uppercase",letterSpacing:.5,marginBottom:6}}>Order Note</label>
            {editMode
              ? <textarea value={editNote} onChange={e=>{setEditNote(e.target.value);mark();}}
                  placeholder="Add a note..."
                  style={{width:"100%",border:"1px solid #e5e5e5",borderRadius:8,padding:"10px 12px",
                    fontSize:13,resize:"vertical",minHeight:56,boxSizing:"border-box",
                    fontFamily:"'IBM Plex Sans',sans-serif",outline:"none"}}/>
              : editNote
                ? <div style={{background:"#FFFBF0",border:"1px solid #F39C12",borderRadius:8,
                    padding:"10px 12px",fontSize:13,color:"#856404"}}>{editNote}</div>
                : <div style={{fontSize:13,color:"#ccc",fontStyle:"italic"}}>No note</div>
            }
          </div>

          {/* Approval */}
          <div style={{background:"#f8f8f8",borderRadius:10,padding:"14px 16px",marginBottom:18}}>
            {editMode ? (
              <>
                <label style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer",marginBottom:approved?12:0}}>
                  <input type="checkbox" checked={approved} onChange={e=>{setApproved(e.target.checked);mark();}}
                    style={{width:16,height:16,cursor:"pointer"}}/>
                  <span style={{fontWeight:700,fontSize:14}}>Mark as Approved</span>
                </label>
                {approved && (
                  <div style={{marginTop:10}}>
                    <label style={{fontSize:12,color:"#888",fontWeight:600,display:"block",marginBottom:5}}>Approved by</label>
                    <input value={approvedBy} onChange={e=>{setApprovedBy(e.target.value);mark();}}
                      placeholder="Your name"
                      style={{border:"1px solid #e5e5e5",borderRadius:8,padding:"8px 12px",fontSize:13,
                        width:"100%",boxSizing:"border-box",fontFamily:"'IBM Plex Sans',sans-serif",outline:"none"}}/>
                  </div>
                )}
              </>
            ) : approved ? (
              <div style={{display:"flex",alignItems:"center",gap:10}}>
                <span style={{fontSize:20}}>✅</span>
                <div>
                  <div style={{fontWeight:700,fontSize:14,color:"#27AE60"}}>Approved</div>
                  {approvedBy && <div style={{fontSize:12,color:"#888"}}>{approvedBy}</div>}
                </div>
              </div>
            ) : (
              <div style={{display:"flex",alignItems:"center",gap:10,color:"#aaa"}}>
                <span style={{fontSize:18}}>○</span>
                <span style={{fontSize:13}}>Not yet approved — click ✏️ Edit to approve</span>
              </div>
            )}
          </div>

          {/* Actions */}
          <div style={{display:"flex",gap:10,justifyContent:"flex-end",flexWrap:"wrap"}}>
            <button onClick={onClose}
              style={{border:"1px solid #e5e5e5",borderRadius:10,padding:"11px 20px",
                fontSize:13,fontWeight:600,cursor:"pointer",background:"#fff",color:"#888"}}>
              Close
            </button>
            {editMode && dirty && (
              <button onClick={handleSave} disabled={saving}
                style={{border:"none",borderRadius:10,padding:"11px 20px",
                  fontSize:13,fontWeight:700,cursor:"pointer",
                  background:saving?"#ccc":"#27AE60",color:"#fff"}}>
                {saving ? "Saving…" : "💾 Save Changes"}
              </button>
            )}
            <button onClick={handlePrint}
              style={{border:"none",borderRadius:10,padding:"11px 20px",
                fontSize:13,fontWeight:700,cursor:"pointer",background:"#1a1a1a",color:"#fff"}}>
              🖨 Print Invoice
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Factory Reports ─────────────────────────────────────────────────────────
function KitchenReports({ orders, saveOrders, restaurants, products, saveProducts, showToast }) {
  const [reportType, setReportType]   = useState("invoice");
  const [location,   setLocation]     = useState("all");
  const [year,       setYear]         = useState(new Date().getFullYear());
  const [month,      setMonth]        = useState(new Date().getMonth());
  const [period,     setPeriod]       = useState("full");
  const [customFrom, setCustomFrom]   = useState("");
  const [customTo,   setCustomTo]     = useState("");
  const [invoiceModal, setInvoiceModal] = useState(null);
  const [includeInvoices, setIncludeInvoices] = useState(false);
  const [compareMode, setCompareMode] = useState("none"); // none | prev-period | prev-month | prev-year | custom
  const [compareFrom, setCompareFrom] = useState("");
  const [compareTo,   setCompareTo]   = useState("");

  const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];

  // ── Date filter ──
  const dateRange = () => {
    if (period === "custom") {
      const f = customFrom ? new Date(customFrom+'T00:00:00') : new Date(2020,0,1);
      const t = customTo   ? new Date(customTo  +'T23:59:59') : new Date();
      return { from: f, to: t };
    }
    const y = year, m = month;
    const lastDay = new Date(y, m+1, 0).getDate();
    if (period === "full")   return { from: new Date(y,m,1), to: new Date(y,m,lastDay,23,59,59) };
    if (period === "first")  return { from: new Date(y,m,1), to: new Date(y,m,15,23,59,59) };
    if (period === "second") return { from: new Date(y,m,16), to: new Date(y,m,lastDay,23,59,59) };
  };

  const compareDateRange = () => {
    if (compareMode === "none") return null;
    if (compareMode === "custom") {
      if (!compareFrom || !compareTo) return null;
      return { from: new Date(compareFrom+'T00:00:00'), to: new Date(compareTo+'T23:59:59') };
    }
    const { from, to } = dateRange();
    const spanMs = to - from;
    if (compareMode === "prev-period") {
      const cTo = new Date(from.getTime() - 1000);
      const cFrom = new Date(cTo.getTime() - spanMs);
      return { from: cFrom, to: cTo };
    }
    if (compareMode === "prev-month") {
      const y = year, m = month;
      const pm = m === 0 ? 11 : m - 1;
      const py = m === 0 ? y - 1 : y;
      const lastDay = new Date(py, pm+1, 0).getDate();
      if (period === "full")   return { from: new Date(py,pm,1), to: new Date(py,pm,lastDay,23,59,59) };
      if (period === "first")  return { from: new Date(py,pm,1), to: new Date(py,pm,15,23,59,59) };
      if (period === "second") return { from: new Date(py,pm,16), to: new Date(py,pm,lastDay,23,59,59) };
      // custom: go back same span
      const cTo = new Date(from.getTime() - 1000);
      return { from: new Date(cTo.getTime() - spanMs), to: cTo };
    }
    if (compareMode === "prev-year") {
      return {
        from: new Date(from.getFullYear()-1, from.getMonth(), from.getDate()),
        to:   new Date(to.getFullYear()-1,   to.getMonth(),   to.getDate(), 23, 59, 59),
      };
    }
    return null;
  };

  const validStatuses = ["confirmed","preparing","dispatched","to_be_delivered","delivered","[ok] confirmed","to be delivered","ok confirmed"];

  const filteredOrders = () => {
    const { from, to } = dateRange();
    return orders.filter(o => {
      if (!validStatuses.includes(o.status?.toLowerCase())) return false;
      // Use deliveryDate if set (editable), fall back to submitted timestamp
      const t = new Date(o.deliveryDate || o.timestamp);
      if (t < from || t > to) return false;
      if (location !== "all" && o.restaurantId !== location) return false;
      return true;
    }).sort((a,b) => new Date(a.deliveryDate || a.timestamp) - new Date(b.deliveryDate || b.timestamp));
  };

  const filteredCompareOrders = () => {
    const cr = compareDateRange();
    if (!cr) return [];
    return orders.filter(o => {
      if (!validStatuses.includes(o.status?.toLowerCase())) return false;
      // Use deliveryDate if set (editable), fall back to submitted timestamp
      const t = new Date(o.deliveryDate || o.timestamp);
      if (t < cr.from || t > cr.to) return false;
      if (location !== "all" && o.restaurantId !== location) return false;
      return true;
    }).sort((a,b) => new Date(a.deliveryDate || a.timestamp) - new Date(b.deliveryDate || b.timestamp));
  };

  const comparePeriodLabel = () => {
    const cr = compareDateRange();
    if (!cr) return "";
    const fmt = d => d.toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"});
    return `${fmt(cr.from)} – ${fmt(cr.to)}`;
  };

  const orderTotal = (o) => {
    return o.items.reduce((s, it) => {
      const p = it.productId ? products.find(x=>String(x.id)===String(it.productId)) : null;
      const price = it.customPrice ?? p?.price ?? 0;
      return s + price * it.qty;
    }, 0);
  };

  const periodLabel = () => {
    const { from, to } = dateRange();
    const fmt = d => d.toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"});
    return `${fmt(from)} – ${fmt(to)}`;
  };

  // ── Invoice Report ──
  const InvoiceReport = () => {
    const os = filteredOrders();
    const grandTotal = os.reduce((s,o) => s + orderTotal(o), 0);
    return (
      <div>
        <table style={{width:"100%", borderCollapse:"collapse", fontSize:13}}>
          <thead>
            <tr style={{background:"#1a1a1a", color:"#fff"}}>
              <th style={{padding:"10px 12px", textAlign:"left", fontWeight:700}}>Date</th>
              <th style={{padding:"10px 12px", textAlign:"left", fontWeight:700}}>Location</th>
              <th style={{padding:"10px 12px", textAlign:"left", fontWeight:700}}>Order #</th>
              <th style={{padding:"10px 12px", textAlign:"left", fontWeight:700}}>Items</th>
              <th style={{padding:"10px 12px", textAlign:"right", fontWeight:700}}>Total</th>
            </tr>
          </thead>
          <tbody>
            {os.map((o,i) => {
              const r = restaurants.find(x=>x.id===o.restaurantId);
              const total = orderTotal(o);
              return (
                <tr key={o.id} onClick={()=>setInvoiceModal(o)}
                  style={{background: i%2===0?"#fff":"#f9f9f9", borderBottom:"1px solid #eee",
                    cursor:"pointer"}}
                  onMouseEnter={e=>e.currentTarget.style.background="#f0f8ff"}
                  onMouseLeave={e=>e.currentTarget.style.background=i%2===0?"#fff":"#f9f9f9"}>
                  <td style={{padding:"9px 12px", color:"#555"}}>
                    {new Date(o.deliveryDate || o.timestamp).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"})}
                  </td>
                  <td style={{padding:"9px 12px", fontWeight:600}}>{r?.name||"Unknown"}</td>
                  <td style={{padding:"9px 12px", color:"#aaa", fontSize:11}}>#{o.invoiceNumber||o.id}</td>
                  <td style={{padding:"9px 12px", color:"#888"}}>{o.items.length} items</td>
                  <td style={{padding:"9px 12px", textAlign:"right", fontWeight:700}}>${total.toFixed(2)}</td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr style={{background:"#f0f0f0", borderTop:"2px solid #1a1a1a"}}>
              <td colSpan={4} style={{padding:"11px 12px", fontWeight:700, fontSize:14}}>
                {os.length} order{os.length!==1?"s":""} . {periodLabel()}
              </td>
              <td style={{padding:"11px 12px", textAlign:"right", fontWeight:800, fontSize:16, color:"#C0392B"}}>
                ${grandTotal.toFixed(2)}
              </td>
            </tr>
          </tfoot>
        </table>
        {os.length === 0 && <div style={{textAlign:"center", padding:40, color:"#ccc"}}>No confirmed orders in this period</div>}
      </div>
    );
  };

  // ── Item Sales Report ──
  const ItemReport = () => {
    const os = filteredOrders();
    const itemMap = {};
    os.forEach(o => {
      o.items.forEach(it => {
        const p = it.productId ? products.find(x=>String(x.id)===String(it.productId)) : null;
        const name = it.name || p?.name || "Unknown";
        const key = it.productId || name;
        const price = it.customPrice ?? p?.price ?? 0;
        if (!itemMap[key]) itemMap[key] = { name, zhName: p?.nameZh||"", category: p?.category||"Other", qty:0, revenue:0 };
        itemMap[key].qty += it.qty;
        itemMap[key].revenue += price * it.qty;
      });
    });
    const items = Object.values(itemMap).sort((a,b) => b.qty - a.qty);
    const totalQty = items.reduce((s,i)=>s+i.qty,0);
    const totalRev = items.reduce((s,i)=>s+i.revenue,0);
    return (
      <div>
        <table style={{width:"100%", borderCollapse:"collapse", fontSize:13}}>
          <thead>
            <tr style={{background:"#1a1a1a", color:"#fff"}}>
              <th style={{padding:"10px 12px", textAlign:"left"}}>Item</th>
              <th style={{padding:"10px 12px", textAlign:"left", color:"rgba(255,255,255,0.6)", fontWeight:400}}>中文名</th>
              <th style={{padding:"10px 12px", textAlign:"left", color:"rgba(255,255,255,0.6)", fontWeight:400}}>Category</th>
              <th style={{padding:"10px 12px", textAlign:"right"}}>Qty Sold</th>
              <th style={{padding:"10px 12px", textAlign:"right"}}>Revenue</th>
            </tr>
          </thead>
          <tbody>
            {items.map((it,i) => (
              <tr key={i} style={{background: i%2===0?"#fff":"#f9f9f9", borderBottom:"1px solid #eee"}}>
                <td style={{padding:"9px 12px", fontWeight:600}}>{it.name}</td>
                <td style={{padding:"9px 12px", color:"#888", fontSize:12}}>{it.zhName}</td>
                <td style={{padding:"9px 12px", color:"#aaa", fontSize:11}}>{it.category}</td>
                <td style={{padding:"9px 12px", textAlign:"right", fontWeight:700}}>{it.qty}</td>
                <td style={{padding:"9px 12px", textAlign:"right", fontWeight:600, color:"#27AE60"}}>${it.revenue.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr style={{background:"#f0f0f0", borderTop:"2px solid #1a1a1a"}}>
              <td colSpan={3} style={{padding:"11px 12px", fontWeight:700, fontSize:14}}>
                {items.length} unique item{items.length!==1?"s":""}
              </td>
              <td style={{padding:"11px 12px", textAlign:"right", fontWeight:800, fontSize:15}}>{totalQty}</td>
              <td style={{padding:"11px 12px", textAlign:"right", fontWeight:800, fontSize:15, color:"#C0392B"}}>${totalRev.toFixed(2)}</td>
            </tr>
          </tfoot>
        </table>
        {items.length === 0 && <div style={{textAlign:"center", padding:40, color:"#ccc"}}>No confirmed orders in this period</div>}
      </div>
    );
  };

  // ── Category Report ──
  const CategoryReport = () => {
    const COLORS = ["#C0392B","#2471A3","#27AE60","#E67E22","#8E44AD","#16A085","#F39C12","#2C3E50","#E74C3C","#1ABC9C","#D35400","#7F8C8D"];
    const FACTORY_COLORS = {"Frozen Dumplings":"#C0392B","Meats":"#E67E22","Sauces":"#2471A3","Pancakes":"#F39C12","Vegetables":"#27AE60","Sides and Soups":"#8E44AD"};

    const os = filteredOrders();
    const catMap = {};
    const lbsMap = {}; // factory categories only, by lbs

    os.forEach(o => {
      o.items.forEach(it => {
        const p = it.productId ? products.find(x=>String(x.id)===String(it.productId)) : null;
        const cat = p?.category || (it.added ? "Uncategorized" : "Other");
        const price = it.customPrice ?? p?.price ?? 0;
        if (!catMap[cat]) catMap[cat] = { qty:0, revenue:0 };
        catMap[cat].qty += it.qty;
        catMap[cat].revenue += price * it.qty;

        // Poundage tracking — any product with a weightLbs set
        if (p && p.weightLbs) {
          if (!lbsMap[cat]) lbsMap[cat] = 0;
          lbsMap[cat] += p.weightLbs * it.qty;
        }
      });
    });

    const cats = Object.entries(catMap).sort((a,b) => b[1].revenue - a[1].revenue);
    const totalRev = cats.reduce((s,[,v])=>s+v.revenue,0);
    const totalQty = cats.reduce((s,[,v])=>s+v.qty,0);

    const lbsCats = Object.entries(lbsMap).sort((a,b) => b[1]-a[1]);
    const totalLbs = lbsCats.reduce((s,[,v])=>s+v,0);

    const makePieSlices = (data, total) => {
      const size = 200, cx = 100, cy = 100, r = 85;
      let startAngle = -Math.PI/2;
      return data.map(([cat, val], i) => {
        const pct = val / total;
        const angle = pct * 2 * Math.PI;
        const x1 = cx + r * Math.cos(startAngle);
        const y1 = cy + r * Math.sin(startAngle);
        const x2 = cx + r * Math.cos(startAngle + angle);
        const y2 = cy + r * Math.sin(startAngle + angle);
        const large = angle > Math.PI ? 1 : 0;
        const path = `M ${cx} ${cy} L ${x1} ${y1} A ${r} ${r} 0 ${large} 1 ${x2} ${y2} Z`;
        const midAngle = startAngle + angle/2;
        const lx = cx + (r*0.65) * Math.cos(midAngle);
        const ly = cy + (r*0.65) * Math.sin(midAngle);
        const label = pct > 0.05 ? `${(pct*100).toFixed(0)}%` : "";
        startAngle += angle;
        return { path, color: FACTORY_COLORS[cat] || COLORS[i % COLORS.length], label, lx, ly, cat };
      });
    };

    const PieChart = ({ slices }) => (
      <svg width={200} height={200} viewBox="0 0 200 200">
        {slices.map((s,i) => <path key={i} d={s.path} fill={s.color} stroke="#fff" strokeWidth={1.5}/>)}
        {slices.map((s,i) => s.label ? (
          <text key={i} x={s.lx} y={s.ly} textAnchor="middle" dominantBaseline="middle"
            fontSize={10} fontWeight={700} fill="#fff">{s.label}</text>
        ) : null)}
      </svg>
    );

    const revSlices = totalRev > 0 ? makePieSlices(cats, totalRev) : [];
    const lbsSlices = totalLbs > 0 ? makePieSlices(lbsCats, totalLbs) : [];

    return (
      <div>
        {cats.length === 0
          ? <div style={{textAlign:"center", padding:40, color:"#ccc"}}>No confirmed orders in this period</div>
          : <>
              {/* ── Revenue by Category ── */}
              <div style={{fontWeight:700, fontSize:14, color:"#555", marginBottom:12, letterSpacing:.3}}>Revenue by Category</div>
              <div style={{display:"flex", gap:24, flexWrap:"wrap", alignItems:"flex-start", marginBottom:32}}>
                <div style={{display:"flex", flexDirection:"column", alignItems:"center", gap:12, minWidth:200}}>
                  <PieChart slices={revSlices}/>
                  <div style={{display:"flex", flexDirection:"column", gap:5, width:"100%"}}>
                    {cats.map(([cat],i) => (
                      <div key={cat} style={{display:"flex", alignItems:"center", gap:7, fontSize:12}}>
                        <div style={{width:12, height:12, borderRadius:3, background:FACTORY_COLORS[cat]||COLORS[i%COLORS.length], flexShrink:0}}/>
                        <span style={{color:"#555"}}>{cat}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div style={{flex:1, minWidth:280}}>
                  <table style={{width:"100%", borderCollapse:"collapse", fontSize:13}}>
                    <thead>
                      <tr style={{background:"#1a1a1a", color:"#fff"}}>
                        <th style={{padding:"10px 12px", textAlign:"left"}}>Category</th>
                        <th style={{padding:"10px 12px", textAlign:"right"}}>Qty</th>
                        <th style={{padding:"10px 12px", textAlign:"right"}}>Revenue</th>
                        <th style={{padding:"10px 12px", textAlign:"right"}}>% of Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cats.map(([cat,v],i) => (
                        <tr key={cat} style={{background:i%2===0?"#fff":"#f9f9f9", borderBottom:"1px solid #eee"}}>
                          <td style={{padding:"9px 12px"}}>
                            <div style={{display:"flex", alignItems:"center", gap:7}}>
                              <div style={{width:10, height:10, borderRadius:2, background:FACTORY_COLORS[cat]||COLORS[i%COLORS.length], flexShrink:0}}/>
                              <span style={{fontWeight:600}}>{cat}</span>
                            </div>
                          </td>
                          <td style={{padding:"9px 12px", textAlign:"right"}}>{v.qty}</td>
                          <td style={{padding:"9px 12px", textAlign:"right", color:"#27AE60", fontWeight:600}}>${v.revenue.toFixed(2)}</td>
                          <td style={{padding:"9px 12px", textAlign:"right"}}>
                            <div style={{display:"flex", alignItems:"center", justifyContent:"flex-end", gap:7}}>
                              <div style={{height:6, width:60, background:"#eee", borderRadius:3, overflow:"hidden"}}>
                                <div style={{height:"100%", width:`${(v.revenue/totalRev*100).toFixed(1)}%`,
                                  background:FACTORY_COLORS[cat]||COLORS[i%COLORS.length], borderRadius:3}}/>
                              </div>
                              <span style={{minWidth:38, textAlign:"right"}}>{(v.revenue/totalRev*100).toFixed(1)}%</span>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr style={{background:"#f0f0f0", borderTop:"2px solid #1a1a1a"}}>
                        <td style={{padding:"11px 12px", fontWeight:700}}>Total</td>
                        <td style={{padding:"11px 12px", textAlign:"right", fontWeight:700}}>{totalQty}</td>
                        <td style={{padding:"11px 12px", textAlign:"right", fontWeight:800, color:"#C0392B", fontSize:15}}>${totalRev.toFixed(2)}</td>
                        <td style={{padding:"11px 12px", textAlign:"right", fontWeight:700}}>100%</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>

              {/* ── Poundage by Category ── */}
              <div style={{borderTop:"2px solid #f0f0f0", paddingTop:24}}>
                <div style={{display:"flex", alignItems:"baseline", gap:10, marginBottom:4}}>
                  <div style={{fontWeight:700, fontSize:14, color:"#555", letterSpacing:.3}}>⚖️ Poundage by Category</div>
                  <div style={{fontSize:12, color:"#aaa"}}>All products with lbs/unit set</div>
                </div>
                {totalLbs === 0
                  ? <div style={{padding:"20px 16px", background:"#f8f8f8", borderRadius:10, color:"#aaa", fontSize:13}}>
                      No weight data yet — set lbs/unit for products in <strong>Settings → ⚖️ Weights</strong>.
                    </div>
                  : <div style={{display:"flex", gap:24, flexWrap:"wrap", alignItems:"flex-start"}}>
                      <div style={{display:"flex", flexDirection:"column", alignItems:"center", gap:12, minWidth:200}}>
                        <PieChart slices={lbsSlices}/>
                        <div style={{display:"flex", flexDirection:"column", gap:5, width:"100%"}}>
                          {lbsCats.map(([cat]) => (
                            <div key={cat} style={{display:"flex", alignItems:"center", gap:7, fontSize:12}}>
                              <div style={{width:12, height:12, borderRadius:3, background:FACTORY_COLORS[cat]||"#ccc", flexShrink:0}}/>
                              <span style={{color:"#555"}}>{cat}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div style={{flex:1, minWidth:280}}>
                        <table style={{width:"100%", borderCollapse:"collapse", fontSize:13}}>
                          <thead>
                            <tr style={{background:"#1a1a1a", color:"#fff"}}>
                              <th style={{padding:"10px 12px", textAlign:"left"}}>Category</th>
                              <th style={{padding:"10px 12px", textAlign:"right"}}>Lbs Sold</th>
                              <th style={{padding:"10px 12px", textAlign:"right"}}>% of Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            {lbsCats.map(([cat,lbs],i) => (
                              <tr key={cat} style={{background:i%2===0?"#fff":"#f9f9f9", borderBottom:"1px solid #eee"}}>
                                <td style={{padding:"9px 12px"}}>
                                  <div style={{display:"flex", alignItems:"center", gap:7}}>
                                    <div style={{width:10, height:10, borderRadius:2, background:FACTORY_COLORS[cat]||COLORS[i%COLORS.length], flexShrink:0}}/>
                                    <span style={{fontWeight:600}}>{cat}</span>
                                  </div>
                                </td>
                                <td style={{padding:"9px 12px", textAlign:"right", fontWeight:600}}>{lbs.toFixed(1)} lbs</td>
                                <td style={{padding:"9px 12px", textAlign:"right"}}>
                                  <div style={{display:"flex", alignItems:"center", justifyContent:"flex-end", gap:7}}>
                                    <div style={{height:6, width:60, background:"#eee", borderRadius:3, overflow:"hidden"}}>
                                      <div style={{height:"100%", width:`${(lbs/totalLbs*100).toFixed(1)}%`,
                                        background:FACTORY_COLORS[cat]||COLORS[i%COLORS.length], borderRadius:3}}/>
                                    </div>
                                    <span style={{minWidth:38, textAlign:"right"}}>{(lbs/totalLbs*100).toFixed(1)}%</span>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                          <tfoot>
                            <tr style={{background:"#f0f0f0", borderTop:"2px solid #1a1a1a"}}>
                              <td style={{padding:"11px 12px", fontWeight:700}}>Total</td>
                              <td style={{padding:"11px 12px", textAlign:"right", fontWeight:800, color:"#2471A3", fontSize:15}}>{totalLbs.toFixed(1)} lbs</td>
                              <td style={{padding:"11px 12px", textAlign:"right", fontWeight:700}}>100%</td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                }
              </div>
            </>
        }
      </div>
    );
  };

  // ── Product Mix Report (items × location breakdown) ──
  const ProductMixReport = () => {
    const os = filteredOrders();
    if (os.length === 0) return <div style={{textAlign:"center", padding:40, color:"#ccc"}}>No confirmed orders in this period</div>;

    // Get all locations that appear in these orders
    const locIds = [...new Set(os.map(o => o.restaurantId).filter(Boolean))];
    const locs = locIds.map(id => restaurants.find(r => r.id === id)).filter(Boolean).sort((a,b)=>a.name.localeCompare(b.name));

    // Build: productKey -> { name, category, totalQty, totalRev, byLoc: {locId: {qty, rev}} }
    const itemMap = {};
    os.forEach(o => {
      o.items.forEach(it => {
        const p = it.productId ? products.find(x => x.id === it.productId) : null;
        const key = it.productId || (it.name || "?");
        const name = p?.name || it.name || "?";
        const cat  = p?.category || (it.added ? "Add-Ons" : "Other");
        const price = it.customPrice ?? p?.price ?? 0;
        const qty  = Number(it.qty) || 0;
        if (!itemMap[key]) itemMap[key] = { name, category: cat, totalQty: 0, totalRev: 0, byLoc: {} };
        itemMap[key].totalQty += qty;
        itemMap[key].totalRev += price * qty;
        const lid = o.restaurantId;
        if (lid) {
          if (!itemMap[key].byLoc[lid]) itemMap[key].byLoc[lid] = { qty: 0, rev: 0 };
          itemMap[key].byLoc[lid].qty += qty;
          itemMap[key].byLoc[lid].rev += price * qty;
        }
      });
    });
    const items = Object.values(itemMap).sort((a,b) => b.totalQty - a.totalQty);
    const totalQty = items.reduce((s,i) => s + i.totalQty, 0);
    const totalRev = items.reduce((s,i) => s + i.totalRev, 0);
    const showLocBreakdown = location === "all" && locs.length > 1;

    return (
      <div>
        <div style={{fontSize:12, color:"#888", marginBottom:12, fontStyle:"italic"}}>
          {totalQty} total units shipped across {items.length} product{items.length!==1?"s":""}
          {showLocBreakdown ? ` · ${locs.length} locations` : ""}
        </div>
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%", borderCollapse:"collapse", fontSize:13, minWidth: showLocBreakdown ? 600 : 400}}>
            <thead>
              <tr style={{background:"#1a1a1a", color:"#fff"}}>
                <th style={{padding:"10px 12px", textAlign:"left", fontWeight:700}}>Product</th>
                <th style={{padding:"10px 12px", textAlign:"left", color:"rgba(255,255,255,0.6)", fontWeight:400, fontSize:11}}>Category</th>
                {showLocBreakdown && locs.map(loc => (
                  <th key={loc.id} style={{padding:"10px 8px", textAlign:"right", color:"rgba(255,255,255,0.75)", fontWeight:600, fontSize:11, whiteSpace:"nowrap"}}>
                    {loc.name.length > 14 ? loc.name.slice(0,13)+"…" : loc.name}
                  </th>
                ))}
                <th style={{padding:"10px 12px", textAlign:"right", fontWeight:700}}>Total Units</th>
                <th style={{padding:"10px 12px", textAlign:"right", fontWeight:700}}>Revenue</th>
                <th style={{padding:"10px 12px", textAlign:"right", fontWeight:700}}>% Mix</th>
              </tr>
            </thead>
            <tbody>
              {items.map((it, i) => (
                <tr key={i} style={{background: i%2===0 ? "#fff" : "#f9f9f9", borderBottom:"1px solid #eee"}}>
                  <td style={{padding:"9px 12px", fontWeight:700}}>{it.name}</td>
                  <td style={{padding:"9px 12px", color:"#aaa", fontSize:11}}>{it.category}</td>
                  {showLocBreakdown && locs.map(loc => (
                    <td key={loc.id} style={{padding:"9px 8px", textAlign:"right", fontSize:12, color: it.byLoc[loc.id]?.qty ? "#333" : "#ddd"}}>
                      {it.byLoc[loc.id]?.qty || "—"}
                    </td>
                  ))}
                  <td style={{padding:"9px 12px", textAlign:"right", fontWeight:800, fontSize:15, color:"#1a1a1a"}}>{it.totalQty}</td>
                  <td style={{padding:"9px 12px", textAlign:"right", fontWeight:600, color:"#27AE60"}}>${it.totalRev.toFixed(2)}</td>
                  <td style={{padding:"9px 12px", textAlign:"right"}}>
                    <div style={{display:"flex", alignItems:"center", justifyContent:"flex-end", gap:6}}>
                      <div style={{height:6, width:50, background:"#eee", borderRadius:3, overflow:"hidden"}}>
                        <div style={{height:"100%", width:`${totalQty>0?(it.totalQty/totalQty*100).toFixed(1):0}%`, background:"#C0392B", borderRadius:3}}/>
                      </div>
                      <span style={{minWidth:36, textAlign:"right", color:"#555"}}>{totalQty > 0 ? (it.totalQty/totalQty*100).toFixed(1) : 0}%</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{background:"#f0f0f0", borderTop:"2px solid #1a1a1a"}}>
                <td colSpan={2 + (showLocBreakdown ? locs.length : 0)} style={{padding:"11px 12px", fontWeight:700, fontSize:14}}>
                  {items.length} product{items.length!==1?"s":""}
                </td>
                <td style={{padding:"11px 12px", textAlign:"right", fontWeight:800, fontSize:15}}>{totalQty}</td>
                <td style={{padding:"11px 12px", textAlign:"right", fontWeight:800, fontSize:15, color:"#C0392B"}}>${totalRev.toFixed(2)}</td>
                <td style={{padding:"11px 12px", textAlign:"right", fontWeight:700}}>100%</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    );
  };

  // ── Location Summary Report ──
  const LocationReport = () => {
    const os = filteredOrders();
    if (os.length === 0) return <div style={{textAlign:"center", padding:40, color:"#ccc"}}>No confirmed orders in this period</div>;

    // Build per-location summary
    const locMap = {};
    os.forEach(o => {
      const lid = o.restaurantId || "__unknown__";
      const r = restaurants.find(x => x.id === o.restaurantId);
      const name = r?.name || "Unknown";
      const total = orderTotal(o);
      if (!locMap[lid]) locMap[lid] = { name, orders: 0, revenue: 0, units: 0 };
      locMap[lid].orders += 1;
      locMap[lid].revenue += total;
      o.items.forEach(it => { locMap[lid].units += Number(it.qty) || 0; });
    });
    const locs = Object.values(locMap).sort((a,b) => b.revenue - a.revenue);
    const grandTotal = locs.reduce((s,l) => s + l.revenue, 0);
    const grandOrders = locs.reduce((s,l) => s + l.orders, 0);
    const grandUnits  = locs.reduce((s,l) => s + l.units,  0);

    // Top items per location (inline breakdown)
    const topItemsByLoc = {};
    os.forEach(o => {
      const lid = o.restaurantId || "__unknown__";
      if (!topItemsByLoc[lid]) topItemsByLoc[lid] = {};
      o.items.forEach(it => {
        const p = it.productId ? products.find(x => x.id === it.productId) : null;
        const key = it.productId || (it.name || "?");
        const name = p?.name || it.name || "?";
        if (!topItemsByLoc[lid][key]) topItemsByLoc[lid][key] = { name, qty: 0 };
        topItemsByLoc[lid][key].qty += Number(it.qty) || 0;
      });
    });

    const COLORS = ["#C0392B","#2471A3","#27AE60","#E67E22","#8E44AD","#16A085","#F39C12","#2C3E50","#1ABC9C","#D35400"];

    return (
      <div>
        <div style={{fontSize:12, color:"#888", marginBottom:16, fontStyle:"italic"}}>
          {grandOrders} order{grandOrders!==1?"s":"" } · {grandUnits} units · {locs.length} location{locs.length!==1?"s":""}
        </div>
        {/* Bar chart */}
        {locs.length > 1 && grandTotal > 0 && (
          <div style={{background:"#fafafa", border:"1px solid #eee", borderRadius:12, padding:"16px 20px", marginBottom:20}}>
            <div style={{fontSize:12, fontWeight:700, color:"#555", marginBottom:12}}>Revenue by Location</div>
            {locs.map((loc, i) => (
              <div key={i} style={{marginBottom:10}}>
                <div style={{display:"flex", justifyContent:"space-between", fontSize:12, marginBottom:4}}>
                  <span style={{fontWeight:700, color:"#333"}}>{loc.name}</span>
                  <span style={{color:"#555", fontWeight:600}}>${loc.revenue.toFixed(2)} <span style={{color:"#aaa", fontWeight:400}}>({(loc.revenue/grandTotal*100).toFixed(1)}%)</span></span>
                </div>
                <div style={{height:10, background:"#eee", borderRadius:5, overflow:"hidden"}}>
                  <div style={{height:"100%", width:`${(loc.revenue/grandTotal*100).toFixed(1)}%`, background:COLORS[i%COLORS.length], borderRadius:5, transition:"width 0.3s"}}/>
                </div>
              </div>
            ))}
          </div>
        )}
        {/* Per-location cards */}
        <div style={{display:"flex", flexDirection:"column", gap:14}}>
          {locs.map((loc, i) => {
            const lid = Object.keys(locMap).find(k => locMap[k] === loc);
            const topItems = Object.values(topItemsByLoc[lid]||{}).sort((a,b)=>b.qty-a.qty).slice(0,5);
            return (
              <div key={i} style={{border:"1px solid #e5e5e5", borderRadius:12, overflow:"hidden"}}>
                <div style={{background:COLORS[i%COLORS.length], padding:"12px 16px", display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                  <div style={{fontWeight:800, fontSize:15, color:"#fff"}}>{loc.name}</div>
                  <div style={{fontSize:13, color:"rgba(255,255,255,0.85)", fontWeight:600}}>${loc.revenue.toFixed(2)}</div>
                </div>
                <div style={{padding:"12px 16px", background:"#fff"}}>
                  <div style={{display:"flex", gap:20, marginBottom: topItems.length > 0 ? 12 : 0}}>
                    <div style={{textAlign:"center"}}>
                      <div style={{fontSize:20, fontWeight:800, color:"#1a1a1a"}}>{loc.orders}</div>
                      <div style={{fontSize:11, color:"#aaa", fontWeight:600}}>ORDERS</div>
                    </div>
                    <div style={{textAlign:"center"}}>
                      <div style={{fontSize:20, fontWeight:800, color:"#1a1a1a"}}>{loc.units}</div>
                      <div style={{fontSize:11, color:"#aaa", fontWeight:600}}>UNITS</div>
                    </div>
                    <div style={{textAlign:"center"}}>
                      <div style={{fontSize:20, fontWeight:800, color:"#27AE60"}}>${loc.orders > 0 ? (loc.revenue/loc.orders).toFixed(0) : 0}</div>
                      <div style={{fontSize:11, color:"#aaa", fontWeight:600}}>AVG ORDER</div>
                    </div>
                    <div style={{textAlign:"center"}}>
                      <div style={{fontSize:20, fontWeight:800, color:"#2471A3"}}>{(loc.revenue/grandTotal*100).toFixed(1)}%</div>
                      <div style={{fontSize:11, color:"#aaa", fontWeight:600}}>OF TOTAL</div>
                    </div>
                  </div>
                  {topItems.length > 0 && (
                    <div>
                      <div style={{fontSize:11, fontWeight:700, color:"#aaa", marginBottom:6, textTransform:"uppercase", letterSpacing:"0.05em"}}>Top Items</div>
                      <div style={{display:"flex", flexWrap:"wrap", gap:6}}>
                        {topItems.map((it, j) => (
                          <div key={j} style={{background:"#f5f5f5", borderRadius:6, padding:"4px 10px", fontSize:12, fontWeight:600, color:"#333"}}>
                            {it.name} <span style={{color:"#888", fontWeight:400}}>×{it.qty}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        {/* Summary table */}
        <div style={{marginTop:20}}>
          <table style={{width:"100%", borderCollapse:"collapse", fontSize:13}}>
            <thead>
              <tr style={{background:"#1a1a1a", color:"#fff"}}>
                <th style={{padding:"10px 12px", textAlign:"left", fontWeight:700}}>Location</th>
                <th style={{padding:"10px 12px", textAlign:"right", fontWeight:700}}>Orders</th>
                <th style={{padding:"10px 12px", textAlign:"right", fontWeight:700}}>Units</th>
                <th style={{padding:"10px 12px", textAlign:"right", fontWeight:700}}>Avg Order</th>
                <th style={{padding:"10px 12px", textAlign:"right", fontWeight:700}}>Revenue</th>
                <th style={{padding:"10px 12px", textAlign:"right", fontWeight:700}}>% Share</th>
              </tr>
            </thead>
            <tbody>
              {locs.map((loc, i) => (
                <tr key={i} style={{background: i%2===0 ? "#fff" : "#f9f9f9", borderBottom:"1px solid #eee"}}>
                  <td style={{padding:"9px 12px"}}>
                    <div style={{display:"flex", alignItems:"center", gap:8}}>
                      <div style={{width:10, height:10, borderRadius:2, background:COLORS[i%COLORS.length], flexShrink:0}}/>
                      <span style={{fontWeight:700}}>{loc.name}</span>
                    </div>
                  </td>
                  <td style={{padding:"9px 12px", textAlign:"right"}}>{loc.orders}</td>
                  <td style={{padding:"9px 12px", textAlign:"right"}}>{loc.units}</td>
                  <td style={{padding:"9px 12px", textAlign:"right", color:"#555"}}>${loc.orders > 0 ? (loc.revenue/loc.orders).toFixed(2) : "0.00"}</td>
                  <td style={{padding:"9px 12px", textAlign:"right", fontWeight:700, color:"#27AE60"}}>${loc.revenue.toFixed(2)}</td>
                  <td style={{padding:"9px 12px", textAlign:"right"}}>
                    <div style={{display:"flex", alignItems:"center", justifyContent:"flex-end", gap:6}}>
                      <div style={{height:6, width:50, background:"#eee", borderRadius:3, overflow:"hidden"}}>
                        <div style={{height:"100%", width:`${(loc.revenue/grandTotal*100).toFixed(1)}%`, background:COLORS[i%COLORS.length], borderRadius:3}}/>
                      </div>
                      <span style={{minWidth:40, textAlign:"right", color:"#555"}}>{(loc.revenue/grandTotal*100).toFixed(1)}%</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{background:"#f0f0f0", borderTop:"2px solid #1a1a1a"}}>
                <td style={{padding:"11px 12px", fontWeight:700, fontSize:14}}>All Locations</td>
                <td style={{padding:"11px 12px", textAlign:"right", fontWeight:700}}>{grandOrders}</td>
                <td style={{padding:"11px 12px", textAlign:"right", fontWeight:700}}>{grandUnits}</td>
                <td style={{padding:"11px 12px", textAlign:"right", color:"#555"}}>${grandOrders > 0 ? (grandTotal/grandOrders).toFixed(2) : "0.00"}</td>
                <td style={{padding:"11px 12px", textAlign:"right", fontWeight:800, fontSize:15, color:"#C0392B"}}>${grandTotal.toFixed(2)}</td>
                <td style={{padding:"11px 12px", textAlign:"right", fontWeight:700}}>100%</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    );
  };

  // ── Excel download ──
  const downloadExcel = () => {
    const os = filteredOrders();
    const cos = filteredCompareOrders();
    if (os.length === 0) { showToast("No data to export"); return; }
    const loc = location === "all" ? "All Locations" : (restaurants.find(x=>x.id===location)?.name||"");
    const hasCompare = compareMode !== "none" && cos.length > 0;

    const doExport = (XLSX) => {
      const wb = XLSX.utils.book_new();
      const aggItems = (orders) => {
        const m = {};
        orders.forEach(o => o.items.forEach(it => {
          const p = it.productId ? products.find(x=>String(x.id)===String(it.productId)) : null;
          const k = it.productId||(it.name||"?");
          const price = it.customPrice ?? p?.price ?? 0;
          if (!m[k]) m[k] = {name:it.name||p?.name||"?",cat:p?.category||"Other",qty:0,rev:0};
          m[k].qty += Number(it.qty)||0;
          m[k].rev += price*(Number(it.qty)||0);
        }));
        return Object.values(m).sort((a,b)=>b.qty-a.qty);
      };
      const aggCats = (orders) => {
        const m = {};
        orders.forEach(o => o.items.forEach(it => {
          const p = it.productId ? products.find(x=>String(x.id)===String(it.productId)) : null;
          const k = p?.category||(it.added?"Add-Ons":"Other");
          const price = it.customPrice ?? p?.price ?? 0;
          if (!m[k]) m[k] = {qty:0,rev:0};
          m[k].qty += Number(it.qty)||0;
          m[k].rev += price*(Number(it.qty)||0);
        }));
        return m;
      };
      const types = reportType === "full" ? ["invoice","items","category","mix","location"] : [reportType];
      types.forEach(rType => {
        if (rType === "invoice") {
          const hdr = hasCompare
            ? ["Date","Location","Order #","Revenue","","Compare Date","Compare Loc","Compare Order #","Compare Revenue","Δ Revenue","Δ %"]
            : ["Date","Location","Order #","Items","Revenue"];
          const rows = [hdr];
          const maxLen = Math.max(os.length, cos.length);
          for (let i=0; i<maxLen; i++) {
            const o = os[i]; const c = cos[i];
            const oT = o?orderTotal(o):0; const cT = c?orderTotal(c):0;
            const r = o?restaurants.find(x=>x.id===o.restaurantId):null;
            const cr = c?restaurants.find(x=>x.id===c.restaurantId):null;
            if (hasCompare) rows.push([
              o?new Date(o.timestamp).toLocaleDateString("en-US"):"",r?.name||"",o?`#${o.invoiceNumber||o.id}`:"",oT||"","",
              c?new Date(c.timestamp).toLocaleDateString("en-US"):"",cr?.name||"",c?`#${c.id}`:"",cT||"",
              o&&c?oT-cT:"",o&&c&&cT?`${Math.round((oT-cT)/cT*100)}%`:"",
            ]);
            else { if (!o) break; rows.push([new Date(o.timestamp).toLocaleDateString("en-US"),r?.name||"",`#${o.invoiceNumber||o.id}`,o.items.length,oT]); }
          }
          rows.push([]);
          rows.push(hasCompare
            ? ["TOTAL","","",os.reduce((s,o)=>s+orderTotal(o),0),"","","","",cos.reduce((s,o)=>s+orderTotal(o),0)]
            : ["TOTAL","","",os.length,os.reduce((s,o)=>s+orderTotal(o),0)]);
          XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(rows), "Orders");
        }
        if (rType === "items") {
          const ci = aggItems(os); const pi = hasCompare?aggItems(cos):[];
          const keys = [...new Set([...ci.map(i=>i.name),...pi.map(i=>i.name)])];
          const hdr = hasCompare
            ? ["Item","Category","Curr Qty","Curr Revenue","Prev Qty","Prev Revenue","Δ Qty","Δ Revenue","Δ %"]
            : ["Item","Category","Qty Sold","Revenue"];
          const rows = [hdr];
          keys.forEach(name => {
            const c = ci.find(x=>x.name===name)||{qty:0,rev:0,cat:""};
            const p = pi.find(x=>x.name===name)||{qty:0,rev:0};
            rows.push(hasCompare
              ? [name,c.cat,c.qty,c.rev,p.qty,p.rev,c.qty-p.qty,c.rev-p.rev,p.rev>0?`${Math.round((c.rev-p.rev)/p.rev*100)}%`:"—"]
              : [name,c.cat,c.qty,c.rev]);
          });
          XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(rows), "Items");
        }
        if (rType === "category") {
          const cc = aggCats(os); const pc = hasCompare?aggCats(cos):{};
          const keys = [...new Set([...Object.keys(cc),...Object.keys(pc)])].sort();
          const hdr = hasCompare
            ? ["Category","Curr Qty","Curr Revenue","Prev Qty","Prev Revenue","Δ Qty","Δ Revenue","Δ %"]
            : ["Category","Qty Sold","Revenue"];
          const rows = [hdr];
          keys.forEach(cat => {
            const c = cc[cat]||{qty:0,rev:0}; const p = pc[cat]||{qty:0,rev:0};
            rows.push(hasCompare
              ? [cat,c.qty,c.rev,p.qty,p.rev,c.qty-p.qty,c.rev-p.rev,p.rev>0?`${Math.round((c.rev-p.rev)/p.rev*100)}%`:"—"]
              : [cat,c.qty,c.rev]);
          });
          XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(rows), "Categories");
        }
        if (rType === "mix") {
          // Product mix with per-location columns
          const locIds = [...new Set(os.map(o=>o.restaurantId).filter(Boolean))];
          const locs = locIds.map(id=>restaurants.find(r=>r.id===id)).filter(Boolean).sort((a,b)=>a.name.localeCompare(b.name));
          const itemMap = {};
          os.forEach(o => {
            o.items.forEach(it => {
              const p = it.productId ? products.find(x=>String(x.id)===String(it.productId)) : null;
              const key = it.productId||(it.name||"?");
              const name = p?.name||it.name||"?";
              const cat = p?.category||(it.added?"Add-Ons":"Other");
              const price = it.customPrice ?? p?.price ?? 0;
              const qty = Number(it.qty)||0;
              if (!itemMap[key]) { const byLoc={}; locs.forEach(l=>byLoc[l.id]=0); itemMap[key]={name,cat,totalQty:0,totalRev:0,byLoc}; }
              itemMap[key].totalQty += qty;
              itemMap[key].totalRev += price*qty;
              if (o.restaurantId && itemMap[key].byLoc[o.restaurantId]!==undefined) itemMap[key].byLoc[o.restaurantId] += qty;
            });
          });
          const mixItems = Object.values(itemMap).sort((a,b)=>b.totalQty-a.totalQty);
          const hdr = ["Product","Category",...locs.map(l=>l.name),"Total Units","Revenue","% Mix"];
          const totalQ = mixItems.reduce((s,i)=>s+i.totalQty,0);
          const rows = [hdr];
          mixItems.forEach(it => {
            rows.push([it.name, it.cat, ...locs.map(l=>it.byLoc[l.id]||0), it.totalQty, it.totalRev.toFixed(2),
              totalQ>0?`${(it.totalQty/totalQ*100).toFixed(1)}%`:"0%"]);
          });
          rows.push(["TOTAL","", ...locs.map(l=>mixItems.reduce((s,i)=>s+(i.byLoc[l.id]||0),0)), totalQ, mixItems.reduce((s,i)=>s+i.totalRev,0).toFixed(2),"100%"]);
          XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(rows), "Product Mix");
        }
        if (rType === "location") {
          const locMap = {};
          os.forEach(o => {
            const lid = o.restaurantId||"__unknown__";
            const r = restaurants.find(x=>x.id===o.restaurantId);
            const name = r?.name||"Unknown";
            const total = orderTotal(o);
            if (!locMap[lid]) locMap[lid]={name,orders:0,revenue:0,units:0};
            locMap[lid].orders+=1; locMap[lid].revenue+=total;
            o.items.forEach(it=>{locMap[lid].units+=Number(it.qty)||0;});
          });
          const locs = Object.values(locMap).sort((a,b)=>b.revenue-a.revenue);
          const grandRev = locs.reduce((s,l)=>s+l.revenue,0);
          const hdr = ["Location","Orders","Units","Avg Order Value","Revenue","% of Total"];
          const rows = [hdr];
          locs.forEach(l => {
            rows.push([l.name,l.orders,l.units,l.orders>0?(l.revenue/l.orders).toFixed(2):"0.00",l.revenue.toFixed(2),grandRev>0?`${(l.revenue/grandRev*100).toFixed(1)}%`:"0%"]);
          });
          rows.push(["TOTAL",locs.reduce((s,l)=>s+l.orders,0),locs.reduce((s,l)=>s+l.units,0),"",grandRev.toFixed(2),"100%"]);
          XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(rows), "By Location");
        }
      });
      const fname = `${reportType}-report-${loc.replace(/[^a-z0-9]/gi,"_")}-${periodLabel().replace(/[^a-z0-9]/gi,"_")}`;
      XLSX.writeFile(wb, `${fname}.xlsx`);
      showToast("Downloaded ✓");
    };
    if (window.XLSX) doExport(window.XLSX);
    else { const s=document.createElement("script"); s.src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js"; s.onload=()=>doExport(window.XLSX); document.head.appendChild(s); }
  };

  const callReportAPI = async (mode="download") => {
    const os = filteredOrders();
    if (os.length === 0) { showToast("No data to export"); return; }
    const loc = location === "all" ? "All Locations" : (restaurants.find(x=>x.id===location)?.name||"");
    const label = periodLabel();
    const grandTotal = os.reduce((s,o)=>s+orderTotal(o),0);

    showToast("⏳ Generating PDF…");

    const cos = filteredCompareOrders();
    const hasCompare = compareMode !== "none" && cos.length > 0;

    const buildOrderPayload = (orderList) => orderList.map(o => {
      const r = restaurants.find(x=>x.id===o.restaurantId);
      return {
        id: String(o.id),
        date: new Date(o.timestamp).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}),
        rawTimestamp: o.timestamp,
        restName: r?.name || "Unknown",
        total: orderTotal(o),
        note: o.note || "",
        delivDate: o.deliveryDate ? new Date(o.deliveryDate).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}) : "",
        items: (o.items||[]).map(it => {
          const p = it.productId ? products.find(x=>String(x.id)===String(it.productId)) : null;
          return {
            name: p?.name || it.name || "?",
            cat:  p?.category || "Other",
            qty:  Number(it.qty)||0,
            price: Number(it.customPrice ?? p?.price ?? 0),
            added: !!it.added,
          };
        }),
      };
    });

    const payload = {
      reportType,
      location: loc,
      period: label,
      grandTotal,
      includeInvoices,
      orders: buildOrderPayload(os),
      ...(hasCompare ? {
        compare: {
          period: comparePeriodLabel(),
          grandTotal: cos.reduce((s,o)=>s+orderTotal(o),0),
          orders: buildOrderPayload(cos),
        }
      } : {}),
    };

    try {
      const res = await fetch("/api/generate-report", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const err = await res.json().catch(()=>({}));
        showToast("❌ PDF failed: " + (err.error||res.status));
        return;
      }
      const blob = await res.blob();
      const url  = URL.createObjectURL(blob);
      if (mode === "preview") {
        window.open(url, "_blank");
        showToast("✓ Preview opened");
      } else {
        const a = document.createElement("a");
        a.href = url;
        a.download = `vdh-report-${loc.replace(/[^a-z0-9]/gi,"_")}-${label.replace(/[^a-z0-9]/gi,"_")}.pdf`;
        a.click();
        showToast("✓ PDF downloaded");
      }
      setTimeout(()=>URL.revokeObjectURL(url), 10000);
    } catch(e) {
      showToast("❌ PDF error: " + e.message);
    }
  };

  const printPDF = () => callReportAPI("download");


  const years = Array.from({length:4},(_,i)=>new Date().getFullYear()-i);

  return (
    <div style={{background:"#fff", borderRadius:14, padding:24, boxShadow:"0 2px 14px rgba(0,0,0,0.06)"}}>
      {/* Controls row 1: report type + filters */}
      <div style={{display:"flex", gap:10, flexWrap:"wrap", marginBottom:12, alignItems:"center"}}>
        {/* Report type */}
        <div style={{display:"flex", gap:3, background:"#f0f0f0", borderRadius:9, padding:3}}>
          {[["invoice","📋 Invoice"],["items","📦 Items"],["category","🥟 Category"],["mix","🗺 Product Mix"],["location","📍 By Location"],["full","📑 Full Report"]].map(([v,l])=>(
            <button key={v} onClick={()=>setReportType(v)}
              style={{border:"none", borderRadius:7, padding:"6px 12px", fontSize:12, fontWeight:700, cursor:"pointer",
                background: reportType===v ? "#1a1a1a" : "transparent",
                color: reportType===v ? "#fff" : "#666"}}>
              {l}
            </button>
          ))}
        </div>
        {/* Location */}
        <select value={location} onChange={e=>setLocation(e.target.value==="all"?"all":parseInt(e.target.value))}
          style={{border:"1px solid #e5e5e5", borderRadius:8, padding:"7px 12px", fontSize:13, background:"#fff"}}>
          <option value="all">All Locations</option>
          {restaurants.map(r=><option key={r.id} value={r.id}>{r.name}</option>)}
        </select>
        {/* Month */}
        <select value={month} onChange={e=>setMonth(parseInt(e.target.value))}
          style={{border:"1px solid #e5e5e5", borderRadius:8, padding:"7px 12px", fontSize:13, background:"#fff"}}>
          {MONTHS.map((m,i)=><option key={i} value={i}>{m}</option>)}
        </select>
        {/* Year */}
        <select value={year} onChange={e=>setYear(parseInt(e.target.value))}
          style={{border:"1px solid #e5e5e5", borderRadius:8, padding:"7px 12px", fontSize:13, background:"#fff"}}>
          {years.map(y=><option key={y} value={y}>{y}</option>)}
        </select>
        {/* Period */}
        <div style={{display:"flex", gap:3, background:"#f0f0f0", borderRadius:9, padding:3}}>
          {[["full","Full Month"],["first","1–15"],["second","16–End"],["custom","Custom"]].map(([v,l])=>(
            <button key={v} onClick={()=>setPeriod(v)}
              style={{border:"none", borderRadius:7, padding:"6px 12px", fontSize:12, fontWeight:700, cursor:"pointer",
                background: period===v ? "#1a1a1a" : "transparent",
                color: period===v ? "#fff" : "#666"}}>
              {l}
            </button>
          ))}
        </div>
        {/* Custom date inputs */}
        {period === "custom" && (
          <div style={{display:"flex", gap:6, alignItems:"center"}}>
            <input type="date" value={customFrom} onChange={e=>setCustomFrom(e.target.value)}
              style={{border:"1px solid #e5e5e5", borderRadius:8, padding:"6px 10px", fontSize:12, outline:"none"}}/>
            <span style={{color:"#aaa", fontSize:12}}>to</span>
            <input type="date" value={customTo} onChange={e=>setCustomTo(e.target.value)}
              style={{border:"1px solid #e5e5e5", borderRadius:8, padding:"6px 10px", fontSize:12, outline:"none"}}/>
          </div>
        )}
      </div>

      {/* Controls row 2: compare + downloads */}
      <div style={{display:"flex", gap:10, flexWrap:"wrap", marginBottom:20, alignItems:"center"}}>
        {/* Compare */}
        <div style={{display:"flex", alignItems:"center", gap:8}}>
          <span style={{fontSize:12, fontWeight:700, color:"#555", whiteSpace:"nowrap"}}>📊 Compare to:</span>
          <select value={compareMode} onChange={e=>setCompareMode(e.target.value)}
            style={{border:"1px solid #e5e5e5", borderRadius:8, padding:"7px 12px", fontSize:13, background:"#fff", outline:"none"}}>
            <option value="none">No Comparison</option>
            <option value="prev-period">Previous Period</option>
            <option value="prev-month">Previous Month</option>
            <option value="prev-year">Same Month Last Year</option>
            <option value="custom">Custom Time Period</option>
          </select>
          {compareMode === "custom" && (
            <div style={{display:"flex", gap:6, alignItems:"center"}}>
              <input type="date" value={compareFrom} onChange={e=>setCompareFrom(e.target.value)}
                style={{border:"1px solid #2471A3", borderRadius:8, padding:"6px 10px", fontSize:12, outline:"none"}}/>
              <span style={{color:"#aaa", fontSize:12}}>to</span>
              <input type="date" value={compareTo} onChange={e=>setCompareTo(e.target.value)}
                style={{border:"1px solid #2471A3", borderRadius:8, padding:"6px 10px", fontSize:12, outline:"none"}}/>
            </div>
          )}
        </div>
        {/* Download buttons */}
        <div style={{marginLeft:"auto", display:"flex", gap:8, alignItems:"center", flexWrap:"wrap"}}>
          <label style={{display:"flex", alignItems:"center", gap:6, cursor:"pointer", fontSize:12, fontWeight:600, color:"#555",
            background:"#f5f5f5", border:"1px solid #e5e5e5", borderRadius:8, padding:"6px 10px", userSelect:"none"}}>
            <input type="checkbox" checked={includeInvoices} onChange={e=>setIncludeInvoices(e.target.checked)}
              style={{width:14, height:14, cursor:"pointer"}}/>
            Include invoices
          </label>
          <button onClick={()=>callReportAPI("preview")}
            style={{background:"#fff", color:"#1a1a1a", border:"1.5px solid #1a1a1a", borderRadius:9, padding:"8px 16px", fontSize:13, fontWeight:700, cursor:"pointer"}}>
            👁 Preview
          </button>
          <button onClick={()=>callReportAPI("download")}
            style={{background:"#1a1a1a", color:"#fff", border:"none", borderRadius:9, padding:"8px 16px", fontSize:13, fontWeight:700, cursor:"pointer"}}>
            🖨 Download PDF
          </button>
          <button onClick={downloadExcel}
            style={{background:"#27AE60", color:"#fff", border:"none", borderRadius:9, padding:"8px 16px", fontSize:13, fontWeight:700, cursor:"pointer"}}>
            📊 Excel
          </button>
          <button onClick={() => {
            const os = filteredOrders();
            const grandTotal = os.reduce((s,o) => s + orderTotal(o), 0);
            const loc = location === "all" ? null : restaurants.find(r=>r.id===location);
            const fmtDate = d => new Date(d).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"});
            const fmtLong = d => new Date(d).toLocaleDateString("en-US",{month:"long",day:"numeric",year:"numeric"});
            const cols = location === "all" ? 4 : 3;
            const html = `<!DOCTYPE html>
<html><head><meta charset="utf-8">
<title>Statement — ${loc?loc.name:"All Locations"} — ${periodLabel()}</title>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=IBM+Plex+Sans:wght@300;400;500;600;700&display=swap');
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:'IBM Plex Sans',sans-serif;font-size:13px;color:#1a1a1a;background:#fff}
  /* ── Cover page ── */
  .cover{min-height:100vh;padding:60px 56px;display:flex;flex-direction:column}
  .brand{display:flex;align-items:baseline;gap:10px;margin-bottom:60px}
  .brand-name{font-family:'Playfair Display',serif;font-size:18px;font-weight:700;letter-spacing:.5px;color:#1a1a1a}
  .brand-tag{font-size:11px;font-weight:500;color:#aaa;letter-spacing:1px;text-transform:uppercase}
  .cover-body{flex:1}
  .cover-label{font-size:11px;font-weight:600;letter-spacing:2px;text-transform:uppercase;color:#aaa;margin-bottom:12px}
  .cover-title{font-family:'Playfair Display',serif;font-size:36px;font-weight:700;line-height:1.15;margin-bottom:6px}
  .cover-period{font-size:15px;color:#666;margin-bottom:48px}
  .cover-divider{border:none;border-top:1.5px solid #e5e5e5;margin-bottom:36px}
  .cover-summary{display:flex;gap:48px;margin-bottom:48px}
  .cover-stat .stat-label{font-size:11px;font-weight:600;letter-spacing:1.5px;text-transform:uppercase;color:#aaa;margin-bottom:6px}
  .cover-stat .stat-value{font-size:28px;font-weight:700;color:#1a1a1a}
  .cover-stat .stat-value.red{color:#C0392B}
  /* Cover table */
  .cover-table{width:100%;border-collapse:collapse}
  .cover-table thead tr{border-bottom:2px solid #1a1a1a}
  .cover-table th{font-size:11px;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:#888;padding:0 0 10px;text-align:left}
  .cover-table th.r,.cover-table td.r{text-align:right}
  .cover-table tbody tr{border-bottom:1px solid #f0f0f0}
  .cover-table tbody tr:hover{background:#fafafa}
  .cover-table td{padding:13px 0;font-size:13px;color:#333}
  .cover-table td.num{font-weight:500;color:#888;font-size:12px}
  .cover-table td.total{font-weight:700;color:#1a1a1a}
  .cover-table tfoot tr{border-top:2px solid #1a1a1a}
  .cover-table tfoot td{padding:14px 0;font-weight:700;font-size:14px}
  .cover-table tfoot td.grand{color:#C0392B;font-size:16px;font-weight:800}
  .cover-footer{margin-top:auto;padding-top:40px;border-top:1px solid #f0f0f0;display:flex;justify-content:space-between;align-items:center}
  .cover-footer-left{font-size:12px;color:#aaa;line-height:1.6}
  .cover-footer-right{font-size:11px;color:#ccc}
  /* ── Invoice pages ── */
  .inv-page{padding:36px 56px;page-break-before:always}
  .blank-page{page-break-before:always;page-break-after:always;height:1px}
  .inv-top{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:20px;padding-bottom:16px;border-bottom:2px solid #1a1a1a}
  .inv-top-left .inv-brand{font-family:'Playfair Display',serif;font-size:14px;font-weight:700;color:#aaa;margin-bottom:10px}
  .inv-top-left .inv-title{font-family:'Playfair Display',serif;font-size:26px;font-weight:700;margin-bottom:4px}
  .inv-top-left .inv-loc{font-size:13px;color:#666}
  .inv-top-right{text-align:right}
  .inv-top-right .inv-date{font-size:12px;color:#888;margin-bottom:8px}
  .inv-top-right .inv-amount{font-size:30px;font-weight:800;color:#C0392B}
  .inv-table{width:100%;border-collapse:collapse}
  .inv-table thead tr{border-bottom:2px solid #1a1a1a}
  .inv-table th{font-size:11px;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:#888;padding:0 0 10px;text-align:left}
  .inv-table th.r,.inv-table td.r{text-align:right}
  .inv-table tbody tr{border-bottom:1px solid #f0f0f0}
  .inv-table tbody tr:nth-child(even) td{background:#fafafa}
  .inv-table td{padding:6px 0;font-size:13px;color:#333}
  .inv-table td.item-name{font-weight:500}
  .inv-table td.unit{font-size:11px;color:#aaa;padding-left:6px}
  .inv-table td.mkt{color:#aaa;font-style:italic}
  .inv-table tfoot tr{border-top:2px solid #1a1a1a}
  .inv-table tfoot td{padding:14px 0;font-weight:700;font-size:14px}
  .inv-table tfoot td.grand{color:#C0392B;font-size:16px;font-weight:800}
  .inv-note{margin-top:20px;padding:12px 16px;background:#fffbea;border-left:3px solid #F0B429;border-radius:0 6px 6px 0;font-size:12px;color:#7B6C00}
  .inv-note strong{font-weight:700}
  .inv-footer{margin-top:40px;padding-top:16px;border-top:1px solid #f0f0f0;display:flex;justify-content:space-between;font-size:11px;color:#ccc}
  @media print{
    *{-webkit-print-color-adjust:exact!important;print-color-adjust:exact!important}
    body{background:#fff}
    .inv-page{page-break-before:always}
    .blank-page{page-break-before:always;page-break-after:always;height:1px}
  }
</style></head><body>

<!-- ══ COVER PAGE ══ -->
<div class="cover">
  <div class="brand">
    <span class="brand-name">Vanessa's Dumpling House</span>
    <span class="brand-tag">The Dumpling Factory</span>
  </div>
  <div class="cover-body">
    <div class="cover-label">Invoice Statement</div>
    <div class="cover-title">${loc ? loc.name : "All Locations"}</div>
    <div class="cover-period">${periodLabel()}</div>
    <hr class="cover-divider">
    <div class="cover-summary">
      <div class="cover-stat">
        <div class="stat-label">Invoices</div>
        <div class="stat-value">${os.length}</div>
      </div>
      <div class="cover-stat">
        <div class="stat-label">Total Due</div>
        <div class="stat-value red">$${grandTotal.toFixed(2)}</div>
      </div>
    </div>
    <table class="cover-table">
      <thead><tr>
        <th>Invoice #</th>
        <th>Date</th>
        ${location==="all"?"<th>Location</th>":""}
        <th class="r">Amount</th>
      </tr></thead>
      <tbody>${os.map(o=>{
        const r=restaurants.find(x=>x.id===o.restaurantId);
        return `<tr>
          <td class="num">#${o.invoiceNumber||o.id}</td>
          <td>${fmtDate(o.deliveryDate||o.timestamp)}</td>
          ${location==="all"?`<td>${r?.name||"—"}</td>`:""}
          <td class="r total">$${orderTotal(o).toFixed(2)}</td>
        </tr>`;
      }).join("")}</tbody>
      <tfoot><tr>
        <td colspan="${cols-1}">${os.length} invoice${os.length!==1?"s":""}</td>
        <td class="r grand">$${grandTotal.toFixed(2)}</td>
      </tr></tfoot>
    </table>
  </div>
  <div class="cover-footer">
    <div class="cover-footer-left">
      Vanessa's Dumpling House · The Dumpling Factory<br>
      30-30 47th Ave Suite 135, Long Island City, NY 11101
    </div>
    <div class="cover-footer-right">Generated ${new Date().toLocaleDateString("en-US",{month:"long",day:"numeric",year:"numeric"})}</div>
  </div>
</div>

<!-- ══ BLANK PAGE (keeps cover on its own sheet when duplex printing) ══ -->
<div class="blank-page"></div>

<!-- ══ INDIVIDUAL INVOICES ══ -->
${os.map(o=>{
  const r=restaurants.find(x=>x.id===o.restaurantId);
  const total=orderTotal(o);
  const useChinese=!!(r?.showChinese);
  return `<div class="inv-page">
  <div class="inv-top">
    <div class="inv-top-left">
      <div class="inv-brand">Vanessa's Dumpling House</div>
      <div class="inv-title">Invoice #${o.invoiceNumber||o.id}</div>
      <div class="inv-loc">${r?.name||""}</div>
    </div>
    <div class="inv-top-right">
      <div class="inv-date">${fmtLong(o.deliveryDate||o.timestamp)}</div>
      <div class="inv-amount">$${total.toFixed(2)}</div>
    </div>
  </div>
  <table class="inv-table">
    <thead><tr>
      <th>Item</th>
      <th></th>
      <th class="r">Qty</th>
      <th class="r">Unit Price</th>
      <th class="r">Subtotal</th>
    </tr></thead>
    <tbody>${o.items.map(it=>{
      const p=it.productId!=null?products.find(x=>String(x.id)===String(it.productId)):null;
      const name=p?.name||it.name||"Unknown";
      const nameZh=p?.nameZh||"";
      const unit=it.unit||p?.unit||"";
      const price=it.customPrice??p?.price??null;
      const sub=price!=null?price*it.qty:null;
      return `<tr>
        <td class="item-name">${name}${useChinese&&nameZh?`<br><span style="font-size:11px;color:#888;font-weight:400">${nameZh}</span>`:""}</td>
        <td class="unit">${unit}</td>
        <td class="r">${it.qty}</td>
        <td class="r">${price!=null?`$${price.toFixed(2)}`:`<span class="mkt">Market</span>`}</td>
        <td class="r">${sub!=null?`<strong>$${sub.toFixed(2)}</strong>`:`<span class="mkt">—</span>`}</td>
      </tr>`;
    }).join("")}</tbody>
    <tfoot><tr>
      <td colspan="4" style="text-align:right">Total</td>
      <td class="r grand">$${total.toFixed(2)}</td>
    </tr></tfoot>
  </table>
  ${o.note?`<div class="inv-note"><strong>Note:</strong> ${o.note}</div>`:""}
  <div class="inv-footer">
    <span>Vanessa's Dumpling House · The Dumpling Factory · 30-30 47th Ave Suite 135, LIC NY 11101</span>
    <span>Invoice #${o.invoiceNumber||o.id}</span>
  </div>
</div>`;
}).join("")}

</body></html>`;
            const w = window.open("","_blank");
            w.document.write(html);
            w.document.close();
            w.focus();
            setTimeout(()=>w.print(), 600);
          }}
            style={{background:"#8E44AD", color:"#fff", border:"none", borderRadius:9, padding:"8px 16px", fontSize:13, fontWeight:700, cursor:"pointer"}}>
            🧾 Statement
          </button>
          <button onClick={() => {
            const os = filteredOrders();
            const fmtDate = d => new Date(d).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"});
            const loc = location === "all" ? null : restaurants.find(r=>r.id===location);
            const wb = XLSX.utils.book_new();
            const safeName = s => s.replace(/[:\\\/\?\*\[\]]/g,"").substring(0,31);

            // Summary tab rows (built up as we process invoices)
            const summaryRows = [];
            summaryRows.push(["Vanessa's Dumpling House — Statement Summary"]);
            summaryRows.push([`Period: ${periodLabel()}`]);
            summaryRows.push([loc ? `Location: ${loc.name}` : "All Locations"]);
            summaryRows.push([]);
            summaryRows.push(["Invoice #", "Location", "Date", "# Items", "Total"]);

            // One tab per invoice
            os.forEach(o => {
              const r = restaurants.find(x=>x.id===o.restaurantId);
              const rName = r?.name || "Unknown";
              const total = orderTotal(o);
              const dateStr = fmtDate(o.deliveryDate||o.timestamp);

              // Add to summary
              summaryRows.push([`#${o.invoiceNumber||o.id}`, rName, dateStr, o.items.length, total]);

              // Build invoice sheet
              const rows = [];
              rows.push(["Vanessa's Dumpling House"]);
              rows.push([`Invoice #${o.invoiceNumber||o.id}`]);
              rows.push([rName]);
              rows.push([dateStr]);
              rows.push([]);
              rows.push(["Item", "Chinese Name", "Unit", "Qty", "Unit Price", "Subtotal"]);
              o.items.forEach(it => {
                const p = it.productId!=null ? products.find(x=>String(x.id)===String(it.productId)) : null;
                const iName = p?.name||it.name||"Unknown";
                const nameZh = p?.nameZh||"";
                const unit = it.unit||p?.unit||"";
                const price = it.customPrice??p?.price??null;
                const sub = price!=null ? price*it.qty : null;
                rows.push([iName, nameZh, unit, it.qty, price!=null?price:null, sub!=null?sub:null]);
              });
              rows.push([]);
              rows.push(["", "", "", "", "Total", total]);
              if (o.note) rows.push(["", `Note: ${o.note}`]);

              const ws = XLSX.utils.aoa_to_sheet(rows);
              ws["!cols"] = [{wch:28},{wch:18},{wch:10},{wch:7},{wch:12},{wch:12}];
              XLSX.utils.book_append_sheet(wb, ws, safeName(`Inv #${o.invoiceNumber||o.id}`));
            });

            // Grand total row on summary
            summaryRows.push([]);
            const grand = os.reduce((s,o)=>s+orderTotal(o),0);
            summaryRows.push(["", "", "", "Grand Total", grand]);

            // Insert Summary as the first sheet
            const summaryWs = XLSX.utils.aoa_to_sheet(summaryRows);
            summaryWs["!cols"] = [{wch:12},{wch:22},{wch:14},{wch:10},{wch:12}];
            // book_append_sheet adds to end, so we use sheet_add_aoa trick: just prepend
            XLSX.utils.book_append_sheet(wb, summaryWs, "Summary");
            // Move Summary to front
            wb.SheetNames = ["Summary", ...wb.SheetNames.filter(n=>n!=="Summary")];

            const filename = `Statement_${loc?loc.name.replace(/\s+/g,"_"):"All"}_${periodLabel().replace(/\s+/g,"_")}.xlsx`;
            XLSX.writeFile(wb, filename);
          }}
            style={{background:"#1E8449", color:"#fff", border:"none", borderRadius:9, padding:"8px 16px", fontSize:13, fontWeight:700, cursor:"pointer"}}>
            📥 Statement Excel
          </button>
        </div>
      </div>

      <div style={{fontSize:12, color:"#aaa", marginBottom:14, fontStyle:"italic"}}>
        Showing confirmed & in-progress orders · {periodLabel()}
        {compareMode !== "none" && comparePeriodLabel() && (
          <span style={{color:"#2471A3", marginLeft:8}}>vs {comparePeriodLabel()}</span>
        )}
        {location !== "all" && ` · ${restaurants.find(x=>x.id===location)?.name}`}
      </div>

      {/* ── Main report ── */}
      {reportType === "invoice"  && <InvoiceReport/>}
      {reportType === "items"    && <ItemReport/>}
      {reportType === "category" && <CategoryReport/>}
      {reportType === "mix"      && <ProductMixReport/>}
      {reportType === "location" && <LocationReport/>}
      {reportType === "full"     && <><InvoiceReport/><div style={{height:32}}/><ItemReport/><div style={{height:32}}/><CategoryReport/><div style={{height:32}}/><ProductMixReport/><div style={{height:32}}/><LocationReport/></>}

      {/* ── Compare section ── */}
      {compareMode !== "none" && compareDateRange() && (() => {
        const curr = filteredOrders();
        const prev = filteredCompareOrders();
        const currTotal = curr.reduce((s,o)=>s+orderTotal(o),0);
        const prevTotal = prev.reduce((s,o)=>s+orderTotal(o),0);
        const pct = (curr, prev) => prev===0 ? null : Math.round((curr-prev)/prev*100);
        const delta = (curr, prev) => {
          const p = pct(curr, prev);
          if (p === null) return null;
          return <span style={{fontSize:11,fontWeight:700,color:p>=0?"#27AE60":"#E74C3C",marginLeft:6}}>{p>=0?"▲":"▼"}{Math.abs(p)}%</span>;
        };

        // Item aggregation for both periods
        const aggItems = (os) => {
          const m = {};
          os.forEach(o => o.items.forEach(it => {
            const p = it.productId ? products.find(x=>String(x.id)===String(it.productId)) : null;
            const k = it.productId||(it.name||"?");
            const price = it.customPrice ?? p?.price ?? 0;
            if (!m[k]) m[k] = {name:it.name||p?.name||"?",cat:p?.category||"Other",qty:0,rev:0};
            m[k].qty += Number(it.qty)||0;
            m[k].rev += price*(Number(it.qty)||0);
          }));
          return Object.values(m).sort((a,b)=>b.qty-a.qty);
        };
        const currItems = aggItems(curr);
        const prevItems = aggItems(prev);
        const allItemKeys = [...new Set([...currItems.map(i=>i.name), ...prevItems.map(i=>i.name)])];

        // Category aggregation
        const aggCats = (os) => {
          const m = {};
          os.forEach(o => o.items.forEach(it => {
            const p = it.productId ? products.find(x=>String(x.id)===String(it.productId)) : null;
            const k = p?.category||(it.added?"Add-Ons":"Other");
            const price = it.customPrice ?? p?.price ?? 0;
            if (!m[k]) m[k] = {qty:0,rev:0};
            m[k].qty += Number(it.qty)||0;
            m[k].rev += price*(Number(it.qty)||0);
          }));
          return m;
        };
        const currCats = aggCats(curr);
        const prevCats = aggCats(prev);
        const allCatKeys = [...new Set([...Object.keys(currCats),...Object.keys(prevCats)])];

        const thStyle = {padding:"8px 12px",fontSize:11,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:.5,borderBottom:"2px solid #1a1a1a"};
        const tdStyle = {padding:"8px 12px",borderBottom:"1px solid #f0f0f0"};

        return (
          <div style={{marginTop:32,borderTop:"2px dashed #e5e5e5",paddingTop:28}}>
            <div style={{display:"flex",alignItems:"center",gap:16,marginBottom:20}}>
              <div style={{fontWeight:800,fontSize:16}}>📊 Comparison</div>
              <div style={{fontSize:12,color:"#888"}}>{periodLabel()} vs {comparePeriodLabel()}</div>
            </div>

            {/* KPI comparison cards */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:12,marginBottom:24}}>
              {[
                ["Orders",curr.length,prev.length,"#1a1a1a"],
                ["Revenue",`$${currTotal.toLocaleString("en-US",{minimumFractionDigits:2,maximumFractionDigits:2})}`,`$${prevTotal.toLocaleString("en-US",{minimumFractionDigits:2,maximumFractionDigits:2})}`,
                 "#27AE60",currTotal,prevTotal],
                ["Avg Order",`$${curr.length?Math.round(currTotal/curr.length).toLocaleString():"0"}`,
                 `$${prev.length?Math.round(prevTotal/prev.length).toLocaleString():"0"}`,
                 "#2471A3",curr.length?currTotal/curr.length:0,prev.length?prevTotal/prev.length:0],
              ].map(([label,currVal,prevVal,color,currN,prevN])=>(
                <div key={label} style={{background:"#fff",border:"1px solid #e8e8e8",borderRadius:12,padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
                  <div style={{fontSize:10,color:"#aaa",fontWeight:700,textTransform:"uppercase",letterSpacing:.5,marginBottom:8}}>{label}</div>
                  <div style={{fontWeight:800,fontSize:20,color,marginBottom:4}}>{currVal}
                    {currN!==undefined && delta(currN,prevN)}
                  </div>
                  <div style={{fontSize:11,color:"#bbb"}}>vs {prevVal}</div>
                </div>
              ))}
            </div>

            {/* Items comparison table */}
            <div style={{fontWeight:700,fontSize:14,marginBottom:10}}>Items — Current vs Previous</div>
            <div style={{background:"#fff",border:"1px solid #e8e8e8",borderRadius:12,overflow:"hidden",marginBottom:24}}>
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
                <thead><tr style={{background:"#f8f8f8"}}>
                  <th style={thStyle}>Item</th>
                  <th style={{...thStyle,textAlign:"right"}}>Current Qty</th>
                  <th style={{...thStyle,textAlign:"right"}}>Prev Qty</th>
                  <th style={{...thStyle,textAlign:"right"}}>Δ Qty</th>
                  <th style={{...thStyle,textAlign:"right"}}>Current Rev</th>
                  <th style={{...thStyle,textAlign:"right"}}>Prev Rev</th>
                  <th style={{...thStyle,textAlign:"right"}}>Δ Rev</th>
                </tr></thead>
                <tbody>
                  {allItemKeys.map((name,i)=>{
                    const c = currItems.find(x=>x.name===name)||{qty:0,rev:0};
                    const p = prevItems.find(x=>x.name===name)||{qty:0,rev:0};
                    const dQty = c.qty - p.qty;
                    const dRev = c.rev - p.rev;
                    return (
                      <tr key={name} style={{background:i%2===0?"#fff":"#fafafa"}}>
                        <td style={tdStyle}><strong>{name}</strong></td>
                        <td style={{...tdStyle,textAlign:"right",fontWeight:700}}>{c.qty}</td>
                        <td style={{...tdStyle,textAlign:"right",color:"#aaa"}}>{p.qty}</td>
                        <td style={{...tdStyle,textAlign:"right",fontWeight:700,color:dQty>=0?"#27AE60":"#E74C3C"}}>{dQty>=0?"+":""}{dQty}</td>
                        <td style={{...tdStyle,textAlign:"right",fontWeight:700}}>{c.rev>0?`$${c.rev.toFixed(2)}`:"—"}</td>
                        <td style={{...tdStyle,textAlign:"right",color:"#aaa"}}>{p.rev>0?`$${p.rev.toFixed(2)}`:"—"}</td>
                        <td style={{...tdStyle,textAlign:"right",fontWeight:700,color:dRev>=0?"#27AE60":"#E74C3C"}}>{dRev!==0?(dRev>=0?"+$":"-$")+Math.abs(dRev).toFixed(2):"—"}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Category comparison */}
            <div style={{fontWeight:700,fontSize:14,marginBottom:10}}>Categories — Current vs Previous</div>
            <div style={{background:"#fff",border:"1px solid #e8e8e8",borderRadius:12,overflow:"hidden"}}>
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
                <thead><tr style={{background:"#f8f8f8"}}>
                  <th style={thStyle}>Category</th>
                  <th style={{...thStyle,textAlign:"right"}}>Current Qty</th>
                  <th style={{...thStyle,textAlign:"right"}}>Prev Qty</th>
                  <th style={{...thStyle,textAlign:"right"}}>Δ</th>
                  <th style={{...thStyle,textAlign:"right"}}>Current Rev</th>
                  <th style={{...thStyle,textAlign:"right"}}>Prev Rev</th>
                  <th style={{...thStyle,textAlign:"right"}}>Δ Rev</th>
                </tr></thead>
                <tbody>
                  {allCatKeys.sort().map((cat,i)=>{
                    const c = currCats[cat]||{qty:0,rev:0};
                    const p = prevCats[cat]||{qty:0,rev:0};
                    const dQty = c.qty - p.qty;
                    const dRev = c.rev - p.rev;
                    return (
                      <tr key={cat} style={{background:i%2===0?"#fff":"#fafafa"}}>
                        <td style={tdStyle}><strong>{cat}</strong></td>
                        <td style={{...tdStyle,textAlign:"right",fontWeight:700}}>{c.qty}</td>
                        <td style={{...tdStyle,textAlign:"right",color:"#aaa"}}>{p.qty}</td>
                        <td style={{...tdStyle,textAlign:"right",fontWeight:700,color:dQty>=0?"#27AE60":"#E74C3C"}}>{dQty>=0?"+":""}{dQty}</td>
                        <td style={{...tdStyle,textAlign:"right",fontWeight:700}}>{c.rev>0?`$${c.rev.toFixed(2)}`:"—"}</td>
                        <td style={{...tdStyle,textAlign:"right",color:"#aaa"}}>{p.rev>0?`$${p.rev.toFixed(2)}`:"—"}</td>
                        <td style={{...tdStyle,textAlign:"right",fontWeight:700,color:dRev>=0?"#27AE60":"#E74C3C"}}>{dRev!==0?(dRev>=0?"+$":"-$")+Math.abs(dRev).toFixed(2):"—"}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        );
      })()}

      {/* Invoice modal overlay */}
      {invoiceModal && (
        <EditableInvoiceModal
          order={invoiceModal}
          restaurants={restaurants}
          products={products}
          saveProducts={saveProducts}
          orders={orders}
          saveOrders={saveOrders}
          showToast={showToast}
          onClose={()=>setInvoiceModal(null)}
        />
      )}
    </div>
  );
}
// ── Stock Tab ─────────────────────────────────────────────────────────────────
function StockTab({ products, factoryStock, saveFactoryStock, auth, showToast }) {
  const [subTab, setSubTab]         = useState("current");
  const [form, setForm]             = useState({ productId:"", type:"add", date:"", lotNumber:"", qty:"", note:"" });
  const [expandedProduct, setExpandedProduct] = useState(null);
  const [saving, setSaving]         = useState(false);
  const today = new Date().toISOString().slice(0,10);

  const isPaperGoods = (productId) => {
    const p = products.find(x => x.id === Number(productId));
    return p?.category === "Paper Goods" || p?.category === "Paper Goods / Other";
  };

  // Aggregate stock by product
  const stockByProduct = {};
  factoryStock.forEach(entry => {
    const pid = entry.productId;
    if (!stockByProduct[pid]) stockByProduct[pid] = { total: 0, lots: [] };
    stockByProduct[pid].total += (entry.qtyRemaining || 0);
    if (entry.qtyRemaining > 0) stockByProduct[pid].lots.push(entry);
  });

  // Sort lots FIFO per product
  Object.values(stockByProduct).forEach(s => {
    s.lots.sort((a,b) => {
      if (!a.date && !b.date) return a.id - b.id;
      if (!a.date) return 1; if (!b.date) return -1;
      return a.date < b.date ? -1 : a.date > b.date ? 1 : a.id - b.id;
    });
  });

  // FIFO preview for subtraction
  const fifoPreview = (productId, qty) => {
    const lots = (stockByProduct[Number(productId)]?.lots || []);
    let rem = Number(qty); const result = [];
    for (const lot of lots) {
      if (rem <= 0) break;
      const take = Math.min(lot.qtyRemaining, rem);
      result.push({ ...lot, take });
      rem -= take;
    }
    return { result, shortfall: Math.max(0, rem) };
  };

  const handleSave = () => {
    const { productId, type, date, lotNumber, qty, note, specificLotId, reason } = form;
    if (!productId) { showToast("Select a product"); return; }
    if (!qty || Number(qty) <= 0) { showToast("Enter a quantity greater than 0"); return; }
    if (type === "add" && !isPaperGoods(productId) && !date) { showToast("Enter production date"); return; }
    if (type === "subtract" && !reason) { showToast("Select a reason for this adjustment"); return; }

    setSaving(true);
    const product = products.find(p => p.id === Number(productId));

    if (type === "add" || type === "opening") {
      const entry = {
        id: Date.now(),
        productId: Number(productId),
        productName: product?.name || "Unknown",
        category: product?.category || "",
        date: isPaperGoods(productId) ? null : date,
        lotNumber: lotNumber.trim() || null,
        qtyProduced: Number(qty),
        qtyRemaining: Number(qty),
        type: type === "opening" ? "opening" : "manual_add",
        note: note.trim(),
        createdAt: new Date().toISOString(),
        createdBy: auth?.name || auth?.username || "Admin",
      };
      saveFactoryStock([entry, ...factoryStock]);
      showToast(`✓ Added ${qty} ${product?.unit || ""} ${product?.name}`);
    } else {
      // Subtract — either from a specific lot or FIFO
      if (specificLotId) {
        const lot = factoryStock.find(e => String(e.id) === String(specificLotId));
        if (!lot) { showToast("Lot not found"); setSaving(false); return; }
        if (Number(qty) > lot.qtyRemaining) {
          showToast(`Only ${lot.qtyRemaining} available in this lot`); setSaving(false); return;
        }
        const logEntry = {
          id: Date.now(), productId: Number(productId),
          productName: product?.name || "Unknown", category: product?.category || "",
          date: lot.date, lotNumber: lot.lotNumber,
          qtyProduced: -Number(qty), qtyRemaining: 0,
          type: "manual_subtract",
          reason: reason || "other",
          note: note.trim() || reason || "Manual adjustment",
          createdAt: new Date().toISOString(),
          createdBy: auth?.name || auth?.username || "Admin",
        };
        const updatedStock = factoryStock.map(e =>
          String(e.id) === String(specificLotId)
            ? { ...e, qtyRemaining: e.qtyRemaining - Number(qty) }
            : e
        );
        saveFactoryStock([logEntry, ...updatedStock]);
        showToast(`✓ Removed ${qty} from ${lot.date ? fmtDate(lot.date) : "lot"}`);
      } else {
        // Auto FIFO
        const { result, shortfall } = fifoPreview(productId, qty);
        if (shortfall > 0) { showToast(`Only ${Number(qty)-shortfall} in stock, not enough to subtract ${qty}`); setSaving(false); return; }
        const updatedIds = new Set(result.map(r => r.id));
        const updatedStock = factoryStock.map(entry => {
          if (!updatedIds.has(entry.id)) return entry;
          const change = result.find(r => r.id === entry.id);
          return { ...entry, qtyRemaining: entry.qtyRemaining - change.take };
        });
        const logEntry = {
          id: Date.now(), productId: Number(productId),
          productName: product?.name || "Unknown", category: product?.category || "",
          date: null, lotNumber: null,
          qtyProduced: -Number(qty), qtyRemaining: 0,
          type: "manual_subtract",
          reason: reason || "other",
          note: note.trim() || reason || "Manual adjustment",
          createdAt: new Date().toISOString(),
          createdBy: auth?.name || auth?.username || "Admin",
        };
        saveFactoryStock([logEntry, ...updatedStock]);
        showToast(`✓ Subtracted ${qty} ${product?.unit || ""} ${product?.name} (FIFO)`);
      }
    }
    setForm({ productId:"", type:"add", date:"", lotNumber:"", qty:"", note:"", specificLotId:null, reason:"" });
    setSaving(false);
  };

  const CAT_ORDER = ["Frozen Dumplings","Buns","Doughs","Vegetables","Sauces","Meats","Soup","Sides","Paper Goods","Other"];
  const productsByCategory = {};
  products.forEach(p => {
    const cat = p.category || "Other";
    if (!productsByCategory[cat]) productsByCategory[cat] = [];
    productsByCategory[cat].push(p);
  });
  const cats = [...CAT_ORDER.filter(c => productsByCategory[c]), ...Object.keys(productsByCategory).filter(c => !CAT_ORDER.includes(c) && productsByCategory[c])];

  const fmtDate = (d) => d ? new Date(d + "T12:00:00").toLocaleDateString("en-US", { month:"short", day:"numeric", year:"numeric" }) : "—";
  const inputStyle = { border:"1px solid #e5e5e5", borderRadius:8, padding:"8px 12px", fontSize:13, fontFamily:"'IBM Plex Sans',sans-serif", outline:"none", width:"100%", boxSizing:"border-box" };

  return (
    <div style={{ padding:"20px 24px" }}>
      {/* Sub-tabs */}
      <div style={{ display:"flex", gap:8, marginBottom:20 }}>
        {[["current","📦 Current Stock"],["adjust","➕ Add / Adjust"],["history","📋 History"]].map(([k,l]) => (
          <button key={k} onClick={() => setSubTab(k)}
            style={{ border:"none", borderRadius:9, padding:"8px 18px", fontSize:13, fontWeight:700, cursor:"pointer",
              background: subTab===k ? "#1a1a1a" : "#f0f0f0", color: subTab===k ? "#fff" : "#555" }}>
            {l}
          </button>
        ))}
      </div>

      {/* ── CURRENT STOCK ── */}
      {subTab === "current" && (
        <div>
          <div style={{ fontSize:12, color:"#888", marginBottom:16 }}>
            Live factory stock — updated as production is logged. Click a product to see lot breakdown.
          </div>
          {cats.map(cat => {
            const catProducts = (productsByCategory[cat] || []).filter(p => stockByProduct[p.id]);
            if (!catProducts.length) return null;
            return (
              <div key={cat} style={{ marginBottom:20 }}>
                <div style={{ fontWeight:900, fontSize:11, textTransform:"uppercase", letterSpacing:1, color:"#888", marginBottom:8, borderBottom:"2px solid #1a1a1a", paddingBottom:4 }}>{cat}</div>
                {catProducts.map(p => {
                  const stock = stockByProduct[p.id] || { total:0, lots:[] };
                  const isExpanded = expandedProduct === p.id;
                  const isLow = stock.total > 0 && stock.total < 20;
                  const isOut = stock.total === 0;
                  return (
                    <div key={p.id} style={{ marginBottom:6 }}>
                      <div onClick={() => setExpandedProduct(isExpanded ? null : p.id)}
                        style={{ display:"flex", alignItems:"center", gap:12, padding:"10px 14px",
                          background: isOut ? "#fff5f5" : isLow ? "#fff5f5" : "#fff",
                          border: `1px solid ${isOut ? "#ffcccc" : isLow ? "#E74C3C" : "#e8e8e8"}`,
                          borderRadius: isExpanded ? "10px 10px 0 0" : 10, cursor:"pointer" }}>
                        <div style={{ flex:1 }}>
                          <div style={{ fontWeight:700, fontSize:14 }}>{p.name}</div>
                          <div style={{ fontSize:11, color:"#aaa" }}>{p.unit}</div>
                        </div>
                        <div style={{ textAlign:"right" }}>
                          <div style={{ fontWeight:900, fontSize:18, color: isOut ? "#E74C3C" : isLow ? "#E74C3C" : "#1a1a1a" }}>
                            {stock.total}
                          </div>
                          {isOut && <div style={{ fontSize:10, color:"#E74C3C", fontWeight:700 }}>OUT OF STOCK</div>}
                          {isLow && !isOut && <div style={{ fontSize:10, color:"#E74C3C", fontWeight:700 }}>⚠️ LOW — REORDER</div>}
                        </div>
                        <div style={{ color:"#ccc", fontSize:12 }}>{isExpanded ? "▲" : "▼"}</div>
                      </div>
                      {isExpanded && (
                        <div style={{ border:"1px solid #e8e8e8", borderTop:"none", borderRadius:"0 0 10px 10px", overflow:"hidden" }}>
                          {stock.lots.length === 0
                            ? <div style={{ padding:"12px 16px", color:"#aaa", fontSize:13 }}>No active lots</div>
                            : stock.lots.map((lot, i) => (
                              <div key={lot.id} style={{ display:"flex", alignItems:"center", gap:12, padding:"8px 16px",
                                background: i % 2 === 0 ? "#fafafa" : "#fff", borderTop: i > 0 ? "1px solid #f0f0f0" : "none" }}>
                                <div style={{ flex:1 }}>
                                  <div style={{ fontSize:12, fontWeight:700, color:"#2471A3" }}>
                                    {lot.date ? fmtDate(lot.date) : "No date"}
                                    {lot.lotNumber && <span style={{ marginLeft:8, color:"#888" }}>Lot: {lot.lotNumber}</span>}
                                  </div>
                                  <div style={{ fontSize:11, color:"#aaa" }}>
                                    {lot.type === "opening" ? "Opening inventory" : lot.type === "manual_add" ? "Manual add" : "Production"}
                                    {lot.createdBy && ` · ${lot.createdBy}`}
                                  </div>
                                </div>
                                <div style={{ fontWeight:800, fontSize:15 }}>{lot.qtyRemaining}</div>
                                <div style={{ fontSize:11, color:"#aaa" }}>
                                  {lot.qtyProduced > 0 && `of ${lot.qtyProduced}`}
                                </div>
                              </div>
                            ))
                          }
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })}
          {Object.keys(stockByProduct).length === 0 && (
            <div style={{ textAlign:"center", padding:40, color:"#aaa" }}>
              <div style={{ fontSize:32, marginBottom:12 }}>📦</div>
              <div style={{ fontWeight:700 }}>No stock entries yet</div>
              <div style={{ fontSize:13, marginTop:6 }}>Use "Add / Adjust" to enter opening inventory</div>
            </div>
          )}
        </div>
      )}

      {/* ── ADD / ADJUST ── */}
      {subTab === "adjust" && (
        <div style={{ maxWidth:520 }}>
          <div style={{ fontSize:12, color:"#888", marginBottom:20 }}>
            Add opening inventory, record a new production batch, or manually adjust stock.
          </div>

          {/* Type selector */}
          <div style={{ marginBottom:16 }}>
            <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:.5, marginBottom:8 }}>Type</label>
            <div style={{ display:"flex", gap:8 }}>
              {[["opening","📥 Opening Inv."],["add","➕ Add / Production"],["subtract","➖ Subtract"]].map(([k,l]) => (
                <button key={k} onClick={() => setForm(f => ({...f, type:k}))}
                  style={{ flex:1, border:`2px solid ${form.type===k ? "#1a1a1a" : "#e5e5e5"}`, borderRadius:10, padding:"10px 6px",
                    fontSize:12, fontWeight:700, cursor:"pointer", background: form.type===k ? "#1a1a1a" : "#fff",
                    color: form.type===k ? "#fff" : "#555" }}>
                  {l}
                </button>
              ))}
            </div>
          </div>

          {/* Product */}
          <div style={{ marginBottom:16 }}>
            <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:.5, marginBottom:6 }}>Product</label>
            <select value={form.productId} onChange={e => setForm(f => ({...f, productId:e.target.value, date:"", lotNumber:""}))}
              style={{ ...inputStyle }}>
              <option value="">Select a product...</option>
              {cats.map(cat => (
                <optgroup key={cat} label={cat}>
                  {(productsByCategory[cat]||[]).map(p => (
                    <option key={p.id} value={p.id}>{p.name} ({p.unit})</option>
                  ))}
                </optgroup>
              ))}
            </select>
          </div>

          {/* Date — hidden for Paper Goods */}
          {form.productId && !isPaperGoods(form.productId) && form.type !== "subtract" && (
            <div style={{ marginBottom:16 }}>
              <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:.5, marginBottom:6 }}>
                {form.type === "opening" ? "Date Made" : "Production Date"} <span style={{ color:"#E74C3C" }}>*</span>
              </label>
              <input type="date" value={form.date} max={today}
                onChange={e => setForm(f => ({...f, date:e.target.value}))}
                style={{ ...inputStyle, width:"auto" }}/>
            </div>
          )}

          {/* Lot number */}
          {form.productId && form.type !== "subtract" && (
            <div style={{ marginBottom:16 }}>
              <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:.5, marginBottom:6 }}>Lot Number <span style={{ color:"#aaa", fontWeight:400 }}>(optional)</span></label>
              <input type="text" value={form.lotNumber} placeholder="e.g. A-001"
                onChange={e => setForm(f => ({...f, lotNumber:e.target.value}))}
                style={{ ...inputStyle }}/>
            </div>
          )}

          {/* Quantity */}
          <div style={{ marginBottom:16 }}>
            <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:.5, marginBottom:6 }}>Quantity <span style={{ color:"#E74C3C" }}>*</span></label>
            <input type="number" min="0.5" step="0.5" value={form.qty} placeholder="0"
              onChange={e => setForm(f => ({...f, qty:e.target.value}))}
              style={{ ...inputStyle, width:120 }}/>
            {form.productId && <span style={{ fontSize:12, color:"#888", marginLeft:8 }}>{products.find(p=>p.id===Number(form.productId))?.unit}</span>}
          </div>

          {/* Specific lot selector for subtract */}
          {form.type === "subtract" && form.productId && (() => {
            const lots = stockByProduct[Number(form.productId)]?.lots || [];
            if (!lots.length) return null;
            return (
              <div style={{ marginBottom:16 }}>
                <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:.5, marginBottom:6 }}>
                  Subtract From <span style={{ color:"#aaa", fontWeight:400 }}>(leave blank for automatic FIFO)</span>
                </label>
                <select value={form.specificLotId||""} onChange={e => setForm(f => ({...f, specificLotId:e.target.value||null}))}
                  style={{ ...inputStyle }}>
                  <option value="">Auto (FIFO — oldest first)</option>
                  {lots.map(lot => (
                    <option key={lot.id} value={lot.id}>
                      {lot.date ? fmtDate(lot.date) : "No date"}{lot.lotNumber ? ` · Lot ${lot.lotNumber}` : ""} — {lot.qtyRemaining} remaining
                    </option>
                  ))}
                </select>
              </div>
            );
          })()}

          {/* Reason for subtract */}
          {form.type === "subtract" && form.productId && (
            <div style={{ marginBottom:16 }}>
              <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:.5, marginBottom:6 }}>Reason</label>
              <select value={form.reason||""} onChange={e => setForm(f => ({...f, reason:e.target.value}))}
                style={{ ...inputStyle }}>
                <option value="">Select reason...</option>
                <option value="sample">🎁 Sample</option>
                <option value="outside_order">📦 Outside Order</option>
                <option value="waste">🗑 Waste / Spoilage</option>
                <option value="correction">✏️ Inventory Correction</option>
                <option value="other">Other</option>
              </select>
            </div>
          )}
          {form.type === "subtract" && form.productId && Number(form.qty) > 0 && !form.specificLotId && (() => {
            const { result, shortfall } = fifoPreview(form.productId, form.qty);
            return (
              <div style={{ marginBottom:16, background:"#f8f8f8", borderRadius:10, padding:"12px 16px" }}>
                <div style={{ fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:.5, marginBottom:8 }}>FIFO Breakdown</div>
                {result.map((r,i) => (
                  <div key={i} style={{ display:"flex", justifyContent:"space-between", fontSize:13, padding:"3px 0" }}>
                    <span>{r.date ? fmtDate(r.date) : "No date"}{r.lotNumber ? ` · Lot ${r.lotNumber}` : ""}</span>
                    <span style={{ fontWeight:700 }}>−{r.take}</span>
                  </div>
                ))}
                {shortfall > 0 && <div style={{ color:"#E74C3C", fontWeight:700, fontSize:13, marginTop:6 }}>⚠️ Insufficient stock — {shortfall} units short</div>}
              </div>
            );
          })()}

          {/* Note */}
          <div style={{ marginBottom:20 }}>
            <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:.5, marginBottom:6 }}>Note <span style={{ color:"#aaa", fontWeight:400 }}>(optional)</span></label>
            <textarea value={form.note} rows={2} placeholder="e.g. Outside order, holiday batch..."
              onChange={e => setForm(f => ({...f, note:e.target.value}))}
              style={{ ...inputStyle, resize:"vertical", minHeight:60 }}/>
          </div>

          <button onClick={handleSave} disabled={saving}
            style={{ background: saving ? "#ccc" : "#1a1a1a", color:"#fff", border:"none", borderRadius:12, padding:"13px 28px",
              fontSize:14, fontWeight:700, cursor: saving ? "not-allowed" : "pointer" }}>
            {saving ? "Saving..." : form.type === "subtract" ? "➖ Subtract Stock" : form.type === "opening" ? "📥 Save Opening Inventory" : "➕ Add Stock"}
          </button>
        </div>
      )}

      {/* ── HISTORY ── */}
      {subTab === "history" && (
        <div>
          <div style={{ fontSize:12, color:"#888", marginBottom:16 }}>All stock entries — adds, subtracts, and opening inventory.</div>
          {factoryStock.length === 0
            ? <div style={{ textAlign:"center", padding:40, color:"#aaa" }}>No entries yet</div>
            : [...factoryStock].sort((a,b) => b.id - a.id).map(entry => {
              const isSubtract = entry.type === "manual_subtract";
              const product = products.find(p => p.id === entry.productId);
              return (
                <div key={entry.id} style={{ display:"flex", alignItems:"center", gap:12, padding:"10px 14px",
                  background:"#fff", border:"1px solid #f0f0f0", borderRadius:10, marginBottom:6 }}>
                  <div style={{ width:6, height:40, borderRadius:3, flexShrink:0,
                    background: isSubtract ? "#E74C3C" : entry.type==="opening" ? "#2471A3" : "#27AE60" }}/>
                  <div style={{ flex:1 }}>
                    <div style={{ fontWeight:700, fontSize:13 }}>{entry.productName || product?.name || "Unknown"}</div>
                    <div style={{ fontSize:11, color:"#888" }}>
                      {entry.date ? fmtDate(entry.date) : "No date"}
                      {entry.lotNumber && ` · Lot: ${entry.lotNumber}`}
                      {" · "}{entry.type === "opening" ? "Opening inventory" : entry.type === "manual_subtract" ? "Manual subtract" : entry.type === "manual_add" ? "Manual add" : "Production"}
                      {entry.createdBy && ` · ${entry.createdBy}`}
                    </div>
                    {entry.note && <div style={{ fontSize:11, color:"#F39C12", marginTop:2 }}>{entry.note}</div>}
                  </div>
                  <div style={{ textAlign:"right" }}>
                    <div style={{ fontWeight:900, fontSize:16, color: isSubtract ? "#E74C3C" : "#27AE60" }}>
                      {isSubtract ? "−" : "+"}{Math.abs(entry.qtyProduced)}
                    </div>
                    {!isSubtract && entry.qtyRemaining < entry.qtyProduced && (
                      <div style={{ fontSize:10, color:"#aaa" }}>{entry.qtyRemaining} left</div>
                    )}
                  </div>
                </div>
              );
            })
          }
        </div>
      )}
    </div>
  );
}

// ── Wholesale Invoice Tab ──────────────────────────────────────────────────────
function WholesaleInvoiceTab({ products, factoryStock, saveFactoryStock, wholesaleCustomers, saveWholesaleCustomers, externalInvoices, saveExternalInvoices, auth, showToast }) {
  const [view, setView]               = useState("list"); // list | customer | newCustomer | newInvoice | invoiceDetail
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedInvoice, setSelectedInvoice]   = useState(null);
  const [customerForm, setCustomerForm] = useState({ name:"", email:"", address:"", phone:"", contactName:"", notes:"", allowedProductIds:[] });
  const [editingCustomer, setEditingCustomer] = useState(null); // null = new
  const [invoiceForm, setInvoiceForm] = useState({ customerId:"", customerName:"", customerEmail:"", customerAddress:"", date: new Date().toISOString().slice(0,10), items:[], note:"" });
  const [saving, setSaving]           = useState(false);
  const [reportFilter, setReportFilter] = useState({ customerId:"all", month:"all", year: new Date().getFullYear(), reportType:"summary", entity:"all" });
  const [mainTab, setMainTab]         = useState("customers"); // customers | invoices | reports
  const [paymentModal, setPaymentModal] = useState(null); // invoice being paid
  const [paymentForm, setPaymentForm]   = useState({ method:"cash", ref:"" });
  const [invoiceSort, setInvoiceSort]   = useState({ field:"date", dir:"desc" });
  const [invoiceStatusFilter, setInvoiceStatusFilter] = useState("all");
  const [invoiceSearch, setInvoiceSearch] = useState("");
  const [editingPaymentDate, setEditingPaymentDate] = useState(false);
  const [stockWarningModal, setStockWarningModal] = useState(null); // {shortfalls, pendingStatus} or null
  const ENTITIES = ["The Dumpling Factory","NV Foods","Vanessa's Dumpling House"];

  const inputStyle = { border:"1px solid #e5e5e5", borderRadius:8, padding:"8px 12px", fontSize:13, fontFamily:"'IBM Plex Sans',sans-serif", outline:"none", width:"100%", boxSizing:"border-box" };
  const fmtMoney = (n) => "$" + (Number(n)||0).toFixed(2);
  const fmtDate = (d) => d ? new Date(d.includes("T") ? d : d+"T12:00:00").toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}) : "—";

  const nextInvoiceNumber = () => {
    const nums = externalInvoices.map(i => parseInt((i.invoiceNumber||"EXT-0").replace("EXT-",""))||0);
    const next = nums.length > 0 ? Math.max(...nums) + 1 : 1;
    return "EXT-" + String(next).padStart(4,"0");
  };

  // Aggregate: total spent per customer
  const customerTotals = {};
  externalInvoices.forEach(inv => {
    if (inv.customerId) customerTotals[inv.customerId] = (customerTotals[inv.customerId]||0) + (inv.subtotal||0);
  });

  // ── SAVE CUSTOMER ──
  const saveCustomer = () => {
    if (!customerForm.name.trim()) { showToast("Customer name required"); return; }
    const existing = editingCustomer ? wholesaleCustomers.find(c=>c.id===editingCustomer) : null;
    const updated = existing
      ? wholesaleCustomers.map(c => c.id === editingCustomer ? {...c, ...customerForm} : c)
      : [{id: Date.now(), ...customerForm, defaultPricing:{}, createdAt: new Date().toISOString()}, ...wholesaleCustomers];
    saveWholesaleCustomers(updated);
    showToast(existing ? "Customer updated ✓" : "Customer added ✓");
    setCustomerForm({name:"",email:"",address:"",phone:"",contactName:"",notes:"",allowedProductIds:[]});
    setEditingCustomer(null);
    setView("list");
  };

  // ── ADD ITEM TO INVOICE ──
  const addInvoiceItem = (productId) => {
    const p = products.find(x => x.id === Number(productId));
    if (!p) return;
    const customer = wholesaleCustomers.find(c => c.id === invoiceForm.customerId);
    const defaultPrice = customer?.defaultPricing?.[p.id] ?? p.price ?? 0;
    setInvoiceForm(f => ({
      ...f,
      items: [...f.items, { productId: p.id, name: p.name, unit: p.unit, qty: 1, price: defaultPrice }]
    }));
  };

  const updateInvoiceItem = (idx, field, val) => {
    setInvoiceForm(f => ({ ...f, items: f.items.map((it,i) => i===idx ? {...it, [field]:val} : it) }));
  };

  const removeInvoiceItem = (idx) => {
    setInvoiceForm(f => ({ ...f, items: f.items.filter((_,i) => i !== idx) }));
  };

  const invoiceSubtotal = invoiceForm.items.reduce((s,it) => s + (Number(it.price)||0)*(Number(it.qty)||0), 0);

  // ── SAVE INVOICE ──
  const saveInvoice = (status="draft", forceOverride=false) => {
    if (!invoiceForm.customerName.trim()) { showToast("Customer name required"); return; }
    if (invoiceForm.items.length === 0) { showToast("Add at least one item"); return; }

    // Check for stock shortfalls on Frozen Dumplings (wholesale warning only — not blocking)
    if (!forceOverride && !invoiceForm.editingInvoiceId) {
      const shortfalls = [];
      invoiceForm.items.forEach(it => {
        const prod = products.find(p => p.id === it.productId);
        if (!prod || prod.category !== "Frozen Dumplings") return;
        const avail = factoryStock.filter(s => s.productId === it.productId).reduce((sum, s) => sum + (s.qtyRemaining||0), 0);
        if (Number(it.qty) > avail) {
          shortfalls.push({ name: prod.name, ordered: Number(it.qty), available: avail });
        }
      });
      if (shortfalls.length > 0) {
        setStockWarningModal({ shortfalls, pendingStatus: status });
        return; // pause — wait for user to confirm or cancel
      }
    }

    setSaving(true);

    // FIFO stock deduction (only for new invoices, not edits)
    let updatedStock = [...factoryStock];
    const isEditing = !!invoiceForm.editingInvoiceId;
    const itemsWithLots = invoiceForm.items.map(it => {
      if (isEditing) return { ...it }; // don't re-deduct stock on edit
      const lotPref = it.lotDate; // null=auto FIFO, "newest"=newest first, lotId=specific
      let lots = updatedStock.filter(s => s.productId === it.productId && s.qtyRemaining > 0);
      if (lotPref === "newest") {
        // Freshest first (newest production date)
        lots.sort((a,b) => !a.date?-1:!b.date?1:a.date>b.date?-1:a.date<b.date?1:0);
      } else if (lotPref && lotPref !== "auto") {
        // Specific lot — put it first, then fall back to FIFO for remainder
        const specific = lots.find(s => String(s.id) === String(lotPref));
        const rest = lots.filter(s => String(s.id) !== String(lotPref))
          .sort((a,b) => !a.date?1:!b.date?-1:a.date<b.date?-1:a.date>b.date?1:0);
        lots = specific ? [specific, ...rest] : rest;
      } else {
        // Auto FIFO — oldest first
        lots.sort((a,b) => !a.date?1:!b.date?-1:a.date<b.date?-1:a.date>b.date?1:a.id-b.id);
      }
      let rem = Number(it.qty); const assignedLots = [];
      for (const lot of lots) {
        if (rem <= 0) break;
        const take = Math.min(lot.qtyRemaining, rem);
        assignedLots.push({ stockId: lot.id, date: lot.date, lotNumber: lot.lotNumber, qty: take });
        updatedStock = updatedStock.map(s => s.id === lot.id ? {...s, qtyRemaining: s.qtyRemaining - take} : s);
        rem -= take;
      }
      const { lotDate: _omit, ...itClean } = it; // strip lotDate from saved item
      return { ...itClean, lots: assignedLots };
    });

    const subtotal = invoiceForm.items.reduce((s,it) => s + (Number(it.price)||0)*(Number(it.qty)||0), 0);

    if (isEditing) {
      const existingInv = externalInvoices.find(i => i.id === invoiceForm.editingInvoiceId);
      const updatedInvoice = {
        ...existingInv,
        customerName: invoiceForm.customerName,
        customerEmail: invoiceForm.customerEmail,
        customerAddress: invoiceForm.customerAddress,
        date: invoiceForm.date,
        items: itemsWithLots,
        subtotal,
        note: invoiceForm.note,
        invoiceNumber: invoiceForm.invoiceNumber || existingInv.invoiceNumber,
        entity: invoiceForm.entity || existingInv.entity || "The Dumpling Factory",
        // Preserve paid status — don't downgrade to "confirmed" on edit
        status: existingInv.status === "paid" ? "paid" : status,
        lastEditedAt: new Date().toISOString(),
        lastEditedBy: auth?.name || auth?.username || "Admin",
      };
      saveExternalInvoices(externalInvoices.map(i => i.id === invoiceForm.editingInvoiceId ? updatedInvoice : i));
      showToast(`✓ Invoice ${updatedInvoice.invoiceNumber} updated`);
    } else {
      const invoice = {
        id: Date.now(),
        invoiceNumber: invoiceForm.invoiceNumber?.trim() || nextInvoiceNumber(),
        customerId: invoiceForm.customerId || null,
        customerName: invoiceForm.customerName,
        customerEmail: invoiceForm.customerEmail,
        customerAddress: invoiceForm.customerAddress,
        entity: invoiceForm.entity || "The Dumpling Factory",
        date: invoiceForm.date,
        items: itemsWithLots,
        subtotal,
        note: invoiceForm.note,
        status,
        createdAt: new Date().toISOString(),
        createdBy: auth?.name || auth?.username || "Admin",
      };
      saveExternalInvoices([invoice, ...externalInvoices]);
      if (!isEditing) saveFactoryStock(updatedStock);
      showToast(`✓ Invoice ${invoice.invoiceNumber} saved`);
    }

    setInvoiceForm({ customerId:"", customerName:"", customerEmail:"", customerAddress:"", date: new Date().toISOString().slice(0,10), items:[], note:"" });
    setSaving(false);
    setView("list");
    setMainTab("invoices");
  };

  // ── PRINT INVOICE ──
  const printInvoice = (inv) => {
    const w = window.open("","_blank","width=900,height=1100");
    if (!w) return;
    const rows = inv.items.map((it,i) => `
      <tr style="background:${i%2===0?"#fff":"#f9f9f9"}">
        <td style="padding:8px 12px;font-weight:600">${it.customName||it.name}</td>
        <td style="padding:8px 12px;color:#888;font-size:12px">${it.unit}</td>
        <td style="padding:8px 12px;text-align:center;font-weight:700">${it.qty}</td>
        <td style="padding:8px 12px;text-align:right">$${Number(it.price).toFixed(2)}</td>
        <td style="padding:8px 12px;text-align:right;font-weight:700">$${(Number(it.price)*Number(it.qty)).toFixed(2)}</td>
      </tr>`).join("");
    const entityName = inv.entity || "The Dumpling Factory";
    w.document.write(`<!DOCTYPE html><html><head><title>Invoice ${inv.invoiceNumber}</title>
      <style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:Arial,sans-serif;color:#1a1a1a;padding:40px;font-size:13px}table{width:100%;border-collapse:collapse}th{background:#1a1a1a;color:#fff;padding:9px 12px;text-align:left;font-size:11px;text-transform:uppercase;letter-spacing:.5px}@media print{.no-print{display:none}}</style>
      </head><body>
      <div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:32px">
        <div>
          <div style="font-size:26px;font-weight:900;color:#C0392B;margin-bottom:4px">INVOICE</div>
          <div style="font-size:13px;font-weight:700">${entityName}</div>
          <div style="font-size:12px;color:#888">30-30 47th Ave, Long Island City, NY 11101</div>
          <div style="font-size:12px;color:#888">718-838-3378 · orders@vanessas.com</div>
        </div>
        <div style="text-align:right">
          <div style="font-size:20px;font-weight:800">${inv.invoiceNumber}</div>
          <div style="font-size:12px;color:#888;margin-top:4px">Date: ${fmtDate(inv.date)}</div>
          <div style="font-size:11px;margin-top:4px;padding:3px 8px;border-radius:12px;display:inline-block;background:${inv.status==="paid"?"#d4edda":"#fff3cd"};color:${inv.status==="paid"?"#155724":"#856404"};font-weight:700;text-transform:capitalize">${inv.status}</div>
        </div>
      </div>
      <div style="display:flex;gap:40px;margin-bottom:28px">
        <div style="flex:1">
          <div style="font-size:10px;color:#aaa;font-weight:700;text-transform:uppercase;letter-spacing:1px;margin-bottom:6px">Bill To</div>
          <div style="font-weight:700;font-size:15px">${inv.customerName}</div>
          ${inv.customerAddress ? `<div style="font-size:12px;color:#888;margin-top:2px">${inv.customerAddress}</div>` : ""}
          ${inv.customerEmail ? `<div style="font-size:12px;color:#888">${inv.customerEmail}</div>` : ""}
        </div>
        <div style="text-align:right">
          <div style="font-size:10px;color:#aaa;font-weight:700;text-transform:uppercase;letter-spacing:1px;margin-bottom:6px">Bill From</div>
          <div style="font-weight:700;font-size:14px">${entityName}</div>
          <div style="font-size:12px;color:#888">30-30 47th Ave, Long Island City, NY 11101</div>
          <div style="font-size:12px;color:#888">718-838-3378</div>
        </div>
      </div>
      <table style="margin-bottom:20px"><thead><tr><th>Item</th><th>Unit</th><th style="text-align:center">Qty</th><th style="text-align:right">Unit Price</th><th style="text-align:right">Total</th></tr></thead>
      <tbody>${rows}</tbody></table>
      <div style="display:flex;justify-content:flex-end;margin-bottom:24px">
        <div style="min-width:220px;border-top:2px solid #1a1a1a;padding-top:10px">
          <div style="display:flex;justify-content:space-between;font-size:18px;font-weight:800">
            <span>Total</span><span>$${(inv.subtotal||0).toFixed(2)}</span>
          </div>
        </div>
      </div>
      ${inv.note ? `<div style="padding:10px 14px;background:#FFFBF0;border-left:3px solid #F39C12;font-size:12px;color:#856404;margin-bottom:20px">Note: ${inv.note}</div>` : ""}
      <div style="margin-top:28px;padding:16px 20px;background:#f8f8f8;border-radius:8px;text-align:center">
        <div style="font-size:13px;color:#555;margin-bottom:6px">Please make all checks/payments to <strong>${entityName}</strong></div>
        <div style="font-size:15px;font-weight:800;color:#1a1a1a">Thank You For Your Order!</div>
      </div>
      <div style="margin-top:20px;padding-top:12px;border-top:1px solid #eee;font-size:11px;color:#aaa;text-align:center">${entityName} · 30-30 47th Ave, Long Island City, NY 11101 · 718-838-3378</div>
      <div class="no-print" style="text-align:center;margin-top:24px">
        <button onclick="window.print()" style="background:#1a1a1a;color:#fff;border:none;padding:12px 28px;border-radius:8px;font-size:14px;font-weight:700;cursor:pointer">🖨 Print / Save as PDF</button>
      </div>
      <script>window.onload=()=>{window.print();}<\/script>
      </body></html>`);
    w.document.close();
  };

  const CAT_ORDER = ["Frozen Dumplings","Buns","Doughs","Vegetables","Sauces","Meats","Soup","Sides","Paper Goods","Other"];

  return (
    <div style={{ padding:"20px 24px" }}>
      {/* Main tabs */}
      <div style={{ display:"flex", gap:8, marginBottom:20, flexWrap:"wrap" }}>
        {[["customers","👥 Customers"],["invoices","🧾 Invoices"],["reports","📊 Sales Reports"]].map(([k,l]) => (
          <button key={k} onClick={() => { setMainTab(k); setView("list"); }}
            style={{ border:"none", borderRadius:9, padding:"8px 18px", fontSize:13, fontWeight:700, cursor:"pointer",
              background: mainTab===k ? "#1a1a1a" : "#f0f0f0", color: mainTab===k ? "#fff" : "#555" }}>
            {l}
          </button>
        ))}
        <button onClick={() => { setMainTab("invoices"); setView("newInvoice"); setInvoiceForm({ customerId:"", customerName:"", customerEmail:"", customerAddress:"", date: new Date().toISOString().slice(0,10), items:[], note:"" }); }}
          style={{ border:"none", borderRadius:9, padding:"8px 18px", fontSize:13, fontWeight:700, cursor:"pointer", background:"#C0392B", color:"#fff", marginLeft:"auto" }}>
          + New Invoice
        </button>
      </div>

      {/* ── CUSTOMERS TAB ── */}
      {mainTab === "customers" && view === "list" && (
        <div>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
            <div style={{ fontSize:12, color:"#888" }}>{wholesaleCustomers.length} wholesale customer{wholesaleCustomers.length!==1?"s":""}</div>
            <button onClick={() => { setEditingCustomer(null); setCustomerForm({name:"",email:"",address:"",phone:"",contactName:"",notes:"",allowedProductIds:[]}); setView("newCustomer"); }}
              style={{ border:"none", borderRadius:9, padding:"8px 18px", fontSize:13, fontWeight:700, cursor:"pointer", background:"#1a1a1a", color:"#fff" }}>
              + Add Customer
            </button>
          </div>
          {wholesaleCustomers.length === 0
            ? <div style={{ textAlign:"center", padding:40, color:"#aaa" }}>
                <div style={{ fontSize:32, marginBottom:12 }}>👥</div>
                <div style={{ fontWeight:700 }}>No customers yet</div>
                <div style={{ fontSize:13, marginTop:6 }}>Add your first wholesale customer to get started</div>
              </div>
            : wholesaleCustomers.map(c => {
                const RETENTION_DAYS = 45;
                const custInvs = externalInvoices.filter(i=>i.customerId===c.id);
                const lastOrder = custInvs.length ? Math.max(...custInvs.map(i=>new Date(i.date).getTime())) : null;
                const daysSince = lastOrder ? Math.floor((Date.now()-lastOrder)/86400000) : null;
                const atRisk = !c.archived && daysSince !== null && daysSince >= RETENTION_DAYS;
                return (
                <div key={c.id} style={{ display:"flex", alignItems:"center", gap:12, padding:"14px 16px",
                  background: c.archived ? "#fafafa" : "#fff",
                  border:`1px solid ${atRisk?"#F39C12":c.archived?"#e0e0e0":"#e8e8e8"}`,
                  borderRadius:12, marginBottom:8, cursor:"pointer",
                  opacity: c.archived ? 0.65 : 1 }}
                  onClick={() => { setSelectedCustomer(c); setView("customer"); }}>
                  <div style={{ width:40, height:40, borderRadius:"50%", background:"#f0f0f0", display:"flex", alignItems:"center", justifyContent:"center", fontWeight:800, fontSize:16, color:"#1a1a1a", flexShrink:0 }}>
                    {c.name[0].toUpperCase()}
                  </div>
                  <div style={{ flex:1 }}>
                    <div style={{ fontWeight:700, fontSize:14, display:"flex", alignItems:"center", gap:8 }}>
                      {c.name}
                      {c.archived && <span style={{ fontSize:10, fontWeight:700, color:"#888", background:"#f0f0f0", border:"1px solid #ddd", borderRadius:6, padding:"2px 6px" }}>📦 Archived</span>}
                      {atRisk && <span style={{ fontSize:10, fontWeight:700, color:"#E67E22", background:"#FFF8F0", border:"1px solid #F39C12", borderRadius:6, padding:"2px 6px" }}>⚠️ {daysSince}d no order</span>}
                    </div>
                    <div style={{ fontSize:12, color:"#888" }}>{c.email || "No email"}{c.contactName ? ` · ${c.contactName}` : ""}</div>
                  </div>
                  <div style={{ textAlign:"right" }}>
                    <div style={{ fontWeight:700, fontSize:13 }}>{fmtMoney(customerTotals[c.id]||0)}</div>
                    <div style={{ fontSize:11, color:"#aaa" }}>total sales</div>
                  </div>
                  <div style={{ color:"#ccc" }}>›</div>
                </div>
                );
              })
          }
        </div>
      )}

      {/* ── CUSTOMER DETAIL ── */}
      {mainTab === "customers" && view === "customer" && selectedCustomer && (
        <div>
          <button onClick={() => setView("list")} style={{ border:"none", background:"none", color:"#2471A3", fontWeight:700, fontSize:13, cursor:"pointer", marginBottom:16 }}>← Back</button>
          <div style={{ background:"#fff", borderRadius:14, padding:"20px 24px", marginBottom:20, border:"1px solid #e8e8e8" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:16 }}>
              <div>
                <div style={{ fontWeight:800, fontSize:20 }}>{selectedCustomer.name}</div>
                {selectedCustomer.contactName && <div style={{ fontSize:13, color:"#888", marginTop:2 }}>{selectedCustomer.contactName}</div>}
              </div>
              <div style={{ display:"flex", gap:8 }}>
                <button onClick={() => { setEditingCustomer(selectedCustomer.id); setCustomerForm({name:selectedCustomer.name,email:selectedCustomer.email||"",address:selectedCustomer.address||"",phone:selectedCustomer.phone||"",contactName:selectedCustomer.contactName||"",notes:selectedCustomer.notes||"",allowedProductIds:selectedCustomer.allowedProductIds||[]}); setView("newCustomer"); }}
                  style={{ border:"1px solid #e5e5e5", background:"#fff", borderRadius:8, padding:"7px 14px", fontSize:12, fontWeight:700, cursor:"pointer" }}>
                  ✏️ Edit
                </button>
                <button onClick={() => {
                  const newArchived = !selectedCustomer.archived;
                  const updated = wholesaleCustomers.map(c => c.id === selectedCustomer.id ? {...c, archived: newArchived} : c);
                  saveWholesaleCustomers(updated);
                  setSelectedCustomer(prev => ({...prev, archived: newArchived}));
                  showToast(newArchived ? "Customer archived — alerts suppressed" : "Customer restored");
                }}
                  style={{ border:`1px solid ${selectedCustomer.archived?"#27AE60":"#ddd"}`, background: selectedCustomer.archived ? "#f0faf4" : "#fafafa", borderRadius:8, padding:"7px 14px", fontSize:12, fontWeight:700, cursor:"pointer", color: selectedCustomer.archived ? "#27AE60" : "#888" }}>
                  {selectedCustomer.archived ? "✓ Archived" : "📦 Archive"}
                </button>
              </div>
            </div>
            {[["📧",selectedCustomer.email],["📍",selectedCustomer.address],["📞",selectedCustomer.phone],["📝",selectedCustomer.notes]].filter(([,v])=>v).map(([icon,val],i) => (
              <div key={i} style={{ display:"flex", gap:8, fontSize:13, color:"#555", marginBottom:6 }}>
                <span>{icon}</span><span>{val}</span>
              </div>
            ))}
            <div style={{ marginTop:16, paddingTop:16, borderTop:"1px solid #f0f0f0", display:"flex", gap:20 }}>
              <div><div style={{ fontWeight:800, fontSize:20 }}>{fmtMoney(customerTotals[selectedCustomer.id]||0)}</div><div style={{ fontSize:11, color:"#aaa" }}>Total Sales</div></div>
              <div><div style={{ fontWeight:800, fontSize:20 }}>{externalInvoices.filter(i=>i.customerId===selectedCustomer.id).length}</div><div style={{ fontSize:11, color:"#aaa" }}>Invoices</div></div>
            </div>
          </div>

          {/* Default pricing */}
          <div style={{ background:"#fff", borderRadius:14, padding:"16px 20px", marginBottom:20, border:"1px solid #e8e8e8" }}>
            <div style={{ fontWeight:700, fontSize:14, marginBottom:12 }}>Custom Pricing</div>
            <div style={{ fontSize:12, color:"#888", marginBottom:12 }}>Set custom prices for this customer. Leave blank to use the standard price.</div>
            {(() => {
              const allowedIds = selectedCustomer.allowedProductIds||[];
              const pricingProducts = allowedIds.length > 0
                ? products.filter(p => allowedIds.includes(p.id) && p.price!=null)
                : products.filter(p => p.price!=null).slice(0,20);
              if (pricingProducts.length === 0) return <div style={{ fontSize:13, color:"#aaa" }}>No items with pricing available. Add items in Edit Customer.</div>;
              return pricingProducts.map(p => {
                const custom = selectedCustomer.defaultPricing?.[p.id];
                return (
                  <div key={p.id} style={{ display:"flex", alignItems:"center", gap:12, marginBottom:8 }}>
                    <div style={{ flex:1, fontSize:13 }}>{p.name} <span style={{ color:"#aaa" }}>({p.unit})</span></div>
                    <div style={{ fontSize:12, color:"#aaa" }}>Std: ${p.price?.toFixed(2)}</div>
                    <div style={{ display:"flex", alignItems:"center", gap:4 }}>
                      <span style={{ color:"#aaa", fontSize:12 }}>$</span>
                      <input type="number" min="0" step="0.01" placeholder={p.price?.toFixed(2)}
                        value={custom != null ? custom : ""}
                        onChange={e => {
                          const val = e.target.value === "" ? undefined : parseFloat(e.target.value)||0;
                          const newPricing = {...(selectedCustomer.defaultPricing||{})};
                          if (val == null) delete newPricing[p.id]; else newPricing[p.id] = val;
                          const updated = wholesaleCustomers.map(c => c.id === selectedCustomer.id ? {...c, defaultPricing: newPricing} : c);
                          saveWholesaleCustomers(updated);
                          setSelectedCustomer(prev => ({...prev, defaultPricing: newPricing}));
                        }}
                        style={{ width:70, border:"1px solid #e5e5e5", borderRadius:6, padding:"5px 8px", fontSize:13, textAlign:"right", outline:"none" }}/>
                    </div>
                  </div>
                );
              });
            })()}
          </div>

          {/* Invoice history for this customer */}
          <div style={{ fontWeight:700, fontSize:14, marginBottom:10 }}>Invoice History</div>
          {externalInvoices.filter(i=>i.customerId===selectedCustomer.id).sort((a,b)=>new Date(b.date)-new Date(a.date)).map(inv => (
            <div key={inv.id}
              style={{ display:"flex", alignItems:"center", gap:12, padding:"12px 16px", background:"#fff",
                border:"1px solid #e8e8e8", borderRadius:10, marginBottom:8 }}>
              <div style={{ flex:1, cursor:"pointer" }} onClick={() => { setSelectedInvoice(inv); setView("invoiceDetail"); }}>
                <div style={{ fontWeight:700, fontSize:13 }}>{inv.invoiceNumber}</div>
                <div style={{ fontSize:11, color:"#888" }}>{fmtDate(inv.date)} · {inv.items.length} items</div>
              </div>
              <div style={{ fontWeight:700, fontSize:14 }}>{fmtMoney(inv.subtotal)}</div>
              <div style={{ fontSize:11, padding:"3px 8px", borderRadius:10, fontWeight:700, textTransform:"capitalize",
                background: inv.status==="paid"?"#d4edda":inv.status==="emailed"?"#cce5ff":inv.status==="confirmed"?"#e8f4fd":"#fff3cd",
                color: inv.status==="paid"?"#155724":inv.status==="emailed"?"#004085":inv.status==="confirmed"?"#2471A3":"#856404" }}>{inv.status}</div>
              <button
                onClick={() => {
                  // Pre-populate a new invoice from this one — customer already selected, items pre-filled at same prices
                  const reorderItems = inv.items.map(it => ({ productId:it.productId, name:it.name, unit:it.unit, qty:it.qty, price:it.price }));
                  setInvoiceForm({
                    customerId: selectedCustomer.id,
                    customerName: selectedCustomer.name,
                    customerEmail: selectedCustomer.email||"",
                    customerAddress: selectedCustomer.address||"",
                    date: new Date().toISOString().slice(0,10),
                    items: reorderItems,
                    note: "",
                  });
                  setMainTab("invoices");
                  setView("newInvoice");
                  showToast("Order loaded — edit and save to create new invoice");
                }}
                style={{ border:"1px solid #e5e5e5", borderRadius:8, padding:"5px 10px", fontSize:11,
                  fontWeight:700, cursor:"pointer", background:"#fff", color:"#555", whiteSpace:"nowrap",
                  flexShrink:0 }}>
                ↺ Reorder
              </button>
            </div>
          ))}
          {externalInvoices.filter(i=>i.customerId===selectedCustomer.id).length === 0 && (
            <div style={{ color:"#aaa", fontSize:13 }}>No invoices yet</div>
          )}
        </div>
      )}

      {/* ── NEW / EDIT CUSTOMER ── */}
      {view === "newCustomer" && (
        <div style={{ maxWidth:480 }}>
          <button onClick={() => setView("list")} style={{ border:"none", background:"none", color:"#2471A3", fontWeight:700, fontSize:13, cursor:"pointer", marginBottom:16 }}>← Back</button>
          <div style={{ fontWeight:800, fontSize:18, marginBottom:20 }}>{editingCustomer ? "Edit Customer" : "New Customer"}</div>
          {[["name","Customer / Company Name","text",true],["contactName","Contact Name","text",false],["email","Email","email",false],["phone","Phone","tel",false],["address","Address","text",false]].map(([field,label,type,required]) => (
            <div key={field} style={{ marginBottom:14 }}>
              <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:.5, marginBottom:6 }}>
                {label}{required && <span style={{ color:"#E74C3C" }}> *</span>}
              </label>
              <input type={type} value={customerForm[field]} onChange={e => setCustomerForm(f=>({...f,[field]:e.target.value}))}
                style={{ ...inputStyle }}/>
            </div>
          ))}
          <div style={{ marginBottom:20 }}>
            <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:.5, marginBottom:6 }}>Notes</label>
            <textarea value={customerForm.notes} rows={2} onChange={e=>setCustomerForm(f=>({...f,notes:e.target.value}))}
              style={{ ...inputStyle, resize:"vertical" }}/>
          </div>

          {/* Allowed products */}
          <div style={{ marginBottom:24 }}>
            <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:.5, marginBottom:4 }}>Available Items</label>
            <div style={{ fontSize:12, color:"#aaa", marginBottom:10 }}>Only checked items will appear in this customer's invoices and pricing. Leave all unchecked to allow all items.</div>
            <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
              {[...products].sort((a,b)=>(a.category||"").localeCompare(b.category||"")||a.name.localeCompare(b.name)).map(p => {
                const allowed = (customerForm.allowedProductIds||[]).includes(p.id);
                return (
                  <div key={p.id} onClick={() => {
                      const cur = customerForm.allowedProductIds||[];
                      setCustomerForm(f => ({...f, allowedProductIds: allowed ? cur.filter(id=>id!==p.id) : [...cur, p.id]}));
                    }}
                    style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 12px",
                      borderRadius:8, border:`1px solid ${allowed?"#1a1a1a":"#e5e5e5"}`,
                      background: allowed?"#f8f8f8":"#fff", cursor:"pointer" }}>
                    <div style={{ width:18, height:18, borderRadius:4, flexShrink:0,
                      border:`2px solid ${allowed?"#1a1a1a":"#ccc"}`,
                      background: allowed?"#1a1a1a":"#fff",
                      display:"flex", alignItems:"center", justifyContent:"center" }}>
                      {allowed && <span style={{ color:"#fff", fontSize:11, fontWeight:800 }}>✓</span>}
                    </div>
                    <div style={{ flex:1 }}>
                      <span style={{ fontSize:13, fontWeight:600 }}>{p.name}</span>
                      <span style={{ fontSize:11, color:"#aaa", marginLeft:6 }}>{p.category} · {p.unit}</span>
                    </div>
                  </div>
                );
              })}
            </div>
            {(customerForm.allowedProductIds||[]).length > 0 && (
              <div style={{ marginTop:8, fontSize:12, color:"#27AE60", fontWeight:600 }}>
                ✓ {customerForm.allowedProductIds.length} item{customerForm.allowedProductIds.length!==1?"s":""} selected
              </div>
            )}
          </div>
          <button onClick={saveCustomer} style={{ background:"#1a1a1a", color:"#fff", border:"none", borderRadius:12, padding:"13px 28px", fontSize:14, fontWeight:700, cursor:"pointer" }}>
            {editingCustomer ? "Save Changes" : "Add Customer"}
          </button>
        </div>
      )}

      {/* ── NEW INVOICE ── */}
      {view === "newInvoice" && (
        <div style={{ maxWidth:640 }}>
          <button onClick={() => setView("list")} style={{ border:"none", background:"none", color:"#2471A3", fontWeight:700, fontSize:13, cursor:"pointer", marginBottom:16 }}>← Back</button>
          <div style={{ fontWeight:800, fontSize:18, marginBottom:20 }}>{invoiceForm.editingInvoiceId ? "Edit Invoice" : "New Invoice"}</div>

          {/* Customer selector */}
          <div style={{ background:"#f8f8f8", borderRadius:12, padding:"16px 18px", marginBottom:18 }}>
            <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:.5, marginBottom:8 }}>Customer</label>
            <select value={invoiceForm.customerId}
              onChange={e => {
                const c = wholesaleCustomers.find(x=>x.id===Number(e.target.value));
                setInvoiceForm(f => ({...f, customerId:Number(e.target.value)||"", customerName:c?.name||"", customerEmail:c?.email||"", customerAddress:c?.address||"", items:[]}));
              }}
              style={{ ...inputStyle, marginBottom:10 }}>
              <option value="">One-time customer (fill manually)</option>
              {wholesaleCustomers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
            {[["customerName","Name *"],["customerEmail","Email"],["customerAddress","Address"]].map(([f,l])=>(
              <div key={f} style={{ marginBottom:8 }}>
                <input placeholder={l} value={invoiceForm[f]} onChange={e=>setInvoiceForm(fi=>({...fi,[f]:e.target.value}))}
                  style={{ ...inputStyle, background:"#fff" }}/>
              </div>
            ))}
            <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:8 }}>
              <label style={{ fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:.5, whiteSpace:"nowrap" }}>Invoice Date</label>
              <input type="date" value={invoiceForm.date} onChange={e=>setInvoiceForm(f=>({...f,date:e.target.value}))}
                style={{ ...inputStyle, width:"auto" }}/>
            </div>
            <div style={{ display:"flex", gap:12, marginBottom:8 }}>
              <div style={{ flex:1 }}>
                <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:.5, marginBottom:4 }}>Invoice #</label>
                <input value={invoiceForm.invoiceNumber||""} onChange={e=>setInvoiceForm(f=>({...f,invoiceNumber:e.target.value}))}
                  placeholder="Auto-generated"
                  style={{ ...inputStyle, background:"#fff" }}/>
              </div>
              <div style={{ flex:1 }}>
                <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:.5, marginBottom:4 }}>Bill From</label>
                <select value={invoiceForm.entity||"The Dumpling Factory"} onChange={e=>setInvoiceForm(f=>({...f,entity:e.target.value}))}
                  style={{ ...inputStyle, background:"#fff" }}>
                  {ENTITIES.map(e=><option key={e} value={e}>{e}</option>)}
                </select>
              </div>
            </div>
          </div>

          {/* Items */}
          <div style={{ marginBottom:16 }}>
            <div style={{ fontWeight:700, fontSize:14, marginBottom:10 }}>Items</div>
            {invoiceForm.items.length > 0 && (
              <div style={{ border:"1px solid #e8e8e8", borderRadius:10, overflow:"hidden", marginBottom:12 }}>
                <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
                  <thead>
                    <tr style={{ background:"#f5f5f5" }}>
                      {["Item","Qty","Unit Price","Total",""].map(h=>(
                        <th key={h} style={{ padding:"8px 10px", textAlign:h==="Qty"||h==="Unit Price"||h==="Total"?"right":"left", fontWeight:700, fontSize:11, color:"#888", textTransform:"uppercase" }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceForm.items.map((it,i)=>(
                      <tr key={i} style={{ borderTop:"1px solid #f0f0f0" }}>
                        <td style={{ padding:"7px 10px" }}>
                          {it.customItem
                            ? <input value={it.name} onChange={e=>updateInvoiceItem(i,"name",e.target.value)}
                                placeholder="Item name *"
                                style={{ fontWeight:600, fontSize:13, border:"none", borderBottom:"1px solid #ddd",
                                  outline:"none", background:"transparent", width:"100%", padding:"1px 0" }}/>
                            : <div style={{ fontWeight:600, fontSize:13 }}>{it.name}</div>
                          }
                          <input
                            value={it.customName||""}
                            onChange={e=>updateInvoiceItem(i,"customName",e.target.value)}
                            placeholder={it.customItem?"Unit (e.g. bag, case)":"Custom label (optional)"}
                            style={{ fontSize:11, color:"#888", border:"none", borderBottom:"1px dashed #ddd",
                              outline:"none", background:"transparent", width:"100%", marginTop:2, padding:"1px 0" }}/>
                          {it.productId && products.find(p=>p.id===it.productId)?.category==="Frozen Dumplings" && (() => {
                            const availLots = factoryStock.filter(s=>s.productId===it.productId&&(s.qtyRemaining||0)>0)
                              .sort((a,b)=>!a.date?1:!b.date?-1:a.date<b.date?-1:a.date>b.date?1:0);
                            return (
                              <div style={{ display:"flex", alignItems:"center", gap:6, marginTop:4 }}>
                                <span style={{ fontSize:10, color:"#2471A3", fontWeight:600 }}>📦</span>
                                <select value={it.lotDate||"auto"} onChange={e=>updateInvoiceItem(i,"lotDate",e.target.value==="auto"?null:e.target.value)}
                                  style={{ fontSize:10, border:"1px solid #e5e5e5", borderRadius:5, padding:"2px 6px", outline:"none", color:"#555" }}>
                                  <option value="auto">Auto FIFO</option>
                                  {availLots.map(lot=>(
                                    <option key={lot.id} value={String(lot.id)}>
                                      {lot.date ? new Date(lot.date+"T12:00:00").toLocaleDateString("en-US",{month:"short",day:"numeric",year:"2-digit"}) : "No date"} ({lot.qtyRemaining} left)
                                    </option>
                                  ))}
                                  {availLots.length === 0 && <option disabled>⚠️ No stock</option>}
                                </select>
                              </div>
                            );
                          })()}
                        </td>
                        <td style={{ padding:"7px 6px" }}>
                          <input type="number" min="0.5" step="0.5" value={it.qty} onChange={e=>updateInvoiceItem(i,"qty",parseFloat(e.target.value)||0)}
                            style={{ width:55, border:"1px solid #e5e5e5", borderRadius:6, padding:"4px 6px", fontSize:13, textAlign:"right", outline:"none" }}/>
                        </td>
                        <td style={{ padding:"7px 6px" }}>
                          <div style={{ display:"flex", alignItems:"center", gap:2 }}>
                            <span style={{ color:"#aaa", fontSize:12 }}>$</span>
                            <input type="number" min="0" step="0.01" value={it.price} onChange={e=>updateInvoiceItem(i,"price",parseFloat(e.target.value)||0)}
                              style={{ width:65, border:"1px solid #e5e5e5", borderRadius:6, padding:"4px 6px", fontSize:13, textAlign:"right", outline:"none" }}/>
                          </div>
                        </td>
                        <td style={{ padding:"7px 10px", textAlign:"right", fontWeight:700 }}>${(Number(it.price)*Number(it.qty)).toFixed(2)}</td>
                        <td style={{ padding:"7px 6px", textAlign:"center" }}>
                          <button onClick={()=>removeInvoiceItem(i)} style={{ background:"none", border:"none", color:"#ddd", fontSize:16, cursor:"pointer" }}
                            onMouseEnter={e=>e.target.style.color="#E74C3C"} onMouseLeave={e=>e.target.style.color="#ddd"}>×</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            {/* Add custom item */}
            <div style={{ display:"flex", gap:8, marginBottom:8 }}>
              <button onClick={()=>{
                setInvoiceForm(f=>({...f, items:[...f.items, {productId:null,name:"",unit:"",qty:1,price:0,customItem:true}]}));
              }} style={{ border:"1px dashed #ccc", background:"#fafafa", borderRadius:8, padding:"7px 14px",
                fontSize:12, fontWeight:700, cursor:"pointer", color:"#888" }}>
                + Custom Item
              </button>
            </div>
            <select value="" onChange={e=>{ addInvoiceItem(e.target.value); }}
              style={{ ...inputStyle, color:"#555" }}>
              <option value="">+ Add catalog item to invoice...</option>
              {(() => {
                const customer = wholesaleCustomers.find(c=>c.id===invoiceForm.customerId);
                const allowedIds = customer?.allowedProductIds||[];
                const availableProducts = allowedIds.length > 0
                  ? products.filter(p => allowedIds.includes(p.id))
                  : products;
                // Use all categories present in availableProducts, not just CAT_ORDER
                const allCats = [...new Set(availableProducts.map(p=>p.category||"Other"))].sort();
                return allCats.map(cat => {
                  const catProds = availableProducts.filter(p=>(p.category||"Other")===cat && !invoiceForm.items.find(it=>it.productId===p.id));
                  if (!catProds.length) return null;
                  const custPricing = customer?.defaultPricing||{};
                  return (
                    <optgroup key={cat} label={cat}>
                      {catProds.map(p => {
                        const custPrice = custPricing[p.id];
                        const displayPrice = custPrice != null ? custPrice : p.price;
                        const priceStr = displayPrice != null
                          ? ` ($${Number(displayPrice).toFixed(2)}${custPrice!=null?" custom":""})`
                          : " (Market)";
                        return <option key={p.id} value={p.id}>{p.name} — {p.unit}{priceStr}</option>;
                      })}
                    </optgroup>
                  );
                });
              })()}
            </select>
          </div>

          {/* Total */}
          {invoiceForm.items.length > 0 && (
            <div style={{ display:"flex", justifyContent:"flex-end", marginBottom:16 }}>
              <div style={{ background:"#1a1a1a", borderRadius:10, padding:"12px 20px", display:"flex", gap:20, alignItems:"center" }}>
                <span style={{ color:"#aaa", fontSize:13 }}>Total</span>
                <span style={{ color:"#fff", fontWeight:800, fontSize:20 }}>{fmtMoney(invoiceSubtotal)}</span>
              </div>
            </div>
          )}

          {/* Note */}
          <div style={{ marginBottom:20 }}>
            <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:.5, marginBottom:6 }}>Note</label>
            <textarea value={invoiceForm.note} rows={2} placeholder="Payment terms, delivery notes..."
              onChange={e=>setInvoiceForm(f=>({...f,note:e.target.value}))}
              style={{ ...inputStyle, resize:"vertical" }}/>
          </div>

          <div style={{ display:"flex", gap:10 }}>
            <button onClick={()=>saveInvoice("draft")} disabled={saving}
              style={{ border:"1px solid #e5e5e5", background:"#fff", borderRadius:12, padding:"12px 22px", fontSize:13, fontWeight:700, cursor:"pointer", color:"#555" }}>
              Save as Draft
            </button>
            <button onClick={()=>saveInvoice("confirmed")} disabled={saving}
              style={{ background:"#1a1a1a", color:"#fff", border:"none", borderRadius:12, padding:"12px 22px", fontSize:13, fontWeight:700, cursor:"pointer" }}>
              Save & Print 🖨
            </button>
          </div>
        </div>
      )}

      {/* ── INVOICES LIST ── */}
      {mainTab === "invoices" && view === "list" && (
        <div>
          {/* Sort & Filter controls */}
          <div style={{ display:"flex", gap:8, marginBottom:16, flexWrap:"wrap", alignItems:"center" }}>
            <select onChange={e => {
                const [field, dir] = e.target.value.split("-");
                setInvoiceSort({ field, dir });
              }}
              value={`${invoiceSort.field}-${invoiceSort.dir}`}
              style={{ border:"1px solid #e5e5e5", borderRadius:8, padding:"7px 12px", fontSize:13, outline:"none" }}>
              <option value="date-desc">Date (Newest first)</option>
              <option value="date-asc">Date (Oldest first)</option>
              <option value="number-desc">Invoice # (High → Low)</option>
              <option value="number-asc">Invoice # (Low → High)</option>
              <option value="customer-asc">Customer (A → Z)</option>
              <option value="customer-desc">Customer (Z → A)</option>
              <option value="amount-desc">Amount (High → Low)</option>
              <option value="amount-asc">Amount (Low → High)</option>
            </select>
            <select value={invoiceStatusFilter} onChange={e=>setInvoiceStatusFilter(e.target.value)}
              style={{ border:"1px solid #e5e5e5", borderRadius:8, padding:"7px 12px", fontSize:13, outline:"none" }}>
              <option value="all">All Statuses</option>
              <option value="draft">Draft</option>
              <option value="confirmed">Confirmed</option>
              <option value="emailed">Emailed</option>
              <option value="paid">Paid</option>
            </select>
            <input placeholder="Search customer or invoice #..."
              value={invoiceSearch} onChange={e=>setInvoiceSearch(e.target.value)}
              style={{ flex:1, minWidth:180, border:"1px solid #e5e5e5", borderRadius:8, padding:"7px 12px", fontSize:13, outline:"none" }}/>
            <span style={{ fontSize:12, color:"#aaa", flexShrink:0 }}>
              {(() => {
                const n = externalInvoices.filter(inv => {
                  if (invoiceStatusFilter !== "all" && inv.status !== invoiceStatusFilter) return false;
                  if (invoiceSearch) {
                    const q = invoiceSearch.toLowerCase();
                    if (!inv.customerName?.toLowerCase().includes(q) && !inv.invoiceNumber?.toLowerCase().includes(q)) return false;
                  }
                  return true;
                }).length;
                return `${n} invoice${n!==1?"s":""}`;
              })()}
            </span>
          </div>
          {(() => {
            const sorted = [...externalInvoices]
              .filter(inv => {
                if (invoiceStatusFilter !== "all" && inv.status !== invoiceStatusFilter) return false;
                if (invoiceSearch) {
                  const q = invoiceSearch.toLowerCase();
                  if (!inv.customerName?.toLowerCase().includes(q) && !inv.invoiceNumber?.toLowerCase().includes(q)) return false;
                }
                return true;
              })
              .sort((a,b) => {
                const { field, dir } = invoiceSort;
                const mul = dir === "asc" ? 1 : -1;
                if (field === "date") return mul * (new Date(a.date) - new Date(b.date));
                if (field === "number") return mul * ((a.invoiceNumber||"").localeCompare(b.invoiceNumber||"",undefined,{numeric:true}));
                if (field === "customer") return mul * ((a.customerName||"").localeCompare(b.customerName||""));
                if (field === "amount") return mul * ((a.subtotal||0) - (b.subtotal||0));
                return 0;
              });
            if (sorted.length === 0) return (
              <div style={{ textAlign:"center", padding:40, color:"#aaa" }}>
                <div style={{ fontSize:32, marginBottom:12 }}>🧾</div>
                <div style={{ fontWeight:700 }}>No invoices found</div>
              </div>
            );
            return sorted.map(inv => (
              <div key={inv.id} onClick={() => { setSelectedInvoice(inv); setView("invoiceDetail"); }}
                style={{ display:"flex", alignItems:"center", gap:12, padding:"12px 16px", background:"#fff",
                  border:"1px solid #e8e8e8", borderRadius:10, marginBottom:8, cursor:"pointer" }}>
                <div style={{ flex:1 }}>
                  <div style={{ fontWeight:700, fontSize:13 }}>{inv.invoiceNumber} — {inv.customerName}</div>
                  <div style={{ fontSize:11, color:"#888" }}>{fmtDate(inv.date)} · {inv.items.length} items</div>
                </div>
                <div style={{ fontWeight:700, fontSize:14 }}>{fmtMoney(inv.subtotal)}</div>
                <div style={{ fontSize:11, padding:"3px 8px", borderRadius:10, fontWeight:700, textTransform:"capitalize",
                  background: inv.status==="paid"?"#d4edda":inv.status==="emailed"?"#cce5ff":inv.status==="confirmed"?"#e8f4fd":"#fff3cd",
                  color: inv.status==="paid"?"#155724":inv.status==="emailed"?"#004085":inv.status==="confirmed"?"#2471A3":"#856404" }}>{inv.status}</div>
              </div>
            ));
          })()}
        </div>
      )}

      {/* ── INVOICE DETAIL ── */}
      {view === "invoiceDetail" && selectedInvoice && (
        <div style={{ maxWidth:560 }}>
          <button onClick={() => { if (selectedCustomer && mainTab==="customers") setView("customer"); else setView("list"); }} style={{ border:"none", background:"none", color:"#2471A3", fontWeight:700, fontSize:13, cursor:"pointer", marginBottom:16 }}>← Back</button>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
            <div>
              <div style={{ fontWeight:800, fontSize:20 }}>{selectedInvoice.invoiceNumber}</div>
              <div style={{ fontSize:13, color:"#888" }}>{selectedInvoice.customerName} · {fmtDate(selectedInvoice.date)}</div>
              {selectedInvoice.entity && selectedInvoice.entity !== "The Dumpling Factory" && (
                <div style={{ fontSize:12, color:"#2471A3", fontWeight:600, marginTop:2 }}>Billed from: {selectedInvoice.entity}</div>
              )}
            </div>
            <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
              {["draft","confirmed","emailed","paid"].map(s => (
                <button key={s} onClick={() => {
                  if (s === "paid" && selectedInvoice.status !== "paid") {
                    setPaymentForm({ method:"cash", ref:"" });
                    setPaymentModal(selectedInvoice);
                  } else {
                    const updated = externalInvoices.map(i => i.id===selectedInvoice.id ? {...i,status:s} : i);
                    saveExternalInvoices(updated);
                    setSelectedInvoice(prev=>({...prev,status:s}));
                    showToast(`Marked as ${s}`);
                  }
                }}
                  style={{ border:`2px solid ${selectedInvoice.status===s?"#1a1a1a":"#e5e5e5"}`, borderRadius:8, padding:"5px 12px",
                    fontSize:11, fontWeight:700, cursor:"pointer", background:selectedInvoice.status===s?"#1a1a1a":"#fff",
                    color:selectedInvoice.status===s?"#fff":"#888", textTransform:"capitalize" }}>{s}</button>
              ))}
            </div>
          </div>
          <div style={{ border:"1px solid #e8e8e8", borderRadius:10, overflow:"hidden", marginBottom:16 }}>
            <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
              <thead><tr style={{ background:"#f5f5f5" }}>
                {["Item","Qty","Price","Total"].map(h=><th key={h} style={{ padding:"8px 12px", textAlign:h==="Item"?"left":"right", fontWeight:700, fontSize:11, color:"#888", textTransform:"uppercase" }}>{h}</th>)}
              </tr></thead>
              <tbody>
                {selectedInvoice.items.map((it,i) => (
                  <tr key={i} style={{ borderTop:"1px solid #f0f0f0" }}>
                    <td style={{ padding:"8px 12px", fontWeight:600 }}>
                      <div>{it.customName || it.name}</div>
                      {it.customName && <div style={{ fontSize:11, color:"#aaa" }}>{it.name}</div>}
                      {/* lot dates intentionally hidden on wholesale invoice */}
                    </td>
                    <td style={{ padding:"8px 12px", textAlign:"right" }}>{it.qty}</td>
                    <td style={{ padding:"8px 12px", textAlign:"right" }}>${Number(it.price).toFixed(2)}</td>
                    <td style={{ padding:"8px 12px", textAlign:"right", fontWeight:700 }}>${(Number(it.price)*Number(it.qty)).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ display:"flex", justifyContent:"flex-end", marginBottom:16 }}>
            <div style={{ minWidth:200 }}>
              <div style={{ display:"flex", justifyContent:"space-between", padding:"10px 0", borderTop:"2px solid #1a1a1a", fontSize:17, fontWeight:800 }}>
                <span>Total</span><span>{fmtMoney(selectedInvoice.subtotal)}</span>
              </div>
            </div>
          </div>
          {selectedInvoice.note && <div style={{ marginBottom:16, padding:"10px 14px", background:"#FFFBF0", border:"1px solid #F39C12", borderRadius:8, fontSize:13, color:"#856404" }}>{selectedInvoice.note}</div>}

          {/* Payment details — shown when paid */}
          {selectedInvoice.status === "paid" && selectedInvoice.paymentMethod && (
            <div style={{ marginBottom:16, padding:"14px 16px", background:"#f0faf4", border:"1px solid #86EFAC", borderRadius:10, display:"flex", alignItems:"center", gap:12 }}>
              <div style={{ flex:1 }}>
                <div style={{ fontWeight:700, fontSize:13, color:"#15803D", marginBottom:6 }}>✓ Payment Recorded</div>
                <div style={{ fontSize:13, color:"#555" }}>
                  <strong>Method:</strong> {selectedInvoice.paymentMethod === "credit" ? "Credit/Debit Card" : selectedInvoice.paymentMethod === "check" ? "Check" : selectedInvoice.paymentMethod === "ach" ? "ACH / Direct Deposit" : "Cash"}
                  {selectedInvoice.paymentRef && (
                    <span style={{ marginLeft:12 }}>
                      <strong>{selectedInvoice.paymentMethod === "check" ? "Check #:" : selectedInvoice.paymentMethod === "ach" ? "Ref:" : "Last 4:"}</strong> {selectedInvoice.paymentRef}
                    </span>
                  )}
                  {selectedInvoice.paidAt && !editingPaymentDate && (
                    <span style={{ marginLeft:12, color:"#888", cursor:"pointer" }} onClick={()=>setEditingPaymentDate(true)} title="Click to edit">
                      {fmtDate(selectedInvoice.paidAt)} ✏️
                    </span>
                  )}
                  {editingPaymentDate && (
                    <span style={{ marginLeft:12 }}>
                      <input type="date" defaultValue={selectedInvoice.paidAt?.slice(0,10)}
                        style={{ border:"1px solid #86EFAC", borderRadius:6, padding:"2px 6px", fontSize:12, outline:"none" }}
                        onChange={e=>{
                          const d = e.target.value;
                          if (!d) return;
                          const updated = externalInvoices.map(i=>i.id===selectedInvoice.id?{...i,paidAt:d+"T12:00:00.000Z"}:i);
                          saveExternalInvoices(updated);
                          setSelectedInvoice(prev=>({...prev,paidAt:d+"T12:00:00.000Z"}));
                          setEditingPaymentDate(false);
                          showToast("Payment date updated ✓");
                        }}/>
                    </span>
                  )}
                </div>
              </div>
              <button onClick={() => {
                  setPaymentForm({ method: selectedInvoice.paymentMethod, ref: selectedInvoice.paymentRef || "" });
                  setPaymentModal(selectedInvoice);
                }}
                style={{ border:"1px solid #86EFAC", background:"#fff", borderRadius:8, padding:"5px 12px",
                  fontSize:12, fontWeight:700, cursor:"pointer", color:"#15803D", flexShrink:0 }}>
                ✏️ Edit
              </button>
            </div>
          )}

          {/* Attachments */}
          <div style={{ marginBottom:20, padding:"14px 16px", background:"#f8f8f8", borderRadius:10, border:"1px solid #e8e8e8" }}>
            <div style={{ fontWeight:700, fontSize:13, marginBottom:10 }}>📎 Attachments</div>
            {(selectedInvoice.attachments||[]).length === 0 && (
              <div style={{ fontSize:12, color:"#aaa", marginBottom:10 }}>No attachments yet. Upload signed invoices, checks, or receipts.</div>
            )}
            {(selectedInvoice.attachments||[]).map((att, i) => (
              <div key={i} style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 10px", background:"#fff", borderRadius:8, border:"1px solid #e5e5e5", marginBottom:6 }}>
                <span style={{ fontSize:18 }}>{att.type?.startsWith("image") ? "🖼" : "📄"}</span>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontSize:13, fontWeight:600, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{att.name}</div>
                  <div style={{ fontSize:11, color:"#aaa" }}>{att.uploadedAt ? fmtDate(att.uploadedAt) : ""}</div>
                </div>
                <a href={att.url} download={att.name} target="_blank" rel="noreferrer"
                  style={{ fontSize:11, fontWeight:700, color:"#2471A3", textDecoration:"none", flexShrink:0 }}>⬇ Download</a>
                {att.type?.startsWith("image") && (
                  <a href={att.url} target="_blank" rel="noreferrer"
                    style={{ fontSize:11, fontWeight:700, color:"#555", textDecoration:"none", flexShrink:0 }}>👁 View</a>
                )}
                <button onClick={async () => {
                    try {
                      if (att.path) await deleteObject(ref(storage, att.path));
                    } catch(e) { console.warn("Storage delete failed:", e); }
                    const newAtts = (selectedInvoice.attachments||[]).filter((_,j)=>j!==i);
                    const updated = externalInvoices.map(inv => inv.id===selectedInvoice.id ? {...inv, attachments:newAtts} : inv);
                    saveExternalInvoices(updated);
                    setSelectedInvoice(prev=>({...prev, attachments:newAtts}));
                  }}
                  style={{ background:"none", border:"none", color:"#ddd", fontSize:16, cursor:"pointer", flexShrink:0 }}
                  onMouseEnter={e=>e.target.style.color="#E74C3C"} onMouseLeave={e=>e.target.style.color="#ddd"}>×</button>
              </div>
            ))}
            <label style={{ display:"inline-flex", alignItems:"center", gap:6, padding:"8px 14px", borderRadius:8,
              border:"1px dashed #ccc", background:"#fff", cursor:"pointer", fontSize:12, fontWeight:700, color:"#555", marginTop:4 }}>
              ＋ Upload PDF or Image
              <input type="file" accept=".pdf,image/*" style={{ display:"none" }}
                onChange={async e => {
                  const file = e.target.files?.[0];
                  if (!file) return;
                  if (file.size > 10 * 1024 * 1024) { showToast("File must be under 10MB"); return; }
                  showToast("Uploading...");
                  try {
                    const path = `invoices/${selectedInvoice.id}/${Date.now()}_${file.name}`;
                    const storageRef = ref(storage, path);
                    await uploadBytes(storageRef, file);
                    const url = await getDownloadURL(storageRef);
                    const newAtt = { name:file.name, type:file.type, url, path, uploadedAt:new Date().toISOString() };
                    const newAtts = [...(selectedInvoice.attachments||[]), newAtt];
                    const updated = externalInvoices.map(inv => inv.id===selectedInvoice.id ? {...inv, attachments:newAtts} : inv);
                    saveExternalInvoices(updated);
                    setSelectedInvoice(prev=>({...prev, attachments:newAtts}));
                    showToast("✓ Attachment saved");
                  } catch(err) {
                    console.error("Upload failed:", err);
                    showToast("Upload failed — try again");
                  }
                  e.target.value = "";
                }}/>
            </label>
          </div>
          <div style={{ display:"flex", gap:10, flexWrap:"wrap", justifyContent:"space-between", alignItems:"center" }}>
            <div style={{ display:"flex", gap:8 }}>
              <button onClick={() => {
                  // Load invoice back into edit form — saves as update to existing invoice
                  setInvoiceForm({
                    editingInvoiceId: selectedInvoice.id,
                    customerId: selectedInvoice.customerId || "",
                    customerName: selectedInvoice.customerName,
                    customerEmail: selectedInvoice.customerEmail || "",
                    customerAddress: selectedInvoice.customerAddress || "",
                    date: selectedInvoice.date,
                    invoiceNumber: selectedInvoice.invoiceNumber || "",
                    entity: selectedInvoice.entity || "The Dumpling Factory",
                    items: selectedInvoice.items.map(it => ({ productId:it.productId, name:it.name, unit:it.unit, qty:it.qty, price:it.price, customName:it.customName||"", customItem:it.customItem||false })),
                    note: selectedInvoice.note || "",
                  });
                  setView("newInvoice");
                }}
                style={{ border:"1px solid #e5e5e5", background:"#fff", borderRadius:10, padding:"10px 16px", fontSize:13, fontWeight:700, cursor:"pointer", color:"#555" }}>
                ✏️ Edit
              </button>
              <button onClick={() => {
                  if (window.confirm(`Delete invoice ${selectedInvoice.invoiceNumber}? This cannot be undone.`)) {
                    saveExternalInvoices(externalInvoices.filter(i => i.id !== selectedInvoice.id));
                    setSelectedInvoice(null);
                    setView("list");
                    showToast("Invoice deleted");
                  }
                }}
                style={{ border:"2px solid #E74C3C", background:"#fff", borderRadius:10, padding:"10px 16px", fontSize:13, fontWeight:700, cursor:"pointer", color:"#E74C3C" }}>
                🗑 Delete
              </button>
            </div>
            <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
              <button onClick={() => printInvoice(selectedInvoice)}
                style={{ background:"#1a1a1a", color:"#fff", border:"none", borderRadius:12, padding:"12px 24px", fontSize:13, fontWeight:700, cursor:"pointer" }}>
                🖨 Print Invoice
              </button>
              {selectedInvoice.customerEmail && (
                <button onClick={async () => {
                  try {
                    const res = await fetch("/api/send-external-invoice", { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({invoice:selectedInvoice}) });
                    if (res.ok) {
                      const updated = externalInvoices.map(i => i.id===selectedInvoice.id ? {...i,status:"emailed"} : i);
                      saveExternalInvoices(updated);
                      setSelectedInvoice(prev=>({...prev,status:"emailed"}));
                      showToast("📧 Invoice emailed ✓");
                    } else { showToast("Email failed"); }
                  } catch(e) { showToast("Email error"); }
                }}
                  style={{ background:"#2471A3", color:"#fff", border:"none", borderRadius:12, padding:"12px 24px", fontSize:13, fontWeight:700, cursor:"pointer" }}>
                  📧 Email to {selectedInvoice.customerEmail}
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ── PAYMENT MODAL ── */}
      {/* ── STOCK WARNING MODAL (wholesale) ── */}
      {stockWarningModal && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.55)", zIndex:3300, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}>
          <div style={{ background:"#fff", borderRadius:16, width:"100%", maxWidth:420, padding:"24px", boxShadow:"0 20px 60px rgba(0,0,0,0.25)" }}>
            <div style={{ fontSize:28, marginBottom:8 }}>⚠️</div>
            <div style={{ fontWeight:800, fontSize:18, marginBottom:6 }}>Stock Shortfall</div>
            <div style={{ fontSize:13, color:"#555", marginBottom:16 }}>The following items exceed current inventory. You can still save — inventory may be produced specifically for this order.</div>
            <div style={{ background:"#FFF8F0", border:"1px solid #F39C12", borderRadius:10, padding:"12px 16px", marginBottom:20 }}>
              {stockWarningModal.shortfalls.map((s,i) => (
                <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"6px 0", borderTop: i>0?"1px solid #FCE5C0":"none" }}>
                  <span style={{ fontWeight:700, fontSize:13 }}>{s.name}</span>
                  <div style={{ textAlign:"right", fontSize:12 }}>
                    <span style={{ color:"#E67E22", fontWeight:700 }}>Ordered {s.ordered}</span>
                    <span style={{ color:"#aaa", margin:"0 6px" }}>·</span>
                    <span style={{ color:s.available===0?"#E74C3C":"#888" }}>Only {s.available} in stock</span>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ display:"flex", gap:10 }}>
              <button onClick={() => setStockWarningModal(null)}
                style={{ flex:1, padding:"12px", borderRadius:10, border:"1px solid #e5e5e5", background:"#fff", fontSize:13, fontWeight:700, cursor:"pointer", color:"#555" }}>
                Go Back
              </button>
              <button onClick={() => { const s = stockWarningModal; setStockWarningModal(null); saveInvoice(s.pendingStatus, true); }}
                style={{ flex:2, padding:"12px", borderRadius:10, border:"none", background:"#E67E22", fontSize:13, fontWeight:700, cursor:"pointer", color:"#fff" }}>
                Save Anyway
              </button>
            </div>
          </div>
        </div>
      )}

      {paymentModal && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:3200, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}
          onClick={() => setPaymentModal(null)}>
          <div style={{ background:"#fff", borderRadius:16, width:"100%", maxWidth:400, padding:"24px", boxShadow:"0 20px 60px rgba(0,0,0,0.25)" }}
            onClick={e=>e.stopPropagation()}>
            <div style={{ fontWeight:800, fontSize:18, marginBottom:4 }}>Record Payment</div>
            <div style={{ fontSize:13, color:"#888", marginBottom:20 }}>{paymentModal.invoiceNumber} · {fmtMoney(paymentModal.subtotal)}</div>

            {/* Method */}
            <div style={{ marginBottom:16 }}>
              <div style={{ fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:.5, marginBottom:8 }}>Payment Method</div>
              <div style={{ display:"flex", gap:8 }}>
                {[["cash","💵 Cash"],["check","🧾 Check"],["credit","💳 Credit/Debit"],["ach","🏦 ACH / Direct Deposit"]].map(([val,label]) => (
                  <button key={val} onClick={() => setPaymentForm(f=>({...f, method:val, ref:""}))}
                    style={{ flex:1, padding:"10px 6px", borderRadius:10, fontSize:12, fontWeight:700, cursor:"pointer",
                      border:`2px solid ${paymentForm.method===val?"#1a1a1a":"#e5e5e5"}`,
                      background: paymentForm.method===val?"#1a1a1a":"#fff",
                      color: paymentForm.method===val?"#fff":"#555" }}>
                    {label}
                  </button>
                ))}
              </div>
            </div>

            {/* Reference field for check or credit */}
            {(paymentForm.method === "check" || paymentForm.method === "credit" || paymentForm.method === "ach") && (
              <div style={{ marginBottom:20 }}>
                <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:.5, marginBottom:6 }}>
                  {paymentForm.method === "check" ? "Check Number" : paymentForm.method === "ach" ? "Reference / Last 4 of Account" : "Last 4 Digits"}
                </label>
                <input
                  type="text"
                  maxLength={paymentForm.method === "credit" ? 4 : 20}
                  inputMode="numeric"
                  placeholder={paymentForm.method === "check" ? "e.g. 1042" : paymentForm.method === "ach" ? "e.g. 6789" : "e.g. 4321"}
                  value={paymentForm.ref}
                  onChange={e => setPaymentForm(f=>({...f, ref:e.target.value.replace(/\D/,"")}))}
                  style={{ ...inputStyle, fontSize:16, fontWeight:700, letterSpacing:2 }}
                  autoFocus/>
              </div>
            )}

            <div style={{ display:"flex", gap:10, marginTop:8 }}>
              <button onClick={() => setPaymentModal(null)}
                style={{ flex:1, padding:"12px", borderRadius:10, border:"1px solid #e5e5e5", background:"#fff", fontSize:13, fontWeight:700, cursor:"pointer", color:"#555" }}>
                Cancel
              </button>
              <button onClick={() => {
                  const isEdit = paymentModal.status === "paid";
                  const paymentData = {
                    status: "paid",
                    paymentMethod: paymentForm.method,
                    paymentRef: paymentForm.ref || null,
                    paidAt: isEdit ? (paymentModal.paidAt || new Date().toISOString()) : new Date().toISOString(),
                  };
                  const updated = externalInvoices.map(i => i.id===paymentModal.id ? {...i, ...paymentData} : i);
                  saveExternalInvoices(updated);
                  setSelectedInvoice(prev => prev ? {...prev, ...paymentData} : prev);
                  setPaymentModal(null);
                  showToast(isEdit ? "✓ Payment updated" : "✓ Payment recorded");
                }}
                style={{ flex:2, padding:"12px", borderRadius:10, border:"none", background:"#1a1a1a", fontSize:13, fontWeight:700, cursor:"pointer", color:"#fff" }}>
                {paymentModal?.status === "paid" ? "✓ Update Payment" : "✓ Confirm Payment"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── REPORTS ── */}
      {mainTab === "reports" && view === "list" && (
        <WholesaleReportsContent
          reportFilter={reportFilter}
          setReportFilter={setReportFilter}
          wholesaleCustomers={wholesaleCustomers}
          externalInvoices={externalInvoices}
          products={products}
          fmtMoney={fmtMoney}
          fmtDate={fmtDate}
          setSelectedInvoice={setSelectedInvoice}
          setView={setView}
          showToast={showToast}
        />
      )}
    </div>
  );
}


// ── ReportsHub — unified reports landing for factory ─────────────────────────
function ReportsHub({ orders, saveOrders, restaurants, products, saveProducts, wholesaleCustomers, externalInvoices, showToast }) {
  const [section, setSection] = useState(null); // null | "restaurant" | "wholesale"

  const fmtMoney = (n) => `$${(Number(n)||0).toFixed(2)}`;
  const fmtDate  = (d) => d ? new Date(d).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}) : "—";

  if (!section) return (
    <div>
      <p style={{ fontSize:13, color:"#888", marginBottom:24 }}>Choose a report type to get started.</p>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))", gap:16 }}>
        {[
          { key:"restaurant", icon:"🍜", label:"Restaurant Reports", desc:"Order revenue, item sales, category breakdown, frequency & growth by location" },
          { key:"wholesale",  icon:"🏪", label:"Wholesale Reports",  desc:"Customer statements, invoices, aging, heat map & MoM growth" },
        ].map(({key,icon,label,desc}) => (
          <div key={key} onClick={()=>setSection(key)}
            style={{ background:"#fff", border:"1px solid #e8e8e8", borderRadius:16, padding:"22px 20px",
              cursor:"pointer", boxShadow:"0 1px 4px rgba(0,0,0,0.05)", transition:"all .15s" }}
            onMouseEnter={e=>{e.currentTarget.style.borderColor="#1a1a1a"; e.currentTarget.style.boxShadow="0 4px 16px rgba(0,0,0,0.1)";}}
            onMouseLeave={e=>{e.currentTarget.style.borderColor="#e8e8e8"; e.currentTarget.style.boxShadow="0 1px 4px rgba(0,0,0,0.05)";}}>
            <div style={{ fontSize:32, marginBottom:10 }}>{icon}</div>
            <div style={{ fontWeight:800, fontSize:16, marginBottom:4 }}>{label}</div>
            <div style={{ fontSize:12, color:"#888" }}>{desc}</div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div>
      <button onClick={()=>setSection(null)}
        style={{ border:"none", background:"none", color:"#2471A3", fontWeight:700, fontSize:13, cursor:"pointer", padding:0, marginBottom:20 }}>
        ← Reports
      </button>
      {section === "restaurant" && (
        <KitchenReports orders={orders} saveOrders={saveOrders} restaurants={restaurants} products={products} saveProducts={saveProducts} showToast={showToast}/>
      )}
      {section === "wholesale" && (
        <WholesaleReportsPanel
          wholesaleCustomers={wholesaleCustomers}
          externalInvoices={externalInvoices}
          products={products}
          fmtMoney={fmtMoney}
          fmtDate={fmtDate}
          showToast={showToast}
        />
      )}
    </div>
  );
}

// ── WholesaleReportsPanel — standalone version of wholesale reports for factory ──
function WholesaleReportsPanel({ wholesaleCustomers, externalInvoices, products, fmtMoney, fmtDate, showToast }) {
  const [reportFilter, setReportFilter] = useState({
    customerId:"all", month:"all", year: new Date().getFullYear(), reportType:"summary", entity:"all"
  });

  // Re-use the same report UI as WholesaleInvoiceTab by extracting the render logic
  // We pass a no-op setSelectedInvoice/setView since we're not in the invoice tab
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [view, setView] = useState("list");

  if (selectedInvoice && view === "invoiceDetail") {
    return (
      <div>
        <button onClick={()=>{setSelectedInvoice(null);setView("list");}}
          style={{ border:"none", background:"none", color:"#2471A3", fontWeight:700, fontSize:13, cursor:"pointer", padding:0, marginBottom:16 }}>
          ← Back to Reports
        </button>
        <div style={{ fontWeight:800, fontSize:18 }}>{selectedInvoice.invoiceNumber}</div>
        <div style={{ fontSize:13, color:"#888", marginBottom:16 }}>{selectedInvoice.customerName} · {fmtDate(selectedInvoice.date)}</div>
        <div style={{ border:"1px solid #e8e8e8", borderRadius:10, overflow:"hidden" }}>
          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
            <thead><tr style={{ background:"#f5f5f5" }}>
              {["Item","Qty","Price","Total"].map(h=><th key={h} style={{ padding:"8px 12px", textAlign:h==="Item"?"left":"right", fontSize:11, fontWeight:700, color:"#888", textTransform:"uppercase" }}>{h}</th>)}
            </tr></thead>
            <tbody>
              {selectedInvoice.items.map((it,i)=>(
                <tr key={i} style={{ borderTop:"1px solid #f0f0f0", background:i%2===0?"#fff":"#fafafa" }}>
                  <td style={{ padding:"8px 12px", fontWeight:600 }}>{it.customName||it.name}</td>
                  <td style={{ padding:"8px 12px", textAlign:"right" }}>{it.qty}</td>
                  <td style={{ padding:"8px 12px", textAlign:"right" }}>${Number(it.price).toFixed(2)}</td>
                  <td style={{ padding:"8px 12px", textAlign:"right", fontWeight:700 }}>${(Number(it.price)*Number(it.qty)).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={{ textAlign:"right", padding:"14px 0", fontWeight:800, fontSize:16 }}>Total: {fmtMoney(selectedInvoice.subtotal)}</div>
      </div>
    );
  }

  return <WholesaleReportsContent
    reportFilter={reportFilter} setReportFilter={setReportFilter}
    wholesaleCustomers={wholesaleCustomers} externalInvoices={externalInvoices}
    products={products} fmtMoney={fmtMoney} fmtDate={fmtDate}
    setSelectedInvoice={setSelectedInvoice} setView={setView} showToast={showToast}
  />;
}

// ── WholesaleReportsContent — shared report content used in both Wholesale tab and ReportsHub ──
function WholesaleReportsContent({ reportFilter, setReportFilter, wholesaleCustomers, externalInvoices, products, fmtMoney, fmtDate, setSelectedInvoice, setView, showToast }) {
  const MONTHS_LIST = ["January","February","March","April","May","June","July","August","September","October","November","December"];

  const filteredInvs = externalInvoices.filter(inv => {
    const d = new Date(inv.date);
    if (reportFilter.customerId !== "all" && String(inv.customerId) !== String(reportFilter.customerId)) return false;
    if (d.getFullYear() !== reportFilter.year) return false;
    if (reportFilter.month !== "all" && d.getMonth() !== Number(reportFilter.month)) return false;
    if (reportFilter.entity !== "all") {
      const invEntity = inv.entity || "The Dumpling Factory";
      if (invEntity !== reportFilter.entity) return false;
    }
    return true;
  });

  const total       = filteredInvs.reduce((s,i)=>s+(i.subtotal||0),0);
  const paid        = filteredInvs.filter(i=>i.status==="paid").reduce((s,i)=>s+(i.subtotal||0),0);
  const outstanding = total - paid;
  const rType       = reportFilter.reportType || "summary";
  const custName    = reportFilter.customerId === "all" ? "All Customers"
    : wholesaleCustomers.find(c=>String(c.id)===String(reportFilter.customerId))?.name || "Customer";
  const periodLabel = reportFilter.month === "all"
    ? String(reportFilter.year)
    : `${MONTHS_LIST[Number(reportFilter.month)]} ${reportFilter.year}`;

  return (
    <div>
      {/* Retention alerts */}
      {(() => {
        const RETENTION_DAYS = 45;
        const now = Date.now();
        const atRisk = wholesaleCustomers.filter(c => {
          if (c.archived) return false; // archived customers never alert
          const invs = externalInvoices.filter(i => i.customerId === c.id);
          if (!invs.length) return false;
          const last = Math.max(...invs.map(i => new Date(i.date).getTime()));
          return (now - last) > RETENTION_DAYS * 86400000;
        });
        if (!atRisk.length) return null;
        return (
          <div style={{ marginBottom:24, padding:"16px 20px", background:"#FFF8F0", border:"2px solid #F39C12", borderRadius:14 }}>
            <div style={{ fontWeight:800, fontSize:14, color:"#E67E22", marginBottom:10 }}>⚠️ {atRisk.length} Customer{atRisk.length!==1?"s":""} Haven't Ordered in {RETENTION_DAYS}+ Days</div>
            <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
              {atRisk.map(c => {
                const invs = externalInvoices.filter(i=>i.customerId===c.id);
                const last = new Date(Math.max(...invs.map(i=>new Date(i.date).getTime())));
                const days = Math.floor((now - last.getTime()) / 86400000);
                return <div key={c.id} style={{ background:"#fff", border:"1px solid #F39C12", borderRadius:10, padding:"8px 14px", fontSize:13 }}>
                  <strong>{c.name}</strong><span style={{ color:"#aaa", marginLeft:8 }}>{days} days ago</span>
                </div>;
              })}
            </div>
          </div>
        );
      })()}

      {/* Report type tabs */}
      <div style={{ display:"flex", gap:4, marginBottom:20, background:"#f0f0f0", borderRadius:10, padding:3, width:"fit-content", flexWrap:"wrap" }}>
        {[["summary","📊 Summary"],["statement","🧾 Statement"],["items","📦 Items Sold"],["aging","⏱ Aging"],["heatmap","🗓 Frequency"],["growth","📈 Growth"]].map(([k,l])=>(
          <button key={k} onClick={()=>setReportFilter(f=>({...f,reportType:k}))}
            style={{ border:"none", borderRadius:8, padding:"7px 14px", fontSize:12, fontWeight:700, cursor:"pointer",
              background:rType===k?"#1a1a1a":"transparent", color:rType===k?"#fff":"#666" }}>
            {l}
          </button>
        ))}
      </div>

      {/* Filters */}
      <div style={{ display:"flex", gap:10, marginBottom:20, flexWrap:"wrap", alignItems:"center" }}>
        <select value={reportFilter.customerId} onChange={e=>setReportFilter(f=>({...f,customerId:e.target.value}))}
          style={{ border:"1px solid #e5e5e5", borderRadius:8, padding:"7px 12px", fontSize:13, outline:"none" }}>
          <option value="all">All Customers</option>
          {wholesaleCustomers.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        <select value={reportFilter.entity||"all"} onChange={e=>setReportFilter(f=>({...f,entity:e.target.value}))}
          style={{ border:"1px solid #e5e5e5", borderRadius:8, padding:"7px 12px", fontSize:13, outline:"none" }}>
          <option value="all">All Entities</option>
          <option value="The Dumpling Factory">The Dumpling Factory</option>
          <option value="NV Foods">NV Foods</option>
          <option value="Vanessa's Dumpling House">Vanessa's Dumpling House</option>
        </select>
        <select value={reportFilter.month} onChange={e=>setReportFilter(f=>({...f,month:e.target.value}))}
          style={{ border:"1px solid #e5e5e5", borderRadius:8, padding:"7px 12px", fontSize:13, outline:"none" }}>
          <option value="all">All Months</option>
          {MONTHS_LIST.map((m,i)=><option key={i} value={i}>{m}</option>)}
        </select>
        <select value={reportFilter.year} onChange={e=>setReportFilter(f=>({...f,year:Number(e.target.value)}))}
          style={{ border:"1px solid #e5e5e5", borderRadius:8, padding:"7px 12px", fontSize:13, outline:"none" }}>
          {[2024,2025,2026,2027].map(y=><option key={y} value={y}>{y}</option>)}
        </select>
      </div>

      {/* Delegate to existing WholesaleInvoiceTab report content inline */}
      {rType === "summary" && (() => {
        const avgOrder = filteredInvs.length ? total/filteredInvs.length : 0;
        const daysTopay = filteredInvs.filter(i=>i.status==="paid"&&i.paidAt&&i.date).map(i=>Math.floor((new Date(i.paidAt)-new Date(i.date))/86400000));
        const avgDays = daysTopay.length ? Math.round(daysTopay.reduce((a,b)=>a+b,0)/daysTopay.length) : null;
        const byCustomer = wholesaleCustomers.map(c=>{
          const cinvs = filteredInvs.filter(i=>i.customerId===c.id);
          return {...c, invoices:cinvs, total:cinvs.reduce((s,i)=>s+(i.subtotal||0),0), paid:cinvs.filter(i=>i.status==="paid").reduce((s,i)=>s+(i.subtotal||0),0)};
        }).filter(c=>c.invoices.length).sort((a,b)=>b.total-a.total);
        return (
          <div>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(140px,1fr))", gap:12, marginBottom:24 }}>
              {[["Total Invoiced",fmtMoney(total),"#1a1a1a"],["Paid",fmtMoney(paid),"#27AE60"],["Outstanding",fmtMoney(outstanding),"#E74C3C"],["# Invoices",filteredInvs.length,"#2471A3"],["Avg Order",fmtMoney(avgOrder),"#8E44AD"],["Avg Days to Pay",avgDays!=null?`${avgDays}d`:"—","#E67E22"]].map(([l,v,col])=>(
                <div key={l} style={{ background:"#fff", border:"1px solid #e8e8e8", borderRadius:12, padding:"14px 16px" }}>
                  <div style={{ fontSize:10, color:"#888", fontWeight:700, textTransform:"uppercase", letterSpacing:.5 }}>{l}</div>
                  <div style={{ fontWeight:800, fontSize:20, marginTop:4, color:col }}>{v}</div>
                </div>
              ))}
            </div>
            {byCustomer.length > 0 && (
              <div style={{ background:"#fff", border:"1px solid #e8e8e8", borderRadius:12, overflow:"hidden" }}>
                <div style={{ padding:"12px 16px", background:"#f5f5f5", fontWeight:700, fontSize:12, color:"#888", display:"grid", gridTemplateColumns:"1fr 80px 80px 80px 80px" }}>
                  <span>CUSTOMER</span><span style={{textAlign:"right"}}>INVOICES</span><span style={{textAlign:"right"}}>TOTAL</span><span style={{textAlign:"right"}}>PAID</span><span style={{textAlign:"right"}}>OUTSTANDING</span>
                </div>
                {byCustomer.map((c,i)=>(
                  <div key={c.id} style={{ display:"grid", gridTemplateColumns:"1fr 80px 80px 80px 80px", padding:"11px 16px", alignItems:"center", borderTop:"1px solid #f0f0f0", background:i%2===0?"#fff":"#fafafa" }}>
                    <div style={{ fontWeight:700, fontSize:13 }}>{c.name}</div>
                    <div style={{ textAlign:"right", fontSize:13 }}>{c.invoices.length}</div>
                    <div style={{ textAlign:"right", fontSize:13, fontWeight:700 }}>{fmtMoney(c.total)}</div>
                    <div style={{ textAlign:"right", fontSize:13, color:"#27AE60" }}>{fmtMoney(c.paid)}</div>
                    <div style={{ textAlign:"right", fontSize:13, color:(c.total-c.paid)>0?"#E74C3C":"#aaa", fontWeight:700 }}>{fmtMoney(c.total-c.paid)}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })()}

      {rType === "aging" && (() => {
        const now2 = new Date();
        const unpaid = externalInvoices.filter(i=>{
          if (i.status==="paid"||i.status==="cancelled") return false;
          if (reportFilter.customerId!=="all"&&String(i.customerId)!==String(reportFilter.customerId)) return false;
          return true;
        }).map(i=>({...i, ageDays:Math.floor((now2-new Date(i.date))/86400000)})).sort((a,b)=>b.ageDays-a.ageDays);
        const buckets = [{label:"0–30 days",min:0,max:30,color:"#27AE60"},{label:"31–60 days",min:31,max:60,color:"#F39C12"},{label:"61–90 days",min:61,max:90,color:"#E67E22"},{label:"90+ days",min:91,max:9999,color:"#E74C3C"}];
        return (
          <div>
            <div style={{ display:"flex", gap:12, marginBottom:20, flexWrap:"wrap" }}>
              {buckets.map(b=>{
                const invs=unpaid.filter(i=>i.ageDays>=b.min&&i.ageDays<=b.max);
                const amt=invs.reduce((s,i)=>s+(i.subtotal||0),0);
                return <div key={b.label} style={{ background:"#fff", border:`2px solid ${b.color}20`, borderRadius:12, padding:"14px 18px", flex:1, minWidth:120 }}>
                  <div style={{ fontSize:11, fontWeight:700, color:b.color, textTransform:"uppercase", marginBottom:4 }}>{b.label}</div>
                  <div style={{ fontWeight:800, fontSize:20, color:b.color }}>{fmtMoney(amt)}</div>
                  <div style={{ fontSize:12, color:"#aaa" }}>{invs.length} invoice{invs.length!==1?"s":""}</div>
                </div>;
              })}
            </div>
            <div style={{ background:"#fff", border:"1px solid #e8e8e8", borderRadius:12, overflow:"hidden" }}>
              {unpaid.length===0
                ? <div style={{padding:32,textAlign:"center",color:"#aaa"}}>No outstanding invoices 🎉</div>
                : unpaid.map((inv,i)=>{
                  const bucket=buckets.find(b=>inv.ageDays>=b.min&&inv.ageDays<=b.max)||buckets[3];
                  return <div key={inv.id} onClick={()=>{setSelectedInvoice(inv);setView("invoiceDetail");}}
                    style={{ display:"flex", alignItems:"center", gap:14, padding:"12px 16px", borderTop:i?"1px solid #f0f0f0":"none", cursor:"pointer", background:i%2===0?"#fff":"#fafafa" }}>
                    <div style={{ width:8, height:8, borderRadius:"50%", background:bucket.color, flexShrink:0 }}/>
                    <div style={{ flex:1 }}>
                      <div style={{ fontWeight:700, fontSize:13 }}>{inv.invoiceNumber} — {inv.customerName}</div>
                      <div style={{ fontSize:11, color:"#888" }}>{fmtDate(inv.date)}</div>
                    </div>
                    <div style={{ fontWeight:700 }}>{fmtMoney(inv.subtotal)}</div>
                    <div style={{ fontSize:12, fontWeight:700, color:bucket.color, background:bucket.color+"15", padding:"3px 10px", borderRadius:8 }}>{inv.ageDays}d overdue</div>
                  </div>;
                })
              }
            </div>
          </div>
        );
      })()}

      {rType === "items" && (() => {
        const itemMap = {};
        filteredInvs.forEach(inv=>(inv.items||[]).forEach(it=>{
          const key = it.productId||it.name;
          if (!itemMap[key]) itemMap[key]={name:it.name,unit:it.unit,qty:0,revenue:0};
          itemMap[key].qty+=Number(it.qty)||0;
          itemMap[key].revenue+=(Number(it.price)||0)*(Number(it.qty)||0);
        }));
        const itemList=Object.values(itemMap).sort((a,b)=>b.revenue-a.revenue);
        const catMap={};
        filteredInvs.forEach(inv=>(inv.items||[]).forEach(it=>{
          const p=products.find(x=>String(x.id)===String(it.productId));
          const cat=p?.category||"Other";
          if (!catMap[cat]) catMap[cat]={qty:0,revenue:0};
          catMap[cat].qty+=Number(it.qty)||0;
          catMap[cat].revenue+=(Number(it.price)||0)*(Number(it.qty)||0);
        }));
        const catList=Object.entries(catMap).sort((a,b)=>b[1].revenue-a[1].revenue);
        return (
          <div>
            <div style={{ fontWeight:800, fontSize:15, marginBottom:12 }}>Top Items by Revenue & Quantity</div>
            <div style={{ background:"#fff", border:"1px solid #e8e8e8", borderRadius:12, overflow:"hidden", marginBottom:24 }}>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 70px 80px 80px 120px", padding:"10px 14px", background:"#f5f5f5", fontSize:11, fontWeight:700, color:"#888" }}>
                <span>ITEM</span><span style={{textAlign:"right"}}>QTY</span><span style={{textAlign:"right"}}>REVENUE</span><span style={{textAlign:"right"}}>AVG/UNIT</span><span style={{textAlign:"right"}}>% OF TOTAL</span>
              </div>
              {itemList.map((it,i)=>(
                <div key={i} style={{ display:"grid", gridTemplateColumns:"1fr 70px 80px 80px 120px", padding:"10px 14px", borderTop:"1px solid #f0f0f0", background:i%2===0?"#fff":"#fafafa", alignItems:"center" }}>
                  <div><div style={{ fontWeight:700, fontSize:13 }}>{it.name}</div><div style={{ fontSize:11, color:"#aaa" }}>{it.unit}</div></div>
                  <div style={{ textAlign:"right", fontSize:13, fontWeight:600 }}>{it.qty}</div>
                  <div style={{ textAlign:"right", fontSize:13, fontWeight:700 }}>{fmtMoney(it.revenue)}</div>
                  <div style={{ textAlign:"right", fontSize:12, color:"#888" }}>{it.qty>0?fmtMoney(it.revenue/it.qty):"—"}</div>
                  <div style={{ textAlign:"right", display:"flex", alignItems:"center", justifyContent:"flex-end", gap:6 }}>
                    <div style={{ background:"#e8e8e8", borderRadius:4, height:8, width:50, overflow:"hidden" }}>
                      <div style={{ background:"#1a1a1a", height:"100%", width:`${total>0?Math.round(it.revenue/total*100):0}%` }}/>
                    </div>
                    <span style={{ fontSize:11, color:"#888", minWidth:28 }}>{total>0?Math.round(it.revenue/total*100):0}%</span>
                  </div>
                </div>
              ))}
              {itemList.length===0&&<div style={{padding:24,textAlign:"center",color:"#aaa"}}>No items in this period</div>}
            </div>
            <div style={{ fontWeight:800, fontSize:15, marginBottom:12 }}>By Category</div>
            <div style={{ display:"flex", gap:10, flexWrap:"wrap" }}>
              {catList.map(([cat,data])=>(
                <div key={cat} style={{ background:"#fff", border:"1px solid #e8e8e8", borderRadius:12, padding:"14px 18px", minWidth:140 }}>
                  <div style={{ fontSize:11, color:"#888", fontWeight:700, textTransform:"uppercase", marginBottom:4 }}>{cat}</div>
                  <div style={{ fontWeight:800, fontSize:18 }}>{fmtMoney(data.revenue)}</div>
                  <div style={{ fontSize:12, color:"#aaa" }}>{data.qty} units</div>
                </div>
              ))}
            </div>
          </div>
        );
      })()}

      {rType === "statement" && (() => {
        const printStatement = () => {
          const w = window.open("","_blank","width=900,height=1100");
          if (!w) return;
          const cols = reportFilter.customerId==="all" ? ["Customer","Date","Invoice #","Amount","Status","Payment"] : ["Date","Invoice #","Amount","Status","Payment"];
          const rows = filteredInvs.sort((a,b)=>new Date(a.date)-new Date(b.date)).map(inv=>`<tr>
            ${reportFilter.customerId==="all"?`<td>${inv.customerName}</td>`:""}
            <td>${fmtDate(inv.date)}</td><td>${inv.invoiceNumber}</td>
            <td style="text-align:right">$${(inv.subtotal||0).toFixed(2)}</td>
            <td style="color:${inv.status==="paid"?"#155724":"#856404"};font-weight:700">${inv.status==="paid"?"✓ Paid":"Unpaid"}</td>
            <td>${inv.status==="paid"?(inv.paymentMethod==="check"?`Check #${inv.paymentRef||""}`:inv.paymentMethod==="credit"?`Card ···${inv.paymentRef||""}`:inv.paymentMethod==="ach"?`ACH${inv.paymentRef?` Ref:${inv.paymentRef}`:""}`:"Cash"):"—"}</td>
          </tr>`).join("");
          w.document.write(`<!DOCTYPE html><html><head><title>Statement — ${custName}</title>
            <style>body{font-family:Arial,sans-serif;padding:40px;max-width:800px;margin:0 auto}h1{font-size:22px;margin:0}h2{font-size:15px;color:#888;font-weight:normal;margin:4px 0 24px}table{width:100%;border-collapse:collapse;font-size:13px}th{background:#1a1a1a;color:#fff;padding:10px 12px;text-align:left}td{padding:9px 12px;border-bottom:1px solid #eee}tr:nth-child(even)td{background:#f9f9f9}.totals{text-align:right;padding:16px 0;font-size:15px}</style></head><body>
            <h1>Account Statement — ${custName}</h1><h2>Period: ${periodLabel}</h2>
            <table><thead><tr>${cols.map(c=>`<th>${c}</th>`).join("")}</tr></thead><tbody>${rows}</tbody></table>
            <div class="totals">Total: <strong>$${total.toFixed(2)}</strong> &nbsp;|&nbsp; Paid: <strong style="color:#155724">$${paid.toFixed(2)}</strong> &nbsp;|&nbsp; Outstanding: <strong style="color:#C0392B">$${outstanding.toFixed(2)}</strong></div>
            <script>window.onload=()=>window.print()</script></body></html>`);
          w.document.close();
        };
        const downloadExcel = () => {
          const doExport = (XLSX) => {
            const wb = XLSX.utils.book_new();
            const rows = [
              [`Account Statement — ${custName}`],[`Period: ${periodLabel}`],[],
              ["Customer","Date","Invoice #","Amount","Status","Payment Method","Payment Ref"],
              ...filteredInvs.sort((a,b)=>new Date(a.date)-new Date(b.date)).map(inv=>[
                inv.customerName,fmtDate(inv.date),inv.invoiceNumber,inv.subtotal||0,
                inv.status==="paid"?"Paid":"Unpaid",inv.paymentMethod||"",inv.paymentRef||""
              ]),
              [],["","","","Total:",total],["","","","Paid:",paid],["","","","Outstanding:",outstanding],
            ];
            const ws = XLSX.utils.aoa_to_sheet(rows);
            ws["!cols"]=[{wch:20},{wch:14},{wch:14},{wch:12},{wch:10},{wch:16},{wch:12}];
            XLSX.utils.book_append_sheet(wb,ws,"Statement");
            if (reportFilter.customerId==="all") {
              wholesaleCustomers.forEach(c=>{
                const cinvs=filteredInvs.filter(i=>i.customerId===c.id);
                if (!cinvs.length) return;
                const ct=cinvs.reduce((s,i)=>s+(i.subtotal||0),0);
                const cp=cinvs.filter(i=>i.status==="paid").reduce((s,i)=>s+(i.subtotal||0),0);
                const crows=[
                  [`Statement — ${c.name}`],[`Period: ${periodLabel}`],[],
                  ["Date","Invoice #","Amount","Status","Payment Method","Payment Ref"],
                  ...cinvs.sort((a,b)=>new Date(a.date)-new Date(b.date)).map(inv=>[fmtDate(inv.date),inv.invoiceNumber,inv.subtotal||0,inv.status==="paid"?"Paid":"Unpaid",inv.paymentMethod||"",inv.paymentRef||""]),
                  [],["","","","Total:",ct],["","","","Paid:",cp],["","","","Outstanding:",ct-cp],
                ];
                const cws=XLSX.utils.aoa_to_sheet(crows);
                XLSX.utils.book_append_sheet(wb,cws,c.name.slice(0,28));
              });
            }
            XLSX.writeFile(wb,`Statement-${custName.replace(/[^a-z0-9]/gi,"_")}-${periodLabel.replace(/\s/,"_")}.xlsx`);
          };
          if (window.XLSX) doExport(window.XLSX);
          else { const s=document.createElement("script"); s.src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js"; s.onload=()=>doExport(window.XLSX); document.head.appendChild(s); }
        };
        return (
          <div>
            <div style={{ display:"flex", gap:10, marginBottom:20, justifyContent:"flex-end" }}>
              <button onClick={printStatement} style={{ border:"1px solid #e5e5e5", background:"#fff", borderRadius:10, padding:"9px 18px", fontSize:13, fontWeight:700, cursor:"pointer", color:"#555" }}>🖨 Print / PDF</button>
              <button onClick={downloadExcel} style={{ background:"#1a1a1a", color:"#fff", border:"none", borderRadius:10, padding:"9px 18px", fontSize:13, fontWeight:700, cursor:"pointer" }}>📊 Download Excel</button>
            </div>
            <div style={{ background:"#fff", border:"1px solid #e8e8e8", borderRadius:14, overflow:"hidden" }}>
              <div style={{ background:"#1a1a1a", padding:"16px 20px", color:"#fff" }}>
                <div style={{ fontWeight:800, fontSize:16 }}>Account Statement — {custName}</div>
                <div style={{ fontSize:13, color:"rgba(255,255,255,0.6)", marginTop:2 }}>{periodLabel}</div>
              </div>
              <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
                <thead><tr style={{ background:"#f5f5f5" }}>
                  {[...(reportFilter.customerId==="all"?["Customer"]:[]),"Date","Invoice #","Amount","Status","Payment"].map(h=>(
                    <th key={h} style={{ padding:"10px 14px", textAlign:h==="Amount"?"right":"left", fontWeight:700, fontSize:11, color:"#888", textTransform:"uppercase" }}>{h}</th>
                  ))}
                </tr></thead>
                <tbody>
                  {filteredInvs.sort((a,b)=>new Date(a.date)-new Date(b.date)).map((inv,i)=>(
                    <tr key={inv.id} style={{ borderTop:"1px solid #f0f0f0", background:i%2===0?"#fff":"#fafafa" }}>
                      {reportFilter.customerId==="all"&&<td style={{ padding:"10px 14px", fontWeight:600 }}>{inv.customerName}</td>}
                      <td style={{ padding:"10px 14px" }}>{fmtDate(inv.date)}</td>
                      <td style={{ padding:"10px 14px", fontWeight:600 }}>{inv.invoiceNumber}</td>
                      <td style={{ padding:"10px 14px", textAlign:"right", fontWeight:700 }}>{fmtMoney(inv.subtotal)}</td>
                      <td style={{ padding:"10px 14px" }}>
                        <span style={{ fontSize:11, padding:"3px 8px", borderRadius:8, fontWeight:700, background:inv.status==="paid"?"#d4edda":"#fff3cd", color:inv.status==="paid"?"#155724":"#856404" }}>
                          {inv.status==="paid"?"✓ Paid":"Unpaid"}
                        </span>
                      </td>
                      <td style={{ padding:"10px 14px", fontSize:12, color:"#555" }}>
                        {inv.status==="paid"?(<>{inv.paymentMethod==="credit"?"💳 Credit/Debit":inv.paymentMethod==="check"?"🧾 Check":inv.paymentMethod==="ach"?"🏦 ACH":"💵 Cash"}{inv.paymentRef&&<span style={{ color:"#aaa", marginLeft:6 }}>#{inv.paymentRef}</span>}</>):"—"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div style={{ padding:"14px 20px", background:"#f8f8f8", display:"flex", gap:24, justifyContent:"flex-end", borderTop:"2px solid #1a1a1a" }}>
                <div style={{ fontSize:13 }}>Total: <strong>{fmtMoney(total)}</strong></div>
                <div style={{ fontSize:13, color:"#27AE60" }}>Paid: <strong>{fmtMoney(paid)}</strong></div>
                <div style={{ fontSize:13, color:"#E74C3C" }}>Outstanding: <strong>{fmtMoney(outstanding)}</strong></div>
              </div>
            </div>
            {filteredInvs.length===0&&<div style={{ textAlign:"center", padding:32, color:"#aaa" }}>No invoices in this period</div>}
          </div>
        );
      })()}

      {rType === "heatmap" && (() => {
        const MO = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        const custInvs = externalInvoices.filter(i=>reportFilter.customerId==="all"||String(i.customerId)===String(reportFilter.customerId));
        const allYrs = [...new Set(custInvs.map(i=>new Date(i.date).getFullYear()))].sort();
        const heatData={};
        custInvs.forEach(inv=>{const d=new Date(inv.date);const k=`${d.getFullYear()}-${d.getMonth()}`;if(!heatData[k])heatData[k]={count:0,revenue:0};heatData[k].count++;heatData[k].revenue+=inv.subtotal||0;});
        const maxCount=Math.max(1,...Object.values(heatData).map(d=>d.count));
        return (
          <div>
            <div style={{ fontWeight:800, fontSize:15, marginBottom:16 }}>Order Frequency by Month</div>
            <div style={{ overflowX:"auto" }}>
              <table style={{ borderCollapse:"collapse", fontSize:12 }}>
                <thead><tr><th style={{ padding:"8px 12px", textAlign:"left", color:"#aaa" }}>Year</th>{MO.map(m=><th key={m} style={{ padding:"8px 8px", color:"#aaa", width:48 }}>{m}</th>)}</tr></thead>
                <tbody>{allYrs.map(yr=>(
                  <tr key={yr}><td style={{ padding:"8px 12px", fontWeight:800 }}>{yr}</td>
                  {MO.map((_,mi)=>{const d=heatData[`${yr}-${mi}`];const intensity=d?d.count/maxCount:0;const bg=d?`rgba(26,26,26,${0.08+intensity*0.82})`:"#f5f5f5";return(
                    <td key={mi} style={{ padding:4 }}><div title={d?`${d.count} orders · ${fmtMoney(d.revenue)}`:"No orders"} style={{ width:40,height:36,borderRadius:6,background:bg,display:"flex",alignItems:"center",justifyContent:"center" }}>
                      {d&&<span style={{ fontSize:13,fontWeight:800,color:intensity>0.5?"#fff":"#1a1a1a" }}>{d.count}</span>}
                    </div></td>
                  );})}
                  </tr>
                ))}</tbody>
              </table>
            </div>
            <div style={{ fontSize:11, color:"#aaa", marginTop:12 }}>Darker = more orders. Hover for details.</div>
          </div>
        );
      })()}

      {rType === "growth" && (() => {
        const MO2=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        const custInvs2=externalInvoices.filter(i=>reportFilter.customerId==="all"||String(i.customerId)===String(reportFilter.customerId));
        const monthly={};
        custInvs2.forEach(inv=>{const d=new Date(inv.date);const k=`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}`;if(!monthly[k])monthly[k]=0;monthly[k]+=inv.subtotal||0;});
        const months=Object.keys(monthly).sort();
        const maxRev=Math.max(1,...Object.values(monthly));
        return (
          <div>
            <div style={{ fontWeight:800, fontSize:15, marginBottom:16 }}>Monthly Revenue</div>
            {months.length===0?<div style={{textAlign:"center",padding:32,color:"#aaa"}}>No data yet</div>:(
              <div style={{ background:"#fff", border:"1px solid #e8e8e8", borderRadius:12, padding:20 }}>
                <div style={{ display:"flex", alignItems:"flex-end", gap:6, height:160, overflowX:"auto", paddingBottom:8 }}>
                  {months.map((key,i)=>{
                    const rev=monthly[key];const [yr,mo]=key.split("-");const prev=i>0?monthly[months[i-1]]:null;
                    const pct=prev?Math.round((rev-prev)/prev*100):null;const barH=Math.max(4,Math.round(rev/maxRev*130));
                    return <div key={key} style={{ display:"flex",flexDirection:"column",alignItems:"center",gap:4,minWidth:48 }}>
                      {pct!==null&&<div style={{ fontSize:9,fontWeight:700,color:pct>=0?"#27AE60":"#E74C3C" }}>{pct>=0?"+":""}{pct}%</div>}
                      <div style={{ width:36,background:"#1a1a1a",borderRadius:"4px 4px 0 0",height:barH }} title={fmtMoney(rev)}/>
                      <div style={{ fontSize:10,color:"#aaa",textAlign:"center" }}>{MO2[Number(mo)-1]}</div>
                      <div style={{ fontSize:10,color:"#888",fontWeight:700 }}>{yr}</div>
                    </div>;
                  })}
                </div>
                <div style={{ marginTop:16,display:"flex",flexWrap:"wrap",gap:12 }}>
                  {months.slice(-3).reverse().map((key)=>{const[yr,mo]=key.split("-");return(
                    <div key={key} style={{ background:"#f8f8f8",borderRadius:10,padding:"10px 14px" }}>
                      <div style={{ fontSize:11,color:"#aaa" }}>{MO2[Number(mo)-1]} {yr}</div>
                      <div style={{ fontWeight:800,fontSize:16 }}>{fmtMoney(monthly[key])}</div>
                    </div>
                  );})}
                </div>
              </div>
            )}
          </div>
        );
      })()}
    </div>
  );
}

// ── FactoryItemsTab ────────────────────────────────────────────────────────────
function FactoryItemsTab({ products, setProducts, customCats=[], auth, showToast }) {
  const [search, setSearch] = useState("");
  const [editProduct, setEditProduct] = useState(null);
  const [saving, setSaving] = useState(false);

  const CAT_ORDER_LOCAL = ["Dumplings","Sauces","Beverages","Paper Goods","Dry Goods","Other"];
  const allCats = [...new Set([...CAT_ORDER_LOCAL, ...customCats, ...products.map(p=>p.category||"Other")])];

  const filtered = products.filter(p =>
    !search || p.name?.toLowerCase().includes(search.toLowerCase()) ||
    p.nameZh?.toLowerCase().includes(search.toLowerCase())
  );
  const grouped = allCats.reduce((acc, cat) => {
    const items = filtered.filter(p => (p.category||"Other") === cat);
    if (items.length) acc[cat] = items;
    return acc;
  }, {});

  const saveProducts = (updated) => { setProducts(updated); };

  const notifyItemChange = async (item, changeType, oldPrice) => {
    try {
      await fetch("/api/notify-item-change", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          item,
          changeType,
          oldPrice: oldPrice ?? null,
          changedBy: auth?.name || auth?.username || "Factory user",
        }),
      });
    } catch(e) { console.warn("Notify failed:", e); }
  };

  const handleSave = async (prod) => {
    setSaving(true);
    const isNew = !prod.id;
    const oldProduct = products.find(p => p.id === prod.id);
    const oldPrice = oldProduct?.price ?? null;
    const priceChanged = !isNew && oldPrice !== prod.price;

    const updated = isNew
      ? [...products, { ...prod, id: Date.now() }]
      : products.map(p => p.id === prod.id ? prod : p);

    saveProducts(updated);
    setEditProduct(null);
    showToast(isNew ? "Item added ✓" : "Item updated ✓");

    if (isNew || priceChanged) {
      await notifyItemChange(prod, isNew ? "added" : "price_changed", oldPrice);
    }
    setSaving(false);
  };

  const inputStyle = { border:"1px solid #e5e5e5", borderRadius:8, padding:"8px 12px", fontSize:13,
    fontFamily:"'IBM Plex Sans',sans-serif", outline:"none", width:"100%", boxSizing:"border-box" };

  return (
    <div>
      <div style={{display:"flex", gap:10, marginBottom:16, flexWrap:"wrap"}}>
        <input value={search} onChange={e=>setSearch(e.target.value)}
          placeholder="Search items..."
          style={{flex:1, minWidth:180, border:"1px solid #e5e5e5", borderRadius:9, padding:"9px 13px",
            fontSize:14, fontFamily:"'IBM Plex Sans',sans-serif", outline:"none"}}/>
        <button onClick={()=>setEditProduct({name:"",nameZh:"",category:allCats[0]||"Other",unit:"",price:null})}
          style={{background:"#1a1a1a", color:"#fff", border:"none", borderRadius:9, padding:"9px 16px",
            fontWeight:700, fontSize:13, cursor:"pointer", fontFamily:"'IBM Plex Sans',sans-serif"}}>
          + Add Item
        </button>
      </div>

      <div style={{fontSize:12, color:"#888", marginBottom:16, padding:"10px 14px", background:"#FFFBF0",
        border:"1px solid #F39C12", borderRadius:8}}>
        ⚠️ Adding items or changing prices will automatically notify Adam & Yuzhen by email.
      </div>

      {Object.entries(grouped).map(([cat, items]) => (
        <div key={cat} style={{marginBottom:18}}>
          <div style={{fontSize:11, fontWeight:700, color:"#aaa", textTransform:"uppercase",
            letterSpacing:.8, marginBottom:8, paddingLeft:2}}>
            {cat} · {items.length} items
          </div>
          <div style={{background:"#fff", border:"1px solid #e5e5e5", borderRadius:12, overflow:"hidden"}}>
            {items.map((p, i) => (
              <div key={p.id} style={{display:"flex", alignItems:"center", gap:12, padding:"11px 14px",
                borderBottom: i<items.length-1?"1px solid #f0f0f0":"none",
                background: i%2===0?"#fff":"#fafafa"}}>
                <div style={{flex:1, minWidth:0}}>
                  <div style={{fontWeight:700, fontSize:13}}>{p.name}</div>
                  <div style={{fontSize:11, color:"#bbb", marginTop:1}}>
                    {p.nameZh && <span style={{marginRight:8}}>{p.nameZh}</span>}
                    {p.unit}
                    {p.price != null
                      ? <span style={{marginLeft:8, color:"#555"}}>${p.price.toFixed(2)}</span>
                      : <span style={{marginLeft:8, color:"#F39C12", fontStyle:"italic"}}>Market Price</span>}
                  </div>
                </div>
                <button onClick={()=>setEditProduct({...p})}
                  style={{background:"#f0f0f0", border:"none", borderRadius:7, padding:"6px 12px",
                    fontSize:12, fontWeight:700, cursor:"pointer", color:"#555",
                    fontFamily:"'IBM Plex Sans',sans-serif"}}>Edit</button>
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* Edit / Add modal */}
      {editProduct && (
        <div style={{position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:3200,
          display:"flex", alignItems:"center", justifyContent:"center", padding:16}}
          onClick={()=>setEditProduct(null)}>
          <div style={{background:"#fff", borderRadius:16, width:"100%", maxWidth:440,
            padding:"24px", boxShadow:"0 20px 60px rgba(0,0,0,0.25)", maxHeight:"90vh", overflowY:"auto"}}
            onClick={e=>e.stopPropagation()}>
            <div style={{fontWeight:800, fontSize:18, marginBottom:20}}>
              {editProduct.id ? "Edit Item" : "New Item"}
            </div>
            {[["name","Item Name (English)",true],["nameZh","Item Name (Chinese)",false],["unit","Unit (e.g. case, bag, lb)",true]].map(([field,label,req])=>(
              <div key={field} style={{marginBottom:14}}>
                <label style={{display:"block", fontSize:11, fontWeight:700, color:"#888",
                  textTransform:"uppercase", letterSpacing:.5, marginBottom:6}}>
                  {label}{req&&<span style={{color:"#E74C3C"}}> *</span>}
                </label>
                <input value={editProduct[field]||""} onChange={e=>setEditProduct(p=>({...p,[field]:e.target.value}))}
                  style={inputStyle}/>
              </div>
            ))}
            <div style={{marginBottom:14}}>
              <label style={{display:"block", fontSize:11, fontWeight:700, color:"#888",
                textTransform:"uppercase", letterSpacing:.5, marginBottom:6}}>Category *</label>
              <select value={editProduct.category||""} onChange={e=>setEditProduct(p=>({...p,category:e.target.value}))}
                style={{...inputStyle}}>
                {allCats.map(c=><option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            <div style={{marginBottom:20}}>
              <label style={{display:"block", fontSize:11, fontWeight:700, color:"#888",
                textTransform:"uppercase", letterSpacing:.5, marginBottom:6}}>Price (leave blank for Market Price)</label>
              <div style={{display:"flex", alignItems:"center", gap:6}}>
                <span style={{color:"#aaa"}}>$</span>
                <input type="number" min="0" step="0.01"
                  value={editProduct.price ?? ""}
                  onChange={e=>setEditProduct(p=>({...p,price:e.target.value===""?null:parseFloat(e.target.value)}))}
                  style={{...inputStyle, width:120}}/>
              </div>
              {editProduct.id && products.find(p=>p.id===editProduct.id)?.price !== editProduct.price && editProduct.price !== null && (
                <div style={{fontSize:11, color:"#E67E22", marginTop:6, fontWeight:600}}>
                  ⚠️ Price change will notify Adam & Yuzhen
                </div>
              )}
            </div>
            <div style={{display:"flex", gap:10}}>
              <button onClick={()=>setEditProduct(null)}
                style={{flex:1, padding:"12px", borderRadius:10, border:"1px solid #e5e5e5",
                  background:"#fff", fontSize:13, fontWeight:700, cursor:"pointer", color:"#555"}}>
                Cancel
              </button>
              <button onClick={()=>handleSave(editProduct)} disabled={saving||!editProduct.name?.trim()}
                style={{flex:2, padding:"12px", borderRadius:10, border:"none",
                  background: editProduct.name?.trim()?"#1a1a1a":"#ccc",
                  color:"#fff", fontSize:13, fontWeight:700,
                  cursor: editProduct.name?.trim()?"pointer":"not-allowed"}}>
                {saving ? "Saving..." : editProduct.id ? "Save Changes" : "Add Item"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── OwnerView — read-only invoices, reports and chat ─────────────────────────
function OwnerView({ auth, orders, restaurants, products, externalInvoices, wholesaleCustomers, users, db, showToast, pName, fmtPrice, onSignOut }) {
  const [tab, setTab]                   = useState("home"); // "home"|"invoices"|"reports"|"chat"
  const [invoiceSection, setInvoiceSection] = useState("wholesale"); // "wholesale"|"restaurant"
  const [selectedOrder, setSelectedOrder]   = useState(null); // drill-in restaurant order
  const [selectedInvoice, setSelectedInvoice] = useState(null); // drill-in wholesale invoice
  const [filterRest, setFilterRest]     = useState("all");
  const [filterMonth, setFilterMonth]   = useState("all");
  const [filterYear, setFilterYear]     = useState(new Date().getFullYear());
  const [wsFilter, setWsFilter]         = useState({ customerId:"all", month:"all", year:new Date().getFullYear(), reportType:"summary" });
  const [reportSection, setReportSection] = useState("wholesale"); // "wholesale"|"restaurant"
  const [restReportFilter, setRestReportFilter] = useState({ restId:"all", month:"all", year:new Date().getFullYear() });

  const fmtDate  = (d) => d ? new Date(d).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}) : "—";
  const fmtMoney = (n) => `$${(Number(n)||0).toFixed(2)}`;
  const MONTHS   = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  const MO_SHORT = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

  const orderTotal = (o) => (o.items||[]).reduce((s,it) => {
    const p = products.find(x=>String(x.id)===String(it.productId));
    return s + (it.customPrice ?? p?.price ?? 0) * (it.qty||0);
  }, 0);

  const confirmedOrders = orders.filter(o =>
    ["confirmed","to_be_delivered","delivered","dispatched","preparing","[ok] confirmed"].includes(o.status?.toLowerCase())
  );

  // ── Print helpers ──
  const printRestOrder = (o) => {
    const rest = restaurants.find(r=>r.id===o.restaurantId);
    const w = window.open("","_blank");
    const rows = (o.items||[]).map(it => {
      const p = products.find(x=>String(x.id)===String(it.productId));
      const price = it.customPrice ?? p?.price ?? 0;
      return `<tr><td>${p?.name||it.name||"?"}</td><td style="text-align:center">${it.qty}</td><td style="text-align:right">$${price.toFixed(2)}</td><td style="text-align:right;font-weight:700">$${(price*it.qty).toFixed(2)}</td></tr>`;
    }).join("");
    w.document.write(`<!DOCTYPE html><html><head><title>Order #${o.invoiceNumber||o.id}</title>
      <style>body{font-family:Arial,sans-serif;padding:32px;max-width:700px;margin:0 auto}h2{margin:0}p{color:#888;margin:4px 0 20px}table{width:100%;border-collapse:collapse;font-size:13px}th{background:#1a1a1a;color:#fff;padding:9px 12px;text-align:left}td{padding:9px 12px;border-bottom:1px solid #eee}tr:nth-child(even)td{background:#f9f9f9}.total{text-align:right;padding:14px 0;font-size:16px;font-weight:800}</style></head><body>
      <h2>${rest?.name||"Unknown"} — Order #${o.invoiceNumber||o.id}</h2><p>${fmtDate(o.timestamp)}</p>
      <table><thead><tr><th>Item</th><th style="text-align:center">Qty</th><th style="text-align:right">Unit Price</th><th style="text-align:right">Total</th></tr></thead><tbody>${rows}</tbody></table>
      <div class="total">Total: ${fmtMoney(orderTotal(o))}</div>
      <script>window.onload=()=>window.print()</script></body></html>`);
    w.document.close();
  };

  const printWsInvoice = (inv) => {
    const w = window.open("","_blank");
    const rows = (inv.items||[]).map((it,i)=>`<tr style="background:${i%2===0?"#fff":"#f9f9f9"}"><td style="padding:9px 12px;font-weight:600">${it.customName||it.name}</td><td style="padding:9px 12px;color:#888">${it.unit}</td><td style="padding:9px 12px;text-align:center">${it.qty}</td><td style="padding:9px 12px;text-align:right">$${Number(it.price).toFixed(2)}</td><td style="padding:9px 12px;text-align:right;font-weight:700">$${(Number(it.price)*Number(it.qty)).toFixed(2)}</td></tr>`).join("");
    w.document.write(`<!DOCTYPE html><html><head><title>${inv.invoiceNumber}</title>
      <style>body{font-family:Arial,sans-serif;padding:32px;max-width:700px;margin:0 auto}h2{margin:0}p{color:#888;margin:4px 0 20px}table{width:100%;border-collapse:collapse;font-size:13px}th{background:#1a1a1a;color:#fff;padding:9px 12px;text-align:left}.total{text-align:right;padding:14px 0;font-size:16px;font-weight:800}</style></head><body>
      <h2>${inv.invoiceNumber} — ${inv.customerName}</h2><p>${fmtDate(inv.date)}</p>
      <table><thead><tr><th>Item</th><th>Unit</th><th style="text-align:center">Qty</th><th style="text-align:right">Price</th><th style="text-align:right">Total</th></tr></thead><tbody>${rows}</tbody></table>
      <div class="total">${fmtMoney(inv.subtotal)} &nbsp;·&nbsp; ${inv.status==="paid"?'<span style="color:#27AE60">✓ Paid</span>':'<span style="color:#C0392B">Unpaid</span>'}</div>
      <script>window.onload=()=>window.print()</script></body></html>`);
    w.document.close();
  };

  const TABS = [
    { key:"home",     icon:"🏠", label:"Home"     },
    { key:"invoices", icon:"🧾", label:"Invoices"  },
    { key:"reports",  icon:"📊", label:"Reports"   },
    { key:"chat",     icon:"💬", label:"Chat"      },
  ];

  const inputStyle = { border:"1px solid #e5e5e5", borderRadius:8, padding:"7px 12px", fontSize:13, outline:"none", background:"#fff" };

  return (
    <div style={{minHeight:"100vh", background:"#F2F0EC", fontFamily:"'IBM Plex Sans',sans-serif"}}>
      <style>{FONT}</style>

      {/* ── Top nav ── */}
      <div style={{background:"#1a1a1a", padding:"0 24px", display:"flex", alignItems:"center", gap:4, height:56, position:"sticky", top:0, zIndex:100, boxShadow:"0 2px 12px rgba(0,0,0,0.3)"}}>
        <img src={LOGO_NAV} alt="VDH" style={{height:22,width:"auto",maxWidth:140,marginRight:16}}/>
        {TABS.map(t => (
          <button key={t.key} onClick={()=>{setTab(t.key);setSelectedOrder(null);setSelectedInvoice(null);}}
            style={{border:"none",borderRadius:8,padding:"7px 14px",fontSize:13,fontWeight:700,cursor:"pointer",
              background:tab===t.key?"rgba(255,255,255,0.15)":"transparent",
              color:tab===t.key?"#fff":"rgba(255,255,255,0.5)",
              transition:"all .15s"}}>
            {t.icon} {t.label}
          </button>
        ))}
        <div style={{marginLeft:"auto",display:"flex",alignItems:"center",gap:12}}>
          <div style={{color:"rgba(255,255,255,0.6)",fontSize:12,fontWeight:600}}>{auth?.name}</div>
          <button onClick={onSignOut}
            style={{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.15)",borderRadius:7,padding:"5px 12px",color:"rgba(255,255,255,0.6)",fontSize:11,fontWeight:700,cursor:"pointer"}}>
            Sign out
          </button>
        </div>
      </div>

      {/* ── HOME ── */}
      {tab === "home" && (
        <div style={{maxWidth:900,margin:"0 auto",padding:"48px 24px"}}>
          <div style={{marginBottom:40}}>
            <h1 style={{fontFamily:"'Playfair Display',serif",fontSize:32,margin:"0 0 8px",color:"#1a1a1a"}}>
              Good {new Date().getHours()<12?"morning":new Date().getHours()<17?"afternoon":"evening"}, {auth?.name?.split(" ")[0]} 👋
            </h1>
            <p style={{color:"#888",fontSize:15,margin:0}}>{new Date().toLocaleDateString("en-US",{weekday:"long",month:"long",day:"numeric",year:"numeric"})}</p>
          </div>

          {/* Quick links */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:12}}>
            {[
              {key:"invoices",icon:"🧾",label:"View Invoices",desc:"Restaurant orders & wholesale invoices"},
              {key:"reports", icon:"📊",label:"Reports",      desc:"Sales, items, aging & growth"},
              {key:"chat",    icon:"💬",label:"Chat",         desc:"Message the team"},
            ].map(({key,icon,label,desc})=>(
              <div key={key} onClick={()=>setTab(key)}
                style={{background:"#fff",borderRadius:14,padding:"20px",cursor:"pointer",
                  boxShadow:"0 1px 4px rgba(0,0,0,0.06)",transition:"all .15s",
                  border:"1.5px solid transparent"}}
                onMouseEnter={e=>{e.currentTarget.style.borderColor="#1a1a1a";e.currentTarget.style.boxShadow="0 4px 16px rgba(0,0,0,0.1)";}}
                onMouseLeave={e=>{e.currentTarget.style.borderColor="transparent";e.currentTarget.style.boxShadow="0 1px 4px rgba(0,0,0,0.06)";}}>
                <div style={{fontSize:28,marginBottom:10}}>{icon}</div>
                <div style={{fontWeight:700,fontSize:15,marginBottom:4}}>{label}</div>
                <div style={{fontSize:12,color:"#aaa"}}>{desc}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ── INVOICES ── */}
      {tab === "invoices" && (
        <div style={{maxWidth:900,margin:"0 auto",padding:"28px 24px"}}>

          {/* Drill-in: wholesale invoice detail */}
          {selectedInvoice && (
            <div>
              <button onClick={()=>setSelectedInvoice(null)}
                style={{border:"none",background:"none",color:"#2471A3",fontWeight:700,fontSize:13,cursor:"pointer",padding:"0 0 16px"}}>
                ← Back to Invoices
              </button>
              <div style={{background:"#fff",borderRadius:16,overflow:"hidden",boxShadow:"0 1px 6px rgba(0,0,0,0.06)"}}>
                <div style={{background:"#1a1a1a",padding:"20px 24px",display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                  <div>
                    <div style={{color:"#fff",fontWeight:800,fontSize:20}}>{selectedInvoice.invoiceNumber}</div>
                    <div style={{color:"rgba(255,255,255,0.5)",fontSize:13,marginTop:4}}>{selectedInvoice.customerName} · {fmtDate(selectedInvoice.date)}</div>
                  </div>
                  <div style={{display:"flex",gap:8,alignItems:"center"}}>
                    <div style={{fontSize:12,padding:"4px 10px",borderRadius:8,fontWeight:700,
                      background:selectedInvoice.status==="paid"?"#d4edda":"#fff3cd",
                      color:selectedInvoice.status==="paid"?"#155724":"#856404"}}>{selectedInvoice.status}</div>
                    <button onClick={()=>printWsInvoice(selectedInvoice)}
                      style={{background:"rgba(255,255,255,0.15)",color:"#fff",border:"none",borderRadius:8,
                        padding:"7px 14px",fontSize:12,fontWeight:700,cursor:"pointer"}}>🖨 Print</button>
                  </div>
                </div>
                <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
                  <thead><tr style={{background:"#f5f5f5"}}>
                    {["Item","Unit","Qty","Unit Price","Total"].map(h=>(
                      <th key={h} style={{padding:"10px 16px",textAlign:["Qty","Unit Price","Total"].includes(h)?"right":"left",fontWeight:700,fontSize:11,color:"#888",textTransform:"uppercase"}}>{h}</th>
                    ))}
                  </tr></thead>
                  <tbody>
                    {(selectedInvoice.items||[]).map((it,i)=>(
                      <tr key={i} style={{borderTop:"1px solid #f0f0f0",background:i%2===0?"#fff":"#fafafa"}}>
                        <td style={{padding:"10px 16px",fontWeight:600}}>{it.customName||it.name}</td>
                        <td style={{padding:"10px 16px",color:"#aaa"}}>{it.unit}</td>
                        <td style={{padding:"10px 16px",textAlign:"right"}}>{it.qty}</td>
                        <td style={{padding:"10px 16px",textAlign:"right"}}>${Number(it.price).toFixed(2)}</td>
                        <td style={{padding:"10px 16px",textAlign:"right",fontWeight:700}}>${(Number(it.price)*Number(it.qty)).toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div style={{padding:"16px 24px",background:"#f8f8f8",display:"flex",justifyContent:"flex-end",gap:24,borderTop:"2px solid #1a1a1a"}}>
                  <div style={{fontSize:14}}>Total: <strong>{fmtMoney(selectedInvoice.subtotal)}</strong></div>
                  {selectedInvoice.paymentMethod && (
                    <div style={{fontSize:13,color:"#27AE60",fontWeight:700}}>
                      ✓ Paid · {selectedInvoice.paymentMethod==="check"?"Check":selectedInvoice.paymentMethod==="credit"?"Credit/Debit":selectedInvoice.paymentMethod==="ach"?"ACH":"Cash"}
                      {selectedInvoice.paymentRef&&` #${selectedInvoice.paymentRef}`}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Drill-in: restaurant order detail */}
          {selectedOrder && !selectedInvoice && (
            <div>
              <button onClick={()=>setSelectedOrder(null)}
                style={{border:"none",background:"none",color:"#2471A3",fontWeight:700,fontSize:13,cursor:"pointer",padding:"0 0 16px"}}>
                ← Back to Invoices
              </button>
              {(() => {
                const rest = restaurants.find(r=>r.id===selectedOrder.restaurantId);
                const total = orderTotal(selectedOrder);
                return (
                  <div style={{background:"#fff",borderRadius:16,overflow:"hidden",boxShadow:"0 1px 6px rgba(0,0,0,0.06)"}}>
                    <div style={{background:"#1a1a1a",padding:"20px 24px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div>
                        <div style={{color:"#fff",fontWeight:800,fontSize:20}}>{rest?.name||"Unknown"}</div>
                        <div style={{color:"rgba(255,255,255,0.5)",fontSize:13,marginTop:4}}>Order #{selectedOrder.id} · {fmtDate(selectedOrder.timestamp)}</div>
                      </div>
                      <button onClick={()=>printRestOrder(selectedOrder)}
                        style={{background:"rgba(255,255,255,0.15)",color:"#fff",border:"none",borderRadius:8,
                          padding:"7px 14px",fontSize:12,fontWeight:700,cursor:"pointer"}}>🖨 Print</button>
                    </div>
                    <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
                      <thead><tr style={{background:"#f5f5f5"}}>
                        {["Item","Qty","Unit Price","Total"].map(h=>(
                          <th key={h} style={{padding:"10px 16px",textAlign:["Qty","Unit Price","Total"].includes(h)?"right":"left",fontWeight:700,fontSize:11,color:"#888",textTransform:"uppercase"}}>{h}</th>
                        ))}
                      </tr></thead>
                      <tbody>
                        {(selectedOrder.items||[]).map((it,i)=>{
                          const p = products.find(x=>String(x.id)===String(it.productId));
                          const price = it.customPrice ?? p?.price ?? 0;
                          return (
                            <tr key={i} style={{borderTop:"1px solid #f0f0f0",background:i%2===0?"#fff":"#fafafa"}}>
                              <td style={{padding:"10px 16px",fontWeight:600}}>{p?.name||it.name||"?"}</td>
                              <td style={{padding:"10px 16px",textAlign:"right"}}>{it.qty}</td>
                              <td style={{padding:"10px 16px",textAlign:"right"}}>{price>0?`$${price.toFixed(2)}`:"—"}</td>
                              <td style={{padding:"10px 16px",textAlign:"right",fontWeight:700}}>{price>0?`$${(price*it.qty).toFixed(2)}`:"—"}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    <div style={{padding:"16px 24px",background:"#f8f8f8",textAlign:"right",borderTop:"2px solid #1a1a1a"}}>
                      <span style={{fontSize:14}}>Total: <strong>{fmtMoney(total)}</strong></span>
                    </div>
                  </div>
                );
              })()}
            </div>
          )}

          {/* Invoice list */}
          {!selectedInvoice && !selectedOrder && (
            <div>
              <div style={{display:"flex",gap:4,background:"#e8e8e8",borderRadius:10,padding:3,width:"fit-content",marginBottom:20}}>
                {[["wholesale","🏭 Wholesale"],["restaurant","🏪 Restaurant"]].map(([k,l])=>(
                  <button key={k} onClick={()=>setInvoiceSection(k)}
                    style={{border:"none",borderRadius:8,padding:"8px 16px",fontSize:13,fontWeight:700,cursor:"pointer",
                      background:invoiceSection===k?"#1a1a1a":"transparent",
                      color:invoiceSection===k?"#fff":"#666"}}>
                    {l}
                  </button>
                ))}
              </div>

              {invoiceSection === "wholesale" && (
                <div>
                  <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap",alignItems:"center"}}>
                    <select value={wsFilter.customerId} onChange={e=>setWsFilter(f=>({...f,customerId:e.target.value}))} style={inputStyle}>
                      <option value="all">All Customers</option>
                      {wholesaleCustomers.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
                    </select>
                    <select value={wsFilter.month} onChange={e=>setWsFilter(f=>({...f,month:e.target.value}))} style={inputStyle}>
                      <option value="all">All Months</option>
                      {MONTHS.map((m,i)=><option key={i} value={i}>{m}</option>)}
                    </select>
                    <select value={wsFilter.year} onChange={e=>setWsFilter(f=>({...f,year:Number(e.target.value)}))} style={inputStyle}>
                      {[2024,2025,2026,2027].map(y=><option key={y} value={y}>{y}</option>)}
                    </select>
                  </div>
                  {(() => {
                    const filtered = externalInvoices.filter(inv => {
                      const d = new Date(inv.date);
                      if (wsFilter.customerId !== "all" && String(inv.customerId) !== String(wsFilter.customerId)) return false;
                      if (d.getFullYear() !== wsFilter.year) return false;
                      if (wsFilter.month !== "all" && d.getMonth() !== Number(wsFilter.month)) return false;
                      return true;
                    }).sort((a,b)=>new Date(b.date)-new Date(a.date));
                    const total = filtered.reduce((s,i)=>s+(i.subtotal||0),0);
                    const paid  = filtered.filter(i=>i.status==="paid").reduce((s,i)=>s+(i.subtotal||0),0);
                    return (
                      <div>
                        <div style={{display:"flex",gap:12,marginBottom:16,flexWrap:"wrap"}}>
                          {[["Total",fmtMoney(total),"#1a1a1a"],["Paid",fmtMoney(paid),"#27AE60"],["Outstanding",fmtMoney(total-paid),"#C0392B"]].map(([l,v,c])=>(
                            <div key={l} style={{background:"#fff",borderRadius:12,padding:"12px 18px",flex:1,minWidth:110,boxShadow:"0 1px 4px rgba(0,0,0,0.05)"}}>
                              <div style={{fontSize:10,color:"#aaa",fontWeight:700,textTransform:"uppercase",marginBottom:4}}>{l}</div>
                              <div style={{fontWeight:800,fontSize:20,color:c}}>{v}</div>
                            </div>
                          ))}
                        </div>
                        {filtered.length===0
                          ? <div style={{textAlign:"center",padding:40,color:"#aaa"}}>No invoices in this period</div>
                          : filtered.map(inv=>(
                            <div key={inv.id} onClick={()=>setSelectedInvoice(inv)}
                              style={{background:"#fff",border:"1px solid #e8e8e8",borderRadius:12,
                                padding:"14px 16px",marginBottom:8,display:"flex",alignItems:"center",gap:12,
                                cursor:"pointer",transition:"border .15s"}}
                              onMouseEnter={e=>e.currentTarget.style.borderColor="#1a1a1a"}
                              onMouseLeave={e=>e.currentTarget.style.borderColor="#e8e8e8"}>
                              <div style={{flex:1}}>
                                <div style={{fontWeight:700,fontSize:14}}>{inv.invoiceNumber} — {inv.customerName}</div>
                                <div style={{fontSize:12,color:"#aaa",marginTop:2}}>{fmtDate(inv.date)} · {(inv.items||[]).length} items</div>
                              </div>
                              <div style={{fontWeight:800,fontSize:16}}>{fmtMoney(inv.subtotal)}</div>
                              <div style={{fontSize:11,padding:"3px 10px",borderRadius:8,fontWeight:700,
                                background:inv.status==="paid"?"#d4edda":"#fff3cd",
                                color:inv.status==="paid"?"#155724":"#856404"}}>{inv.status}</div>
                              <span style={{color:"#ccc",fontSize:18}}>›</span>
                            </div>
                          ))
                        }
                      </div>
                    );
                  })()}
                </div>
              )}

              {invoiceSection === "restaurant" && (
                <div>
                  <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap",alignItems:"center"}}>
                    <select value={filterRest} onChange={e=>setFilterRest(e.target.value)} style={inputStyle}>
                      <option value="all">All Locations</option>
                      {restaurants.map(r=><option key={r.id} value={r.id}>{r.name}</option>)}
                    </select>
                    <select value={filterMonth} onChange={e=>setFilterMonth(e.target.value)} style={inputStyle}>
                      <option value="all">All Months</option>
                      {MONTHS.map((m,i)=><option key={i} value={i}>{m}</option>)}
                    </select>
                    <select value={filterYear} onChange={e=>setFilterYear(Number(e.target.value))} style={inputStyle}>
                      {[2024,2025,2026,2027].map(y=><option key={y} value={y}>{y}</option>)}
                    </select>
                  </div>
                  {(() => {
                    const filtered = confirmedOrders.filter(o => {
                      if (filterRest !== "all" && String(o.restaurantId) !== String(filterRest)) return false;
                      const d = new Date(o.timestamp);
                      if (d.getFullYear() !== filterYear) return false;
                      if (filterMonth !== "all" && d.getMonth() !== Number(filterMonth)) return false;
                      return true;
                    }).sort((a,b)=>new Date(b.timestamp)-new Date(a.timestamp));
                    const total = filtered.reduce((s,o)=>s+orderTotal(o),0);
                    return (
                      <div>
                        <div style={{fontSize:13,color:"#888",marginBottom:12,fontWeight:600}}>
                          {filtered.length} orders · {fmtMoney(total)} total
                        </div>
                        {filtered.length===0
                          ? <div style={{textAlign:"center",padding:40,color:"#aaa"}}>No orders in this period</div>
                          : filtered.map(o=>{
                            const rest = restaurants.find(r=>r.id===o.restaurantId);
                            return (
                              <div key={o.id} onClick={()=>setSelectedOrder(o)}
                                style={{background:"#fff",border:"1px solid #e8e8e8",borderRadius:12,
                                  padding:"14px 16px",marginBottom:8,display:"flex",alignItems:"center",gap:12,
                                  cursor:"pointer",transition:"border .15s"}}
                                onMouseEnter={e=>e.currentTarget.style.borderColor="#1a1a1a"}
                                onMouseLeave={e=>e.currentTarget.style.borderColor="#e8e8e8"}>
                                <div style={{width:10,height:10,borderRadius:"50%",background:rest?.color||"#888",flexShrink:0}}/>
                                <div style={{flex:1}}>
                                  <div style={{fontWeight:700,fontSize:14}}>{rest?.name||"Unknown"}</div>
                                  <div style={{fontSize:12,color:"#aaa",marginTop:2}}>{fmtDate(o.timestamp)} · {(o.items||[]).length} items · #{o.id}</div>
                                </div>
                                <div style={{fontWeight:800,fontSize:16}}>{fmtMoney(orderTotal(o))}</div>
                                <span style={{color:"#ccc",fontSize:18}}>›</span>
                              </div>
                            );
                          })
                        }
                      </div>
                    );
                  })()}
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {/* ── REPORTS ── */}
      {tab === "reports" && (
        <div style={{maxWidth:900,margin:"0 auto",padding:"28px 24px"}}>
          <div style={{display:"flex",gap:4,background:"#e8e8e8",borderRadius:10,padding:3,width:"fit-content",marginBottom:24}}>
            {[["wholesale","🏭 Wholesale"],["restaurant","🏪 Restaurant"]].map(([k,l])=>(
              <button key={k} onClick={()=>setReportSection(k)}
                style={{border:"none",borderRadius:8,padding:"8px 16px",fontSize:13,fontWeight:700,cursor:"pointer",
                  background:reportSection===k?"#1a1a1a":"transparent",
                  color:reportSection===k?"#fff":"#666"}}>
                {l}
              </button>
            ))}
          </div>

          {reportSection === "wholesale" && (
            <WholesaleReportsContent
              reportFilter={wsFilter} setReportFilter={setWsFilter}
              wholesaleCustomers={wholesaleCustomers} externalInvoices={externalInvoices}
              products={products} fmtMoney={fmtMoney} fmtDate={fmtDate}
              setSelectedInvoice={()=>{}} setView={()=>{}} showToast={showToast}
            />
          )}

          {reportSection === "restaurant" && (() => {
            const rf = restReportFilter;
            const filtered = confirmedOrders.filter(o => {
              if (rf.restId !== "all" && String(o.restaurantId) !== String(rf.restId)) return false;
              const d = new Date(o.timestamp);
              if (d.getFullYear() !== rf.year) return false;
              if (rf.month !== "all" && d.getMonth() !== Number(rf.month)) return false;
              return true;
            });
            // Item breakdown
            const itemMap = {};
            filtered.forEach(o => (o.items||[]).forEach(it => {
              const p = products.find(x=>String(x.id)===String(it.productId));
              const key = it.productId||it.name;
              if (!itemMap[key]) itemMap[key] = { name:p?.name||it.name||"?", category:p?.category||"Other", qty:0, revenue:0 };
              itemMap[key].qty += Number(it.qty)||0;
              const price = it.customPrice ?? p?.price ?? 0;
              itemMap[key].revenue += price * (Number(it.qty)||0);
            }));
            const itemList = Object.values(itemMap).sort((a,b)=>b.qty-a.qty);
            const totalRevenue = itemList.reduce((s,i)=>s+i.revenue,0);
            const totalQty = itemList.reduce((s,i)=>s+i.qty,0);
            // Category breakdown
            const catMap = {};
            itemList.forEach(it => {
              if (!catMap[it.category]) catMap[it.category] = { qty:0, revenue:0 };
              catMap[it.category].qty += it.qty;
              catMap[it.category].revenue += it.revenue;
            });
            const catList = Object.entries(catMap).sort((a,b)=>b[1].qty-a[1].qty);
            // Monthly trend
            const monthlyMap = {};
            filtered.forEach(o => {
              const d = new Date(o.timestamp);
              const key = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}`;
              if (!monthlyMap[key]) monthlyMap[key] = { revenue:0, count:0 };
              monthlyMap[key].revenue += orderTotal(o);
              monthlyMap[key].count++;
            });
            const months = Object.keys(monthlyMap).sort();
            const maxRev = Math.max(1,...Object.values(monthlyMap).map(m=>m.revenue));

            // Excel export
            const exportExcel = () => {
              const doExport = (XLSX) => {
                const wb = XLSX.utils.book_new();
                // Items sheet
                const itemRows = [["Item","Category","Qty Ordered","Revenue"],
                  ...itemList.map(it=>[it.name,it.category,it.qty,it.revenue])];
                const ws1 = XLSX.utils.aoa_to_sheet(itemRows);
                XLSX.utils.book_append_sheet(wb, ws1, "Items");
                // Category sheet
                const catRows = [["Category","Qty","Revenue"],...catList.map(([c,d])=>[c,d.qty,d.revenue])];
                const ws2 = XLSX.utils.aoa_to_sheet(catRows);
                XLSX.utils.book_append_sheet(wb, ws2, "Categories");
                XLSX.writeFile(wb, `Restaurant-Report-${rf.year}.xlsx`);
              };
              if (window.XLSX) doExport(window.XLSX);
              else { const s=document.createElement("script"); s.src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js"; s.onload=()=>doExport(window.XLSX); document.head.appendChild(s); }
            };

            return (
              <div>
                {/* Filters */}
                <div style={{display:"flex",gap:8,marginBottom:20,flexWrap:"wrap",alignItems:"center"}}>
                  <select value={rf.restId} onChange={e=>setRestReportFilter(f=>({...f,restId:e.target.value}))} style={inputStyle}>
                    <option value="all">All Locations</option>
                    {restaurants.map(r=><option key={r.id} value={r.id}>{r.name}</option>)}
                  </select>
                  <select value={rf.month} onChange={e=>setRestReportFilter(f=>({...f,month:e.target.value}))} style={inputStyle}>
                    <option value="all">All Months</option>
                    {MONTHS.map((m,i)=><option key={i} value={i}>{m}</option>)}
                  </select>
                  <select value={rf.year} onChange={e=>setRestReportFilter(f=>({...f,year:Number(e.target.value)}))} style={inputStyle}>
                    {[2024,2025,2026,2027].map(y=><option key={y} value={y}>{y}</option>)}
                  </select>
                  <button onClick={exportExcel}
                    style={{marginLeft:"auto",background:"#1a1a1a",color:"#fff",border:"none",borderRadius:8,
                      padding:"8px 16px",fontSize:12,fontWeight:700,cursor:"pointer"}}>
                    📊 Export Excel
                  </button>
                </div>

                {/* Summary KPIs */}
                <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:12,marginBottom:24}}>
                  {[["Orders",filtered.length,"#1a1a1a"],["Total Units",totalQty,"#2471A3"],["Revenue",fmtMoney(totalRevenue),"#27AE60"],["Avg Order",fmtMoney(filtered.length?totalRevenue/filtered.length:0),"#8E44AD"]].map(([l,v,c])=>(
                    <div key={l} style={{background:"#fff",borderRadius:12,padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.05)"}}>
                      <div style={{fontSize:10,color:"#aaa",fontWeight:700,textTransform:"uppercase",marginBottom:6}}>{l}</div>
                      <div style={{fontWeight:800,fontSize:20,color:c}}>{v}</div>
                    </div>
                  ))}
                </div>

                {/* Monthly bar chart */}
                {months.length > 0 && (
                  <div style={{background:"#fff",borderRadius:14,padding:"20px",marginBottom:20,boxShadow:"0 1px 4px rgba(0,0,0,0.05)"}}>
                    <div style={{fontWeight:700,fontSize:14,marginBottom:16}}>Monthly Revenue</div>
                    <div style={{display:"flex",alignItems:"flex-end",gap:8,height:120,overflowX:"auto",paddingBottom:8}}>
                      {months.map(key=>{
                        const d = monthlyMap[key];
                        const [yr,mo] = key.split("-");
                        const barH = Math.max(4,Math.round(d.revenue/maxRev*100));
                        return (
                          <div key={key} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:4,minWidth:52}}>
                            <div style={{fontSize:10,fontWeight:700,color:"#888"}}>{fmtMoney(d.revenue)}</div>
                            <div style={{width:40,background:"#1a1a1a",borderRadius:"4px 4px 0 0",height:barH}}/>
                            <div style={{fontSize:10,color:"#aaa"}}>{MO_SHORT[Number(mo)-1]}</div>
                            <div style={{fontSize:9,color:"#ccc"}}>{yr}</div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* Items by quantity */}
                <div style={{background:"#fff",borderRadius:14,overflow:"hidden",marginBottom:20,boxShadow:"0 1px 4px rgba(0,0,0,0.05)"}}>
                  <div style={{padding:"14px 16px",fontWeight:700,fontSize:14,borderBottom:"1px solid #f0f0f0"}}>Top Items by Quantity</div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 60px 90px 100px",padding:"8px 16px",background:"#f8f8f8",fontSize:10,fontWeight:700,color:"#aaa",textTransform:"uppercase"}}>
                    <span>Item</span><span style={{textAlign:"right"}}>Qty</span><span style={{textAlign:"right"}}>Revenue</span><span style={{textAlign:"right"}}>% of Total</span>
                  </div>
                  {itemList.slice(0,20).map((it,i)=>(
                    <div key={i} style={{display:"grid",gridTemplateColumns:"1fr 60px 90px 100px",padding:"10px 16px",
                      borderTop:"1px solid #f0f0f0",background:i%2===0?"#fff":"#fafafa",alignItems:"center"}}>
                      <div>
                        <div style={{fontWeight:600,fontSize:13}}>{it.name}</div>
                        <div style={{fontSize:11,color:"#aaa"}}>{it.category}</div>
                      </div>
                      <div style={{textAlign:"right",fontWeight:700}}>{it.qty}</div>
                      <div style={{textAlign:"right",fontSize:13}}>{it.revenue>0?fmtMoney(it.revenue):"—"}</div>
                      <div style={{textAlign:"right",display:"flex",alignItems:"center",justifyContent:"flex-end",gap:6}}>
                        <div style={{background:"#e8e8e8",borderRadius:4,height:6,width:40,overflow:"hidden"}}>
                          <div style={{background:"#1a1a1a",height:"100%",width:`${totalQty>0?Math.round(it.qty/totalQty*100):0}%`}}/>
                        </div>
                        <span style={{fontSize:11,color:"#888",minWidth:28}}>{totalQty>0?Math.round(it.qty/totalQty*100):0}%</span>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Category breakdown */}
                <div style={{background:"#fff",borderRadius:14,overflow:"hidden",boxShadow:"0 1px 4px rgba(0,0,0,0.05)"}}>
                  <div style={{padding:"14px 16px",fontWeight:700,fontSize:14,borderBottom:"1px solid #f0f0f0"}}>By Category</div>
                  {catList.map(([cat,data],i)=>(
                    <div key={cat} style={{display:"flex",alignItems:"center",gap:16,padding:"12px 16px",
                      borderTop:i?"1px solid #f0f0f0":"none",background:i%2===0?"#fff":"#fafafa"}}>
                      <div style={{flex:1,fontWeight:600,fontSize:13}}>{cat}</div>
                      <div style={{fontSize:13,color:"#888"}}>{data.qty} units</div>
                      <div style={{fontWeight:700,fontSize:13}}>{data.revenue>0?fmtMoney(data.revenue):"—"}</div>
                      <div style={{width:80,background:"#e8e8e8",borderRadius:4,height:6,overflow:"hidden"}}>
                        <div style={{background:"#1a1a1a",height:"100%",width:`${totalQty>0?Math.round(data.qty/totalQty*100):0}%`}}/>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })()}
        </div>
      )}

      {/* ── CHAT ── */}
      {tab === "chat" && (
        <div style={{height:"calc(100vh - 56px)"}}>
          <ChatTab auth={auth} users={users} restaurants={restaurants} db={db} showToast={showToast}/>
        </div>
      )}
    </div>
  );
}

// ── ChatTab — internal messaging for all staff ────────────────────────────────
function ChatTab({ auth, users, restaurants, db, showToast }) {
  const [channels, setChannels]       = useState([]); // {id, type, name, participants, unread}
  const [activeChannel, setActiveChannel] = useState(null);
  const [messages, setMessages]       = useState([]);
  const [input, setInput]             = useState("");
  const [imageFile, setImageFile]     = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [uploading, setUploading]     = useState(false);
  const [showNewChat, setShowNewChat] = useState(false);
  const [newChatType, setNewChatType] = useState("dm"); // "dm" | "group"
  const [newChatName, setNewChatName] = useState("");
  const [newChatUsers, setNewChatUsers] = useState([]);
  const [unreadMap, setUnreadMap]     = useState({});
  const messagesEndRef = useRef(null);
  const fileInputRef   = useRef(null);
  const isAdmin = auth?.role === "admin";

  // ── Build location channels from restaurants ──
  const locationChannels = useMemo(() => [
    ...restaurants.map(r => ({ id:`loc_${r.id}`, type:"location", name:r.name, color:r.color, participants:[] })),
    { id:"loc_factory", type:"location", name:"Factory", color:"#1a1a1a", participants:[] },
    { id:"loc_general", type:"location", name:"General", color:"#555", participants:[] },
  ], [restaurants]);

  // ── Load DM/group channels from Firestore ──
  useEffect(() => {
    if (!db) return;
    const { collection: col, query, where, onSnapshot: snap, orderBy } = window._firestore || {};
    // Use the already-imported Firestore functions via db
    import("firebase/firestore").then(({ collection, query, where, onSnapshot, orderBy: fbOrderBy }) => {
      const uid = String(auth?.userId);
      const q = query(
        collection(db, "chatChannels"),
        where("participants", "array-contains", uid)
      );
      const unsub = onSnapshot(q, (snapshot) => {
        const chans = snapshot.docs.map(d => ({id:d.id, ...d.data()}));
        setChannels(chans);
      });
      return () => unsub();
    });
  }, [db, auth?.userId]);

  // ── Load messages for active channel ──
  useEffect(() => {
    if (!activeChannel || !db) return;
    import("firebase/firestore").then(({ collection, query, orderBy, onSnapshot, limit }) => {
      const q = query(
        collection(db, "chatChannels", activeChannel.id, "messages"),
        orderBy("timestamp", "asc"),
        limit(200)
      );
      const unsub = onSnapshot(q, (snapshot) => {
        setMessages(snapshot.docs.map(d => ({id:d.id, ...d.data()})));
        // Mark read
        setUnreadMap(m => ({...m, [activeChannel.id]: 0}));
      });
      return () => unsub();
    });
  }, [activeChannel?.id, db]);

  // ── Track unread for non-active channels ──
  useEffect(() => {
    if (!db) return;
    import("firebase/firestore").then(({ collection, query, orderBy, onSnapshot, limit }) => {
      const unsubs = locationChannels.map(chan => {
        const q = query(
          collection(db, "chatChannels", chan.id, "messages"),
          orderBy("timestamp", "desc"),
          limit(1)
        );
        return onSnapshot(q, (snap) => {
          if (!snap.empty) {
            const last = snap.docs[0].data();
            if (last.senderId !== String(auth?.userId) && activeChannel?.id !== chan.id) {
              setUnreadMap(m => ({...m, [chan.id]: (m[chan.id]||0)+1}));
            }
          }
        });
      });
      return () => unsubs.forEach(u => u());
    });
  }, [db, auth?.userId, locationChannels]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({behavior:"smooth"});
  }, [messages]);

  const allChannels = [
    ...locationChannels,
    ...channels.filter(c => c.type === "dm" || c.type === "group"),
  ];

  const imageFileRef = useRef(null);
  const inputRef2 = useRef("");

  // Keep refs in sync with state
  useEffect(() => { imageFileRef.current = imageFile; }, [imageFile]);
  useEffect(() => { inputRef2.current = input; }, [input]);

  const sendMessage = async () => {
    const currentInput = inputRef2.current;
    const currentFile = imageFileRef.current;
    console.log("sendMessage called:", { currentInput, currentFile, activeChannel: activeChannel?.id });
    if (!activeChannel || (!currentInput.trim() && !currentFile)) {
      console.log("sendMessage: early return - no content");
      return;
    }
    setUploading(true);
    try {
      const { addDoc, serverTimestamp, doc: fsDoc, setDoc } = await import("firebase/firestore");
      let imageUrl = null;
      if (currentFile) {
        console.log("Uploading file:", currentFile.name, currentFile.size);
        const path = `chat/${activeChannel.id}/${Date.now()}_${currentFile.name}`;
        const storRef = ref(storage, path);
        await uploadBytes(storRef, currentFile);
        imageUrl = await getDownloadURL(storRef);
        console.log("Upload done, url:", imageUrl);
      }
      const msg = {
        text: currentInput.trim(),
        imageUrl,
        senderId: String(auth?.userId),
        senderName: auth?.name || "Unknown",
        senderRole: auth?.role || "user",
        timestamp: serverTimestamp(),
      };
      await setDoc(fsDoc(db, "chatChannels", activeChannel.id), {
        type: activeChannel.type,
        name: activeChannel.name,
        participants: activeChannel.participants || [],
        lastMessage: currentInput.trim() || "📷 Image",
        lastAt: serverTimestamp(),
      }, {merge:true});
      await addDoc(collection(db, "chatChannels", activeChannel.id, "messages"), msg);
      setInput("");
      setImageFile(null);
      setImagePreview(null);
      imageFileRef.current = null;
      inputRef2.current = "";
    } catch(e) { console.error("Send failed:", e); }
    setUploading(false);
  };

  const createDMOrGroup = async () => {
    if (!newChatUsers.length) return;
    const { collection, addDoc, doc, setDoc, serverTimestamp } = await import("firebase/firestore");
    const participants = [...new Set([String(auth?.userId), ...newChatUsers])];
    const chanData = {
      type: newChatType,
      name: newChatType === "dm"
        ? (users.find(u=>String(u.id)===newChatUsers[0])?.name || "DM")
        : (newChatName || "Group Chat"),
      participants,
      createdBy: String(auth?.userId),
      createdAt: serverTimestamp(),
      lastMessage: "",
      lastAt: serverTimestamp(),
    };
    const ref = await addDoc(collection(db, "chatChannels"), chanData);
    setActiveChannel({id:ref.id, ...chanData});
    setShowNewChat(false);
    setNewChatUsers([]);
    setNewChatName("");
  };

  const deleteChannel = async (chan) => {
    if (!window.confirm(`Delete "${chanLabel(chan)}"? All messages will be permanently removed.`)) return;
    const { collection, getDocs, deleteDoc, doc } = await import("firebase/firestore");
    // Delete all messages first
    const msgs = await getDocs(collection(db, "chatChannels", chan.id, "messages"));
    await Promise.all(msgs.docs.map(d => deleteDoc(d.ref)));
    // Delete the channel doc
    await deleteDoc(doc(db, "chatChannels", chan.id));
    if (activeChannel?.id === chan.id) setActiveChannel(null);
    showToast && showToast("Channel deleted");
  };

  const deleteMessage = async (msgId) => {
    if (!isAdmin) return;
    const { doc, deleteDoc } = await import("firebase/firestore");
    await deleteDoc(doc(db, "chatChannels", activeChannel.id, "messages", msgId));
  };

  const handleImageSelect = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setImageFile(file);
    const reader = new FileReader();
    reader.onload = ev => setImagePreview(ev.target.result);
    reader.readAsDataURL(file);
    e.target.value = "";
  };

  const chanLabel = (c) => {
    if (c.type === "dm") {
      const myId = String(auth?.userId);
      const otherId = (c.participants||[]).find(p => String(p) !== myId);
      const otherUser = users.find(u => String(u.id) === String(otherId));
      return otherUser?.name || c.name || "DM";
    }
    return c.name;
  };

  const chanIcon = (c) => {
    if (c.type === "location") return "📍";
    if (c.type === "dm") return "💬";
    return "👥";
  };

  const ROLE_COLORS = { admin:"#C0392B", kitchen:"#2471A3", driver:"#27AE60", cashier:"#8E44AD", prep:"#E67E22", production:"#16A34A" };

  // ── New chat modal ──
  const NewChatModal = () => (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:4000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}
      onClick={()=>setShowNewChat(false)}>
      <div style={{background:"#fff",borderRadius:16,padding:24,width:"100%",maxWidth:400,boxShadow:"0 20px 60px rgba(0,0,0,0.25)"}}
        onClick={e=>e.stopPropagation()}>
        <div style={{fontWeight:800,fontSize:18,marginBottom:16}}>New Conversation</div>
        <div style={{display:"flex",gap:6,marginBottom:16}}>
          {[["dm","💬 Direct Message"],["group","👥 Group Chat"]].map(([t,l])=>(
            <button key={t} onClick={()=>setNewChatType(t)}
              style={{flex:1,padding:"8px",borderRadius:8,border:`2px solid ${newChatType===t?"#1a1a1a":"#e5e5e5"}`,
                background:newChatType===t?"#1a1a1a":"#fff",color:newChatType===t?"#fff":"#555",
                fontWeight:700,fontSize:13,cursor:"pointer"}}>{l}</button>
          ))}
        </div>
        {newChatType==="group" && (
          <input value={newChatName} onChange={e=>setNewChatName(e.target.value)}
            placeholder="Group name..."
            style={{width:"100%",border:"1px solid #e5e5e5",borderRadius:8,padding:"8px 12px",
              fontSize:13,marginBottom:12,outline:"none",boxSizing:"border-box"}}/>
        )}
        <div style={{fontSize:11,fontWeight:700,color:"#888",textTransform:"uppercase",marginBottom:8}}>
          {newChatType==="dm"?"Select user:":"Add participants:"}
        </div>
        <div style={{maxHeight:200,overflowY:"auto",display:"flex",flexDirection:"column",gap:6}}>
          {users.filter(u=>String(u.id)!==String(auth?.userId)).map(u=>{
            const sel = newChatUsers.includes(String(u.id));
            return (
              <div key={u.id} onClick={()=>{
                  if(newChatType==="dm"){setNewChatUsers([String(u.id)]);}
                  else{setNewChatUsers(p=>sel?p.filter(x=>x!==String(u.id)):[...p,String(u.id)]);}
                }}
                style={{display:"flex",alignItems:"center",gap:10,padding:"8px 12px",borderRadius:8,
                  border:`1px solid ${sel?"#1a1a1a":"#e5e5e5"}`,background:sel?"#f8f8f8":"#fff",cursor:"pointer"}}>
                <div style={{width:28,height:28,borderRadius:"50%",background:ROLE_COLORS[u.role]||"#888",
                  display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:800,fontSize:13,flexShrink:0}}>
                  {u.name[0].toUpperCase()}
                </div>
                <div style={{flex:1}}>
                  <div style={{fontWeight:700,fontSize:13}}>{u.name}</div>
                  <div style={{fontSize:11,color:"#aaa",textTransform:"capitalize"}}>{u.role}</div>
                </div>
                {sel && <span style={{color:"#1a1a1a",fontSize:16}}>✓</span>}
              </div>
            );
          })}
        </div>
        <div style={{display:"flex",gap:8,marginTop:16}}>
          <button onClick={()=>setShowNewChat(false)}
            style={{flex:1,padding:"10px",borderRadius:10,border:"1px solid #e5e5e5",background:"#fff",
              fontSize:13,fontWeight:700,cursor:"pointer",color:"#555"}}>Cancel</button>
          <button onClick={createDMOrGroup} disabled={!newChatUsers.length}
            style={{flex:2,padding:"10px",borderRadius:10,border:"none",
              background:newChatUsers.length?"#1a1a1a":"#f0f0f0",
              color:newChatUsers.length?"#fff":"#aaa",fontSize:13,fontWeight:700,cursor:newChatUsers.length?"pointer":"not-allowed"}}>
            Start Chat
          </button>
        </div>
      </div>
    </div>
  );

  const isMobile = useRef(typeof window !== "undefined" && window.innerWidth < 700).current;
  const showMessagePanel = activeChannel && isMobile;
  const showSidebar = !isMobile || !activeChannel;

  const channelListJSX = (
    <div style={{background:"#1a1a1a",display:"flex",flexDirection:"column",
      height:"100%",overflowY:"auto"}}>
      <div style={{padding:"16px 14px 10px",display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0}}>
        <div style={{color:"#fff",fontWeight:800,fontSize:15}}>💬 Chat</div>
        {(isAdmin || auth?.role === "owner") && (
          <button onClick={()=>setShowNewChat(true)}
            style={{background:"#333",border:"none",borderRadius:6,color:"#fff",
              fontSize:20,width:32,height:32,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>+</button>
        )}
      </div>

      {/* Location channels */}
      <div style={{padding:"6px 14px 4px"}}>
        <div style={{fontSize:9,fontWeight:800,color:"#666",textTransform:"uppercase",letterSpacing:1,marginBottom:6}}>Locations</div>
        {locationChannels.map(c=>{
          const unread = unreadMap[c.id]||0;
          const active = activeChannel?.id===c.id;
          return (
            <button key={c.id} onClick={()=>{setActiveChannel(c);setUnreadMap(m=>({...m,[c.id]:0}));}}
              style={{width:"100%",background:active?"#333":"transparent",border:"none",borderRadius:8,
                padding:"10px 10px",cursor:"pointer",display:"flex",alignItems:"center",gap:10,marginBottom:2}}>
              <div style={{width:10,height:10,borderRadius:"50%",background:c.color||"#888",flexShrink:0}}/>
              <div style={{flex:1,textAlign:"left",color:active?"#fff":"#ccc",fontWeight:active?700:500,fontSize:15,
                whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{c.name}</div>
              {unread>0 && <div style={{background:"#C0392B",color:"#fff",borderRadius:10,padding:"2px 8px",fontSize:11,fontWeight:700}}>{unread}</div>}
              {isMobile && <span style={{color:"#555",fontSize:14}}>›</span>}
            </button>
          );
        })}
      </div>

      {/* DMs & Groups */}
      {channels.length > 0 && (
        <div style={{padding:"10px 14px 4px"}}>
          <div style={{fontSize:9,fontWeight:800,color:"#666",textTransform:"uppercase",letterSpacing:1,marginBottom:6}}>Direct & Groups</div>
          {channels.map(c=>{
            const unread = unreadMap[c.id]||0;
            const active = activeChannel?.id===c.id;
            return (
              <div key={c.id} style={{display:"flex",alignItems:"center",gap:4,marginBottom:2}}>
                <button onClick={()=>{setActiveChannel(c);setUnreadMap(m=>({...m,[c.id]:0}));}}
                  style={{flex:1,background:active?"#333":"transparent",border:"none",borderRadius:8,
                    padding:"10px 10px",cursor:"pointer",display:"flex",alignItems:"center",gap:10}}>
                  <div style={{fontSize:16,flexShrink:0}}>{chanIcon(c)}</div>
                  <div style={{flex:1,textAlign:"left",color:active?"#fff":"#ccc",fontWeight:active?700:500,fontSize:15,
                    whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{chanLabel(c)}</div>
                  {unread>0 && <div style={{background:"#C0392B",color:"#fff",borderRadius:10,padding:"2px 8px",fontSize:11,fontWeight:700}}>{unread}</div>}
                  {isMobile && <span style={{color:"#555",fontSize:14}}>›</span>}
                </button>
                {(isAdmin || auth?.role === "owner") && (
                  <button onClick={e=>{e.stopPropagation();deleteChannel(c);}}
                    style={{background:"none",border:"none",color:"#555",fontSize:14,cursor:"pointer",
                      padding:"4px 6px",borderRadius:6,flexShrink:0,lineHeight:1}}
                    title="Delete channel">🗑</button>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* Signed in as */}
      <div style={{marginTop:"auto",padding:"12px 14px",borderTop:"1px solid #333",flexShrink:0}}>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <div style={{width:28,height:28,borderRadius:"50%",background:ROLE_COLORS[auth?.role]||"#888",
            display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:800,fontSize:12,flexShrink:0}}>
            {(auth?.name||"?")[0].toUpperCase()}
          </div>
          <div>
            <div style={{color:"#fff",fontSize:12,fontWeight:700}}>{auth?.name}</div>
            <div style={{color:"#666",fontSize:10,textTransform:"capitalize"}}>{auth?.role}</div>
          </div>
        </div>
      </div>
    </div>
  );

  const messagePanelJSX = !activeChannel ? null : (
    <div style={{flex:1,display:"flex",flexDirection:"column",minWidth:0,height:"100%"}}>
      {/* Channel header */}
      <div style={{background:"#1a1a1a",padding:"12px 16px",
        display:"flex",alignItems:"center",gap:10,flexShrink:0}}>
        {isMobile && (
          <button onClick={()=>setActiveChannel(null)}
            style={{background:"none",border:"none",color:"#fff",fontSize:22,cursor:"pointer",padding:"0 4px 0 0",lineHeight:1}}>←</button>
        )}
        <div style={{width:10,height:10,borderRadius:"50%",background:activeChannel.color||"#888",flexShrink:0}}/>
        <div style={{flex:1}}>
          <div style={{fontWeight:800,fontSize:16,color:"#fff"}}>{chanLabel(activeChannel)}</div>
          <div style={{fontSize:11,color:"#888",textTransform:"capitalize"}}>{activeChannel.type}</div>
        </div>
        {(isAdmin || auth?.role === "owner") && (activeChannel.type==="dm"||activeChannel.type==="group") && (
          <button onClick={()=>deleteChannel(activeChannel)}
            style={{background:"none",border:"1px solid #555",borderRadius:8,color:"#aaa",
              fontSize:12,fontWeight:700,cursor:"pointer",padding:"5px 10px",flexShrink:0}}>
            🗑 Delete
          </button>
        )}
      </div>

      {/* Messages */}
      <div style={{flex:1,overflowY:"auto",padding:"12px 16px",display:"flex",flexDirection:"column",gap:10,background:"#f2f0ec"}}>
        {messages.length===0 && (
          <div style={{textAlign:"center",color:"#aaa",padding:40,fontSize:13}}>
            No messages yet — say hello! 👋
          </div>
        )}
        {messages.map(msg=>{
          const isMe = String(msg.senderId) === String(auth?.userId);
          const ts = msg.timestamp?.toDate ? msg.timestamp.toDate() : new Date(msg.timestamp||Date.now());
          // Consistent color per sender based on their ID
          const BUBBLE_COLORS = ["#2471A3","#27AE60","#8E44AD","#E67E22","#16A34A","#C0392B","#0891B2","#D97706"];
          const senderColor = isMe ? "#1a1a1a" : BUBBLE_COLORS[Math.abs(String(msg.senderId).split("").reduce((a,c)=>a+c.charCodeAt(0),0)) % BUBBLE_COLORS.length];
          return (
            <div key={msg.id} style={{display:"flex",flexDirection:"column",
              alignItems:isMe?"flex-end":"flex-start",gap:3}}>
              {/* Sender name + time — shown above bubble for others, time below for me */}
              {!isMe && (
                <div style={{display:"flex",alignItems:"center",gap:6,paddingLeft:2}}>
                  <div style={{width:22,height:22,borderRadius:"50%",background:senderColor,
                    display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:11,fontWeight:800,flexShrink:0}}>
                    {(msg.senderName||"?")[0].toUpperCase()}
                  </div>
                  <div style={{fontSize:12,fontWeight:700,color:"#555"}}>{msg.senderName}</div>
                  <div style={{fontSize:10,color:"#bbb"}}>{ts.toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"})}</div>
                </div>
              )}
              <div style={{position:"relative",maxWidth:isMobile?"82%":"65%",
                marginLeft:isMe?0:28 /* indent to align with name */}}>
                {msg.imageUrl && (
                  <img src={msg.imageUrl} alt="attachment"
                    style={{maxWidth:"100%",maxHeight:280,borderRadius:12,display:"block",
                      marginBottom:msg.text?4:0,cursor:"pointer",
                      border:`2px solid ${isMe?"#333":senderColor+"40"}`}}
                    onClick={()=>window.open(msg.imageUrl,"_blank")}/>
                )}
                {msg.text && (
                  <div style={{
                    background: isMe ? "#1a1a1a" : senderColor,
                    color:"#fff",
                    borderRadius: isMe?"18px 18px 4px 18px":"18px 18px 18px 4px",
                    padding:"10px 14px",fontSize:15,lineHeight:1.4,
                    boxShadow:"0 1px 4px rgba(0,0,0,0.15)",
                    wordBreak:"break-word",
                  }}>
                    {msg.text}
                  </div>
                )}
                {isAdmin && (
                  <button onClick={()=>{ if(window.confirm("Delete this message?")) deleteMessage(msg.id); }}
                    style={{position:"absolute",top:-8,right:isMe?-8:undefined,left:isMe?undefined:-8,
                      background:"#E74C3C",border:"none",borderRadius:"50%",width:20,height:20,
                      color:"#fff",fontSize:11,cursor:"pointer",display:"flex",alignItems:"center",
                      justifyContent:"center",opacity:0,transition:"opacity .15s"}}
                    onMouseEnter={e=>e.currentTarget.style.opacity=1}
                    onMouseLeave={e=>e.currentTarget.style.opacity=0}>×</button>
                )}
              </div>
              {isMe && (
                <div style={{fontSize:10,color:"#bbb",paddingRight:2}}>
                  {ts.toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"})}
                </div>
              )}
            </div>
          );
        })}
        <div ref={messagesEndRef}/>
      </div>

      {/* Image preview */}
      {imagePreview && (
        <div style={{padding:"8px 16px",background:"#f8f8f8",borderTop:"1px solid #eee",display:"flex",alignItems:"center",gap:10,flexShrink:0}}>
          <img src={imagePreview} alt="preview" style={{height:56,borderRadius:8,border:"1px solid #e5e5e5"}}/>
          <div style={{flex:1,fontSize:12,color:"#888"}}>{imageFile?.name}</div>
          <button onClick={()=>{setImageFile(null);setImagePreview(null);}}
            style={{background:"none",border:"none",fontSize:20,color:"#E74C3C",cursor:"pointer"}}>×</button>
        </div>
      )}

      {/* Input bar */}
      <div style={{padding:"10px 12px",background:"#fff",borderTop:"1px solid #e8e8e8",
        display:"flex",alignItems:"flex-end",gap:8,flexShrink:0,
        paddingBottom: isMobile ? "max(10px, env(safe-area-inset-bottom))" : "10px"}}>
        <button onClick={()=>fileInputRef.current?.click()}
          style={{background:"#f0f0f0",border:"none",borderRadius:10,padding:"10px 12px",
            fontSize:20,cursor:"pointer",flexShrink:0,color:"#555"}}>📎</button>
        <input ref={fileInputRef} type="file" accept="image/*,.pdf" style={{display:"none"}} onChange={handleImageSelect}/>
        <textarea value={input} onChange={e=>setInput(e.target.value)}
          onKeyDown={e=>{if(e.key==="Enter"&&!e.shiftKey){e.preventDefault();sendMessage();}}}
          placeholder={`Message ${chanLabel(activeChannel)}...`}
          rows={1}
          style={{flex:1,border:"1.5px solid #e5e5e5",borderRadius:12,padding:"10px 14px",
            fontSize:15,fontFamily:"'IBM Plex Sans',sans-serif",outline:"none",
            resize:"none",lineHeight:1.4,maxHeight:120,overflowY:"auto"}}/>
        <button onClick={sendMessage}
          style={{background:(input.trim()||imageFile)?"#1a1a1a":"#f0f0f0",border:"none",
            borderRadius:10,padding:"10px 18px",fontSize:15,fontWeight:700,
            color:(input.trim()||imageFile)?"#fff":"#aaa",
            cursor:"pointer",flexShrink:0,
            WebkitTapHighlightColor:"transparent",touchAction:"manipulation"}}>
          {uploading?"…":"Send"}
        </button>
      </div>
    </div>
  );

  return (
    <div style={{display:"flex",height:"calc(100vh - 56px)",background:"#f2f0ec",overflow:"hidden"}}>
      {showNewChat && <NewChatModal/>}

      {/* Mobile: show either sidebar OR message panel full screen */}
      {isMobile ? (
        activeChannel
          ? messagePanelJSX
          : channelListJSX
      ) : (
        /* Desktop: side-by-side */
        <>
          <div style={{width:260,flexShrink:0,height:"100%"}}>{channelListJSX}</div>
          {activeChannel
            ? messagePanelJSX
            : <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",color:"#aaa",flexDirection:"column",gap:12}}>
                <div style={{fontSize:48}}>💬</div>
                <div style={{fontWeight:700,fontSize:16}}>Select a channel to start chatting</div>
                {(isAdmin || auth?.role === "owner") && <div style={{fontSize:13}}>Or click <strong>+</strong> to start a DM or group</div>}
              </div>
          }
        </>
      )}
    </div>
  );
}

function CentralKitchenView({ orders, saveOrders, restaurants, products, setProducts, saveProducts, customCats=[], showToast, pName, fmtPrice, factoryInventory, saveFactoryInventory, factoryLogs, saveFactoryLogs, productionHidden, saveProductionHidden, auth,
  factoryStock, saveFactoryStock, wholesaleCustomers, saveWholesaleCustomers, externalInvoices, saveExternalInvoices }) {
  const [kitchenTab, setKitchenTab]   = useState("hub"); // "hub" | "orders" | "delivery" | "inventory" | "stock" | "wholesale" | "items"
  const [selected, setSelected]       = useState(null);
  const [editItems, setEditItems]     = useState(null);
  const [filterLoc, setFilterLoc]     = useState("all");
  const [filterStatus, setFilterStatus] = useState("new");
  const [filterMonth, setFilterMonth] = useState("all");
  const [filterYear, setFilterYear] = useState("all");
  const [collapsedMonths, setCollapsedMonths] = useState({});
  const toggleMonth = (key) => setCollapsedMonths(p => ({...p, [key]: !p[key]}));
  const [combineMode, setCombineMode] = useState(false);
  const [selectedForCombine, setSelectedForCombine] = useState([]);
  const [showCombinePreview, setShowCombinePreview] = useState(false);
  const [markDeliveredMode, setMarkDeliveredMode] = useState(false);
  const [selectedForDelivered, setSelectedForDelivered] = useState([]);
  const [cancelModal, setCancelModal] = useState(null); // {order, mode: 'kitchen'|'approve_request'}
  const [cancelReason, setCancelReason] = useState("");
  const [cancelConfirmStep, setCancelConfirmStep] = useState(false); // for pending: show confirm before cancelling
  const [showInvoice, setShowInvoice] = useState(false);
  const [adjustReason, setAdjustReason] = useState("pre_delivery"); // pre_delivery | rejected | refund
  const [deliveryDateInput, setDeliveryDateInput] = useState(""); // factory sets delivery date at confirm
  const [manualLots, setManualLots] = useState({}); // productId -> lotId (null = auto-FIFO)
  const [confirmStockWarning, setConfirmStockWarning] = useState(null); // {shortfalls:[]} or null


  const statusColor = s => ({ pending:"#E67E22", sent:"#2471A3", confirmed:"#27AE60", rejected:"#C0392B", cancelled:"#95a5a6", "cancel_requested":"#8E44AD" }[s?.toLowerCase()] || "#aaa");
  const statusLabel = s => ({ pending:"Pending", sent:"Sent", confirmed:"Confirmed", rejected:"Rejected", cancelled:"🚫 Cancelled", cancel_requested:"⚠️ Cancel Requested" }[s?.toLowerCase()] || s);

  const allYears = [...new Set(orders.map(o => new Date(o.timestamp).getFullYear()))].sort((a,b)=>b-a);
  const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];

  const filtered = orders
    .filter(o => filterLoc === "all" || o.restaurantId === filterLoc)
    .filter(o => {
      const s = o.status?.toLowerCase();
      if (filterStatus === "new") return ["pending","sent","cancel_requested"].includes(s);
      if (filterStatus === "confirmed") return ["to_be_delivered","confirmed","preparing","dispatched",
        "[ok] confirmed","to be delivered","ok confirmed"].includes(s);
      if (filterStatus === "delivered") return ["delivered"].includes(s);
      if (filterStatus === "cancelled") return s === "cancelled";
      return true;
    })
    .filter(o => {
      if (filterYear === "all" && filterMonth === "all") return true;
      const d = new Date(o.timestamp);
      if (filterYear !== "all" && d.getFullYear() !== parseInt(filterYear)) return false;
      if (filterMonth !== "all" && d.getMonth() !== parseInt(filterMonth)) return false;
      return true;
    })
    .sort((a,b) => b.id - a.id);

  const orderGroups = (() => {
    const map = {};
    filtered.forEach(o => {
      const d = new Date(o.timestamp);
      const key = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}`;
      const label = d.toLocaleDateString("en-US", {month:"long", year:"numeric"});
      if (!map[key]) map[key] = {key, label, orders:[]};
      map[key].orders.push(o);
    });
    // Sort months newest first, orders within each month newest first
    return Object.values(map).sort((a,b) => b.key.localeCompare(a.key)).map(group => ({
      ...group,
      orders: group.orders.sort((a,b) => new Date(b.timestamp) - new Date(a.timestamp))
    }));
  })();


  const openOrder = (o) => {
    setSelected(o);
    // "to_be_delivered" and "delivered" still show invoice view by default
    // but can be switched to edit mode by factory/admin
    const locked = ["confirmed","sent","cancelled","cancel_requested",
      "to_be_delivered","delivered"].includes(o.status?.toLowerCase());
    setShowInvoice(locked);
    setDeliveryDateInput(o.deliveryDate ? new Date(o.deliveryDate).toISOString().slice(0,10) : "");
    setManualLots({}); // reset manual lot picks when opening a new order
    setEditItems(o.items.map(i => {
      const p = products.find(x => x.id === i.productId);
      // Use saved customPrice first (locked at confirm time), fall back to live catalog only for new/unconfirmed orders
      const savedPrice = i.customPrice ?? p?.price ?? null;
      return { ...i, name: i.name || p?.name || "Unknown", unit: i.unit || p?.unit || "",
        price: savedPrice, customPrice: i.customPrice ?? null, added: i.added || false };
    }));
  };

  const effectivePrice = (it) => it.customPrice ?? it.price ?? null;

  const doCancel = (order, reason) => {
    const updated = orders.map(o => o.id === order.id
      ? {...o, status: "cancelled", cancelReason: reason || null, cancelledAt: new Date().toISOString()}
      : o);
    saveOrders(updated);
    setCancelModal(null); setCancelReason(""); setCancelConfirmStep(false);
    if (selected?.id === order.id) setSelected(null);
    showToast("Order cancelled");
  };

  const doDenyCancel = (order) => {
    const updated = orders.map(o => o.id === order.id
      ? {...o, status: "confirmed", cancelRequestDenied: true}
      : o);
    saveOrders(updated);
    setCancelModal(null);
    showToast("Cancellation request denied");
  };

  // ── Combine orders ──
  const combineEligible = (o) => ["pending","sent"].includes(o.status?.toLowerCase());
  const toggleCombineSelect = (id) => setSelectedForCombine(prev =>
    prev.includes(id) ? prev.filter(x=>x!==id) : [...prev, id]
  );
  const combinePreviewItems = () => {
    const toMerge = orders.filter(o => selectedForCombine.includes(o.id));
    const itemMap = {};
    toMerge.forEach(o => o.items.forEach(item => {
      const key = item.productId || item.name;
      if (itemMap[key]) itemMap[key].qty += item.qty;
      else itemMap[key] = {...item};
    }));
    return Object.values(itemMap);
  };
  const doCombine = () => {
    const toMerge = orders.filter(o => selectedForCombine.includes(o.id));
    if (toMerge.length < 2) return;
    const itemMap = {};
    toMerge.forEach(o => o.items.forEach(item => {
      const key = item.productId || item.name;
      if (itemMap[key]) itemMap[key].qty += item.qty;
      else itemMap[key] = {...item};
    }));
    const notes = toMerge.map(o=>o.note).filter(Boolean).join(" | ");
    const rest = restaurants.find(r=>r.id===toMerge[0].restaurantId);
    const combinedOrder = {
      ...toMerge[0],
      id: Date.now() % 900000 + 100000,
      items: Object.values(itemMap),
      note: notes,
      timestamp: new Date().toISOString(),
      status: "pending",
      combinedFrom: toMerge.map(o=>o.id),
    };
    saveOrders([combinedOrder, ...orders.filter(o=>!selectedForCombine.includes(o.id))]);
    setCombineMode(false); setSelectedForCombine([]); setShowCombinePreview(false);
    showToast(`✓ ${toMerge.length} orders combined into #${combinedOrder.id}`);
  };
  const updatePrice = (idx, val) => setEditItems(prev => prev.map((it,i) => i===idx ? {...it, customPrice: val===""?null:parseFloat(val)||0} : it));
  const updateQty   = (idx, val) => setEditItems(prev => prev.map((it,i) => i===idx ? {...it, qty: parseInt(val)||0} : it));
  const removeItem  = (idx)      => setEditItems(prev => prev.filter((_,i) => i!==idx));


  // ── Build FIFO stockByProduct map (used by confirm logic) ──
  const DUMPLING_CATS = ["Frozen Dumplings"];
  const buildStockByProduct = () => {
    const sbp = {};
    factoryStock.forEach(entry => {
      const pid = entry.productId;
      if (!sbp[pid]) sbp[pid] = [];
      if ((entry.qtyRemaining || 0) > 0) sbp[pid].push({...entry});
    });
    Object.values(sbp).forEach(lots => lots.sort((a,b) => {
      if (!a.date && !b.date) return a.id - b.id;
      if (!a.date) return 1; if (!b.date) return -1;
      return a.date < b.date ? -1 : a.date > b.date ? 1 : 0;
    }));
    return sbp;
  };

  // ── Core confirm: run FIFO assignment and save order ──
  const doConfirmWithItems = (itemsToConfirm, toastMsg = "Order confirmed ✓") => {
    const stockByProduct = buildStockByProduct();
    const stockUpdates = {};
    const lotAssignments = {};
    itemsToConfirm.forEach(it => {
      const prod = it.productId ? products.find(x => x.id === it.productId) : null;
      if (!prod || !DUMPLING_CATS.includes(prod.category)) return;
      let lots = stockByProduct[it.productId] || [];
      const chosenLotId = manualLots[it.productId];
      if (chosenLotId) {
        const specific = lots.find(l => String(l.id) === String(chosenLotId));
        const rest = lots.filter(l => String(l.id) !== String(chosenLotId));
        lots = specific ? [specific, ...rest] : rest;
      }
      let rem = it.qty;
      const assigns = [];
      for (const lot of lots) {
        if (rem <= 0) break;
        const take = Math.min(lot.qtyRemaining, rem);
        assigns.push({ date: lot.date, lotId: lot.id, lotNumber: lot.lotNumber, qty: take });
        stockUpdates[lot.id] = (stockUpdates[lot.id] || 0) + take;
        rem -= take;
      }
      if (assigns.length > 0) lotAssignments[it.productId] = assigns;
    });
    if (Object.keys(stockUpdates).length > 0) {
      saveFactoryStock(factoryStock.map(entry => {
        const deduct = stockUpdates[entry.id];
        return deduct ? { ...entry, qtyRemaining: Math.max(0, (entry.qtyRemaining||0) - deduct) } : entry;
      }));
    }
    const updatedOrder = {
      ...selected, status: "to_be_delivered",
      items: itemsToConfirm.map(it => {
        const p = it.productId ? products.find(x => x.id === it.productId) : null;
        // Snapshot price at confirm time so future catalog price changes never affect this invoice
        const lockedPrice = it.customPrice ?? p?.price ?? null;
        return {
          productId: it.productId||null,
          qty: it.qty,
          customPrice: lockedPrice,
          name: it.name || (it.productId ? products.find(x=>x.id===it.productId)?.name : null) || "",
          unit: it.unit || (it.productId ? products.find(x=>x.id===it.productId)?.unit : null) || "",
          ...(it.added ? { added: true } : {}),
          ...(lotAssignments[it.productId] ? { lotAssignment: lotAssignments[it.productId] } : {}),
        };
      }),
      confirmedAt: new Date().toISOString(),
      deliveryDate: new Date(deliveryDateInput + "T12:00:00").toISOString(),
    };
    saveOrders(orders.map(o => o.id === selected.id ? updatedOrder : o));
    setSelected(updatedOrder);
    setEditItems(updatedOrder.items.map(i => {
      const p = products.find(x => x.id === i.productId);
      return { ...i, name: i.name||p?.name||"Unknown", unit: i.unit||p?.unit||"",
        price: i.customPrice ?? p?.price ?? null, customPrice: i.customPrice ?? null, added: i.added||false };
    }));
    setConfirmStockWarning(null);
    setShowInvoice(true);
    showToast(toastMsg);
  };

  const confirmOrder = () => {
    if (!deliveryDateInput) { showToast("Please set a delivery date before confirming"); return; }
    const itemsToConfirm = editItems.filter(it => it.qty > 0);

    // ── Stock shortfall pre-check — show modal if any item exceeds available stock ──
    if (!confirmStockWarning) {
      const stockByProduct = buildStockByProduct();
      const shortfalls = [];
      itemsToConfirm.forEach(it => {
        const prod = it.productId ? products.find(x => x.id === it.productId) : null;
        if (!prod || !DUMPLING_CATS.includes(prod.category)) return;
        const lots = stockByProduct[it.productId] || [];
        const totalAvail = lots.reduce((s,l) => s + l.qtyRemaining, 0);
        if (totalAvail < it.qty) {
          shortfalls.push({ name: prod.name, ordered: it.qty, available: totalAvail });
        }
      });
      if (shortfalls.length > 0) {
        setConfirmStockWarning({ shortfalls, itemsToConfirm });
        return;
      }
    }

    doConfirmWithItems(itemsToConfirm);
  };

  const rest = selected ? restaurants.find(r => r.id === selected.restaurantId) : null;

  const invoiceItems = (showInvoice && selected ? selected.items : []).map(it => {
    const p = it.productId ? products.find(x => x.id === it.productId) : null;
    return { ...it, name: it.name || p?.name || "Unknown", unit: it.unit || p?.unit || "",
      price: it.customPrice ?? p?.price ?? null };
  });

  const subtotal    = invoiceItems.reduce((s,it) => s + (it.price??0)*it.qty, 0);
  const editSubtotal = editItems ? editItems.reduce((s,it) => s + (effectivePrice(it)??0)*it.qty, 0) : 0;

  const printInvoice = () => {
    const w = window.open("","_blank","width=800,height=900");
    const r = rest;
    const date = selected ? new Date(selected.timestamp).toLocaleDateString("en-US",{weekday:"long",month:"long",day:"numeric",year:"numeric"}) : "";
    const confirmed = selected?.confirmedAt ? new Date(selected.confirmedAt).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}) : "";
    const invoiceItems = (selected?.items||[]).map(it=>{
      const p = it.productId ? products.find(x=>String(x.id)===String(it.productId)) : null;
      return {...it, name:p?.name||it.name||"Item", unit:p?.unit||it.unit||"", price:p?.price??it.customPrice??null, nameZh:p?.nameZh||""};
    });
    const subtotal = invoiceItems.reduce((s,it)=>s+(it.price!=null?it.price*it.qty:0),0);
    const hasMarketPrice = invoiceItems.some(it=>it.price==null);

    const rows = invoiceItems.map((it,i)=>{
      const bg = i%2===0?"#fff":"#f9f9f9";
      const price = it.price!=null?`$${parseFloat(it.price).toFixed(2)}`:"Market";
      const total = it.price!=null?`$${(it.price*it.qty).toFixed(2)}`:"—";
      const addedTag = it.added?`<span style="font-size:9px;background:#FFF3CD;color:#856404;padding:1px 5px;border-radius:3px;margin-left:4px">ADDED</span>`:"";
      const unitTag = it.unit?`<span style="font-size:10px;color:#aaa;font-weight:400;margin-left:5px">${it.unit}</span>`:"";
      return `<tr style="background:${bg}">
        <td style="padding:8px 10px;border-bottom:1px solid #eee;font-weight:600">${it.name}${unitTag}${addedTag}</td>
        <td style="padding:8px 10px;border-bottom:1px solid #eee;color:#888;font-size:12px">${it.nameZh||""}</td>
        <td style="padding:8px 10px;border-bottom:1px solid #eee;text-align:center;font-weight:700">${it.qty}</td>
        <td style="padding:8px 10px;border-bottom:1px solid #eee;text-align:right">${price}</td>
        <td style="padding:8px 10px;border-bottom:1px solid #eee;text-align:right;font-weight:700">${total}</td>
      </tr>`;
    }).join("");

    w.document.write(`<!DOCTYPE html><html><head><title>Purchase Order #${selected?.id}</title>
      <style>
        body{font-family:Arial,sans-serif;margin:0;padding:0;color:#1a1a1a}
        @media print{.no-print{display:none!important}body{margin:0}}
        table{width:100%;border-collapse:collapse}
        th{background:#1a1a1a;color:#fff;padding:10px;text-align:left;font-size:12px}
        th:nth-child(3){text-align:center} th:nth-child(4),th:nth-child(5){text-align:right}
      </style></head><body>
      <div style="padding:20px 30px;border-bottom:2px solid #1a1a1a;display:flex;justify-content:space-between;align-items:flex-start">
        <div>
          <img src="${LOGO_NAV}" style="height:36px;width:auto;margin-bottom:8px"/>
          <div style="font-size:10px;color:#aaa;text-transform:uppercase;letter-spacing:1px">Purchase Order</div>
          <div style="font-size:22px;font-weight:700;margin-top:2px">Deliver to: ${r?.name||""}</div>
          <div style="font-size:13px;color:#555;margin-top:2px">${date}</div>
        </div>
        <div style="text-align:right">
          <div style="font-size:12px;color:#aaa">Order #${selected?.id}</div>
          <div style="font-size:12px;color:#555;margin-top:2px">Placed: ${date}</div>
          ${confirmed?`<div style="font-size:12px;color:#27AE60;font-weight:700">[OK] ${confirmed}</div>`:""}
        </div>
      </div>
      <div style="padding:20px 30px">
        <table><thead><tr>
          <th>Item</th><th>中文名</th><th>Qty</th><th>Unit Price</th><th>Total</th>
        </tr></thead><tbody>${rows}</tbody></table>
        <div style="margin-top:16px;text-align:right;padding:12px;background:#f5f5f5;border-radius:6px">
          <span style="font-size:16px;font-weight:700">${subtotal>0?`Est. Total: $${subtotal.toFixed(2)}`:"Market price — contact for total"}</span>
        </div>
        ${selected?.note?`<div style="margin-top:12px;padding:10px 14px;background:#FFFBF0;border:1px solid #F39C12;border-radius:6px;font-size:13px;color:#856404">Note: Note: ${selected.note}</div>`:""}
        ${selected?.status?.toLowerCase()==="delivered"&&selected?.signature?`
          <div style="margin-top:24px;padding:16px;background:#f0faf4;border:1px solid #27AE60;border-radius:8px">
            <div style="font-weight:700;font-size:13px;color:#27AE60;margin-bottom:4px">[OK] Delivery Confirmed</div>
            <div style="font-size:12px;color:#555;margin-bottom:8px">Delivered by ${selected.deliveredBy||"Driver"} . ${selected.deliveredAt?new Date(selected.deliveredAt).toLocaleString("en-US",{month:"short",day:"numeric",year:"numeric",hour:"2-digit",minute:"2-digit"}):""}</div>
            <div style="font-size:11px;color:#888;margin-bottom:6px;font-weight:700">SIGNATURE:</div>
            <img src="${selected.signature}" style="max-width:280px;height:auto;border:1px solid #ddd;border-radius:4px;background:#fff;padding:4px"/>
          </div>
        `:""}
        <div style="margin-top:30px;text-align:center;font-size:11px;color:#aaa">Generated by VDumplingHQ . Vanessa's Dumpling House</div>
      </div>
      <div class="no-print" style="padding:16px 30px;background:#fff;border-top:1px solid #eee;display:flex;gap:10px;position:sticky;bottom:0">
        <button onclick="window.print()" style="background:#1a1a1a;color:#fff;border:none;padding:10px 20px;border-radius:8px;font-size:14px;font-weight:700;cursor:pointer">Print</button>
        <button onclick="window.close()" style="background:#f0f0f0;border:none;padding:10px 20px;border-radius:8px;font-size:14px;cursor:pointer">Close</button>
      </div>
      <script>window.onload=()=>{window.print();}</script>
    </body></html>`);
    w.document.close();
  };


  const printPackingSlip = () => {
    const w = window.open("","_blank","width=1100,height=800");
    const r = rest;
    const date = selected ? new Date(selected.timestamp).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}) : "";
    const confirmed = selected?.confirmedAt ? new Date(selected.confirmedAt).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}) : "";
    w.document.write(`<!DOCTYPE html><html><head><title>Packing Slip - ${(r&&r.name)||""}</title>
      <style>
        *{box-sizing:border-box;margin:0;padding:0}
        html,body{width:100%;height:100%}
        body{font-family:Arial,sans-serif;color:#1a1a1a;font-size:11px}
        @page{size:landscape;margin:6mm}
        @media print{
          .no-print{display:none!important}
          body{font-size:10px}
          html{height:100%}
        }
      </style></head><body>
      <div style="display:flex;align-items:center;justify-content:space-between;padding:5px 10px;border-bottom:2px solid #1a1a1a;margin-bottom:5px">
        <img src="${LOGO_NAV}" style="height:20px;width:auto;max-width:140px" alt="logo"/>
        <div style="text-align:center">
          <div style="font-size:20px;font-weight:900;letter-spacing:.5px">${r?.name||"Unknown"}</div>
          <div style="font-size:9px;font-weight:600;letter-spacing:2px;color:#555;text-transform:uppercase;margin-top:1px">Packing Slip &middot; Order #${selected?.id}</div>
        </div>
        <div style="text-align:right;font-size:9px;color:#555">
          <div>Placed: ${date}</div>
          <div style="color:#27AE60;font-weight:700">✓ Confirmed ${confirmed}</div>
        </div>
      </div>
      <div style="padding:0 10px 4px">
        ${(() => {
          const CAT_ORDER = ["Frozen Dumplings","Paper Goods","Sauces","Doughs","Buns","Meats","Sides","Vegetables","Soup","Other"];
          const grouped = {};
          invoiceItems.forEach(it => {
            const prod = it.productId ? products.find(x=>String(x.id)===String(it.productId)) : null;
            const cat = prod?.category || "Other";
            if (!grouped[cat]) grouped[cat] = [];
            grouped[cat].push({...it, prod, zhName: prod?.nameZh||""});
          });
          const cats = [...CAT_ORDER.filter(c=>grouped[c]), ...Object.keys(grouped).filter(c=>!CAT_ORDER.includes(c)&&grouped[c])];
          const HDR  = "border-bottom:2px solid #1a1a1a;padding:2px 5px;font-size:9px;font-weight:900;letter-spacing:.8px;text-transform:uppercase;color:#1a1a1a;";
          const BLOCK = "margin-bottom:5px;border:1px solid #ccc;border-radius:2px;overflow:hidden;break-inside:avoid;";
          const noteBlock = (selected && selected.note) ? ['<div style="',BLOCK,'"><div style="',HDR,'">Notes</div><div style="padding:4px 6px;font-size:10px;color:#856404;background:#FFFBF0;border-left:3px solid #F39C12">',selected.note,'</div></div>'].join("") : "";
          const catBlocks = cats.map((cat) => {
            const rowsHtml = grouped[cat].map((it,i) => {
              const bg = i%2===0 ? "background:#fff;" : "background:#f7f7f7;-webkit-print-color-adjust:exact;print-color-adjust:exact;";
              // Use stored lotAssignment, or fall back to current FIFO lots for display
              let lotStr = "";
              const assigns = it.lotAssignment || [];
              if (assigns.length > 0) {
                lotStr = assigns.map(l => {
                  const d = l.date ? new Date(l.date+"T12:00:00").toLocaleDateString("en-US",{month:"short",day:"numeric"}) : "?";
                  return `${l.qty} \u00d7 ${d}`;
                }).join("  \u00b7  ");
              } else if (it.productId && it.prod?.category === "Frozen Dumplings") {
                // Reconstruct FIFO preview from current stock for display only
                const lots = factoryStock
                  .filter(e => e.productId === it.productId && (e.qtyRemaining||0) > 0)
                  .sort((a,b) => !a.date?1:!b.date?-1:a.date<b.date?-1:a.date>b.date?1:0);
                let rem = it.qty; const preview = [];
                for (const lot of lots) {
                  if (rem <= 0) break;
                  const take = Math.min(lot.qtyRemaining, rem);
                  const d = lot.date ? new Date(lot.date+"T12:00:00").toLocaleDateString("en-US",{month:"short",day:"numeric"}) : "?";
                  preview.push(`${take} \u00d7 ${d}`);
                  rem -= take;
                }
                lotStr = preview.join("  \u00b7  ");
              }
              return "<div style=\"display:flex;align-items:center;gap:5px;padding:2px 5px;border-bottom:1px solid #eee;"+bg+"\">"
                + "<input type=\"checkbox\" style=\"width:12px;height:12px;flex-shrink:0;cursor:pointer\" />"
                + "<div style=\"flex:1\"><div style=\"font-weight:700;font-size:10px\">"+it.name+(it.added?" +":"")+"</div>"
                + (it.zhName ? "<div style=\"font-size:9px;color:#888;margin-top:0px\">"+it.zhName+"</div>" : "")
                + (lotStr ? "<div style=\"font-size:8px;color:#2471A3;margin-top:1px\">"+lotStr+"</div>" : "")
                + "</div>"
                + "<input type=\"text\" style=\"width:38px;border:1px solid #ccc;border-radius:3px;padding:1px;font-size:9px;flex-shrink:0;\" />"
                + "<div style=\"font-size:15px;font-weight:900;min-width:22px;text-align:right\">"+it.qty+"</div></div>";
            }).join("");
            return "<div style=\""+BLOCK+"\"><div style=\""+HDR+"\">"+cat+"</div>"+rowsHtml+"</div>";
          });
          const paperGoodsIdx = catBlocks.findIndex((_,i) => cats[i] === "Paper Goods");
          if (noteBlock) {
            const insertAt = paperGoodsIdx >= 0 ? paperGoodsIdx + 1 : catBlocks.length;
            catBlocks.splice(insertAt, 0, noteBlock);
          }
          // Use CSS columns for auto-balancing — browser distributes height evenly
          return "<div style=\"column-count:3;column-gap:10px;column-fill:balance\">"
            + catBlocks.join("")
            + "</div>";
        })()}
        <div style="margin-top:3px;display:flex;justify-content:space-between;align-items:center">
          <div style="font-size:8px;color:#aaa">${invoiceItems.length} item type${invoiceItems.length!==1?"s":""} &middot; ${invoiceItems.reduce((s,it)=>s+it.qty,0)} units total</div>
        </div>
      </div>
      <div style="margin:4px 10px 0;padding-top:5px;border-top:1px dashed #ccc;display:flex;gap:30px">
        <div style="flex:1"><div style="font-size:8px;color:#aaa;margin-bottom:12px">Packed by</div><div style="border-bottom:1px solid #999"></div></div>
        <div style="flex:1"><div style="font-size:8px;color:#aaa;margin-bottom:12px">Received by</div><div style="border-bottom:1px solid #999"></div></div>
        <div style="flex:1"><div style="font-size:8px;color:#aaa;margin-bottom:12px">Date</div><div style="border-bottom:1px solid #999"></div></div>
      </div>
      <div class="no-print" style="padding:12px 16px;border-top:1px solid #eee;margin-top:12px;display:flex;gap:10px;position:sticky;bottom:0;background:#fff">
        <button onclick="window.print()" style="background:#1a1a1a;color:#fff;border:none;padding:10px 20px;border-radius:8px;font-size:14px;font-weight:700;cursor:pointer">Print</button>
        <button onclick="window.close()" style="background:#f0f0f0;border:none;padding:10px 20px;border-radius:8px;font-size:14px;cursor:pointer">Close</button>
      </div>
    </body></html>`);
    w.document.close();
  };

  const downloadExcel = () => {
    const doExport = (XLSX) => {

    const subtotal = invoiceItems.reduce((s,it)=>s+(it.price!=null?it.price*it.qty:0),0);

    const wb = XLSX.utils.book_new();

    // Build rows with metadata header
    const rows = [];
    rows.push(["VANESSA'S DUMPLING HOUSE", "", "", "", ""]);
    rows.push(["Purchase Order", "", "", "", ""]);
    rows.push([]);
    rows.push(["Order #", selected?.id || "", "", "Status", (selected?.status||"").toUpperCase()]);
    rows.push(["Location", rest?.name || "", "", "Ordered", selected?.timestamp ? new Date(selected.timestamp).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}) : ""]);
    rows.push(["Deliver By", selected?.deliveryDate ? new Date(selected.deliveryDate).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}) : "", "", "Manager", rest?.managerName || ""]);
    rows.push([]);
    rows.push(["ITEM", "UNIT", "QTY", "UNIT PRICE", "TOTAL"]);

    invoiceItems.forEach(it => {
      const ep = it.price;
      rows.push([
        it.name + (it.added ? " [ADDED]" : ""),
        it.unit || "",
        it.qty,
        ep != null ? ep : "Market",
        ep != null ? parseFloat((ep * it.qty).toFixed(2)) : ""
      ]);
    });

    rows.push([]);
    rows.push(["", "", "", "TOTAL", parseFloat(subtotal.toFixed(2))]);

    if (selected?.note) {
      rows.push([]);
      rows.push(["Note:", selected.note]);
    }

    const ws = XLSX.utils.aoa_to_sheet(rows);

    // Column widths
    ws["!cols"] = [
      {wch:36}, {wch:16}, {wch:8}, {wch:14}, {wch:14}
    ];

    // Style helpers — SheetJS CE doesn't support full styles but we can set number formats
    const fmtMoney = '"$"#,##0.00';
    // Apply money format to price/total columns (D & E) for item rows
    const itemStartRow = 8; // 0-indexed row 8 = 9th row = first item
    invoiceItems.forEach((_, i) => {
      const r = itemStartRow + i;
      const dRef = XLSX.utils.encode_cell({r, c:3});
      const eRef = XLSX.utils.encode_cell({r, c:4});
      if (ws[dRef] && typeof ws[dRef].v === "number") ws[dRef].z = fmtMoney;
      if (ws[eRef] && typeof ws[eRef].v === "number") ws[eRef].z = fmtMoney;
    });
    // Format subtotal/tax/total rows
    const summaryStart = itemStartRow + invoiceItems.length + 1;
    [0,1,2].forEach(offset => {
      const ref = XLSX.utils.encode_cell({r: summaryStart+offset, c:4});
      if (ws[ref] && typeof ws[ref].v === "number") ws[ref].z = fmtMoney;
    });

    // Merge title cells
    ws["!merges"] = [
      {s:{r:0,c:0}, e:{r:0,c:4}},
      {s:{r:1,c:0}, e:{r:1,c:4}},
    ];

    XLSX.utils.book_append_sheet(wb, ws, "Purchase Order");
      XLSX.writeFile(wb, `PO-${selected?.id}-${(rest?.name||"Factory").replace(/[^a-z0-9]/gi,"_")}.xlsx`);
      showToast("Excel downloaded ✓");
    };

    if (window.XLSX) {
      doExport(window.XLSX);
    } else {
      const script = document.createElement("script");
      script.src = "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js";
      script.onload = () => doExport(window.XLSX);
      script.onerror = () => showToast("Could not load Excel library");
      document.head.appendChild(script);
    }
  };


  return (
    <div style={{maxWidth:960, margin:"0 auto", padding:"0 0 80px"}}>

      {/* ── Hub home — shown when no tab selected ── */}
      {kitchenTab === "hub" && (
        <div>
          <h2 style={{fontSize:26, fontFamily:"'Playfair Display',serif", margin:"0 0 24px"}}>🍳 Central Factory</h2>
          <div style={{display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))", gap:16}}>
            {[
              {key:"orders",    icon:"📋", label:"Orders",    desc:"View & confirm restaurant orders"},
              {key:"delivery",  icon:"🚚", label:"Delivery",  desc:"Manage deliveries & driver view"},
              {key:"inventory", icon:"📦", label:"Production",desc:"Log production & track inventory"},
              {key:"stock",     icon:"🥟", label:"Stock",     desc:"Factory stock & FIFO lots"},
              {key:"wholesale", icon:"🏪", label:"Wholesale", desc:"Customers, invoices & reports"},
              {key:"items",     icon:"🏷", label:"Items",     desc:"Add items & update prices"},
              {key:"reports",   icon:"📊", label:"Reports",   desc:"Restaurant & wholesale analytics"},
            ].map(({key,icon,label,desc}) => (
              <div key={key} onClick={()=>setKitchenTab(key)}
                style={{background:"#fff", border:"1px solid #e8e8e8", borderRadius:16,
                  padding:"22px 20px", cursor:"pointer", transition:"all .15s",
                  boxShadow:"0 1px 4px rgba(0,0,0,0.05)"}}
                onMouseEnter={e=>{e.currentTarget.style.borderColor="#1a1a1a"; e.currentTarget.style.boxShadow="0 4px 16px rgba(0,0,0,0.1)";}}
                onMouseLeave={e=>{e.currentTarget.style.borderColor="#e8e8e8"; e.currentTarget.style.boxShadow="0 1px 4px rgba(0,0,0,0.05)";}}>
                <div style={{fontSize:32, marginBottom:10}}>{icon}</div>
                <div style={{fontWeight:800, fontSize:16, marginBottom:4}}>{label}</div>
                <div style={{fontSize:12, color:"#888"}}>{desc}</div>
              </div>
            ))}
          </div>

        </div>
      )}

      {/* ── Back button + section header when in a tab ── */}
      {kitchenTab !== "hub" && (
        <div style={{display:"flex", alignItems:"center", gap:12, marginBottom:20}}>
          <button onClick={()=>setKitchenTab("hub")}
            style={{border:"none", background:"none", color:"#2471A3", fontWeight:700, fontSize:13, cursor:"pointer", padding:0}}>
            ← Factory Hub
          </button>
          <span style={{color:"#ddd"}}>|</span>
          <h2 style={{fontSize:20, fontFamily:"'Playfair Display',serif", margin:0}}>
            {kitchenTab==="orders"?"📋 Orders":kitchenTab==="delivery"?"🚚 Delivery":kitchenTab==="inventory"?"📦 Production":kitchenTab==="stock"?"🥟 Stock":kitchenTab==="wholesale"?"🏪 Wholesale":kitchenTab==="items"?"🏷 Items & Prices":kitchenTab==="reports"?"📊 Reports":""}
          </h2>
        </div>
      )}

      {kitchenTab === "stock" && (
        <StockTab
          products={products} factoryStock={factoryStock} saveFactoryStock={saveFactoryStock}
          auth={auth} showToast={showToast}
        />
      )}
      {kitchenTab === "wholesale" && (
        <WholesaleInvoiceTab
          products={products} factoryStock={factoryStock} saveFactoryStock={saveFactoryStock}
          wholesaleCustomers={wholesaleCustomers} saveWholesaleCustomers={saveWholesaleCustomers}
          externalInvoices={externalInvoices} saveExternalInvoices={saveExternalInvoices}
          auth={auth} showToast={showToast}
        />
      )}
      {kitchenTab === "items" && (
        <FactoryItemsTab
          products={products}
          setProducts={setProducts}
          customCats={customCats}
          auth={auth}
          showToast={showToast}
        />
      )}
      {kitchenTab === "reports" && (
        <ReportsHub
          orders={orders}
          saveOrders={saveOrders}
          restaurants={restaurants}
          products={products}
          saveProducts={saveProducts}
          wholesaleCustomers={wholesaleCustomers}
          externalInvoices={externalInvoices}
          showToast={showToast}
        />
      )}

      {kitchenTab === "delivery" && (
        <DeliveryHubView
          auth={auth}
          orders={orders}
          saveOrders={saveOrders}
          restaurants={restaurants}
          products={products}
          pName={pName}
          fmtPrice={fmtPrice}
          showToast={showToast}
          isAdmin={true}
          factoryStock={factoryStock}
        />
      )}

      {kitchenTab === "inventory" && (
        <FactoryInventoryView
          products={products}
          factoryInventory={factoryInventory}
          saveFactoryInventory={saveFactoryInventory}
          factoryLogs={factoryLogs}
          saveFactoryLogs={saveFactoryLogs}
          productionHidden={productionHidden}
          saveProductionHidden={saveProductionHidden}
          auth={auth}
          orders={orders}
          showToast={showToast}
        />
      )}

      {kitchenTab === "orders" && (
        <div>
          {/* Filters */}
          <div style={{display:"flex", gap:8, marginBottom:16, flexWrap:"wrap", alignItems:"center"}}>
            <select value={filterLoc} onChange={e=>setFilterLoc(e.target.value==="all"?"all":parseInt(e.target.value))}
              style={{border:"1px solid #ddd", borderRadius:8, padding:"7px 12px", fontSize:13, background:"#fff", cursor:"pointer"}}>
              <option value="all">All Locations</option>
              {restaurants.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
            </select>
            <select value={filterMonth} onChange={e=>setFilterMonth(e.target.value)}
              style={{border:"1px solid #ddd", borderRadius:8, padding:"7px 12px", fontSize:13, background:"#fff", cursor:"pointer"}}>
              <option value="all">All Months</option>
              {MONTHS.map((m,i) => <option key={i} value={i}>{m}</option>)}
            </select>
            <select value={filterYear} onChange={e=>setFilterYear(e.target.value)}
              style={{border:"1px solid #ddd", borderRadius:8, padding:"7px 12px", fontSize:13, background:"#fff", cursor:"pointer"}}>
              <option value="all">All Years</option>
              {allYears.map(y => <option key={y} value={y}>{y}</option>)}
            </select>
            <div style={{display:"flex", gap:4, flexWrap:"wrap"}}>
              {[["new","New"],["confirmed","To Be Delivered"],["delivered","Delivered"],["cancelled","Cancelled"]].map(([v,l]) => (
                <button key={v} onClick={()=>setFilterStatus(v)}
                  style={{border:"none", borderRadius:8, padding:"7px 14px", fontSize:13, fontWeight:600, cursor:"pointer",
                    background: filterStatus===v ? "#1a1a1a" : "#f0f0f0", color: filterStatus===v ? "#fff" : "#555"}}>
                  {l}
                </button>
              ))}
            </div>
            <div style={{marginLeft:"auto", display:"flex", alignItems:"center", gap:10}}>
              <span style={{fontSize:13, color:"#888"}}>{filtered.length} order{filtered.length!==1?"s":""}</span>
              {/* Mark Delivered bulk mode — only on To Be Delivered tab */}
              {filterStatus === "confirmed" && !combineMode && (
                !markDeliveredMode ? (
                  <button onClick={()=>{setMarkDeliveredMode(true);setSelectedForDelivered([]);}}
                    style={{border:"1px solid #e5e5e5",borderRadius:8,padding:"6px 12px",
                      background:"#fff",color:"#555",fontSize:12,fontWeight:700,cursor:"pointer"}}>
                    ✓ Mark Delivered
                  </button>
                ) : (
                  <div style={{display:"flex",gap:6,alignItems:"center"}}>
                    <span style={{fontSize:12,color:"#888",fontWeight:600}}>{selectedForDelivered.length} selected</span>
                    <button
                      disabled={selectedForDelivered.length === 0}
                      onClick={async () => {
                        const toMark = orders.filter(o => selectedForDelivered.includes(o.id));
                        const updated = orders.map(o =>
                          selectedForDelivered.includes(o.id)
                            ? {...o, status:"delivered", deliveredAt: new Date().toISOString()}
                            : o
                        );
                        await saveOrders(updated);
                        setMarkDeliveredMode(false);
                        setSelectedForDelivered([]);
                        showToast(`✓ ${toMark.length} order${toMark.length!==1?"s":""} marked as delivered`);
                      }}
                      style={{border:"none",borderRadius:8,padding:"6px 12px",fontSize:12,fontWeight:700,
                        background:selectedForDelivered.length>0?"#1a1a1a":"#f0f0f0",
                        color:selectedForDelivered.length>0?"#fff":"#aaa",
                        cursor:selectedForDelivered.length>0?"pointer":"not-allowed"}}>
                      Mark as Delivered
                    </button>
                    <button onClick={()=>{setMarkDeliveredMode(false);setSelectedForDelivered([]);}}
                      style={{border:"1px solid #e5e5e5",borderRadius:8,padding:"6px 10px",
                        background:"#fff",color:"#888",fontSize:12,cursor:"pointer"}}>✕</button>
                  </div>
                )
              )}
              {!markDeliveredMode && (
                !combineMode ? (
                  <button onClick={()=>{setCombineMode(true);setSelectedForCombine([]);}}
                    style={{border:"1px solid #e5e5e5",borderRadius:8,padding:"6px 12px",
                      background:"#fff",color:"#555",fontSize:12,fontWeight:700,cursor:"pointer"}}>
                    🔗 Combine
                  </button>
                ) : (
                  <div style={{display:"flex",gap:6,alignItems:"center"}}>
                    <span style={{fontSize:12,color:"#888",fontWeight:600}}>{selectedForCombine.length} selected</span>
                    <button onClick={()=>setShowCombinePreview(true)}
                      disabled={selectedForCombine.length<2}
                      style={{border:"none",borderRadius:8,padding:"6px 12px",fontSize:12,fontWeight:700,
                        background:selectedForCombine.length>=2?"#1a1a1a":"#f0f0f0",
                        color:selectedForCombine.length>=2?"#fff":"#aaa",
                        cursor:selectedForCombine.length>=2?"pointer":"not-allowed"}}>
                      Preview & Merge
                    </button>
                    <button onClick={()=>{setCombineMode(false);setSelectedForCombine([]);}}
                      style={{border:"1px solid #e5e5e5",borderRadius:8,padding:"6px 10px",
                        background:"#fff",color:"#888",fontSize:12,cursor:"pointer"}}>✕</button>
                  </div>
                )
              )}
            </div>
          </div>

          {/* Order list */}
          {filtered.length === 0
            ? <div style={{textAlign:"center", padding:60, color:"#ccc", fontSize:14}}>No orders found</div>
            : orderGroups.map(group => (
                <div key={group.key} style={{marginBottom:20}}>
                  <div onClick={()=>toggleMonth(group.key)}
                    style={{fontSize:12, fontWeight:700, color:"#666", textTransform:"uppercase",
                      letterSpacing:1, padding:"8px 6px", borderBottom:"1px solid #e8e8e8", marginBottom:8,
                      cursor:"pointer", display:"flex", justifyContent:"space-between", alignItems:"center",
                      userSelect:"none"}}>
                    <span>{group.label}</span>
                    <span style={{color:"#bbb", fontSize:11}}>
                      {group.orders.length} order{group.orders.length!==1?"s":""} {collapsedMonths[group.key] ? "▶" : "▼"}
                    </span>
                  </div>
                  {!collapsedMonths[group.key] && <div style={{display:"flex", flexDirection:"column", gap:10}}>
                    {group.orders.map(o => {
                      const r = restaurants.find(x => x.id === o.restaurantId);
                      const date = new Date(o.timestamp).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"});
                      const time = new Date(o.timestamp).toLocaleTimeString("en-US",{hour:"numeric",minute:"2-digit"});
                      const isConfirmed = o.status?.toLowerCase() === "confirmed";
                      return (
                        <div key={o.id}
                          onClick={()=> {
                            if (markDeliveredMode) {
                              setSelectedForDelivered(prev => prev.includes(o.id) ? prev.filter(x=>x!==o.id) : [...prev, o.id]);
                            } else if (combineMode && combineEligible(o)) {
                              toggleCombineSelect(o.id);
                            } else {
                              openOrder(o);
                            }
                          }}
                          style={{background:"#fff", borderRadius:12, padding:"14px 18px", cursor:"pointer",
                            border: markDeliveredMode && selectedForDelivered.includes(o.id) ? "2px solid #27AE60" :
                                    combineMode && selectedForCombine.includes(o.id) ? "2px solid #1a1a1a" :
                                    selected?.id===o.id ? "2px solid #1a1a1a" : "1px solid #e8e8e8",
                            display:"flex", alignItems:"center", gap:14, flexWrap:"wrap",
                            boxShadow:"0 1px 4px rgba(0,0,0,0.05)", opacity: isConfirmed ? 0.7 : 1}}>
                          {markDeliveredMode ? (
                            <div style={{width:22,height:22,borderRadius:6,flexShrink:0,
                              border:`2px solid ${selectedForDelivered.includes(o.id)?"#27AE60":"#ddd"}`,
                              background:selectedForDelivered.includes(o.id)?"#27AE60":"transparent",
                              display:"flex",alignItems:"center",justifyContent:"center"}}>
                              {selectedForDelivered.includes(o.id)&&<span style={{color:"#fff",fontSize:13,fontWeight:800}}>✓</span>}
                            </div>
                          ) : combineMode ? (
                            <div style={{width:22,height:22,borderRadius:6,flexShrink:0,
                              border:`2px solid ${combineEligible(o)?"#1a1a1a":"#ddd"}`,
                              background:selectedForCombine.includes(o.id)?"#1a1a1a":"transparent",
                              display:"flex",alignItems:"center",justifyContent:"center",
                              opacity:combineEligible(o)?1:0.3}}>
                              {selectedForCombine.includes(o.id)&&<span style={{color:"#fff",fontSize:13,fontWeight:800}}>✓</span>}
                            </div>
                          ) : (
                            <div style={{width:10, height:10, borderRadius:"50%", background:statusColor(o.status), flexShrink:0}}/>
                          )}
                          <div style={{flex:1, minWidth:120}}>
                            <div style={{fontWeight:700, fontSize:14}}>{r?.name || "Unknown"}</div>
                            <div style={{fontSize:12, color:"#888"}}>{date} at {time}</div>
                          </div>
                          <div style={{fontSize:12, color:"#666"}}>{o.items?.length||0} item{o.items?.length!==1?"s":""}</div>
                          <div style={{fontSize:12, fontWeight:600, color:statusColor(o.status),
                            background:statusColor(o.status)+"15", padding:"3px 10px", borderRadius:20}}>
                            {statusLabel(o.status)}
                          </div>
                          <div style={{fontSize:11, color:"#bbb"}}>#{o.id}</div>
                        </div>
                      );
                    })}
                  </div>}
                </div>
              ))
          }
          {/* Combine preview modal */}
          {showCombinePreview && (
            <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:400,
              display:"flex",alignItems:"flex-end",justifyContent:"center"}}
              onClick={()=>setShowCombinePreview(false)}>
              <div style={{background:"#fff",borderRadius:"20px 20px 0 0",width:"100%",maxWidth:520,
                maxHeight:"80vh",overflowY:"auto",boxShadow:"0 -8px 40px rgba(0,0,0,0.2)"}}
                onClick={e=>e.stopPropagation()}>
                <div style={{background:"#1a1a1a",borderRadius:"20px 20px 0 0",padding:"18px 20px"}}>
                  <div style={{color:"#aaa",fontSize:11,fontWeight:700,letterSpacing:1}}>
                    COMBINING {selectedForCombine.length} ORDERS
                  </div>
                  <div style={{color:"#fff",fontWeight:800,fontSize:16,marginTop:2}}>Merged Order Preview</div>
                </div>
                <div style={{padding:"16px 20px 28px"}}>
                  <div style={{fontSize:11,fontWeight:700,color:"#aaa",letterSpacing:1,marginBottom:8}}>MERGING</div>
                  <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:16}}>
                    {orders.filter(o=>selectedForCombine.includes(o.id)).map(o=>{
                      const r=restaurants.find(x=>x.id===o.restaurantId);
                      return (
                        <div key={o.id} style={{background:"#f5f5f5",borderRadius:8,padding:"6px 12px",fontSize:12,fontWeight:600}}>
                          #{o.id} . {r?.name} . {o.items.length} items
                        </div>
                      );
                    })}
                  </div>
                  <div style={{fontSize:11,fontWeight:700,color:"#aaa",letterSpacing:1,marginBottom:8}}>
                    COMBINED ITEMS ({combinePreviewItems().length} unique products)
                  </div>
                  <div style={{display:"flex",flexDirection:"column",gap:4,marginBottom:16}}>
                    {combinePreviewItems().map((item,i)=>{
                      const p=products.find(x=>x.id===item.productId);
                      return (
                        <div key={i} style={{display:"flex",alignItems:"center",gap:10,
                          padding:"10px 12px",background:"#fafafa",borderRadius:8}}>
                          <div style={{flex:1,fontWeight:600,fontSize:14}}>
                            {p?pName(p):item.name||"Unknown"}
                          </div>
                          <div style={{fontWeight:800,fontSize:14}}>× {item.qty}</div>
                          {p?.price&&<div style={{fontSize:13,color:"#888",minWidth:60,textAlign:"right"}}>
                            ${(p.price*item.qty).toFixed(2)}
                          </div>}
                        </div>
                      );
                    })}
                  </div>
                  <div style={{background:"#FFF9F0",border:"1px solid #F39C12",borderRadius:10,
                    padding:"10px 14px",marginBottom:14,fontSize:13,color:"#92400E"}}>
                    ⚠️ Original orders will be replaced. This cannot be undone.
                  </div>
                  <div style={{display:"flex",flexDirection:"column",gap:8}}>
                    <button onClick={doCombine}
                      style={{width:"100%",padding:"14px",borderRadius:12,border:"none",
                        background:"#1a1a1a",color:"#fff",fontSize:15,fontWeight:700,cursor:"pointer"}}>
                      🔗 Merge into Single Order
                    </button>
                    <button onClick={()=>setShowCombinePreview(false)}
                      style={{width:"100%",padding:"12px",borderRadius:12,border:"none",
                        background:"#f5f5f5",color:"#555",fontSize:14,cursor:"pointer"}}>
                      Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {selected && (
            <div style={{position:"fixed", inset:0, background:"rgba(0,0,0,0.6)", zIndex:200, overflowY:"auto", padding:"20px 16px"}}
              onClick={e => e.target===e.currentTarget && setSelected(null)}>
              <div style={{background:"#fff", borderRadius:16, maxWidth:720, margin:"0 auto", overflow:"hidden", boxShadow:"0 20px 60px rgba(0,0,0,0.3)"}}>
                {/* Header */}
                <div style={{background: selected?.status?.toLowerCase()==="cancelled" ? "#7f8c8d" : showInvoice ? "#27AE60" : "#C0392B", padding:"18px 24px", display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                  <div>
                    <div style={{color:"#fff", fontWeight:700, fontSize:17}}>
                      {selected?.status?.toLowerCase()==="cancelled" ? "🚫 Cancelled — " : showInvoice ? "📋 Order — " : ""}{rest?.name} — Order #{selected.id}
                    </div>
                    <div style={{color:"rgba(255,255,255,0.75)", fontSize:12, marginTop:2}}>
                      {new Date(selected.timestamp).toLocaleDateString("en-US",{weekday:"long",month:"long",day:"numeric",year:"numeric"})}
                    </div>
                  </div>
                  <div style={{display:"flex",gap:6,alignItems:"center"}}>
                    {showInvoice && !["cancelled"].includes(selected?.status?.toLowerCase()) && (
                      <button onClick={()=>{setShowInvoice(false); setAdjustReason("pre_delivery");}}
                        style={{background:"rgba(255,255,255,0.25)",border:"none",borderRadius:8,
                          padding:"6px 12px",color:"#fff",fontWeight:700,cursor:"pointer",fontSize:12}}>
                        ✏️ Edit Invoice
                      </button>
                    )}
                    <button onClick={()=>setSelected(null)}
                      style={{background:"rgba(255,255,255,0.2)", border:"none", borderRadius:8, padding:"6px 12px", color:"#fff", fontWeight:700, cursor:"pointer", fontSize:16}}>✕</button>
                  </div>
                </div>

                <div style={{padding:"20px 24px"}}>
                  {!showInvoice ? (
                    <>
                      {selected.note && <NoteWithTranslate note={selected.note} />}

                      {/* Delivery date edit for confirmed orders */}
                      {["to_be_delivered","confirmed","[ok] confirmed"].includes(selected?.status?.toLowerCase()) && (
                        <div style={{marginBottom:14,padding:"12px 16px",background:"#f0faf4",border:"1px solid #86EFAC",borderRadius:10,display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}}>
                          <label style={{fontSize:12,fontWeight:700,color:"#15803D",textTransform:"uppercase",letterSpacing:.5,whiteSpace:"nowrap"}}>📅 Delivery Date</label>
                          <input type="date" value={deliveryDateInput}
                            onChange={e=>{
                              const val = e.target.value;
                              setDeliveryDateInput(val);
                              const updated = {...selected, deliveryDate: val};
                              saveOrders(orders.map(o=>o.id===selected.id?updated:o));
                              setSelected(updated);
                              showToast("✓ Delivery date updated");
                            }}
                            style={{border:"1px solid #86EFAC",borderRadius:8,padding:"7px 12px",
                              fontSize:14,fontWeight:700,fontFamily:"'IBM Plex Sans',sans-serif",
                              color:"#15803D",outline:"none",background:"#fff"}}/>
                          <span style={{fontSize:11,color:"#888"}}>Edit to correct the delivery date</span>
                        </div>
                      )}

                      {/* Adjustment reason */}
                      <div style={{marginBottom:14}}>
                        <div style={{fontSize:11,fontWeight:800,color:"#888",marginBottom:6}}>
                          {["sent","pending"].includes(selected?.status?.toLowerCase()) ? "REASON FOR EDIT" : "REASON FOR EDIT"}
                        </div>
                        <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                          {(["sent","pending"].includes(selected?.status?.toLowerCase()) ? [
                            ["pre_delivery","✏️ Correct / Adjust Order","#2471A3"],
                          ] : [
                            ["pre_delivery","📦 Pre-Delivery Change","#2471A3"],
                            ["rejected","🚫 Item Rejected / Not Accepted","#E74C3C"],
                            ["refund","💰 Partial / Full Refund","#8E44AD"],
                          ]).map(([val,label,color])=>(
                            <button key={val} onClick={()=>setAdjustReason(val)}
                              style={{border:`2px solid ${adjustReason===val?color:"#e5e5e5"}`,
                                borderRadius:8,padding:"6px 12px",fontSize:12,fontWeight:700,
                                background:adjustReason===val?color+"15":"#fff",
                                color:adjustReason===val?color:"#888",cursor:"pointer"}}>
                              {label}
                            </button>
                          ))}
                        </div>
                        {adjustReason==="rejected"&&(
                          <div style={{fontSize:11,color:"#E74C3C",marginTop:6}}>
                            Set rejected item qty to 0 — it will be added back to factory inventory
                          </div>
                        )}
                        {adjustReason==="refund"&&(
                          <div style={{fontSize:11,color:"#8E44AD",marginTop:6}}>
                            Adjust prices or quantities below. A refund note will be added to the order
                          </div>
                        )}
                      </div>

                      {/* Items table */}
                      <div style={{marginBottom:14}}>
                        <div style={{display:"grid", gridTemplateColumns:"1fr 72px 100px 90px 32px", gap:6, padding:"7px 8px", background:"#f5f5f5", borderRadius:8, fontSize:11, fontWeight:700, color:"#888", marginBottom:4}}>
                          <span>ITEM</span><span style={{textAlign:"center"}}>QTY</span>
                          <span style={{textAlign:"center"}}>UNIT PRICE</span>
                          <span style={{textAlign:"right"}}>TOTAL</span><span/>
                        </div>
                        {editItems && editItems.map((it, idx) => {
                          const ep = effectivePrice(it);
                          return (
                            <div key={idx} style={{display:"grid", gridTemplateColumns:"1fr 72px 100px 90px 32px", gap:6, padding:"7px 8px", alignItems:"center",
                              background: it.added ? "#FFFBF0" : idx%2===0?"#fff":"#fafafa", borderRadius:8, marginBottom:2,
                              border: it.added ? "1px dashed #F39C12" : "1px solid transparent"}}>
                              <div>
                                {it.added && !it.productId
                                  ? <input
                                      value={it.name}
                                      onChange={e => setEditItems(prev => prev.map((x,i) => i===idx ? {...x, name:e.target.value} : x))}
                                      placeholder="Item name..."
                                      style={{fontWeight:600, fontSize:13, border:"1px solid #F39C12", borderRadius:6,
                                        padding:"4px 8px", width:"100%", boxSizing:"border-box",
                                        fontFamily:"'IBM Plex Sans',sans-serif", outline:"none", background:"#FFFBF0"}}/>
                                  : <span style={{fontWeight:600, fontSize:13}}>{it.name}</span>
                                }
                                {it.added && <span style={{fontSize:9, color:"#E67E22", marginLeft:5, fontWeight:700}}>+ADDED</span>}
                                {!it.added && it.unit && <span style={{fontSize:11, color:"#bbb", marginLeft:5}}>{it.unit}</span>}
                              </div>
                              <input type="number" value={it.qty} min={0} onChange={e=>updateQty(idx,e.target.value)}
                                style={{textAlign:"center", border:"1px solid #e5e5e5", borderRadius:6, padding:"5px 4px", fontSize:13, width:"100%"}}/>
                              <div style={{position:"relative"}}>
                                <span style={{position:"absolute", left:7, top:"50%", transform:"translateY(-50%)", color:"#aaa", fontSize:11, pointerEvents:"none"}}>$</span>
                                <input type="number" step="0.01" min="0"
                                  value={it.customPrice !== null ? it.customPrice : (it.price !== null && it.price !== undefined ? it.price : "")}
                                  placeholder={it.price != null ? String(it.price) : "Market"}
                                  onChange={e=>updatePrice(idx, e.target.value)}
                                  style={{textAlign:"right", border:"1px solid #e5e5e5", borderRadius:6, padding:"5px 8px 5px 18px", fontSize:13, width:"100%",
                                    background: it.customPrice !== null ? "#FFFBF0" : "#fff"}}/>
                              </div>
                              <div style={{textAlign:"right", fontSize:13, fontWeight:600, color: ep!=null?"#1a1a1a":"#aaa"}}>
                                {ep != null ? `$${(ep*it.qty).toFixed(2)}` : "—"}
                              </div>
                              <button onClick={()=>removeItem(idx)}
                                style={{background:"#fee", border:"none", borderRadius:6, padding:"4px 6px", color:"#C0392B", cursor:"pointer", fontSize:11, fontWeight:700}}>✕</button>
                            </div>
                          );
                        })}
                      </div>
                      {/* Add item */}
                      <div style={{background:"#f8f8f8", borderRadius:10, padding:"10px 12px", marginBottom:14, border:"1px dashed #ddd"}}>
                        <div style={{fontSize:11, fontWeight:700, color:"#888", marginBottom:7}}>+ ADD ITEM (phone order / last minute)</div>
                        <select
                          value=""
                          onChange={e => {
                            const val = e.target.value;
                            if (!val) return;
                            if (val === "custom") {
                              setEditItems(prev => [...prev, {productId:null, name:"", unit:"", qty:1, customPrice:null, added:true}]);
                            } else {
                              const p = products.find(x => x.id === parseInt(val));
                              if (!p) return;
                              setEditItems(prev => [...prev, {
                                productId: p.id, name: p.name, unit: p.unit, qty: 1,
                                customPrice: p.price ?? null, added: true
                              }]);
                            }
                          }}
                          style={{width:"100%", border:"1px solid #e5e5e5", borderRadius:8, padding:"8px 12px",
                            fontSize:13, background:"#fff", fontFamily:"'IBM Plex Sans',sans-serif",
                            color:"#555", cursor:"pointer"}}>
                          <option value="">Select a product to add...</option>
                          {products
                            .filter(p => !editItems.some(it => it.productId === p.id))
                            .map(p => (
                              <option key={p.id} value={p.id}>
                                {p.name} — {p.unit}{p.price != null ? ` ($${p.price.toFixed(2)})` : " (Market)"}
                              </option>
                            ))
                          }
                          <option value="custom">✏️ Add custom line item...</option>
                        </select>
                      </div>
                      <div style={{textAlign:"right", fontSize:14, fontWeight:700, marginBottom:18}}>
                        Subtotal: ${editSubtotal.toFixed(2)}
                      </div>
                      <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", gap:10, flexWrap:"wrap"}}>
                        <button onClick={()=>{ setCancelModal({order:selected, mode:"kitchen"}); setCancelReason(""); setCancelConfirmStep(false); }}
                          style={{background:"#fff", color:"#C0392B", border:"2px solid #C0392B", borderRadius:10, padding:"11px 20px", fontSize:14, fontWeight:700, cursor:"pointer"}}>
                          🚫 Cancel Order
                        </button>
                        {["to_be_delivered","delivered","confirmed"].includes(selected?.status?.toLowerCase()) ? (
                          // Already confirmed — save changes, adjust FIFO stock for quantity changes
                          <button onClick={()=>{
                            const prevItems = selected.items;
                            const newItems = editItems.filter(it=>it.qty>0).map(it=>({
                              productId:it.productId||null, qty:it.qty, customPrice:it.customPrice??null,
                              name: it.name || (it.productId ? products.find(x=>x.id===it.productId)?.name : null) || "",
                              unit: it.unit || (it.productId ? products.find(x=>x.id===it.productId)?.unit : null) || "",
                              ...(it.added?{added:true}:{}),
                              // preserve existing lot assignments
                              ...(it.lotAssignment?{lotAssignment:it.lotAssignment}:{}),
                            }));

                            // ── FIFO stock adjustment for Frozen Dumplings ──
                            const DUMPLING_CATS = ["Frozen Dumplings"];
                            let updatedStock = [...factoryStock];
                            const stockChanges = [];

                            newItems.forEach(newIt => {
                              if (!newIt.productId) return;
                              const prod = products.find(x=>x.id===newIt.productId);
                              if (!prod || !DUMPLING_CATS.includes(prod.category)) return;
                              const prevIt = prevItems.find(p=>p.productId===newIt.productId);
                              const prevQty = prevIt?.qty || 0;
                              const diff = newIt.qty - prevQty; // positive = added more, negative = removed

                              if (diff === 0) return;

                              if (diff > 0) {
                                // Added more — FIFO deduct from stock
                                const stockByProd = {};
                                updatedStock.forEach(e => {
                                  if (e.productId === newIt.productId && (e.qtyRemaining||0) > 0) {
                                    if (!stockByProd[e.productId]) stockByProd[e.productId] = [];
                                    stockByProd[e.productId].push({...e});
                                  }
                                });
                                const lots = (stockByProd[newIt.productId]||[]).sort((a,b)=>
                                  !a.date?1:!b.date?-1:a.date<b.date?-1:a.date>b.date?1:0);
                                let rem = diff;
                                const newAssigns = [...(prevIt?.lotAssignment||[])];
                                for (const lot of lots) {
                                  if (rem <= 0) break;
                                  const take = Math.min(lot.qtyRemaining, rem);
                                  updatedStock = updatedStock.map(e=>
                                    e.id===lot.id ? {...e, qtyRemaining:Math.max(0,e.qtyRemaining-take)} : e);
                                  const existing = newAssigns.find(a=>a.lotId===lot.id);
                                  if (existing) existing.qty += take;
                                  else newAssigns.push({date:lot.date,lotId:lot.id,lotNumber:lot.lotNumber,qty:take});
                                  rem -= take;
                                }
                                newIt.lotAssignment = newAssigns;
                                if (rem > 0) stockChanges.push(`⚠️ ${prod.name}: needed ${diff} more, only ${diff-rem} in stock`);
                              } else {
                                // Removed — return stock to original lots if known, else create return entry
                                const returnQty = Math.abs(diff);
                                const assigns = prevIt?.lotAssignment || [];
                                if (assigns.length > 0) {
                                  // Return proportionally to original lots (newest first = LIFO return)
                                  let rem = returnQty;
                                  const revAssigns = [...assigns].reverse();
                                  const newAssigns = [...assigns];
                                  for (const a of revAssigns) {
                                    if (rem <= 0) break;
                                    const ret = Math.min(a.qty, rem);
                                    updatedStock = updatedStock.map(e=>
                                      e.id===a.lotId ? {...e, qtyRemaining:(e.qtyRemaining||0)+ret} : e);
                                    const na = newAssigns.find(x=>x.lotId===a.lotId);
                                    if (na) na.qty -= ret;
                                    rem -= ret;
                                  }
                                  newIt.lotAssignment = newAssigns.filter(a=>a.qty>0);
                                } else {
                                  // No lot assignment — create a return entry with today's date
                                  const returnEntry = {
                                    id: Date.now() + Math.random(),
                                    productId: newIt.productId,
                                    productName: prod.name,
                                    category: prod.category,
                                    date: new Date().toISOString().slice(0,10),
                                    lotNumber: null,
                                    qtyProduced: returnQty,
                                    qtyRemaining: returnQty,
                                    type: "order_return",
                                    note: `Returned from order #${selected.id}`,
                                    createdAt: new Date().toISOString(),
                                    createdBy: auth?.name || "Admin",
                                  };
                                  updatedStock = [returnEntry, ...updatedStock];
                                }
                              }
                            });

                            // Also handle items removed entirely
                            prevItems.forEach(prevIt => {
                              if (!prevIt.productId) return;
                              const prod = products.find(x=>x.id===prevIt.productId);
                              if (!prod || !DUMPLING_CATS.includes(prod.category)) return;
                              if (!newItems.find(n=>n.productId===prevIt.productId)) {
                                // Item removed entirely — return all to stock
                                const assigns = prevIt.lotAssignment || [];
                                if (assigns.length > 0) {
                                  assigns.forEach(a => {
                                    updatedStock = updatedStock.map(e=>
                                      e.id===a.lotId ? {...e, qtyRemaining:(e.qtyRemaining||0)+a.qty} : e);
                                  });
                                }
                              }
                            });

                            if (updatedStock !== factoryStock) saveFactoryStock(updatedStock);

                            // Old factoryInventory restore for rejected/refund (legacy)
                            if (["rejected","refund"].includes(adjustReason)) {
                              const newInv = {...factoryInventory};
                              prevItems.forEach(prev=>{
                                if (!prev.productId) return;
                                const newItem = newItems.find(n=>n.productId===prev.productId);
                                const diff = prev.qty - (newItem?.qty||0);
                                if (diff > 0) newInv[prev.productId] = (newInv[prev.productId]||0) + diff;
                              });
                              saveFactoryInventory(newInv);
                            }

                            const updatedOrder = {
                              ...selected,
                              items: newItems,
                              lastEditedAt: new Date().toISOString(),
                              lastEditReason: adjustReason,
                              lastEditedBy: auth?.name || "Admin",
                            };
                            saveOrders(orders.map(o=>o.id===selected.id?updatedOrder:o));
                            setSelected(updatedOrder);
                            setShowInvoice(true);
                            const extraMsg = stockChanges.length ? ` (${stockChanges.join(", ")})` : "";
                            showToast(adjustReason==="refund"?"💰 Refund applied & invoice updated":
                              adjustReason==="rejected"?"🚫 Rejected items removed & inventory restored":
                              `✓ Invoice updated${extraMsg}`);
                          }}
                            style={{background:"#1a1a1a",color:"#fff",border:"none",borderRadius:10,
                              padding:"13px 28px",fontSize:15,fontWeight:700,cursor:"pointer"}}>
                            💾 Save Changes
                          </button>
                        ) : (
                          <>
                            <div style={{marginBottom:14,padding:"12px 16px",background:"#f8f8f8",borderRadius:10,display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}}>
                              <label style={{fontSize:12,fontWeight:700,color:"#888",textTransform:"uppercase",letterSpacing:.5,whiteSpace:"nowrap"}}>📅 Delivery Date</label>
                              <input type="date" value={deliveryDateInput}
                                onChange={e=>setDeliveryDateInput(e.target.value)}
                                style={{border:"1px solid #e5e5e5",borderRadius:8,padding:"7px 12px",
                                  fontSize:14,fontWeight:700,fontFamily:"'IBM Plex Sans',sans-serif",
                                  color:deliveryDateInput?"#1a1a1a":"#aaa",outline:"none"}}/>
                              {!deliveryDateInput && <span style={{fontSize:11,color:"#E74C3C",fontWeight:600}}>Required before confirming</span>}
                            </div>
                            {/* Manual lot assignment — one picker per dumpling item */}
                            {(() => {
                              const dumplingItems = (editItems||[]).filter(it => {
                                const prod = it.productId ? products.find(x=>String(x.id)===String(it.productId)) : null;
                                return prod && prod.category === "Frozen Dumplings" && it.qty > 0;
                              });
                              if (!dumplingItems.length) return null;
                              return (
                                <div style={{marginBottom:14,padding:"14px 16px",background:"#EBF5FB",border:"1px solid #AED6F1",borderRadius:10}}>
                                  <div style={{fontWeight:700,fontSize:12,color:"#2471A3",marginBottom:10,textTransform:"uppercase",letterSpacing:.5}}>📦 Assign Dumpling Lots</div>
                                  {dumplingItems.map(it => {
                                    const prod = products.find(x=>String(x.id)===String(it.productId));
                                    const availLots = factoryStock.filter(s=>s.productId===it.productId&&(s.qtyRemaining||0)>0)
                                      .sort((a,b)=>!a.date?1:!b.date?-1:a.date<b.date?-1:a.date>b.date?1:0);
                                    const chosenId = manualLots[it.productId] || null;
                                    return (
                                      <div key={it.productId} style={{marginBottom:10,display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
                                        <div style={{fontSize:12,fontWeight:700,color:"#1a1a1a",minWidth:120}}>{prod?.name||it.name} <span style={{color:"#888",fontWeight:400}}>×{it.qty}</span></div>
                                        <select value={chosenId||"auto"} onChange={e=>setManualLots(m=>({...m,[it.productId]:e.target.value==="auto"?null:e.target.value}))}
                                          style={{fontSize:12,border:"1px solid #AED6F1",borderRadius:7,padding:"4px 8px",outline:"none",color:"#1a1a1a",background:"#fff"}}>
                                          <option value="auto">Auto FIFO</option>
                                          {availLots.map(lot=>(
                                            <option key={lot.id} value={String(lot.id)}>
                                              {lot.date ? new Date(lot.date+"T12:00:00").toLocaleDateString("en-US",{month:"short",day:"numeric",year:"2-digit"}) : "No date"} ({lot.qtyRemaining} left)
                                            </option>
                                          ))}
                                          {availLots.length===0 && <option disabled>⚠️ No stock available</option>}
                                        </select>
                                      </div>
                                    );
                                  })}
                                </div>
                              );
                            })()}
                            <button onClick={confirmOrder}
                              style={{background: deliveryDateInput ? "#27AE60" : "#ccc", color:"#fff", border:"none", borderRadius:10, padding:"13px 32px", fontSize:15, fontWeight:700, cursor: deliveryDateInput ? "pointer" : "not-allowed", boxShadow: deliveryDateInput ? "0 4px 14px rgba(39,174,96,0.3)" : "none"}}>
                              ✓ Confirm Order
                            </button>
                          </>
                        )}
                      </div>
                    </>
                  ) : (
                    <>
                      {/* Invoice view */}
                      {/* Signature display for delivered orders */}
                    {selected?.status?.toLowerCase()==="delivered" && selected?.signature && (
                      <div style={{background:"#f0faf4",border:"1px solid #27AE60",
                        borderRadius:12,padding:"16px 18px",marginBottom:16}}>
                        <div style={{fontWeight:800,fontSize:13,color:"#27AE60",marginBottom:8,
                          display:"flex",alignItems:"center",gap:8}}>
                          [OK] Delivery Confirmed
                          <span style={{fontWeight:400,fontSize:11,color:"#888"}}>
                            {selected.deliveredAt ? new Date(selected.deliveredAt).toLocaleString("en-US",
                              {month:"short",day:"numeric",year:"numeric",
                               hour:"2-digit",minute:"2-digit"}) : ""}
                          </span>
                        </div>
                        <div style={{fontSize:12,color:"#555",marginBottom:10}}>
                          Signed by restaurant staff . Delivered by {selected.deliveredBy||"Driver"}
                        </div>
                        <div style={{background:"#fff",borderRadius:8,border:"1px solid #e5e5e5",
                          padding:8,display:"inline-block"}}>
                          <div style={{fontSize:10,color:"#aaa",marginBottom:4,fontWeight:700}}>
                            SIGNATURE
                          </div>
                          <img src={selected.signature} alt="Delivery signature"
                            style={{maxWidth:"100%",width:280,height:"auto",display:"block",
                              borderRadius:4}}/>
                        </div>
                      </div>
                    )}


                    {/* Edit history badge */}
                    {selected?.lastEditedAt && (
                      <div style={{background:
                        selected.lastEditReason==="refund"?"#f5f0ff":
                        selected.lastEditReason==="rejected"?"#fff8f8":"#f0f8ff",
                        border:`1px solid ${selected.lastEditReason==="refund"?"#8E44AD":selected.lastEditReason==="rejected"?"#E74C3C":"#2471A3"}`,
                        borderRadius:10,padding:"10px 14px",marginBottom:14,fontSize:12}}>
                        <div style={{fontWeight:700,color:
                          selected.lastEditReason==="refund"?"#8E44AD":
                          selected.lastEditReason==="rejected"?"#E74C3C":"#2471A3"}}>
                          {selected.lastEditReason==="refund"?"💰 Refund Applied":
                           selected.lastEditReason==="rejected"?"🚫 Items Rejected":
                           "Note: Invoice Edited"}
                        </div>
                        <div style={{color:"#888",marginTop:2}}>
                          By {selected.lastEditedBy} . {new Date(selected.lastEditedAt).toLocaleString("en-US",{month:"short",day:"numeric",hour:"2-digit",minute:"2-digit"})}
                        </div>
                      </div>
                    )}

                    {selected?.status?.toLowerCase()==="cancelled" && (
                        <div style={{background:"#f4f6f7", border:"1px solid #bdc3c7", borderRadius:10, padding:"16px 18px", marginBottom:18}}>
                          <div style={{fontWeight:800, fontSize:16, color:"#7f8c8d", marginBottom:6}}>🚫 Order Cancelled</div>
                          <div style={{fontSize:13, color:"#555", marginBottom:4}}>
                            <span style={{color:"#888"}}>Order #</span><strong>{selected.id}</strong>
                            <span style={{color:"#888", marginLeft:12}}>Location: </span><strong>{rest?.name}</strong>
                          </div>
                          {selected.cancelledAt && (
                            <div style={{fontSize:13, color:"#555", marginBottom:4}}>
                              <span style={{color:"#888"}}>Cancelled: </span>
                              <strong>{new Date(selected.cancelledAt).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"})}</strong>
                            </div>
                          )}
                          {(selected.cancelReason || selected.cancelRequestReason) && (
                            <div style={{marginTop:10, padding:"10px 14px", background:"#fff", borderRadius:8, border:"1px solid #ddd"}}>
                              <div style={{fontSize:11, fontWeight:700, color:"#aaa", textTransform:"uppercase", marginBottom:4}}>Reason for Cancellation</div>
                              <div style={{fontSize:14, color:"#333"}}>"{selected.cancelReason || selected.cancelRequestReason}"</div>
                            </div>
                          )}
                        </div>
                      )}
                      <div style={{display:"flex", justifyContent:"space-between", marginBottom:14, padding:"14px 16px", background:"#f8f8f8", borderRadius:10, gap:16, flexWrap:"wrap"}}>
                        <div>
                          <div style={{fontSize:10, fontWeight:700, color:"#999", textTransform:"uppercase", marginBottom:3}}>From</div>
                          <div style={{fontWeight:700, fontSize:15}}>{rest?.name}</div>
                          <div style={{fontSize:12, color:"#555"}}>{rest?.managerName}</div>
                        </div>
                        <div>
                          <div style={{fontSize:10, fontWeight:700, color:"#999", textTransform:"uppercase", marginBottom:3}}>To</div>
                          <div style={{fontWeight:700, fontSize:15}}>Central Factory</div>
                        </div>
                        <div style={{textAlign:"right"}}>
                          <div style={{fontSize:11, color:"#aaa"}}>Order #{selected.id}</div>
                          <div style={{fontSize:12, color:"#555"}}>{new Date(selected.timestamp).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"})}</div>
                          <div style={{fontSize:12, color:"#27AE60", fontWeight:700, marginTop:4}}>
                            ✓ Confirmed {selected.confirmedAt ? new Date(selected.confirmedAt).toLocaleDateString("en-US",{month:"short",day:"numeric"}) : ""}
                          </div>
                        </div>
                      </div>

                      {/* ── Delivery date — editable on all confirmed/delivered orders ── */}
                      <div style={{marginBottom:16, padding:"10px 14px", background:"#EBF5FB", border:"1px solid #AED6F1", borderRadius:10, display:"flex", alignItems:"center", gap:12, flexWrap:"wrap"}}>
                        <span style={{fontSize:11, fontWeight:700, color:"#2471A3", textTransform:"uppercase", letterSpacing:.5, whiteSpace:"nowrap"}}>📅 Delivery Date</span>
                        <input type="date" value={deliveryDateInput}
                          onChange={e => {
                            const val = e.target.value;
                            setDeliveryDateInput(val);
                            const updated = { ...selected, deliveryDate: val ? new Date(val + "T12:00:00").toISOString() : null };
                            saveOrders(orders.map(o => o.id === selected.id ? updated : o));
                            setSelected(updated);
                            showToast("✓ Delivery date updated");
                          }}
                          style={{border:"1px solid #AED6F1", borderRadius:8, padding:"6px 10px", fontSize:13, fontWeight:700,
                            fontFamily:"'IBM Plex Sans',sans-serif", color: deliveryDateInput ? "#2471A3" : "#aaa", outline:"none", background:"#fff"}}/>
                        {!deliveryDateInput && <span style={{fontSize:11, color:"#E74C3C", fontWeight:600}}>No date set</span>}
                        <span style={{fontSize:11, color:"#888", marginLeft:"auto"}}>Tap to correct</span>
                      </div>
                      <div style={{marginBottom:16}}>
                        <div style={{display:"grid", gridTemplateColumns:"1fr 60px 90px 90px", gap:8, padding:"8px 10px", background:"#1a1a1a", borderRadius:"8px 8px 0 0", fontSize:11, fontWeight:700, color:"#fff"}}>
                          <span>ITEM</span><span style={{textAlign:"center"}}>QTY</span>
                          <span style={{textAlign:"right"}}>UNIT PRICE</span><span style={{textAlign:"right"}}>TOTAL</span>
                        </div>
                        {invoiceItems.map((it,i) => {
                          const ep = it.price;
                          return (
                            <div key={i} style={{display:"grid", gridTemplateColumns:"1fr 60px 90px 90px", gap:8, padding:"9px 10px", alignItems:"center", background: i%2===0?"#fff":"#f9f9f9", borderBottom:"1px solid #eee"}}>
                              <div>
                                <span style={{fontWeight:600, fontSize:13}}>{it.name}</span>
                                {it.added && <span style={{fontSize:9, background:"#FFF3CD", color:"#856404", padding:"1px 5px", borderRadius:3, marginLeft:5, fontWeight:700}}>ADDED</span>}
                                {it.unit && <span style={{fontSize:11, color:"#aaa", marginLeft:5}}>{it.unit}</span>}
                              </div>
                              <div style={{textAlign:"center", fontSize:13}}>{it.qty}</div>
                              <div style={{textAlign:"right", fontSize:13, color: ep!=null?"#1a1a1a":"#aaa"}}>{ep != null ? `$${parseFloat(ep).toFixed(2)}` : "Market"}</div>
                              <div style={{textAlign:"right", fontSize:13, fontWeight:600}}>{ep != null ? `$${(ep*it.qty).toFixed(2)}` : "—"}</div>
                            </div>
                          );
                        })}
                        <div style={{padding:"12px 10px", background:"#f5f5f5", borderRadius:"0 0 8px 8px", display:"flex", justifyContent:"flex-end", gap:8, alignItems:"center"}}>
                          <span style={{fontSize:13, color:"#888"}}>Total:</span>
                          <span style={{fontSize:18, fontWeight:700}}>${subtotal.toFixed(2)}</span>
                        </div>
                      </div>
                      {selected.note && <NoteWithTranslate note={selected.note} />}
                      {selected.status?.toLowerCase() === "cancel_requested" && (
                        <div style={{background:"#f3e8ff", border:"1px solid #8E44AD", borderRadius:10, padding:"12px 16px", marginBottom:14}}>
                          <div style={{fontWeight:700, color:"#6C3483", fontSize:14, marginBottom:4}}>⚠️ Restaurant Requested Cancellation</div>
                          {selected.cancelRequestReason && <div style={{fontSize:13, color:"#7D3C98"}}>Reason: "{selected.cancelRequestReason}"</div>}
                          <div style={{fontSize:12, color:"#9B59B6", marginTop:6}}>Use the Cancel Order button below to process this cancellation.</div>
                        </div>
                      )}
                      <div style={{display:"flex", gap:10, flexWrap:"wrap", justifyContent:"space-between", paddingTop:14, borderTop:"1px solid #eee", alignItems:"center"}}>
                        <button onClick={()=>{ setCancelModal({order:selected, mode:"kitchen"}); setCancelReason(""); setCancelConfirmStep(false); }}
                          style={{background:"#fff", color:"#C0392B", border:"2px solid #C0392B", borderRadius:9, padding:"9px 16px", fontSize:13, fontWeight:700, cursor:"pointer"}}>
                          🚫 Cancel Order
                        </button>
                        <div style={{display:"flex", gap:8, flexWrap:"wrap"}}>
                          <button onClick={printInvoice} style={{border:"1px solid #e5e5e5", background:"#fff", borderRadius:9, padding:"10px 16px", fontSize:13, fontWeight:600, cursor:"pointer", color:"#555"}}>📄 Save as PDF / Print</button>
                          <button onClick={downloadExcel} style={{border:"1px solid #e5e5e5", background:"#fff", borderRadius:9, padding:"10px 16px", fontSize:13, fontWeight:600, cursor:"pointer", color:"#555"}}>📊 Download Excel</button>

                          <button onClick={printPackingSlip} style={{border:"1px solid #e5e5e5", background:"#fff", borderRadius:9, padding:"10px 16px", fontSize:13, fontWeight:600, cursor:"pointer", color:"#555"}}>📦 Print Packing Slip</button>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Cancel Modal */}
      {cancelModal && (
        <div style={{position:"fixed", inset:0, background:"rgba(0,0,0,0.6)", zIndex:500, display:"flex", alignItems:"center", justifyContent:"center", padding:16}}>
          <div style={{background:"#fff", borderRadius:16, maxWidth:440, width:"100%", padding:28, boxShadow:"0 20px 60px rgba(0,0,0,0.3)"}}>
            {!cancelConfirmStep ? (
              <>
                <div style={{fontSize:18, fontWeight:800, marginBottom:6}}>
                  {cancelModal.order.status?.toLowerCase() === "confirmed" ? "Cancel confirmed order?" : "Cancel this order?"}
                </div>
                <div style={{fontSize:13, color:"#888", marginBottom:16}}>
                  Order #{cancelModal.order.id} . {cancelModal.order.restaurantName || "Restaurant"}
                </div>
                {cancelModal.order.status?.toLowerCase() === "confirmed" && (
                  <div style={{marginBottom:16}}>
                    <label style={{fontSize:12, fontWeight:700, color:"#555", display:"block", marginBottom:6}}>REASON FOR CANCELLATION (required)</label>
                    <textarea value={cancelReason} onChange={e=>setCancelReason(e.target.value)}
                      placeholder="Enter reason..."
                      style={{width:"100%", border:"1px solid #e5e5e5", borderRadius:9, padding:"10px 12px", fontSize:13, resize:"vertical", minHeight:80, boxSizing:"border-box"}}/>
                  </div>
                )}
                {cancelModal.order.status?.toLowerCase() === "cancel_requested" && (
                  <div style={{background:"#f3e8ff", borderRadius:8, padding:"10px 12px", marginBottom:16, fontSize:13, color:"#6C3483"}}>
                    <strong>Restaurant reason:</strong> {cancelModal.order.cancelRequestReason || "No reason given"}
                  </div>
                )}
                <div style={{display:"flex", gap:10}}>
                  <button onClick={()=>{ setCancelModal(null); setCancelReason(""); }}
                    style={{flex:1, background:"#f0f0f0", border:"none", borderRadius:10, padding:12, fontSize:14, fontWeight:600, cursor:"pointer", color:"#555"}}>
                    Keep Order
                  </button>
                  <button
                    disabled={cancelModal.order.status?.toLowerCase() === "confirmed" && !cancelReason.trim()}
                    onClick={()=>{
                      const s = cancelModal.order.status?.toLowerCase();
                      if (s === "pending" || s === "sent") { setCancelConfirmStep(true); }
                      else { doCancel(cancelModal.order, cancelReason || cancelModal.order.cancelRequestReason); }
                    }}
                    style={{flex:1,
                      background: cancelModal.order.status?.toLowerCase() === "confirmed" && !cancelReason.trim() ? "#eee" : "#C0392B",
                      color: cancelModal.order.status?.toLowerCase() === "confirmed" && !cancelReason.trim() ? "#aaa" : "#fff",
                      border:"none", borderRadius:10, padding:12, fontSize:14, fontWeight:700, cursor:"pointer"}}>
                    Cancel Order
                  </button>
                </div>
              </>
            ) : (
              <>
                <div style={{fontSize:18, fontWeight:800, marginBottom:8}}>Are you sure?</div>
                <div style={{fontSize:14, color:"#555", marginBottom:20}}>
                  This will permanently cancel Order #{cancelModal.order.id}. This cannot be undone.
                </div>
                <div style={{display:"flex", gap:10}}>
                  <button onClick={()=>setCancelConfirmStep(false)}
                    style={{flex:1, background:"#f0f0f0", border:"none", borderRadius:10, padding:12, fontSize:14, fontWeight:600, cursor:"pointer", color:"#555"}}>
                    Go Back
                  </button>
                  <button onClick={()=>doCancel(cancelModal.order, "")}
                    style={{flex:1, background:"#C0392B", color:"#fff", border:"none", borderRadius:10, padding:12, fontSize:14, fontWeight:700, cursor:"pointer"}}>
                    Yes, Cancel Order
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* ── STOCK WARNING MODAL (restaurant confirm) ── */}
      {confirmStockWarning && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.55)", zIndex:3300, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}>
          <div style={{ background:"#fff", borderRadius:16, width:"100%", maxWidth:440, padding:"24px", boxShadow:"0 20px 60px rgba(0,0,0,0.25)" }}>
            <div style={{ fontSize:18, fontWeight:800, marginBottom:6 }}>⚠️ Not Enough Stock</div>
            <div style={{ fontSize:13, color:"#555", marginBottom:14 }}>Some items exceed current factory stock. Would you like to update the order quantities to match what's available?</div>
            <div style={{ background:"#FFF8F0", border:"1px solid #F39C12", borderRadius:10, padding:"12px 16px", marginBottom:20 }}>
              {confirmStockWarning.shortfalls.map((s,i) => (
                <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"6px 0", borderTop: i>0?"1px solid #FCE5C0":"none" }}>
                  <span style={{ fontWeight:700, fontSize:13 }}>{s.name}</span>
                  <div style={{ textAlign:"right" }}>
                    <span style={{ fontSize:12, color:"#C0392B", fontWeight:600 }}>Ordered: {s.ordered}</span>
                    <span style={{ fontSize:12, color:"#aaa", margin:"0 4px" }}>→</span>
                    <span style={{ fontSize:12, color:"#27AE60", fontWeight:600 }}>Available: {s.available}</span>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              <button onClick={() => {
                // Cap shortfall items to available stock, then confirm
                const capped = (confirmStockWarning.itemsToConfirm || editItems.filter(it => it.qty > 0)).map(it => {
                  const sf = confirmStockWarning.shortfalls.find(s => {
                    const p = products.find(x => x.id === it.productId);
                    return p && s.name === p.name;
                  });
                  return sf ? { ...it, qty: sf.available } : it;
                }).filter(it => it.qty > 0);
                doConfirmWithItems(capped, "Order updated & confirmed ✓");
              }}
                style={{ padding:"13px", borderRadius:10, border:"none", background:"#2471A3", fontSize:13, fontWeight:700, cursor:"pointer", color:"#fff" }}>
                ✓ Update Order & Confirm
                <div style={{ fontSize:11, fontWeight:400, opacity:0.85, marginTop:2 }}>Adjust quantities to available stock</div>
              </button>
              <button onClick={() => doConfirmWithItems(confirmStockWarning.itemsToConfirm || editItems.filter(it => it.qty > 0))}
                style={{ padding:"13px", borderRadius:10, border:"none", background:"#E67E22", fontSize:13, fontWeight:700, cursor:"pointer", color:"#fff" }}>
                Confirm with Original Quantities
                <div style={{ fontSize:11, fontWeight:400, opacity:0.85, marginTop:2 }}>Keep as ordered — produce the rest</div>
              </button>
              <button onClick={() => setConfirmStockWarning(null)}
                style={{ padding:"11px", borderRadius:10, border:"1px solid #ddd", background:"#f5f5f5", fontSize:13, fontWeight:600, cursor:"pointer", color:"#555" }}>
                Go Back
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


export default function App() {
  // ── Auth ──
  // ── Cache busting — track version, Vercel handles actual cache via content hashing ──
  useEffect(() => {
    localStorage.setItem("vdh_version", APP_VERSION);
  }, []);

  const [auth, setAuth] = useState(() => {
    try {
      const saved = sessionStorage.getItem("vdh_auth");
      return saved ? JSON.parse(saved) : null;
    } catch { return null; }
  });
  const [dbLoaded, setDbLoaded] = useState(false);

  // All shared state — loaded from Firebase
  const [users, setUsers]             = useState([]);
  const [products, setProducts]       = useState([]);
  const [restaurants, setRestaurants] = useState([]);
  const [parLevels, setParLevels]     = useState({});
  const [customCats, setCustomCats]   = useState([]);
  const [hiddenItems, setHiddenItems] = useState({});
  const [catVisibility, setCatVisibility] = useState({});
  const [catOrder, setCatOrder]           = useState([]); // explicit category ordering
  const [inventoryAddOns, setInventoryAddOns] = useState([]); // product IDs shown in add-ons prompt
  const [inventory, setInventory]     = useState({});
  const [orders, setOrders]           = useState([]);
  const [lang, setLang]               = useState("en");
  const [showSignOut, setShowSignOut]   = useState(false);
  // ── Prep module state ──
  // ── Factory Inventory ──
  const [factoryInventory,    setFactoryInventory]    = useState({});
  const [productionHidden,    setProductionHidden]    = useState({}); // { deptId: [productId,...] } // { productId: qty }
  const [factoryLogs,         setFactoryLogs]         = useState([]); // production log entries
  const [factoryStock,        setFactoryStock]        = useState([]); // lotted factory stock
  const [wholesaleCustomers,  setWholesaleCustomers]  = useState([]); // external/wholesale customers
  const [externalInvoices,    setExternalInvoices]    = useState([]); // external sales invoices
  const [prepStaff,           setPrepStaff]           = useState([]);
  const [prepTasks,           setPrepTasks]           = useState([]);
  const [prepTemplates,       setPrepTemplates]       = useState({});
  const [prepDailyAssignments,setPrepDailyAssignments]= useState({});
  const [prepTimestamps,      setPrepTimestamps]      = useState([]);
  const [activeRest, setActiveRest]   = useState(1);
  const [activeTab, setActiveTab]     = useState(null);
  const [inventoryResetKey, setInventoryResetKey] = useState(0);
  const [appView, setAppView]         = useState("restaurant");
  const [reviewData, setReviewData]   = useState(null);
  const [invoiceOrder, setInvoiceOrder] = useState(null);
  const [closingReports, setClosingReports] = useState([]);

  // Firebase doc reference
  const DB_DOC = "kitchenlink/data";
const APP_VERSION = "2.1.0"; // Bump this string to force cache refresh on all devices

  // Load from Firebase on mount, subscribe to real-time updates
  useEffect(() => {
    try {
      const [col, docId] = DB_DOC.split("/");
      const ref = doc(db, col, docId);
      const unsub = onSnapshot(ref, (snap) => {
        initialLoadDone.current = true; // Set FIRST so saveField calls are allowed
        try {
          if (snap.exists()) {
            const d = snap.data();
            if (d.users)       setUsers(d.users);
            if (d.products)    setProducts(d.products);
            if (d.restaurants) setRestaurants(d.restaurants);
            if (d.parLevels)   setParLevels(d.parLevels);
            if (d.customCats)  setCustomCats(d.customCats);
            if (d.hiddenItems) setHiddenItems(d.hiddenItems);
            if (d.factoryInventory)   setFactoryInventory(d.factoryInventory||{});
            if (d.productionHidden)   setProductionHidden(d.productionHidden||{});
            if (d.factoryLogs)        setFactoryLogs(d.factoryLogs||[]);
            if (d.prepStaff)            setPrepStaff(d.prepStaff);
            if (d.prepTasks && d.prepTasks.length > 0) {
              // Merge new tasks + translations from INIT into existing Firebase tasks
              const existingIds = new Set(d.prepTasks.map(t=>t.id));
              const brandNew = INIT_PREP_TASKS.filter(t=>!existingIds.has(t.id));
              const merged = d.prepTasks.map(t => {
                const init = INIT_PREP_TASKS.find(x=>x.id===t.id||(x.nameEn===t.nameEn&&x.category===t.category));
                return init ? {...t, nameEs:init.nameEs||t.nameEs||"", nameZh:init.nameZh||t.nameZh||"",
                  recordOutput:init.recordOutput||false, recordPromptEn:init.recordPromptEn||"",
                  recordPromptZh:init.recordPromptZh||"", recordPromptEs:init.recordPromptEs||""} : t;
              });
              const final = [...merged, ...brandNew];
              setPrepTasks(final);
              // Only write back if we actually added new tasks (not just translation updates)
              if (final.length !== d.prepTasks.length) saveField("prepTasks", final);
            } else if (!d.prepTasks) { setPrepTasks(INIT_PREP_TASKS); saveField("prepTasks", INIT_PREP_TASKS); }
            if (d.prepTemplates)        setPrepTemplates(d.prepTemplates);
            if (d.prepDailyAssignments) setPrepDailyAssignments(d.prepDailyAssignments);
            if (d.prepTimestamps)       setPrepTimestamps(d.prepTimestamps);
            if (d.catVisibility) setCatVisibility(d.catVisibility);
            if (d.catOrder)     setCatOrder(d.catOrder);
            if (d.inventoryAddOns) setInventoryAddOns(d.inventoryAddOns);
            if (d.inventory)   setInventory(d.inventory);

            // ── Auto-migrate legacy closing reports from main doc ──
            if (d.closingReports && d.closingReports.length > 0) {
              setClosingReports(d.closingReports);
              const migBatch = writeBatch(db);
              for (const report of d.closingReports) {
                migBatch.set(doc(db, "closingReports", String(report.id)), report);
              }
              migBatch.update(ref, { closingReports: deleteField() });
              migBatch.commit()
                .then(() => console.warn(`VDumplingHQ: Migrated ${d.closingReports.length} closing reports to collection`))
                .catch(e => console.error("Closing reports migration failed:", e));
            }
            if (d.orders && d.orders.length > 0) {
              // Temporarily show legacy orders while migration runs
              setOrders(d.orders);
              // Write each legacy order to the collection
              const migBatch = writeBatch(db);
              for (const order of d.orders) {
                migBatch.set(doc(db, "orders", String(order.id)), order);
              }
              // Remove orders array from main doc to free space
              migBatch.update(ref, { orders: deleteField() });
              migBatch.commit()
                .then(() => console.warn(`VDumplingHQ: Migrated ${d.orders.length} legacy orders to collection`))
                .catch(e => console.error("Order migration failed:", e));
            }
          } else {
            // Document not found — do NOT seed. This protects against network blips
            // returning empty snapshots on existing databases.
            // First-time setup must be done manually via the seed button in admin settings.
            console.warn("VDumplingHQ: snap.exists() returned false — skipping to protect data. If this is a fresh install, use Admin > Settings > Backup > Initialize App.");
          }
        } catch(innerErr) {
          console.error("Firebase data error:", innerErr);
        }
        setDbLoaded(true);
      }, (err) => {
        console.error("Firebase connection error:", err);
        setDbLoaded(true);
      });
      // ── Real-time listener for orders collection ──────────────────────────
      const ordersRef  = collection(db, "orders");
      const unsubOrders = onSnapshot(ordersRef, (snap) => {
        if (snap.docs.length > 0) {
          const loaded = snap.docs
            .map(d => d.data())
            .sort((a,b) => new Date(b.timestamp) - new Date(a.timestamp));
          setOrders(loaded);
        }
      }, (err) => {
        console.error("Orders collection listener error:", err);
      });

      // ── Real-time listener for closingReports collection ─────────────────
      const closingReportsRef = collection(db, "closingReports");
      const unsubClosingReports = onSnapshot(closingReportsRef, (snap) => {
        if (snap.docs.length > 0) {
          const loaded = snap.docs
            .map(d => d.data())
            .sort((a,b) => b.id - a.id);
          setClosingReports(loaded);
        }
      }, (err) => {
        console.error("Closing reports collection listener error:", err);
      });

      // ── Real-time listener for factoryStock collection ──────────────────
      const factoryStockRef = collection(db, "factoryStock");
      const unsubFactoryStock = onSnapshot(factoryStockRef, (snap) => {
        const loaded = snap.docs.map(d => d.data())
          .sort((a,b) => (a.date||"") < (b.date||"") ? -1 : (a.date||"") > (b.date||"") ? 1 : a.id - b.id);
        setFactoryStock(loaded);
      }, (err) => { console.error("factoryStock listener error:", err); });

      // ── Real-time listener for wholesaleCustomers collection ──────────────
      const wholesaleCustomersRef = collection(db, "wholesaleCustomers");
      const unsubWholesaleCustomers = onSnapshot(wholesaleCustomersRef, (snap) => {
        const loaded = snap.docs.map(d => d.data()).sort((a,b) => a.name?.localeCompare(b.name||""));
        setWholesaleCustomers(loaded);
      }, (err) => { console.error("wholesaleCustomers listener error:", err); });

      // ── Real-time listener for externalInvoices collection ────────────────
      const externalInvoicesRef = collection(db, "externalInvoices");
      const unsubExternalInvoices = onSnapshot(externalInvoicesRef, (snap) => {
        const loaded = snap.docs.map(d => d.data()).sort((a,b) => b.id - a.id);
        setExternalInvoices(loaded);
      }, (err) => { console.error("externalInvoices listener error:", err); });

      return () => { unsub(); unsubOrders(); unsubClosingReports(); unsubFactoryStock(); unsubWholesaleCustomers(); unsubExternalInvoices(); };
    } catch(outerErr) {
      console.error("Firebase init error:", outerErr);
      setDbLoaded(true);
    }
  }, []);

  // Save helpers — write to Firebase
  const initialLoadDone = useRef(false);
  const saveField = (field, value) => {
    if (!initialLoadDone.current) {
      console.warn("saveField blocked - Firebase not yet loaded:", field);
      return;
    }
    const [col, docId] = DB_DOC.split("/");
    setDoc(doc(db, col, docId), { [field]: value }, { merge: true });
  };
  const saveUsers        = (v) => { setUsers(v);        saveField("users", v); };
  const saveProducts     = (v) => { setProducts(v);     saveField("products", v); };
  const saveRestaurants  = (v) => { setRestaurants(v);  saveField("restaurants", v); };
  const savePars         = (v) => { setParLevels(v);    saveField("parLevels", v); };
  const saveCategories   = (v) => { setCustomCats(v);   saveField("customCats", v); };
  const saveHiddenItems  = (v) => { setHiddenItems(v);  saveField("hiddenItems", v); };
  const saveCatVisibility = (v) => { setCatVisibility(v); saveField("catVisibility", v); };
  const saveCatOrder      = (v) => { setCatOrder(v);      saveField("catOrder", v); };
  const saveInventoryAddOns = (v) => { setInventoryAddOns(v); saveField("inventoryAddOns", v); };
  const saveInventory    = (v) => { setInventory(v);    saveField("inventory", v); };
  const saveProductionHidden = (v) => { setProductionHidden(v); saveField("productionHidden", v); };
  const saveFactoryInventory = (v) => { setFactoryInventory(v); saveField("factoryInventory", v); };
  const saveFactoryLogs      = (v) => { setFactoryLogs(v);      saveField("factoryLogs", v); };
  const savePrepStaff            = (v) => { setPrepStaff(v);            saveField("prepStaff", v); };
  const savePrepTasks            = (v) => { setPrepTasks(v);            saveField("prepTasks", v); };
  const savePrepTemplates        = (v) => { setPrepTemplates(v);        saveField("prepTemplates", v); };
  const savePrepDailyAssignments = (v) => { setPrepDailyAssignments(v); saveField("prepDailyAssignments", v); };
  const savePrepTimestamps       = (v) => { setPrepTimestamps(v);       saveField("prepTimestamps", v); };
  // ── Batch-write save functions for new collections ────────────────────────
  // We can't use mkCollectionSave with closures easily, so direct implementations:
  const saveFactoryStock = (newArray) => {
    setFactoryStock(newArray);
    if (!initialLoadDone.current) return;
    const currentMap = new Map(factoryStock.map(r => [r.id, r]));
    const newMap     = new Map(newArray.map(r => [r.id, r]));
    const batch      = writeBatch(db); let changes = 0;
    for (const [id, item] of newMap) {
      const ex = currentMap.get(id);
      if (!ex || JSON.stringify(ex) !== JSON.stringify(item)) { batch.set(doc(db, "factoryStock", String(id)), item); changes++; }
    }
    for (const [id] of currentMap) { if (!newMap.has(id)) { batch.delete(doc(db, "factoryStock", String(id))); changes++; } }
    if (changes > 0) batch.commit().catch(e => console.error("factoryStock save failed:", e));
  };
  const saveWholesaleCustomers = (newArray) => {
    setWholesaleCustomers(newArray);
    if (!initialLoadDone.current) return;
    const currentMap = new Map(wholesaleCustomers.map(r => [r.id, r]));
    const newMap     = new Map(newArray.map(r => [r.id, r]));
    const batch      = writeBatch(db); let changes = 0;
    for (const [id, item] of newMap) {
      const ex = currentMap.get(id);
      if (!ex || JSON.stringify(ex) !== JSON.stringify(item)) { batch.set(doc(db, "wholesaleCustomers", String(id)), item); changes++; }
    }
    for (const [id] of currentMap) { if (!newMap.has(id)) { batch.delete(doc(db, "wholesaleCustomers", String(id))); changes++; } }
    if (changes > 0) batch.commit().catch(e => console.error("wholesaleCustomers save failed:", e));
  };
  const saveExternalInvoices = (newArray) => {
    setExternalInvoices(newArray);
    if (!initialLoadDone.current) return;
    const currentMap = new Map(externalInvoices.map(r => [r.id, r]));
    const newMap     = new Map(newArray.map(r => [r.id, r]));
    const batch      = writeBatch(db); let changes = 0;
    for (const [id, item] of newMap) {
      const ex = currentMap.get(id);
      if (!ex || JSON.stringify(ex) !== JSON.stringify(item)) { batch.set(doc(db, "externalInvoices", String(id)), item); changes++; }
    }
    for (const [id] of currentMap) { if (!newMap.has(id)) { batch.delete(doc(db, "externalInvoices", String(id))); changes++; } }
    if (changes > 0) batch.commit().catch(e => console.error("externalInvoices save failed:", e));
  };

  // ── Auto-backfill: silently lock customPrice on historical confirmed orders ──
  // Runs once when both orders and products are loaded. Any confirmed order item
  // with customPrice==null gets the current catalog price stamped on it so future
  // catalog changes never retroactively alter it.
  const priceBackfillDone = useRef(false);
  useEffect(() => {
    if (priceBackfillDone.current) return;
    if (!orders.length || !products.length || !initialLoadDone.current) return;
    const CONFIRMED = ["confirmed","to_be_delivered","delivered"];
    const toFix = orders.filter(o =>
      CONFIRMED.includes(o.status?.toLowerCase()) &&
      o.items?.some(it => it.productId && it.customPrice == null)
    );
    if (toFix.length === 0) { priceBackfillDone.current = true; return; }
    const batch = writeBatch(db);
    const patched = toFix.map(o => ({
      ...o,
      items: o.items.map(it => {
        if (!it.productId || it.customPrice != null) return it;
        const prod = products.find(x => x.id === it.productId);
        return { ...it, customPrice: prod?.price ?? 0 };
      }),
    }));
    patched.forEach(o => batch.set(doc(db, "orders", String(o.id)), o));
    batch.commit()
      .then(() => {
        setOrders(prev => prev.map(o => patched.find(p => p.id === o.id) || o));
        priceBackfillDone.current = true;
      })
      .catch(e => console.error("Price backfill failed:", e));
  }, [orders, products]);

  const saveOrders = (newArray) => {
    setOrders(newArray);
    // Write to individual order documents in the orders collection (no 1MB limit)
    if (!initialLoadDone.current) return;
    const currentMap = new Map(orders.map(o => [o.id, o]));
    const newMap     = new Map(newArray.map(o => [o.id, o]));
    const batch      = writeBatch(db);
    let   changes    = 0;
    // Write new or changed orders
    for (const [id, order] of newMap) {
      const existing = currentMap.get(id);
      if (!existing || JSON.stringify(existing) !== JSON.stringify(order)) {
        batch.set(doc(db, "orders", String(id)), order);
        changes++;
      }
    }
    // Delete removed orders
    for (const [id] of currentMap) {
      if (!newMap.has(id)) {
        batch.delete(doc(db, "orders", String(id)));
        changes++;
      }
    }
    if (changes > 0) {
      batch.commit().catch(e => console.error("Orders save failed:", e));
    }
  };
  const saveClosingReports = (newArray) => {
    setClosingReports(newArray);
    if (!initialLoadDone.current) return;
    const currentMap = new Map((closingReports||[]).map(r => [r.id, r]));
    const newMap     = new Map(newArray.map(r => [r.id, r]));
    const batch      = writeBatch(db);
    let   changes    = 0;
    for (const [id, report] of newMap) {
      const existing = currentMap.get(id);
      if (!existing || JSON.stringify(existing) !== JSON.stringify(report)) {
        batch.set(doc(db, "closingReports", String(id)), report);
        changes++;
      }
    }
    for (const [id] of currentMap) {
      if (!newMap.has(id)) {
        batch.delete(doc(db, "closingReports", String(id)));
        changes++;
      }
    }
    if (changes > 0) {
      batch.commit().catch(e => console.error("Closing reports save failed:", e));
    }
  };


  // ── Toast ──
  const [toast, setToast] = useState("");
  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(""), 2500); };

  // ── Email modal ──
  const [emailModal, setEmailModal] = useState(null);

  // ── Active restaurant ──
  const rest = restaurants.find(r => r.id === activeRest) || restaurants[0] || null;
  const inv  = inventory[activeRest] || {};

  // ── Confirm order → save to Firebase ──
  const confirmOrder = (restId, items, note, hasCatering, delivDate) => {
    // ── Deduplication: block identical order from same location within 60s ──
    const fiveMinutesAgo = Date.now() - 300000; // 5 minute window
    const isDuplicate = orders.some(o => {
      if (o.restaurantId !== restId) return false;
      if (new Date(o.timestamp).getTime() < fiveMinutesAgo) return false;
      if (o.items.length !== items.length) return false;
      return o.items.every(oi => items.some(ni => ni.productId===oi.productId && ni.qty===oi.qty));
    });
    if (isDuplicate) {
      showToast("⚠️ Duplicate order blocked — identical order already submitted within 5 minutes");
      setReviewData(null);
      return;
    }
    // Subtract from factory inventory when order is placed
    const newInv = {...factoryInventory};
    items.forEach(item => {
      if (item.productId) {
        newInv[item.productId] = Math.max(0, (newInv[item.productId]||0) - item.qty);
      }
    });
    saveFactoryInventory(newInv);

    const now = new Date();
    const mm = String(now.getMonth()+1).padStart(2,"0");
    const monthPrefix = parseInt(mm) * 1000;
    const monthOrders = orders.filter(o => {
      const d = new Date(o.timestamp||0);
      return d.getMonth()===now.getMonth() && d.getFullYear()===now.getFullYear();
    });
    const seq = String(monthOrders.length + 1).padStart(3,"0");
    const newId = parseInt(`${mm}${seq}`); // e.g. 09001, 10003
    const newOrder = {
      id: newId,
      restaurantId: restId,
      items,
      note: note||"",
      hasCatering: !!hasCatering,
      timestamp: new Date().toISOString(),
      deliveryDate: null, // Set by factory at confirmation — not auto-calculated
      status: "pending",
    };
    const updated = [newOrder, ...orders];
    saveOrders(updated);
    setReviewData(null);
    setInvoiceOrder(newOrder.id);
    setInventoryResetKey(k => k+1); // Force InventoryTab to remount with empty state
    setAppView("restaurant");
    showToast("Order submitted ✓");
    // Auto-send email — pass fresh orders list to avoid stale closure overwrite
    sendOrder(newOrder, updated);
  };

  // ── Send order via email ──
  const sendOrder = async (orderOrId, ordersSnapshot) => {
    const order = typeof orderOrId === "number" ? orders.find(o => o.id === orderOrId) : orderOrId;
    if (!order) return;
    const r = restaurants.find(x => x.id === order.restaurantId);
    if (!r) return;
    try {
      const branch = {
        name: r.name,
        managerName: r.managerName || r.name,
        managerEmail: r.managerEmail || "",
      };
      const items = order.items.map(item => {
        const p = products.find(x => x.id === item.productId);
        return {
          name: p ? p.name : "Unknown",
          unit: p ? p.unit : "",
          qty: item.qty,
          price: p ? p.price : null,
        };
      });
      const res = await fetch("/api/send-order", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ order, branch, items }),
      });
      if (res.ok) {
        // Mark order as sent — use ordersSnapshot if provided to avoid stale closure
        const sentAt = new Date().toISOString();
        const baseOrders = ordersSnapshot || orders;
        const updatedOrders = baseOrders.map(o =>
          o.id === order.id ? { ...o, status: "sent", sentAt } : o
        );
        saveOrders(updatedOrders);
        setEmailModal({ ...order, status: "sent", sentAt });
        showToast("Order submitted ✓");
      } else {
        const err = await res.json().catch(()=>({}));
        showToast("Email failed: " + (err.error || res.status));
        console.error("Send order error:", err);
      }
    } catch(e) {
      showToast("Network error: " + e.message);
      console.error("Send order exception:", e);
    }
  };

  // ── Live invoice ──
  const liveInvoice = invoiceOrder ? orders.find(o => o.id === invoiceOrder) || null : null;
  const liveInvoiceRest = liveInvoice ? restaurants.find(r => r.id === liveInvoice.restaurantId) : null;

  // ── Translations & helpers ──
  const LANGS = {
    en: { restaurant:"Restaurant", kitchen:"Factory", settings:"Settings",
          inventory:"Inventory", history:"History", catering:"Catering",
          submit:"Submit Order", review:"Review Order",
          stockCheck:"Inventory", orders:"History", close:"Close", sendFactory:"📧 Resend Email",
          todayOrderDay:"Order Day!", nextOrder:"Next order:",
          orderDays:"Order days:", nextDelivery:"Delivery:",
          orderToday:"Order Today",
          homeOrderByInventory:"Order by Inventory", homeOrderByInventorySub:"Count stock & auto-fill order",
          homeOrderByItem:"Order by Item", homeOrderByItemSub:"Pick items directly",
          homeCatering:"Catering", homeCateringSub:"Coming soon",
          homeHistory:"Order History", homeHistorySub:"View past orders",
          homeClosing:"Closing Report", homeClosingSub:"End of shift",
          cats:{"Buns":"Buns","Doughs":"Doughs","Frozen Dumplings":"Frozen Dumplings",
                "Meats":"Meats","Paper Goods":"Paper Goods","Sauces":"Sauces",
                "Sides":"Sides","Soup":"Soup","Vegetables":"Vegetables"} },
    zh: { restaurant:"餐厅", kitchen:"厨房", settings:"设置",
          inventory:"库存", history:"历史", catering:"外卖",
          submit:"提交订单", review:"审查订单",
          stockCheck:"库存", orders:"历史", close:"关闭", sendFactory:"📧 重新发送",
          todayOrderDay:"今日订购!", nextOrder:"下次订购:",
          orderDays:"订购日:", nextDelivery:"送货:",
          orderToday:"今日订购",
          homeOrderByInventory:"库存订购", homeOrderByInventorySub:"盘点库存并自动填写订单",
          homeOrderByItem:"按商品订购", homeOrderByItemSub:"直接选择商品",
          homeCatering:"外卖", homeCateringSub:"即将推出",
          homeHistory:"订单历史", homeHistorySub:"查看历史订单",
          homeClosing:"结班报告", homeClosingSub:"班次结束",
          cats:{"Buns":"包子","Doughs":"面团","Frozen Dumplings":"冷冻饺子",
                "Meats":"肉类","Paper Goods":"纸品","Sauces":"酱料",
                "Sides":"配菜","Soup":"汤","Vegetables":"蔬菜"} }
  };
  const t = LANGS[lang] || LANGS.en;
  const pName = (p) => lang === "zh" && p.nameZh ? p.nameZh : p.name;
  const fmtPrice = (item) => {
    if (item.price == null) return "Market";
    return "$" + Number(item.price).toFixed(2);
  };

  // ── Advance order status (Factory view) ──
  const NEXT_STATUS = { "pending":"sent", "sent":"confirmed", "confirmed":"preparing", "preparing":"dispatched", "dispatched":"delivered" };
  const advanceFactory = (orderId) => {
    const updated = orders.map(o => o.id === orderId ? {...o, status: NEXT_STATUS[o.status]||o.status} : o);
    saveOrders(updated);
  };

  const isAdmin   = auth?.role === "admin";
  const isKitchen = auth?.role === "kitchen";
  const isCashier = auth?.role === "cashier";
  const isOwner   = auth?.role === "owner";
  // Managers only see their branch
  const visibleRestaurants = isAdmin ? restaurants : restaurants.filter(r => (auth?.branchIds||[auth?.branchId]).includes(r.id));

  // Nav: managers don't see Kitchen or Settings
  const NAV_ITEMS = isCashier ? [
    { key:"restaurant", icon:"🏪", label: t.restaurant },
  ] : [
    ...(isAdmin ? [{ key:"adminHome", icon:"🏠", label:"Home" }] : []),
    { key:"restaurant", icon:"🏪", label: t.restaurant },
    ...(isAdmin ? [
      { key:"centralKitchen", icon:"👨\u200d🍳", label: t.kitchen },
      { key:"prep", icon:"📋", label: "Prep" },
      { key:"settings", icon:"⚙",  label: t.settings },
    ] : []),
    { key:"chat", icon:"💬", label: "Chat" },
  ];

  // Loading screen while Firebase connects
  if (!dbLoaded) {
    return (
      <>
        <style>{FONT}</style>
        <div style={{minHeight:"100vh",background:"#F2F0EC",display:"flex",
          flexDirection:"column",alignItems:"center",justifyContent:"center",gap:16}}>
          <img src={LOGO_NAV} alt="Vanessa's Dumpling House" style={{height:48,width:"auto",maxWidth:240,marginBottom:4}}/>
          <div style={{fontSize:13,color:"#aaa",letterSpacing:.5}}>Connecting...</div>
        </div>
      </>
    );
  }

  // Login gate
  if (!auth) {
    return (
      <>
        <style>{FONT}</style>
        <LoginScreen onLogin={(a) => {
          try { sessionStorage.setItem("vdh_auth", JSON.stringify(a)); } catch {}
          // Clear ALL previous navigation state before setting new user
          setAppView("login");
          setActiveTab(null);
          setActiveRest(null);
          setAuth(a);
          // Route based on role
          if (a.role==="kitchen") { setAppView("centralKitchen"); }
          else if (a.role==="prep") { setAppView("prep"); }
          else if (a.role==="driver") { setAppView("driver"); }
          else if (a.role==="production") { setAppView("production"); }
          else if (a.role==="admin") { setAppView("adminHome"); }
          else if (a.role==="owner") { setAppView("owner"); }
          else {
            if (a.branchIds&&a.branchIds.length>0) setActiveRest(a.branchIds[0]);
            else if (a.branchId) setActiveRest(a.branchId);
            if (a.role==="cashier") { setAppView("restaurant"); setActiveTab("closing"); }
            else { setAppView("restaurant"); setActiveTab(null); }
          }
        }} users={users} />
      </>
    );
  }

  // ── Owner view ──
  if (isOwner) {
    return (
      <>
        <style>{FONT}</style>
        <OwnerView
          auth={auth}
          orders={orders}
          restaurants={restaurants}
          products={products}
          externalInvoices={externalInvoices}
          wholesaleCustomers={wholesaleCustomers}
          users={users}
          db={db}
          showToast={showToast}
          pName={pName}
          fmtPrice={fmtPrice}
          onSignOut={()=>{try{sessionStorage.removeItem("vdh_auth");}catch{}; setAuth(null);setAppView("login");}}
        />
      </>
    );
  }
  const isProduction = auth?.role === "production";
  if (isProduction) {
    // Get assigned items for this user
    const userProductionItems = auth?.productionItems || [];
    // Get products they're assigned (or all if none assigned)
    const allDepts = [
      {id:"dumplings",label:"Dumpling Production",icon:"🥟",cats:["Frozen Dumplings","Buns","Doughs"]},
      {id:"vegetables",label:"Vegetable Production",icon:"🥬",cats:["Vegetables","Sides"]},
      {id:"sauces",label:"Sauce Production",icon:"🫙",cats:["Sauces"]},
      {id:"meats",label:"Meat Production",icon:"🥩",cats:["Meats","Soup"]},
      {id:"other",label:"Other Goods",icon:"📦",cats:["Paper Goods"]},
    ];
    const userDeptIds = auth?.departments || [];
    const allowedCats = allDepts
      .filter(d => !userDeptIds.length || userDeptIds.includes(d.id))
      .flatMap(d => d.cats);
    const assignedProducts = userProductionItems.length > 0
      ? products.filter(p => userProductionItems.includes(p.id))
      : products.filter(p => allowedCats.includes(p.category));

    return (
      <>
        <style>{FONT}</style>
        <ProductionStaffView
          products={assignedProducts}
          auth={auth}
          factoryInventory={factoryInventory}
          saveFactoryInventory={saveFactoryInventory}
          factoryLogs={factoryLogs}
          saveFactoryLogs={saveFactoryLogs}
          showToast={showToast}
          onSignOut={()=>{try{sessionStorage.removeItem("vdh_auth");}catch{}; setAuth(null);setAppView("login");}}
        />
      </>
    );
  }

  // ── Driver view ──
  if (auth?.role === "driver") {
    return (
      <>
        <style>{FONT}</style>
        {appView === "chat" ? (
          <div style={{minHeight:"100vh",background:"#f2f0ec"}}>
            <div style={{background:"#1a1a1a",padding:"14px 20px",display:"flex",alignItems:"center",gap:12}}>
              <button onClick={()=>setAppView("driver")} style={{color:"#fff",background:"none",border:"none",fontSize:20,cursor:"pointer"}}>←</button>
              <div style={{color:"#fff",fontWeight:800,fontSize:16}}>💬 Chat</div>
            </div>
            <ChatTab auth={auth} users={users} restaurants={restaurants} db={db} showToast={showToast}/>
          </div>
        ) : (
          <DeliveryHubView
            auth={auth}
            orders={orders}
            saveOrders={saveOrders}
            restaurants={restaurants}
            products={products}
            pName={pName}
            fmtPrice={fmtPrice}
            showToast={showToast}
            isAdmin={false}
            onOpenChat={()=>setAppView("chat")}
            factoryStock={factoryStock}
          />
        )}
      </>
    );
  }

  const isPrep = auth?.role === "prep";
  if (isPrep) {
    return (
      <>
        <style>{FONT}</style>
        <PrepStaffBoard
          prepStaff={prepStaff}
          prepTasks={prepTasks}
          prepDailyAssignments={prepDailyAssignments}
          prepTimestamps={prepTimestamps}
          savePrepTimestamps={savePrepTimestamps}
        />
      </>
    );
  }
  if (isKitchen && appView !== "centralKitchen") {
    setAppView("centralKitchen");
  }

  return (
    <>
      <style>{FONT}{`
        *{box-sizing:border-box;margin:0;padding:0;}
        body{font-family:'IBM Plex Sans',sans-serif;background:#F2F0EC;color:#1a1a1a;}
        h1,h2,h3{font-family:'Playfair Display',serif;}
        button{cursor:pointer;font-family:'IBM Plex Sans',sans-serif;}
        input,select,textarea{font-family:'IBM Plex Sans',sans-serif;}
        .tab{background:none;border:none;padding:9px 16px;border-radius:9px;font-size:13px;font-weight:600;color:#999;transition:all .15s;}
        .tab.on{background:#1a1a1a;color:#fff;}
        .tab:hover:not(.on){background:#e5e5e5;color:#444;}
        input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none;}
        input[type=number]{-moz-appearance:textfield;}
        ::-webkit-scrollbar{height:4px;width:4px;}
        ::-webkit-scrollbar-track{background:#f0f0f0;border-radius:2px;}
        ::-webkit-scrollbar-thumb{background:#ccc;border-radius:2px;}
        @keyframes fsl{from{transform:translateX(30px);opacity:0}to{transform:translateX(0);opacity:1}}
        @keyframes fadeIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}
        /* Mobile nav */
        .mobile-menu-btn{display:flex!important;}
        @media(max-width:600px){
          .desktop-nav-label{display:none!important;}
          .desk-nav{display:none!important;}
          .nav-status{display:none!important;}
          .signout-text{display:none!important;}
          .desk-only{display:none!important;}
          .mob-only{display:inline!important;}
        }
        @media(min-width:601px){
          .mobile-menu-btn{display:none!important;}
          .mob-only{display:none!important;}
        }
      `}</style>

      {/* Toast */}
      {toast && (
        <div style={{position:"fixed",top:16,right:16,zIndex:9999,background:"#1a1a1a",
          color:"#fff",borderRadius:12,padding:"13px 20px",fontWeight:600,fontSize:13,
          boxShadow:"0 8px 30px rgba(0,0,0,0.2)",maxWidth:360,lineHeight:1.5,animation:"fsl .3s ease"}}>
          {toast}
        </div>
      )}

      {/* Sign Out Confirm Modal */}
      {showSignOut && (
        <div style={{position:"fixed",inset:0,zIndex:600,background:"rgba(0,0,0,0.5)",
          display:"flex",alignItems:"center",justifyContent:"center",padding:20}}
          onClick={()=>setShowSignOut(false)}>
          <div style={{background:"#fff",borderRadius:20,padding:"28px 24px",
            width:"100%",maxWidth:340,boxShadow:"0 8px 40px rgba(0,0,0,0.2)",textAlign:"center"}}
            onClick={e=>e.stopPropagation()}>
            <div style={{fontSize:32,marginBottom:12}}>🚪</div>
            <div style={{fontWeight:800,fontSize:18,color:"#1a1a1a",marginBottom:8}}>
              Sign out?
            </div>
            <div style={{fontSize:14,color:"#888",marginBottom:24}}>
              Any unsaved progress will be lost.
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              <button onClick={()=>{ setShowSignOut(false); setAuth(null); }}
                style={{width:"100%",padding:"14px",borderRadius:12,border:"none",
                  background:"#1a1a1a",color:"#fff",fontSize:15,fontWeight:700,cursor:"pointer"}}>
                Yes, sign out
              </button>
              <button onClick={()=>setShowSignOut(false)}
                style={{width:"100%",padding:"13px",borderRadius:12,border:"none",
                  background:"#f5f5f5",color:"#555",fontSize:15,fontWeight:600,cursor:"pointer"}}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modals */}
      {reviewData && (() => { const modalRest = restaurants.find(r=>r.id===(reviewData.restId||activeRest)) || rest; return modalRest && (
        <OrderReviewModal
          baseItems={reviewData.baseItems}
          cateringBreakdown={reviewData.cateringBreakdown}
          rest={restaurants.find(r=>r.id===(reviewData.restId||activeRest))||rest}
          delivDate={reviewData.delivDate}
          initialNote={reviewData.note||""}
          onClose={()=>setReviewData(null)}
          hidePrice={!isAdmin}
          onConfirm={(items,note)=>confirmOrder(reviewData.restId||activeRest,items,note,!!reviewData.cateringBreakdown,reviewData.delivDate)}
          products={products} t={t} pName={pName} fmtPrice={fmtPrice}
        />
      ); })()}
      {liveInvoice && liveInvoiceRest && (
        <InvoiceModal order={liveInvoice} rest={liveInvoiceRest}
          onClose={()=>setInvoiceOrder(null)} onSend={sendOrder}
          products={products} t={t} pName={pName} fmtPrice={fmtPrice} hidePrice={!isAdmin}/>
      )}
      {emailModal && (
        <EmailSentModal order={emailModal} rest={restaurants.find(r=>r.id===emailModal.restaurantId)||restaurants[0]}
          onClose={()=>setEmailModal(null)} t={t}/>
      )}

      {/* ── Sticky Nav ── */}
      <div style={{background:"#fff",borderBottom:"1px solid #e8e8e8",padding:"0 20px",
        display:"flex",alignItems:"center",justifyContent:"space-between",
        position:"sticky",top:0,zIndex:100,height:52,gap:8}}>
        {/* Logo */}
        <img src={LOGO_NAV} alt="Vanessa's"
          style={{height:26,width:"auto",objectFit:"contain",maxWidth:160,cursor:"pointer",flexShrink:0}}
          onClick={()=>isAdmin ? setAppView("adminHome") : setAppView("restaurant")}/>
        {/* Desktop nav tabs — hidden on mobile */}
        <div className="desk-nav" style={{display:"flex",gap:2,flex:1,justifyContent:"center"}}>
          {NAV_ITEMS.map(({key,icon,label})=>(
            <button key={key} onClick={()=>setAppView(key)}
              style={{display:"flex",alignItems:"center",gap:5,padding:"7px 14px",
                borderRadius:9,border:"none",fontSize:13,fontWeight:600,cursor:"pointer",
                background:appView===key?"#1a1a1a":"transparent",
                color:appView===key?"#fff":"#666",
                fontFamily:"'IBM Plex Sans',sans-serif",transition:"all .15s"}}>
              <span>{icon}</span>
              <span className="desktop-nav-label">{label}</span>
            </button>
          ))}
        </div>
        {/* Right controls */}
        <div style={{display:"flex",alignItems:"center",gap:8,flexShrink:0}}>
          <button onClick={()=>setLang(l=>l==="en"?"zh":"en")}
            style={{border:"1px solid #e5e5e5",borderRadius:8,padding:"5px 10px",
              fontSize:12,fontWeight:700,cursor:"pointer",background:"#fff",
              fontFamily:"'IBM Plex Sans',sans-serif"}}>
            {lang==="en"?"中文":"EN"}
          </button>
          <button onClick={()=>{ try{sessionStorage.removeItem("vdh_auth");}catch{} setAuth(null); setAppView("login"); setActiveTab(null); setActiveRest(null); }}
            style={{border:"1px solid #e5e5e5",borderRadius:8,padding:"5px 10px",
              fontSize:12,cursor:"pointer",background:"#fff",color:"#888",
              fontFamily:"'IBM Plex Sans',sans-serif"}}>
            <span className="signout-text">Sign out</span>
            <span className="mob-only" style={{display:"none"}}>⎋</span>
          </button>
        </div>
      </div>

      {/* ── Main Content ── */}
      <div style={{maxWidth:1100,margin:"0 auto",padding:"20px 14px",animation:"fadeIn .25s ease"}}>
        {appView==="adminHome" && (
          <AdminHomeView setAppView={setAppView} auth={auth}/>
        )}
        {appView==="restaurant" && (
          !dbLoaded ? (
            <div style={{display:"flex",alignItems:"center",justifyContent:"center",
              minHeight:"60vh",flexDirection:"column",gap:12}}>
              <div style={{fontSize:32}}>🍽</div>
              <div style={{fontSize:14,color:"#aaa",fontFamily:"'IBM Plex Sans',sans-serif"}}>Loading...</div>
            </div>
          ) : <RestaurantView
            key={lang}
            restaurants={visibleRestaurants} activeRest={activeRest} setActiveRest={setActiveRest}
            inventory={inventory} setInventory={setInventory} saveInventory={saveInventory}
            parLevels={parLevels} setParLevels={setParLevels} savePars={savePars}
            orders={orders} saveOrders={saveOrders} activeTab={activeTab} setActiveTab={setActiveTab}
            onOpenReview={setReviewData}
            onViewInvoice={setInvoiceOrder}
            onSend={sendOrder}
            showToast={showToast}
            products={products} hiddenItems={hiddenItems} customCats={customCats} catOrder={catOrder} t={t} pName={pName} fmtPrice={fmtPrice} lang={lang}
            closingReports={closingReports} saveClosingReports={saveClosingReports}
            auth={auth} isCashier={isCashier} hidePrice={!isAdmin}
            allRestaurants={restaurants} saveRestaurants={saveRestaurants}
            inventoryResetKey={inventoryResetKey}
            catVisibility={catVisibility}
            inventoryAddOns={inventoryAddOns}
          />
        )}
        {appView==="kitchen" && isAdmin && (
          <KitchenView
            restaurants={restaurants} orders={orders}
            onAdvance={advanceFactory} onView={setInvoiceOrder}
            products={products} t={t} pName={pName} fmtPrice={fmtPrice}
          />
        )}
        {appView==="centralKitchen" && (isKitchen || isAdmin) && (
          <CentralKitchenView
            orders={orders}
            saveOrders={saveOrders}
            restaurants={restaurants}
            products={products}
            setProducts={setProducts}
            saveProducts={saveProducts}
            customCats={customCats}
            showToast={showToast}
            pName={pName}
            fmtPrice={fmtPrice}
            factoryInventory={factoryInventory}
            saveFactoryInventory={saveFactoryInventory}
            factoryLogs={factoryLogs}
            saveFactoryLogs={saveFactoryLogs}
            productionHidden={productionHidden}
            saveProductionHidden={saveProductionHidden}
            auth={auth}
            factoryStock={factoryStock}
            saveFactoryStock={saveFactoryStock}
            wholesaleCustomers={wholesaleCustomers}
            saveWholesaleCustomers={saveWholesaleCustomers}
            externalInvoices={externalInvoices}
            saveExternalInvoices={saveExternalInvoices}
          />
        )}
        {appView==="prep" && isAdmin && (
          <PrepAdminView
            prepStaff={prepStaff} savePrepStaff={savePrepStaff}
            prepTasks={prepTasks} savePrepTasks={savePrepTasks}
            prepTemplates={prepTemplates} savePrepTemplates={savePrepTemplates}
            prepDailyAssignments={prepDailyAssignments} savePrepDailyAssignments={savePrepDailyAssignments}
            prepTimestamps={prepTimestamps}
            showToast={showToast}
          />
        )}
        {appView==="reports" && isAdmin && (
          <ReportsHub
            orders={orders}
            saveOrders={saveOrders}
            closingReports={closingReports}
            restaurants={restaurants}
            products={products}
            saveProducts={saveProducts}
            showToast={showToast}
          />
        )}
        {appView==="settings" && isAdmin && (
          <SettingsTab
            products={products} setProducts={setProducts}
            restaurants={restaurants} setRestaurants={setRestaurants}
            parLevels={parLevels} setParLevels={setParLevels}
            customCats={customCats} setCustomCats={setCustomCats}
            hiddenItems={hiddenItems} saveHiddenItems={saveHiddenItems}
            catVisibility={catVisibility} saveCatVisibility={saveCatVisibility}
            catOrder={catOrder} saveCatOrder={saveCatOrder}
            inventoryAddOns={inventoryAddOns} saveInventoryAddOns={saveInventoryAddOns}
            saveField={saveField}
            users={users} setUsers={setUsers}
            t={t} pName={pName}
            orders={orders} saveOrders={saveOrders}
            closingReports={closingReports}
            factoryInventory={factoryInventory}
            factoryLogs={factoryLogs}
            prepStaff={prepStaff}
            prepTasks={prepTasks}
            prepTemplates={prepTemplates}
            prepDailyAssignments={prepDailyAssignments}
            prepTimestamps={prepTimestamps}
            productionHidden={productionHidden}
            showToast={showToast}
          />
        )}
        {appView==="chat" && (
          <ChatTab
            auth={auth}
            users={users}
            restaurants={restaurants}
            db={db}
            showToast={showToast}
          />
        )}
      </div>

      {/* ── Mobile Bottom Nav ── */}
      <div style={{position:"fixed",bottom:0,left:0,right:0,background:"#fff",
        borderTop:"1px solid #e8e8e8",display:"flex",zIndex:100,
        boxShadow:"0 -4px 20px rgba(0,0,0,0.07)"}}
        className="mobile-menu-btn">
        {NAV_ITEMS.map(({key,icon,label})=>(
          <button key={key} onClick={()=>setAppView(key)} style={{
            flex:1,border:"none",background:"none",padding:"10px 0 14px",
            display:"flex",flexDirection:"column",alignItems:"center",gap:3,
            color:appView===key?"#1a1a1a":"#aaa",fontWeight:appView===key?700:400,
            borderTop:appView===key?"2px solid #1a1a1a":"2px solid transparent",
            fontSize:11,transition:"all .15s",
          }}>
            <span style={{fontSize:20}}>{icon}</span>
            <span style={{fontSize:10,fontWeight:600}}>{label}</span>
          </button>
        ))}
      </div>

      {/* Bottom padding for mobile nav */}
      <div style={{height:72}} className="mobile-menu-btn"/>
    </>
  );
}
